import _possibleConstructorReturn2 from "D:\\projects\\production-web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf3 from "D:\\projects\\production-web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits2 from "D:\\projects\\production-web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _objectWithoutProperties2 from "D:\\projects\\production-web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray2 from "D:\\projects\\production-web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck2 from "D:\\projects\\production-web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass2 from "D:\\projects\\production-web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _defineProperty3 from "D:\\projects\\production-web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React__default, { createContext, memo, createElement, cloneElement, isValidElement, Component, createRef, PureComponent, useState, useEffect } from 'react';
import { withTranslation, I18nextProvider, initReactI18next } from 'react-i18next';
import i18n from '@ohif/i18n';
import i18n$1 from 'i18next';
import ReactDOM__default, { findDOMNode } from 'react-dom';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace(n) {
  return n && n['default'] || n;
}

var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof2(obj) {
        return typeof obj;
      };
    } else {
      _typeof2 = function _typeof2(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof2(obj);
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return _typeof2(obj);
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      };
    }

    return _typeof(obj);
  }

  module.exports = _typeof;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;
var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf;
});
var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;
var HandlerRole;

(function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

function symbolObservablePonyfill(root) {
  var result;
  var Symbol = root.Symbol;

  if (typeof Symbol === 'function') {
    if (Symbol.observable) {
      result = Symbol.observable;
    } else {
      result = Symbol('observable');
      Symbol.observable = result;
    }
  } else {
    result = '@@observable';
  }

  return result;
}
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = symbolObservablePonyfill(root);
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */

var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */


function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[result] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[result] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */


function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */


function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */


var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var browser = invariant;
var INIT_COORDS = 'dnd-core/INIT_COORDS';
var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = 'dnd-core/HOVER';
var DROP = 'dnd-core/DROP';
var END_DRAG = 'dnd-core/END_DRAG';

function setClientOffset(clientOffset, sourceClientOffset) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: sourceClientOffset || null,
      clientOffset: clientOffset || null
    }
  };
} // cheap lodash replacements

/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */


function get(obj, path, defaultValue) {
  return path.split('.').reduce(function (a, c) {
    return a && a[c] ? a[c] : defaultValue || null;
  }, obj);
}
/**
 * drop-in replacement for _.without
 */


function without(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
/**
 * drop-in replacement for _.isString
 * @param input
 */


function isObject(input) {
  return typeof input === 'object';
}
/**
 * repalcement for _.xor
 * @param itemsA
 * @param itemsB
 */


function xor(itemsA, itemsB) {
  var map = new Map();

  var insertItem = function insertItem(item) {
    return map.set(item, map.has(item) ? map.get(item) + 1 : 1);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  map.forEach(function (count, key) {
    if (count === 1) {
      result.push(key);
    }
  });
  return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */


function intersection(itemsA, itemsB) {
  return itemsA.filter(function (t) {
    return itemsB.indexOf(t) > -1;
  });
}

var ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};

function createBeginDrag(manager) {
  return function beginDrag() {
    var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      publishSource: true
    };
    var _options$publishSourc = options.publishSource,
        publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc,
        clientOffset = options.clientOffset,
        getSourceClientOffset = options.getSourceClientOffset;
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry(); // Initialize the coordinates using the client offset

    manager.dispatch(setClientOffset(clientOffset));
    verifyInvariants(sourceIds, monitor, registry); // Get the draggable source

    var sourceId = getDraggableSource(sourceIds, monitor);

    if (sourceId === null) {
      manager.dispatch(ResetCoordinatesAction);
      return;
    } // Get the source client offset


    var sourceClientOffset = null;

    if (clientOffset) {
      verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
      sourceClientOffset = getSourceClientOffset(sourceId);
    } // Initialize the full coordinates


    manager.dispatch(setClientOffset(clientOffset, sourceClientOffset));
    var source = registry.getSource(sourceId);
    var item = source.beginDrag(monitor, sourceId);
    verifyItemIsObject(item);
    registry.pinSource(sourceId);
    var itemType = registry.getSourceType(sourceId);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType: itemType,
        item: item,
        sourceId: sourceId,
        clientOffset: clientOffset || null,
        sourceClientOffset: sourceClientOffset || null,
        isSourcePublic: !!publishSource
      }
    };
  };
}

function verifyInvariants(sourceIds, monitor, registry) {
  browser(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = sourceIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var s = _step.value;
      browser(registry.getSource(s), 'Expected sourceIds to be registered.');
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
  browser(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}

function verifyItemIsObject(item) {
  browser(isObject(item), 'Item must be an object.');
}

function getDraggableSource(sourceIds, monitor) {
  var sourceId = null;

  for (var _i2 = sourceIds.length - 1; _i2 >= 0; _i2--) {
    if (monitor.canDragSource(sourceIds[_i2])) {
      sourceId = sourceIds[_i2];
      break;
    }
  }

  return sourceId;
}

function createPublishDragSource(manager) {
  return function publishDragSource() {
    var monitor = manager.getMonitor();

    if (monitor.isDragging()) {
      return {
        type: PUBLISH_DRAG_SOURCE
      };
    }
  };
}

function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }

  return Array.isArray(targetType) ? targetType.some(function (t) {
    return t === draggedItemType;
  }) : targetType === draggedItemType;
}

function createHover(manager) {
  return function hover(targetIdsArg) {
    var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        clientOffset = _ref9.clientOffset;

    verifyTargetIdsIsArray(targetIdsArg);
    var targetIds = targetIdsArg.slice(0);
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    checkInvariants(targetIds, monitor, registry);
    var draggedItemType = monitor.getItemType();
    removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
    hoverAllTargets(targetIds, monitor, registry);
    return {
      type: HOVER,
      payload: {
        targetIds: targetIds,
        clientOffset: clientOffset || null
      }
    };
  };
}

function verifyTargetIdsIsArray(targetIdsArg) {
  browser(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}

function checkInvariants(targetIds, monitor, registry) {
  browser(monitor.isDragging(), 'Cannot call hover while not dragging.');
  browser(!monitor.didDrop(), 'Cannot call hover after drop.');

  for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
    var targetId = targetIds[_i3];
    browser(targetIds.lastIndexOf(targetId) === _i3, 'Expected targetIds to be unique in the passed array.');
    var target = registry.getTarget(targetId);
    browser(target, 'Expected targetIds to be registered.');
  }
}

function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
  // Remove those targetIds that don't match the targetType.  This
  // fixes shallow isOver which would only be non-shallow because of
  // non-matching targets.
  for (var _i4 = targetIds.length - 1; _i4 >= 0; _i4--) {
    var targetId = targetIds[_i4];
    var targetType = registry.getTargetType(targetId);

    if (!matchesType(targetType, draggedItemType)) {
      targetIds.splice(_i4, 1);
    }
  }
}

function hoverAllTargets(targetIds, monitor, registry) {
  // Finally call hover on all matching targets.
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator3 = targetIds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator3.next()).done); _iteratorNormalCompletion2 = true) {
      var targetId = _step2.value;
      var target = registry.getTarget(targetId);
      target.hover(monitor, targetId);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function createDrop(manager) {
  return function drop() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyInvariants$1(monitor);
    var targetIds = getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action

    targetIds.forEach(function (targetId, index) {
      var dropResult = determineDropResult(targetId, index, registry, monitor);
      var action = {
        type: DROP,
        payload: {
          dropResult: _objectSpread2({}, options, {}, dropResult)
        }
      };
      manager.dispatch(action);
    });
  };
}

function verifyInvariants$1(monitor) {
  browser(monitor.isDragging(), 'Cannot call drop while not dragging.');
  browser(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}

function determineDropResult(targetId, index, registry, monitor) {
  var target = registry.getTarget(targetId);
  var dropResult = target ? target.drop(monitor, targetId) : undefined;
  verifyDropResultType(dropResult);

  if (typeof dropResult === 'undefined') {
    dropResult = index === 0 ? {} : monitor.getDropResult();
  }

  return dropResult;
}

function verifyDropResultType(dropResult) {
  browser(typeof dropResult === 'undefined' || isObject(dropResult), 'Drop result must either be an object or undefined.');
}

function getDroppableTargets(monitor) {
  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
  targetIds.reverse();
  return targetIds;
}

function createEndDrag(manager) {
  return function endDrag() {
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyIsDragging(monitor);
    var sourceId = monitor.getSourceId();
    var source = registry.getSource(sourceId, true);
    source.endDrag(monitor, sourceId);
    registry.unpinSource();
    return {
      type: END_DRAG
    };
  };
}

function verifyIsDragging(monitor) {
  browser(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

function createDragDropActions(manager) {
  return {
    beginDrag: createBeginDrag(manager),
    publishDragSource: createPublishDragSource(manager),
    hover: createHover(manager),
    drop: createDrop(manager),
    endDrag: createEndDrag(manager)
  };
}

var strictEquality = function strictEquality(a, b) {
  return a === b;
};
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */


function areCoordsEqual(offsetA, offsetB) {
  if (!offsetA && !offsetB) {
    return true;
  } else if (!offsetA || !offsetB) {
    return false;
  } else {
    return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
  }
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */


function areArraysEqual(a, b) {
  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : strictEquality;

  if (a.length !== b.length) {
    return false;
  }

  for (var _i5 = 0; _i5 < a.length; ++_i5) {
    if (!isEqual(a[_i5], b[_i5])) {
      return false;
    }
  }

  return true;
}

var initialState = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};

function dragOffset() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: payload.sourceClientOffset,
        initialClientOffset: payload.clientOffset,
        clientOffset: payload.clientOffset
      };

    case HOVER:
      if (areCoordsEqual(state.clientOffset, payload.clientOffset)) {
        return state;
      }

      return _objectSpread2({}, state, {
        clientOffset: payload.clientOffset
      });

    case END_DRAG:
    case DROP:
      return initialState;

    default:
      return state;
  }
}

var ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';

function _addSource(sourceId) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}

function _addTarget(targetId) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: targetId
    }
  };
}

function _removeSource(sourceId) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}

function _removeTarget(targetId) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: targetId
    }
  };
}

var initialState$1 = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: false,
  isSourcePublic: null
};

function dragOperation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case BEGIN_DRAG:
      return _objectSpread2({}, state, {
        itemType: payload.itemType,
        item: payload.item,
        sourceId: payload.sourceId,
        isSourcePublic: payload.isSourcePublic,
        dropResult: null,
        didDrop: false
      });

    case PUBLISH_DRAG_SOURCE:
      return _objectSpread2({}, state, {
        isSourcePublic: true
      });

    case HOVER:
      return _objectSpread2({}, state, {
        targetIds: payload.targetIds
      });

    case REMOVE_TARGET:
      if (state.targetIds.indexOf(payload.targetId) === -1) {
        return state;
      }

      return _objectSpread2({}, state, {
        targetIds: without(state.targetIds, payload.targetId)
      });

    case DROP:
      return _objectSpread2({}, state, {
        dropResult: payload.dropResult,
        didDrop: true,
        targetIds: []
      });

    case END_DRAG:
      return _objectSpread2({}, state, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: false,
        isSourcePublic: null,
        targetIds: []
      });

    default:
      return state;
  }
}

function refCount() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return state + 1;

    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return state - 1;

    default:
      return state;
  }
}

var NONE = [];
var ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */

function areDirty(dirtyIds, handlerIds) {
  if (dirtyIds === NONE) {
    return false;
  }

  if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
    return true;
  }

  var commonIds = intersection(handlerIds, dirtyIds);
  return commonIds.length > 0;
}

function dirtyHandlerIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case HOVER:
      break;

    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;

    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }

  var _action$payload = action.payload,
      _action$payload$targe = _action$payload.targetIds,
      targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe,
      _action$payload$prevT = _action$payload.prevTargetIds,
      prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
  var result = xor(targetIds, prevTargetIds);
  var didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);

  if (!didChange) {
    return NONE;
  } // Check the target ids at the innermost position. If they are valid, add them
  // to the result


  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
  var innermostTargetId = targetIds[targetIds.length - 1];

  if (prevInnermostTargetId !== innermostTargetId) {
    if (prevInnermostTargetId) {
      result.push(prevInnermostTargetId);
    }

    if (innermostTargetId) {
      result.push(innermostTargetId);
    }
  }

  return result;
}

function stateId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
}

function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    dirtyHandlerIds: dirtyHandlerIds(state.dirtyHandlerIds, {
      type: action.type,
      payload: _objectSpread2({}, action.payload, {
        prevTargetIds: get(state, 'dragOperation.targetIds', [])
      })
    }),
    dragOffset: dragOffset(state.dragOffset, action),
    refCount: refCount(state.refCount, action),
    dragOperation: dragOperation(state.dragOperation, action),
    stateId: stateId(state.stateId)
  };
}
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */


function add(a, b) {
  return {
    x: a.x + b.x,
    y: a.y + b.y
  };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */


function subtract(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */


function _getSourceClientOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset,
      initialSourceClientOffset = state.initialSourceClientOffset;

  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
    return null;
  }

  return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */


function _getDifferenceFromInitialOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset;

  if (!clientOffset || !initialClientOffset) {
    return null;
  }

  return subtract(clientOffset, initialClientOffset);
}

var DragDropMonitorImpl =
/*#__PURE__*/
function () {
  function DragDropMonitorImpl(store, registry) {
    _classCallCheck2(this, DragDropMonitorImpl);

    this.store = store;
    this.registry = registry;
  }

  _createClass2(DragDropMonitorImpl, [{
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      var _this7 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        handlerIds: undefined
      };
      var handlerIds = options.handlerIds;
      browser(typeof listener === 'function', 'listener must be a function.');
      browser(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
      var prevStateId = this.store.getState().stateId;

      var handleChange = function handleChange() {
        var state = _this7.store.getState();

        var currentStateId = state.stateId;

        try {
          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !areDirty(state.dirtyHandlerIds, handlerIds);

          if (!canSkipListener) {
            listener();
          }
        } finally {
          prevStateId = currentStateId;
        }
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      var _this8 = this;

      browser(typeof listener === 'function', 'listener must be a function.');
      var previousState = this.store.getState().dragOffset;

      var handleChange = function handleChange() {
        var nextState = _this8.store.getState().dragOffset;

        if (nextState === previousState) {
          return;
        }

        previousState = nextState;
        listener();
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId);
      browser(source, 'Expected to find a valid source.');

      if (this.isDragging()) {
        return false;
      }

      return source.canDrag(this, sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var target = this.registry.getTarget(targetId);
      browser(target, 'Expected to find a valid target.');

      if (!this.isDragging() || this.didDrop()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();
      return matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return Boolean(this.getItemType());
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      // undefined on initial render
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId, true);
      browser(source, 'Expected to find a valid source.');

      if (!this.isDragging() || !this.isSourcePublic()) {
        return false;
      }

      var sourceType = this.registry.getSourceType(sourceId);
      var draggedItemType = this.getItemType();

      if (sourceType !== draggedItemType) {
        return false;
      }

      return source.isDragging(this, sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shallow: false
      };

      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var shallow = options.shallow;

      if (!this.isDragging()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();

      if (draggedItemType && !matchesType(targetType, draggedItemType)) {
        return false;
      }

      var targetIds = this.getTargetIds();

      if (!targetIds.length) {
        return false;
      }

      var index = targetIds.indexOf(targetId);

      if (shallow) {
        return index === targetIds.length - 1;
      } else {
        return index > -1;
      }
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.store.getState().dragOperation.itemType;
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.store.getState().dragOperation.item;
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.store.getState().dragOperation.sourceId;
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.store.getState().dragOperation.targetIds;
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.store.getState().dragOperation.dropResult;
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.store.getState().dragOperation.didDrop;
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return this.store.getState().dragOperation.isSourcePublic;
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.store.getState().dragOffset.initialClientOffset;
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.store.getState().dragOffset.initialSourceClientOffset;
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.store.getState().dragOffset.clientOffset;
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return _getSourceClientOffset(this.store.getState().dragOffset);
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return _getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
  }]);

  return DragDropMonitorImpl;
}(); // Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.


var browserRaw = rawAsap;

function rawAsap(task) {
  if (!queue.length) {
    requestFlush();
  } // Equivalent to push, but avoids a function call.


  queue[queue.length] = task;
}

var queue = []; // `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.

var requestFlush; // The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.

var index = 0; // If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.

var capacity = 1024; // The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.

function flush() {
  while (index < queue.length) {
    var currentIndex = index; // Advance the index before calling the task. This ensures that we will
    // begin flushing on the next task the task throws an error.

    index = index + 1;
    queue[currentIndex].call(); // Prevent leaking memory for long chains of recursive calls to `asap`.
    // If we call `asap` within tasks scheduled by `asap`, the queue will
    // grow, but to avoid an O(n) walk for every task we execute, we don't
    // shift tasks off the queue after they have been executed.
    // Instead, we periodically shift 1024 tasks off the queue.

    if (index > capacity) {
      // Manually shift all values starting at the index back to the
      // beginning of the queue.
      for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
        queue[scan] = queue[scan + index];
      }

      queue.length -= index;
      index = 0;
    }
  }

  queue.length = 0;
  index = 0;
} // `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */


var scope = typeof commonjsGlobal !== "undefined" ? commonjsGlobal : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver; // MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7

if (typeof BrowserMutationObserver === "function") {
  requestFlush = makeRequestCallFromMutationObserver(flush); // MessageChannels are desirable because they give direct access to the HTML
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
} else {
  requestFlush = makeRequestCallFromTimer(flush);
} // `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.


rawAsap.requestFlush = requestFlush; // To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".

function makeRequestCallFromMutationObserver(callback) {
  var toggle = 1;
  var observer = new BrowserMutationObserver(callback);
  var node = document.createTextNode("");
  observer.observe(node, {
    characterData: true
  });
  return function requestCall() {
    toggle = -toggle;
    node.data = toggle;
  };
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.


function makeRequestCallFromTimer(callback) {
  return function requestCall() {
    // We dispatch a timeout with a specified delay of 0 for engines that
    // can reliably accommodate that request. This will usually be snapped
    // to a 4 milisecond delay, but once we're flushing, there's no delay
    // between events.
    var timeoutHandle = setTimeout(handleTimer, 0); // However, since this timer gets frequently dropped in Firefox
    // workers, we enlist an interval handle that will try to fire
    // an event 20 times per second until it succeeds.

    var intervalHandle = setInterval(handleTimer, 50);

    function handleTimer() {
      // Whichever timer succeeds will cancel both timers and
      // execute the callback.
      clearTimeout(timeoutHandle);
      clearInterval(intervalHandle);
      callback();
    }
  };
} // This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.


rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer; // rawAsap provides everything we need except exception management.
// RawTasks are recycled to reduce GC churn.

var freeTasks = []; // We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.

var pendingErrors = [];
var requestErrorThrow = browserRaw.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
  if (pendingErrors.length) {
    throw pendingErrors.shift();
  }
}
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */


var browserAsap = asap;

function asap(task) {
  var rawTask;

  if (freeTasks.length) {
    rawTask = freeTasks.pop();
  } else {
    rawTask = new RawTask();
  }

  rawTask.task = task;
  browserRaw(rawTask);
} // We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.


function RawTask() {
  this.task = null;
} // The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.


RawTask.prototype.call = function () {
  try {
    this.task.call();
  } catch (error) {
    if (asap.onerror) {
      // This hook exists purely for testing purposes.
      // Its name will be periodically randomized to break any code that
      // depends on its existence.
      asap.onerror(error);
    } else {
      // In a web browser, exceptions are not fatal. However, to avoid
      // slowing down the queue of pending tasks, we rethrow the error in a
      // lower priority turn.
      pendingErrors.push(error);
      requestErrorThrow();
    }
  } finally {
    this.task = null;
    freeTasks[freeTasks.length] = this;
  }
};

var nextUniqueId = 0;

function getNextUniqueId() {
  return nextUniqueId++;
}

function validateSourceContract(source) {
  browser(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
  browser(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
  browser(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}

function validateTargetContract(target) {
  browser(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
  browser(typeof target.hover === 'function', 'Expected hover to be a function.');
  browser(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}

function validateType(type, allowArray) {
  if (allowArray && Array.isArray(type)) {
    type.forEach(function (t) {
      return validateType(t, false);
    });
    return;
  }

  browser(typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

function getNextHandlerId(role) {
  var id = getNextUniqueId().toString();

  switch (role) {
    case HandlerRole.SOURCE:
      return "S".concat(id);

    case HandlerRole.TARGET:
      return "T".concat(id);

    default:
      throw new Error("Unknown Handler Role: ".concat(role));
  }
}

function parseRoleFromHandlerId(handlerId) {
  switch (handlerId[0]) {
    case 'S':
      return HandlerRole.SOURCE;

    case 'T':
      return HandlerRole.TARGET;

    default:
      browser(false, "Cannot parse handler ID: ".concat(handlerId));
  }
}

function mapContainsValue(map, searchValue) {
  var entries = map.entries();
  var isDone = false;

  do {
    var _entries$next = entries.next(),
        done = _entries$next.done,
        _entries$next$value = _slicedToArray2(_entries$next.value, 2),
        value = _entries$next$value[1];

    if (value === searchValue) {
      return true;
    }

    isDone = done;
  } while (!isDone);

  return false;
}

var HandlerRegistryImpl =
/*#__PURE__*/
function () {
  function HandlerRegistryImpl(store) {
    _classCallCheck2(this, HandlerRegistryImpl);

    this.store = store;
    this.types = new Map();
    this.dragSources = new Map();
    this.dropTargets = new Map();
    this.pinnedSourceId = null;
    this.pinnedSource = null;
  }

  _createClass2(HandlerRegistryImpl, [{
    key: "addSource",
    value: function addSource(type, source) {
      validateType(type);
      validateSourceContract(source);
      var sourceId = this.addHandler(HandlerRole.SOURCE, type, source);
      this.store.dispatch(_addSource(sourceId));
      return sourceId;
    }
  }, {
    key: "addTarget",
    value: function addTarget(type, target) {
      validateType(type, true);
      validateTargetContract(target);
      var targetId = this.addHandler(HandlerRole.TARGET, type, target);
      this.store.dispatch(_addTarget(targetId));
      return targetId;
    }
  }, {
    key: "containsHandler",
    value: function containsHandler(handler) {
      return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
  }, {
    key: "getSource",
    value: function getSource(sourceId) {
      var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      browser(this.isSourceId(sourceId), 'Expected a valid source ID.');
      var isPinned = includePinned && sourceId === this.pinnedSourceId;
      var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
      return source;
    }
  }, {
    key: "getTarget",
    value: function getTarget(targetId) {
      browser(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.dropTargets.get(targetId);
    }
  }, {
    key: "getSourceType",
    value: function getSourceType(sourceId) {
      browser(this.isSourceId(sourceId), 'Expected a valid source ID.');
      return this.types.get(sourceId);
    }
  }, {
    key: "getTargetType",
    value: function getTargetType(targetId) {
      browser(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.types.get(targetId);
    }
  }, {
    key: "isSourceId",
    value: function isSourceId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.SOURCE;
    }
  }, {
    key: "isTargetId",
    value: function isTargetId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.TARGET;
    }
  }, {
    key: "removeSource",
    value: function removeSource(sourceId) {
      var _this9 = this;

      browser(this.getSource(sourceId), 'Expected an existing source.');
      this.store.dispatch(_removeSource(sourceId));
      browserAsap(function () {
        _this9.dragSources.delete(sourceId);

        _this9.types.delete(sourceId);
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(targetId) {
      browser(this.getTarget(targetId), 'Expected an existing target.');
      this.store.dispatch(_removeTarget(targetId));
      this.dropTargets.delete(targetId);
      this.types.delete(targetId);
    }
  }, {
    key: "pinSource",
    value: function pinSource(sourceId) {
      var source = this.getSource(sourceId);
      browser(source, 'Expected an existing source.');
      this.pinnedSourceId = sourceId;
      this.pinnedSource = source;
    }
  }, {
    key: "unpinSource",
    value: function unpinSource() {
      browser(this.pinnedSource, 'No source is pinned at the time.');
      this.pinnedSourceId = null;
      this.pinnedSource = null;
    }
  }, {
    key: "addHandler",
    value: function addHandler(role, type, handler) {
      var id = getNextHandlerId(role);
      this.types.set(id, type);

      if (role === HandlerRole.SOURCE) {
        this.dragSources.set(id, handler);
      } else if (role === HandlerRole.TARGET) {
        this.dropTargets.set(id, handler);
      }

      return id;
    }
  }]);

  return HandlerRegistryImpl;
}();

function makeStoreInstance(debugMode) {
  // TODO: if we ever make a react-native version of this,
  // we'll need to consider how to pull off dev-tooling
  var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce, debugMode && reduxDevTools && reduxDevTools({
    name: 'dnd-core',
    instanceId: 'dnd-core'
  }));
}

var DragDropManagerImpl =
/*#__PURE__*/
function () {
  function DragDropManagerImpl(createBackend) {
    var _this10 = this;

    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var debugMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck2(this, DragDropManagerImpl);

    this.context = context;
    this.isSetUp = false;

    this.handleRefCountChange = function () {
      var shouldSetUp = _this10.store.getState().refCount > 0;

      if (shouldSetUp && !_this10.isSetUp) {
        _this10.backend.setup();

        _this10.isSetUp = true;
      } else if (!shouldSetUp && _this10.isSetUp) {
        _this10.backend.teardown();

        _this10.isSetUp = false;
      }
    };

    var store = makeStoreInstance(debugMode);
    this.store = store;
    this.monitor = new DragDropMonitorImpl(store, new HandlerRegistryImpl(store));
    this.backend = createBackend(this);
    store.subscribe(this.handleRefCountChange);
  }

  _createClass2(DragDropManagerImpl, [{
    key: "getContext",
    value: function getContext() {
      return this.context;
    }
  }, {
    key: "getMonitor",
    value: function getMonitor() {
      return this.monitor;
    }
  }, {
    key: "getBackend",
    value: function getBackend() {
      return this.backend;
    }
  }, {
    key: "getRegistry",
    value: function getRegistry() {
      return this.monitor.registry;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      var manager = this;
      var dispatch = this.store.dispatch;

      function bindActionCreator(actionCreator) {
        return function () {
          for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }

          var action = actionCreator.apply(manager, args);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      var actions = createDragDropActions(this);
      return Object.keys(actions).reduce(function (boundActions, key) {
        var action = actions[key];
        boundActions[key] = bindActionCreator(action);
        return boundActions;
      }, {});
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.store.dispatch(action);
    }
  }]);

  return DragDropManagerImpl;
}();

function createDragDropManager(backend, context, debugMode) {
  return new DragDropManagerImpl(backend, context, debugMode);
}
/**
 * Create the React Context
 */


var DndContext = createContext({
  dragDropManager: undefined
});
/**
 * Creates the context object we're providing
 * @param backend
 * @param context
 */

function createDndContext(backend, context, debugMode) {
  return {
    dragDropManager: createDragDropManager(backend, context, debugMode)
  };
}
/**
 * A React component that provides the React-DnD context
 */


var DndProvider = memo(function (_ref10) {
  var children = _ref10.children,
      props = _objectWithoutProperties2(_ref10, ["children"]);

  var context = 'manager' in props ? {
    dragDropManager: props.manager
  } : createSingletonDndContext(props.backend, props.context, props.debugMode);
  return createElement(DndContext.Provider, {
    value: context
  }, children);
});
var instanceSymbol = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');

function createSingletonDndContext(backend) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
  var debugMode = arguments.length > 2 ? arguments[2] : undefined;
  var ctx = context;

  if (!ctx[instanceSymbol]) {
    ctx[instanceSymbol] = createDndContext(backend, context, debugMode);
  }

  return ctx[instanceSymbol];
}

function getGlobalContext() {
  return typeof global !== 'undefined' ? global : window;
}
/*
 * A utility for rendering a drag preview image
 */


var DragPreviewImage = memo(function (_ref11) {
  var connect = _ref11.connect,
      src = _ref11.src;

  if (typeof Image !== 'undefined') {
    var img = new Image();
    img.src = src;

    img.onload = function () {
      return connect(img);
    };
  }

  return null;
});
DragPreviewImage.displayName = 'DragPreviewImage'; //

var shallowequal = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
};

function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);
  return [targetId, function () {
    return registry.removeTarget(targetId);
  }];
}

function registerSource(type, source, manager) {
  var registry = manager.getRegistry();
  var sourceId = registry.addSource(type, source);
  return [sourceId, function () {
    return registry.removeSource(sourceId);
  }];
}

var isCallingCanDrag = false;
var isCallingIsDragging = false;

var DragSourceMonitorImpl =
/*#__PURE__*/
function () {
  function DragSourceMonitorImpl(manager) {
    _classCallCheck2(this, DragSourceMonitorImpl);

    this.sourceId = null;
    this.internalMonitor = manager.getMonitor();
  }

  _createClass2(DragSourceMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(sourceId) {
      this.sourceId = sourceId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.sourceId;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      browser(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingCanDrag = true;
        return this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = false;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      if (!this.sourceId) {
        return false;
      }

      browser(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingIsDragging = true;
        return this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = false;
      }
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      return this.internalMonitor.isDraggingSource(sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId, options) {
      return this.internalMonitor.isOverTarget(targetId, options);
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.internalMonitor.getTargetIds();
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return this.internalMonitor.isSourcePublic();
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.internalMonitor.getSourceId();
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      return this.internalMonitor.subscribeToOffsetChange(listener);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      return this.internalMonitor.canDragSource(sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      return this.internalMonitor.canDropOnTarget(targetId);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DragSourceMonitorImpl;
}();

function setRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else {
    ref.current = node;
  }
}

function cloneWithRef(element, newRef) {
  var previousRef = element.ref;
  browser(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');

  if (!previousRef) {
    // When there is no ref on the element, use the new ref directly
    return cloneElement(element, {
      ref: newRef
    });
  }

  return cloneElement(element, {
    ref: function ref(node) {
      setRef(newRef, node);

      if (previousRef) {
        setRef(previousRef, node);
      }
    }
  });
}

function throwIfCompositeComponentElement(element) {
  // Custom components can no longer be wrapped directly in React DnD 2.0
  // so that we don't need to depend on findDOMNode() from react-dom.
  if (typeof element.type === 'string') {
    return;
  }

  var displayName = element.type.displayName || element.type.name || 'the component';
  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
  return function () {
    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // When passed a node, call the hook straight away.
    if (!isValidElement(elementOrNode)) {
      var node = elementOrNode;
      hook(node, options); // return the node so it can be chained (e.g. when within callback refs
      // <div ref={node => connectDragSource(connectDropTarget(node))}/>

      return node;
    } // If passed a ReactElement, clone it and attach this function as a ref.
    // This helps us achieve a neat API where user doesn't even know that refs
    // are being used under the hood.


    var element = elementOrNode;
    throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly

    var ref = options ? function (node) {
      return hook(node, options);
    } : hook;
    return cloneWithRef(element, ref);
  };
}

function wrapConnectorHooks(hooks) {
  var wrappedHooks = {};
  Object.keys(hooks).forEach(function (key) {
    var hook = hooks[key]; // ref objects should be passed straight through without wrapping

    if (key.endsWith('Ref')) {
      wrappedHooks[key] = hooks[key];
    } else {
      var wrappedHook = wrapHookToRecognizeElement(hook);

      wrappedHooks[key] = function () {
        return wrappedHook;
      };
    }
  });
  return wrappedHooks;
}

function isRef(obj) {
  return obj !== null && typeof obj === 'object' && obj.hasOwnProperty('current');
}

var SourceConnector =
/*#__PURE__*/
function () {
  function SourceConnector(backend) {
    var _this11 = this;

    _classCallCheck2(this, SourceConnector);

    this.backend = backend;
    this.hooks = wrapConnectorHooks({
      dragSource: function dragSource(node, options) {
        _this11.dragSourceOptions = options || null;

        if (isRef(node)) {
          _this11.dragSourceRef = node;
        } else {
          _this11.dragSourceNode = node;
        }

        _this11.reconnectDragSource();
      },
      dragPreview: function dragPreview(node, options) {
        _this11.dragPreviewOptions = options || null;

        if (isRef(node)) {
          _this11.dragPreviewRef = node;
        } else {
          _this11.dragPreviewNode = node;
        }

        _this11.reconnectDragPreview();
      }
    });
    this.handlerId = null; // The drop target may either be attached via ref or connect function

    this.dragSourceRef = null;
    this.dragSourceOptionsInternal = null; // The drag preview may either be attached via ref or connect function

    this.dragPreviewRef = null;
    this.dragPreviewOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDragSource = null;
    this.lastConnectedDragSourceOptions = null;
    this.lastConnectedDragPreview = null;
    this.lastConnectedDragPreviewOptions = null;
  }

  _createClass2(SourceConnector, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (this.handlerId === newHandlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      this.reconnectDragSource();
      this.reconnectDragPreview();
    }
  }, {
    key: "reconnectDragSource",
    value: function reconnectDragSource() {
      // if nothing has changed then don't resubscribe
      var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();

      if (didChange) {
        this.disconnectDragSource();
      }

      var dragSource = this.dragSource;

      if (!this.handlerId) {
        return;
      }

      if (!dragSource) {
        this.lastConnectedDragSource = dragSource;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragSource = dragSource;
        this.lastConnectedDragSourceOptions = this.dragSourceOptions;
        this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
      }
    }
  }, {
    key: "reconnectDragPreview",
    value: function reconnectDragPreview() {
      // if nothing has changed then don't resubscribe
      var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();

      if (didChange) {
        this.disconnectDragPreview();
      }

      var dragPreview = this.dragPreview;

      if (!this.handlerId || !dragPreview) {
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragPreview = dragPreview;
        this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
        this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
      }
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didConnectedDragSourceChange",
    value: function didConnectedDragSourceChange() {
      return this.lastConnectedDragSource !== this.dragSource;
    }
  }, {
    key: "didConnectedDragPreviewChange",
    value: function didConnectedDragPreviewChange() {
      return this.lastConnectedDragPreview !== this.dragPreview;
    }
  }, {
    key: "didDragSourceOptionsChange",
    value: function didDragSourceOptionsChange() {
      return !shallowequal(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
  }, {
    key: "didDragPreviewOptionsChange",
    value: function didDragPreviewOptionsChange() {
      return !shallowequal(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
  }, {
    key: "disconnectDragSource",
    value: function disconnectDragSource() {
      if (this.dragSourceUnsubscribe) {
        this.dragSourceUnsubscribe();
        this.dragSourceUnsubscribe = undefined;
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
      }
    }
  }, {
    key: "disconnectDragPreview",
    value: function disconnectDragPreview() {
      if (this.dragPreviewUnsubscribe) {
        this.dragPreviewUnsubscribe();
        this.dragPreviewUnsubscribe = undefined;
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
      }
    }
  }, {
    key: "connectTarget",
    get: function get() {
      return this.dragSource;
    }
  }, {
    key: "dragSourceOptions",
    get: function get() {
      return this.dragSourceOptionsInternal;
    },
    set: function set(options) {
      this.dragSourceOptionsInternal = options;
    }
  }, {
    key: "dragPreviewOptions",
    get: function get() {
      return this.dragPreviewOptionsInternal;
    },
    set: function set(options) {
      this.dragPreviewOptionsInternal = options;
    }
  }, {
    key: "dragSource",
    get: function get() {
      return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
  }, {
    key: "dragPreview",
    get: function get() {
      return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
  }]);

  return SourceConnector;
}();

var TargetConnector =
/*#__PURE__*/
function () {
  function TargetConnector(backend) {
    var _this12 = this;

    _classCallCheck2(this, TargetConnector);

    this.backend = backend;
    this.hooks = wrapConnectorHooks({
      dropTarget: function dropTarget(node, options) {
        _this12.dropTargetOptions = options;

        if (isRef(node)) {
          _this12.dropTargetRef = node;
        } else {
          _this12.dropTargetNode = node;
        }

        _this12.reconnect();
      }
    });
    this.handlerId = null; // The drop target may either be attached via ref or connect function

    this.dropTargetRef = null;
    this.dropTargetOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDropTarget = null;
    this.lastConnectedDropTargetOptions = null;
  }

  _createClass2(TargetConnector, [{
    key: "reconnect",
    value: function reconnect() {
      // if nothing has changed then don't resubscribe
      var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();

      if (didChange) {
        this.disconnectDropTarget();
      }

      var dropTarget = this.dropTarget;

      if (!this.handlerId) {
        return;
      }

      if (!dropTarget) {
        this.lastConnectedDropTarget = dropTarget;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDropTarget = dropTarget;
        this.lastConnectedDropTargetOptions = this.dropTargetOptions;
        this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
      }
    }
  }, {
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (newHandlerId === this.handlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didDropTargetChange",
    value: function didDropTargetChange() {
      return this.lastConnectedDropTarget !== this.dropTarget;
    }
  }, {
    key: "didOptionsChange",
    value: function didOptionsChange() {
      return !shallowequal(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
  }, {
    key: "disconnectDropTarget",
    value: function disconnectDropTarget() {
      if (this.unsubscribeDropTarget) {
        this.unsubscribeDropTarget();
        this.unsubscribeDropTarget = undefined;
      }
    }
  }, {
    key: "connectTarget",
    get: function get() {
      return this.dropTarget;
    }
  }, {
    key: "dropTargetOptions",
    get: function get() {
      return this.dropTargetOptionsInternal;
    },
    set: function set(options) {
      this.dropTargetOptionsInternal = options;
    }
  }, {
    key: "dropTarget",
    get: function get() {
      return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
  }]);

  return TargetConnector;
}();

var isCallingCanDrop = false;

var DropTargetMonitorImpl =
/*#__PURE__*/
function () {
  function DropTargetMonitorImpl(manager) {
    _classCallCheck2(this, DropTargetMonitorImpl);

    this.targetId = null;
    this.internalMonitor = manager.getMonitor();
  }

  _createClass2(DropTargetMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(targetId) {
      this.targetId = targetId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.targetId;
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      // Cut out early if the target id has not been set. This should prevent errors
      // where the user has an older version of dnd-core like in
      // https://github.com/react-dnd/react-dnd/issues/1310
      if (!this.targetId) {
        return false;
      }

      browser(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');

      try {
        isCallingCanDrop = true;
        return this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = false;
      }
    }
  }, {
    key: "isOver",
    value: function isOver(options) {
      if (!this.targetId) {
        return false;
      }

      return this.internalMonitor.isOverTarget(this.targetId, options);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DropTargetMonitorImpl;
}(); // cheap lodash replacements


function isFunction(input) {
  return typeof input === 'function';
}

function noop() {// noop
}

function isObjectLike(input) {
  return typeof input === 'object' && input !== null;
}

function isPlainObject$1(input) {
  if (!isObjectLike(input)) {
    return false;
  }

  if (Object.getPrototypeOf(input) === null) {
    return true;
  }

  var proto = input;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(input) === proto;
}

function getDecoratedComponent(instanceRef) {
  var currentRef = instanceRef.current;

  if (currentRef == null) {
    return null;
  } else if (currentRef.decoratedRef) {
    // go through the private field in decorateHandler to avoid the invariant hit
    return currentRef.decoratedRef.current;
  } else {
    return currentRef;
  }
}

function isClassComponent(Component$$1) {
  return Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function';
}

function isRefForwardingComponent(C) {
  return C && C.$$typeof && C.$$typeof.toString() === 'Symbol(react.forward_ref)';
}

function isRefable(C) {
  return isClassComponent(C) || isRefForwardingComponent(C);
}

function checkDecoratorArguments(functionName, signature) {
  if (process.env.NODE_ENV !== 'production') {
    for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
      args[_key6 - 2] = arguments[_key6];
    }

    for (var _i6 = 0, _args = args; _i6 < _args.length; _i6++) {
      var arg = _args[_i6];

      if (arg && arg.prototype && arg.prototype.render) {
        // eslint-disable-next-line no-console
        console.error('You seem to be applying the arguments in the wrong order. ' + "It should be ".concat(functionName, "(").concat(signature, ")(Component), not the other way around. ") + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
        return;
      }
    }
  }
}
/** @license React v16.13.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element$1 = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;
/**
 * Provides a set of static methods for creating Disposables.
 * @param {Function} action Action to run during the first call to dispose.
 * The action is guaranteed to be run at most once.
 */

var Disposable =
/*#__PURE__*/
function () {
  function Disposable(action) {
    _classCallCheck2(this, Disposable);

    this.isDisposed = false;
    this.action = isFunction(action) ? action : noop;
  }
  /**
   * Validates whether the given object is a disposable
   * @param {Object} Object to test whether it has a dispose method
   * @returns {Boolean} true if a disposable object, else false.
   */


  _createClass2(Disposable, [{
    key: "dispose",

    /** Performs the task of cleaning up resources. */
    value: function dispose() {
      if (!this.isDisposed) {
        this.action();
        this.isDisposed = true;
      }
    }
  }], [{
    key: "isDisposable",
    value: function isDisposable(d) {
      return d && isFunction(d.dispose);
    }
  }, {
    key: "_fixup",
    value: function _fixup(result) {
      return Disposable.isDisposable(result) ? result : Disposable.empty;
    }
    /**
     * Creates a disposable object that invokes the specified action when disposed.
     * @param {Function} dispose Action to run during the first call to dispose.
     * The action is guaranteed to be run at most once.
     * @return {Disposable} The disposable object that runs the given action upon disposal.
     */

  }, {
    key: "create",
    value: function create(action) {
      return new Disposable(action);
    }
  }]);

  return Disposable;
}();
/**
 * Gets the disposable that does nothing when disposed.
 */


Disposable.empty = {
  dispose: noop
};
/**
 * Represents a group of disposable resources that are disposed together.
 * @constructor
 */

var CompositeDisposable =
/*#__PURE__*/
function () {
  function CompositeDisposable() {
    _classCallCheck2(this, CompositeDisposable);

    this.isDisposed = false;

    for (var _len7 = arguments.length, disposables = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      disposables[_key7] = arguments[_key7];
    }

    this.disposables = disposables;
  }
  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Any} item Disposable to add.
   */


  _createClass2(CompositeDisposable, [{
    key: "add",
    value: function add(item) {
      if (this.isDisposed) {
        item.dispose();
      } else {
        this.disposables.push(item);
      }
    }
    /**
     * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
     * @param {Any} item Disposable to remove.
     * @returns {Boolean} true if found; false otherwise.
     */

  }, {
    key: "remove",
    value: function remove(item) {
      var shouldDispose = false;

      if (!this.isDisposed) {
        var idx = this.disposables.indexOf(item);

        if (idx !== -1) {
          shouldDispose = true;
          this.disposables.splice(idx, 1);
          item.dispose();
        }
      }

      return shouldDispose;
    }
    /**
     *  Disposes all disposables in the group and removes them from the group but
     *  does not dispose the CompositeDisposable.
     */

  }, {
    key: "clear",
    value: function clear() {
      if (!this.isDisposed) {
        var len = this.disposables.length;
        var currentDisposables = new Array(len);

        for (var _i7 = 0; _i7 < len; _i7++) {
          currentDisposables[_i7] = this.disposables[_i7];
        }

        this.disposables = [];

        for (var _i8 = 0; _i8 < len; _i8++) {
          currentDisposables[_i8].dispose();
        }
      }
    }
    /**
     *  Disposes all disposables in the group and removes them from the group.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      if (!this.isDisposed) {
        this.isDisposed = true;
        var len = this.disposables.length;
        var currentDisposables = new Array(len);

        for (var _i9 = 0; _i9 < len; _i9++) {
          currentDisposables[_i9] = this.disposables[_i9];
        }

        this.disposables = [];

        for (var _i10 = 0; _i10 < len; _i10++) {
          currentDisposables[_i10].dispose();
        }
      }
    }
  }]);

  return CompositeDisposable;
}();
/**
 * Represents a disposable resource whose underlying disposable resource can
 * be replaced by another disposable resource, causing automatic disposal of
 * the previous underlying disposable resource.
 */


var SerialDisposable =
/*#__PURE__*/
function () {
  function SerialDisposable() {
    _classCallCheck2(this, SerialDisposable);

    this.isDisposed = false;
  }
  /**
   * Gets the underlying disposable.
   * @returns {Any} the underlying disposable.
   */


  _createClass2(SerialDisposable, [{
    key: "getDisposable",
    value: function getDisposable() {
      return this.current;
    }
  }, {
    key: "setDisposable",
    value: function setDisposable(value) {
      var shouldDispose = this.isDisposed;

      if (!shouldDispose) {
        var old = this.current;
        this.current = value;

        if (old) {
          old.dispose();
        }
      }

      if (shouldDispose && value) {
        value.dispose();
      }
    }
    /** Performs the task of cleaning up resources. */

  }, {
    key: "dispose",
    value: function dispose() {
      if (!this.isDisposed) {
        this.isDisposed = true;
        var old = this.current;
        this.current = undefined;

        if (old) {
          old.dispose();
        }
      }
    }
  }]);

  return SerialDisposable;
}();

function decorateHandler(_ref12) {
  var DecoratedComponent = _ref12.DecoratedComponent,
      createHandler = _ref12.createHandler,
      createMonitor = _ref12.createMonitor,
      createConnector = _ref12.createConnector,
      registerHandler = _ref12.registerHandler,
      containerDisplayName = _ref12.containerDisplayName,
      getType = _ref12.getType,
      collect = _ref12.collect,
      options = _ref12.options;
  var _options$arePropsEqua = options.arePropsEqual,
      arePropsEqual = _options$arePropsEqua === void 0 ? shallowequal : _options$arePropsEqua;
  var Decorated = DecoratedComponent;
  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

  var DragDropContainer =
  /*#__PURE__*/
  function (_Component3) {
    _inherits2(DragDropContainer, _Component3);

    function DragDropContainer(props) {
      var _this13;

      _classCallCheck2(this, DragDropContainer);

      _this13 = _possibleConstructorReturn2(this, _getPrototypeOf3(DragDropContainer).call(this, props));
      _this13.decoratedRef = createRef();

      _this13.handleChange = function () {
        var nextState = _this13.getCurrentState();

        if (!shallowequal(nextState, _this13.state)) {
          _this13.setState(nextState);
        }
      };

      _this13.disposable = new SerialDisposable();

      _this13.receiveProps(props);

      _this13.dispose();

      return _this13;
    }

    _createClass2(DragDropContainer, [{
      key: "getHandlerId",
      value: function getHandlerId() {
        return this.handlerId;
      }
    }, {
      key: "getDecoratedComponentInstance",
      value: function getDecoratedComponentInstance() {
        browser(this.decoratedRef.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
        return this.decoratedRef.current;
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !arePropsEqual(nextProps, this.props) || !shallowequal(nextState, this.state);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.disposable = new SerialDisposable();
        this.currentType = undefined;
        this.receiveProps(this.props);
        this.handleChange();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!arePropsEqual(this.props, prevProps)) {
          this.receiveProps(this.props);
          this.handleChange();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.dispose();
      }
    }, {
      key: "receiveProps",
      value: function receiveProps(props) {
        if (!this.handler) {
          return;
        }

        this.handler.receiveProps(props);
        this.receiveType(getType(props));
      }
    }, {
      key: "receiveType",
      value: function receiveType(type) {
        if (!this.handlerMonitor || !this.manager || !this.handlerConnector) {
          return;
        }

        if (type === this.currentType) {
          return;
        }

        this.currentType = type;

        var _registerHandler = registerHandler(type, this.handler, this.manager),
            _registerHandler2 = _slicedToArray2(_registerHandler, 2),
            handlerId = _registerHandler2[0],
            unregister = _registerHandler2[1];

        this.handlerId = handlerId;
        this.handlerMonitor.receiveHandlerId(handlerId);
        this.handlerConnector.receiveHandlerId(handlerId);
        var globalMonitor = this.manager.getMonitor();
        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
          handlerIds: [handlerId]
        });
        this.disposable.setDisposable(new CompositeDisposable(new Disposable(unsubscribe), new Disposable(unregister)));
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.disposable.dispose();

        if (this.handlerConnector) {
          this.handlerConnector.receiveHandlerId(null);
        }
      }
    }, {
      key: "getCurrentState",
      value: function getCurrentState() {
        if (!this.handlerConnector) {
          return {};
        }

        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor, this.props);

        if (process.env.NODE_ENV !== 'production') {
          browser(isPlainObject$1(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
        }

        return nextState;
      }
    }, {
      key: "render",
      value: function render() {
        var _this14 = this;

        return createElement(DndContext.Consumer, null, function (_ref13) {
          var dragDropManager = _ref13.dragDropManager;

          _this14.receiveDragDropManager(dragDropManager);

          if (typeof requestAnimationFrame !== 'undefined') {
            requestAnimationFrame(function () {
              return _this14.handlerConnector.reconnect();
            });
          }

          return createElement(Decorated, Object.assign({}, _this14.props, _this14.getCurrentState(), {
            // NOTE: if Decorated is a Function Component, decoratedRef will not be populated unless it's a refforwarding component.
            ref: isRefable(Decorated) ? _this14.decoratedRef : null
          }));
        });
      }
    }, {
      key: "receiveDragDropManager",
      value: function receiveDragDropManager(dragDropManager) {
        if (this.manager !== undefined) {
          return;
        }

        browser(dragDropManager !== undefined, 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

        if (dragDropManager === undefined) {
          return;
        }

        this.manager = dragDropManager;
        this.handlerMonitor = createMonitor(dragDropManager);
        this.handlerConnector = createConnector(dragDropManager.getBackend());
        this.handler = createHandler(this.handlerMonitor, this.decoratedRef);
      }
    }]);

    return DragDropContainer;
  }(Component);

  DragDropContainer.DecoratedComponent = DecoratedComponent;
  DragDropContainer.displayName = "".concat(containerDisplayName, "(").concat(displayName, ")");
  return hoistNonReactStatics_cjs(DragDropContainer, DecoratedComponent);
}

function isValidType(type, allowArray) {
  return typeof type === 'string' || typeof type === 'symbol' || !!allowArray && Array.isArray(type) && type.every(function (t) {
    return isValidType(t, false);
  });
}

var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];

var SourceImpl =
/*#__PURE__*/
function () {
  function SourceImpl(spec, monitor, ref) {
    var _this15 = this;

    _classCallCheck2(this, SourceImpl);

    this.spec = spec;
    this.monitor = monitor;
    this.ref = ref;
    this.props = null;

    this.beginDrag = function () {
      if (!_this15.props) {
        return;
      }

      var item = _this15.spec.beginDrag(_this15.props, _this15.monitor, _this15.ref.current);

      if (process.env.NODE_ENV !== 'production') {
        browser(isPlainObject$1(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', item);
      }

      return item;
    };
  }

  _createClass2(SourceImpl, [{
    key: "receiveProps",
    value: function receiveProps(props) {
      this.props = props;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      if (!this.props) {
        return false;
      }

      if (!this.spec.canDrag) {
        return true;
      }

      return this.spec.canDrag(this.props, this.monitor);
    }
  }, {
    key: "isDragging",
    value: function isDragging(globalMonitor, sourceId) {
      if (!this.props) {
        return false;
      }

      if (!this.spec.isDragging) {
        return sourceId === globalMonitor.getSourceId();
      }

      return this.spec.isDragging(this.props, this.monitor);
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      if (!this.props) {
        return;
      }

      if (!this.spec.endDrag) {
        return;
      }

      this.spec.endDrag(this.props, this.monitor, getDecoratedComponent(this.ref));
    }
  }]);

  return SourceImpl;
}();

function createSourceFactory(spec) {
  Object.keys(spec).forEach(function (key) {
    browser(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', ALLOWED_SPEC_METHODS.join(', '), key);
    browser(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
  });
  REQUIRED_SPEC_METHODS.forEach(function (key) {
    browser(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
  });
  return function createSource(monitor, ref) {
    return new SourceImpl(spec, monitor, ref);
  };
}
/**
 * Decorates a component as a dragsource
 * @param type The dragsource type
 * @param spec The drag source specification
 * @param collect The props collector function
 * @param options DnD options
 */


function DragSource(type, spec, collect) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  checkDecoratorArguments('DragSource', 'type, spec, collect[, options]', type, spec, collect, options);
  var getType = type;

  if (typeof type !== 'function') {
    browser(isValidType(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', type);

    getType = function getType() {
      return type;
    };
  }

  browser(isPlainObject$1(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', spec);
  var createSource = createSourceFactory(spec);
  browser(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
  browser(isPlainObject$1(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
  return function decorateSource(DecoratedComponent) {
    return decorateHandler({
      containerDisplayName: 'DragSource',
      createHandler: createSource,
      registerHandler: registerSource,
      createConnector: function createConnector(backend) {
        return new SourceConnector(backend);
      },
      createMonitor: function createMonitor(manager) {
        return new DragSourceMonitorImpl(manager);
      },
      DecoratedComponent: DecoratedComponent,
      getType: getType,
      collect: collect,
      options: options
    });
  };
}

var ALLOWED_SPEC_METHODS$1 = ['canDrop', 'hover', 'drop'];

var TargetImpl =
/*#__PURE__*/
function () {
  function TargetImpl(spec, monitor, ref) {
    _classCallCheck2(this, TargetImpl);

    this.spec = spec;
    this.monitor = monitor;
    this.ref = ref;
    this.props = null;
  }

  _createClass2(TargetImpl, [{
    key: "receiveProps",
    value: function receiveProps(props) {
      this.props = props;
    }
  }, {
    key: "receiveMonitor",
    value: function receiveMonitor(monitor) {
      this.monitor = monitor;
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      if (!this.spec.canDrop) {
        return true;
      }

      return this.spec.canDrop(this.props, this.monitor);
    }
  }, {
    key: "hover",
    value: function hover() {
      if (!this.spec.hover) {
        return;
      }

      this.spec.hover(this.props, this.monitor, getDecoratedComponent(this.ref));
    }
  }, {
    key: "drop",
    value: function drop() {
      if (!this.spec.drop) {
        return undefined;
      }

      var dropResult = this.spec.drop(this.props, this.monitor, this.ref.current);

      if (process.env.NODE_ENV !== 'production') {
        browser(typeof dropResult === 'undefined' || isPlainObject$1(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', dropResult);
      }

      return dropResult;
    }
  }]);

  return TargetImpl;
}();

function createTargetFactory(spec) {
  Object.keys(spec).forEach(function (key) {
    browser(ALLOWED_SPEC_METHODS$1.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', ALLOWED_SPEC_METHODS$1.join(', '), key);
    browser(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', key, key, spec[key]);
  });
  return function createTarget(monitor, ref) {
    return new TargetImpl(spec, monitor, ref);
  };
}

function DropTarget(type, spec, collect) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  checkDecoratorArguments('DropTarget', 'type, spec, collect[, options]', type, spec, collect, options);
  var getType = type;

  if (typeof type !== 'function') {
    browser(isValidType(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', type);

    getType = function getType() {
      return type;
    };
  }

  browser(isPlainObject$1(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', spec);
  var createTarget = createTargetFactory(spec);
  browser(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
  browser(isPlainObject$1(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
  return function decorateTarget(DecoratedComponent) {
    return decorateHandler({
      containerDisplayName: 'DropTarget',
      createHandler: createTarget,
      registerHandler: registerTarget,
      createMonitor: function createMonitor(manager) {
        return new DropTargetMonitorImpl(manager);
      },
      createConnector: function createConnector(backend) {
        return new TargetConnector(backend);
      },
      DecoratedComponent: DecoratedComponent,
      getType: getType,
      collect: collect,
      options: options
    });
  };
}

function DragLayer$$1(collect) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  checkDecoratorArguments('DragLayer', 'collect[, options]', collect, options);
  browser(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', collect);
  browser(isPlainObject$1(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', options);
  return function decorateLayer(DecoratedComponent) {
    var Decorated = DecoratedComponent;
    var _options$arePropsEqua2 = options.arePropsEqual,
        arePropsEqual = _options$arePropsEqua2 === void 0 ? shallowequal : _options$arePropsEqua2;
    var displayName = Decorated.displayName || Decorated.name || 'Component';

    var DragLayerContainer =
    /*#__PURE__*/
    function (_Component4) {
      _inherits2(DragLayerContainer, _Component4);

      function DragLayerContainer() {
        var _this16;

        _classCallCheck2(this, DragLayerContainer);

        _this16 = _possibleConstructorReturn2(this, _getPrototypeOf3(DragLayerContainer).apply(this, arguments));
        _this16.isCurrentlyMounted = false;
        _this16.ref = createRef();

        _this16.handleChange = function () {
          if (!_this16.isCurrentlyMounted) {
            return;
          }

          var nextState = _this16.getCurrentState();

          if (!shallowequal(nextState, _this16.state)) {
            _this16.setState(nextState);
          }
        };

        return _this16;
      }

      _createClass2(DragLayerContainer, [{
        key: "getDecoratedComponentInstance",
        value: function getDecoratedComponentInstance() {
          browser(this.ref.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
          return this.ref.current;
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !arePropsEqual(nextProps, this.props) || !shallowequal(nextState, this.state);
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.isCurrentlyMounted = true;
          this.handleChange();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isCurrentlyMounted = false;

          if (this.unsubscribeFromOffsetChange) {
            this.unsubscribeFromOffsetChange();
            this.unsubscribeFromOffsetChange = undefined;
          }

          if (this.unsubscribeFromStateChange) {
            this.unsubscribeFromStateChange();
            this.unsubscribeFromStateChange = undefined;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this17 = this;

          return createElement(DndContext.Consumer, null, function (_ref14) {
            var dragDropManager = _ref14.dragDropManager;

            if (dragDropManager === undefined) {
              return null;
            }

            _this17.receiveDragDropManager(dragDropManager); // Let componentDidMount fire to initialize the collected state


            if (!_this17.isCurrentlyMounted) {
              return null;
            }

            return createElement(Decorated, Object.assign({}, _this17.props, _this17.state, {
              ref: isRefable(Decorated) ? _this17.ref : null
            }));
          });
        }
      }, {
        key: "receiveDragDropManager",
        value: function receiveDragDropManager(dragDropManager) {
          if (this.manager !== undefined) {
            return;
          }

          this.manager = dragDropManager;
          browser(typeof dragDropManager === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
          var monitor = this.manager.getMonitor();
          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
        }
      }, {
        key: "getCurrentState",
        value: function getCurrentState() {
          if (!this.manager) {
            return {};
          }

          var monitor = this.manager.getMonitor();
          return collect(monitor, this.props);
        }
      }]);

      return DragLayerContainer;
    }(Component);

    DragLayerContainer.displayName = "DragLayer(".concat(displayName, ")");
    DragLayerContainer.DecoratedComponent = DecoratedComponent;
    return hoistNonReactStatics_cjs(DragLayerContainer, DecoratedComponent);
  };
}
/**
 * @deprecated Use DnDProvider in your JSX tree instead. This will be removed in a future major version.
 *
 * Wrap the root component of your application with DragDropContext decorator to set up React DnD.
 * This lets you specify the backend, and sets up the shared DnD state behind the scenes.
 * @param backendFactory The DnD backend factory
 * @param backendContext The backend context
 */


function DragDropContext(backendFactory, backendContext, debugMode) {
  checkDecoratorArguments('DragDropContext', 'backend', backendFactory);
  var childContext = createDndContext(backendFactory, backendContext, debugMode);
  return function decorateContext(DecoratedComponent) {
    var Decorated = DecoratedComponent;
    var displayName = Decorated.displayName || Decorated.name || 'Component';

    var DragDropContextContainer =
    /*#__PURE__*/
    function (_Component5) {
      _inherits2(DragDropContextContainer, _Component5);

      function DragDropContextContainer(props, context) {
        var _this18;

        _classCallCheck2(this, DragDropContextContainer);

        _this18 = _possibleConstructorReturn2(this, _getPrototypeOf3(DragDropContextContainer).call(this, props, context));
        _this18.ref = createRef();

        _this18.getManager = function () {
          return childContext.dragDropManager;
        }; // eslint-disable-next-line no-console


        console.warn("DragDropContext has been deprecated and will be removed in a future version. Please use DndProvider instead.");
        return _this18;
      }

      _createClass2(DragDropContextContainer, [{
        key: "getDecoratedComponentInstance",
        value: function getDecoratedComponentInstance() {
          browser(this.ref.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
          return this.ref.current;
        }
      }, {
        key: "render",
        value: function render() {
          return createElement(DndContext.Provider, {
            value: childContext
          }, createElement(Decorated, Object.assign({}, this.props, {
            ref: isRefable(Decorated) ? this.ref : null
          })));
        }
      }]);

      return DragDropContextContainer;
    }(Component);

    DragDropContextContainer.DecoratedComponent = DecoratedComponent;
    DragDropContextContainer.displayName = "DragDropContext(".concat(displayName, ")");
    return hoistNonReactStatics_cjs(DragDropContextContainer, DecoratedComponent);
  };
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */


var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols$1) {
      symbols = getOwnPropertySymbols$1(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function printWarning$1() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement$$1, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement$$1(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement$$1(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };
  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

    var isValidElement$$1 = function isValidElement$$1(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod


    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(isValidElement$$1, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ExampleDropTarget {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: center;\n          justify-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n\n  min-height: 100px;\n\n  border: 2px dashed black;\n  padding: 20px;\n  -webkit-transition: 0.2s all ease;\n  transition: 0.2s all ease;\n}\n\n.ExampleDropTarget h4,\n.ExampleDropTarger p {\n  text-align: center;\n  word-break: break-word;\n}\n\n.ExampleDropTarget.can-drop {\n  border: 2px dashed #20a5d6;\n  background-color: #fafafa;\n  color: black;\n}\n\n.ExampleDropTarget.hovered {\n  border: 2px dashed #20a5d6;\n  background-color: black;\n  color: #91b9cd;\n  cursor: copy;\n}\n";
styleInject(css); // if they have the same string type.

var Types = {
  THUMBNAIL: 'thumbnail'
};
var divTarget = {
  drop: function drop(props, monitor, component) {
    // Note: For this example we use setState, but in
    // OHIF we will update the redux store instead
    var item = monitor.getItem();
    component.setState({
      item: {
        id: item.id,
        seriesDescription: item.seriesDescription
      }
    });
    return {
      id: 'ExampleDropTarget'
    };
  }
}; // TODO: Find out why we can't move this into the Example app instead.
// It looks like the context isn't properly shared.

var CustomDropTarget =
/*#__PURE__*/
function (_Component) {
  inherits(CustomDropTarget, _Component);

  function CustomDropTarget() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, CustomDropTarget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(CustomDropTarget)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      item: null
    });
    return _this;
  }

  createClass(CustomDropTarget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          canDrop = _this$props.canDrop,
          isOver = _this$props.isOver,
          connectDropTarget = _this$props.connectDropTarget;
      var isActive = canDrop && isOver;
      var className = ExampleDropTarget.className;

      if (isActive) {
        className += ' hovered';
      } else if (canDrop) {
        className += ' can-drop';
      }

      return connectDropTarget(React__default.createElement("div", {
        className: className
      }, React__default.createElement("h4", null, isActive ? 'Release to drop' : 'Drag / Drop something from the Study Browser here'), React__default.createElement("p", {
        className: "study-drop-results"
      }, this.state.item && JSON.stringify(this.state.item))));
    }
  }]);
  return CustomDropTarget;
}(Component);

defineProperty(CustomDropTarget, "className", 'ExampleDropTarget');
defineProperty(CustomDropTarget, "defaultProps", {
  isOver: false
});
defineProperty(CustomDropTarget, "propTypes", {
  connectDropTarget: propTypes.func.isRequired,
  canDrop: propTypes.bool.isRequired,
  isOver: propTypes.bool.isRequired
});

var collect = function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
};

var ExampleDropTarget = DropTarget(Types.THUMBNAIL, divTarget, collect)(CustomDropTarget);

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

var isNativeFunction = _isNativeFunction;
var construct = createCommonjsModule(function (module) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
      module.exports = _construct = Reflect.construct;
    } else {
      module.exports = _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  module.exports = _construct;
});
var wrapNativeSuper = createCommonjsModule(function (module) {
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return construct(Class, arguments, getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  module.exports = _wrapNativeSuper;
});
var css$1 = ":root {\n  --text-secondary-color: #91b9cd;\n  --active-color: #20a5d6;\n  --primary-background-color: #000;\n  --ui-border-color-dark: #3c5d80;\n  --sidebar-transition: all 0.3s ease;\n}\n.ThumbnailEntry.active .ImageThumbnail {\n  border-color: var(--active-color);\n  box-shadow: none;\n  -webkit-transition: var(--sidebar-transition);\n  transition: var(--sidebar-transition);\n}\n.ImageThumbnail {\n  background-color: var(--primary-background-color);\n  box-shadow: inset 0 0 0 1px var(--ui-border-color-dark);\n  border: 5px solid transparent;\n  border-radius: 12px;\n  height: 145px;\n  margin: 0 auto;\n  padding: 5px;\n  position: relative;\n  -webkit-transition: var(--sidebar-transition);\n  transition: var(--sidebar-transition);\n  width: 160px;\n  -moz-background-clip: padding;\n  -webkit-background-clip: padding;\n  background-clip: padding-box;\n}\n.image-thumbnail-canvas {\n  height: 100%;\n  overflow: hidden;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: center;\n          justify-content: center;\n}\n.image-thumbnail-canvas img {\n  -webkit-user-drag: none;\n  pointer-events: none;\n}\n.thumbnailLoadingIndicator {\n  display: none;\n  pointer-events: none;\n  color: var(--text-secondary-color);\n  height: 20px;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  position: absolute;\n}\n.thumbnailLoadingIndicator.d-block {\n  display: block;\n}\n.thumbnailLoadingIndicator p {\n  text-align: center;\n  font-size: 10pt;\n}\n.image-thumbnail-progress-bar {\n  position: relative;\n  width: 100%;\n  height: 3px;\n  top: -5px;\n}\n.image-thumbnail-progress-bar .image-thumbnail-progress-bar-inner {\n  height: 100%;\n  width: 0;\n  border-radius: 5px;\n  background-color: var(--active-color);\n}\n";
styleInject(css$1);

function ViewportErrorIndicator(props) {
  return React__default.createElement("div", {
    className: "loadingIndicator",
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: 'auto',
      textAlign: 'center',
      pointerEvents: 'none'
    }
  }, React__default.createElement("p", null, "Error"), React__default.createElement("p", {
    className: "description"
  }, "An error has occurred."), React__default.createElement("p", {
    className: "details"
  }, props.details));
}

ViewportErrorIndicator.propTypes = {
  details: propTypes.string
};

function ViewportLoadingIndicator(props) {
  return React__default.createElement("div", {
    className: "loadingIndicator",
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: 'auto',
      textAlign: 'center',
      pointerEvents: 'none'
    }
  }, "Loading ", props.percentComplete);
}

ViewportLoadingIndicator.propTypes = {
  percentComplete: propTypes.number
};

var strictUriEncode = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
};

function encoderForArrayFormat(opts) {
  switch (opts.arrayFormat) {
    case 'index':
      return function (key, value, index) {
        return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
      };

    case 'bracket':
      return function (key, value) {
        return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
      };

    default:
      return function (key, value) {
        return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
      };
  }
}

function parserForArrayFormat(opts) {
  var result;

  switch (opts.arrayFormat) {
    case 'index':
      return function (key, value, accumulator) {
        result = /\[(\d*)\]$/.exec(key);
        key = key.replace(/\[\d*\]$/, '');

        if (!result) {
          accumulator[key] = value;
          return;
        }

        if (accumulator[key] === undefined) {
          accumulator[key] = {};
        }

        accumulator[key][result[1]] = value;
      };

    case 'bracket':
      return function (key, value, accumulator) {
        result = /(\[\])$/.exec(key);
        key = key.replace(/\[\]$/, '');

        if (!result) {
          accumulator[key] = value;
          return;
        } else if (accumulator[key] === undefined) {
          accumulator[key] = [value];
          return;
        }

        accumulator[key] = [].concat(accumulator[key], value);
      };

    default:
      return function (key, value, accumulator) {
        if (accumulator[key] === undefined) {
          accumulator[key] = value;
          return;
        }

        accumulator[key] = [].concat(accumulator[key], value);
      };
  }
}

function encode(value, opts) {
  if (opts.encode) {
    return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
  }

  return value;
}

function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  } else if (typeof input === 'object') {
    return keysSorter(Object.keys(input)).sort(function (a, b) {
      return Number(a) - Number(b);
    }).map(function (key) {
      return input[key];
    });
  }

  return input;
}

var extract = function extract(str) {
  return str.split('?')[1] || '';
};

var parse = function parse(str, opts) {
  opts = objectAssign({
    arrayFormat: 'none'
  }, opts);
  var formatter = parserForArrayFormat(opts); // Create an object with no prototype
  // https://github.com/sindresorhus/query-string/issues/47

  var ret = Object.create(null);

  if (typeof str !== 'string') {
    return ret;
  }

  str = str.trim().replace(/^(\?|#|&)/, '');

  if (!str) {
    return ret;
  }

  str.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('='); // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37

    var key = parts.shift();
    var val = parts.length > 0 ? parts.join('=') : undefined; // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters

    val = val === undefined ? null : decodeURIComponent(val);
    formatter(decodeURIComponent(key), val, ret);
  });
  return Object.keys(ret).sort().reduce(function (result, key) {
    var val = ret[key];

    if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
      // Sort object keys, not values
      result[key] = keysSorter(val);
    } else {
      result[key] = val;
    }

    return result;
  }, Object.create(null));
};

var stringify = function stringify(obj, opts) {
  var defaults = {
    encode: true,
    strict: true,
    arrayFormat: 'none'
  };
  opts = objectAssign(defaults, opts);
  var formatter = encoderForArrayFormat(opts);
  return obj ? Object.keys(obj).sort().map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return '';
    }

    if (val === null) {
      return encode(key, opts);
    }

    if (Array.isArray(val)) {
      var result = [];
      val.slice().forEach(function (val2) {
        if (val2 === undefined) {
          return;
        }

        result.push(formatter(key, val2, result.length));
      });
      return result.join('&');
    }

    return encode(key, opts) + '=' + encode(val, opts);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : '';
};

var queryString = {
  extract: extract,
  parse: parse,
  stringify: stringify
}; // - Passed in as a prop?
// - Set as external dependency?
// - Pass in the entire load and render function as a prop?
//import cornerstone from 'cornerstone-core';

/**
 * Asynchronous wrapper around Cornerstone's renderToCanvas method.
 *
 * @param {HTMLElement} canvasElement An HTML <canvas> element
 * @param {Image} image A Cornerstone Image
 *
 * @return {Promise} A promise tracking the progress of the rendering. Resolves empty.
 */
// function renderAsync(canvasElement, image) {
//   return new Promise((resolve, reject) => {
//     try {
//       cornerstone.renderToCanvas(canvasElement, image);
//       resolve();
//     } catch (error) {
//       reject(error);
//     }
//   });
// }

var requestImage = function requestImage(url, element) {
  var request = new XMLHttpRequest();
  request.responseType = 'blob';
  var type = window.store.getState().api.user.info.dcmType || queryString.parse(window.location.search).dcm4cheeType || 'dcm';
  if (type === 'dcm') url += '/rendered';
  request.open('get', url, true);
  var token = window.localStorage.getItem('access_token');
  request.setRequestHeader('Authorization', 'Bearer ' + token);
  request.setRequestHeader('Accept', 'image/jpeg');

  request.onreadystatechange = function (e) {
    if (request.readyState == XMLHttpRequest.DONE && request.status == 200) {
      var img = document.createElement('img');
      img.src = URL.createObjectURL(request.response);
      element.src = URL.createObjectURL(request.response);

      element.onload = function () {
        var viewerImgSize = {
          width: img.width,
          height: img.height
        };
        window.localStorage.setItem('viewerImgSize', JSON.stringify(viewerImgSize));
        URL.revokeObjectURL(element.src);
      };
    }
  };

  request.send(null);
};

var AuthImg =
/*#__PURE__*/
function (_HTMLImageElement) {
  inherits(AuthImg, _HTMLImageElement);

  function AuthImg() {
    var _this;

    classCallCheck(this, AuthImg);
    _this = possibleConstructorReturn(this, getPrototypeOf(AuthImg).call(this));
    _this._lastUrl = '';
    return _this;
  }

  createClass(AuthImg, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var url = this.getAttribute('authSrc');

      if (url !== this._lastUrl) {
        this._lastUrl = url;
        requestImage(url, this);
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['authSrc'];
    }
  }]);
  return AuthImg;
}(wrapNativeSuper(HTMLImageElement));

window.customElements.define('auth-img', AuthImg, {
  extends: 'img'
});

var ImageThumbnail =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ImageThumbnail, _PureComponent);

  function ImageThumbnail(props) {
    var _this2;

    classCallCheck(this, ImageThumbnail);
    _this2 = possibleConstructorReturn(this, getPrototypeOf(ImageThumbnail).call(this, props));
    _this2.canvas = React__default.createRef();
    var renderIntoCanvas = _this2.props.imageId && !_this2.props.imageSrc;
    _this2.state = {
      loading: renderIntoCanvas
    };
    return _this2;
  }

  createClass(ImageThumbnail, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          stackPercentComplete = _this$props.stackPercentComplete,
          thumbIndex = _this$props.thumbIndex;

      if (stackPercentComplete !== prevProps.stackPercentComplete && stackPercentComplete === 100 && this.props.onLoaded) {
        this.props.onLoaded(thumbIndex);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // const renderIntoCanvas = this.props.imageId && !this.props.imageSrc;
      this.setState({
        loading: false
      }); // if (renderIntoCanvas) {
      //   const { imageId } = this.props;
      //   const canvas = this.canvas.current;
      //   cornerstone.loadAndCacheImage(imageId).then(
      //     image => {
      //       renderAsync(canvas, image).then(
      //         () => {
      //           this.setState({
      //             loading: false,
      //           });
      //         },
      //         error => {
      //           // TODO: Set state?
      //           throw new Error(error);
      //         }
      //       );
      //     },
      //     error => {
      //       // TODO: Set state?
      //       throw new Error(error);
      //     }
      //   );
      // }
    }
  }, {
    key: "render",
    value: function render() {
      var loadingOrError;

      if (this.props.error) {
        loadingOrError = React__default.createElement(ViewportErrorIndicator, null);
      } else if (this.state.loading) {
        loadingOrError = React__default.createElement(ViewportLoadingIndicator, null);
      }

      var showStackLoadingProgressBar = this.props.stackPercentComplete !== undefined; // const renderIntoCanvas = this.props.imageId && !this.props.imageSrc;

      var imageId = this.props.imageId.split('wadors:')[1] || '';
      var _this$props2 = this.props,
          activeIndex = _this$props2.activeIndex,
          thumbIndex = _this$props2.thumbIndex;
      return React__default.createElement("div", {
        className: "ImageThumbnail ".concat(activeIndex === thumbIndex ? 'active' : '')
      }, React__default.createElement("div", {
        className: "image-thumbnail-canvas"
      }, React__default.createElement("img", {
        className: "static-image",
        is: "auth-img",
        authsrc: imageId //width={this.props.width}
        ,
        height: this.props.height,
        alt: ''
      })), loadingOrError, showStackLoadingProgressBar && React__default.createElement("div", {
        className: "image-thumbnail-progress-bar"
      }, React__default.createElement("div", {
        className: "image-thumbnail-progress-bar-inner",
        style: {
          width: "".concat(this.props.stackPercentComplete, "%")
        }
      })));
    }
  }]);
  return ImageThumbnail;
}(PureComponent);

defineProperty(ImageThumbnail, "propTypes", {
  imageSrc: propTypes.string,
  imageId: propTypes.string,
  error: propTypes.bool.isRequired,
  width: propTypes.number.isRequired,
  height: propTypes.number.isRequired,
  stackPercentComplete: propTypes.number.isRequired,
  //for ct
  thumbIndex: propTypes.number,
  onLoaded: propTypes.func,
  activeIndex: propTypes.number
});
defineProperty(ImageThumbnail, "defaultProps", {
  error: false,
  stackPercentComplete: 0,
  width: 217,
  height: 123,
  //for ct
  activeIndex: 0
});
var css$2 = "* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n:root {\n  --series-count-background-color: #678696;\n}\n.ThumbnailEntry {\n  cursor: pointer;\n  display: table;\n}\n.ThumbnailEntry .alt-image-text {\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n  background-color: var(--primary-background-color);\n  box-shadow: inset 0 0 0 1px var(--ui-border-color-dark);\n  border: 5px solid transparent;\n  border-radius: 12px;\n  height: 135px;\n  margin: 0 auto;\n  padding: 5px;\n  position: relative;\n  -webkit-transition: var(--sidebar-transition);\n  transition: var(--sidebar-transition);\n  width: 217px;\n  display: -webkit-box;\n  display: flex;\n}\n.ThumbnailEntry .alt-image-text h1 {\n  text-align: center;\n  color: var(--text-primary-color);\n}\n.ThumbnailEntry .series-details {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n  color: var(--text-primary-color);\n  font-size: 14px;\n  line-height: 1.3em;\n  margin-top: 5px;\n  margin-left: 1rem;\n  margin-right: 0.5rem;\n  max-width: 217px;\n  min-height: 36px;\n  position: relative;\n  word-wrap: break-word;\n}\n.ThumbnailEntry .series-details .series-description {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.ThumbnailEntry .series-details.info-only .series-description {\n  display: none;\n}\n.ThumbnailEntry .series-details.info-only .series-information {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n  float: none;\n  max-width: none;\n  padding-right: 0;\n}\n.ThumbnailEntry .series-details.info-only .series-information .item {\n  -webkit-box-flex: 1;\n          flex: 1;\n  text-align: center;\n}\n.ThumbnailEntry .series-details.info-only .series-information .item .icon,\n.ThumbnailEntry .series-details.info-only .series-information .item .value {\n  display: inline;\n  float: none;\n  line-height: 25px;\n}\n.ThumbnailEntry .series-details.info-only .series-information .item .value {\n  margin-left: 0;\n  width: auto;\n}\n.ThumbnailEntry .series-information {\n  padding-right: 4px;\n  max-width: 50px;\n}\n.ThumbnailEntry .series-information .item-frames .icon {\n  height: 18px;\n}\n.ThumbnailEntry .series-information .value {\n  color: var(--text-secondary-color);\n  display: inline-block;\n  float: right;\n  font-size: 12px;\n  margin-left: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: calc(100% - 15px);\n}\n.ThumbnailEntry .series-information .icon {\n  color: var(--active-color);\n  display: inline-block;\n  float: left;\n  font-size: 10px;\n  font-weight: 900;\n  text-align: right;\n  width: 11px;\n}\n.ThumbnailEntry .series-information .icon div {\n  background-color: var(--series-count-background-color);\n  margin-top: 6px;\n  position: relative;\n}\n.ThumbnailEntry .series-information .icon div:after {\n  background-color: var(--active-color);\n  box-shadow: 1px 1px rgba(0,0,0,0.115);\n  left: -4px;\n  position: absolute;\n  top: -4px;\n}\n.ThumbnailEntry .series-information .icon div,\n.ThumbnailEntry .series-information .icon div:after {\n  border: 0px solid var(--series-count-background-color);\n  content: '';\n  display: inline-block;\n  height: 11px;\n  width: 11px;\n}\n.image-thumbnail-clone {\n  z-index: 100000;\n  pointer-events: none;\n}\n.image-thumbnail-clone:hover {\n  border-color: var(--hover-color);\n  box-shadow: none;\n}\n.image-series-nums {\n  background: var(--active-color);\n  color: #fff;\n  text-align: center;\n  line-height: 25px;\n  font-size: 14px;\n  border-radius: 12px 12px 0 0;\n}\n.image-series-nums +.ImageThumbnail.active {\n  border-radius: 0 0 12px 12px;\n}\n";
styleInject(css$2);
var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});

var ThumbnailEntry =
/*#__PURE__*/
function (_Component) {
  inherits(ThumbnailEntry, _Component);

  function ThumbnailEntry() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, ThumbnailEntry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(ThumbnailEntry)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "onClick", function () {
      if (_this.props.onClick) {
        _this.props.onClick();
      }
    });
    defineProperty(assertThisInitialized(_this), "onDoubleClick", function () {
      if (_this.props.onDoubleClick) {
        _this.props.onDoubleClick();
      }
    });
    return _this;
  }

  createClass(ThumbnailEntry, [{
    key: "render",
    value: function render() {
      // const hasInstanceNumber = this.props.instanceNumber !== undefined;
      var className = classnames('ThumbnailEntry noselect', {
        active: this.props.active,
        disabled: !this.props.finished
      });
      var contents = null;

      if (this.props.imageSrc || this.props.imageId) {
        contents = React__default.createElement("div", {
          className: "p-x-1"
        }, this.props.isCT && React__default.createElement("div", {
          className: "image-series-nums"
        }, "\u5E8F\u5217", this.props.thumbIndex + 1, ":\u5171", this.props.numImageFrames, "\u5F20"), React__default.createElement(ImageThumbnail, {
          imageSrc: this.props.imageSrc,
          imageId: this.props.imageId,
          error: this.props.error,
          stackPercentComplete: this.props.stackPercentComplete //for ct
          ,
          onLoaded: this.props.onLoaded,
          thumbIndex: this.props.thumbIndex,
          activeIndex: this.props.activeIndex
        }));
      } else if (this.props.altImageText) {
        contents = React__default.createElement("div", {
          className: 'alt-image-text p-x-1'
        }, React__default.createElement("h1", null, this.props.altImageText));
      }

      return React__default.createElement("div", {
        className: className,
        onClick: this.onClick,
        onDoubleClick: this.onDoubleClick,
        onMouseDown: this.onMouseDown
      }, contents, this.props.isCT ? null : React__default.createElement("div", {
        className: 'series-details'
      }, React__default.createElement("div", {
        className: "series-description"
      }, this.props.seriesDescription)));
    }
  }]);
  return ThumbnailEntry;
}(Component);

defineProperty(ThumbnailEntry, "defaultProps", {
  active: false,
  error: false,
  stackPercentComplete: 0,
  activeIndex: 0
});
defineProperty(ThumbnailEntry, "propTypes", {
  id: propTypes.string.isRequired,
  imageSrc: propTypes.string,
  imageId: propTypes.string,
  error: propTypes.bool.isRequired,
  active: propTypes.bool.isRequired,
  stackPercentComplete: propTypes.number,

  /**
  altImageText will be used when no imageId or imageSrc is provided.
  It will be displayed inside the <div>. This is useful when it is difficult
  to make a preview for a type of DICOM series (e.g. DICOM-SR)
  */
  altImageText: propTypes.string,
  seriesDescription: propTypes.string,
  seriesNumber: propTypes.oneOfType([propTypes.string, propTypes.number]),
  instanceNumber: propTypes.oneOfType([propTypes.string, propTypes.number]),
  numImageFrames: propTypes.number,
  onDoubleClick: propTypes.func,
  onClick: propTypes.func,
  //
  onLoaded: propTypes.func,
  activeIndex: propTypes.number,
  finished: propTypes.bool,
  thumbIndex: propTypes.number,
  isCT: propTypes.bool
});
var css$3 = ".DragPreview .source-preview {\n  border-radius: 5px;\n  background-color: rgba(0,0,0,0.5);\n  position: fixed;\n  opacity: 0.5;\n  z-index: 9999;\n  left: 0;\n  top: 0;\n  -webkit-transition: none;\n  transition: none;\n  pointer-events: none;\n  -webkit-touch-callout: none;\n}\n";
styleInject(css$3);

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(source, true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var subscribedToOffsetChange = false;
var dragPreviewRef = null;

var collector = function collector(monitor) {
  if (!subscribedToOffsetChange) {
    monitor.subscribeToOffsetChange(onOffsetChange(monitor));
    subscribedToOffsetChange = true;
  }

  if (dragPreviewRef) {
    var offset = monitor.getSourceClientOffset() || monitor.getInitialSourceClientOffset();

    if (offset) {
      var transform = "translate(".concat(offset.x, "px, ").concat(offset.y, "px)");
      dragPreviewRef.style['transform'] = transform;
      dragPreviewRef.style['-webkit-transform'] = transform;
    }
  }

  var item = monitor.getItem();
  var newItem = {};

  if (item) {
    newItem = {
      active: item.active,
      altImageText: item.altImageText,
      id: item.id,
      imageSrc: item.imageSrc,
      imageId: item.imageId,
      instanceNumber: item.instanceNumber,
      error: item.error,
      numImageFrames: item.numImageFrames,
      seriesDescription: item.seriesDescription,
      seriesNumber: item.seriesNumber,
      stackPercentComplete: item.stackPercentComplete
    };
  }

  return _objectSpread({}, newItem, {
    isDragging: monitor.isDragging()
  });
};

var onOffsetChange = function onOffsetChange(monitor) {
  return function () {
    if (!dragPreviewRef) return;
    var offset = monitor.getSourceClientOffset() || monitor.getInitialSourceClientOffset();
    if (!offset) return;
    var transform = "translate(".concat(offset.x, "px, ").concat(offset.y, "px)");
    dragPreviewRef.style['transform'] = transform;
    dragPreviewRef.style['-webkit-transform'] = transform;
  };
};

var updateRef = function updateRef(ref) {
  dragPreviewRef = ref;
};

var DragPreview =
/*#__PURE__*/
function (_PureComponent) {
  inherits(DragPreview, _PureComponent);

  function DragPreview() {
    classCallCheck(this, DragPreview);
    return possibleConstructorReturn(this, getPrototypeOf(DragPreview).apply(this, arguments));
  }

  createClass(DragPreview, [{
    key: "render",
    value: function render() {
      var isDragging = this.props.isDragging;
      if (!isDragging) return null;
      return React__default.createElement("div", {
        className: "DragPreview"
      }, React__default.createElement("div", {
        className: "source-preview",
        ref: updateRef
      }, React__default.createElement(ThumbnailEntry, this.props)));
    }
  }]);
  return DragPreview;
}(PureComponent);

DragPreview.propTypes = {
  isDragging: propTypes.bool
};
var DragPreview$1 = DragLayer$$1(collector)(memo(DragPreview)); // if they have the same string type.

var Types$1 = {
  THUMBNAIL: 'thumbnail'
};
var thumbnailSource = {
  /*canDrag(props) {
    return props.error === false;
  },*/
  beginDrag: function beginDrag(props) {
    return props;
  },
  endDrag: function endDrag(props, monitor) {
    //const item = monitor.getItem();
    var dropResult = monitor.getDropResult();
  }
};

var ThumbnailEntryDragSource =
/*#__PURE__*/
function (_Component) {
  inherits(ThumbnailEntryDragSource, _Component);

  function ThumbnailEntryDragSource() {
    classCallCheck(this, ThumbnailEntryDragSource);
    return possibleConstructorReturn(this, getPrototypeOf(ThumbnailEntryDragSource).apply(this, arguments));
  }

  createClass(ThumbnailEntryDragSource, [{
    key: "render",
    value: function render() {
      var connectDragSource = this.props.connectDragSource;
      var dropEffect = 'copy';
      return connectDragSource(React__default.createElement("div", {
        className: "ThumbnailEntryContainer"
      }, React__default.createElement(DragPreview$1, this.props), React__default.createElement(ThumbnailEntry, this.props)), {
        dropEffect: dropEffect
      });
    }
  }]);
  return ThumbnailEntryDragSource;
}(Component);

defineProperty(ThumbnailEntryDragSource, "propTypes", {
  connectDragSource: propTypes.func.isRequired,
  isDragging: propTypes.bool.isRequired
});
defineProperty(ThumbnailEntryDragSource, "defaultProps", {
  isDragging: false
});

var collect$1 = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var ThumbnailEntryDragSource$1 = DragSource(Types$1.THUMBNAIL, thumbnailSource, collect$1)(ThumbnailEntryDragSource);
var css$4 = ".StudyBrowser {\n  float: left;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  background-color: #000;\n  padding-bottom: 20px;\n}\n.StudyBrowser .scrollable-study-thumbnails {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-bottom: 50px;\n  padding-right: 16px;\n  margin-right: -16px;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.StudyBrowser .scrollable-study-thumbnails::-webkit-scrollbar {\n  display: none;\n}\n.StudyBrowser .scrollable-study-thumbnails .title {\n  color: #fff;\n  background: #2d5874;\n  margin: 0;\n  line-height: 40px;\n  padding-left: 20px;\n  font-size: 18px;\n  cursor: pointer;\n}\n.StudyBrowser .scrollable-study-thumbnails .title:hover {\n  background: #36435b;\n}\n.StudyBrowser .scrollable-study-thumbnails .open {\n  height: auto;\n  overflow: hidden;\n}\n.StudyBrowser .scrollable-study-thumbnails .close {\n  height: 0;\n  overflow: hidden;\n}\n.StudyBrowser .scrollable-study-thumbnails .ThumbnailEntryContainer {\n  margin: 0 auto;\n  padding-bottom: 1.5rem;\n}\n.StudyBrowser .scrollable-study-thumbnails .ThumbnailEntryContainer .noselect {\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer */\n  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */\n  -webkit-user-select: none; /* Chrome, Safari, and Opera */\n  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/\n}\n.draggable {\n  cursor: copy;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n}\n.left-name {\n  background: var(--ui-gray-darker);\n  color: var(--text-secondary-color);\n  height: 63px;\n  line-height: 63px;\n  font-size: 22px;\n  padding-left: 10px;\n}\n";
styleInject(css$4);

var StudyBrowser =
/*#__PURE__*/
function (_Component) {
  inherits(StudyBrowser, _Component);

  function StudyBrowser() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, StudyBrowser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(StudyBrowser)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      opened: []
    });
    defineProperty(assertThisInitialized(_this), "onThumbnailClick", function (study, thumb, thumbIndex) {
      if (_this.props.onThumbnailClick) {
        _this.props.onThumbnailClick({
          studyInstanceUid: study.studyInstanceUid,
          displaySetInstanceUid: thumb.displaySetInstanceUid,
          thumbIndex: thumbIndex
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "onThumbnailDoubleClick", function (study, thumb) {// if (this.props.onThumbnailDoubleClick) {
      //   this.props.onThumbnailDoubleClick({
      //     studyInstanceUid: study.studyInstanceUid,
      //     displaysetInstanceUid: thumb.displaysetInstanceUid,
      //   });
      // }
    });
    defineProperty(assertThisInitialized(_this), "dealWithData", function (data) {
      var c = [];
      var d = {};
      data.forEach(function (element) {
        if (!d[element.date]) {
          c.push({
            date: element.date,
            allData: [element]
          });
          d[element.date] = element;
        } else {
          c.forEach(function (ele) {
            if (ele.date === element.date) {
              ele.allData.push(element);
            }
          });
        }
      });
      return c;
    });
    defineProperty(assertThisInitialized(_this), "getStudies", function (studies, history) {
      var activeView = _this.props.activeView;
      return studies.map(function (study, studyIndex) {
        return study.thumbnails.map(function (thumb, thumbIndex) {
          var imageId = thumb.imageId || [];
          var active = imageId.indexOf(activeView.sopInstanceUid) > -1;

          if (active) {
            window.localStorage.setItem('thumbIndex', thumbIndex);
          }

          if (_this.props.supportsDragAndDrop) {
            return React__default.createElement(ThumbnailEntryDragSource$1, _extends_1({
              key: "".concat(studyIndex, "_").concat(thumbIndex)
            }, study, thumb, {
              id: "".concat(studyIndex, "_").concat(thumbIndex),
              active: active,
              seriesDescription: history ? thumb.date.indexOf(' ') > -1 ? '本次' : '历史' : '',
              onClick: _this.onThumbnailClick.bind(assertThisInitialized(_this), study, thumb, thumbIndex),
              onDoubleClick: _this.onThumbnailDoubleClick.bind(assertThisInitialized(_this), study, thumb)
            }));
          } else {
            return React__default.createElement("div", {
              className: "ThumbnailEntryContainer"
            }, React__default.createElement(ThumbnailEntry, _extends_1({
              key: "".concat(studyIndex, "_").concat(thumbIndex)
            }, study, thumb, {
              active: active,
              id: "".concat(studyIndex, "_").concat(thumbIndex),
              seriesDescription: history ? thumb.date.indexOf(' ') > -1 ? '本次' : '历史' : '',
              onClick: _this.onThumbnailClick.bind(assertThisInitialized(_this), study, thumb, studyIndex),
              onDoubleClick: _this.onThumbnailDoubleClick.bind(assertThisInitialized(_this), study, thumb)
            })));
          }
        });
      });
    });
    defineProperty(assertThisInitialized(_this), "clickTitle", function (date) {
      var opened = _this.state.opened;
      var index = opened.indexOf(date);

      if (index > -1) {
        opened.splice(index, 1);
      } else {
        opened.push(date);
      }

      _this.setState({
        opened: opened
      });
    });
    return _this;
  }

  createClass(StudyBrowser, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var studies = this.props.studies;
      var opened = this.state.opened;
      var thumbnails = this.getStudies(studies);
      var newStudies = this.dealWithData(this.props.studies);
      var components = thumbnails.flat();
      var followupVisible = this.props.followupVisible;
      return React__default.createElement("div", {
        className: "StudyBrowser"
      }, React__default.createElement("div", {
        className: "left-name"
      }, React__default.createElement("span", null, followupVisible ? '随访模式' : '序列')), React__default.createElement("div", {
        className: "scrollable-study-thumbnails"
      }, followupVisible ? React__default.createElement(React__default.Fragment, null, newStudies.map(function (study, index) {
        return React__default.createElement("div", {
          key: index
        }, React__default.createElement("p", {
          className: "title",
          onClick: function onClick() {
            return _this2.clickTitle(study.date);
          }
        }, study.date), React__default.createElement("div", {
          className: opened.indexOf(study.date) > -1 ? 'open' : 'close'
        }, _this2.getStudies(study.allData, true).flat()));
      })) : components));
    }
  }]);
  return StudyBrowser;
}(Component);

defineProperty(StudyBrowser, "defaultProps", {
  studies: [],
  supportsDragAndDrop: true
});
defineProperty(StudyBrowser, "propTypes", {
  studies: propTypes.array.isRequired,
  supportsDragAndDrop: propTypes.bool.isRequired,
  onThumbnailClick: propTypes.func,
  onThumbnailDoubleClick: propTypes.func,
  activeView: propTypes.object,
  followupVisible: propTypes.bool
});

var CTStudyBrowser =
/*#__PURE__*/
function (_Component) {
  inherits(CTStudyBrowser, _Component);

  function CTStudyBrowser(props) {
    var _this;

    classCallCheck(this, CTStudyBrowser);
    _this = possibleConstructorReturn(this, getPrototypeOf(CTStudyBrowser).call(this, props));
    defineProperty(assertThisInitialized(_this), "resetActiveIndex", function (viewport) {
      var studies = _this.props.studies;
      var finished = _this.state.finished;
      studies.map(function (study) {
        (study.thumbnails || []).map(function (thumb, thumbIndex) {
          if (viewport.displaySetInstanceUid === thumb.displaySetInstanceUid && finished) {
            _this.setState({
              activeIndex: thumbIndex
            });
          }
        });
      });
    });
    defineProperty(assertThisInitialized(_this), "onThumbnailClick", function (study, thumb, thumbIndex) {
      _this.setState({
        activeIndex: thumbIndex
      });

      if (_this.props.onThumbnailClick) {
        _this.props.onThumbnailClick({
          studyInstanceUid: study.studyInstanceUid,
          displaySetInstanceUid: thumb.displaySetInstanceUid,
          thumbIndex: thumbIndex
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "onThumbnailDoubleClick", function (study, thumb) {// if (this.props.onThumbnailDoubleClick) {
      //   this.props.onThumbnailDoubleClick({
      //     studyInstanceUid: study.studyInstanceUid,
      //     displaysetInstanceUid: thumb.displaysetInstanceUid,
      //   });
      // }
    });
    defineProperty(assertThisInitialized(_this), "onThumbnailLoaded", function (index) {
      var studies = _this.props.studies;
      index = index + 1;
      studies.map(function (study) {
        (study.thumbnails || []).map(function (thumb, thumbIndex) {
          if (index === thumbIndex && _this.props.onThumbnailLoaded) _this.props.onThumbnailLoaded({
            studyInstanceUid: study.studyInstanceUid,
            displaySetInstanceUid: thumb.displaySetInstanceUid,
            thumbIndex: thumbIndex
          });
        });

        if (index === (study.thumbnails || []).length) {
          _this.onThumbnailClick(study, study.thumbnails[0], 0);

          if (_this.props.onLoadFinished) _this.props.onLoadFinished();

          _this.setState({
            finished: true
          });
        }
      });
    });
    _this.state = {
      activeIndex: 0,
      finished: false
    };
    return _this;
  }

  createClass(CTStudyBrowser, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.activeViewport !== this.props.activeViewport) {
        this.resetActiveIndex(this.props.activeViewport);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          activeIndex = _this$state.activeIndex,
          finished = _this$state.finished;
      var studies = this.props.studies;
      var thumbnails = studies.map(function (study, studyIndex) {
        return (study.thumbnails || []).map(function (thumb, thumbIndex) {
          return React__default.createElement("div", {
            className: "ThumbnailEntryContainer",
            key: "".concat(studyIndex, "_").concat(thumbIndex)
          }, React__default.createElement(ThumbnailEntry, _extends_1({
            key: "".concat(studyIndex, "_").concat(thumbIndex)
          }, study, thumb, {
            id: "".concat(studyIndex, "_").concat(thumbIndex),
            onClick: finished ? _this2.onThumbnailClick.bind(_this2, study, thumb, thumbIndex) : null,
            onDoubleClick: finished ? _this2.onThumbnailDoubleClick.bind(_this2, study, thumb) : null,
            onLoaded: _this2.onThumbnailLoaded,
            thumbIndex: thumbIndex,
            imageId: thumb.imageId,
            activeIndex: activeIndex,
            active: activeIndex === thumbIndex,
            finished: finished,
            isCT: true
          }))); // if (this.props.supportsDragAndDrop) {
          //   return (
          //     <ThumbnailEntryDragSource
          //       key={`${studyIndex}_${thumbIndex}`}
          //       {...study}
          //       {...thumb}
          //       id={`${studyIndex}_${thumbIndex}`}
          //       onClick={this.onThumbnailClick.bind(
          //         this,
          //         study,
          //         thumb,
          //         thumbIndex
          //       )}
          //       onDoubleClick={this.onThumbnailDoubleClick.bind(
          //         this,
          //         study,
          //         thumb
          //       )}
          //       thumbIndex={thumbIndex}
          //       imageId={thumb.imageId}
          //     />
          //   );
          // } else {
          // }
        });
      });
      var components = thumbnails.flat();
      return React__default.createElement("div", {
        className: "StudyBrowser"
      }, React__default.createElement("div", {
        className: "left-name"
      }, React__default.createElement("span", null, "\u68C0\u67E5\u5E8F\u5217")), React__default.createElement("div", {
        className: "scrollable-study-thumbnails"
      }, components));
    }
  }]);
  return CTStudyBrowser;
}(Component);

defineProperty(CTStudyBrowser, "defaultProps", {
  studies: [],
  supportsDragAndDrop: true,
  activeViewportIndex: 0
});
defineProperty(CTStudyBrowser, "propTypes", {
  studies: propTypes.array.isRequired,
  supportsDragAndDrop: propTypes.bool.isRequired,
  onThumbnailClick: propTypes.func,
  onThumbnailDoubleClick: propTypes.func,
  onThumbnailLoaded: propTypes.func,
  onLoadFinished: propTypes.func,
  activeViewport: propTypes.object
});
var css$5 = ".btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.btn.disabled,\n.btn[disabled],\nfieldset[disabled] .btn {\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.65;\n}\nbutton.close {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.layoutChooser-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  font-size: 14px;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0,0,0,0.15);\n  border-radius: 4px;\n  box-shadow: 0 6px 12px rgba(0,0,0,0.175);\n}\n.layoutChooser {\n  border: 1px solid rgba(77,99,110,0.81);\n  border-radius: 8px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 5000;\n}\n.layoutChooser .selectedBefore {\n  background-color: #5cc3eb;\n}\n.layoutChooser table {\n  margin: 0 auto;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.layoutChooser table td {\n  cursor: pointer;\n}\n.layoutChooser table td:hover,\n.layoutChooser table td.hover {\n  background-color: #209ac9;\n}\n";
styleInject(css$5);
/**
 * Adds the 'hover' class to cells above and to the left of the current cell
 * This is used to "fill in" the grid that the user will change the layout to,
 * if they click on a specific table cell.
 **/

var LayoutChooser =
/*#__PURE__*/
function (_PureComponent) {
  inherits(LayoutChooser, _PureComponent);

  function LayoutChooser(props) {
    var _this;

    classCallCheck(this, LayoutChooser);
    _this = possibleConstructorReturn(this, getPrototypeOf(LayoutChooser).call(this, props));
    defineProperty(assertThisInitialized(_this), "isRange", function (cell, parentCell) {
      return cell.row <= parentCell.row && cell.col <= parentCell.col;
    });
    defineProperty(assertThisInitialized(_this), "highlightCells", function (currentCell) {
      var table = [];

      for (var row = 0; row < _this.props.rows; row++) {
        var newRow = [];

        for (var col = 0; col < _this.props.columns; col++) {
          var cell = {
            row: row,
            col: col
          };

          if (_this.isRange(cell, currentCell)) {
            cell.className = 'hover';
          } else if (_this.isRange(currentCell, _this.emptyCell) && _this.isRange(cell, _this.state.selectedCell)) {
            cell.className = 'selectedBefore';
          }

          newRow.push(cell);
        }

        table.push(newRow);
      }

      _this.setState({
        table: table
      });
    });
    _this.emptyCell = {
      row: -1,
      column: -1
    };
    _this.state = {
      table: [[]],
      selectedCell: _this.props.selectedCell
    };
    return _this;
  }

  createClass(LayoutChooser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.highlightCells(this.emptyCell);
    }
  }, {
    key: "onClick",
    value: function onClick(currentCell) {
      this.setState({
        selectedCell: currentCell
      });
      this.highlightCells(currentCell);

      if (this.props.onClick) {
        this.props.onClick(currentCell);
      }

      if (this.props.onChange) {
        this.props.onChange(currentCell);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var columns = this.props.columns;
      var style = {
        display: this.props.visible ? 'block' : 'none',
        minWidth: columns * this.props.boxSize + (columns + 5) * this.props.cellBorder
      };
      return React__default.createElement("div", {
        className: "layoutChooser layoutChooser-dropdown-menu",
        role: "menu",
        style: style
      }, React__default.createElement("table", null, React__default.createElement("tbody", null, this.state.table.map(function (row, i) {
        return React__default.createElement("tr", {
          key: i
        }, row.map(function (cell, j) {
          return React__default.createElement("td", {
            className: cell.className,
            style: {
              width: _this2.props.boxSize,
              height: _this2.props.boxSize,
              border: 'solid 1px black'
            },
            key: j,
            onMouseEnter: function onMouseEnter() {
              return _this2.highlightCells(cell);
            },
            onMouseLeave: function onMouseLeave() {
              return _this2.highlightCells(_this2.emptyCell);
            },
            onClick: function onClick() {
              return _this2.onClick(cell);
            }
          });
        }));
      }))));
    }
  }]);
  return LayoutChooser;
}(PureComponent);

defineProperty(LayoutChooser, "propTypes", {
  rows: propTypes.number.isRequired,
  columns: propTypes.number.isRequired,
  visible: propTypes.bool.isRequired,
  selectedCell: propTypes.object,
  boxSize: propTypes.number.isRequired,
  cellBorder: propTypes.number.isRequired,
  onClick: propTypes.func,
  onChange: propTypes.func
});
defineProperty(LayoutChooser, "defaultProps", {
  rows: 3,
  columns: 3,
  visible: true,
  boxSize: 20,
  cellBorder: 1,
  selectedCell: {
    row: -1,
    col: -1
  }
});
var css$6 = ".toolbar-button {\n  height: 48px;\n  color: var(--default-color);\n  float: left;\n  text-align: center;\n  padding: 0 10px;\n  cursor: pointer;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Chrome and Opera */\n}\n.toolbar-button .toolbar-button-label {\n  font-size: 12px;\n  font-weight: 500;\n}\n.toolbar-button .expand-caret {\n  width: 8px;\n  height: 8px;\n  -webkit-transform: translate(2px, 2px);\n          transform: translate(2px, 2px);\n}\n.toolbar-button svg {\n  height: 21px;\n  width: 21px;\n  margin: 2px;\n}\n.toolbar-button:hover {\n  color: var(--hover-color);\n}\n.toolbar-button.active,\n.toolbar-button:active {\n  color: var(--active-color);\n}\n.toolbar-button.disabled {\n  color: #999;\n}\n";
styleInject(css$6);

var adjust = function adjust(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Adjust"), React__default.createElement("path", {
    d: "M12 22.5v-17c-4.688 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5zM24 14c0 6.625-5.375 12-12 12S0 20.625 0 14 5.375 2 12 2s12 5.375 12 12z"
  }));
};

adjust.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}; // Icons

var angleDoubleDown = function angleDoubleDown(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Angle Double Down"), React__default.createElement("path", {
    d: "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
  }));
};

angleDoubleDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 350 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var angleDoubleUp = function angleDoubleUp(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Angle Double Up"), React__default.createElement("path", {
    d: "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
  }));
};

angleDoubleUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 350 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var angleLeft = function angleLeft(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Angle Left"), React__default.createElement("path", {
    d: "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
  }));
};

angleLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var arrows = function arrows(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Arrows"), React__default.createElement("path", {
    d: "M9 1v16M1 9h16M7 3l2-2 2 2M15 11l2-2-2-2M11 15l-2 2-2-2M3 7L1 9l2 2"
  }));
};

arrows.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  stroke: "currentColor",
  width: "1em",
  height: "1em",
  fill: "none",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var arrowsAltH = function arrowsAltH(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Arrows Alt H"), React__default.createElement("path", {
    d: "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
  }));
};

arrowsAltH.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var arrowsAltV = function arrowsAltV(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Arrows Alt V"), React__default.createElement("path", {
    d: "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
  }));
};

arrowsAltV.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var bars = function bars(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Bars"), React__default.createElement("path", {
    d: "M1664 1344v128q0 26-19 45t-45 19H192q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19H192q-26 0-45-19t-19-45V832q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19H192q-26 0-45-19t-19-45V320q0-26 19-45t45-19h1408q26 0 45 19t19 45z"
  }));
};

bars.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1792 1792",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var brain = function brain(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Brain"), React__default.createElement("path", {
    d: "M9.477 17.251A3.251 3.251 0 0 0 6.227 14c-.053 0-.1.013-.153.016"
  }), React__default.createElement("path", {
    d: "M9.139 4.388A2 2 0 1 0 6.5 2.5a2 2 0 0 0 .081.534C6.47 3.025 6.363 3 6.25 3a3.732 3.732 0 0 0-2.965 6.023 2.985 2.985 0 0 0 0 5.957A3.731 3.731 0 0 0 6.25 21c.113 0 .22-.023.331-.033a2 2 0 1 0 2.558-1.353"
  }), React__default.createElement("path", {
    d: "M6.074 9.986c.052 0 .1.015.153.015a3.251 3.251 0 0 0 3.25-3.25M14.523 17.251A3.251 3.251 0 0 1 17.773 14c.053 0 .1.013.153.016"
  }), React__default.createElement("path", {
    d: "M14.861 4.388A2 2 0 1 1 17.5 2.5a2 2 0 0 1-.081.534c.111-.01.218-.034.331-.034a3.732 3.732 0 0 1 2.965 6.022 2.985 2.985 0 0 1 0 5.957A3.731 3.731 0 0 1 17.75 21c-.113 0-.22-.023-.331-.033a2 2 0 1 1-2.558-1.353"
  }), React__default.createElement("path", {
    d: "M17.926 9.986c-.052 0-.1.015-.153.015a3.251 3.251 0 0 1-3.25-3.25M10.5 2.4a3 3 0 0 1 3 0M10.409 22.1c.993.536 2.19.536 3.183 0M12 7.001v10.5"
  }));
};

brain.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  strokeWidth: "1.25",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var caretDown = function caretDown(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Caret Down"), React__default.createElement("path", {
    d: "M286.935 69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952 0-9.233 1.807-12.85 5.424C1.807 72.998 0 77.279 0 82.228c0 4.948 1.807 9.229 5.424 12.847l127.907 127.907c3.621 3.617 7.902 5.428 12.85 5.428s9.233-1.811 12.847-5.428L286.935 95.074c3.613-3.617 5.427-7.898 5.427-12.847 0-4.948-1.814-9.229-5.427-12.85z"
  }));
};

caretDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 292.362 292.362",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var caretUp = function caretUp(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Caret Up"), React__default.createElement("path", {
    d: "M44.68 29.383L26.728 11.52a5.377 5.377 0 0 0-7.585 0L1.19 29.383C.03 30.538-.319 32.09.306 33.605c.624 1.512 2.099 2.311 3.735 2.311h37.786c1.638 0 3.112-.799 3.736-2.312.626-1.514.277-3.065-.883-4.221z"
  }));
};

caretUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 45.871 45.871",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var check = function check(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Check"), React__default.createElement("path", {
    d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
  }));
};

check.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var checkCircle = function checkCircle(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Check Circle"), React__default.createElement("path", {
    d: "M13.5 0a13.5 13.5 0 0 1 0 27 13.5 13.5 0 0 1 0-27M23 8l-2-2-10 10-5-5-2 2 7 7z"
  }));
};

checkCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 27",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var checkCircleO = function checkCircleO(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Check Circle"), React__default.createElement("path", {
    d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
  }));
};

checkCircleO.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var chevronDown = function chevronDown(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Chevron Down"), React__default.createElement("path", {
    d: "M12 1.4L10.6 0 6 4.6 1.4 0 0 1.4l6 6z"
  }));
};

chevronDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 9",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var circle = function circle(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Circle"), React__default.createElement("path", {
    d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
  }));
};

circle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var circleNotch = function circleNotch(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Circle Notch"), React__default.createElement("path", {
    d: "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
  }));
};

circleNotch.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var circleO = function circleO(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Circle Outline"), React__default.createElement("path", {
    d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
  }));
};

circleO.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var cog = function cog(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Cog"), React__default.createElement("path", {
    d: "M12.85 8.25c0-.22.08-.45.08-.75s0-.52-.08-.75l1.58-1.27c.15-.15.15-.3.07-.45L13 2.4c-.07-.07-.22-.15-.45-.07l-1.87.75c-.38-.3-.83-.53-1.28-.75L9.1.38C9.18.15 8.95 0 8.8 0h-3c-.15 0-.37.15-.37.3l-.3 2.03c-.45.15-.83.45-1.28.75l-1.8-.75c-.22-.08-.37 0-.52.15L.03 5.1c-.08.08 0 .3.15.45l1.57 1.2c0 .23-.07.45-.07.75s0 .53.07.75L.18 9.53c-.15.15-.15.29-.08.45l1.5 2.62c.08.08.23.15.45.08l1.88-.75c.37.3.82.52 1.27.75l.3 1.95c0 .15.15.3.38.3h3c.15 0 .37-.15.37-.3l.3-1.95c.45-.23.9-.45 1.28-.75l1.87.75c.15.07.38 0 .45-.15l1.5-2.63c.08-.15.08-.37-.07-.45l-1.73-1.2zM7.3 10.13c-1.42 0-2.62-1.2-2.62-2.63 0-1.42 1.2-2.62 2.62-2.62 1.43 0 2.63 1.2 2.63 2.62 0 1.43-1.2 2.63-2.63 2.63z"
  }));
};

cog.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var createComment = function createComment(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Create Comment"), React__default.createElement("path", {
    d: "M22.32 14H35c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H21l-4 4V20.39c2.45-1.42 4.36-3.68 5.32-6.39zM10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm5 11h-4v4H9v-4H5V9h4V5h2v4h4v2z"
  }));
};

createComment.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 34",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var createScreenCapture = function createScreenCapture(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Create Screen Capture"), React__default.createElement("path", {
    d: "M27 30c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
  }), React__default.createElement("path", {
    d: "M24 17l-1.8 2H19c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V21c0-1.1-.9-2-2-2h-3.2L30 17h-6zm3 15c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zM10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm5 11h-4v4H9v-4H5V9h4V5h2v4h4v2z"
  }));
};

createScreenCapture.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 35",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var crosshairs = function crosshairs(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Crosshairs"), React__default.createElement("path", {
    d: "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
  }));
};

crosshairs.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var cube = function cube(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Cube"), React__default.createElement("path", {
    d: "M-115.1 280.3c0-.1.1-.1.1-.2v-.1-.3l.1-45c0-.5-.3-.9-.7-1.2L-154 211c-.1 0-.1 0-.2-.1-.4-.2-.8-.1-1.2.1l-38.8 22.1c-.4.2-.7.7-.7 1.2l-.3 44.6c0 .5.3.9.7 1.2l38.7 22.9c.2.1.5.2.7.2.2 0 .5-.1.7-.2l38.8-22.1c.1 0 .1-.1.2-.1s.1-.1.1-.1c0-.1.1-.1.1-.2.1-.1.1-.1.1-.2zm-45.6 16.6c1.5-1.5 3-3 4.5-4.6v2.4l-3 3-1.5-.8zm-3.2-1.9c2.5-2.6 5.1-5.1 7.6-7.7v2.4c-2 2.1-4.1 4.1-6.1 6.2l-1.5-.9zm-3.1-1.8c3.6-3.6 7.1-7.2 10.7-10.8v2.4c-2.6 2.6-5.2 5.2-7.7 7.8l-1.5 1.5-1.5-.9zm-3.1-1.9c4.6-4.7 9.2-9.3 13.8-14v2.4c-4.1 4.2-8.2 8.3-12.3 12.5l-1.5-.9zm-3.2-1.8c.1-.1.1-.1 0 0 5.7-5.7 11.3-11.4 17-17.1v2.4c-5.1 5.2-10.3 10.4-15.4 15.6l-1.6-.9zm-3.1-1.9c6.7-6.8 13.4-13.6 20.1-20.3v2.4c-6.1 6.2-12.3 12.4-18.4 18.6-.1.1-.1.1-.1.2l-1.6-.9zm-3.1-1.9c7.7-7.8 15.5-15.6 23.2-23.4v2.4c-7.2 7.3-14.4 14.5-21.5 21.8l-.1.1-1.6-.9zm-3.2-1.8c.1 0 .1-.1 0 0 8.7-8.9 17.4-17.6 26.1-26.4l.2.1v2.1l-24.7 25-.1.1-1.5-.9zm-3.1-1.8c.1-.1.1-.2.2-.2L-160 256l.3-.3 1.5.9-25.9 26.2s-.1.1-.1.2l-1.6-.9zm-3.1-1.9c0-.1.1-.1.1-.2l25.9-26.2 1.5.9-25.9 26.2-.2.2-1.4-.9zm-3.2-1.9l.2-.2c8.6-8.7 17.2-17.4 25.8-26.2l1.5.9-25.7 26-.4.4-1.4-.9zm37.4-64.5l35.8 20.9-36 20.5-35.8-20.9 36-20.5zm-36.5 23.4l1.5.9-2.5 2.5v-2.4c.4-.3.7-.6 1-1zm-1.1 16.2c3.5-3.5 7-7.1 10.5-10.6l1.5.9c-4 4.1-8 8.1-12.1 12.2l.1-2.5zm.1-2.6v-2.4c.9-.9 1.8-1.9 2.8-2.8 1.5-1.6 3.1-3.1 4.6-4.7l1.5.9c-3 3-6 6-8.9 9zm0-5.1v-2.4l4.2-4.2 1.5.9-5.7 5.7zm13.6-1.1l1.5.9c-5.1 5.1-10.1 10.3-15.2 15.4v-2.4c4.6-4.7 9.1-9.3 13.7-13.9zm-13.7 18.9c5.6-5.7 11.2-11.4 16.9-17.1l1.5.9c-6.1 6.2-12.3 12.4-18.4 18.6v-2.4zm-.1 5.1c6.7-6.8 13.4-13.5 20.1-20.3l1.5.9c-7.2 7.3-14.4 14.6-21.6 21.8v-2.4zm0 5l23.2-23.5 1.5.9-24.8 25.1.1-2.5zm36.2 23.7v2.3l-1.4-.8c.5-.6.9-1.1 1.4-1.5zm2.6-39.7l36-20.5-.1 41.8-35.8 20.4-.1-41.7z"
  }), React__default.createElement("path", {
    d: "M-154.9 232.7c.1 0 .1 0 0 0 .8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4.1.8.7 1.4 1.4 1.4zM-154.9 239.1c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4 0 .7.6 1.4 1.4 1.4zM-155 249.1c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4.7 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4zM-154.9 245.4c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4zM-154.8 219.9c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4 0 .8.7 1.4 1.4 1.4zM-154.8 226.3c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4zM-148.8 258.9c-.7-.4-1.5-.2-1.9.5-.4.7-.2 1.5.5 1.9.2.1.5.2.7.2.5 0 .9-.2 1.2-.7.4-.7.2-1.5-.5-1.9zM-121.1 275.3c-.7-.4-1.5-.2-1.9.5-.4.7-.2 1.5.5 1.9.2.1.5.2.7.2.5 0 .9-.2 1.2-.7.4-.7.1-1.5-.5-1.9zM-126.6 272c-.7-.4-1.5-.2-1.9.5-.4.7-.2 1.5.5 1.9.2.1.5.2.7.2.5 0 .9-.2 1.2-.7.3-.7.1-1.5-.5-1.9zM-143.2 262.2c-.7-.4-1.5-.2-1.9.5-.4.7-.2 1.5.5 1.9.2.1.5.2.7.2.5 0 .9-.2 1.2-.7.3-.7.1-1.5-.5-1.9zM-132.2 268.7c-.7-.4-1.5-.2-1.9.5-.4.7-.2 1.5.5 1.9.2.1.5.2.7.2.5 0 .9-.2 1.2-.7.4-.6.2-1.5-.5-1.9zM-137.7 265.5c-.7-.4-1.5-.2-1.9.5-.4.7-.2 1.5.5 1.9.2.1.5.2.7.2.5 0 .9-.2 1.2-.7.4-.7.1-1.6-.5-1.9z"
  }));
};

cube.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-205 207 100 100",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var d3Rotate = function d3Rotate(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "3D Rotate"), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.856 11.409l-.013-.335-.01-.195a6.21 6.21 0 0 1-.008-.14l-.004-.06-1.214.08v.004l.013.209.025.731.001.025-.001-.01.001.029v.021-.01.03-.009.03-.01l.001.035-.001-.01.001.04v-.01.045-.01.06-.009.06c0 .925-.066 1.891-.214 2.85.443-.125.877-.272 1.288-.444.097-.8.143-1.604.143-2.405l-.004-.381-.004-.211zm-12.47 5.265L2 15.691l.658-.711C1.817 14.19 1.2 13.182 1.2 12c.006-.916.35-1.691.912-2.399.83-1.011 2.014-1.758 3.339-2.293-.116.484-.212.973-.289 1.466a7.583 7.583 0 0 0-1.57 1.038c-.563.5-1.035 1.118-1.149 1.862-.076.5.027.975.259 1.417.197.374.478.711.782.995l.657-.711 1.245 3.299zM9.6 6.283c.84-.103 1.656-.148 2.4-.148 1.765 0 3.552.222 5.246.722 2.32.685 5.537 2.332 5.554 5.143-.006.915-.349 1.69-.911 2.398-2.151 2.622-6.685 3.467-9.889 3.467-.89 0-1.822-.054-2.697-.182l.165-1.205c.82.12 1.699.17 2.533.17 2.71 0 6.298-.621 8.408-2.46.644-.572 1.167-1.297 1.175-2.188-.013-1.455-1.41-2.516-2.574-3.134-2.086-1.093-4.677-1.515-7.01-1.515-.884 0-1.862.066-2.852.219.127-.442.277-.873.452-1.287zm5.624 12.551c.486-.076.975-.169 1.459-.283-.85 2.063-2.374 4.235-4.683 4.249-.916-.006-1.691-.349-2.399-.911C6.979 19.737 6.135 15.204 6.135 12c0-1.764.222-3.552.722-5.246C7.542 4.434 9.189 1.217 12 1.2c1.454 0 2.627.926 3.466 2.038l.778-.577.61 3.471-3.144-1.593.778-.577c-.581-.787-1.465-1.545-2.488-1.545-1.455.013-2.516 1.411-3.134 2.575C7.773 7.076 7.351 9.667 7.351 12c0 2.71.621 6.298 2.461 8.408.572.644 1.296 1.167 2.188 1.175 1.455-.013 2.516-1.41 3.134-2.574l.09-.175z"
  }));
};

d3Rotate.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 30",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var database = function database(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Database"), React__default.createElement("path", {
    d: "M12 12c4.703 0 9.422-.844 12-2.656V12c0 2.203-5.375 4-12 4S0 14.203 0 12V9.344C2.578 11.157 7.297 12 12 12zm0 12c4.703 0 9.422-.844 12-2.656V24c0 2.203-5.375 4-12 4S0 26.203 0 24v-2.656C2.578 23.157 7.297 24 12 24zm0-6c4.703 0 9.422-.844 12-2.656V18c0 2.203-5.375 4-12 4S0 20.203 0 18v-2.656C2.578 17.157 7.297 18 12 18zm0-18c6.625 0 12 1.797 12 4v2c0 2.203-5.375 4-12 4S0 8.203 0 6V4c0-2.203 5.375-4 12-4z"
  }));
};

database.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var dotCircle = function dotCircle(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Dot Circle"), React__default.createElement("path", {
    d: "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
  }));
};

dotCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var edit = function edit(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Edit"), React__default.createElement("path", {
    d: "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
  }));
};

edit.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var ellipseCircle = function ellipseCircle(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Ellipse Circle"), React__default.createElement("path", {
    d: "M9 0a9 9 0 0 1 0 18A9 9 0 0 1 9 0M4.5 8a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3M9 8a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3m4.5 0a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3"
  }));
};

ellipseCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var ellipseH = function ellipseH(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Ellipse Horizontal"), React__default.createElement("path", {
    d: "M6 11.5v3A1.5 1.5 0 0 1 4.5 16h-3A1.5 1.5 0 0 1 0 14.5v-3A1.5 1.5 0 0 1 1.5 10h3A1.5 1.5 0 0 1 6 11.5zm8 0v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 8 14.5v-3A1.5 1.5 0 0 1 9.5 10h3a1.5 1.5 0 0 1 1.5 1.5zm8 0v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5z"
  }));
};

ellipseH.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var ellipseV = function ellipseV(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Ellipse Vertical"), React__default.createElement("path", {
    d: "M6 19.5v3A1.5 1.5 0 0 1 4.5 24h-3A1.5 1.5 0 0 1 0 22.5v-3A1.5 1.5 0 0 1 1.5 18h3A1.5 1.5 0 0 1 6 19.5zm0-8v3A1.5 1.5 0 0 1 4.5 16h-3A1.5 1.5 0 0 1 0 14.5v-3A1.5 1.5 0 0 1 1.5 10h3A1.5 1.5 0 0 1 6 11.5zm0-8v3A1.5 1.5 0 0 1 4.5 8h-3A1.5 1.5 0 0 1 0 6.5v-3A1.5 1.5 0 0 1 1.5 2h3A1.5 1.5 0 0 1 6 3.5z"
  }));
};

ellipseV.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 6 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var exclamationCircle = function exclamationCircle(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Exclamation Circle"), React__default.createElement("path", {
    d: "M10 1a9 9 0 0 1 0 18 9 9 0 0 1 0-18m0 4v2m0 2v6"
  }));
};

exclamationCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  fill: "none",
  strokeWidth: "2"
};

var exclamationTriangle = function exclamationTriangle(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Exclamation Triangle"), React__default.createElement("path", {
    d: "M11 0l11 20H0zm1 7h-2v6h2zm0 8h-2v2h2z"
  }));
};

exclamationTriangle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 20",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var fastBackward = function fastBackward(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
  }));
};

fastBackward.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var fastForward = function fastForward(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
  }));
};

fastForward.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var info = function info(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Info"), React__default.createElement("path", {
    d: "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
  }));
};

info.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 192 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var inlineEdit = function inlineEdit(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Inline Edit"), React__default.createElement("path", {
    d: "M11 2L12.85.15a1 1 0 0 1 1 0l2 2a1 1 0 0 1 0 1L14 5zm-1 1L0 13v3h3L13 6zm6 13v-2H7l-2 2z"
  }));
};

inlineEdit.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var level = function level(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Level"), React__default.createElement("path", {
    d: "M14.5 3.5a1 1 0 0 1-11 11z",
    opacity: ".8",
    stroke: "none"
  }), React__default.createElement("circle", {
    cx: "9",
    cy: "9",
    r: "8",
    fill: "none",
    strokeWidth: "2"
  }));
};

level.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  stroke: "currentColor"
};

var link = function link(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Link"), React__default.createElement("path", {
    d: "M5.364 28.917a5.357 5.357 0 0 0 3.797 1.57 5.347 5.347 0 0 0 3.798-1.572l7.552-7.554a5.325 5.325 0 0 0 1.574-3.797 5.336 5.336 0 0 0-1.574-3.796l-2.297-2.298-2.009 2.009 2.297 2.298c.478.478.741 1.113.741 1.788 0 .674-.264 1.309-.741 1.786l-7.553 7.555a2.533 2.533 0 0 1-3.576 0l-2.297-2.298a2.53 2.53 0 0 1 0-3.576l3.775-3.776-2.009-2.009-3.776 3.776a5.378 5.378 0 0 0 0 7.595l2.299 2.3zM26.695 2.992"
  }), React__default.createElement("path", {
    d: "M26.695 2.992a5.328 5.328 0 0 0-3.797-1.575h-.002a5.34 5.34 0 0 0-3.798 1.573l-7.551 7.553a5.331 5.331 0 0 0-1.576 3.799c0 1.434.558 2.784 1.574 3.797l2.297 2.297 2.01-2.009-2.298-2.297a2.515 2.515 0 0 1-.741-1.788c0-.676.265-1.311.742-1.788l7.553-7.555a2.51 2.51 0 0 1 1.789-.74h.001c.674 0 1.309.264 1.786.74l2.297 2.299a2.51 2.51 0 0 1 .74 1.788 2.52 2.52 0 0 1-.74 1.788l-3.776 3.777 2.009 2.009 3.776-3.777a5.34 5.34 0 0 0 1.574-3.797c0-1.435-.56-2.784-1.574-3.797l-2.295-2.296z"
  }));
};

link.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var linkCircles = function linkCircles(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Link Circles"), React__default.createElement("g", {
    transform: "translate(1 1)"
  }, React__default.createElement("circle", {
    opacity: ".8",
    cx: "7.5",
    cy: "7.5",
    r: "7.5"
  }), React__default.createElement("circle", {
    opacity: ".6",
    cx: "15.5",
    cy: "7.5",
    r: "7.5"
  })));
};

linkCircles.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 15",
  stroke: "currentColor",
  width: "1em",
  height: "1em",
  fill: "none"
};

var list = function list(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "List"), React__default.createElement("path", {
    d: "M0 0h2v2H0zm4 0h14v2H4zM0 4h2v2H0zm4 0h14v2H4zM0 8h2v2H0zm4 0h14v2H4z"
  }));
};

list.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 10",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var liver = function liver(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Liver"), React__default.createElement("path", {
    d: "M15.188 1.427c.82-.385 1.764-.428 2.675-.427 2.433.003 4.933.267 7.366.268.403 0 .63.13.733.414.099.274.009.497-.306.739-1.45 1.113-2.074 2.596-2.097 4.343a5.524 5.524 0 0 1-3.862 5.188c-1.45.453-2.87.372-4.257-.24l-.094-.04c-.334.472-.626.956-.989 1.382-1.555 1.83-3.59 2.695-6.034 2.715-1.405.011-2.727.338-3.946 1.017-.86.478-1.612 1.078-2.207 1.852-.195.254-.45.331-.74.237-.284-.093-.417-.274-.417-.603-.001-3.31-.034-6.622.01-9.932.047-3.461 2.913-6.49 6.453-6.913 1.713-.205 4.21.303 5.65 1.545.24.206.643.617.943 1.073.242.368.567.852.683 1.057.116.205-1.692-2.182-1.625-2.13.53-.566 1.365-1.218 2.061-1.545z"
  }));
};

liver.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 20",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  strokeWidth: "1.65",
  fill: "none",
  fillRule: "evenodd"
};

var lock = function lock(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Lock"), React__default.createElement("path", {
    d: "M5 12h8V9c0-2.203-1.797-4-4-4S5 6.797 5 9v3zm13 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 0 22.5v-9A1.5 1.5 0 0 1 1.5 12H2V9c0-3.844 3.156-7 7-7s7 3.156 7 7v3h.5a1.5 1.5 0 0 1 1.5 1.5z"
  }));
};

lock.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var lockAlt = function lockAlt(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Lock"), React__default.createElement("path", {
    d: "M14 7h-1V5c0-2.8-2.2-5-5-5S3 2.2 3 5v2H2C.9 7 0 7.9 0 9v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-2.9 0H4.9V5c0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1v2z"
  }));
};

lockAlt.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 21",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var lung = function lung(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Lung"), React__default.createElement("path", {
    d: "M5.55 23.068h.668a4.55 4.55 0 0 0 4.55-4.55v-2.85c0-1.104-.353-2.18-1.007-3.07A5.185 5.185 0 0 1 8.755 9.53V6.944a1.54 1.54 0 0 0-.939-1.418c-1.558-.355-2.235.185-2.97 1.222-.65.916-1.726 2.902-3.23 5.957A6 6 0 0 0 1 15.354v3.164a4.55 4.55 0 0 0 4.55 4.55z"
  }), React__default.createElement("path", {
    d: "M11.465 0v7.633a2 2 0 0 1-.75 1.561L8.582 10.9M15.083 0v7.633a2 2 0 0 0 .75 1.561l2.132 1.705"
  }), React__default.createElement("path", {
    d: "M21.384 23.068h-.667a4.55 4.55 0 0 1-4.55-4.55v-2.85c0-1.104.352-2.18 1.006-3.07a5.185 5.185 0 0 0 1.006-3.069V6.944c0-.618.37-1.177.939-1.418 1.558-.355 2.235.185 2.97 1.222.65.916 1.726 2.902 3.23 5.957a6 6 0 0 1 .616 2.649v3.164a4.55 4.55 0 0 1-4.55 4.55z"
  }));
};

lung.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 24",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  strokeWidth: "1.5",
  fill: "none"
};

var measureNonTarget = function measureNonTarget(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Measure Non-Target"), React__default.createElement("circle", {
    cx: "6.5",
    cy: "6.5",
    r: "6"
  }), React__default.createElement("path", {
    d: "M6.5 3v7M3 6.5h7"
  }), React__default.createElement("path", {
    d: "M23 7L8 22m-1-5v6h6",
    strokeWidth: "2"
  }));
};

measureNonTarget.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var measureTarget = function measureTarget(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Measure Target"), React__default.createElement("path", {
    d: "M9.5 26l2-2-1.5-1.5.5-.5 1.5 1.5 1.5-1.5-2.5-2.5.5-.5 2.5 2.5 1.5-1.5-1.5-1.5.5-.5 1.5 1.5 1.5-1.5-2.5-2.5.5-.5 2.5 2.5 1.5-1.5-1.5-1.5.5-.5 1.5 1.5 1.5-1.5-2.5-2.5.5-.5 2.5 2.5 1.5-1.5-1.5-1.5.5-.5 1.5 1.5 2-2-4-4a2 2 0 0 0-2.5 0l-14 14a2 2 0 0 0 0 2.5l4 4zM6 0a6 6 0 0 1 0 12A6 6 0 0 1 6 0m.5 3a.5.5 0 0 0-1 0v2.5H3a.5.5 0 0 0 0 1h2.5V9a.5.5 0 0 0 1 0V6.5H9a.5.5 0 0 0 0-1H6.5z"
  }));
};

measureTarget.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  strokeWidth: "0"
};

var measureTargetCr = function measureTargetCr(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Measure Target CR"), React__default.createElement("text", {
    fill: "#000",
    y: "8",
    fontSize: "10"
  }, "CR"), React__default.createElement("path", {
    d: "M23 7L8 22m-1-5v6h6",
    strokeWidth: "2"
  }));
};

measureTargetCr.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var measureTargetNe = function measureTargetNe(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Measure Target NE"), React__default.createElement("text", {
    fill: "#000",
    y: "8",
    fontSize: "10",
    fontFamily: "sans-serif"
  }, "NE"), React__default.createElement("path", {
    d: "M23 7L8 22m-1-5v6h6",
    strokeWidth: "2"
  }));
};

measureTargetNe.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var measureTargetUn = function measureTargetUn(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Measure Target UN"), React__default.createElement("text", {
    fill: "#000",
    y: "8",
    fontSize: "10"
  }, "UN"), React__default.createElement("path", {
    d: "M23 7L8 22m-1-5v6h6",
    strokeWidth: "2"
  }));
};

measureTargetUn.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var measureTemp = function measureTemp(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Measure Temp"), React__default.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React__default.createElement("circle", {
    cx: "6.5",
    cy: "6.5",
    r: "6"
  }), React__default.createElement("path", {
    d: "M6.5 3v7M3 6.5h7"
  }), React__default.createElement("path", {
    d: "M22.5 6L6 22.5",
    strokeWidth: "3",
    strokeDasharray: "0.6666,5"
  })));
};

measureTemp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  fill: "none"
};

var objectGroup = function objectGroup(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Object Group"), React__default.createElement("path", {
    d: "M14.5 2.75h2a2.5 2.5 0 0 1 2.5 2.5V18.5a2.5 2.5 0 0 1-2.5 2.5H5a2.5 2.5 0 0 1-2.5-2.5v-1"
  }), React__default.createElement("path", {
    d: "M.5 2v14A1.5 1.5 0 0 0 2 17.5h12a1.5 1.5 0 0 0 1.5-1.5V2M2 2h12M4.4 7.5h7.2m0 3H4.4m0 3h7.2"
  }));
};

objectGroup.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 22",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var ohifLogo = function ohifLogo(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "OHIF Logo"), React__default.createElement("rect", {
    x: "1.25",
    y: "1.25",
    width: "18.8",
    height: "18.8",
    rx: "1",
    ry: "1"
  }), React__default.createElement("rect", {
    x: "26",
    y: "1.25",
    width: "18.8",
    height: "18.8",
    rx: "1",
    ry: "1"
  }), React__default.createElement("rect", {
    x: "1.25",
    y: "26",
    width: "18.8",
    height: "18.8",
    rx: "1",
    ry: "1"
  }), React__default.createElement("rect", {
    x: "26",
    y: "26",
    width: "18.8",
    height: "18.8",
    rx: "1",
    ry: "1"
  }));
};

ohifLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47 47",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  fill: "none",
  strokeWidth: "2.5"
};

var oval = function oval(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Oval"), React__default.createElement("path", {
    d: "M12 5.5c-4.688 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5zM24 14c0 6.625-5.375 12-12 12S0 20.625 0 14 5.375 2 12 2s12 5.375 12 12z"
  }));
};

oval.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var palette = function palette(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Pallete"), React__default.createElement("path", {
    d: "M17.484 12c.844 0 1.5-.656 1.5-1.5s-.656-1.5-1.5-1.5-1.5.656-1.5 1.5.656 1.5 1.5 1.5zm-3-3.984c.844 0 1.5-.656 1.5-1.5s-.656-1.5-1.5-1.5-1.5.656-1.5 1.5.656 1.5 1.5 1.5zm-4.968 0c.844 0 1.5-.656 1.5-1.5s-.656-1.5-1.5-1.5-1.5.656-1.5 1.5.656 1.5 1.5 1.5zm-3 3.984c.844 0 1.5-.656 1.5-1.5S7.36 9 6.516 9s-1.5.656-1.5 1.5.656 1.5 1.5 1.5zM12 3c4.969 0 9 3.609 9 8.016 0 2.766-2.25 4.969-5.016 4.969H14.25c-.844 0-1.5.656-1.5 1.5 0 .375.141.703.375.984s.375.656.375 1.031c0 .844-.656 1.5-1.5 1.5-4.969 0-9-4.031-9-9s4.031-9 9-9z"
  }));
};

palette.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var play = function play(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
  }));
};

play.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var plus = function plus(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Add"), React__default.createElement("path", {
    d: "M6.5 7v5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V7h-5C.22 7 0 6.78 0 6.5S.22 6 .5 6h5V1c0-.28.22-.5.5-.5s.5.22.5.5v5h5c.28 0 .5.22.5.5s-.22.5-.5.5h-5z"
  }));
};

plus.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 13",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var powerOff = function powerOff(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Power Off"), React__default.createElement("path", {
    d: "M24 14c0 6.609-5.391 12-12 12S0 20.609 0 14c0-3.797 1.75-7.297 4.797-9.578a1.979 1.979 0 0 1 2.797.391 1.995 1.995 0 0 1-.391 2.797C5.172 9.141 4 11.469 4 14.001c0 4.406 3.594 8 8 8s8-3.594 8-8c0-2.531-1.172-4.859-3.203-6.391a1.995 1.995 0 0 1-.391-2.797 1.981 1.981 0 0 1 2.797-.391A11.877 11.877 0 0 1 24 14zM14 2v10c0 1.094-.906 2-2 2s-2-.906-2-2V2c0-1.094.906-2 2-2s2 .906 2 2z"
  }));
};

powerOff.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var reset = function reset(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Reset"), React__default.createElement("path", {
    d: "M24 14c0 6.609-5.391 12-12 12a11.972 11.972 0 0 1-9.234-4.328.52.52 0 0 1 .031-.672l2.141-2.156a.599.599 0 0 1 .391-.141.51.51 0 0 1 .359.187A7.91 7.91 0 0 0 12 21.999c4.406 0 8-3.594 8-8s-3.594-8-8-8A7.952 7.952 0 0 0 6.563 8.14l2.141 2.156a.964.964 0 0 1 .219 1.078 1.002 1.002 0 0 1-.922.625h-7c-.547 0-1-.453-1-1v-7c0-.406.25-.766.625-.922a.964.964 0 0 1 1.078.219l2.031 2.016c2.203-2.078 5.187-3.313 8.266-3.313 6.609 0 12 5.391 12 12z"
  }));
};

reset.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var rotate = function rotate(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Rotate"), React__default.createElement("path", {
    d: "M24 4v7c0 .547-.453 1-1 1h-7c-.406 0-.766-.25-.922-.625a.964.964 0 0 1 .219-1.078l2.156-2.156A8.026 8.026 0 0 0 12 6c-4.406 0-8 3.594-8 8s3.594 8 8 8a7.91 7.91 0 0 0 6.312-3.109.508.508 0 0 1 .359-.187.6.6 0 0 1 .391.141l2.141 2.156c.187.172.187.469.031.672A11.972 11.972 0 0 1 12 26.001c-6.609 0-12-5.391-12-12s5.391-12 12-12c3.078 0 6.062 1.234 8.266 3.313l2.031-2.016a.984.984 0 0 1 1.094-.219c.359.156.609.516.609.922z"
  }));
};

rotate.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var rotateLeft = function rotateLeft(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M310.8 912.9c35.7 18.1 73.8 31.2 113 39.1l18.1-90.1c-31.2-6.2-61.3-16.6-89.6-31l-41.5 82zm-150-347.3l-91 13.3c3.3 22.4 8.3 44.7 15 66.3l87.8-27.1c-5.2-17.1-9.3-34.7-11.8-52.5zm-25.6 188.5c21.5 33.7 47.5 64.3 77.1 91.2l61.7-68.1c-23.6-21.3-44.3-45.7-61.3-72.5l-77.5 49.4zm579 51.8l52.3 75.5c32.9-22.7 62.6-49.8 88.3-80.4l-70.5-59.1c-20.3 24.3-43.9 45.8-70.1 64zm-202-739.4c-103.1 0-200.7 34.8-279.9 98.5L131.5 64.2 61.9 412.5l348.3-69.6L298 230.7c61.4-46.6 135.8-72.2 214.3-72.2 195.9 0 355.2 159.3 355.2 355.2 0 33-4.6 65.8-13.5 97.3-5 17.4-11.3 34.4-18.7 50.7l83.5 38.4c9.4-20.5 17.3-42 23.6-63.9 11.3-39.7 17-80.9 17-122.4-.1-246.7-200.7-447.3-447.2-447.3zM536.7 868l6.3 91.7c40-2.7 79.4-10.8 117.1-24L629.7 849c-33.1 12-71.4 19.2-111.3 19.8l18.3-.8z"
  }));
};

rotateLeft.defaultProps = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var rotateRight = function rotateRight(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Rotate Right"), React__default.createElement("path", {
    d: "M710.4 912.9l-41.5-82c-28.3 14.4-58.4 24.7-89.6 31l18.1 90.1c39.2-7.9 77.3-21.1 113-39.1zm150-347.3c-2.6 17.8-6.6 35.5-11.8 52.5l87.8 27.1c6.7-21.6 11.7-43.9 15-66.3l-91-13.3zM886 754.1l-77.5-49.5c-17.1 26.8-37.7 51.2-61.3 72.5l61.7 68.1c29.6-26.8 55.6-57.4 77.1-91.1zm-579 51.8c-26.2-18.2-49.8-39.7-70.2-64L166.3 801c25.8 30.6 55.4 57.7 88.3 80.4l52.4-75.5zM509 66.5c-246.5 0-447.1 200.6-447.1 447.1 0 41.6 5.7 82.7 17 122.4 6.3 21.9 14.2 43.4 23.6 63.9l83.5-38.4c-7.5-16.3-13.7-33.3-18.7-50.7-8.9-31.5-13.5-64.3-13.5-97.3 0-195.9 159.3-355.2 355.2-355.2 78.5 0 152.8 25.6 214.3 72.2L611 342.9l348.3 69.6-69.6-348.3L788.8 165C709.7 101.3 612.1 66.5 509 66.5zm-6.2 802.3c-39.9-.6-78.1-7.8-111.3-19.8l-30.4 86.7c37.7 13.2 77.1 21.3 117.1 24l6.3-91.7 18.3.8z"
  }));
};

rotateRight.defaultProps = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var search = function search(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Search"), React__default.createElement("path", {
    d: "M9.516 14.016c2.484 0 4.5-2.016 4.5-4.5s-2.016-4.5-4.5-4.5-4.5 2.016-4.5 4.5 2.016 4.5 4.5 4.5zm6 0l4.969 4.969-1.5 1.5-4.969-4.969v-.797l-.281-.281c-1.125.984-2.625 1.547-4.219 1.547C5.907 15.985 3 13.126 3 9.516S5.906 3 9.516 3s6.469 2.906 6.469 6.516c0 1.594-.563 3.094-1.547 4.219l.281.281h.797z"
  }));
};

search.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var searchPlus = function searchPlus(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Search Plus"), React__default.createElement("g", {
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, React__default.createElement("path", {
    d: "M11.5 11.5L16 16"
  }), React__default.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "6"
  })));
};

searchPlus.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17",
  width: "1em",
  height: "1em",
  stroke: "currentColor"
};

var softTissue = function softTissue(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Soft Tissue"), React__default.createElement("path", {
    d: "M14.968 4.345c.287.06.474.11.524.13l3.5 1.4a3 3 0 0 1 1.824 2.16l2.108 4.816a.5.5 0 0 1-.489.605H19.83a.5.5 0 0 1-.487-.386c-.922-1.726-1.395-2.634-1.417-2.725-.033-.137-1.326-.08-1.466-.064a.279.279 0 0 0-.247.275l.788 9.812a.504.504 0 0 1-.005.073l.343 3.766a.51.51 0 0 1-.51.533h-2.873a.51.51 0 0 1-.51-.465l-.599-3.407h-2.702L9.49 24.28a.51.51 0 0 1-.51.464H6.11a.51.51 0 0 1-.51-.532l.549-8.384.17-5.208a.279.279 0 0 0-.246-.275c-.14-.016-1.218-.049-1.252.088L3.8 13.071a.5.5 0 0 1-.49.385H.71a.5.5 0 0 1-.49-.605l1.966-4.813c.21-.98.895-1.79 1.827-2.16l3.5-1.4c.051-.02.235-.068.52-.126L8.618.988c.941.408 1.845.612 2.711.612.867 0 1.694-.204 2.48-.612l1.159 3.357z"
  }));
};

softTissue.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 26",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  strokeWidth: "1.5",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var sort = function sort(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Sort"), React__default.createElement("path", {
    d: "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
  }));
};

sort.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var sortDown = function sortDown(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Sort Down"), React__default.createElement("path", {
    d: "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
  }));
};

sortDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var sortUp = function sortUp(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Sort Up"), React__default.createElement("path", {
    d: "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
  }));
};

sortUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var squareO = function squareO(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Square Outline"), React__default.createElement("path", {
    d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
  }));
};

squareO.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var star = function star(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Star"), React__default.createElement("path", {
    d: "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
  }));
};

star.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var stepBackward = function stepBackward(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
  }));
};

stepBackward.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var stepForward = function stepForward(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
  }));
};

stepForward.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var stop = function stop(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Stop"), React__default.createElement("path", {
    d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
  }));
};

stop.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var sun = function sun(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Sun"), React__default.createElement("path", {
    d: "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
  }));
};

sun.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var th = function th(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "TH"), React__default.createElement("path", {
    d: "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
  }));
};

th.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var thLarge = function thLarge(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "TH Large"), React__default.createElement("path", {
    d: "M0 0h7v6H0zm8 0h7v6H8zM0 7h7v6H0zm8 0h7v6H8z"
  }));
};

thLarge.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 13",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var thList = function thList(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "TH List"), React__default.createElement("path", {
    d: "M9 5.016h12V9H9V5.016zm0 13.968V15h12v3.984H9zm0-4.968V9.985h12v4.031H9zM3.984 9V5.016h4.031V9H3.984zm0 9.984V15h4.031v3.984H3.984zm0-4.968V9.985h4.031v4.031H3.984z"
  }));
};

thList.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var times = function times(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Times"), React__default.createElement("path", {
    d: "M1 1l12 12M1 13L13 1"
  }));
};

times.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  width: "1em",
  height: "1em",
  stroke: "currentColor",
  strokeWidth: "1.75"
};

var trash = function trash(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "Trash"), React__default.createElement("path", {
    d: "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
  }));
};

trash.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var user = function user(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "User"), React__default.createElement("path", {
    d: "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
  }));
};

user.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var youtube = function youtube(props) {
  return React__default.createElement("svg", props, React__default.createElement("title", null, "YouTube Logo"), React__default.createElement("path", {
    d: "M11.109 17.625l7.562-3.906-7.562-3.953v7.859zM14 4.156c5.891 0 9.797.281 9.797.281.547.063 1.75.063 2.812 1.188 0 0 .859.844 1.109 2.781.297 2.266.281 4.531.281 4.531v2.125s.016 2.266-.281 4.531c-.25 1.922-1.109 2.781-1.109 2.781-1.062 1.109-2.266 1.109-2.812 1.172 0 0-3.906.297-9.797.297-7.281-.063-9.516-.281-9.516-.281-.625-.109-2.031-.078-3.094-1.188 0 0-.859-.859-1.109-2.781C-.016 17.327 0 15.062 0 15.062v-2.125s-.016-2.266.281-4.531C.531 6.469 1.39 5.625 1.39 5.625 2.452 4.5 3.656 4.5 4.202 4.437c0 0 3.906-.281 9.797-.281z"
  }));
};

youtube.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var tuberculosis = function tuberculosis(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M997.669 533.943C975.726 466.65 871.863 261.85 810.423 201.874c-43.886-42.423-81.92-62.903-115.566-62.903-24.868 0-61.44 11.703-83.383 67.292-11.703 29.257-14.628 57.051-14.628 59.977 0 1.463-2.926 30.72-7.315 73.143-5.851-5.852-10.24-11.703-14.628-16.092L595.383 4.39 552.96 1.463l-21.943 334.994H501.76L481.28 4.39l-42.423 2.925 20.48 318.903c-4.388 4.389-10.24 11.703-19.017 20.48-4.389-46.811-7.314-76.068-8.777-78.994 0-2.926-2.926-32.183-14.629-59.977-21.943-55.589-57.051-67.292-83.383-67.292-33.645 0-71.68 20.48-115.565 62.903-58.515 58.514-163.84 263.314-185.783 330.606C8.777 604.16-5.851 816.274 19.017 902.583c8.777 38.034 27.794 117.028 95.086 117.028 19.017 0 40.96-7.314 64.366-21.942 17.554-5.852 65.828-10.24 92.16-10.24h1.462c43.886 0 125.806-8.778 175.543-62.903 30.72-33.646 43.886-78.995 38.035-134.583-4.389-57.052-16.092-175.543-26.332-282.332 0 0 45.349-29.257 58.514-29.257 11.703 0 57.052 29.257 57.052 29.257-10.24 108.252-21.943 225.28-27.794 282.332-5.852 55.588 7.314 100.937 38.034 134.583 49.737 54.125 131.657 62.903 175.543 62.903h1.463c24.868 0 74.605 5.851 92.16 10.24 23.405 14.628 45.348 21.942 64.365 21.942 67.292 0 86.309-77.531 95.086-117.028 21.943-84.846 7.314-296.96-16.091-368.64zM753.37 770.926c-13.165 19.017-16.091 35.108-35.108 21.943s-21.943-39.498-8.777-57.052c13.165-19.017 39.497-21.943 57.051-8.777 19.017 13.166 0 24.869-13.166 43.886zM854.31 898.194c-36.572 0-65.829 0-65.829-36.571s29.257-65.829 65.829-65.829 65.828 29.257 65.828 65.829c-1.463 36.571-30.72 36.571-65.828 36.571zM820.663 727.04c8.777-13.166 27.794-16.091 40.96-7.314 13.166 8.777 16.091 27.794 7.314 40.96-8.777 13.165-21.943 2.925-35.108-5.852-14.629-8.777-23.406-14.628-13.166-27.794z",
    fill: "#d81e06"
  }));
};

tuberculosis.defaultProps = {
  className: "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
};

var pneumonia = function pneumonia(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M997.669 533.943C975.726 466.65 871.863 261.85 810.423 201.874c-43.886-42.423-81.92-62.903-115.566-62.903-24.868 0-61.44 11.703-83.383 67.292-11.703 29.257-14.628 57.051-14.628 59.977 0 1.463-2.926 30.72-7.315 73.143-5.851-5.852-10.24-11.703-14.628-16.092L595.383 4.39 552.96 1.463l-21.943 334.994H501.76L481.28 4.39l-42.423 2.925 20.48 318.903c-4.388 4.389-10.24 11.703-19.017 20.48-4.389-46.811-7.314-76.068-8.777-78.994 0-2.926-2.926-32.183-14.629-59.977-21.943-55.589-57.051-67.292-83.383-67.292-33.645 0-71.68 20.48-115.565 62.903-58.515 58.514-163.84 263.314-185.783 330.606C8.777 604.16-5.851 816.274 19.017 902.583c8.777 38.034 27.794 117.028 95.086 117.028 19.017 0 40.96-7.314 64.366-21.942 17.554-5.852 65.828-10.24 92.16-10.24h1.462c43.886 0 125.806-8.778 175.543-62.903 30.72-33.646 43.886-78.995 38.035-134.583-4.389-57.052-16.092-175.543-26.332-282.332 0 0 45.349-29.257 58.514-29.257 11.703 0 57.052 29.257 57.052 29.257-10.24 108.252-21.943 225.28-27.794 282.332-5.852 55.588 7.314 100.937 38.034 134.583 49.737 54.125 131.657 62.903 175.543 62.903h1.463c24.868 0 74.605 5.851 92.16 10.24 23.405 14.628 45.348 21.942 64.365 21.942 67.292 0 86.309-77.531 95.086-117.028 21.943-84.846 7.314-296.96-16.091-368.64zM753.37 770.926c-13.165 19.017-16.091 35.108-35.108 21.943s-21.943-39.498-8.777-57.052c13.165-19.017 39.497-21.943 57.051-8.777 19.017 13.166 0 24.869-13.166 43.886zM854.31 898.194c-36.572 0-65.829 0-65.829-36.571s29.257-65.829 65.829-65.829 65.828 29.257 65.828 65.829c-1.463 36.571-30.72 36.571-65.828 36.571zM820.663 727.04c8.777-13.166 27.794-16.091 40.96-7.314 13.166 8.777 16.091 27.794 7.314 40.96-8.777 13.165-21.943 2.925-35.108-5.852-14.629-8.777-23.406-14.628-13.166-27.794z",
    fill: "#f4ea2a"
  }));
};

pneumonia.defaultProps = {
  className: "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
};

var lungCancer = function lungCancer(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M997.669 533.943C975.726 466.65 871.863 261.85 810.423 201.874c-43.886-42.423-81.92-62.903-115.566-62.903-24.868 0-61.44 11.703-83.383 67.292-11.703 29.257-14.628 57.051-14.628 59.977 0 1.463-2.926 30.72-7.315 73.143-5.851-5.852-10.24-11.703-14.628-16.092L595.383 4.39 552.96 1.463l-21.943 334.994H501.76L481.28 4.39l-42.423 2.925 20.48 318.903c-4.388 4.389-10.24 11.703-19.017 20.48-4.389-46.811-7.314-76.068-8.777-78.994 0-2.926-2.926-32.183-14.629-59.977-21.943-55.589-57.051-67.292-83.383-67.292-33.645 0-71.68 20.48-115.565 62.903-58.515 58.514-163.84 263.314-185.783 330.606C8.777 604.16-5.851 816.274 19.017 902.583c8.777 38.034 27.794 117.028 95.086 117.028 19.017 0 40.96-7.314 64.366-21.942 17.554-5.852 65.828-10.24 92.16-10.24h1.462c43.886 0 125.806-8.778 175.543-62.903 30.72-33.646 43.886-78.995 38.035-134.583-4.389-57.052-16.092-175.543-26.332-282.332 0 0 45.349-29.257 58.514-29.257 11.703 0 57.052 29.257 57.052 29.257-10.24 108.252-21.943 225.28-27.794 282.332-5.852 55.588 7.314 100.937 38.034 134.583 49.737 54.125 131.657 62.903 175.543 62.903h1.463c24.868 0 74.605 5.851 92.16 10.24 23.405 14.628 45.348 21.942 64.365 21.942 67.292 0 86.309-77.531 95.086-117.028 21.943-84.846 7.314-296.96-16.091-368.64zM753.37 770.926c-13.165 19.017-16.091 35.108-35.108 21.943s-21.943-39.498-8.777-57.052c13.165-19.017 39.497-21.943 57.051-8.777 19.017 13.166 0 24.869-13.166 43.886zM854.31 898.194c-36.572 0-65.829 0-65.829-36.571s29.257-65.829 65.829-65.829 65.828 29.257 65.828 65.829c-1.463 36.571-30.72 36.571-65.828 36.571zM820.663 727.04c8.777-13.166 27.794-16.091 40.96-7.314 13.166 8.777 16.091 27.794 7.314 40.96-8.777 13.165-21.943 2.925-35.108-5.852-14.629-8.777-23.406-14.628-13.166-27.794z",
    fill: "#1afa29"
  }));
};

lungCancer.defaultProps = {
  className: "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
};

var pleuralDisease = function pleuralDisease(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M997.669 533.943C975.726 466.65 871.863 261.85 810.423 201.874c-43.886-42.423-81.92-62.903-115.566-62.903-24.868 0-61.44 11.703-83.383 67.292-11.703 29.257-14.628 57.051-14.628 59.977 0 1.463-2.926 30.72-7.315 73.143-5.851-5.852-10.24-11.703-14.628-16.092L595.383 4.39 552.96 1.463l-21.943 334.994H501.76L481.28 4.39l-42.423 2.925 20.48 318.903c-4.388 4.389-10.24 11.703-19.017 20.48-4.389-46.811-7.314-76.068-8.777-78.994 0-2.926-2.926-32.183-14.629-59.977-21.943-55.589-57.051-67.292-83.383-67.292-33.645 0-71.68 20.48-115.565 62.903-58.515 58.514-163.84 263.314-185.783 330.606C8.777 604.16-5.851 816.274 19.017 902.583c8.777 38.034 27.794 117.028 95.086 117.028 19.017 0 40.96-7.314 64.366-21.942 17.554-5.852 65.828-10.24 92.16-10.24h1.462c43.886 0 125.806-8.778 175.543-62.903 30.72-33.646 43.886-78.995 38.035-134.583-4.389-57.052-16.092-175.543-26.332-282.332 0 0 45.349-29.257 58.514-29.257 11.703 0 57.052 29.257 57.052 29.257-10.24 108.252-21.943 225.28-27.794 282.332-5.852 55.588 7.314 100.937 38.034 134.583 49.737 54.125 131.657 62.903 175.543 62.903h1.463c24.868 0 74.605 5.851 92.16 10.24 23.405 14.628 45.348 21.942 64.365 21.942 67.292 0 86.309-77.531 95.086-117.028 21.943-84.846 7.314-296.96-16.091-368.64zM753.37 770.926c-13.165 19.017-16.091 35.108-35.108 21.943s-21.943-39.498-8.777-57.052c13.165-19.017 39.497-21.943 57.051-8.777 19.017 13.166 0 24.869-13.166 43.886zM854.31 898.194c-36.572 0-65.829 0-65.829-36.571s29.257-65.829 65.829-65.829 65.828 29.257 65.828 65.829c-1.463 36.571-30.72 36.571-65.828 36.571zM820.663 727.04c8.777-13.166 27.794-16.091 40.96-7.314 13.166 8.777 16.091 27.794 7.314 40.96-8.777 13.165-21.943 2.925-35.108-5.852-14.629-8.777-23.406-14.628-13.166-27.794z",
    fill: "#1296db"
  }));
};

pleuralDisease.defaultProps = {
  className: "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
};

var download = function download(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M1024 640.192C1024 782.912 919.872 896 787.648 896h-512C123.904 896 0 761.6 0 597.504 0 451.968 94.656 331.52 226.432 302.976 284.16 195.456 391.808 128 512 128c152.32 0 282.112 108.416 323.392 261.12C941.888 413.44 1024 519.04 1024 640.192zm-682.688-70.016L512 756.48l170.688-186.24H341.312zm213.376 0v-256h-85.376v256h85.376z",
    fill: "currentColor"
  }));
};

download.defaultProps = {
  className: "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
};

var clock = function clock(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M512 56.89c251.351 0 455.11 203.759 455.11 455.11S763.352 967.11 512 967.11 56.89 763.352 56.89 512 260.648 56.89 512 56.89zm-28.445 227.555c-15.709 0-28.444 12.734-28.444 28.444v256c0 15.709 12.735 28.444 28.444 28.444h256c15.71 0 28.445-12.734 28.445-28.444 0-15.71-12.735-28.444-28.445-28.444H512V312.889c0-15.71-12.735-28.444-28.445-28.444z"
  }));
};

clock.defaultProps = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var empty = function empty(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M855.6 427.2H168.5c-12.7 0-24.4 6.9-30.6 18L4.4 684.7C1.5 689.9 0 695.8 0 701.8v287.1c0 19.4 15.7 35.1 35.1 35.1H989c19.4 0 35.1-15.7 35.1-35.1V701.8c0-6-1.5-11.8-4.4-17.1L886.2 445.2c-6.2-11.1-17.9-18-30.6-18zM673.4 695.6c-16.5 0-30.8 11.5-34.3 27.7-12.7 58.5-64.8 102.3-127.2 102.3s-114.5-43.8-127.2-102.3c-3.5-16.1-17.8-27.7-34.3-27.7H119c-26.4 0-43.3-28-31.1-51.4l81.7-155.8c6.1-11.6 18-18.8 31.1-18.8h622.4c13 0 25 7.2 31.1 18.8l81.7 155.8c12.2 23.4-4.7 51.4-31.1 51.4H673.4zm146.5-486.1c-1-1.8-2.1-3.7-3.2-5.5-9.8-16.6-31.1-22.2-47.8-12.6L648.5 261c-17 9.8-22.7 31.6-12.6 48.4.9 1.4 1.7 2.9 2.5 4.4 9.5 17 31.2 22.8 48 13L807 257.3c16.7-9.7 22.4-31 12.9-47.8zm-444.5 51.6L255 191.6c-16.7-9.6-38-4-47.8 12.6-1.1 1.8-2.1 3.6-3.2 5.5-9.5 16.8-3.8 38.1 12.9 47.8L337.3 327c16.9 9.7 38.6 4 48-13.1.8-1.5 1.7-2.9 2.5-4.4 10.2-16.8 4.5-38.6-12.4-48.4zM512 239.3h2.5c19.5.3 35.5-15.5 35.5-35.1v-139c0-19.3-15.6-34.9-34.8-35.1h-6.4C489.6 30.3 474 46 474 65.2v139c0 19.5 15.9 35.4 35.5 35.1h2.5z"
  }));
};

empty.defaultProps = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};

var followup = function followup(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M122.7 28.7c5.5 0 9.9 4.5 9.9 10.1v72.9c0 5.5-4.4 10-9.9 10.1H78.1L52.2 141c-.9.6-1.9 1-3 1.2l-1.3.1c-2.3 0-4.5-1.1-5.9-3-1.3-1.8-1.7-4.1-1.1-6.2l1.5-11.4H11.3c-5.5 0-10-4.5-9.9-10.1V38.8c0-5.6 4.5-10.1 9.9-10.1h111.4zm-.2 10.1L11.3 39l.2 72.7 36.7-.2c1.5 0 2.9.6 3.8 1.8 1 1.1 1.4 2.6 1.2 4l-1.5 11.4 21.7-16.2c.9-.6 1.9-1 3-1h46.3l-.2-72.7zm26.8-37.4c5.2 0 9.5 4.3 9.5 9.6v66c0 5.3-4.2 9.6-9.5 9.6h-10.8V76.4h10.2V11.7h-95v11.1H43.6V11.1c0-5.3 4.2-9.6 9.5-9.6l96.2-.1z"
  }));
};

followup.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 159.6 144.3",
  width: "1em",
  height: "1em",
  fill: "currentColor"
};
var ICONS = {
  user: user,
  sort: sort,
  th: th,
  star: star,
  'sort-up': sortUp,
  'sort-down': sortDown,
  info: info,
  cube: cube,
  crosshairs: crosshairs,
  'dot-circle': dotCircle,
  'angle-left': angleLeft,
  '3d-rotate': d3Rotate,
  plus: plus,
  'chevron-down': chevronDown,
  'angle-double-down': angleDoubleDown,
  'angle-double-up': angleDoubleUp,
  'arrows-alt-h': arrowsAltH,
  'arrows-alt-v': arrowsAltV,
  bars: bars,
  'caret-down': caretDown,
  'caret-up': caretUp,
  'check-circle-o': checkCircleO,
  check: check,
  circle: circle,
  'circle-o': circleO,
  times: times,
  'create-comment': createComment,
  'create-screen-capture': createScreenCapture,
  edit: edit,
  'fast-backward': fastBackward,
  'fast-forward': fastForward,
  'object-group': objectGroup,
  search: search,
  'power-off': powerOff,
  'inline-edit': inlineEdit,
  list: list,
  'ohif-logo': ohifLogo,
  lock: lock,
  play: play,
  database: database,
  cog: cog,
  'circle-notch': circleNotch,
  'square-o': squareO,
  'check-circle': checkCircle,
  'lock-alt': lockAlt,
  'step-backward': stepBackward,
  'step-forward': stepForward,
  stop: stop,
  'th-large': thLarge,
  'th-list': thList,
  sun: sun,
  palette: palette,
  youtube: youtube,
  oval: oval,
  'ellipse-h': ellipseH,
  'ellipse-v': ellipseV,
  adjust: adjust,
  level: level,
  'link-circles': linkCircles,
  'search-plus': searchPlus,
  'measure-non-target': measureNonTarget,
  'measure-target': measureTarget,
  'measure-target-cr': measureTargetCr,
  'measure-target-un': measureTargetUn,
  'measure-target-ne': measureTargetNe,
  'measure-temp': measureTemp,
  'ellipse-circle': ellipseCircle,
  arrows: arrows,
  reset: reset,
  rotate: rotate,
  'rotate-left': rotateLeft,
  'rotate-right': rotateRight,
  trash: trash,
  'exclamation-circle': exclamationCircle,
  link: link,
  'exclamation-triangle': exclamationTriangle,
  brain: brain,
  'soft-tissue': softTissue,
  lung: lung,
  liver: liver,
  tuberculosis: tuberculosis,
  pneumonia: pneumonia,
  'lung-cancer': lungCancer,
  'pleural-disease': pleuralDisease,
  download: download,
  clock: clock,
  empty: empty,
  followup: followup
};
/**
 * Return the matching SVG Icon as a React Component.
 * Results in an inlined SVG Element. If there's no match,
 * return `null`
 */

function getIcon(key, props) {
  if (!key || !ICONS[key]) {
    return React__default.createElement('div', null, 'Missing Icon');
  }

  return React__default.createElement(ICONS[key], props);
}

var css$7 = ".icon-pulse {\n  fa-spin: 1s infinite steps(8);\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn);\n  }\n}\n";
styleInject(css$7);

var Icon = function Icon(props) {
  return getIcon(props.name, props);
};

Icon.propTypes = {
  /** The string name of the icon to display */
  name: propTypes.string.isRequired
}; // Reference > https://reactjs.org/docs/context.html

var WrapperI18n = function WrapperI18n(Component$$1) {
  var WrapperComponent = function WrapperComponent(props) {
    return React__default.createElement(I18nextProvider, {
      i18n: i18n
    }, React__default.createElement(Component$$1, props));
  };

  return WrapperComponent;
};

var withTranslation$1 = function withTranslation$$1(namespace) {
  return function (Component$$1) {
    var TranslatedComponent = function TranslatedComponent(props) {
      return React__default.createElement(Component$$1, props);
    };

    return WrapperI18n(withTranslation(namespace)(TranslatedComponent));
  };
};

var utils = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.defaults = defaults;
  exports.extend = extend;
  var arr = [];
  var each = arr.forEach;
  var slice = arr.slice;

  function defaults(obj) {
    each.call(slice.call(arguments, 1), function (source) {
      if (source) {
        for (var prop in source) {
          if (obj[prop] === undefined) obj[prop] = source[prop];
        }
      }
    });
    return obj;
  }

  function extend(obj) {
    each.call(slice.call(arguments, 1), function (source) {
      if (source) {
        for (var prop in source) {
          obj[prop] = source[prop];
        }
      }
    });
    return obj;
  }
});
unwrapExports(utils);
var utils_1 = utils.defaults;
var utils_2 = utils.extend;
var cookie_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var cookie = {
    create: function create(name, value, minutes, domain) {
      var expires = void 0;

      if (minutes) {
        var date = new Date();
        date.setTime(date.getTime() + minutes * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
      } else expires = '';

      domain = domain ? 'domain=' + domain + ';' : '';
      document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
    },
    read: function read(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }

      return null;
    },
    remove: function remove(name) {
      this.create(name, '', -1);
    }
  };
  exports.default = {
    name: 'cookie',
    lookup: function lookup(options) {
      var found = void 0;

      if (options.lookupCookie && typeof document !== 'undefined') {
        var c = cookie.read(options.lookupCookie);
        if (c) found = c;
      }

      return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
      if (options.lookupCookie && typeof document !== 'undefined') {
        cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
      }
    }
  };
});
unwrapExports(cookie_1);
var querystring = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    name: 'querystring',
    lookup: function lookup(options) {
      var found = void 0;

      if (typeof window !== 'undefined') {
        var query = window.location.search.substring(1);
        var params = query.split('&');

        for (var i = 0; i < params.length; i++) {
          var pos = params[i].indexOf('=');

          if (pos > 0) {
            var key = params[i].substring(0, pos);

            if (key === options.lookupQuerystring) {
              found = params[i].substring(pos + 1);
            }
          }
        }
      }

      return found;
    }
  };
});
unwrapExports(querystring);
var localStorage = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var hasLocalStorageSupport = void 0;

  try {
    hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
  } catch (e) {
    hasLocalStorageSupport = false;
  }

  exports.default = {
    name: 'localStorage',
    lookup: function lookup(options) {
      var found = void 0;

      if (options.lookupLocalStorage && hasLocalStorageSupport) {
        var lng = window.localStorage.getItem(options.lookupLocalStorage);
        if (lng) found = lng;
      }

      return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
      if (options.lookupLocalStorage && hasLocalStorageSupport) {
        window.localStorage.setItem(options.lookupLocalStorage, lng);
      }
    }
  };
});
unwrapExports(localStorage);
var navigator_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    name: 'navigator',
    lookup: function lookup(options) {
      var found = [];

      if (typeof navigator !== 'undefined') {
        if (navigator.languages) {
          // chrome only; not an array, so can't use .push.apply instead of iterating
          for (var i = 0; i < navigator.languages.length; i++) {
            found.push(navigator.languages[i]);
          }
        }

        if (navigator.userLanguage) {
          found.push(navigator.userLanguage);
        }

        if (navigator.language) {
          found.push(navigator.language);
        }
      }

      return found.length > 0 ? found : undefined;
    }
  };
});
unwrapExports(navigator_1);
var htmlTag = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    name: 'htmlTag',
    lookup: function lookup(options) {
      var found = void 0;
      var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

      if (htmlTag && typeof htmlTag.getAttribute === 'function') {
        found = htmlTag.getAttribute('lang');
      }

      return found;
    }
  };
});
unwrapExports(htmlTag);
var path = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    name: 'path',
    lookup: function lookup(options) {
      var found = void 0;

      if (typeof window !== 'undefined') {
        var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);

        if (language instanceof Array) {
          if (typeof options.lookupFromPathIndex === 'number') {
            if (typeof language[options.lookupFromPathIndex] !== 'string') {
              return undefined;
            }

            found = language[options.lookupFromPathIndex].replace('/', '');
          } else {
            found = language[0].replace('/', '');
          }
        }
      }

      return found;
    }
  };
});
unwrapExports(path);
var subdomain = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    name: 'subdomain',
    lookup: function lookup(options) {
      var found = void 0;

      if (typeof window !== 'undefined') {
        var language = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);

        if (language instanceof Array) {
          if (typeof options.lookupFromSubdomainIndex === 'number') {
            found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
          } else {
            found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
          }
        }
      }

      return found;
    }
  };
});
unwrapExports(subdomain);
var commonjs = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var utils$$1 = _interopRequireWildcard(utils);

  var _cookie2 = _interopRequireDefault(cookie_1);

  var _querystring2 = _interopRequireDefault(querystring);

  var _localStorage2 = _interopRequireDefault(localStorage);

  var _navigator2 = _interopRequireDefault(navigator_1);

  var _htmlTag2 = _interopRequireDefault(htmlTag);

  var _path2 = _interopRequireDefault(path);

  var _subdomain2 = _interopRequireDefault(subdomain);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function getDefaults() {
    return {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      // cache user language
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'] //cookieMinutes: 10,
      //cookieDomain: 'myDomain'

    };
  }

  var Browser = function () {
    function Browser(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Browser);

      this.type = 'languageDetector';
      this.detectors = {};
      this.init(services, options);
    }

    _createClass(Browser, [{
      key: 'init',
      value: function init(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = utils$$1.defaults(options, this.options || {}, getDefaults()); // backwards compatibility

        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector(_cookie2.default);
        this.addDetector(_querystring2.default);
        this.addDetector(_localStorage2.default);
        this.addDetector(_navigator2.default);
        this.addDetector(_htmlTag2.default);
        this.addDetector(_path2.default);
        this.addDetector(_subdomain2.default);
      }
    }, {
      key: 'addDetector',
      value: function addDetector(detector) {
        this.detectors[detector.name] = detector;
      }
    }, {
      key: 'detect',
      value: function detect(detectionOrder) {
        var _this = this;

        if (!detectionOrder) detectionOrder = this.options.order;
        var detected = [];
        detectionOrder.forEach(function (detectorName) {
          if (_this.detectors[detectorName]) {
            var lookup = _this.detectors[detectorName].lookup(_this.options);

            if (lookup && typeof lookup === 'string') lookup = [lookup];
            if (lookup) detected = detected.concat(lookup);
          }
        });
        var found = void 0;
        detected.forEach(function (lng) {
          if (found) return;

          var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);

          if (_this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
        });

        if (!found) {
          var fallbacks = this.i18nOptions.fallbackLng;
          if (typeof fallbacks === 'string') fallbacks = [fallbacks];
          if (!fallbacks) fallbacks = [];

          if (Object.prototype.toString.apply(fallbacks) === '[object Array]') {
            found = fallbacks[0];
          } else {
            found = fallbacks[0] || fallbacks.default && fallbacks.default[0];
          }
        }

        return found;
      }
    }, {
      key: 'cacheUserLanguage',
      value: function cacheUserLanguage(lng, caches) {
        var _this2 = this;

        if (!caches) caches = this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach(function (cacheName) {
          if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
        });
      }
    }]);

    return Browser;
  }();

  Browser.type = 'languageDetector';
  exports.default = Browser;
});
unwrapExports(commonjs);
/* eslint no-var: 0 */

var main = commonjs.default;
var i18nextBrowserLanguagedetector = main;
var default_1 = main;
i18nextBrowserLanguagedetector.default = default_1;
var enUsTrans = {
  login: '登录',
  pleaseLogin: '请先登录',
  successful: '成功',
  failure: '失败',
  email: '邮箱',
  account: '账号',
  emailTip: '请输入登录邮箱',
  password: '密码',
  passwordTip: '请输入密码',
  verifyCode: '验证码',
  verifyCodeTip: '请输入图形验证码',
  title: '九峰医疗胸部X线智能筛查',
  JFhealthcare: '九峰医疗',
  chestXrayScreening: '胸部X线智能筛查',
  totalChestXRay: '累计传片',
  totalUser: '总注册用户',
  张: '张',
  人: '人',
  experienceTip: '为确保您的使用体验，推荐使用chrome浏览器。',
  welcome: '欢迎',
  viralPneumonia: '病毒性肺炎',
  uploadTime: '上传时间',
  status: '状态',
  institution: '机构',
  name: '姓名',
  age: '年龄',
  sex: '性别',
  search: '搜索',
  reset: '重置',
  autoRefresh: '自动刷新',
  return: '返回',
  information: '基本信息',
  abnormal: '异常疑似度',
  bodyPart: '部位',
  radiologistReview: '医生审核',
  operation: '操作',
  detailedInfo: '详情',
  chestPA: '正位胸片',
  otherBodyPart: '其他部位',
  normal: '正常',
  unreviewed: '待审核',
  otherAbnormal: '其他异常',
  suspectedViralPneumonia: '疑似病毒性肺炎',
  unKnown: '未知',
  percent: '度',
  startDate: '开始时间',
  endDate: '结束时间',
  selectStatus: '请选择状态',
  enterInstitutionName: '请输入机构名称',
  enterSubjectName: '请输入患者姓名',
  study: '检查',
  zoom: '缩放',
  magnify: '放大镜',
  levels: '调窗',
  pan: '移动',
  invert: '负相',
  transform: '变换',
  rotateLeft: '向左旋转',
  rotateRight: '向右旋转',
  flipH: '左右翻转',
  flipV: '上下翻转',
  more: '更多',
  RIOwindow: 'RIO调窗',
  CINE: '放映',
  download: '下载',
  heatmap: '热力图',
  barChart: 'AI结果',
  series: '序列',
  seniorRadiologistReview: '专家审核',
  impression: '专家意见',
  reviewedByDr: '审核医生',
  enterImpression: '请您输入评审意见',
  edit: '修改',
  done: '确定',
  QC: '胸片AI质控',
  QCStatus: '质控状态',
  qualified: '合格',
  unqualified: '不合格',
  penetration: '曝光检测',
  overPenetration: '曝光过度',
  underPenetration: '曝光不足',
  normalPenetration: '曝光正常',
  artifact: '异物筛查',
  foreignObject: '体外异物',
  inclusion: '关键点检测',
  costophrenicR: '右边隔角',
  vertebra: '第七颈椎',
  costophrenicL: '左边隔角',
  AIQCreport: 'AI智能分析报告',
  under: '不足',
  over: '过度',
  notIncluded: '不全',
  included: '正常',
  have: '存在',
  no: '不存在',
  lung: '肺部',
  male: '男',
  female: '女',
  QCResult: '质控结果',
  opacity: '透明度' // login: 'Login ',
  // pleaseLogin: 'Please Login',
  // successful: 'successful',
  // failure: 'failure',
  // email: 'Email',
  // emailTip: 'Enter login E-mail',
  // password: 'Password',
  // passwordTip: 'Enter password',
  // verifyCode: 'Verify Code',
  // verifyCodeTip: 'Enter verify code',
  // title: 'JF healthcare AI chest X-ray screening',
  // JFhealthcare: 'JF healthcare',
  // chestXrayScreening: 'AI chest X-ray screening',
  // totalChestXRay: 'Total chest X-rays',
  // totalUser: 'Total users',
  // 张: '',
  // 人: '',
  // experienceTip:
  //   'We recommend using Chromium-based browser for better experience.',
  // welcome: 'Welcome',
  // viralPneumonia: 'Viral pneumonia',
  // uploadTime: 'Upload time',
  // status: 'Status',
  // institution: 'Institution',
  // name: 'Name',
  // age: 'Age',
  // sex: 'Sex',
  // search: 'Search',
  // reset: 'Reset',
  // autoRefresh: 'Auto refresh',
  // return: 'Return',
  // information: 'Information',
  // abnormal: 'Abnormal',
  // bodyPart: 'Body part',
  // radiologistReview: 'Radiologist review',
  // operation: 'Operation',
  // detailedInfo: 'Detailed info',
  // chestPA: 'Chest PA',
  // otherBodyPart: 'Other body part',
  // normal: 'Normal',
  // unreviewed: 'Unreviewed',
  // otherAbnormal: 'Other abnormal',
  // suspectedViralPneumonia: 'Suspected viral pneumonia',
  // unKnown: 'Unknown',
  // percent: 'percent',
  // startDate: 'Start date',
  // endDate: 'End date',
  // selectStatus: 'Select status',
  // enterInstitutionName: 'Enter institution name',
  // enterSubjectName: 'Enter subject name',
  // study: 'Study',
  // zoom: 'Zoom',
  // magnify: 'Magnify',
  // levels: 'Levels',
  // pan: 'Pan',
  // invert: 'Invert',
  // transform: 'Transform',
  // rotateRight: 'Rotate right',
  // flipH: 'Flip H',
  // flipV: 'Flip V',
  // more: 'More',
  // RIOwindow: 'RIO window',
  // CINE: 'CINE',
  // download: 'Download',
  // heatmap: 'Heatmap',
  // barChart: 'AI result',
  // series: 'Series',
  // seniorRadiologistReview: 'Senior radiologist review',
  // impression: 'Impression',
  // reviewedByDr: 'Reviewed by Dr. ',
  // enterImpression: 'Enter impression',
  // edit: 'Edit',
  // done: 'Done',
  // QC: 'AI chest X-ray QC',
  // QCStatus: 'QC status',
  // qualified: 'Qualified',
  // unqualified: 'Unqualified',
  // penetration: 'Penetration',
  // overPenetration: 'Over penetration',
  // underPenetration: 'Under penetration',
  // normalPenetration: 'Normal penetration',
  // artifact: 'Artifact',
  // foreignObject: 'Foreign object',
  // inclusion: 'Inclusion (landmark detection)',
  // costophrenicR: 'Costophrenic angle R ',
  // vertebra: 'Vertebra prominens / C7 ',
  // costophrenicL: 'Costophrenic angle L ',
  // AIQCreport: 'AI QC report',
  // under: 'under',
  // over: 'over',
  // notIncluded: 'not included',
  // included: 'included',
  // have: 'have ',
  // no: 'no ',
  // lung: 'Lung',
  // male: 'Male',
  // female: 'Female',
  // QCResult: 'QC result',
  // opacity: 'Opacity',

};
var zhCnTrans = {
  login: '登录',
  pleaseLogin: '请先登录',
  successful: '成功',
  failure: '失败',
  email: '邮箱',
  emailTip: '请输入登录邮箱',
  password: '密码',
  passwordTip: '请输入密码',
  verifyCode: '验证码',
  verifyCodeTip: '请输入图形验证码',
  title: '九峰医疗胸部X线智能筛查',
  JFhealthcare: '九峰医疗',
  chestXrayScreening: '胸部X线智能筛查',
  totalChestXRay: '累计传片',
  totalUser: '总注册用户',
  张: '张',
  人: '人',
  experienceTip: '为确保您的使用体验，推荐使用chrome浏览器。',
  welcome: '欢迎',
  viralPneumonia: '病毒性肺炎',
  uploadTime: '上传时间',
  status: '状态',
  institution: '机构',
  name: '姓名',
  age: '年龄',
  sex: '性别',
  search: '搜索',
  reset: '重置',
  autoRefresh: '自动刷新',
  return: '返回',
  information: '基本信息',
  abnormal: '异常疑似度',
  bodyPart: '部位',
  radiologistReview: '医生审核',
  operation: '操作',
  detailedInfo: '详情',
  chestPA: '正位胸片',
  otherBodyPart: '其他部位',
  normal: '正常',
  unreviewed: '待审核',
  otherAbnormal: '其他异常',
  suspectedViralPneumonia: '疑似病毒性肺炎',
  unKnown: '未知',
  percent: '度',
  startDate: '开始时间',
  endDate: '结束时间',
  selectStatus: '请选择状态',
  enterInstitutionName: '请输入机构名称',
  enterSubjectName: '请输入患者姓名',
  study: '检查',
  zoom: '缩放',
  magnify: '放大镜',
  levels: '调窗',
  pan: '移动',
  invert: '负相',
  transform: '变换',
  rotateLeft: '向左旋转',
  rotateRight: '向右旋转',
  flipH: '左右翻转',
  flipV: '上下翻转',
  more: '更多',
  RIOwindow: 'RIO调窗',
  CINE: '放映',
  download: '下载',
  heatmap: '热力图',
  barChart: 'AI结果',
  series: '序列',
  seniorRadiologistReview: '专家审核',
  impression: '专家意见',
  reviewedByDr: '审核医生',
  enterImpression: '请您输入评审意见',
  edit: '修改',
  done: '确定',
  QC: '胸片AI质控',
  QCStatus: '质控状态',
  qualified: '合格',
  unqualified: '不合格',
  penetration: '曝光检测',
  overPenetration: '曝光过度',
  underPenetration: '曝光不足',
  normalPenetration: '曝光正常',
  artifact: '异物筛查',
  foreignObject: '体外异物',
  inclusion: '关键点检测',
  costophrenicR: '右边隔角',
  vertebra: '第七颈椎',
  costophrenicL: '左边隔角',
  AIQCreport: 'AI智能分析报告',
  under: '不足',
  over: '过度',
  notIncluded: '不全',
  included: '正常',
  have: '存在',
  no: '不存在',
  lung: '肺部',
  male: '男',
  female: '女',
  QCResult: '质控结果',
  opacity: '透明度'
};
i18n$1.use(i18nextBrowserLanguagedetector) //嗅探当前浏览器语言
.use(initReactI18next) //init i18next
.init({
  //引入资源文件
  resources: {
    en: {
      translation: enUsTrans
    },
    zh: {
      translation: zhCnTrans
    }
  },
  //选择默认语言，选择内容为上述配置中的key，即en/zh
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default

  }
});

function ToolbarButton(props) {
  var isActive = props.isActive,
      icon = props.icon,
      labelWhenActive = props.labelWhenActive,
      onClick = props.onClick,
      disabled = props.disabled,
      key = props.key;
  var className = classnames(props.className, {
    active: isActive
  }, {
    disabled: disabled
  });
  var iconProps = typeof icon === 'string' ? {
    name: icon
  } : icon;
  var label = isActive && labelWhenActive ? labelWhenActive : props.label;
  var arrowIconName = props.isExpanded ? 'caret-up' : 'caret-down';
  var arrowIcon = props.isExpandable && React__default.createElement(Icon, {
    name: arrowIconName,
    className: "expand-caret"
  });

  var handleClick = function handleClick(event) {
    if (disabled) return;

    if (onClick) {
      onClick(event, props);
    }
  };

  return React__default.createElement("div", {
    className: className,
    onClick: handleClick,
    key: label
  }, iconProps && React__default.createElement(Icon, iconProps), React__default.createElement("div", {
    className: "toolbar-button-label"
  }, i18n$1.t(label), arrowIcon));
}

ToolbarButton.propTypes = {
  id: propTypes.string,
  isActive: propTypes.bool,

  /** Display label for button */
  label: propTypes.string.isRequired,

  /** Alternative text to show when button is active */
  labelWhenActive: propTypes.string,
  className: propTypes.string.isRequired,
  icon: propTypes.oneOfType([propTypes.string, propTypes.shape({
    name: propTypes.string.isRequired
  })]),
  onClick: propTypes.func,

  /** Determines if we show expandable 'caret' symbol */
  isExpandable: propTypes.bool,

  /** Direction of expandable 'caret' symbol */
  isExpanded: propTypes.bool,
  disabled: propTypes.bool
};
ToolbarButton.defaultProps = {
  isActive: false,
  className: 'toolbar-button'
};
var ToolbarButton$1 = withTranslation$1('Buttons')(ToolbarButton);

var LayoutButton =
/*#__PURE__*/
function (_PureComponent) {
  inherits(LayoutButton, _PureComponent);

  function LayoutButton() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, LayoutButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(LayoutButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      dropdownVisible: _this.props.dropdownVisible
    });
    defineProperty(assertThisInitialized(_this), "onClick", function () {
      _this.props.layoutButtonClick(_this.state.dropdownVisible);

      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    });
    defineProperty(assertThisInitialized(_this), "onChange", function (selectedCell) {
      _this.props.layoutOnChange(selectedCell);

      _this.props.setActiveFullscreen(false);

      if (_this.props.onChange) {
        window.localStorage.setItem('layout', JSON.stringify(selectedCell));

        _this.props.onChange(selectedCell);
      }
    });
    return _this;
  }

  createClass(LayoutButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.dropdownVisible !== prevProps.dropdownVisible) {
        this.setState({
          dropdownVisible: this.props.dropdownVisible
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var layout = window.localStorage.getItem('layout');
      layout = layout ? JSON.parse(layout) : undefined;
      if (layout) this.props.onChange(layout);
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "btn-group"
      }, React__default.createElement(ToolbarButton$1, {
        isActive: this.state.dropdownVisible,
        label: "\u5E03\u5C40",
        icon: "th",
        onClick: this.onClick
      }), React__default.createElement(LayoutChooser, {
        visible: this.state.dropdownVisible,
        onChange: this.onChange,
        onClick: this.onClick,
        selectedCell: this.props.selectedCell
      }));
    }
  }]);
  return LayoutButton;
}(PureComponent);

defineProperty(LayoutButton, "defaultProps", {
  dropdownVisible: false
});
defineProperty(LayoutButton, "propTypes", {
  dropdownVisible: propTypes.bool.isRequired,

  /** Called with the selectedCell number when grid sell is selected */
  onChange: propTypes.func,

  /** The cell to show as selected */
  selectedCell: propTypes.object,
  layoutButtonClick: propTypes.func,
  layoutOnChange: propTypes.func,
  setActiveFullscreen: propTypes.func
});
var css$8 = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* stylelint-disable at-rule-no-unknown */\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n}\ninput::-ms-clear,\ninput::-ms-reveal {\n  display: none;\n}\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n@-ms-viewport {\n  width: device-width;\n}\narticle,\naside,\ndialog,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n  display: block;\n}\nbody {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  background-color: #fff;\n  -webkit-font-feature-settings: 'tnum';\n          font-feature-settings: 'tnum';\n}\n[tabindex='-1']:focus {\n  outline: none !important;\n}\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n  border-bottom: 0;\n  cursor: help;\n}\naddress {\n  margin-bottom: 1em;\n  font-style: normal;\n  line-height: inherit;\n}\ninput[type='text'],\ninput[type='password'],\ninput[type='number'],\ntextarea {\n  -webkit-appearance: none;\n}\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\ndt {\n  font-weight: 500;\n}\ndd {\n  margin-bottom: 0.5em;\n  margin-left: 0;\n}\nblockquote {\n  margin: 0 0 1em;\n}\ndfn {\n  font-style: italic;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\na {\n  color: #1890ff;\n  text-decoration: none;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  -webkit-transition: color 0.3s;\n  transition: color 0.3s;\n  -webkit-text-decoration-skip: objects;\n}\na:hover {\n  color: #40a9ff;\n}\na:active {\n  color: #096dd9;\n}\na:active,\na:hover {\n  text-decoration: none;\n  outline: 0;\n}\na[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n  pointer-events: none;\n}\npre,\ncode,\nkbd,\nsamp {\n  font-size: 1em;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1em;\n  overflow: auto;\n}\nfigure {\n  margin: 0 0 1em;\n}\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\na,\narea,\nbutton,\n[role='button'],\ninput:not([type='range']),\nlabel,\nselect,\nsummary,\ntextarea {\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n}\ntable {\n  border-collapse: collapse;\n}\ncaption {\n  padding-top: 0.75em;\n  padding-bottom: 0.3em;\n  color: rgba(0, 0, 0, 0.45);\n  text-align: left;\n  caption-side: bottom;\n}\nth {\n  text-align: inherit;\n}\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\ninput[type='radio'],\ninput[type='checkbox'] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0;\n}\ninput[type='date'],\ninput[type='time'],\ninput[type='datetime-local'],\ninput[type='month'] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\nfieldset {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0.5em;\n  padding: 0;\n  color: inherit;\n  font-size: 1.5em;\n  line-height: inherit;\n  white-space: normal;\n}\nprogress {\n  vertical-align: baseline;\n}\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n[type='search'] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\noutput {\n  display: inline-block;\n}\nsummary {\n  display: list-item;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none !important;\n}\nmark {\n  padding: 0.2em;\n  background-color: #feffe6;\n}\n::-moz-selection {\n  color: #fff;\n  background: #1890ff;\n}\n::selection {\n  color: #fff;\n  background: #1890ff;\n}\n.clearfix {\n  zoom: 1;\n}\n.clearfix::before,\n.clearfix::after {\n  display: table;\n  content: '';\n}\n.clearfix::after {\n  clear: both;\n}\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.anticon > * {\n  line-height: 1;\n}\n.anticon svg {\n  display: inline-block;\n}\n.anticon::before {\n  display: none;\n}\n.anticon .anticon-icon {\n  display: block;\n}\n.anticon[tabindex] {\n  cursor: pointer;\n}\n.anticon-spin::before {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n          animation: loadingCircle 1s infinite linear;\n}\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n          animation: loadingCircle 1s infinite linear;\n}\n.fade-enter,\n.fade-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.fade-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.fade-enter.fade-enter-active,\n.fade-appear.fade-appear-active {\n  -webkit-animation-name: antFadeIn;\n          animation-name: antFadeIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.fade-leave.fade-leave-active {\n  -webkit-animation-name: antFadeOut;\n          animation-name: antFadeOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.fade-enter,\n.fade-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n.fade-leave {\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n@-webkit-keyframes antFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes antFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes antFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.move-up-enter,\n.move-up-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.move-up-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.move-up-enter.move-up-enter-active,\n.move-up-appear.move-up-appear-active {\n  -webkit-animation-name: antMoveUpIn;\n          animation-name: antMoveUpIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.move-up-leave.move-up-leave-active {\n  -webkit-animation-name: antMoveUpOut;\n          animation-name: antMoveUpOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.move-up-enter,\n.move-up-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-up-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n          animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-down-enter,\n.move-down-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.move-down-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.move-down-enter.move-down-enter-active,\n.move-down-appear.move-down-appear-active {\n  -webkit-animation-name: antMoveDownIn;\n          animation-name: antMoveDownIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.move-down-leave.move-down-leave-active {\n  -webkit-animation-name: antMoveDownOut;\n          animation-name: antMoveDownOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.move-down-enter,\n.move-down-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-down-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n          animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-left-enter,\n.move-left-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.move-left-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.move-left-enter.move-left-enter-active,\n.move-left-appear.move-left-appear-active {\n  -webkit-animation-name: antMoveLeftIn;\n          animation-name: antMoveLeftIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.move-left-leave.move-left-leave-active {\n  -webkit-animation-name: antMoveLeftOut;\n          animation-name: antMoveLeftOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.move-left-enter,\n.move-left-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-left-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n          animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-right-enter,\n.move-right-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.move-right-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.move-right-enter.move-right-enter-active,\n.move-right-appear.move-right-appear-active {\n  -webkit-animation-name: antMoveRightIn;\n          animation-name: antMoveRightIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.move-right-leave.move-right-leave-active {\n  -webkit-animation-name: antMoveRightOut;\n          animation-name: antMoveRightOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.move-right-enter,\n.move-right-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-right-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n          animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n@-webkit-keyframes antMoveDownIn {\n  0% {\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveDownIn {\n  0% {\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antMoveDownOut {\n  0% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveDownOut {\n  0% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antMoveLeftIn {\n  0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveLeftIn {\n  0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antMoveLeftOut {\n  0% {\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveLeftOut {\n  0% {\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antMoveRightIn {\n  0% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveRightIn {\n  0% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antMoveRightOut {\n  0% {\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveRightOut {\n  0% {\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antMoveUpIn {\n  0% {\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveUpIn {\n  0% {\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antMoveUpOut {\n  0% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveUpOut {\n  0% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n    -webkit-transform-origin: 0 0;\n            transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n[ant-click-animating='true'],\n[ant-click-animating-without-extra-node='true'] {\n  position: relative;\n}\nhtml {\n  --antd-wave-shadow-color: #1890ff;\n}\n[ant-click-animating-without-extra-node='true']::after,\n.ant-click-animating-node {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  -webkit-box-shadow: 0 0 0 0 #1890ff;\n          box-shadow: 0 0 0 0 #1890ff;\n  -webkit-box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);\n          box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);\n  opacity: 0.2;\n  -webkit-animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n  content: '';\n  pointer-events: none;\n}\n@-webkit-keyframes waveEffect {\n  100% {\n    -webkit-box-shadow: 0 0 0 #1890ff;\n            box-shadow: 0 0 0 #1890ff;\n    -webkit-box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);\n            box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);\n  }\n}\n@keyframes waveEffect {\n  100% {\n    -webkit-box-shadow: 0 0 0 #1890ff;\n            box-shadow: 0 0 0 #1890ff;\n    -webkit-box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);\n            box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);\n  }\n}\n@-webkit-keyframes fadeEffect {\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeEffect {\n  100% {\n    opacity: 0;\n  }\n}\n.slide-up-enter,\n.slide-up-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.slide-up-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.slide-up-enter.slide-up-enter-active,\n.slide-up-appear.slide-up-appear-active {\n  -webkit-animation-name: antSlideUpIn;\n          animation-name: antSlideUpIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.slide-up-leave.slide-up-leave-active {\n  -webkit-animation-name: antSlideUpOut;\n          animation-name: antSlideUpOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.slide-up-enter,\n.slide-up-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n          animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-up-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n          animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-down-enter,\n.slide-down-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.slide-down-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.slide-down-enter.slide-down-enter-active,\n.slide-down-appear.slide-down-appear-active {\n  -webkit-animation-name: antSlideDownIn;\n          animation-name: antSlideDownIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.slide-down-leave.slide-down-leave-active {\n  -webkit-animation-name: antSlideDownOut;\n          animation-name: antSlideDownOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.slide-down-enter,\n.slide-down-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n          animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-down-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n          animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-left-enter,\n.slide-left-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.slide-left-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.slide-left-enter.slide-left-enter-active,\n.slide-left-appear.slide-left-appear-active {\n  -webkit-animation-name: antSlideLeftIn;\n          animation-name: antSlideLeftIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.slide-left-leave.slide-left-leave-active {\n  -webkit-animation-name: antSlideLeftOut;\n          animation-name: antSlideLeftOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.slide-left-enter,\n.slide-left-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n          animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-left-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n          animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-right-enter,\n.slide-right-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.slide-right-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.slide-right-enter.slide-right-enter-active,\n.slide-right-appear.slide-right-appear-active {\n  -webkit-animation-name: antSlideRightIn;\n          animation-name: antSlideRightIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.slide-right-leave.slide-right-leave-active {\n  -webkit-animation-name: antSlideRightOut;\n          animation-name: antSlideRightOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.slide-right-enter,\n.slide-right-appear {\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n          animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-right-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n          animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@-webkit-keyframes antSlideUpIn {\n  0% {\n    -webkit-transform: scaleY(0.8);\n            transform: scaleY(0.8);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideUpIn {\n  0% {\n    -webkit-transform: scaleY(0.8);\n            transform: scaleY(0.8);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antSlideUpOut {\n  0% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scaleY(0.8);\n            transform: scaleY(0.8);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideUpOut {\n  0% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scaleY(0.8);\n            transform: scaleY(0.8);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antSlideDownIn {\n  0% {\n    -webkit-transform: scaleY(0.8);\n            transform: scaleY(0.8);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideDownIn {\n  0% {\n    -webkit-transform: scaleY(0.8);\n            transform: scaleY(0.8);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antSlideDownOut {\n  0% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scaleY(0.8);\n            transform: scaleY(0.8);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideDownOut {\n  0% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scaleY(0.8);\n            transform: scaleY(0.8);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antSlideLeftIn {\n  0% {\n    -webkit-transform: scaleX(0.8);\n            transform: scaleX(0.8);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scaleX(1);\n            transform: scaleX(1);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideLeftIn {\n  0% {\n    -webkit-transform: scaleX(0.8);\n            transform: scaleX(0.8);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scaleX(1);\n            transform: scaleX(1);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antSlideLeftOut {\n  0% {\n    -webkit-transform: scaleX(1);\n            transform: scaleX(1);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scaleX(0.8);\n            transform: scaleX(0.8);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideLeftOut {\n  0% {\n    -webkit-transform: scaleX(1);\n            transform: scaleX(1);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scaleX(0.8);\n            transform: scaleX(0.8);\n    -webkit-transform-origin: 0% 0%;\n            transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antSlideRightIn {\n  0% {\n    -webkit-transform: scaleX(0.8);\n            transform: scaleX(0.8);\n    -webkit-transform-origin: 100% 0%;\n            transform-origin: 100% 0%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scaleX(1);\n            transform: scaleX(1);\n    -webkit-transform-origin: 100% 0%;\n            transform-origin: 100% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideRightIn {\n  0% {\n    -webkit-transform: scaleX(0.8);\n            transform: scaleX(0.8);\n    -webkit-transform-origin: 100% 0%;\n            transform-origin: 100% 0%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scaleX(1);\n            transform: scaleX(1);\n    -webkit-transform-origin: 100% 0%;\n            transform-origin: 100% 0%;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antSlideRightOut {\n  0% {\n    -webkit-transform: scaleX(1);\n            transform: scaleX(1);\n    -webkit-transform-origin: 100% 0%;\n            transform-origin: 100% 0%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scaleX(0.8);\n            transform: scaleX(0.8);\n    -webkit-transform-origin: 100% 0%;\n            transform-origin: 100% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideRightOut {\n  0% {\n    -webkit-transform: scaleX(1);\n            transform: scaleX(1);\n    -webkit-transform-origin: 100% 0%;\n            transform-origin: 100% 0%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scaleX(0.8);\n            transform: scaleX(0.8);\n    -webkit-transform-origin: 100% 0%;\n            transform-origin: 100% 0%;\n    opacity: 0;\n  }\n}\n.swing-enter,\n.swing-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.swing-enter.swing-enter-active,\n.swing-appear.swing-appear-active {\n  -webkit-animation-name: antSwingIn;\n          animation-name: antSwingIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n@-webkit-keyframes antSwingIn {\n  0%,\n  100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n  20% {\n    -webkit-transform: translateX(-10px);\n            transform: translateX(-10px);\n  }\n  40% {\n    -webkit-transform: translateX(10px);\n            transform: translateX(10px);\n  }\n  60% {\n    -webkit-transform: translateX(-5px);\n            transform: translateX(-5px);\n  }\n  80% {\n    -webkit-transform: translateX(5px);\n            transform: translateX(5px);\n  }\n}\n@keyframes antSwingIn {\n  0%,\n  100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n  20% {\n    -webkit-transform: translateX(-10px);\n            transform: translateX(-10px);\n  }\n  40% {\n    -webkit-transform: translateX(10px);\n            transform: translateX(10px);\n  }\n  60% {\n    -webkit-transform: translateX(-5px);\n            transform: translateX(-5px);\n  }\n  80% {\n    -webkit-transform: translateX(5px);\n            transform: translateX(5px);\n  }\n}\n.zoom-enter,\n.zoom-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-enter.zoom-enter-active,\n.zoom-appear.zoom-appear-active {\n  -webkit-animation-name: antZoomIn;\n          animation-name: antZoomIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.zoom-leave.zoom-leave-active {\n  -webkit-animation-name: antZoomOut;\n          animation-name: antZoomOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-enter,\n.zoom-appear {\n  -webkit-transform: scale(0);\n      -ms-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n          animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-big-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-big-enter.zoom-big-enter-active,\n.zoom-big-appear.zoom-big-appear-active {\n  -webkit-animation-name: antZoomBigIn;\n          animation-name: antZoomBigIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.zoom-big-leave.zoom-big-leave-active {\n  -webkit-animation-name: antZoomBigOut;\n          animation-name: antZoomBigOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  -webkit-transform: scale(0);\n      -ms-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n          animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  -webkit-animation-duration: 0.1s;\n          animation-duration: 0.1s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-big-fast-leave {\n  -webkit-animation-duration: 0.1s;\n          animation-duration: 0.1s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-big-fast-enter.zoom-big-fast-enter-active,\n.zoom-big-fast-appear.zoom-big-fast-appear-active {\n  -webkit-animation-name: antZoomBigIn;\n          animation-name: antZoomBigIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.zoom-big-fast-leave.zoom-big-fast-leave-active {\n  -webkit-animation-name: antZoomBigOut;\n          animation-name: antZoomBigOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  -webkit-transform: scale(0);\n      -ms-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-fast-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n          animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-up-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-up-enter.zoom-up-enter-active,\n.zoom-up-appear.zoom-up-appear-active {\n  -webkit-animation-name: antZoomUpIn;\n          animation-name: antZoomUpIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.zoom-up-leave.zoom-up-leave-active {\n  -webkit-animation-name: antZoomUpOut;\n          animation-name: antZoomUpOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  -webkit-transform: scale(0);\n      -ms-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-up-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n          animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-down-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-down-enter.zoom-down-enter-active,\n.zoom-down-appear.zoom-down-appear-active {\n  -webkit-animation-name: antZoomDownIn;\n          animation-name: antZoomDownIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.zoom-down-leave.zoom-down-leave-active {\n  -webkit-animation-name: antZoomDownOut;\n          animation-name: antZoomDownOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  -webkit-transform: scale(0);\n      -ms-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-down-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n          animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-left-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-left-enter.zoom-left-enter-active,\n.zoom-left-appear.zoom-left-appear-active {\n  -webkit-animation-name: antZoomLeftIn;\n          animation-name: antZoomLeftIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.zoom-left-leave.zoom-left-leave-active {\n  -webkit-animation-name: antZoomLeftOut;\n          animation-name: antZoomLeftOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  -webkit-transform: scale(0);\n      -ms-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-left-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n          animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-right-leave {\n  -webkit-animation-duration: 0.2s;\n          animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  -webkit-animation-play-state: paused;\n          animation-play-state: paused;\n}\n.zoom-right-enter.zoom-right-enter-active,\n.zoom-right-appear.zoom-right-appear-active {\n  -webkit-animation-name: antZoomRightIn;\n          animation-name: antZoomRightIn;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n}\n.zoom-right-leave.zoom-right-leave-active {\n  -webkit-animation-name: antZoomRightOut;\n          animation-name: antZoomRightOut;\n  -webkit-animation-play-state: running;\n          animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  -webkit-transform: scale(0);\n      -ms-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n  -webkit-animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n          animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-right-leave {\n  -webkit-animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n          animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n@-webkit-keyframes antZoomIn {\n  0% {\n    -webkit-transform: scale(0.2);\n            transform: scale(0.2);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomIn {\n  0% {\n    -webkit-transform: scale(0.2);\n            transform: scale(0.2);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antZoomOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(0.2);\n            transform: scale(0.2);\n    opacity: 0;\n  }\n}\n@keyframes antZoomOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(0.2);\n            transform: scale(0.2);\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antZoomBigIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomBigIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes antZoomBigOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    opacity: 0;\n  }\n}\n@keyframes antZoomBigOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antZoomUpIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 50% 0%;\n            transform-origin: 50% 0%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 50% 0%;\n            transform-origin: 50% 0%;\n  }\n}\n@keyframes antZoomUpIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 50% 0%;\n            transform-origin: 50% 0%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 50% 0%;\n            transform-origin: 50% 0%;\n  }\n}\n@-webkit-keyframes antZoomUpOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 50% 0%;\n            transform-origin: 50% 0%;\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 50% 0%;\n            transform-origin: 50% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomUpOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 50% 0%;\n            transform-origin: 50% 0%;\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 50% 0%;\n            transform-origin: 50% 0%;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antZoomLeftIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 0% 50%;\n            transform-origin: 0% 50%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 0% 50%;\n            transform-origin: 0% 50%;\n  }\n}\n@keyframes antZoomLeftIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 0% 50%;\n            transform-origin: 0% 50%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 0% 50%;\n            transform-origin: 0% 50%;\n  }\n}\n@-webkit-keyframes antZoomLeftOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 0% 50%;\n            transform-origin: 0% 50%;\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 0% 50%;\n            transform-origin: 0% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomLeftOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 0% 50%;\n            transform-origin: 0% 50%;\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 0% 50%;\n            transform-origin: 0% 50%;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antZoomRightIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 100% 50%;\n            transform-origin: 100% 50%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 50%;\n            transform-origin: 100% 50%;\n  }\n}\n@keyframes antZoomRightIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 100% 50%;\n            transform-origin: 100% 50%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 50%;\n            transform-origin: 100% 50%;\n  }\n}\n@-webkit-keyframes antZoomRightOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 50%;\n            transform-origin: 100% 50%;\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 100% 50%;\n            transform-origin: 100% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomRightOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 50%;\n            transform-origin: 100% 50%;\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 100% 50%;\n            transform-origin: 100% 50%;\n    opacity: 0;\n  }\n}\n@-webkit-keyframes antZoomDownIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n  }\n}\n@keyframes antZoomDownIn {\n  0% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n  }\n}\n@-webkit-keyframes antZoomDownOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomDownOut {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n  }\n  100% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    -webkit-transform-origin: 50% 100%;\n            transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n.ant-motion-collapse-legacy {\n  overflow: hidden;\n}\n.ant-motion-collapse-legacy-active {\n  -webkit-transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-motion-collapse {\n  overflow: hidden;\n  -webkit-transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n";
styleInject(css$8);
var style =
/*#__PURE__*/
Object.freeze({
  default: css$8
});
var css$9 = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-modal {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  -webkit-font-feature-settings: 'tnum';\n          font-feature-settings: 'tnum';\n  position: relative;\n  top: 100px;\n  width: auto;\n  margin: 0 auto;\n  padding-bottom: 24px;\n  pointer-events: none;\n}\n.ant-modal-wrap {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  overflow: auto;\n  outline: 0;\n  -webkit-overflow-scrolling: touch;\n}\n.ant-modal-title {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  word-wrap: break-word;\n}\n.ant-modal-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: auto;\n}\n.ant-modal-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: 700;\n  line-height: 1;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  -webkit-transition: color 0.3s;\n  transition: color 0.3s;\n}\n.ant-modal-close-x {\n  display: block;\n  width: 56px;\n  height: 56px;\n  font-size: 16px;\n  font-style: normal;\n  line-height: 56px;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n}\n.ant-modal-close:focus,\n.ant-modal-close:hover {\n  color: rgba(0, 0, 0, 0.75);\n  text-decoration: none;\n}\n.ant-modal-header {\n  padding: 16px 24px;\n  color: rgba(0, 0, 0, 0.65);\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  border-radius: 4px 4px 0 0;\n}\n.ant-modal-body {\n  padding: 24px;\n  font-size: 14px;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n.ant-modal-footer {\n  padding: 10px 16px;\n  text-align: right;\n  background: transparent;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 4px 4px;\n}\n.ant-modal-footer button + button {\n  margin-bottom: 0;\n  margin-left: 8px;\n}\n.ant-modal.zoom-enter,\n.ant-modal.zoom-appear {\n  -webkit-transform: none;\n      -ms-transform: none;\n          transform: none;\n  opacity: 0;\n  -webkit-animation-duration: 0.3s;\n          animation-duration: 0.3s;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.ant-modal-mask {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.45);\n  filter: alpha(opacity=50);\n}\n.ant-modal-mask-hidden {\n  display: none;\n}\n.ant-modal-open {\n  overflow: hidden;\n}\n.ant-modal-centered {\n  text-align: center;\n}\n.ant-modal-centered::before {\n  display: inline-block;\n  width: 0;\n  height: 100%;\n  vertical-align: middle;\n  content: '';\n}\n.ant-modal-centered .ant-modal {\n  top: 0;\n  display: inline-block;\n  text-align: left;\n  vertical-align: middle;\n}\n@media (max-width: 767px) {\n  .ant-modal {\n    max-width: calc(100vw - 16px);\n    margin: 8px auto;\n  }\n  .ant-modal-centered .ant-modal {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n  }\n}\n.ant-modal-confirm .ant-modal-header {\n  display: none;\n}\n.ant-modal-confirm .ant-modal-close {\n  display: none;\n}\n.ant-modal-confirm .ant-modal-body {\n  padding: 32px 32px 24px;\n}\n.ant-modal-confirm-body-wrapper {\n  zoom: 1;\n}\n.ant-modal-confirm-body-wrapper::before,\n.ant-modal-confirm-body-wrapper::after {\n  display: table;\n  content: '';\n}\n.ant-modal-confirm-body-wrapper::after {\n  clear: both;\n}\n.ant-modal-confirm-body .ant-modal-confirm-title {\n  display: block;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.4;\n}\n.ant-modal-confirm-body .ant-modal-confirm-content {\n  margin-top: 8px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n}\n.ant-modal-confirm-body > .anticon {\n  float: left;\n  margin-right: 16px;\n  font-size: 22px;\n}\n.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {\n  margin-left: 38px;\n}\n.ant-modal-confirm .ant-modal-confirm-btns {\n  float: right;\n  margin-top: 24px;\n}\n.ant-modal-confirm .ant-modal-confirm-btns button + button {\n  margin-bottom: 0;\n  margin-left: 8px;\n}\n.ant-modal-confirm-error .ant-modal-confirm-body > .anticon {\n  color: #f5222d;\n}\n.ant-modal-confirm-warning .ant-modal-confirm-body > .anticon,\n.ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon {\n  color: #faad14;\n}\n.ant-modal-confirm-info .ant-modal-confirm-body > .anticon {\n  color: #1890ff;\n}\n.ant-modal-confirm-success .ant-modal-confirm-body > .anticon {\n  color: #52c41a;\n}\n";
styleInject(css$9);
var style$1 =
/*#__PURE__*/
Object.freeze({
  default: css$9
});
var css$a = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-btn {\n  line-height: 1.499;\n  position: relative;\n  display: inline-block;\n  font-weight: 400;\n  white-space: nowrap;\n  text-align: center;\n  background-image: none;\n  border: 1px solid transparent;\n  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n          box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);\n  cursor: pointer;\n  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  height: 32px;\n  padding: 0 15px;\n  font-size: 14px;\n  border-radius: 4px;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-btn > .anticon {\n  line-height: 1;\n}\n.ant-btn,\n.ant-btn:active,\n.ant-btn:focus {\n  outline: 0;\n}\n.ant-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-btn:not([disabled]):active {\n  outline: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn.disabled,\n.ant-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-btn.disabled > *,\n.ant-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-btn-lg {\n  height: 40px;\n  padding: 0 15px;\n  font-size: 16px;\n  border-radius: 4px;\n}\n.ant-btn-sm {\n  height: 24px;\n  padding: 0 7px;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.ant-btn > a:only-child {\n  color: currentColor;\n}\n.ant-btn > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:hover,\n.ant-btn:focus {\n  color: #40a9ff;\n  background-color: #fff;\n  border-color: #40a9ff;\n}\n.ant-btn:hover > a:only-child,\n.ant-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn:hover > a:only-child::after,\n.ant-btn:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:active,\n.ant-btn.active {\n  color: #096dd9;\n  background-color: #fff;\n  border-color: #096dd9;\n}\n.ant-btn:active > a:only-child,\n.ant-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn:active > a:only-child::after,\n.ant-btn.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-disabled,\n.ant-btn.disabled,\n.ant-btn[disabled],\n.ant-btn-disabled:hover,\n.ant-btn.disabled:hover,\n.ant-btn[disabled]:hover,\n.ant-btn-disabled:focus,\n.ant-btn.disabled:focus,\n.ant-btn[disabled]:focus,\n.ant-btn-disabled:active,\n.ant-btn.disabled:active,\n.ant-btn[disabled]:active,\n.ant-btn-disabled.active,\n.ant-btn.disabled.active,\n.ant-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-disabled > a:only-child,\n.ant-btn.disabled > a:only-child,\n.ant-btn[disabled] > a:only-child,\n.ant-btn-disabled:hover > a:only-child,\n.ant-btn.disabled:hover > a:only-child,\n.ant-btn[disabled]:hover > a:only-child,\n.ant-btn-disabled:focus > a:only-child,\n.ant-btn.disabled:focus > a:only-child,\n.ant-btn[disabled]:focus > a:only-child,\n.ant-btn-disabled:active > a:only-child,\n.ant-btn.disabled:active > a:only-child,\n.ant-btn[disabled]:active > a:only-child,\n.ant-btn-disabled.active > a:only-child,\n.ant-btn.disabled.active > a:only-child,\n.ant-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-disabled > a:only-child::after,\n.ant-btn.disabled > a:only-child::after,\n.ant-btn[disabled] > a:only-child::after,\n.ant-btn-disabled:hover > a:only-child::after,\n.ant-btn.disabled:hover > a:only-child::after,\n.ant-btn[disabled]:hover > a:only-child::after,\n.ant-btn-disabled:focus > a:only-child::after,\n.ant-btn.disabled:focus > a:only-child::after,\n.ant-btn[disabled]:focus > a:only-child::after,\n.ant-btn-disabled:active > a:only-child::after,\n.ant-btn.disabled:active > a:only-child::after,\n.ant-btn[disabled]:active > a:only-child::after,\n.ant-btn-disabled.active > a:only-child::after,\n.ant-btn.disabled.active > a:only-child::after,\n.ant-btn[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn:hover,\n.ant-btn:focus,\n.ant-btn:active,\n.ant-btn.active {\n  text-decoration: none;\n  background: #fff;\n}\n.ant-btn > i,\n.ant-btn > span {\n  display: inline-block;\n  -webkit-transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  pointer-events: none;\n}\n.ant-btn-primary {\n  color: #fff;\n  background-color: #1890ff;\n  border-color: #1890ff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n          box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n}\n.ant-btn-primary > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  color: #fff;\n  background-color: #40a9ff;\n  border-color: #40a9ff;\n}\n.ant-btn-primary:hover > a:only-child,\n.ant-btn-primary:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary:active,\n.ant-btn-primary.active {\n  color: #fff;\n  background-color: #096dd9;\n  border-color: #096dd9;\n}\n.ant-btn-primary:active > a:only-child,\n.ant-btn-primary.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary:active > a:only-child::after,\n.ant-btn-primary.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-primary-disabled,\n.ant-btn-primary.disabled,\n.ant-btn-primary[disabled],\n.ant-btn-primary-disabled:hover,\n.ant-btn-primary.disabled:hover,\n.ant-btn-primary[disabled]:hover,\n.ant-btn-primary-disabled:focus,\n.ant-btn-primary.disabled:focus,\n.ant-btn-primary[disabled]:focus,\n.ant-btn-primary-disabled:active,\n.ant-btn-primary.disabled:active,\n.ant-btn-primary[disabled]:active,\n.ant-btn-primary-disabled.active,\n.ant-btn-primary.disabled.active,\n.ant-btn-primary[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-primary-disabled > a:only-child,\n.ant-btn-primary.disabled > a:only-child,\n.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-primary-disabled:hover > a:only-child,\n.ant-btn-primary.disabled:hover > a:only-child,\n.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-primary-disabled:focus > a:only-child,\n.ant-btn-primary.disabled:focus > a:only-child,\n.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-primary-disabled:active > a:only-child,\n.ant-btn-primary.disabled:active > a:only-child,\n.ant-btn-primary[disabled]:active > a:only-child,\n.ant-btn-primary-disabled.active > a:only-child,\n.ant-btn-primary.disabled.active > a:only-child,\n.ant-btn-primary[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary-disabled > a:only-child::after,\n.ant-btn-primary.disabled > a:only-child::after,\n.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-primary-disabled:hover > a:only-child::after,\n.ant-btn-primary.disabled:hover > a:only-child::after,\n.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-primary-disabled:focus > a:only-child::after,\n.ant-btn-primary.disabled:focus > a:only-child::after,\n.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-primary-disabled:active > a:only-child::after,\n.ant-btn-primary.disabled:active > a:only-child::after,\n.ant-btn-primary[disabled]:active > a:only-child::after,\n.ant-btn-primary-disabled.active > a:only-child::after,\n.ant-btn-primary.disabled.active > a:only-child::after,\n.ant-btn-primary[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {\n  border-right-color: #40a9ff;\n  border-left-color: #40a9ff;\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {\n  border-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {\n  border-right-color: #40a9ff;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {\n  border-right-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child),\n.ant-btn-group .ant-btn-primary + .ant-btn-primary {\n  border-left-color: #40a9ff;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],\n.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {\n  border-left-color: #d9d9d9;\n}\n.ant-btn-ghost {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: transparent;\n  border-color: #d9d9d9;\n}\n.ant-btn-ghost > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost:hover,\n.ant-btn-ghost:focus {\n  color: #40a9ff;\n  background-color: transparent;\n  border-color: #40a9ff;\n}\n.ant-btn-ghost:hover > a:only-child,\n.ant-btn-ghost:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost:hover > a:only-child::after,\n.ant-btn-ghost:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost:active,\n.ant-btn-ghost.active {\n  color: #096dd9;\n  background-color: transparent;\n  border-color: #096dd9;\n}\n.ant-btn-ghost:active > a:only-child,\n.ant-btn-ghost.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost:active > a:only-child::after,\n.ant-btn-ghost.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-ghost-disabled,\n.ant-btn-ghost.disabled,\n.ant-btn-ghost[disabled],\n.ant-btn-ghost-disabled:hover,\n.ant-btn-ghost.disabled:hover,\n.ant-btn-ghost[disabled]:hover,\n.ant-btn-ghost-disabled:focus,\n.ant-btn-ghost.disabled:focus,\n.ant-btn-ghost[disabled]:focus,\n.ant-btn-ghost-disabled:active,\n.ant-btn-ghost.disabled:active,\n.ant-btn-ghost[disabled]:active,\n.ant-btn-ghost-disabled.active,\n.ant-btn-ghost.disabled.active,\n.ant-btn-ghost[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-ghost-disabled > a:only-child,\n.ant-btn-ghost.disabled > a:only-child,\n.ant-btn-ghost[disabled] > a:only-child,\n.ant-btn-ghost-disabled:hover > a:only-child,\n.ant-btn-ghost.disabled:hover > a:only-child,\n.ant-btn-ghost[disabled]:hover > a:only-child,\n.ant-btn-ghost-disabled:focus > a:only-child,\n.ant-btn-ghost.disabled:focus > a:only-child,\n.ant-btn-ghost[disabled]:focus > a:only-child,\n.ant-btn-ghost-disabled:active > a:only-child,\n.ant-btn-ghost.disabled:active > a:only-child,\n.ant-btn-ghost[disabled]:active > a:only-child,\n.ant-btn-ghost-disabled.active > a:only-child,\n.ant-btn-ghost.disabled.active > a:only-child,\n.ant-btn-ghost[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost-disabled > a:only-child::after,\n.ant-btn-ghost.disabled > a:only-child::after,\n.ant-btn-ghost[disabled] > a:only-child::after,\n.ant-btn-ghost-disabled:hover > a:only-child::after,\n.ant-btn-ghost.disabled:hover > a:only-child::after,\n.ant-btn-ghost[disabled]:hover > a:only-child::after,\n.ant-btn-ghost-disabled:focus > a:only-child::after,\n.ant-btn-ghost.disabled:focus > a:only-child::after,\n.ant-btn-ghost[disabled]:focus > a:only-child::after,\n.ant-btn-ghost-disabled:active > a:only-child::after,\n.ant-btn-ghost.disabled:active > a:only-child::after,\n.ant-btn-ghost[disabled]:active > a:only-child::after,\n.ant-btn-ghost-disabled.active > a:only-child::after,\n.ant-btn-ghost.disabled.active > a:only-child::after,\n.ant-btn-ghost[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-style: dashed;\n}\n.ant-btn-dashed > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed:hover,\n.ant-btn-dashed:focus {\n  color: #40a9ff;\n  background-color: #fff;\n  border-color: #40a9ff;\n}\n.ant-btn-dashed:hover > a:only-child,\n.ant-btn-dashed:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed:hover > a:only-child::after,\n.ant-btn-dashed:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed:active,\n.ant-btn-dashed.active {\n  color: #096dd9;\n  background-color: #fff;\n  border-color: #096dd9;\n}\n.ant-btn-dashed:active > a:only-child,\n.ant-btn-dashed.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed:active > a:only-child::after,\n.ant-btn-dashed.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-dashed-disabled,\n.ant-btn-dashed.disabled,\n.ant-btn-dashed[disabled],\n.ant-btn-dashed-disabled:hover,\n.ant-btn-dashed.disabled:hover,\n.ant-btn-dashed[disabled]:hover,\n.ant-btn-dashed-disabled:focus,\n.ant-btn-dashed.disabled:focus,\n.ant-btn-dashed[disabled]:focus,\n.ant-btn-dashed-disabled:active,\n.ant-btn-dashed.disabled:active,\n.ant-btn-dashed[disabled]:active,\n.ant-btn-dashed-disabled.active,\n.ant-btn-dashed.disabled.active,\n.ant-btn-dashed[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-dashed-disabled > a:only-child,\n.ant-btn-dashed.disabled > a:only-child,\n.ant-btn-dashed[disabled] > a:only-child,\n.ant-btn-dashed-disabled:hover > a:only-child,\n.ant-btn-dashed.disabled:hover > a:only-child,\n.ant-btn-dashed[disabled]:hover > a:only-child,\n.ant-btn-dashed-disabled:focus > a:only-child,\n.ant-btn-dashed.disabled:focus > a:only-child,\n.ant-btn-dashed[disabled]:focus > a:only-child,\n.ant-btn-dashed-disabled:active > a:only-child,\n.ant-btn-dashed.disabled:active > a:only-child,\n.ant-btn-dashed[disabled]:active > a:only-child,\n.ant-btn-dashed-disabled.active > a:only-child,\n.ant-btn-dashed.disabled.active > a:only-child,\n.ant-btn-dashed[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed-disabled > a:only-child::after,\n.ant-btn-dashed.disabled > a:only-child::after,\n.ant-btn-dashed[disabled] > a:only-child::after,\n.ant-btn-dashed-disabled:hover > a:only-child::after,\n.ant-btn-dashed.disabled:hover > a:only-child::after,\n.ant-btn-dashed[disabled]:hover > a:only-child::after,\n.ant-btn-dashed-disabled:focus > a:only-child::after,\n.ant-btn-dashed.disabled:focus > a:only-child::after,\n.ant-btn-dashed[disabled]:focus > a:only-child::after,\n.ant-btn-dashed-disabled:active > a:only-child::after,\n.ant-btn-dashed.disabled:active > a:only-child::after,\n.ant-btn-dashed[disabled]:active > a:only-child::after,\n.ant-btn-dashed-disabled.active > a:only-child::after,\n.ant-btn-dashed.disabled.active > a:only-child::after,\n.ant-btn-dashed[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger {\n  color: #fff;\n  background-color: #ff4d4f;\n  border-color: #ff4d4f;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n          box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n}\n.ant-btn-danger > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger:hover,\n.ant-btn-danger:focus {\n  color: #fff;\n  background-color: #ff7875;\n  border-color: #ff7875;\n}\n.ant-btn-danger:hover > a:only-child,\n.ant-btn-danger:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger:hover > a:only-child::after,\n.ant-btn-danger:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger:active,\n.ant-btn-danger.active {\n  color: #fff;\n  background-color: #d9363e;\n  border-color: #d9363e;\n}\n.ant-btn-danger:active > a:only-child,\n.ant-btn-danger.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger:active > a:only-child::after,\n.ant-btn-danger.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-danger-disabled,\n.ant-btn-danger.disabled,\n.ant-btn-danger[disabled],\n.ant-btn-danger-disabled:hover,\n.ant-btn-danger.disabled:hover,\n.ant-btn-danger[disabled]:hover,\n.ant-btn-danger-disabled:focus,\n.ant-btn-danger.disabled:focus,\n.ant-btn-danger[disabled]:focus,\n.ant-btn-danger-disabled:active,\n.ant-btn-danger.disabled:active,\n.ant-btn-danger[disabled]:active,\n.ant-btn-danger-disabled.active,\n.ant-btn-danger.disabled.active,\n.ant-btn-danger[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-danger-disabled > a:only-child,\n.ant-btn-danger.disabled > a:only-child,\n.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-danger-disabled:hover > a:only-child,\n.ant-btn-danger.disabled:hover > a:only-child,\n.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-danger-disabled:focus > a:only-child,\n.ant-btn-danger.disabled:focus > a:only-child,\n.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-danger-disabled:active > a:only-child,\n.ant-btn-danger.disabled:active > a:only-child,\n.ant-btn-danger[disabled]:active > a:only-child,\n.ant-btn-danger-disabled.active > a:only-child,\n.ant-btn-danger.disabled.active > a:only-child,\n.ant-btn-danger[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger-disabled > a:only-child::after,\n.ant-btn-danger.disabled > a:only-child::after,\n.ant-btn-danger[disabled] > a:only-child::after,\n.ant-btn-danger-disabled:hover > a:only-child::after,\n.ant-btn-danger.disabled:hover > a:only-child::after,\n.ant-btn-danger[disabled]:hover > a:only-child::after,\n.ant-btn-danger-disabled:focus > a:only-child::after,\n.ant-btn-danger.disabled:focus > a:only-child::after,\n.ant-btn-danger[disabled]:focus > a:only-child::after,\n.ant-btn-danger-disabled:active > a:only-child::after,\n.ant-btn-danger.disabled:active > a:only-child::after,\n.ant-btn-danger[disabled]:active > a:only-child::after,\n.ant-btn-danger-disabled.active > a:only-child::after,\n.ant-btn-danger.disabled.active > a:only-child::after,\n.ant-btn-danger[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link {\n  color: #1890ff;\n  background-color: transparent;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-link > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:hover,\n.ant-btn-link:focus {\n  color: #40a9ff;\n  background-color: transparent;\n  border-color: #40a9ff;\n}\n.ant-btn-link:hover > a:only-child,\n.ant-btn-link:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link:hover > a:only-child::after,\n.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:active,\n.ant-btn-link.active {\n  color: #096dd9;\n  background-color: transparent;\n  border-color: #096dd9;\n}\n.ant-btn-link:active > a:only-child,\n.ant-btn-link.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link:active > a:only-child::after,\n.ant-btn-link.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link-disabled,\n.ant-btn-link.disabled,\n.ant-btn-link[disabled],\n.ant-btn-link-disabled:hover,\n.ant-btn-link.disabled:hover,\n.ant-btn-link[disabled]:hover,\n.ant-btn-link-disabled:focus,\n.ant-btn-link.disabled:focus,\n.ant-btn-link[disabled]:focus,\n.ant-btn-link-disabled:active,\n.ant-btn-link.disabled:active,\n.ant-btn-link[disabled]:active,\n.ant-btn-link-disabled.active,\n.ant-btn-link.disabled.active,\n.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-link-disabled > a:only-child,\n.ant-btn-link.disabled > a:only-child,\n.ant-btn-link[disabled] > a:only-child,\n.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-link:hover,\n.ant-btn-link:focus,\n.ant-btn-link:active {\n  border-color: transparent;\n}\n.ant-btn-link-disabled,\n.ant-btn-link.disabled,\n.ant-btn-link[disabled],\n.ant-btn-link-disabled:hover,\n.ant-btn-link.disabled:hover,\n.ant-btn-link[disabled]:hover,\n.ant-btn-link-disabled:focus,\n.ant-btn-link.disabled:focus,\n.ant-btn-link[disabled]:focus,\n.ant-btn-link-disabled:active,\n.ant-btn-link.disabled:active,\n.ant-btn-link[disabled]:active,\n.ant-btn-link-disabled.active,\n.ant-btn-link.disabled.active,\n.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: transparent;\n  border-color: transparent;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-link-disabled > a:only-child,\n.ant-btn-link.disabled > a:only-child,\n.ant-btn-link[disabled] > a:only-child,\n.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-round {\n  height: 32px;\n  padding: 0 16px;\n  font-size: 16px;\n  border-radius: 32px;\n}\n.ant-btn-round.ant-btn-lg {\n  height: 40px;\n  padding: 0 20px;\n  font-size: 18px;\n  border-radius: 40px;\n}\n.ant-btn-round.ant-btn-sm {\n  height: 24px;\n  padding: 0 12px;\n  font-size: 14px;\n  border-radius: 24px;\n}\n.ant-btn-circle,\n.ant-btn-circle-outline {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  font-size: 16px;\n  border-radius: 50%;\n}\n.ant-btn-circle.ant-btn-lg,\n.ant-btn-circle-outline.ant-btn-lg {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  font-size: 18px;\n  border-radius: 50%;\n}\n.ant-btn-circle.ant-btn-sm,\n.ant-btn-circle-outline.ant-btn-sm {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  font-size: 14px;\n  border-radius: 50%;\n}\n.ant-btn::before {\n  position: absolute;\n  top: -1px;\n  right: -1px;\n  bottom: -1px;\n  left: -1px;\n  z-index: 1;\n  display: none;\n  background: #fff;\n  border-radius: inherit;\n  opacity: 0.35;\n  -webkit-transition: opacity 0.2s;\n  transition: opacity 0.2s;\n  content: '';\n  pointer-events: none;\n}\n.ant-btn .anticon {\n  -webkit-transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-btn .anticon.anticon-plus > svg,\n.ant-btn .anticon.anticon-minus > svg {\n  shape-rendering: optimizeSpeed;\n}\n.ant-btn.ant-btn-loading {\n  position: relative;\n  pointer-events: none;\n}\n.ant-btn.ant-btn-loading::before {\n  display: block;\n}\n.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {\n  padding-left: 29px;\n}\n.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) .anticon:not(:last-child) {\n  margin-left: -14px;\n}\n.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) {\n  padding-left: 24px;\n}\n.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only) .anticon {\n  margin-left: -17px;\n}\n.ant-btn-group {\n  position: relative;\n  display: inline-block;\n}\n.ant-btn-group > .ant-btn,\n.ant-btn-group > span > .ant-btn {\n  position: relative;\n}\n.ant-btn-group > .ant-btn:hover,\n.ant-btn-group > span > .ant-btn:hover,\n.ant-btn-group > .ant-btn:focus,\n.ant-btn-group > span > .ant-btn:focus,\n.ant-btn-group > .ant-btn:active,\n.ant-btn-group > span > .ant-btn:active,\n.ant-btn-group > .ant-btn.active,\n.ant-btn-group > span > .ant-btn.active {\n  z-index: 2;\n}\n.ant-btn-group > .ant-btn:disabled,\n.ant-btn-group > span > .ant-btn:disabled {\n  z-index: 0;\n}\n.ant-btn-group-lg > .ant-btn,\n.ant-btn-group-lg > span > .ant-btn {\n  height: 40px;\n  padding: 0 15px;\n  font-size: 16px;\n  border-radius: 0;\n  line-height: 38px;\n}\n.ant-btn-group-sm > .ant-btn,\n.ant-btn-group-sm > span > .ant-btn {\n  height: 24px;\n  padding: 0 7px;\n  font-size: 14px;\n  border-radius: 0;\n  line-height: 22px;\n}\n.ant-btn-group-sm > .ant-btn > .anticon,\n.ant-btn-group-sm > span > .ant-btn > .anticon {\n  font-size: 14px;\n}\n.ant-btn-group .ant-btn + .ant-btn,\n.ant-btn + .ant-btn-group,\n.ant-btn-group span + .ant-btn,\n.ant-btn-group .ant-btn + span,\n.ant-btn-group > span + span,\n.ant-btn-group + .ant-btn,\n.ant-btn-group + .ant-btn-group {\n  margin-left: -1px;\n}\n.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {\n  border-left-color: transparent;\n}\n.ant-btn-group .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn:first-child,\n.ant-btn-group > span:first-child > .ant-btn {\n  margin-left: 0;\n}\n.ant-btn-group > .ant-btn:only-child {\n  border-radius: 4px;\n}\n.ant-btn-group > span:only-child > .ant-btn {\n  border-radius: 4px;\n}\n.ant-btn-group > .ant-btn:first-child:not(:last-child),\n.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-btn-group > .ant-btn:last-child:not(:first-child),\n.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:only-child {\n  border-radius: 4px;\n}\n.ant-btn-group-sm > span:only-child > .ant-btn {\n  border-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),\n.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),\n.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-btn-group > .ant-btn-group {\n  float: left;\n}\n.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {\n  padding-right: 8px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {\n  padding-left: 8px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-btn:not(.ant-btn-circle):not(.ant-btn-circle-outline).ant-btn-icon-only {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ant-btn:focus > span,\n.ant-btn:active > span {\n  position: relative;\n}\n.ant-btn > .anticon + span,\n.ant-btn > span + .anticon {\n  margin-left: 8px;\n}\n.ant-btn-background-ghost {\n  color: #fff;\n  background: transparent !important;\n  border-color: #fff;\n}\n.ant-btn-background-ghost.ant-btn-primary {\n  color: #1890ff;\n  background-color: transparent;\n  border-color: #1890ff;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary:hover,\n.ant-btn-background-ghost.ant-btn-primary:focus {\n  color: #40a9ff;\n  background-color: transparent;\n  border-color: #40a9ff;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary:active,\n.ant-btn-background-ghost.ant-btn-primary.active {\n  color: #096dd9;\n  background-color: transparent;\n  border-color: #096dd9;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled,\n.ant-btn-background-ghost.ant-btn-primary.disabled,\n.ant-btn-background-ghost.ant-btn-primary[disabled],\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger {\n  color: #ff4d4f;\n  background-color: transparent;\n  border-color: #ff4d4f;\n  text-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger:hover,\n.ant-btn-background-ghost.ant-btn-danger:focus {\n  color: #ff7875;\n  background-color: transparent;\n  border-color: #ff7875;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger:active,\n.ant-btn-background-ghost.ant-btn-danger.active {\n  color: #d9363e;\n  background-color: transparent;\n  border-color: #d9363e;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled,\n.ant-btn-background-ghost.ant-btn-danger.disabled,\n.ant-btn-background-ghost.ant-btn-danger[disabled],\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link {\n  color: #1890ff;\n  background-color: transparent;\n  border-color: transparent;\n  text-shadow: none;\n  color: #fff;\n}\n.ant-btn-background-ghost.ant-btn-link > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link:hover,\n.ant-btn-background-ghost.ant-btn-link:focus {\n  color: #40a9ff;\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-btn-background-ghost.ant-btn-link:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link:focus > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link:active,\n.ant-btn-background-ghost.ant-btn-link.active {\n  color: #096dd9;\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-btn-background-ghost.ant-btn-link:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-background-ghost.ant-btn-link-disabled,\n.ant-btn-background-ghost.ant-btn-link.disabled,\n.ant-btn-background-ghost.ant-btn-link[disabled],\n.ant-btn-background-ghost.ant-btn-link-disabled:hover,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-link-disabled:active,\n.ant-btn-background-ghost.ant-btn-link.disabled:active,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active,\n.ant-btn-background-ghost.ant-btn-link-disabled.active,\n.ant-btn-background-ghost.ant-btn-link.disabled.active,\n.ant-btn-background-ghost.ant-btn-link[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f5f5f5;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ant-btn-background-ghost.ant-btn-link-disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link-disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-link[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-link-disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled] > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:hover > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:focus > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled]:active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link-disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link.disabled.active > a:only-child::after,\n.ant-btn-background-ghost.ant-btn-link[disabled].active > a:only-child::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: transparent;\n  content: '';\n}\n.ant-btn-two-chinese-chars::first-letter {\n  letter-spacing: 0.34em;\n}\n.ant-btn-two-chinese-chars > *:not(.anticon) {\n  margin-right: -0.34em;\n  letter-spacing: 0.34em;\n}\n.ant-btn-block {\n  width: 100%;\n}\n.ant-btn:empty {\n  vertical-align: top;\n}\na.ant-btn {\n  line-height: 30px;\n}\na.ant-btn-lg {\n  line-height: 38px;\n}\na.ant-btn-sm {\n  line-height: 22px;\n}\n";
styleInject(css$a);
var style$2 =
/*#__PURE__*/
Object.freeze({
  default: css$a
});
getCjsExportFromNamespace(style);
getCjsExportFromNamespace(style$2);
getCjsExportFromNamespace(style$1);

var _global = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
  var core = module.exports = {
    version: '2.6.11'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});

var _core_1 = _core.version;

var _aFunction = function _aFunction(it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
}; // optional / simple context binding


var _ctx = function _ctx(fn, that, length) {
  _aFunction(fn);

  if (that === undefined) return fn;

  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var _isObject = function _isObject(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function _anObject(it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function _fails(exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
}; // Thank's IE8 for his funny defineProperty


var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

var document$1 = _global.document; // typeof document.createElement is 'object' in old IE

var is = _isObject(document$1) && _isObject(document$1.createElement);

var _domCreate = function _domCreate(it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
}); // 7.1.1 ToPrimitive(input [, PreferredType])
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string


var _toPrimitive = function _toPrimitive(it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;
var f$1 = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);

  P = _toPrimitive(P, true);

  _anObject(Attributes);

  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var _objectDp = {
  f: f$1
};

var _propertyDesc = function _propertyDesc(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;

var _has = function _has(it, key) {
  return hasOwnProperty$1.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;

  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue; // export native or passed

    out = own ? target[key] : source[key]; // prevent global pollution for namespaces

    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global) // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();

            case 1:
              return new C(a);

            case 2:
              return new C(a, b);
          }

          return new C(a, b, c);
        }

        return C.apply(this, arguments);
      };

      F[PROTOTYPE] = C[PROTOTYPE];
      return F; // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
}; // type bitmap


$export.F = 1; // forced

$export.G = 2; // global

$export.S = 4; // static

$export.P = 8; // proto

$export.B = 16; // bind

$export.W = 32; // wrap

$export.U = 64; // safe

$export.R = 128; // real proto method for `library`

var _export = $export;
var toString = {}.toString;

var _cof = function _cof(it) {
  return toString.call(it).slice(8, -1);
}; // fallback for non-array-like ES3 and non-enumerable old V8 strings
// eslint-disable-next-line no-prototype-builtins


var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
}; // 7.2.1 RequireObjectCoercible(argument)


var _defined = function _defined(it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
}; // to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function _toIobject(it) {
  return _iobject(_defined(it));
}; // 7.1.4 ToInteger


var ceil = Math.ceil;
var floor = Math.floor;

var _toInteger = function _toInteger(it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
}; // 7.1.15 ToLength


var min = Math.min;

var _toLength = function _toLength(it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

var _toAbsoluteIndex = function _toAbsoluteIndex(index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
}; // false -> Array#indexOf
// true  -> Array#includes


var _arrayIncludes = function _arrayIncludes(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);

    var length = _toLength(O.length);

    var index = _toAbsoluteIndex(fromIndex, length);

    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }
    return !IS_INCLUDES && -1;
  };
};

var _library = true;

var _shared = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global[SHARED] || (_global[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core.version,
    mode: 'pure',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
});

var id = 0;
var px = Math.random();

var _uid = function _uid(key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function _sharedKey(key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);

var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function _objectKeysInternal(object, names) {
  var O = _toIobject(object);

  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    if (key != IE_PROTO) _has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }

  return result;
}; // IE 8- don't enum bug keys


var _enumBugKeys = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(','); // 19.1.2.14 / 15.2.3.14 Object.keys(O)


var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$2 = Object.getOwnPropertySymbols;
var _objectGops = {
  f: f$2
};
var f$3 = {}.propertyIsEnumerable;
var _objectPie = {
  f: f$3
}; // 7.1.13 ToObject(argument)

var _toObject = function _toObject(it) {
  return Object(_defined(it));
}; // 19.1.2.1 Object.assign(target, source, ...)


var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {}; // eslint-disable-next-line no-undef

  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = _toObject(target);

  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;

  while (aLen > index) {
    var S = _iobject(arguments[index++]);

    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign; // 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', {
  assign: _objectAssign
});

var assign = _core.Object.assign;
var assign$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": assign,
    __esModule: true
  };
});
unwrapExports(assign$1);

var _extends = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _assign2 = _interopRequireDefault(assign$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
});

var _extends$1 = unwrapExports(_extends);

var classCallCheck$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
});

var _classCallCheck$1 = unwrapExports(classCallCheck$1); // true  -> String#at
// false -> String#codePointAt


var _stringAt = function _stringAt(TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));

    var i = _toInteger(pos);

    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);

  var keys = _objectKeys(Properties);

  var length = keys.length;
  var i = 0;
  var P;

  while (length > i) {
    _objectDp.f(O, P = keys[i++], Properties[P]);
  }

  return O;
};

var document$2 = _global.document;

var _html = document$2 && document$2.documentElement; // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


var IE_PROTO$1 = _sharedKey('IE_PROTO');

var Empty = function Empty() {
  /* empty */
};

var PROTOTYPE$1 = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');

  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';

  _html.appendChild(iframe);

  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);

  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;

  while (i--) {
    delete _createDict[PROTOTYPE$1][_enumBugKeys[i]];
  }

  return _createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO$1] = O;
  } else result = _createDict();

  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
  var store = _shared('wks');

  var Symbol = _global.Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
  };

  $exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function _setToStringTag(it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
    configurable: true,
    value: tag
  });
};

var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

_hide(IteratorPrototype, _wks('iterator'), function () {
  return this;
});

var _iterCreate = function _iterCreate(Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, {
    next: _propertyDesc(1, next)
  });

  _setToStringTag(Constructor, NAME + ' Iterator');
}; // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');

var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];

  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }

  return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');

var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

var _iterDefine = function _iterDefine(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);

  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];

    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };

      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }

    return function entries() {
      return new Constructor(this, kind);
    };
  };

  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype; // Fix native

  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));

    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines


      if (!_library && typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  } // fix Array#{values, @@iterator}.name in V8 / FF


  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;

    $default = function values() {
      return $native.call(this);
    };
  } // Define iterator


  if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }

  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }

  return methods;
};

var $at = _stringAt(true); // 21.1.3.27 String.prototype[@@iterator]()


_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target

  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return {
    value: undefined,
    done: true
  };
  point = $at(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});

var _iterStep = function _iterStep(done, value) {
  return {
    value: value,
    done: !!done
  };
}; // 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()


var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target

  this._i = 0; // next index

  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;

  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }

  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

var TO_STRING_TAG = _wks('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = _global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
}

var f$4 = _wks;
var _wksExt = {
  f: f$4
};

var iterator = _wksExt.f('iterator');

var iterator$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": iterator,
    __esModule: true
  };
});
unwrapExports(iterator$1);

var _meta = createCommonjsModule(function (module) {
  var META = _uid('meta');

  var setDesc = _objectDp.f;
  var id = 0;

  var isExtensible = Object.isExtensible || function () {
    return true;
  };

  var FREEZE = !_fails(function () {
    return isExtensible(Object.preventExtensions({}));
  });

  var setMeta = function setMeta(it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return primitive with prefix
    if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMeta(it); // return object ID
    }

    return it[META].i;
  };

  var getWeak = function getWeak(it, create) {
    if (!_has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMeta(it); // return hash weak collections IDs
    }

    return it[META].w;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
    return it;
  };

  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
});

var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;
var defineProperty$2 = _objectDp.f;

var _wksDefine = function _wksDefine(name) {
  var $Symbol = _core.Symbol || (_core.Symbol = {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$2($Symbol, name, {
    value: _wksExt.f(name)
  });
}; // all enumerable object keys, includes symbols


var _enumKeys = function _enumKeys(it) {
  var result = _objectKeys(it);

  var getSymbols = _objectGops.f;

  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;

    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }

  return result;
}; // 7.2.2 IsArray(argument)


var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
}; // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)


var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$5 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
  f: f$5
}; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$1 = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$6 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
  f: f$6
};
var gOPD = Object.getOwnPropertyDescriptor;
var f$7 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) {
    /* empty */
  }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};
var _objectGopd = {
  f: f$7
}; // ECMAScript 6 symbols shim

var META = _meta.KEY;
var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;

var _stringify = $JSON && $JSON.stringify;

var PROTOTYPE$2 = 'prototype';

var HIDDEN = _wks('_hidden');

var TO_PRIMITIVE = _wks('toPrimitive');

var isEnum = {}.propertyIsEnumerable;

var SymbolRegistry = _shared('symbol-registry');

var AllSymbols = _shared('symbols');

var OPSymbols = _shared('op-symbols');

var ObjectProto$1 = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
var QObject = _global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function get() {
      return dP$1(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto$1, key);
  if (protoDesc) delete ObjectProto$1[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto$1) dP$1(ObjectProto$1, key, protoDesc);
} : dP$1;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);

  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);

  _anObject(it);

  key = _toPrimitive(key, true);

  _anObject(D);

  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, {
        enumerable: _propertyDesc(0, false)
      });
    }

    return setSymbolDesc(it, key, D);
  }

  return dP$1(it, key, D);
};

var $defineProperties = function defineProperties(it, P) {
  _anObject(it);

  var keys = _enumKeys(P = _toIobject(P));

  var i = 0;
  var l = keys.length;
  var key;

  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }

  return it;
};

var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};

var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};

var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }

  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$1;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
  }

  return result;
}; // 19.4.1.1 Symbol([description])


if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');

    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);

    var $set = function $set(value) {
      if (this === ObjectProto$1) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };

    if (_descriptors && setter) setSymbolDesc(ObjectProto$1, tag, {
      configurable: true,
      set: $set
    });
    return wrap(tag);
  };

  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, {
  Symbol: $Symbol
});

for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  _wks(es6Symbols[j++]);
}

for (var wellKnownSymbols = _objectKeys(_wks.store), k$1 = 0; wellKnownSymbols.length > k$1;) {
  _wksDefine(wellKnownSymbols[k$1++]);
}

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return _has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
}); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443


var FAILS_ON_PRIMITIVES = _fails(function () {
  _objectGops.f(1);
});

_export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops.f(_toObject(it));
  }
}); // 24.3.2 JSON.stringify(value [, replacer [, space]])


$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols

  return _stringify([S]) != '[null]' || _stringify({
    a: S
  }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;

    while (arguments.length > i) {
      args.push(arguments[i++]);
    }

    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

    if (!_isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
}); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

_setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]


_setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]


_setToStringTag(_global.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core.Symbol;
var symbol$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": symbol,
    __esModule: true
  };
});
unwrapExports(symbol$1);

var _typeof_1$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _iterator2 = _interopRequireDefault(iterator$1);

  var _symbol2 = _interopRequireDefault(symbol$1);

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
  };

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
});

var _typeof = unwrapExports(_typeof_1$1);

var possibleConstructorReturn$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _typeof3 = _interopRequireDefault(_typeof_1$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
  };
});

var _possibleConstructorReturn$1 = unwrapExports(possibleConstructorReturn$1); // Works with __proto__ only. Old v8 can't work with null proto objects.

/* eslint-disable no-proto */


var check$1 = function check$1(O, proto) {
  _anObject(O);

  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};

var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }

    return function setPrototypeOf(O, proto) {
      check$1(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check$1
}; // 19.1.3.19 Object.setPrototypeOf(O, proto)

_export(_export.S, 'Object', {
  setPrototypeOf: _setProto.set
});

var setPrototypeOf$1 = _core.Object.setPrototypeOf;
var setPrototypeOf$2 = createCommonjsModule(function (module) {
  module.exports = {
    "default": setPrototypeOf$1,
    __esModule: true
  };
});
unwrapExports(setPrototypeOf$2); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

_export(_export.S, 'Object', {
  create: _objectCreate
});

var $Object = _core.Object;

var create = function create(P, D) {
  return $Object.create(P, D);
};

var create$1 = createCommonjsModule(function (module) {
  module.exports = {
    "default": create,
    __esModule: true
  };
});
unwrapExports(create$1);
var inherits$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf$2);

  var _create2 = _interopRequireDefault(create$1);

  var _typeof3 = _interopRequireDefault(_typeof_1$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  };
});

var _inherits$1 = unwrapExports(inherits$1);
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */


var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};

function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

var cached;

function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }

  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}
/**
 * Easy to set element style, return previous style
 * IE browser compatible(IE browser doesn't merge overflow style, need to set it separately)
 * https://github.com/ant-design/ant-design/issues/19393
 *
 */


function setStyle(style) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$element = options.element,
      element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style); // IE browser compatible

  styleKeys.forEach(function (key) {
    oldStyle[key] = element.style[key];
  });
  styleKeys.forEach(function (key) {
    element.style[key] = style[key];
  });
  return oldStyle;
}

function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

var cacheStyle = {};

var switchScrollingEffect = function switchScrollingEffect(close) {
  if (!isBodyOverflowing() && !close) {
    return;
  } // https://github.com/ant-design/ant-design/issues/19729


  var scrollingEffectClassName = 'ant-scrolling-effect';
  var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');
  var bodyClassName = document.body.className;

  if (close) {
    if (!scrollingEffectClassNameReg.test(bodyClassName)) return;
    setStyle(cacheStyle);
    cacheStyle = {};
    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg, '').trim();
    return;
  }

  var scrollBarSize = getScrollBarSize();

  if (scrollBarSize) {
    cacheStyle = setStyle({
      position: 'relative',
      width: "calc(100% - ".concat(scrollBarSize, "px)")
    });

    if (!scrollingEffectClassNameReg.test(bodyClassName)) {
      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName);
      document.body.className = addClassName.trim();
    }
  }
}; // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


_export(_export.S + _export.F * !_descriptors, 'Object', {
  defineProperty: _objectDp.f
});

var $Object$1 = _core.Object;

var defineProperty$3 = function defineProperty(it, key, desc) {
  return $Object$1.defineProperty(it, key, desc);
};

var defineProperty$4 = createCommonjsModule(function (module) {
  module.exports = {
    "default": defineProperty$3,
    __esModule: true
  };
});
unwrapExports(defineProperty$4);
var defineProperty$6 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _defineProperty2 = _interopRequireDefault(defineProperty$4);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (obj, key, value) {
    if (key in obj) {
      (0, _defineProperty2.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };
});

var _defineProperty$2 = unwrapExports(defineProperty$6);

var createClass$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _defineProperty2 = _interopRequireDefault(defineProperty$4);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
});

var _createClass$1 = unwrapExports(createClass$1);
/** @license React v16.13.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b$1 = "function" === typeof Symbol && Symbol.for,
    c$1 = b$1 ? Symbol.for("react.element") : 60103,
    d$1 = b$1 ? Symbol.for("react.portal") : 60106,
    e$1 = b$1 ? Symbol.for("react.fragment") : 60107,
    f$8 = b$1 ? Symbol.for("react.strict_mode") : 60108,
    g$1 = b$1 ? Symbol.for("react.profiler") : 60114,
    h$1 = b$1 ? Symbol.for("react.provider") : 60109,
    k$2 = b$1 ? Symbol.for("react.context") : 60110,
    l$1 = b$1 ? Symbol.for("react.async_mode") : 60111,
    m$1 = b$1 ? Symbol.for("react.concurrent_mode") : 60111,
    n$1 = b$1 ? Symbol.for("react.forward_ref") : 60112,
    p$1 = b$1 ? Symbol.for("react.suspense") : 60113,
    q$1 = b$1 ? Symbol.for("react.suspense_list") : 60120,
    r$1 = b$1 ? Symbol.for("react.memo") : 60115,
    t$1 = b$1 ? Symbol.for("react.lazy") : 60116,
    v$1 = b$1 ? Symbol.for("react.block") : 60121,
    w$1 = b$1 ? Symbol.for("react.fundamental") : 60117,
    x$1 = b$1 ? Symbol.for("react.responder") : 60118,
    y$1 = b$1 ? Symbol.for("react.scope") : 60119;

function z$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e$1:
          case g$1:
          case f$8:
          case p$1:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$2:
              case n$1:
              case t$1:
              case r$1:
              case h$1:
                return a;

              default:
                return u;
            }

        }

      case d$1:
        return u;
    }
  }
}

function A$1(a) {
  return z$1(a) === m$1;
}

var AsyncMode$1 = l$1;
var ConcurrentMode$1 = m$1;
var ContextConsumer$1 = k$2;
var ContextProvider$1 = h$1;
var Element$2 = c$1;
var ForwardRef$1 = n$1;
var Fragment$1 = e$1;
var Lazy$1 = t$1;
var Memo$1 = r$1;
var Portal$1 = d$1;
var Profiler$1 = g$1;
var StrictMode$1 = f$8;
var Suspense$1 = p$1;

var isAsyncMode$1 = function isAsyncMode$1(a) {
  return A$1(a) || z$1(a) === l$1;
};

var isConcurrentMode$1 = A$1;

var isContextConsumer$1 = function isContextConsumer$1(a) {
  return z$1(a) === k$2;
};

var isContextProvider$1 = function isContextProvider$1(a) {
  return z$1(a) === h$1;
};

var isElement$1 = function isElement$1(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1;
};

var isForwardRef$1 = function isForwardRef$1(a) {
  return z$1(a) === n$1;
};

var isFragment$1 = function isFragment$1(a) {
  return z$1(a) === e$1;
};

var isLazy$1 = function isLazy$1(a) {
  return z$1(a) === t$1;
};

var isMemo$1 = function isMemo$1(a) {
  return z$1(a) === r$1;
};

var isPortal$1 = function isPortal$1(a) {
  return z$1(a) === d$1;
};

var isProfiler$1 = function isProfiler$1(a) {
  return z$1(a) === g$1;
};

var isStrictMode$1 = function isStrictMode$1(a) {
  return z$1(a) === f$8;
};

var isSuspense$1 = function isSuspense$1(a) {
  return z$1(a) === p$1;
};

var isValidElementType$1 = function isValidElementType$1(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$8 || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$2 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};

var typeOf$1 = z$1;
var reactIs_production_min$1 = {
  AsyncMode: AsyncMode$1,
  ConcurrentMode: ConcurrentMode$1,
  ContextConsumer: ContextConsumer$1,
  ContextProvider: ContextProvider$1,
  Element: Element$2,
  ForwardRef: ForwardRef$1,
  Fragment: Fragment$1,
  Lazy: Lazy$1,
  Memo: Memo$1,
  Portal: Portal$1,
  Profiler: Profiler$1,
  StrictMode: StrictMode$1,
  Suspense: Suspense$1,
  isAsyncMode: isAsyncMode$1,
  isConcurrentMode: isConcurrentMode$1,
  isContextConsumer: isContextConsumer$1,
  isContextProvider: isContextProvider$1,
  isElement: isElement$1,
  isForwardRef: isForwardRef$1,
  isFragment: isFragment$1,
  isLazy: isLazy$1,
  isMemo: isMemo$1,
  isPortal: isPortal$1,
  isProfiler: isProfiler$1,
  isStrictMode: isStrictMode$1,
  isSuspense: isSuspense$1,
  isValidElementType: isValidElementType$1,
  typeOf: typeOf$1
};
var reactIs_development$1 = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1$1 = reactIs_development$1.AsyncMode;
var reactIs_development_2$1 = reactIs_development$1.ConcurrentMode;
var reactIs_development_3$1 = reactIs_development$1.ContextConsumer;
var reactIs_development_4$1 = reactIs_development$1.ContextProvider;
var reactIs_development_5$1 = reactIs_development$1.Element;
var reactIs_development_6$1 = reactIs_development$1.ForwardRef;
var reactIs_development_7$1 = reactIs_development$1.Fragment;
var reactIs_development_8$1 = reactIs_development$1.Lazy;
var reactIs_development_9$1 = reactIs_development$1.Memo;
var reactIs_development_10$1 = reactIs_development$1.Portal;
var reactIs_development_11$1 = reactIs_development$1.Profiler;
var reactIs_development_12$1 = reactIs_development$1.StrictMode;
var reactIs_development_13$1 = reactIs_development$1.Suspense;
var reactIs_development_14$1 = reactIs_development$1.isAsyncMode;
var reactIs_development_15$1 = reactIs_development$1.isConcurrentMode;
var reactIs_development_16$1 = reactIs_development$1.isContextConsumer;
var reactIs_development_17$1 = reactIs_development$1.isContextProvider;
var reactIs_development_18$1 = reactIs_development$1.isElement;
var reactIs_development_19$1 = reactIs_development$1.isForwardRef;
var reactIs_development_20$1 = reactIs_development$1.isFragment;
var reactIs_development_21$1 = reactIs_development$1.isLazy;
var reactIs_development_22$1 = reactIs_development$1.isMemo;
var reactIs_development_23$1 = reactIs_development$1.isPortal;
var reactIs_development_24$1 = reactIs_development$1.isProfiler;
var reactIs_development_25$1 = reactIs_development$1.isStrictMode;
var reactIs_development_26$1 = reactIs_development$1.isSuspense;
var reactIs_development_27$1 = reactIs_development$1.isValidElementType;
var reactIs_development_28$1 = reactIs_development$1.typeOf;
var reactIs$1 = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1;
  } else {
    module.exports = reactIs_development$1;
  }
});
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;

var printWarning$2 = function printWarning$2() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$3 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$2 = function printWarning$2(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$3);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$2((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures$1[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$2('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1 = {};
  }
};

var checkPropTypes_1$1 = checkPropTypes$1;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$3 = function printWarning$3() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$3 = function printWarning$3(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull$1() {
  return null;
}

var factoryWithTypeCheckers$1 = function factoryWithTypeCheckers$1(isValidElement$$1, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$3('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement$$1(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$3('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$3('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull$1;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$3('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$3('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull$1;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement$$1(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction$1() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction$1;

var factoryWithThrowingShims$1 = function factoryWithThrowingShims$1() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction$1
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes$1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$1; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims$1();
  }
});

var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component$$1;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!React__default.Profiler) {
    return Component$$1;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component$$1;
};

function toArrayChildren(children) {
  var ret = [];
  React__default.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;

  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }

      if (child && child.key === key) {
        ret = child;
      }
    });
  }

  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;

  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }

        ret = child;
      }
    });
  }

  return ret;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;

  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];

      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }

  return same;
}

function mergeChildren(prev, next) {
  var ret = []; // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });
  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }

    ret.push(child);
  });
  ret = ret.concat(pendingChildren);
  return ret;
}

var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },
  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};
var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },
  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};
var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];

        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener$1(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,
  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }

    startEvents.forEach(function (startEvent) {
      addEventListener$1(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }

    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },
  // End events
  endEvents: endEvents,
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }

    endEvents.forEach(function (endEvent) {
      addEventListener$1(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }

    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

var componentIndexof = function componentIndexof(arr, obj) {
  if (arr.indexOf) return arr.indexOf(obj);

  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }

  return -1;
};
/**
 * Module dependencies.
 */


try {
  var index$5 = componentIndexof;
} catch (err) {
  var index$5 = componentIndexof;
}
/**
 * Whitespace regexp.
 */


var re = /\s+/;
/**
 * toString reference.
 */

var toString$2 = Object.prototype.toString;
/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

var componentClasses = function componentClasses(el) {
  return new ClassList(el);
};
/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */


function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }

  this.el = el;
  this.list = el.classList;
}
/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */


ClassList.prototype.add = function (name) {
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  } // fallback


  var arr = this.array();
  var i = index$5(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};
/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */


ClassList.prototype.remove = function (name) {
  if ('[object RegExp]' == toString$2.call(name)) {
    return this.removeMatching(name);
  } // classList


  if (this.list) {
    this.list.remove(name);
    return this;
  } // fallback


  var arr = this.array();
  var i = index$5(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};
/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */


ClassList.prototype.removeMatching = function (re) {
  var arr = this.array();

  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }

  return this;
};
/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */


ClassList.prototype.toggle = function (name, force) {
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }

    return this;
  } // fallback


  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};
/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */


ClassList.prototype.array = function () {
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};
/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */


ClassList.prototype.has = ClassList.prototype.contains = function (name) {
  return this.list ? this.list.contains(name) : !!~index$5(this.array(), name);
};

var isCssAnimationSupported = TransitionEvents.endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O', // ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';

  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);

    if (ret) {
      break;
    }
  }

  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay); // sometimes, browser bug

    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;

      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = componentClasses(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);
    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);
    TransitionEvents.removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null; // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.

    if (end) {
      end();
    }
  };

  TransitionEvents.addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }

  nodeClasses.add(className);
  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);

    if (active) {
      setTimeout(active, 0);
    }

    fixBrowserByTimeout(node); // 30ms for firefox
  }, 30);
  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);
    TransitionEvents.removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null; // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.

    if (callback) {
      callback();
    }
  };

  TransitionEvents.addEndEventListener(node, node.rcEndListener);
  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }

    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;

  if (value === undefined) {
    v = property;
    property = '';
  }

  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  _inherits$1(AnimateChild, _React$Component);

  function AnimateChild() {
    _classCallCheck$1(this, AnimateChild);

    return _possibleConstructorReturn$1(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  _createClass$1(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (util.isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (util.isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (util.isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = ReactDOM__default.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();

      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };

      if ((isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';

        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }

        this.stopper = cssAnimation(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;

      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(React__default.Component);

AnimateChild.propTypes = {
  children: propTypes$1.any,
  animation: propTypes$1.any,
  transitionName: propTypes$1.any
};
var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;

  if (React__default.isValidElement(children)) {
    if (!children.key) {
      return React__default.cloneElement(children, {
        key: defaultKey
      });
    }
  }

  return children;
}

function noop$1() {}

var Animate = function (_React$Component) {
  _inherits$1(Animate, _React$Component); // eslint-disable-line


  function Animate(props) {
    _classCallCheck$1(this, Animate);

    var _this = _possibleConstructorReturn$1(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];
    _this.state = {
      children: toArrayChildren(getChildrenFromProps(props))
    };
    _this.childrenRefs = {};
    return _this;
  }

  _createClass$1(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;

      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }

      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = toArrayChildren(getChildrenFromProps(nextProps));
      var props = this.props; // exclusive needs immediate response

      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }

      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys; // last props children if exclusive

      var currentChildren = props.exclusive ? toArrayChildren(getChildrenFromProps(props)) : this.state.children; // in case destroy in showProp mode

      var newChildren = [];

      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && findChildInChildrenByKey(nextChildren, currentChild.key);
          var newChild = void 0;

          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = React__default.cloneElement(nextChild || currentChild, _defineProperty$2({}, showProp, true));
          } else {
            newChild = nextChild;
          }

          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !findChildInChildrenByKey(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = mergeChildren(currentChildren, nextChildren);
      } // need render to avoid update


      this.setState({
        children: newChildren
      });
      nextChildren.forEach(function (child) {
        var key = child && child.key;

        if (child && currentlyAnimatingKeys[key]) {
          return;
        }

        var hasPrev = child && findChildInChildrenByKey(currentChildren, key);

        if (showProp) {
          var showInNext = child.props[showProp];

          if (hasPrev) {
            var showInNow = findShownChildInChildrenByKey(currentChildren, key, showProp);

            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });
      currentChildren.forEach(function (child) {
        var key = child && child.key;

        if (child && currentlyAnimatingKeys[key]) {
          return;
        }

        var hasNext = child && findChildInChildrenByKey(nextChildren, key);

        if (showProp) {
          var showInNow = child.props[showProp];

          if (hasNext) {
            var showInNext = findShownChildInChildrenByKey(nextChildren, key, showProp);

            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;

      if (showProp) {
        return findShownChildInChildrenByKey(currentChildren, key, showProp);
      }

      return findChildInChildrenByKey(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];

      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;

      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }

          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }

          return React__default.createElement(AnimateChild, {
            key: child.key,
            ref: function ref(node) {
              _this4.childrenRefs[child.key] = node;
            },
            animation: props.animation,
            transitionName: props.transitionName,
            transitionEnter: props.transitionEnter,
            transitionAppear: props.transitionAppear,
            transitionLeave: props.transitionLeave
          }, child);
        });
      }

      var Component$$1 = props.component;

      if (Component$$1) {
        var passedProps = props;

        if (typeof Component$$1 === 'string') {
          passedProps = _extends$1({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }

        return React__default.createElement(Component$$1, passedProps, children);
      }

      return children[0] || null;
    }
  }]);

  return Animate;
}(React__default.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: propTypes$1.string,
  style: propTypes$1.object,
  component: propTypes$1.any,
  componentProps: propTypes$1.object,
  animation: propTypes$1.object,
  transitionName: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.object]),
  transitionEnter: propTypes$1.bool,
  transitionAppear: propTypes$1.bool,
  exclusive: propTypes$1.bool,
  transitionLeave: propTypes$1.bool,
  onEnd: propTypes$1.func,
  onEnter: propTypes$1.func,
  onLeave: propTypes$1.func,
  onAppear: propTypes$1.func,
  showProp: propTypes$1.string,
  children: propTypes$1.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop$1,
  onEnter: noop$1,
  onLeave: noop$1,
  onAppear: noop$1
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;

      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;

      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key]; // if update on exclusive mode, skip check

    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }

    var currentChildren = toArrayChildren(getChildrenFromProps(props));

    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (util.allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (util.allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;

      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key]; // if update on exclusive mode, skip check

    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }

    var currentChildren = toArrayChildren(getChildrenFromProps(props)); // in case state change is too fast

    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (util.allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };

      if (!isSameChildren(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

var Animate$1 = unsafeLifecyclesPolyfill(Animate);

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var LazyRenderBox = function (_React$Component) {
  _inherits$1(LazyRenderBox, _React$Component);

  function LazyRenderBox() {
    _classCallCheck$1(this, LazyRenderBox);

    return _possibleConstructorReturn$1(this, _React$Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.forceRender) {
      return true;
    }

    return !!nextProps.hiddenClassName || !!nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _a = this.props,
        className = _a.className,
        hiddenClassName = _a.hiddenClassName,
        visible = _a.visible,
        forceRender = _a.forceRender,
        restProps = __rest(_a, ["className", "hiddenClassName", "visible", "forceRender"]);

    var useClassName = className;

    if (!!hiddenClassName && !visible) {
      useClassName += " " + hiddenClassName;
    }

    return createElement("div", _extends$1({}, restProps, {
      className: useClassName
    }));
  };

  return LazyRenderBox;
}(Component);

var uuid = 0;
/* eslint react/no-is-mounted:0 */

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document;
    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      ret = d.body[method];
    }
  }

  return ret;
}

function setTransformOrigin(node, value) {
  var style = node.style;
  ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
    style[prefix + 'TransformOrigin'] = value;
  });
  style['transformOrigin'] = value;
}

function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}

var cacheOverflow = {};

var Dialog = function (_React$Component) {
  _inherits$1(Dialog, _React$Component);

  function Dialog(props) {
    _classCallCheck$1(this, Dialog);

    var _this = _possibleConstructorReturn$1(this, _React$Component.call(this, props));

    _this.inTransition = false;

    _this.onAnimateLeave = function () {
      var afterClose = _this.props.afterClose; // need demo?
      // https://github.com/react-component/dialog/pull/28

      if (_this.wrap) {
        _this.wrap.style.display = 'none';
      }

      _this.inTransition = false;

      _this.switchScrollingEffect();

      if (afterClose) {
        afterClose();
      }
    };

    _this.onDialogMouseDown = function () {
      _this.dialogMouseDown = true;
    };

    _this.onMaskMouseUp = function () {
      if (_this.dialogMouseDown) {
        _this.timeoutId = setTimeout(function () {
          _this.dialogMouseDown = false;
        }, 0);
      }
    };

    _this.onMaskClick = function (e) {
      // android trigger click on open (fastclick??)
      if (Date.now() - _this.openTime < 300) {
        return;
      }

      if (e.target === e.currentTarget && !_this.dialogMouseDown) {
        _this.close(e);
      }
    };

    _this.onKeyDown = function (e) {
      var props = _this.props;

      if (props.keyboard && e.keyCode === KeyCode.ESC) {
        e.stopPropagation();

        _this.close(e);

        return;
      } // keep focus inside dialog


      if (props.visible) {
        if (e.keyCode === KeyCode.TAB) {
          var activeElement = document.activeElement;
          var sentinelStart = _this.sentinelStart;

          if (e.shiftKey) {
            if (activeElement === sentinelStart) {
              _this.sentinelEnd.focus();
            }
          } else if (activeElement === _this.sentinelEnd) {
            sentinelStart.focus();
          }
        }
      }
    };

    _this.getDialogElement = function () {
      var props = _this.props;
      var closable = props.closable;
      var prefixCls = props.prefixCls;
      var dest = {};

      if (props.width !== undefined) {
        dest.width = props.width;
      }

      if (props.height !== undefined) {
        dest.height = props.height;
      }

      var footer = void 0;

      if (props.footer) {
        footer = createElement("div", {
          className: prefixCls + '-footer',
          ref: _this.saveRef('footer')
        }, props.footer);
      }

      var header = void 0;

      if (props.title) {
        header = createElement("div", {
          className: prefixCls + '-header',
          ref: _this.saveRef('header')
        }, createElement("div", {
          className: prefixCls + '-title',
          id: _this.titleId
        }, props.title));
      }

      var closer = void 0;

      if (closable) {
        closer = createElement("button", {
          type: "button",
          onClick: _this.close,
          "aria-label": "Close",
          className: prefixCls + '-close'
        }, props.closeIcon || createElement("span", {
          className: prefixCls + '-close-x'
        }));
      }

      var style = _extends$1({}, props.style, dest);

      var sentinelStyle = {
        width: 0,
        height: 0,
        overflow: 'hidden'
      };

      var transitionName = _this.getTransitionName();

      var dialogElement = createElement(LazyRenderBox, {
        key: "dialog-element",
        role: "document",
        ref: _this.saveRef('dialog'),
        style: style,
        className: prefixCls + ' ' + (props.className || ''),
        visible: props.visible,
        forceRender: props.forceRender,
        onMouseDown: _this.onDialogMouseDown
      }, createElement("div", {
        tabIndex: 0,
        ref: _this.saveRef('sentinelStart'),
        style: sentinelStyle,
        "aria-hidden": "true"
      }), createElement("div", {
        className: prefixCls + '-content'
      }, closer, header, createElement("div", _extends$1({
        className: prefixCls + '-body',
        style: props.bodyStyle,
        ref: _this.saveRef('body')
      }, props.bodyProps), props.children), footer), createElement("div", {
        tabIndex: 0,
        ref: _this.saveRef('sentinelEnd'),
        style: sentinelStyle,
        "aria-hidden": "true"
      }));
      return createElement(Animate$1, {
        key: "dialog",
        showProp: "visible",
        onLeave: _this.onAnimateLeave,
        transitionName: transitionName,
        component: "",
        transitionAppear: true
      }, props.visible || !props.destroyOnClose ? dialogElement : null);
    };

    _this.getZIndexStyle = function () {
      var style = {};
      var props = _this.props;

      if (props.zIndex !== undefined) {
        style.zIndex = props.zIndex;
      }

      return style;
    };

    _this.getWrapStyle = function () {
      return _extends$1({}, _this.getZIndexStyle(), _this.props.wrapStyle);
    };

    _this.getMaskStyle = function () {
      return _extends$1({}, _this.getZIndexStyle(), _this.props.maskStyle);
    };

    _this.getMaskElement = function () {
      var props = _this.props;
      var maskElement = void 0;

      if (props.mask) {
        var maskTransition = _this.getMaskTransitionName();

        maskElement = createElement(LazyRenderBox, _extends$1({
          style: _this.getMaskStyle(),
          key: "mask",
          className: props.prefixCls + '-mask',
          hiddenClassName: props.prefixCls + '-mask-hidden',
          visible: props.visible
        }, props.maskProps));

        if (maskTransition) {
          maskElement = createElement(Animate$1, {
            key: "mask",
            showProp: "visible",
            transitionAppear: true,
            component: "",
            transitionName: maskTransition
          }, maskElement);
        }
      }

      return maskElement;
    };

    _this.getMaskTransitionName = function () {
      var props = _this.props;
      var transitionName = props.maskTransitionName;
      var animation = props.maskAnimation;

      if (!transitionName && animation) {
        transitionName = props.prefixCls + '-' + animation;
      }

      return transitionName;
    };

    _this.getTransitionName = function () {
      var props = _this.props;
      var transitionName = props.transitionName;
      var animation = props.animation;

      if (!transitionName && animation) {
        transitionName = props.prefixCls + '-' + animation;
      }

      return transitionName;
    };

    _this.switchScrollingEffect = function () {
      var getOpenCount = _this.props.getOpenCount;
      var openCount = getOpenCount();

      if (openCount === 1) {
        if (cacheOverflow.hasOwnProperty('overflowX')) {
          return;
        }

        cacheOverflow = {
          overflowX: document.body.style.overflowX,
          overflowY: document.body.style.overflowY,
          overflow: document.body.style.overflow
        };
        switchScrollingEffect(); // Must be set after switchScrollingEffect

        document.body.style.overflow = 'hidden';
      } else if (!openCount) {
        // IE browser doesn't merge overflow style, need to set it separately
        // https://github.com/ant-design/ant-design/issues/19393
        if (cacheOverflow.overflow !== undefined) {
          document.body.style.overflow = cacheOverflow.overflow;
        }

        if (cacheOverflow.overflowX !== undefined) {
          document.body.style.overflowX = cacheOverflow.overflowX;
        }

        if (cacheOverflow.overflowY !== undefined) {
          document.body.style.overflowY = cacheOverflow.overflowY;
        }

        cacheOverflow = {};
        switchScrollingEffect(true);
      }
    };

    _this.close = function (e) {
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose(e);
      }
    };

    _this.saveRef = function (name) {
      return function (node) {
        _this[name] = node;
      };
    };

    _this.titleId = 'rcDialogTitle' + uuid++;
    return _this;
  }

  Dialog.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}); // if forceRender is true, set element style display to be none;

    if ((this.props.forceRender || this.props.getContainer === false && !this.props.visible) && this.wrap) {
      this.wrap.style.display = 'none';
    }
  };

  Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props = this.props,
        visible = _props.visible,
        mask = _props.mask,
        focusTriggerAfterClose = _props.focusTriggerAfterClose;
    var mousePosition = this.props.mousePosition;

    if (visible) {
      // first show
      if (!prevProps.visible) {
        this.openTime = Date.now();
        this.switchScrollingEffect();
        this.tryFocus();
        var dialogNode = findDOMNode(this.dialog);

        if (mousePosition) {
          var elOffset = offset(dialogNode);
          setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
        } else {
          setTransformOrigin(dialogNode, '');
        }
      }
    } else if (prevProps.visible) {
      this.inTransition = true;

      if (mask && this.lastOutSideFocusNode && focusTriggerAfterClose) {
        try {
          this.lastOutSideFocusNode.focus();
        } catch (e) {
          this.lastOutSideFocusNode = null;
        }

        this.lastOutSideFocusNode = null;
      }
    }
  };

  Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        visible = _props2.visible,
        getOpenCount = _props2.getOpenCount;

    if ((visible || this.inTransition) && !getOpenCount()) {
      this.switchScrollingEffect();
    }

    clearTimeout(this.timeoutId);
  };

  Dialog.prototype.tryFocus = function tryFocus() {
    if (!contains(this.wrap, document.activeElement)) {
      this.lastOutSideFocusNode = document.activeElement;
      this.sentinelStart.focus();
    }
  };

  Dialog.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.prefixCls,
        maskClosable = props.maskClosable;
    var style = this.getWrapStyle(); // clear hide display
    // and only set display after async anim, not here for hide

    if (props.visible) {
      style.display = null;
    }

    return createElement("div", {
      className: prefixCls + '-root'
    }, this.getMaskElement(), createElement("div", _extends$1({
      tabIndex: -1,
      onKeyDown: this.onKeyDown,
      className: prefixCls + '-wrap ' + (props.wrapClassName || ''),
      ref: this.saveRef('wrap'),
      onClick: maskClosable ? this.onMaskClick : null,
      onMouseUp: maskClosable ? this.onMaskMouseUp : null,
      role: "dialog",
      "aria-labelledby": props.title ? this.titleId : null,
      style: style
    }, props.wrapProps), this.getDialogElement()));
  };

  return Dialog;
}(Component);

Dialog.defaultProps = {
  className: '',
  mask: true,
  visible: false,
  keyboard: true,
  closable: true,
  maskClosable: true,
  destroyOnClose: false,
  prefixCls: 'rc-dialog',
  focusTriggerAfterClose: true
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  } // Binding "this" is important for shallow renderer support.


  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
} // React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.


componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component$$1.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component$$1;
  } // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.


  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;

  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }

  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }

  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }

  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component$$1.displayName || Component$$1.name;
    var newApiName = typeof Component$$1.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  } // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.


  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  } // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.


  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component$$1;
}

var reactLifecyclesCompat_es =
/*#__PURE__*/
Object.freeze({
  polyfill: polyfill
});

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ContainerRender =
/*#__PURE__*/
function (_React$Component) {
  _inherits$2(ContainerRender, _React$Component);

  function ContainerRender() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$2(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$2(this, (_getPrototypeOf2 = _getPrototypeOf(ContainerRender)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.removeContainer = function () {
      if (_this.container) {
        ReactDOM__default.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        ReactDOM__default.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass$2(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(React__default.Component);

ContainerRender.propTypes = {
  autoMount: propTypes$1.bool,
  autoDestroy: propTypes$1.bool,
  visible: propTypes$1.bool,
  forceRender: propTypes$1.bool,
  parent: propTypes$1.any,
  getComponent: propTypes$1.func.isRequired,
  getContainer: propTypes$1.func.isRequired,
  children: propTypes$1.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$2(obj);
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$3(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$2(self);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

var Portal$2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits$3(Portal, _React$Component);

  function Portal() {
    _classCallCheck$3(this, Portal);

    return _possibleConstructorReturn$3(this, _getPrototypeOf$1(Portal).apply(this, arguments));
  }

  _createClass$3(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return ReactDOM__default.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(React__default.Component);

Portal$2.propTypes = {
  getContainer: propTypes$1.func.isRequired,
  children: propTypes$1.node.isRequired,
  didUpdate: propTypes$1.func
};

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof$3(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$3 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$3 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$3(obj);
}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$4(self, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$3(self);
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

var openCount = 0;
var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);
var IS_REACT_16 = 'createPortal' in ReactDOM__default; // https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332

var cacheOverflow$1 = {};

var PortalWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits$4(PortalWrapper, _React$Component);

  function PortalWrapper(props) {
    var _this;

    _classCallCheck$4(this, PortalWrapper);

    _this = _possibleConstructorReturn$4(this, _getPrototypeOf$2(PortalWrapper).call(this, props));

    _this.getParent = function () {
      var getContainer = _this.props.getContainer;

      if (getContainer) {
        if (typeof getContainer === 'string') {
          return document.querySelectorAll(getContainer)[0];
        }

        if (typeof getContainer === 'function') {
          return getContainer();
        }

        if (_typeof$3(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
          return getContainer;
        }
      }

      return document.body;
    };

    _this.getContainer = function () {
      if (windowIsUndefined) {
        return null;
      }

      if (!_this.container) {
        _this.container = document.createElement('div');

        var parent = _this.getParent();

        if (parent) {
          parent.appendChild(_this.container);
        }
      }

      _this.setWrapperClassName();

      return _this.container;
    };

    _this.setWrapperClassName = function () {
      var wrapperClassName = _this.props.wrapperClassName;

      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
        _this.container.className = wrapperClassName;
      }
    };

    _this.savePortal = function (c) {
      // Warning: don't rename _component
      // https://github.com/react-component/util/pull/65#discussion_r352407916
      _this._component = c;
    };

    _this.removeCurrentContainer = function (visible) {
      _this.container = null;
      _this._component = null;

      if (!IS_REACT_16) {
        if (visible) {
          _this.renderComponent({
            afterClose: _this.removeContainer,
            onClose: function onClose() {},
            visible: false
          });
        } else {
          _this.removeContainer();
        }
      }
    };

    _this.switchScrollingEffect = function () {
      if (openCount === 1 && !Object.keys(cacheOverflow$1).length) {
        switchScrollingEffect(); // Must be set after switchScrollingEffect

        cacheOverflow$1 = setStyle({
          overflow: 'hidden',
          overflowX: 'hidden',
          overflowY: 'hidden'
        });
      } else if (!openCount) {
        setStyle(cacheOverflow$1);
        cacheOverflow$1 = {};
        switchScrollingEffect(true);
      }
    };

    var _visible = props.visible;
    openCount = _visible ? openCount + 1 : openCount;
    _this.state = {
      _self: _assertThisInitialized$3(_this)
    };
    return _this;
  }

  _createClass$4(PortalWrapper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setWrapperClassName();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var visible = this.props.visible; // 离开时不会 render， 导到离开时数值不变，改用 func 。。

      openCount = visible && openCount ? openCount - 1 : openCount;
      this.removeCurrentContainer(visible);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          forceRender = _this$props.forceRender,
          visible = _this$props.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount() {
          return openCount;
        },
        getContainer: this.getContainer,
        switchScrollingEffect: this.switchScrollingEffect
      }; // suppport react15

      if (!IS_REACT_16) {
        return React__default.createElement(ContainerRender, {
          parent: this,
          visible: visible,
          autoDestroy: false,
          getComponent: function getComponent() {
            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return children(_objectSpread$1({}, extra, {}, childProps, {
              ref: _this2.savePortal
            }));
          },
          getContainer: this.getContainer,
          forceRender: forceRender
        }, function (_ref) {
          var renderComponent = _ref.renderComponent,
              removeContainer = _ref.removeContainer;
          _this2.renderComponent = renderComponent;
          _this2.removeContainer = removeContainer;
          return null;
        });
      }

      if (forceRender || visible || this._component) {
        portal = React__default.createElement(Portal$2, {
          getContainer: this.getContainer,
          ref: this.savePortal
        }, children(childProps));
      }

      return portal;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevProps = _ref2.prevProps,
          _self = _ref2._self;
      var visible = props.visible,
          getContainer = props.getContainer;

      if (prevProps) {
        var prevVisible = prevProps.visible,
            prevGetContainer = prevProps.getContainer;

        if (visible !== prevVisible) {
          openCount = visible && !prevVisible ? openCount + 1 : openCount - 1;
        }

        var getContainerIsFunc = typeof getContainer === 'function' && typeof prevGetContainer === 'function';

        if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
          _self.removeCurrentContainer(false);
        }
      }

      return {
        prevProps: props
      };
    }
  }]);

  return PortalWrapper;
}(React__default.Component);

PortalWrapper.propTypes = {
  wrapperClassName: propTypes$1.string,
  forceRender: propTypes$1.bool,
  getContainer: propTypes$1.any,
  children: propTypes$1.func,
  visible: propTypes$1.bool
};
var Portal$3 = polyfill(PortalWrapper); // fix issue #10656

/*
* getContainer remarks
* Custom container should not be return, because in the Portal component, it will remove the
* return container element here, if the custom container is the only child of it's component,
* like issue #10656, It will has a conflict with removeChild method in react-dom.
* So here should add a child (div element) to custom container.
* */

var require$$1 = function require$$1(props) {
  var visible = props.visible,
      getContainer = props.getContainer,
      forceRender = props.forceRender; // 渲染在当前 dom 里；

  if (getContainer === false) {
    return createElement(Dialog, _extends$1({}, props, {
      getOpenCount: function getOpenCount() {
        return 2;
      }
    }));
  }

  return createElement(Portal$3, {
    visible: visible,
    forceRender: forceRender,
    getContainer: getContainer
  }, function (childProps) {
    return createElement(Dialog, _extends$1({}, props, childProps));
  });
};

var EventBaseObject_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function returnFalse() {
    return false;
  }

  function returnTrue() {
    return true;
  }

  function EventBaseObject() {
    this.timeStamp = Date.now();
    this.target = undefined;
    this.currentTarget = undefined;
  }

  EventBaseObject.prototype = {
    isEventObject: 1,
    constructor: EventBaseObject,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    preventDefault: function preventDefault() {
      this.isDefaultPrevented = returnTrue;
    },
    stopPropagation: function stopPropagation() {
      this.isPropagationStopped = returnTrue;
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      this.isImmediatePropagationStopped = returnTrue; // fixed 1.2
      // call stopPropagation implicitly

      this.stopPropagation();
    },
    halt: function halt(immediate) {
      if (immediate) {
        this.stopImmediatePropagation();
      } else {
        this.stopPropagation();
      }

      this.preventDefault();
    }
  };
  exports["default"] = EventBaseObject;
  module.exports = exports["default"];
});
unwrapExports(EventBaseObject_1);
var EventObject = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var _EventBaseObject2 = _interopRequireDefault(EventBaseObject_1);

  var _objectAssign2 = _interopRequireDefault(objectAssign);

  var TRUE = true;
  var FALSE = false;
  var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

  function isNullOrUndefined(w) {
    return w === null || w === undefined;
  }

  var eventNormalizers = [{
    reg: /^key/,
    props: ['char', 'charCode', 'key', 'keyCode', 'which'],
    fix: function fix(event, nativeEvent) {
      if (isNullOrUndefined(event.which)) {
        event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
      } // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)


      if (event.metaKey === undefined) {
        event.metaKey = event.ctrlKey;
      }
    }
  }, {
    reg: /^touch/,
    props: ['touches', 'changedTouches', 'targetTouches']
  }, {
    reg: /^hashchange$/,
    props: ['newURL', 'oldURL']
  }, {
    reg: /^gesturechange$/i,
    props: ['rotation', 'scale']
  }, {
    reg: /^(mousewheel|DOMMouseScroll)$/,
    props: [],
    fix: function fix(event, nativeEvent) {
      var deltaX = undefined;
      var deltaY = undefined;
      var delta = undefined;
      var wheelDelta = nativeEvent.wheelDelta;
      var axis = nativeEvent.axis;
      var wheelDeltaY = nativeEvent.wheelDeltaY;
      var wheelDeltaX = nativeEvent.wheelDeltaX;
      var detail = nativeEvent.detail; // ie/webkit

      if (wheelDelta) {
        delta = wheelDelta / 120;
      } // gecko


      if (detail) {
        // press control e.detail == 1 else e.detail == 3
        delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
      } // Gecko


      if (axis !== undefined) {
        if (axis === event.HORIZONTAL_AXIS) {
          deltaY = 0;
          deltaX = 0 - delta;
        } else if (axis === event.VERTICAL_AXIS) {
          deltaX = 0;
          deltaY = delta;
        }
      } // Webkit


      if (wheelDeltaY !== undefined) {
        deltaY = wheelDeltaY / 120;
      }

      if (wheelDeltaX !== undefined) {
        deltaX = -1 * wheelDeltaX / 120;
      } // 默认 deltaY (ie)


      if (!deltaX && !deltaY) {
        deltaY = delta;
      }

      if (deltaX !== undefined) {
        /**
         * deltaX of mousewheel event
         * @property deltaX
         * @member Event.DomEvent.Object
         */
        event.deltaX = deltaX;
      }

      if (deltaY !== undefined) {
        /**
         * deltaY of mousewheel event
         * @property deltaY
         * @member Event.DomEvent.Object
         */
        event.deltaY = deltaY;
      }

      if (delta !== undefined) {
        /**
         * delta of mousewheel event
         * @property delta
         * @member Event.DomEvent.Object
         */
        event.delta = delta;
      }
    }
  }, {
    reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
    props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
    fix: function fix(event, nativeEvent) {
      var eventDoc = undefined;
      var doc = undefined;
      var body = undefined;
      var target = event.target;
      var button = nativeEvent.button; // Calculate pageX/Y if missing and clientX/Y available

      if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
        eventDoc = target.ownerDocument || document;
        doc = eventDoc.documentElement;
        body = eventDoc.body;
        event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
        event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
      } // which for click: 1 === left; 2 === middle; 3 === right
      // do not use button


      if (!event.which && button !== undefined) {
        if (button & 1) {
          event.which = 1;
        } else if (button & 2) {
          event.which = 3;
        } else if (button & 4) {
          event.which = 2;
        } else {
          event.which = 0;
        }
      } // add relatedTarget, if necessary


      if (!event.relatedTarget && event.fromElement) {
        event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
      }

      return event;
    }
  }];

  function retTrue() {
    return TRUE;
  }

  function retFalse() {
    return FALSE;
  }

  function DomEventObject(nativeEvent) {
    var type = nativeEvent.type;
    var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

    _EventBaseObject2['default'].call(this);

    this.nativeEvent = nativeEvent; // in case dom event has been mark as default prevented by lower dom node

    var isDefaultPrevented = retFalse;

    if ('defaultPrevented' in nativeEvent) {
      isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
    } else if ('getPreventDefault' in nativeEvent) {
      // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
      isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
    } else if ('returnValue' in nativeEvent) {
      isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
    }

    this.isDefaultPrevented = isDefaultPrevented;
    var fixFns = [];
    var fixFn = undefined;
    var l = undefined;
    var prop = undefined;
    var props = commonProps.concat();
    eventNormalizers.forEach(function (normalizer) {
      if (type.match(normalizer.reg)) {
        props = props.concat(normalizer.props);

        if (normalizer.fix) {
          fixFns.push(normalizer.fix);
        }
      }
    });
    l = props.length; // clone properties of the original event object

    while (l) {
      prop = props[--l];
      this[prop] = nativeEvent[prop];
    } // fix target property, if necessary


    if (!this.target && isNative) {
      this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
    } // check if target is a text node (safari)


    if (this.target && this.target.nodeType === 3) {
      this.target = this.target.parentNode;
    }

    l = fixFns.length;

    while (l) {
      fixFn = fixFns[--l];
      fixFn(this, nativeEvent);
    }

    this.timeStamp = nativeEvent.timeStamp || Date.now();
  }

  var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
  (0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
    constructor: DomEventObject,
    preventDefault: function preventDefault() {
      var e = this.nativeEvent; // if preventDefault exists run it on the original event

      if (e.preventDefault) {
        e.preventDefault();
      } else {
        // otherwise set the returnValue property of the original event to FALSE (IE)
        e.returnValue = FALSE;
      }

      EventBaseObjectProto.preventDefault.call(this);
    },
    stopPropagation: function stopPropagation() {
      var e = this.nativeEvent; // if stopPropagation exists run it on the original event

      if (e.stopPropagation) {
        e.stopPropagation();
      } else {
        // otherwise set the cancelBubble property of the original event to TRUE (IE)
        e.cancelBubble = TRUE;
      }

      EventBaseObjectProto.stopPropagation.call(this);
    }
  });
  exports['default'] = DomEventObject;
  module.exports = exports['default'];
});
unwrapExports(EventObject);
var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports['default'] = addEventListener;

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var _EventObject2 = _interopRequireDefault(EventObject);

  function addEventListener(target, eventType, callback, option) {
    function wrapCallback(e) {
      var ne = new _EventObject2['default'](e);
      callback.call(target, ne);
    }

    if (target.addEventListener) {
      var _ret = function () {
        var useCapture = false;

        if (typeof option === 'object') {
          useCapture = option.capture || false;
        } else if (typeof option === 'boolean') {
          useCapture = option;
        }

        target.addEventListener(eventType, wrapCallback, option || false);
        return {
          v: {
            remove: function remove() {
              target.removeEventListener(eventType, wrapCallback, useCapture);
            }
          }
        };
      }();

      if (typeof _ret === 'object') return _ret.v;
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, wrapCallback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, wrapCallback);
        }
      };
    }
  }

  module.exports = exports['default'];
});
unwrapExports(lib);
var addEventListener$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addEventListenerWrap;

  var _addDomEventListener = _interopRequireDefault(lib);

  var _reactDom = _interopRequireDefault(ReactDOM__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function addEventListenerWrap(target, eventType, cb, option) {
    /* eslint camelcase: 2 */
    var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
      _reactDom.default.unstable_batchedUpdates(cb, e);
    } : cb;
    return (0, _addDomEventListener.default)(target, eventType, callback, option);
  }
});
unwrapExports(addEventListener$2);
var en_US = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = {
    // Options.jsx
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: '',
    // Pagination.jsx
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages'
  };
  module.exports = exports['default'];
});
unwrapExports(en_US);
var en_US$2 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports['default'] = {
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'Ok',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    yearFormat: 'YYYY',
    dateFormat: 'M/D/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    monthBeforeYear: true,
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
  };
  module.exports = exports['default'];
});
unwrapExports(en_US$2);
var en_US$4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var locale = {
    placeholder: 'Select time'
  };
  var _default = locale;
  exports["default"] = _default;
});
unwrapExports(en_US$4);
var en_US$6 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _en_US = _interopRequireDefault(en_US$2);

  var _en_US2 = _interopRequireDefault(en_US$4);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  } // Merge into a locale object


  var locale = {
    lang: _extends({
      placeholder: 'Select date',
      rangePlaceholder: ['Start date', 'End date']
    }, _en_US["default"]),
    timePickerLocale: _extends({}, _en_US2["default"])
  }; // All settings at:
  // https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

  var _default = locale;
  exports["default"] = _default;
});
unwrapExports(en_US$6);
var en_US$8 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _en_US = _interopRequireDefault(en_US$6);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _en_US["default"];
  exports["default"] = _default;
});
unwrapExports(en_US$8);

var _default_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _en_US = _interopRequireDefault(en_US);

  var _en_US2 = _interopRequireDefault(en_US$6);

  var _en_US3 = _interopRequireDefault(en_US$4);

  var _en_US4 = _interopRequireDefault(en_US$8);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = {
    locale: 'en',
    Pagination: _en_US["default"],
    DatePicker: _en_US2["default"],
    TimePicker: _en_US3["default"],
    Calendar: _en_US4["default"],
    global: {
      placeholder: 'Please select'
    },
    Table: {
      filterTitle: 'Filter menu',
      filterConfirm: 'OK',
      filterReset: 'Reset',
      selectAll: 'Select current page',
      selectInvert: 'Invert current page',
      sortTitle: 'Sort',
      expand: 'Expand row',
      collapse: 'Collapse row'
    },
    Modal: {
      okText: 'OK',
      cancelText: 'Cancel',
      justOkText: 'OK'
    },
    Popconfirm: {
      okText: 'OK',
      cancelText: 'Cancel'
    },
    Transfer: {
      titles: ['', ''],
      searchPlaceholder: 'Search here',
      itemUnit: 'item',
      itemsUnit: 'items'
    },
    Upload: {
      uploading: 'Uploading...',
      removeFile: 'Remove file',
      uploadError: 'Upload error',
      previewFile: 'Preview file'
    },
    Empty: {
      description: 'No Data'
    },
    Icon: {
      icon: 'icon'
    },
    Text: {
      edit: 'edit',
      copy: 'copy',
      copied: 'copy success',
      expand: 'expand'
    },
    PageHeader: {
      back: 'back'
    }
  };
  exports["default"] = _default;
});

unwrapExports(_default_1);
var locale = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.changeConfirmLocale = changeConfirmLocale;
  exports.getConfirmLocale = getConfirmLocale;

  var _default = _interopRequireDefault(_default_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var runtimeLocale = _extends({}, _default["default"].Modal);

  function changeConfirmLocale(newLocale) {
    if (newLocale) {
      runtimeLocale = _extends({}, runtimeLocale, newLocale);
    } else {
      runtimeLocale = _extends({}, _default["default"].Modal);
    }
  }

  function getConfirmLocale() {
    return runtimeLocale;
  }
});
unwrapExports(locale);
var locale_1 = locale.changeConfirmLocale;
var locale_2 = locale.getConfirmLocale;
var dist = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var normalViewBox = '0 0 1024 1024';
  var newViewBox = '64 64 896 896';
  var fill = 'fill';
  var outline = 'outline';
  var twotone = 'twotone';

  function getNode(viewBox) {
    var paths = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      paths[_i - 1] = arguments[_i];
    }

    return {
      tag: 'svg',
      attrs: {
        viewBox: viewBox,
        focusable: false
      },
      children: paths.map(function (path) {
        if (Array.isArray(path)) {
          return {
            tag: 'path',
            attrs: {
              fill: path[0],
              d: path[1]
            }
          };
        }

        return {
          tag: 'path',
          attrs: {
            d: path
          }
        };
      })
    };
  }

  function getIcon(name, theme, icon) {
    return {
      name: name,
      theme: theme,
      icon: icon
    };
  }

  exports.AccountBookFill = getIcon('account-book', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
  exports.AlertFill = getIcon('alert', fill, getNode(newViewBox, 'M512 244c176.18 0 319 142.82 319 319v233a32 32 0 0 1-32 32H225a32 32 0 0 1-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 0 1 8 8v96a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V76a8 8 0 0 1 8-8zM177.25 191.66a8 8 0 0 1 11.32 0l67.88 67.88a8 8 0 0 1 0 11.31l-39.6 39.6a8 8 0 0 1-11.31 0l-67.88-67.88a8 8 0 0 1 0-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 0 1 0 11.3l-67.88 67.9a8 8 0 0 1-11.32 0l-39.6-39.6a8 8 0 0 1 0-11.32l67.89-67.88a8 8 0 0 1 11.31 0zM192 892h640a32 32 0 0 1 32 32v24a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-24a32 32 0 0 1 32-32zm148-317v253h64V575h-64z'));
  exports.AlipaySquareFill = getIcon('alipay-square', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z'));
  exports.AliwangwangFill = getIcon('aliwangwang', fill, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z'));
  exports.AlipayCircleFill = getIcon('alipay-circle', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
  exports.AmazonCircleFill = getIcon('amazon-circle', fill, getNode(newViewBox, 'M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z'));
  exports.AndroidFill = getIcon('android', fill, getNode(newViewBox, 'M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm208.4 0a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z'));
  exports.AmazonSquareFill = getIcon('amazon-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z'));
  exports.ApiFill = getIcon('api', fill, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z'));
  exports.AppstoreFill = getIcon('appstore', fill, getNode(newViewBox, 'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z'));
  exports.AudioFill = getIcon('audio', fill, getNode(newViewBox, 'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'));
  exports.AppleFill = getIcon('apple', fill, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
  exports.BackwardFill = getIcon('backward', fill, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
  exports.BankFill = getIcon('bank', fill, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z'));
  exports.BehanceCircleFill = getIcon('behance-circle', fill, getNode(newViewBox, 'M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0 0 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z'));
  exports.BellFill = getIcon('bell', fill, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z'));
  exports.BehanceSquareFill = getIcon('behance-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
  exports.BookFill = getIcon('book', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z'));
  exports.BoxPlotFill = getIcon('box-plot', fill, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z'));
  exports.BugFill = getIcon('bug', fill, getNode(newViewBox, 'M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 0 0 123.2-149.5A120.4 120.4 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.CalculatorFill = getIcon('calculator', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z'));
  exports.BulbFill = getIcon('bulb', fill, getNode(newViewBox, 'M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z'));
  exports.BuildFill = getIcon('build', fill, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z'));
  exports.CalendarFill = getIcon('calendar', fill, getNode(newViewBox, 'M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z'));
  exports.CameraFill = getIcon('camera', fill, getNode(newViewBox, 'M864 260H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0z'));
  exports.CarFill = getIcon('car', fill, getNode(newViewBox, 'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z'));
  exports.CaretDownFill = getIcon('caret-down', fill, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
  exports.CaretLeftFill = getIcon('caret-left', fill, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
  exports.CaretRightFill = getIcon('caret-right', fill, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
  exports.CarryOutFill = getIcon('carry-out', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
  exports.CaretUpFill = getIcon('caret-up', fill, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
  exports.CheckCircleFill = getIcon('check-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z'));
  exports.CheckSquareFill = getIcon('check-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z'));
  exports.ChromeFill = getIcon('chrome', fill, getNode(newViewBox, 'M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0 0 96 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z'));
  exports.CiCircleFill = getIcon('ci-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'));
  exports.ClockCircleFill = getIcon('clock-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'));
  exports.CloseCircleFill = getIcon('close-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z'));
  exports.CloudFill = getIcon('cloud', fill, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z'));
  exports.CloseSquareFill = getIcon('close-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z'));
  exports.CodeSandboxSquareFill = getIcon('code-sandbox-square', fill, getNode(newViewBox, 'M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z'));
  exports.CodeSandboxCircleFill = getIcon('code-sandbox-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z'));
  exports.CodeFill = getIcon('code', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z'));
  exports.CompassFill = getIcon('compass', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'));
  exports.CodepenCircleFill = getIcon('codepen-circle', fill, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
  exports.CodepenSquareFill = getIcon('codepen-square', fill, getNode(newViewBox, 'M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z'));
  exports.ContactsFill = getIcon('contacts', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z'));
  exports.ControlFill = getIcon('control', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z'));
  exports.ContainerFill = getIcon('container', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z'));
  exports.CopyFill = getIcon('copy', fill, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z'));
  exports.CopyrightCircleFill = getIcon('copyright-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z'));
  exports.CreditCardFill = getIcon('credit-card', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z'));
  exports.CrownFill = getIcon('crown', fill, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z'));
  exports.CustomerServiceFill = getIcon('customer-service', fill, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z'));
  exports.DashboardFill = getIcon('dashboard', fill, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 0 1-11.3 0L261.7 352a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z'));
  exports.DeleteFill = getIcon('delete', fill, getNode(newViewBox, 'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z'));
  exports.DiffFill = getIcon('diff', fill, getNode(newViewBox, 'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z'));
  exports.DingtalkCircleFill = getIcon('dingtalk-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
  exports.DatabaseFill = getIcon('database', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'));
  exports.DingtalkSquareFill = getIcon('dingtalk-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
  exports.DislikeFill = getIcon('dislike', fill, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z'));
  exports.DollarCircleFill = getIcon('dollar-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'));
  exports.DownCircleFill = getIcon('down-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
  exports.DownSquareFill = getIcon('down-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
  exports.DribbbleCircleFill = getIcon('dribbble-circle', fill, getNode(newViewBox, 'M675.1 328.3a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z'));
  exports.DribbbleSquareFill = getIcon('dribbble-square', fill, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
  exports.DropboxCircleFill = getIcon('dropbox-circle', fill, getNode(newViewBox, 'M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z'));
  exports.DropboxSquareFill = getIcon('dropbox-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z'));
  exports.EnvironmentFill = getIcon('environment', fill, getNode(newViewBox, 'M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 0 0 400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 0 0 512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
  exports.EditFill = getIcon('edit', fill, getNode(newViewBox, 'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z'));
  exports.ExclamationCircleFill = getIcon('exclamation-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
  exports.EuroCircleFill = getIcon('euro-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z'));
  exports.ExperimentFill = getIcon('experiment', fill, getNode(newViewBox, 'M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0 0 94.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 0 1 164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0 0 36.6-82.5z'));
  exports.EyeInvisibleFill = getIcon('eye-invisible', fill, getNode(newViewBox, 'M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z', 'M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'));
  exports.EyeFill = getIcon('eye', fill, getNode(newViewBox, 'M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
  exports.FacebookFill = getIcon('facebook', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z'));
  exports.FastBackwardFill = getIcon('fast-backward', fill, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
  exports.FastForwardFill = getIcon('fast-forward', fill, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
  exports.FileAddFill = getIcon('file-add', fill, getNode(newViewBox, 'M480 580H372a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V644h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H544V472a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
  exports.FileExcelFill = getIcon('file-excel', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 0 0-10.27-5.79h-38.44a12 12 0 0 0-6.4 1.85 12 12 0 0 0-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 0 0-1.84 6.39 12 12 0 0 0 12 12h34.46a12 12 0 0 0 10.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0 0 10.23 5.72h37.48a12 12 0 0 0 6.48-1.9 12 12 0 0 0 3.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 0 0 1.9-6.5 12 12 0 0 0-12-12h-35.7a12 12 0 0 0-10.29 5.84z'));
  exports.FileExclamationFill = getIcon('file-exclamation', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm32-152V448a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8z'));
  exports.FileImageFill = getIcon('file-image', fill, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z'));
  exports.FileMarkdownFill = getIcon('file-markdown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0 0 14.62 9.5h24.06a16 16 0 0 0 14.63-9.51l59.1-133.35V758a16 16 0 0 0 16.01 16H641a16 16 0 0 0 16-16V486a16 16 0 0 0-16-16h-34.75a16 16 0 0 0-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 0 0-14.67-9.61H383a16 16 0 0 0-16 16v272a16 16 0 0 0 16 16h27.13a16 16 0 0 0 16-16V600.93z'));
  exports.FilePdfFill = getIcon('file-pdf', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 0 1 5.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 0 1-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 0 1-1.12-.15 2.07 2.07 0 0 1-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 0 1-1.36 6.31 6.7 6.7 0 0 1-2.17 1.28z'));
  exports.FilePptFill = getIcon('file-ppt', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 0 0-12 12v276a12 12 0 0 0 12 12h32.53a12 12 0 0 0 12-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z'));
  exports.FileTextFill = getIcon('file-text', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z'));
  exports.FileWordFill = getIcon('file-word', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0 0 11.6 8.9h31.77a12 12 0 0 0 11.6-8.88l74.37-276a12 12 0 0 0 .4-3.12 12 12 0 0 0-12-12h-35.57a12 12 0 0 0-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 0 0 528.1 472h-32.2a12 12 0 0 0-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 0 0-11.68-9.29h-35.39a12 12 0 0 0-3.11.41 12 12 0 0 0-8.47 14.7l74.17 276A12 12 0 0 0 415.6 772h31.99a12 12 0 0 0 11.59-8.9l52.81-197z'));
  exports.FileUnknownFill = getIcon('file-unknown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z'));
  exports.FileZipFill = getIcon('file-zip', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z'));
  exports.FileFill = getIcon('file', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
  exports.FilterFill = getIcon('filter', fill, getNode(newViewBox, 'M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z'));
  exports.FireFill = getIcon('fire', fill, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9z'));
  exports.FlagFill = getIcon('flag', fill, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z'));
  exports.FolderAddFill = getIcon('folder-add', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z'));
  exports.FolderFill = getIcon('folder', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z'));
  exports.FolderOpenFill = getIcon('folder-open', fill, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z'));
  exports.ForwardFill = getIcon('forward', fill, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
  exports.FrownFill = getIcon('frown', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
  exports.FundFill = getIcon('fund', fill, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 0 1-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 0 1-11.3 0l-36.8-36.8a8.03 8.03 0 0 1 0-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z'));
  exports.FunnelPlotFill = getIcon('funnel-plot', fill, getNode(newViewBox, 'M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z'));
  exports.GiftFill = getIcon('gift', fill, getNode(newViewBox, 'M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z'));
  exports.GithubFill = getIcon('github', fill, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
  exports.GitlabFill = getIcon('gitlab', fill, getNode(newViewBox, 'M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z'));
  exports.GoldenFill = getIcon('golden', fill, getNode(newViewBox, 'M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z'));
  exports.GoogleCircleFill = getIcon('google-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
  exports.GooglePlusCircleFill = getIcon('google-plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
  exports.GooglePlusSquareFill = getIcon('google-plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
  exports.GoogleSquareFill = getIcon('google-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 0 1 272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
  exports.HddFill = getIcon('hdd', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z'));
  exports.HeartFill = getIcon('heart', fill, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z'));
  exports.HighlightFill = getIcon('highlight', fill, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z'));
  exports.HomeFill = getIcon('home', fill, getNode(newViewBox, 'M946.5 505L534.6 93.4a31.93 31.93 0 0 0-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z'));
  exports.HourglassFill = getIcon('hourglass', fill, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z'));
  exports.Html5Fill = getIcon('html5', fill, getNode(newViewBox, 'M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z'));
  exports.IdcardFill = getIcon('idcard', fill, getNode(newViewBox, 'M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z'));
  exports.IeCircleFill = getIcon('ie-circle', fill, getNode(newViewBox, 'M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
  exports.IeSquareFill = getIcon('ie-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
  exports.InfoCircleFill = getIcon('info-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
  exports.InstagramFill = getIcon('instagram', fill, getNode(newViewBox, 'M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z'));
  exports.InsuranceFill = getIcon('insurance', fill, getNode(newViewBox, 'M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 0 1-8.9-1.4L430 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z'));
  exports.InteractionFill = getIcon('interaction', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
  exports.InterationFill = getIcon('interation', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
  exports.LayoutFill = getIcon('layout', fill, getNode(newViewBox, 'M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z'));
  exports.LeftCircleFill = getIcon('left-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178a8 8 0 0 1 12.7 6.5v46.8z'));
  exports.LeftSquareFill = getIcon('left-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z'));
  exports.LikeFill = getIcon('like', fill, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z'));
  exports.LockFill = getIcon('lock', fill, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z'));
  exports.LinkedinFill = getIcon('linkedin', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z'));
  exports.MailFill = getIcon('mail', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z'));
  exports.MedicineBoxFill = getIcon('medicine-box', fill, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z'));
  exports.MediumCircleFill = getIcon('medium-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
  exports.MediumSquareFill = getIcon('medium-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
  exports.MehFill = getIcon('meh', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
  exports.MessageFill = getIcon('message', fill, getNode(newViewBox, 'M924.3 338.4a447.57 447.57 0 0 0-96.1-143.3 443.09 443.09 0 0 0-143-96.3A443.91 443.91 0 0 0 512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 0 0-141.7 96.5 445 445 0 0 0-95 142.8A449.89 449.89 0 0 0 65 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 0 0 199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 0 0 827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z'));
  exports.MinusCircleFill = getIcon('minus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
  exports.MinusSquareFill = getIcon('minus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
  exports.MobileFill = getIcon('mobile', fill, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
  exports.MoneyCollectFill = getIcon('money-collect', fill, getNode(newViewBox, 'M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z'));
  exports.PauseCircleFill = getIcon('pause-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'));
  exports.PayCircleFill = getIcon('pay-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 0 1 7-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 0 1 7.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z'));
  exports.NotificationFill = getIcon('notification', fill, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z'));
  exports.PhoneFill = getIcon('phone', fill, getNode(newViewBox, 'M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z'));
  exports.PictureFill = getIcon('picture', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 0 1-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z'));
  exports.PieChartFill = getIcon('pie-chart', fill, getNode(newViewBox, 'M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 0 0-282.5 117 397.47 397.47 0 0 0-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 0 0 155.6 31.5 398.57 398.57 0 0 0 282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0 0 31.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 0 0 588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z'));
  exports.PlayCircleFill = getIcon('play-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 0 1-12.7-6.5V353.7a8 8 0 0 1 12.7-6.5L656.1 506a7.9 7.9 0 0 1 0 12.9z'));
  exports.PlaySquareFill = getIcon('play-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6z'));
  exports.PlusCircleFill = getIcon('plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
  exports.PlusSquareFill = getIcon('plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
  exports.PoundCircleFill = getIcon('pound-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z'));
  exports.PrinterFill = getIcon('printer', fill, getNode(newViewBox, 'M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'));
  exports.ProfileFill = getIcon('profile', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z'));
  exports.ProjectFill = getIcon('project', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z'));
  exports.PushpinFill = getIcon('pushpin', fill, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z'));
  exports.PropertySafetyFill = getIcon('property-safety', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
  exports.QqCircleFill = getIcon('qq-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
  exports.QqSquareFill = getIcon('qq-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
  exports.QuestionCircleFill = getIcon('question-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'));
  exports.ReadFill = getIcon('read', fill, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z'));
  exports.ReconciliationFill = getIcon('reconciliation', fill, getNode(newViewBox, 'M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'));
  exports.RedEnvelopeFill = getIcon('red-envelope', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 0 1 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z'));
  exports.RedditCircleFill = getIcon('reddit-circle', fill, getNode(newViewBox, 'M584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm72 108a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
  exports.RedditSquareFill = getIcon('reddit-square', fill, getNode(newViewBox, 'M296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM368 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
  exports.RestFill = getIcon('rest', fill, getNode(newViewBox, 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0z'));
  exports.RightCircleFill = getIcon('right-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
  exports.RocketFill = getIcon('rocket', fill, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 0 1 0 96 48.01 48.01 0 0 1 0-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z'));
  exports.RightSquareFill = getIcon('right-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
  exports.SafetyCertificateFill = getIcon('safety-certificate', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
  exports.SaveFill = getIcon('save', fill, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z'));
  exports.ScheduleFill = getIcon('schedule', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z'));
  exports.SecurityScanFill = getIcon('security-scan', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 1 0 113.27-113.28 80.1 80.1 0 1 0-113.27 113.28z'));
  exports.SettingFill = getIcon('setting', fill, getNode(newViewBox, 'M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 0 0-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a442.5 442.5 0 0 0-79.6-137.7l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.3a353.44 353.44 0 0 0-98.9 57.3l-81.8-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a445.93 445.93 0 0 0-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0 0 25.8 25.7l2.7.5a448.27 448.27 0 0 0 158.8 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z'));
  exports.ShopFill = getIcon('shop', fill, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z'));
  exports.ShoppingFill = getIcon('shopping', fill, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z'));
  exports.SketchCircleFill = getIcon('sketch-circle', fill, getNode(newViewBox, 'M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z'));
  exports.SketchSquareFill = getIcon('sketch-square', fill, getNode(newViewBox, 'M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z'));
  exports.SkinFill = getIcon('skin', fill, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44z'));
  exports.SlackCircleFill = getIcon('slack-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
  exports.SlackSquareFill = getIcon('slack-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
  exports.SkypeFill = getIcon('skype', fill, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z'));
  exports.SlidersFill = getIcon('sliders', fill, getNode(newViewBox, 'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z'));
  exports.SmileFill = getIcon('smile', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
  exports.SnippetsFill = getIcon('snippets', fill, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
  exports.SoundFill = getIcon('sound', fill, getNode(newViewBox, 'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z'));
  exports.StarFill = getIcon('star', fill, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z'));
  exports.StepBackwardFill = getIcon('step-backward', fill, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
  exports.StepForwardFill = getIcon('step-forward', fill, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
  exports.StopFill = getIcon('stop', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z'));
  exports.SwitcherFill = getIcon('switcher', fill, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'));
  exports.TabletFill = getIcon('tablet', fill, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
  exports.TagFill = getIcon('tag', fill, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z'));
  exports.TagsFill = getIcon('tags', fill, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
  exports.TaobaoCircleFill = getIcon('taobao-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
  exports.TaobaoSquareFill = getIcon('taobao-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
  exports.ToolFill = getIcon('tool', fill, getNode(newViewBox, 'M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z'));
  exports.ThunderboltFill = getIcon('thunderbolt', fill, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z'));
  exports.TrademarkCircleFill = getIcon('trademark-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'));
  exports.TwitterCircleFill = getIcon('twitter-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
  exports.TrophyFill = getIcon('trophy', fill, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z'));
  exports.TwitterSquareFill = getIcon('twitter-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
  exports.UnlockFill = getIcon('unlock', fill, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z'));
  exports.UpCircleFill = getIcon('up-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
  exports.UpSquareFill = getIcon('up-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
  exports.UsbFill = getIcon('usb', fill, getNode(newViewBox, 'M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
  exports.WalletFill = getIcon('wallet', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.VideoCameraFill = getIcon('video-camera', fill, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z'));
  exports.WarningFill = getIcon('warning', fill, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
  exports.WeiboCircleFill = getIcon('weibo-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
  exports.WechatFill = getIcon('wechat', fill, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
  exports.WindowsFill = getIcon('windows', fill, getNode(newViewBox, 'M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z'));
  exports.YahooFill = getIcon('yahoo', fill, getNode(newViewBox, 'M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z'));
  exports.WeiboSquareFill = getIcon('weibo-square', fill, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
  exports.YuqueFill = getIcon('yuque', fill, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z'));
  exports.YoutubeFill = getIcon('youtube', fill, getNode(newViewBox, 'M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z'));
  exports.ZhihuSquareFill = getIcon('zhihu-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
  exports.ZhihuCircleFill = getIcon('zhihu-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
  exports.AccountBookOutline = getIcon('account-book', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'));
  exports.AlertOutline = getIcon('alert', outline, getNode(newViewBox, 'M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z'));
  exports.AlipayCircleOutline = getIcon('alipay-circle', outline, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
  exports.AliwangwangOutline = getIcon('aliwangwang', outline, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 0 1-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 0 1-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 0 1 217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z'));
  exports.AndroidOutline = getIcon('android', outline, getNode(newViewBox, 'M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z'));
  exports.ApiOutline = getIcon('api', outline, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z'));
  exports.AppstoreOutline = getIcon('appstore', outline, getNode(newViewBox, 'M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'));
  exports.AudioOutline = getIcon('audio', outline, getNode(newViewBox, 'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z'));
  exports.AppleOutline = getIcon('apple', outline, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
  exports.BackwardOutline = getIcon('backward', outline, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
  exports.BankOutline = getIcon('bank', outline, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z'));
  exports.BellOutline = getIcon('bell', outline, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z'));
  exports.BehanceSquareOutline = getIcon('behance-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
  exports.BookOutline = getIcon('book', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z'));
  exports.BoxPlotOutline = getIcon('box-plot', outline, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z'));
  exports.BulbOutline = getIcon('bulb', outline, getNode(newViewBox, 'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'));
  exports.BugOutline = getIcon('bug', outline, getNode(newViewBox, 'M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 0 0 123.2-149.5A120 120 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 0 1 308 680V412h408v268z'));
  exports.CalculatorOutline = getIcon('calculator', outline, getNode(newViewBox, 'M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z'));
  exports.BuildOutline = getIcon('build', outline, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z'));
  exports.CalendarOutline = getIcon('calendar', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z'));
  exports.CameraOutline = getIcon('camera', outline, getNode(newViewBox, 'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'));
  exports.CarOutline = getIcon('car', outline, getNode(newViewBox, 'M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.CaretDownOutline = getIcon('caret-down', outline, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
  exports.CaretLeftOutline = getIcon('caret-left', outline, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
  exports.CaretRightOutline = getIcon('caret-right', outline, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
  exports.CarryOutOutline = getIcon('carry-out', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'));
  exports.CheckCircleOutline = getIcon('check-circle', outline, getNode(newViewBox, 'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
  exports.CaretUpOutline = getIcon('caret-up', outline, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
  exports.CheckSquareOutline = getIcon('check-square', outline, getNode(newViewBox, 'M433.1 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.ChromeOutline = getIcon('chrome', outline, getNode(newViewBox, 'M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z'));
  exports.ClockCircleOutline = getIcon('clock-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z'));
  exports.CloseCircleOutline = getIcon('close-circle', outline, getNode(newViewBox, 'M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z', 'M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
  exports.CloudOutline = getIcon('cloud', outline, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'));
  exports.CloseSquareOutline = getIcon('close-square', outline, getNode(newViewBox, 'M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.CodeOutline = getIcon('code', outline, getNode(newViewBox, 'M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.CodepenCircleOutline = getIcon('codepen-circle', outline, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
  exports.CompassOutline = getIcon('compass', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 0 0-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 0 0-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z'));
  exports.ContactsOutline = getIcon('contacts', outline, getNode(newViewBox, 'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'));
  exports.ContainerOutline = getIcon('container', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
  exports.ControlOutline = getIcon('control', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z'));
  exports.CopyOutline = getIcon('copy', outline, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'));
  exports.CreditCardOutline = getIcon('credit-card', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'));
  exports.CrownOutline = getIcon('crown', outline, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z'));
  exports.CustomerServiceOutline = getIcon('customer-service', outline, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'));
  exports.DashboardOutline = getIcon('dashboard', outline, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'));
  exports.DeleteOutline = getIcon('delete', outline, getNode(newViewBox, 'M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z'));
  exports.DiffOutline = getIcon('diff', outline, getNode(newViewBox, 'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'));
  exports.DatabaseOutline = getIcon('database', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.DislikeOutline = getIcon('dislike', outline, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'));
  exports.DownCircleOutline = getIcon('down-circle', outline, getNode(newViewBox, 'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
  exports.DownSquareOutline = getIcon('down-square', outline, getNode(newViewBox, 'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.DribbbleSquareOutline = getIcon('dribbble-square', outline, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
  exports.EnvironmentOutline = getIcon('environment', outline, getNode(newViewBox, 'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'));
  exports.EditOutline = getIcon('edit', outline, getNode(newViewBox, 'M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z'));
  exports.ExclamationCircleOutline = getIcon('exclamation-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z'));
  exports.ExperimentOutline = getIcon('experiment', outline, getNode(newViewBox, 'M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z'));
  exports.EyeInvisibleOutline = getIcon('eye-invisible', outline, getNode(newViewBox, 'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z', 'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'));
  exports.EyeOutline = getIcon('eye', outline, getNode(newViewBox, 'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
  exports.FacebookOutline = getIcon('facebook', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z'));
  exports.FastBackwardOutline = getIcon('fast-backward', outline, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
  exports.FastForwardOutline = getIcon('fast-forward', outline, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
  exports.FileAddOutline = getIcon('file-add', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'));
  exports.FileExcelOutline = getIcon('file-excel', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'));
  exports.FileExclamationOutline = getIcon('file-exclamation', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM472 744a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z'));
  exports.FileImageOutline = getIcon('file-image', outline, getNode(newViewBox, 'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
  exports.FileMarkdownOutline = getIcon('file-markdown', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'));
  exports.FilePptOutline = getIcon('file-ppt', outline, getNode(newViewBox, 'M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
  exports.FileTextOutline = getIcon('file-text', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z'));
  exports.FilePdfOutline = getIcon('file-pdf', outline, getNode(newViewBox, 'M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
  exports.FileZipOutline = getIcon('file-zip', outline, getNode(newViewBox, 'M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'));
  exports.FileOutline = getIcon('file', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
  exports.FilterOutline = getIcon('filter', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'));
  exports.FileWordOutline = getIcon('file-word', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'));
  exports.FireOutline = getIcon('fire', outline, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'));
  exports.FileUnknownOutline = getIcon('file-unknown', outline, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1 0 64 0 32 32 0 1 0-64 0z'));
  exports.FlagOutline = getIcon('flag', outline, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'));
  exports.FolderAddOutline = getIcon('folder-add', outline, getNode(newViewBox, 'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
  exports.FolderOutline = getIcon('folder', outline, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
  exports.FolderOpenOutline = getIcon('folder-open', outline, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'));
  exports.ForwardOutline = getIcon('forward', outline, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
  exports.FrownOutline = getIcon('frown', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533z'));
  exports.FundOutline = getIcon('fund', outline, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L531 565 416.6 450.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'));
  exports.FunnelPlotOutline = getIcon('funnel-plot', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'));
  exports.GiftOutline = getIcon('gift', outline, getNode(newViewBox, 'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z'));
  exports.GithubOutline = getIcon('github', outline, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
  exports.GitlabOutline = getIcon('gitlab', outline, getNode(newViewBox, 'M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z'));
  exports.HeartOutline = getIcon('heart', outline, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'));
  exports.HddOutline = getIcon('hdd', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.HighlightOutline = getIcon('highlight', outline, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z'));
  exports.HomeOutline = getIcon('home', outline, getNode(newViewBox, 'M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'));
  exports.HourglassOutline = getIcon('hourglass', outline, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'));
  exports.Html5Outline = getIcon('html5', outline, getNode(newViewBox, 'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'));
  exports.IdcardOutline = getIcon('idcard', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'));
  exports.InfoCircleOutline = getIcon('info-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'));
  exports.InstagramOutline = getIcon('instagram', outline, getNode(newViewBox, 'M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z'));
  exports.InsuranceOutline = getIcon('insurance', outline, getNode(newViewBox, 'M441.6 306.8L403 288.6a6.1 6.1 0 0 0-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 0 0-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0 0 33.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'));
  exports.InteractionOutline = getIcon('interaction', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
  exports.InterationOutline = getIcon('interation', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
  exports.LayoutOutline = getIcon('layout', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z'));
  exports.LeftCircleOutline = getIcon('left-circle', outline, getNode(newViewBox, 'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
  exports.LeftSquareOutline = getIcon('left-square', outline, getNode(newViewBox, 'M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 0 0 0 13z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.LikeOutline = getIcon('like', outline, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z'));
  exports.LinkedinOutline = getIcon('linkedin', outline, getNode(newViewBox, 'M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 1 0-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z'));
  exports.LockOutline = getIcon('lock', outline, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
  exports.MedicineBoxOutline = getIcon('medicine-box', outline, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
  exports.MehOutline = getIcon('meh', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
  exports.MailOutline = getIcon('mail', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z'));
  exports.MessageOutline = getIcon('message', outline, getNode(newViewBox, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'));
  exports.MinusCircleOutline = getIcon('minus-circle', outline, getNode(newViewBox, 'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
  exports.MinusSquareOutline = getIcon('minus-square', outline, getNode(newViewBox, 'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.MobileOutline = getIcon('mobile', outline, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.MoneyCollectOutline = getIcon('money-collect', outline, getNode(newViewBox, 'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z'));
  exports.PauseCircleOutline = getIcon('pause-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'));
  exports.PayCircleOutline = getIcon('pay-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 0 0-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z'));
  exports.NotificationOutline = getIcon('notification', outline, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'));
  exports.PhoneOutline = getIcon('phone', outline, getNode(newViewBox, 'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'));
  exports.PictureOutline = getIcon('picture', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'));
  exports.PieChartOutline = getIcon('pie-chart', outline, getNode(newViewBox, 'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'));
  exports.PlaySquareOutline = getIcon('play-square', outline, getNode(newViewBox, 'M442.3 677.6l199.4-156.7a11.3 11.3 0 0 0 0-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.PlayCircleOutline = getIcon('play-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z'));
  exports.PlusCircleOutline = getIcon('plus-circle', outline, getNode(newViewBox, 'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
  exports.PrinterOutline = getIcon('printer', outline, getNode(newViewBox, 'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'));
  exports.PlusSquareOutline = getIcon('plus-square', outline, getNode(newViewBox, 'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.ProfileOutline = getIcon('profile', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.ProjectOutline = getIcon('project', outline, getNode(newViewBox, 'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.PushpinOutline = getIcon('pushpin', outline, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'));
  exports.PropertySafetyOutline = getIcon('property-safety', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 0 0-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 0 0-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z'));
  exports.QuestionCircleOutline = getIcon('question-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.ReadOutline = getIcon('read', outline, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z'));
  exports.ReconciliationOutline = getIcon('reconciliation', outline, getNode(newViewBox, 'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
  exports.RedEnvelopeOutline = getIcon('red-envelope', outline, getNode(newViewBox, 'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'));
  exports.RestOutline = getIcon('rest', outline, getNode(newViewBox, 'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z', 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'));
  exports.RightCircleOutline = getIcon('right-circle', outline, getNode(newViewBox, 'M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
  exports.RocketOutline = getIcon('rocket', outline, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0 1 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'));
  exports.RightSquareOutline = getIcon('right-square', outline, getNode(newViewBox, 'M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.SafetyCertificateOutline = getIcon('safety-certificate', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'));
  exports.ScheduleOutline = getIcon('schedule', outline, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z'));
  exports.SaveOutline = getIcon('save', outline, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'));
  exports.SecurityScanOutline = getIcon('security-scan', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z'));
  exports.SettingOutline = getIcon('setting', outline, getNode(newViewBox, 'M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z'));
  exports.ShoppingOutline = getIcon('shopping', outline, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'));
  exports.SkinOutline = getIcon('skin', outline, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'));
  exports.SkypeOutline = getIcon('skype', outline, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 0 1-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 0 1-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0 1 71.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z'));
  exports.SlackSquareOutline = getIcon('slack-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
  exports.SlidersOutline = getIcon('sliders', outline, getNode(newViewBox, 'M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74z'));
  exports.SmileOutline = getIcon('smile', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4z'));
  exports.SnippetsOutline = getIcon('snippets', outline, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
  exports.SoundOutline = getIcon('sound', outline, getNode(newViewBox, 'M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344z'));
  exports.StarOutline = getIcon('star', outline, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z'));
  exports.StepBackwardOutline = getIcon('step-backward', outline, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
  exports.StepForwardOutline = getIcon('step-forward', outline, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
  exports.StopOutline = getIcon('stop', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z'));
  exports.SwitcherOutline = getIcon('switcher', outline, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z'));
  exports.TagOutline = getIcon('tag', outline, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'));
  exports.TabletOutline = getIcon('tablet', outline, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.ShopOutline = getIcon('shop', outline, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'));
  exports.TagsOutline = getIcon('tags', outline, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1 0 67.88-67.89 48 48 0 1 0-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
  exports.TaobaoCircleOutline = getIcon('taobao-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
  exports.ToolOutline = getIcon('tool', outline, getNode(newViewBox, 'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'));
  exports.ThunderboltOutline = getIcon('thunderbolt', outline, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z'));
  exports.TrophyOutline = getIcon('trophy', outline, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM184 352V232h64v207.6a91.99 91.99 0 0 1-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'));
  exports.UnlockOutline = getIcon('unlock', outline, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
  exports.UpCircleOutline = getIcon('up-circle', outline, getNode(newViewBox, 'M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
  exports.UpSquareOutline = getIcon('up-square', outline, getNode(newViewBox, 'M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.UsbOutline = getIcon('usb', outline, getNode(newViewBox, 'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
  exports.VideoCameraOutline = getIcon('video-camera', outline, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
  exports.WalletOutline = getIcon('wallet', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.WarningOutline = getIcon('warning', outline, getNode(newViewBox, 'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'));
  exports.WechatOutline = getIcon('wechat', outline, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
  exports.WeiboCircleOutline = getIcon('weibo-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
  exports.WindowsOutline = getIcon('windows', outline, getNode(newViewBox, 'M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z'));
  exports.YahooOutline = getIcon('yahoo', outline, getNode(newViewBox, 'M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z'));
  exports.WeiboSquareOutline = getIcon('weibo-square', outline, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
  exports.YuqueOutline = getIcon('yuque', outline, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z'));
  exports.YoutubeOutline = getIcon('youtube', outline, getNode(newViewBox, 'M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z'));
  exports.AlibabaOutline = getIcon('alibaba', outline, getNode(newViewBox, 'M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z'));
  exports.AlignCenterOutline = getIcon('align-center', outline, getNode(newViewBox, 'M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.AlignLeftOutline = getIcon('align-left', outline, getNode(newViewBox, 'M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.AlignRightOutline = getIcon('align-right', outline, getNode(newViewBox, 'M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.AlipayOutline = getIcon('alipay', outline, getNode(newViewBox, 'M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 0 1-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z'));
  exports.AliyunOutline = getIcon('aliyun', outline, getNode(newViewBox, 'M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0 1 32.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 0 1-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 0 1-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z'));
  exports.AmazonOutline = getIcon('amazon', outline, getNode(newViewBox, 'M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 0 0-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z'));
  exports.AntCloudOutline = getIcon('ant-cloud', outline, getNode(newViewBox, 'M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0 1 22.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 0 1-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-65.7 61.3a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z'));
  exports.ApartmentOutline = getIcon('apartment', outline, getNode(newViewBox, 'M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z'));
  exports.AntDesignOutline = getIcon('ant-design', outline, getNode(newViewBox, 'M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 0 0 0 76.4L474.6 944a54.14 54.14 0 0 0 76.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 0 0-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 1 0 212.6 0 106.3 106.2 0 1 0-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 0 0 0 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 0 0 0 68.6 48.7 48.7 0 0 0 68.7 0l121.8-121.7a53.93 53.93 0 0 0-.1-76.4z'));
  exports.AreaChartOutline = getIcon('area-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z'));
  exports.ArrowLeftOutline = getIcon('arrow-left', outline, getNode(newViewBox, 'M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
  exports.ArrowDownOutline = getIcon('arrow-down', outline, getNode(newViewBox, 'M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z'));
  exports.ArrowUpOutline = getIcon('arrow-up', outline, getNode(newViewBox, 'M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z'));
  exports.ArrowsAltOutline = getIcon('arrows-alt', outline, getNode(newViewBox, 'M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z'));
  exports.ArrowRightOutline = getIcon('arrow-right', outline, getNode(newViewBox, 'M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z'));
  exports.AuditOutline = getIcon('audit', outline, getNode(newViewBox, 'M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z'));
  exports.BarChartOutline = getIcon('bar-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z'));
  exports.BarcodeOutline = getIcon('barcode', outline, getNode(newViewBox, 'M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
  exports.BarsOutline = getIcon('bars', outline, getNode(normalViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
  exports.BgColorsOutline = getIcon('bg-colors', outline, getNode(newViewBox, 'M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z'));
  exports.BehanceOutline = getIcon('behance', outline, getNode(newViewBox, 'M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z'));
  exports.BlockOutline = getIcon('block', outline, getNode(newViewBox, 'M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z'));
  exports.BoldOutline = getIcon('bold', outline, getNode(newViewBox, 'M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z'));
  exports.BorderBottomOutline = getIcon('border-bottom', outline, getNode(newViewBox, 'M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
  exports.BorderLeftOutline = getIcon('border-left', outline, getNode(newViewBox, 'M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.BorderOuterOutline = getIcon('border-outer', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
  exports.BorderInnerOutline = getIcon('border-inner', outline, getNode(newViewBox, 'M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.BorderRightOutline = getIcon('border-right', outline, getNode(newViewBox, 'M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.BorderHorizontalOutline = getIcon('border-horizontal', outline, getNode(newViewBox, 'M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.BorderTopOutline = getIcon('border-top', outline, getNode(newViewBox, 'M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.BorderVerticleOutline = getIcon('border-verticle', outline, getNode(newViewBox, 'M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.BorderOutline = getIcon('border', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
  exports.BranchesOutline = getIcon('branches', outline, getNode(newViewBox, 'M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
  exports.CheckOutline = getIcon('check', outline, getNode(newViewBox, 'M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z'));
  exports.CiOutline = getIcon('ci', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'));
  exports.CloseOutline = getIcon('close', outline, getNode(newViewBox, 'M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'));
  exports.CloudDownloadOutline = getIcon('cloud-download', outline, getNode(newViewBox, 'M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
  exports.CloudServerOutline = getIcon('cloud-server', outline, getNode(newViewBox, 'M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z', 'M424 748a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm0-178a32 32 0 1 0 64 0 32 32 0 1 0-64 0z', 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z'));
  exports.CloudSyncOutline = getIcon('cloud-sync', outline, getNode(newViewBox, 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z', 'M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z'));
  exports.CloudUploadOutline = getIcon('cloud-upload', outline, getNode(newViewBox, 'M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
  exports.ClusterOutline = getIcon('cluster', outline, getNode(newViewBox, 'M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
  exports.CodepenOutline = getIcon('codepen', outline, getNode(newViewBox, 'M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 0 0-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z'));
  exports.CodeSandboxOutline = getIcon('code-sandbox', outline, getNode(newViewBox, 'M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z'));
  exports.ColumHeightOutline = getIcon('colum-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
  exports.ColumnWidthOutline = getIcon('column-width', outline, getNode(newViewBox, 'M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 0 0-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z'));
  exports.ColumnHeightOutline = getIcon('column-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
  exports.CoffeeOutline = getIcon('coffee', outline, getNode(normalViewBox, 'M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z'));
  exports.CopyrightOutline = getIcon('copyright', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'));
  exports.DashOutline = getIcon('dash', outline, getNode(newViewBox, 'M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z'));
  exports.DeploymentUnitOutline = getIcon('deployment-unit', outline, getNode(newViewBox, 'M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z'));
  exports.DesktopOutline = getIcon('desktop', outline, getNode(newViewBox, 'M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z'));
  exports.DingdingOutline = getIcon('dingding', outline, getNode(newViewBox, 'M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z'));
  exports.DisconnectOutline = getIcon('disconnect', outline, getNode(newViewBox, 'M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z'));
  exports.DollarOutline = getIcon('dollar', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'));
  exports.DoubleRightOutline = getIcon('double-right', outline, getNode(newViewBox, 'M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z'));
  exports.DotChartOutline = getIcon('dot-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
  exports.DoubleLeftOutline = getIcon('double-left', outline, getNode(newViewBox, 'M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z'));
  exports.DownloadOutline = getIcon('download', outline, getNode(newViewBox, 'M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
  exports.DribbbleOutline = getIcon('dribbble', outline, getNode(newViewBox, 'M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 0 1 512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z'));
  exports.DropboxOutline = getIcon('dropbox', outline, getNode(newViewBox, 'M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z'));
  exports.EllipsisOutline = getIcon('ellipsis', outline, getNode(newViewBox, 'M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
  exports.EnterOutline = getIcon('enter', outline, getNode(newViewBox, 'M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z'));
  exports.EuroOutline = getIcon('euro', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z'));
  exports.ExceptionOutline = getIcon('exception', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.ExclamationOutline = getIcon('exclamation', outline, getNode(newViewBox, 'M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
  exports.ExportOutline = getIcon('export', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
  exports.FallOutline = getIcon('fall', outline, getNode(newViewBox, 'M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 0 0-11.3 0l-45 45.2a8.03 8.03 0 0 0 0 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 0 0 4.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z'));
  exports.FileDoneOutline = getIcon('file-done', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 0 0-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.FileSyncOutline = getIcon('file-sync', outline, getNode(newViewBox, 'M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z'));
  exports.FileProtectOutline = getIcon('file-protect', outline, getNode(newViewBox, 'M644.7 669.2a7.92 7.92 0 0 0-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 0 0-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z'));
  exports.FileSearchOutline = getIcon('file-search', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
  exports.FileJpgOutline = getIcon('file-jpg', outline, getNode(normalViewBox, 'M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z'));
  exports.FontColorsOutline = getIcon('font-colors', outline, getNode(newViewBox, 'M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 0 0 6-12.4L573.6 118.6a9.9 9.9 0 0 0-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z'));
  exports.FontSizeOutline = getIcon('font-size', outline, getNode(newViewBox, 'M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z'));
  exports.ForkOutline = getIcon('fork', outline, getNode(newViewBox, 'M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm336 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm192-552a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
  exports.FormOutline = getIcon('form', outline, getNode(newViewBox, 'M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z', 'M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z'));
  exports.FullscreenExitOutline = getIcon('fullscreen-exit', outline, getNode(newViewBox, 'M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 0 0 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 0 0 391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 0 0-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z'));
  exports.FullscreenOutline = getIcon('fullscreen', outline, getNode(newViewBox, 'M290 236.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0 0 13.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 0 0 0 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 0 0-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z'));
  exports.GatewayOutline = getIcon('gateway', outline, getNode(newViewBox, 'M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z'));
  exports.DownOutline = getIcon('down', outline, getNode(newViewBox, 'M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z'));
  exports.DragOutline = getIcon('drag', outline, getNode(newViewBox, 'M909.3 506.3L781.7 405.6a7.23 7.23 0 0 0-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 0 0-11.3 0L405.6 242.3a7.23 7.23 0 0 0 5.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 0 0 .1-11.4z'));
  exports.GlobalOutline = getIcon('global', outline, getNode(newViewBox, 'M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z'));
  exports.GooglePlusOutline = getIcon('google-plus', outline, getNode(newViewBox, 'M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z'));
  exports.GoogleOutline = getIcon('google', outline, getNode(newViewBox, 'M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z'));
  exports.HeatMapOutline = getIcon('heat-map', outline, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z'));
  exports.GoldOutline = getIcon('gold', outline, getNode(newViewBox, 'M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z'));
  exports.HistoryOutline = getIcon('history', outline, getNode(newViewBox, 'M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 0 0 3 14.1zm167.7 301.1l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 0 1-112.5 75.9 352.18 352.18 0 0 1-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 0 1-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 0 1 171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 0 1 112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 0 1 775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z'));
  exports.IeOutline = getIcon('ie', outline, getNode(newViewBox, 'M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z'));
  exports.InboxOutline = getIcon('inbox', outline, getNode(normalViewBox, 'M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z'));
  exports.ImportOutline = getIcon('import', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.InfoOutline = getIcon('info', outline, getNode(newViewBox, 'M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z'));
  exports.ItalicOutline = getIcon('italic', outline, getNode(newViewBox, 'M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
  exports.IssuesCloseOutline = getIcon('issues-close', outline, getNode(newViewBox, 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 0 0-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0 0 26 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 0 1-49.8 62.2A355.92 355.92 0 0 1 651.1 840a355 355 0 0 1-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 0 1-113.3-76.3A353.06 353.06 0 0 1 184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 0 1 138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 0 0 892 694z'));
  exports.KeyOutline = getIcon('key', outline, getNode(newViewBox, 'M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z'));
  exports.LaptopOutline = getIcon('laptop', outline, getNode(newViewBox, 'M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z'));
  exports.LeftOutline = getIcon('left', outline, getNode(newViewBox, 'M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z'));
  exports.LinkOutline = getIcon('link', outline, getNode(newViewBox, 'M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z'));
  exports.LineChartOutline = getIcon('line-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z'));
  exports.LineHeightOutline = getIcon('line-height', outline, getNode(newViewBox, 'M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 0 0-11.3 0L713.6 306.3a7.23 7.23 0 0 0 5.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 0 0-5.6-11.7z'));
  exports.LineOutline = getIcon('line', outline, getNode(newViewBox, 'M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.Loading3QuartersOutline = getIcon('loading-3-quarters', outline, getNode(normalViewBox, 'M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z'));
  exports.LoadingOutline = getIcon('loading', outline, getNode(normalViewBox, 'M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z'));
  exports.LoginOutline = getIcon('login', outline, getNode(newViewBox, 'M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z'));
  exports.LogoutOutline = getIcon('logout', outline, getNode(newViewBox, 'M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
  exports.ManOutline = getIcon('man', outline, getNode(newViewBox, 'M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z'));
  exports.MediumOutline = getIcon('medium', outline, getNode(newViewBox, 'M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 0 1-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 0 1 6.8-17.2z'));
  exports.MediumWorkmarkOutline = getIcon('medium-workmark', outline, getNode(normalViewBox, 'M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 0 1-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0 1 34.61 21.67v-56.19a6.99 6.99 0 0 0-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 0 0-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0 0 19.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 0 0-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 0 1-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 0 0-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0 0 19.35-12.2v-80.85a7.65 7.65 0 0 0-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 0 0-21.19 11.64 99.68 99.68 0 0 1 2.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 0 0 2.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 0 0-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0 1 44.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 0 0 2.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 0 0 2.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 0 0 2.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 0 0 2.96-17.78V457.97A19.71 19.71 0 0 0 24 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 0 0-2.72 6.8v139.37a6.5 6.5 0 0 0 2.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0 0 40.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z'));
  exports.MenuUnfoldOutline = getIcon('menu-unfold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z'));
  exports.MenuFoldOutline = getIcon('menu-fold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z'));
  exports.MenuOutline = getIcon('menu', outline, getNode(newViewBox, 'M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
  exports.MinusOutline = getIcon('minus', outline, getNode(newViewBox, 'M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
  exports.MonitorOutline = getIcon('monitor', outline, getNode(newViewBox, 'M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 0 0-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 0 0-11.2-1.4l-37.9 29.7a7.97 7.97 0 0 0-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z'));
  exports.MoreOutline = getIcon('more', outline, getNode(newViewBox, 'M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
  exports.OrderedListOutline = getIcon('ordered-list', outline, getNode(newViewBox, 'M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 0 0-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 0 0 2.1-5.4V432c0-2.2-1.8-4-4-4z'));
  exports.NumberOutline = getIcon('number', outline, getNode(newViewBox, 'M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z'));
  exports.PauseOutline = getIcon('pause', outline, getNode(newViewBox, 'M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z'));
  exports.PercentageOutline = getIcon('percentage', outline, getNode(newViewBox, 'M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z'));
  exports.PaperClipOutline = getIcon('paper-clip', outline, getNode(newViewBox, 'M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z'));
  exports.PicCenterOutline = getIcon('pic-center', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z'));
  exports.PicLeftOutline = getIcon('pic-left', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
  exports.PlusOutline = getIcon('plus', outline, getNode(newViewBox, 'M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z', 'M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z'));
  exports.PicRightOutline = getIcon('pic-right', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
  exports.PoundOutline = getIcon('pound', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'));
  exports.PoweroffOutline = getIcon('poweroff', outline, getNode(newViewBox, 'M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
  exports.PullRequestOutline = getIcon('pull-request', outline, getNode(newViewBox, 'M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0z'));
  exports.QqOutline = getIcon('qq', outline, getNode(newViewBox, 'M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z'));
  exports.QuestionOutline = getIcon('question', outline, getNode(newViewBox, 'M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 0 0-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z'));
  exports.RadarChartOutline = getIcon('radar-chart', outline, getNode(newViewBox, 'M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z'));
  exports.QrcodeOutline = getIcon('qrcode', outline, getNode(newViewBox, 'M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
  exports.RadiusBottomleftOutline = getIcon('radius-bottomleft', outline, getNode(newViewBox, 'M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.RadiusBottomrightOutline = getIcon('radius-bottomright', outline, getNode(newViewBox, 'M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z'));
  exports.RadiusUpleftOutline = getIcon('radius-upleft', outline, getNode(newViewBox, 'M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.RadiusUprightOutline = getIcon('radius-upright', outline, getNode(newViewBox, 'M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z'));
  exports.RadiusSettingOutline = getIcon('radius-setting', outline, getNode(newViewBox, 'M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z'));
  exports.RedditOutline = getIcon('reddit', outline, getNode(newViewBox, 'M288 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 1 0-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 0 0-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 0 0 176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 1 1 0 63 31.5 31.5 0 0 1 0-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0 1 50.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 0 1-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
  exports.RedoOutline = getIcon('redo', outline, getNode(newViewBox, 'M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z'));
  exports.ReloadOutline = getIcon('reload', outline, getNode(newViewBox, 'M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z'));
  exports.RetweetOutline = getIcon('retweet', outline, getNode(normalViewBox, 'M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z'));
  exports.RightOutline = getIcon('right', outline, getNode(newViewBox, 'M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z'));
  exports.RiseOutline = getIcon('rise', outline, getNode(newViewBox, 'M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 0 0 0 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0 0 13.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z'));
  exports.RollbackOutline = getIcon('rollback', outline, getNode(newViewBox, 'M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 0 0 0 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z'));
  exports.SafetyOutline = getIcon('safety', outline, getNode(normalViewBox, 'M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z', 'M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z'));
  exports.RobotOutline = getIcon('robot', outline, getNode(newViewBox, 'M300 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
  exports.SearchOutline = getIcon('search', outline, getNode(newViewBox, 'M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z'));
  exports.ScanOutline = getIcon('scan', outline, getNode(newViewBox, 'M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.ScissorOutline = getIcon('scissor', outline, getNode(newViewBox, 'M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z'));
  exports.SelectOutline = getIcon('select', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 0 0-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z'));
  exports.ShakeOutline = getIcon('shake', outline, getNode(newViewBox, 'M324 666a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 0 0 0 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0 0 11.2 0L373.7 164a7.9 7.9 0 0 0 0-11.2l-38.4-38.4a7.9 7.9 0 0 0-11.2 0L114.3 323.9a7.9 7.9 0 0 0 0 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 0 0-11.2 0L650.3 860.1a7.9 7.9 0 0 0 0 11.2l38.4 38.4a7.9 7.9 0 0 0 11.2 0L909.7 700a7.9 7.9 0 0 0 0-11.2l-38.3-38.5z'));
  exports.ShareAltOutline = getIcon('share-alt', outline, getNode(newViewBox, 'M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z'));
  exports.ShoppingCartOutline = getIcon('shopping-cart', outline, getNode(normalViewBox, 'M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z'));
  exports.ShrinkOutline = getIcon('shrink', outline, getNode(newViewBox, 'M881.7 187.4l-45.1-45.1a8.03 8.03 0 0 0-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L447.9 585a7.9 7.9 0 0 0-8.9-8.9z'));
  exports.SlackOutline = getIcon('slack', outline, getNode(newViewBox, 'M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 0 0-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z'));
  exports.SmallDashOutline = getIcon('small-dash', outline, getNode(newViewBox, 'M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z'));
  exports.SolutionOutline = getIcon('solution', outline, getNode(newViewBox, 'M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'));
  exports.SketchOutline = getIcon('sketch', outline, getNode(newViewBox, 'M925.6 405.1l-203-253.7a6.5 6.5 0 0 0-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 0 0 .2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 0 0 .2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z'));
  exports.SortDescendingOutline = getIcon('sort-descending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM310.3 167.1a8 8 0 0 0-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z'));
  exports.SortAscendingOutline = getIcon('sort-ascending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z'));
  exports.StockOutline = getIcon('stock', outline, getNode(newViewBox, 'M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z'));
  exports.SwapLeftOutline = getIcon('swap-left', outline, getNode(normalViewBox, 'M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
  exports.SwapRightOutline = getIcon('swap-right', outline, getNode(normalViewBox, 'M873.1 596.2l-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z'));
  exports.StrikethroughOutline = getIcon('strikethrough', outline, getNode(newViewBox, 'M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9z'));
  exports.SwapOutline = getIcon('swap', outline, getNode(newViewBox, 'M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
  exports.SyncOutline = getIcon('sync', outline, getNode(newViewBox, 'M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z'));
  exports.TableOutline = getIcon('table', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z'));
  exports.TeamOutline = getIcon('team', outline, getNode(newViewBox, 'M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z'));
  exports.TaobaoOutline = getIcon('taobao', outline, getNode(newViewBox, 'M168.5 273.7a68.7 68.7 0 1 0 137.4 0 68.7 68.7 0 1 0-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z'));
  exports.ToTopOutline = getIcon('to-top', outline, getNode(newViewBox, 'M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z'));
  exports.TrademarkOutline = getIcon('trademark', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z'));
  exports.TransactionOutline = getIcon('transaction', outline, getNode(newViewBox, 'M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z'));
  exports.TwitterOutline = getIcon('twitter', outline, getNode(newViewBox, 'M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94 336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z'));
  exports.UnderlineOutline = getIcon('underline', outline, getNode(newViewBox, 'M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z'));
  exports.UndoOutline = getIcon('undo', outline, getNode(newViewBox, 'M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z'));
  exports.UnorderedListOutline = getIcon('unordered-list', outline, getNode(newViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
  exports.UpOutline = getIcon('up', outline, getNode(newViewBox, 'M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z'));
  exports.UploadOutline = getIcon('upload', outline, getNode(newViewBox, 'M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
  exports.UserAddOutline = getIcon('user-add', outline, getNode(newViewBox, 'M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 888.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.UsergroupAddOutline = getIcon('usergroup-add', outline, getNode(newViewBox, 'M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
  exports.UserOutline = getIcon('user', outline, getNode(newViewBox, 'M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z'));
  exports.UserDeleteOutline = getIcon('user-delete', outline, getNode(newViewBox, 'M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
  exports.UsergroupDeleteOutline = getIcon('usergroup-delete', outline, getNode(newViewBox, 'M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
  exports.VerticalAlignBottomOutline = getIcon('vertical-align-bottom', outline, getNode(newViewBox, 'M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z'));
  exports.VerticalAlignMiddleOutline = getIcon('vertical-align-middle', outline, getNode(newViewBox, 'M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z'));
  exports.VerticalAlignTopOutline = getIcon('vertical-align-top', outline, getNode(newViewBox, 'M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z'));
  exports.VerticalRightOutline = getIcon('vertical-right', outline, getNode(newViewBox, 'M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z'));
  exports.VerticalLeftOutline = getIcon('vertical-left', outline, getNode(newViewBox, 'M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 0 0 254 164z'));
  exports.WifiOutline = getIcon('wifi', outline, getNode(newViewBox, 'M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 0 0-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 0 0-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 0 0-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 1 0 128 0 64 64 0 1 0-128 0z'));
  exports.ZhihuOutline = getIcon('zhihu', outline, getNode(newViewBox, 'M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z'));
  exports.WeiboOutline = getIcon('weibo', outline, getNode(newViewBox, 'M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 0 0-106-34.3 28.45 28.45 0 0 0-21.9 33.8 28.39 28.39 0 0 0 33.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0 1 11.3 53.3 28.45 28.45 0 0 0 18.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 0 0-25.4 39.3 33.12 33.12 0 0 0 39.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z'));
  exports.WomanOutline = getIcon('woman', outline, getNode(newViewBox, 'M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z'));
  exports.ZoomInOutline = getIcon('zoom-in', outline, getNode(newViewBox, 'M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
  exports.AccountBookTwoTone = getIcon('account-book', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 0 1 7.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z'], [primaryColor, 'M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'], [primaryColor, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z']);
  });
  exports.ZoomOutOutline = getIcon('zoom-out', outline, getNode(newViewBox, 'M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
  exports.AlertTwoTone = getIcon('alert', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z'], [primaryColor, 'M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z']);
  });
  exports.ApiTwoTone = getIcon('api', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z'], [primaryColor, 'M578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 0 0-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z']);
  });
  exports.AppstoreTwoTone = getIcon('appstore', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'], [secondaryColor, 'M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z']);
  });
  exports.BankTwoTone = getIcon('bank', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M240.9 393.9h542.2L512 196.7z'], [primaryColor, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z']);
  });
  exports.AudioTwoTone = getIcon('audio', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z'], [primaryColor, 'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'], [primaryColor, 'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z']);
  });
  exports.BellTwoTone = getIcon('bell', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z'], [primaryColor, 'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z']);
  });
  exports.BookTwoTone = getIcon('book', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z'], [secondaryColor, 'M668 345.9V136h-96v211.4l49.5-35.4z'], [secondaryColor, 'M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 0 1-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z']);
  });
  exports.BoxPlotTwoTone = getIcon('box-plot', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M296 368h88v288h-88zm152 0h280v288H448z'], [primaryColor, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z']);
  });
  exports.BugTwoTone = getIcon('bug', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 0 1-22.66 49.02 281.39 281.39 0 0 1-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 0 1-100.45-100.45 278.63 278.63 0 0 1-22.66-49.02A119.95 119.95 0 0 0 188 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 0 1 232 680v-96H84a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8 63 63 0 0 0 63 63h560a63 63 0 0 0 63-63 8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 76.77-62.23 139-139 139v100h148a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H792zM368 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0 1 74.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0 1 74.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 0 0-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 0 0-45.4 45.39C373.95 218.85 368 243.67 368 272z'], [secondaryColor, 'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308z']);
  });
  exports.BulbTwoTone = getIcon('bulb', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z'], [primaryColor, 'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z']);
  });
  exports.CalculatorTwoTone = getIcon('calculator', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z'], [primaryColor, 'M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z']);
  });
  exports.BuildTwoTone = getIcon('build', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M144 546h200v200H144zm268-268h200v200H412z'], [primaryColor, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z']);
  });
  exports.CalendarTwoTone = getIcon('calendar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'], [primaryColor, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z']);
  });
  exports.CameraTwoTone = getIcon('camera', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z'], [primaryColor, 'M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'], [primaryColor, 'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z']);
  });
  exports.CarTwoTone = getIcon('car', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'], [primaryColor, 'M720 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [primaryColor, 'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z'], [primaryColor, 'M224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z']);
  });
  exports.CarryOutTwoTone = getIcon('carry-out', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'], [secondaryColor, 'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z'], [primaryColor, 'M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z']);
  });
  exports.CheckCircleTwoTone = getIcon('check-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z'], [primaryColor, 'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z']);
  });
  exports.CheckSquareTwoTone = getIcon('check-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z'], [primaryColor, 'M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z']);
  });
  exports.ClockCircleTwoTone = getIcon('clock-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'], [primaryColor, 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z']);
  });
  exports.CloseCircleTwoTone = getIcon('close-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 0 1-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z'], [primaryColor, 'M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z']);
  });
  exports.CloudTwoTone = getIcon('cloud', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 0 0-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 0 0-52.4 49.9 240.47 240.47 0 0 0-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 0 0-66.1 43.7A123.1 123.1 0 0 0 140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 0 0 884 612c0-56.2-37.8-105.5-92.1-120z'], [primaryColor, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z']);
  });
  exports.CloseSquareTwoTone = getIcon('close-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z'], [primaryColor, 'M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z']);
  });
  exports.CodeTwoTone = getIcon('code', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z'], [primaryColor, 'M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z']);
  });
  exports.CompassTwoTone = getIcon('compass', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'], [primaryColor, 'M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z'], [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z']);
  });
  exports.ContactsTwoTone = getIcon('contacts', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M460.3 526a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'], [secondaryColor, 'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 0 1-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 0 1-8 8.4z'], [primaryColor, 'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z'], [primaryColor, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z']);
  });
  exports.ContainerTwoTone = getIcon('container', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z'], [primaryColor, 'M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'], [primaryColor, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z'], [primaryColor, 'M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z']);
  });
  exports.ControlTwoTone = getIcon('control', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z'], [secondaryColor, 'M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z'], [primaryColor, 'M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 0 1 408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z']);
  });
  exports.CopyTwoTone = getIcon('copy', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z'], [primaryColor, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z'], [primaryColor, 'M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z']);
  });
  exports.CreditCardTwoTone = getIcon('credit-card', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z'], [primaryColor, 'M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'], [primaryColor, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z']);
  });
  exports.CrownTwoTone = getIcon('crown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z'], [secondaryColor, 'M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z'], [primaryColor, 'M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z'], [primaryColor, 'M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z']);
  });
  exports.CustomerServiceTwoTone = getIcon('customer-service', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M696 632h128v192H696zm-496 0h128v192H200z'], [primaryColor, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z']);
  });
  exports.DashboardTwoTone = getIcon('dashboard', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 0 0 884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 0 1-11.3 0l-56.6-56.6a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z'], [primaryColor, 'M623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z'], [primaryColor, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z'], [primaryColor, 'M762.7 340.8l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z']);
  });
  exports.DeleteTwoTone = getIcon('delete', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M292.7 840h438.6l24.2-512h-487z'], [primaryColor, 'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z']);
  });
  exports.DiffTwoTone = getIcon('diff', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z'], [primaryColor, 'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'], [primaryColor, 'M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z'], [primaryColor, 'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z']);
  });
  exports.DatabaseTwoTone = getIcon('database', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'], [primaryColor, 'M304 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-544a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [primaryColor, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z']);
  });
  exports.DislikeTwoTone = getIcon('dislike', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0 0 42.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z'], [primaryColor, 'M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z']);
  });
  exports.DownCircleTwoTone = getIcon('down-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z'], [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [primaryColor, 'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z']);
  });
  exports.DownSquareTwoTone = getIcon('down-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z'], [primaryColor, 'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z']);
  });
  exports.EnvironmentTwoTone = getIcon('environment', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'], [primaryColor, 'M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'], [primaryColor, 'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z']);
  });
  exports.EditTwoTone = getIcon('edit', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z'], [primaryColor, 'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z']);
  });
  exports.ExclamationCircleTwoTone = getIcon('exclamation-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'], [primaryColor, 'M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
  });
  exports.ExperimentTwoTone = getIcon('experiment', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 0 1 552 512a40 40 0 0 1-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z'], [primaryColor, 'M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z'], [primaryColor, 'M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0 0 40 39.4z']);
  });
  exports.EyeInvisibleTwoTone = getIcon('eye-invisible', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M254.89 758.85l125.57-125.57a176 176 0 0 1 248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 0 1-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'], [primaryColor, 'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zM878.63 165.56L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z'], [primaryColor, 'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z']);
  });
  exports.EyeTwoTone = getIcon('eye', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M81.8 537.8a60.3 60.3 0 0 1 0-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z'], [secondaryColor, 'M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'], [primaryColor, 'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z'], [primaryColor, 'M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z']);
  });
  exports.FileAddTwoTone = getIcon('file-add', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z']);
  });
  exports.FileExclamationTwoTone = getIcon('file-exclamation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
  });
  exports.FileImageTwoTone = getIcon('file-image', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0 1 12.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
  });
  exports.FileExcelTwoTone = getIcon('file-excel', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm51.6 120h35.7a12.04 12.04 0 0 1 10.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 0 1-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z']);
  });
  exports.FileMarkdownTwoTone = getIcon('file-markdown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 0 1-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z']);
  });
  exports.FilePdfTwoTone = getIcon('file-pdf', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z'], [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z'], [secondaryColor, 'M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z']);
  });
  exports.FilePptTwoTone = getIcon('file-ppt', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z'], [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z']);
  });
  exports.FileTextTwoTone = getIcon('file-text', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z']);
  });
  exports.FileUnknownTwoTone = getIcon('file-unknown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z'], [primaryColor, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M480 744a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z']);
  });
  exports.FileZipTwoTone = getIcon('file-zip', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M344 630h32v2h-32z'], [secondaryColor, 'M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 0 1-42-42z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z']);
  });
  exports.FileWordTwoTone = getIcon('file-word', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0 1 11.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0 1 11.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'], [primaryColor, 'M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z']);
  });
  exports.FileTwoTone = getIcon('file', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42z'], [primaryColor, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z']);
  });
  exports.FilterTwoTone = getIcon('filter', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z'], [primaryColor, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z']);
  });
  exports.FireTwoTone = getIcon('fire', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 0 1-51 24.4 73.36 73.36 0 0 1-53.4-18.8 74.01 74.01 0 0 1-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 0 1-12.1 46.5 354.26 354.26 0 0 1-58.2 101 349.6 349.6 0 0 1-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 0 0-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z'], [primaryColor, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z']);
  });
  exports.FolderAddTwoTone = getIcon('folder-add', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z'], [primaryColor, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'], [primaryColor, 'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z']);
  });
  exports.FlagTwoTone = getIcon('flag', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M184 232h368v336H184z'], [secondaryColor, 'M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z'], [primaryColor, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z']);
  });
  exports.FolderTwoTone = getIcon('folder', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'], [secondaryColor, 'M372.5 256H184v512h656V370.4H492.1z']);
  });
  exports.FolderOpenTwoTone = getIcon('folder-open', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M159 768h612.3l103.4-256H262.3z'], [primaryColor, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z']);
  });
  exports.FrownTwoTone = getIcon('frown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'], [primaryColor, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
  });
  exports.FundTwoTone = getIcon('fund', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'], [secondaryColor, 'M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 0 1-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 0 1-11.3 0l-36.7-36.9a8.03 8.03 0 0 1 0-11.3z'], [primaryColor, 'M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L533 561 418.6 446.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z']);
  });
  exports.FunnelPlotTwoTone = getIcon('funnel-plot', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z'], [primaryColor, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z']);
  });
  exports.GiftTwoTone = getIcon('gift', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z'], [primaryColor, 'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z']);
  });
  exports.HddTwoTone = getIcon('hdd', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z'], [primaryColor, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'], [primaryColor, 'M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
  });
  exports.HeartTwoTone = getIcon('heart', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'], [secondaryColor, 'M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z']);
  });
  exports.HighlightTwoTone = getIcon('highlight', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z'], [primaryColor, 'M957.6 507.5L603.2 158.3a7.9 7.9 0 0 0-11.2 0L353.3 393.5a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z']);
  });
  exports.HomeTwoTone = getIcon('home', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z'], [primaryColor, 'M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.6 63.6 0 0 0-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0 0 18.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z']);
  });
  exports.HourglassTwoTone = getIcon('hourglass', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 0 0 354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 0 0 512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z'], [primaryColor, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z']);
  });
  exports.Html5TwoTone = getIcon('html5', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z'], [secondaryColor, 'M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z'], [primaryColor, 'M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z']);
  });
  exports.IdcardTwoTone = getIcon('idcard', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'], [secondaryColor, 'M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z'], [secondaryColor, 'M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'], [primaryColor, 'M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z']);
  });
  exports.InfoCircleTwoTone = getIcon('info-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'], [primaryColor, 'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z']);
  });
  exports.InsuranceTwoTone = getIcon('insurance', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'], [secondaryColor, 'M521.9 358.8h97.9v41.6h-97.9z'], [secondaryColor, 'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 0 1-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z'], [primaryColor, 'M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 0 0-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0 0 33.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z']);
  });
  exports.InteractionTwoTone = getIcon('interaction', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'], [primaryColor, 'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z']);
  });
  exports.InterationTwoTone = getIcon('interation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'], [primaryColor, 'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z']);
  });
  exports.LayoutTwoTone = getIcon('layout', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z'], [primaryColor, 'M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z']);
  });
  exports.LeftCircleTwoTone = getIcon('left-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z'], [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [primaryColor, 'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z']);
  });
  exports.LeftSquareTwoTone = getIcon('left-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 0 1 0-12.9z'], [primaryColor, 'M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 0 0 0 12.9z']);
  });
  exports.LikeTwoTone = getIcon('like', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0 0 33.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0 0 19.6-43c0-19.1-11-37.5-28.8-48.4z'], [primaryColor, 'M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 0 0-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0 1 42.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z']);
  });
  exports.LockTwoTone = getIcon('lock', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z'], [secondaryColor, 'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'], [primaryColor, 'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z']);
  });
  exports.MailTwoTone = getIcon('mail', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 0 1-68.7 0z'], [secondaryColor, 'M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z'], [primaryColor, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z']);
  });
  exports.MedicineBoxTwoTone = getIcon('medicine-box', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z'], [primaryColor, 'M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'], [primaryColor, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z']);
  });
  exports.MehTwoTone = getIcon('meh', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'], [primaryColor, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
  });
  exports.MessageTwoTone = getIcon('message', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M775.3 248.9a369.62 369.62 0 0 0-119-80A370.2 370.2 0 0 0 512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 0 0-80-119zM312 560a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'], [primaryColor, 'M664 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'], [primaryColor, 'M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'], [primaryColor, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
  });
  exports.MinusCircleTwoTone = getIcon('minus-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'], [primaryColor, 'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z']);
  });
  exports.MinusSquareTwoTone = getIcon('minus-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z'], [primaryColor, 'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z']);
  });
  exports.MobileTwoTone = getIcon('mobile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z'], [secondaryColor, 'M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'], [primaryColor, 'M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
  });
  exports.PauseCircleTwoTone = getIcon('pause-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'], [primaryColor, 'M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z']);
  });
  exports.MoneyCollectTwoTone = getIcon('money-collect', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z'], [primaryColor, 'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z'], [primaryColor, 'M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z']);
  });
  exports.NotificationTwoTone = getIcon('notification', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z'], [primaryColor, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z']);
  });
  exports.PhoneTwoTone = getIcon('phone', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z'], [primaryColor, 'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z']);
  });
  exports.PictureTwoTone = getIcon('picture', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z'], [secondaryColor, 'M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z'], [secondaryColor, 'M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 1 1 0 176 88 88 0 0 1 0-176z'], [secondaryColor, 'M276 368a28 28 0 1 0 56 0 28 28 0 1 0-56 0z'], [primaryColor, 'M304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z']);
  });
  exports.PlayCircleTwoTone = getIcon('play-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 0 1-12.7-6.5V353a8 8 0 0 1 12.7-6.5l218.4 158.8a7.9 7.9 0 0 1 0 12.9z'], [primaryColor, 'M676.1 505.3L457.7 346.5A8 8 0 0 0 445 353v317.6a8.02 8.02 0 0 0 12.7 6.5l218.4-158.9a7.9 7.9 0 0 0 0-12.9z']);
  });
  exports.PlaySquareTwoTone = getIcon('play-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z'], [primaryColor, 'M442.3 677.6l199.4-156.8a11.2 11.2 0 0 0 0-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z']);
  });
  exports.PieChartTwoTone = getIcon('pie-chart', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 0 1-85.7-127.1A397.12 397.12 0 0 1 72 552.2v.2a398.57 398.57 0 0 0 117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 0 0 471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z'], [secondaryColor, 'M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 0 0-166.4-89.8z'], [secondaryColor, 'M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z'], [primaryColor, 'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z'], [primaryColor, 'M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 0 0-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 0 0 4.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z']);
  });
  exports.PlusCircleTwoTone = getIcon('plus-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'], [primaryColor, 'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z']);
  });
  exports.PlusSquareTwoTone = getIcon('plus-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z'], [primaryColor, 'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z']);
  });
  exports.PoundCircleTwoTone = getIcon('pound-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z'], [primaryColor, 'M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0 0 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z']);
  });
  exports.PrinterTwoTone = getIcon('printer', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'], [primaryColor, 'M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'], [primaryColor, 'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z']);
  });
  exports.ProfileTwoTone = getIcon('profile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'], [primaryColor, 'M340 656a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z']);
  });
  exports.ProjectTwoTone = getIcon('project', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z'], [primaryColor, 'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z']);
  });
  exports.PushpinTwoTone = getIcon('pushpin', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0 0 30.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z'], [primaryColor, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z']);
  });
  exports.PropertySafetyTwoTone = getIcon('property-safety', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'], [secondaryColor, 'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 0 1 8.9-5.5z'], [primaryColor, 'M438.9 323.5a9.88 9.88 0 0 0-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 0 0-8.9 5.5l-73.2 144.3-72.9-144.3z']);
  });
  exports.QuestionCircleTwoTone = getIcon('question-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'], [primaryColor, 'M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z']);
  });
  exports.ReconciliationTwoTone = getIcon('reconciliation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'], [secondaryColor, 'M642 657a34 34 0 1 0 68 0 34 34 0 1 0-68 0z'], [primaryColor, 'M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'], [primaryColor, 'M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z'], [primaryColor, 'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z']);
  });
  exports.RedEnvelopeTwoTone = getIcon('red-envelope', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'], [secondaryColor, 'M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 0 1-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 0 1 7.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 0 1 3.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 0 1 7.5-4.6z'], [secondaryColor, 'M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z'], [primaryColor, 'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z']);
  });
  exports.RestTwoTone = getIcon('rest', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z'], [primaryColor, 'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'], [primaryColor, 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z']);
  });
  exports.RightCircleTwoTone = getIcon('right-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z'], [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [primaryColor, 'M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z']);
  });
  exports.RocketTwoTone = getIcon('rocket', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 0 0-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'], [primaryColor, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0 1 62.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z'], [primaryColor, 'M464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
  });
  exports.RightSquareTwoTone = getIcon('right-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z'], [primaryColor, 'M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z']);
  });
  exports.SafetyCertificateTwoTone = getIcon('safety-certificate', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'], [secondaryColor, 'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z'], [primaryColor, 'M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z']);
  });
  exports.SaveTwoTone = getIcon('save', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z'], [primaryColor, 'M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'], [primaryColor, 'M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 0 0-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z']);
  });
  exports.ScheduleTwoTone = getIcon('schedule', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z'], [primaryColor, 'M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'], [primaryColor, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'], [primaryColor, 'M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z']);
  });
  exports.SecurityScanTwoTone = getIcon('security-scan', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'], [secondaryColor, 'M460.7 451.1a80.1 80.1 0 1 0 160.2 0 80.1 80.1 0 1 0-160.2 0z'], [secondaryColor, 'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z'], [primaryColor, 'M418.8 527.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 0 1 113.3 0 80.1 80.1 0 0 1 0 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z']);
  });
  exports.SettingTwoTone = getIcon('setting', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 0 0-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z'], [secondaryColor, 'M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 0 1-79.7 137.9l-1.8 2.1a32 32 0 0 1-35.1 9.5l-81.3-28.9a350 350 0 0 1-99.7 57.6l-15.7 85a32.05 32.05 0 0 1-25.8 25.7l-2.7.5a445.2 445.2 0 0 1-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z'], [primaryColor, 'M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502z'], [primaryColor, 'M594.1 952.2a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 0 0-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6a32.09 32.09 0 0 0 7.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z']);
  });
  exports.ShopTwoTone = getIcon('shop', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z'], [primaryColor, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z']);
  });
  exports.ShoppingTwoTone = getIcon('shopping', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z'], [primaryColor, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z']);
  });
  exports.SkinTwoTone = getIcon('skin', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z'], [primaryColor, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z']);
  });
  exports.SlidersTwoTone = getIcon('sliders', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M180 292h80v440h-80zm369 180h-74a3 3 0 0 0-3 3v74a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-74a3 3 0 0 0-3-3zm215-108h80v296h-80z'], [primaryColor, 'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z']);
  });
  exports.SmileTwoTone = getIcon('smile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'], [primaryColor, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4zm-24-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
  });
  exports.SnippetsTwoTone = getIcon('snippets', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z'], [primaryColor, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z']);
  });
  exports.SoundTwoTone = getIcon('sound', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z'], [primaryColor, 'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z']);
  });
  exports.StarTwoTone = getIcon('star', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z'], [primaryColor, 'M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0 0 46.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z']);
  });
  exports.StopTwoTone = getIcon('stop', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z']);
  });
  exports.SwitcherTwoTone = getIcon('switcher', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M184 840h528V312H184v528zm116-290h296v64H300v-64z'], [primaryColor, 'M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'], [primaryColor, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z'], [primaryColor, 'M300 550h296v64H300z']);
  });
  exports.TabletTwoTone = getIcon('tablet', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z'], [secondaryColor, 'M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'], [primaryColor, 'M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
  });
  exports.TagTwoTone = getIcon('tag', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z'], [primaryColor, 'M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'], [primaryColor, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8a9.9 9.9 0 0 0 7.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z']);
  });
  exports.TagsTwoTone = getIcon('tags', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0 1 33.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0 1 12.4 46.4 47.81 47.81 0 0 1-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 0 1-12.4-46.4z'], [secondaryColor, 'M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 0 1 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z'], [primaryColor, 'M889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0 0 33.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 0 0-46.4-12.4 47.81 47.81 0 0 0-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0 0 46.4 12.4z'], [primaryColor, 'M137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z']);
  });
  exports.ToolTwoTone = getIcon('tool', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M706.8 488.7a32.05 32.05 0 0 1-45.3 0L537 364.2a32.05 32.05 0 0 1 0-45.3l132.9-132.8a184.2 184.2 0 0 0-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z'], [primaryColor, 'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z']);
  });
  exports.TrademarkCircleTwoTone = getIcon('trademark-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z'], [secondaryColor, 'M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'], [primaryColor, 'M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z']);
  });
  exports.UnlockTwoTone = getIcon('unlock', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'], [primaryColor, 'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'], [primaryColor, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z']);
  });
  exports.TrophyTwoTone = getIcon('trophy', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z'], [primaryColor, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6a91.99 91.99 0 0 1-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z']);
  });
  exports.UpCircleTwoTone = getIcon('up-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'], [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [primaryColor, 'M518.4 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z']);
  });
  exports.ThunderboltTwoTone = getIcon('thunderbolt', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z'], [primaryColor, 'M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z']);
  });
  exports.UpSquareTwoTone = getIcon('up-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'], [secondaryColor, 'M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z'], [primaryColor, 'M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z']);
  });
  exports.UsbTwoTone = getIcon('usb', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z'], [primaryColor, 'M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'], [primaryColor, 'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z']);
  });
  exports.VideoCameraTwoTone = getIcon('video-camera', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z'], [primaryColor, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z'], [primaryColor, 'M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z']);
  });
  exports.WalletTwoTone = getIcon('wallet', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z'], [secondaryColor, 'M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'], [primaryColor, 'M580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [secondaryColor, 'M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z']);
  });
  exports.WarningTwoTone = getIcon('warning', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'], [secondaryColor, 'M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'], [primaryColor, 'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z']);
  });
  exports.CiTwoTone = getIcon('ci', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'], [primaryColor, 'M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z']);
  });
  exports.CopyrightTwoTone = getIcon('copyright', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z'], [primaryColor, 'M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z']);
  });
  exports.DollarTwoTone = getIcon('dollar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z'], [primaryColor, 'M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z']);
  });
  exports.EuroTwoTone = getIcon('euro', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'], [secondaryColor, 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z'], [primaryColor, 'M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z']);
  });
  exports.GoldTwoTone = getIcon('gold', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [primaryColor, 'M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z'], [secondaryColor, 'M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z']);
  });
  exports.CanlendarTwoTone = getIcon('canlendar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'], [primaryColor, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z']);
  });
});
unwrapExports(dist);
var dist_1 = dist.AccountBookFill;
var dist_2 = dist.AlertFill;
var dist_3 = dist.AlipaySquareFill;
var dist_4 = dist.AliwangwangFill;
var dist_5 = dist.AlipayCircleFill;
var dist_6 = dist.AmazonCircleFill;
var dist_7 = dist.AndroidFill;
var dist_8 = dist.AmazonSquareFill;
var dist_9 = dist.ApiFill;
var dist_10 = dist.AppstoreFill;
var dist_11 = dist.AudioFill;
var dist_12 = dist.AppleFill;
var dist_13 = dist.BackwardFill;
var dist_14 = dist.BankFill;
var dist_15 = dist.BehanceCircleFill;
var dist_16 = dist.BellFill;
var dist_17 = dist.BehanceSquareFill;
var dist_18 = dist.BookFill;
var dist_19 = dist.BoxPlotFill;
var dist_20 = dist.BugFill;
var dist_21 = dist.CalculatorFill;
var dist_22 = dist.BulbFill;
var dist_23 = dist.BuildFill;
var dist_24 = dist.CalendarFill;
var dist_25 = dist.CameraFill;
var dist_26 = dist.CarFill;
var dist_27 = dist.CaretDownFill;
var dist_28 = dist.CaretLeftFill;
var dist_29 = dist.CaretRightFill;
var dist_30 = dist.CarryOutFill;
var dist_31 = dist.CaretUpFill;
var dist_32 = dist.CheckCircleFill;
var dist_33 = dist.CheckSquareFill;
var dist_34 = dist.ChromeFill;
var dist_35 = dist.CiCircleFill;
var dist_36 = dist.ClockCircleFill;
var dist_37 = dist.CloseCircleFill;
var dist_38 = dist.CloudFill;
var dist_39 = dist.CloseSquareFill;
var dist_40 = dist.CodeSandboxSquareFill;
var dist_41 = dist.CodeSandboxCircleFill;
var dist_42 = dist.CodeFill;
var dist_43 = dist.CompassFill;
var dist_44 = dist.CodepenCircleFill;
var dist_45 = dist.CodepenSquareFill;
var dist_46 = dist.ContactsFill;
var dist_47 = dist.ControlFill;
var dist_48 = dist.ContainerFill;
var dist_49 = dist.CopyFill;
var dist_50 = dist.CopyrightCircleFill;
var dist_51 = dist.CreditCardFill;
var dist_52 = dist.CrownFill;
var dist_53 = dist.CustomerServiceFill;
var dist_54 = dist.DashboardFill;
var dist_55 = dist.DeleteFill;
var dist_56 = dist.DiffFill;
var dist_57 = dist.DingtalkCircleFill;
var dist_58 = dist.DatabaseFill;
var dist_59 = dist.DingtalkSquareFill;
var dist_60 = dist.DislikeFill;
var dist_61 = dist.DollarCircleFill;
var dist_62 = dist.DownCircleFill;
var dist_63 = dist.DownSquareFill;
var dist_64 = dist.DribbbleCircleFill;
var dist_65 = dist.DribbbleSquareFill;
var dist_66 = dist.DropboxCircleFill;
var dist_67 = dist.DropboxSquareFill;
var dist_68 = dist.EnvironmentFill;
var dist_69 = dist.EditFill;
var dist_70 = dist.ExclamationCircleFill;
var dist_71 = dist.EuroCircleFill;
var dist_72 = dist.ExperimentFill;
var dist_73 = dist.EyeInvisibleFill;
var dist_74 = dist.EyeFill;
var dist_75 = dist.FacebookFill;
var dist_76 = dist.FastBackwardFill;
var dist_77 = dist.FastForwardFill;
var dist_78 = dist.FileAddFill;
var dist_79 = dist.FileExcelFill;
var dist_80 = dist.FileExclamationFill;
var dist_81 = dist.FileImageFill;
var dist_82 = dist.FileMarkdownFill;
var dist_83 = dist.FilePdfFill;
var dist_84 = dist.FilePptFill;
var dist_85 = dist.FileTextFill;
var dist_86 = dist.FileWordFill;
var dist_87 = dist.FileUnknownFill;
var dist_88 = dist.FileZipFill;
var dist_89 = dist.FileFill;
var dist_90 = dist.FilterFill;
var dist_91 = dist.FireFill;
var dist_92 = dist.FlagFill;
var dist_93 = dist.FolderAddFill;
var dist_94 = dist.FolderFill;
var dist_95 = dist.FolderOpenFill;
var dist_96 = dist.ForwardFill;
var dist_97 = dist.FrownFill;
var dist_98 = dist.FundFill;
var dist_99 = dist.FunnelPlotFill;
var dist_100 = dist.GiftFill;
var dist_101 = dist.GithubFill;
var dist_102 = dist.GitlabFill;
var dist_103 = dist.GoldenFill;
var dist_104 = dist.GoogleCircleFill;
var dist_105 = dist.GooglePlusCircleFill;
var dist_106 = dist.GooglePlusSquareFill;
var dist_107 = dist.GoogleSquareFill;
var dist_108 = dist.HddFill;
var dist_109 = dist.HeartFill;
var dist_110 = dist.HighlightFill;
var dist_111 = dist.HomeFill;
var dist_112 = dist.HourglassFill;
var dist_113 = dist.Html5Fill;
var dist_114 = dist.IdcardFill;
var dist_115 = dist.IeCircleFill;
var dist_116 = dist.IeSquareFill;
var dist_117 = dist.InfoCircleFill;
var dist_118 = dist.InstagramFill;
var dist_119 = dist.InsuranceFill;
var dist_120 = dist.InteractionFill;
var dist_121 = dist.InterationFill;
var dist_122 = dist.LayoutFill;
var dist_123 = dist.LeftCircleFill;
var dist_124 = dist.LeftSquareFill;
var dist_125 = dist.LikeFill;
var dist_126 = dist.LockFill;
var dist_127 = dist.LinkedinFill;
var dist_128 = dist.MailFill;
var dist_129 = dist.MedicineBoxFill;
var dist_130 = dist.MediumCircleFill;
var dist_131 = dist.MediumSquareFill;
var dist_132 = dist.MehFill;
var dist_133 = dist.MessageFill;
var dist_134 = dist.MinusCircleFill;
var dist_135 = dist.MinusSquareFill;
var dist_136 = dist.MobileFill;
var dist_137 = dist.MoneyCollectFill;
var dist_138 = dist.PauseCircleFill;
var dist_139 = dist.PayCircleFill;
var dist_140 = dist.NotificationFill;
var dist_141 = dist.PhoneFill;
var dist_142 = dist.PictureFill;
var dist_143 = dist.PieChartFill;
var dist_144 = dist.PlayCircleFill;
var dist_145 = dist.PlaySquareFill;
var dist_146 = dist.PlusCircleFill;
var dist_147 = dist.PlusSquareFill;
var dist_148 = dist.PoundCircleFill;
var dist_149 = dist.PrinterFill;
var dist_150 = dist.ProfileFill;
var dist_151 = dist.ProjectFill;
var dist_152 = dist.PushpinFill;
var dist_153 = dist.PropertySafetyFill;
var dist_154 = dist.QqCircleFill;
var dist_155 = dist.QqSquareFill;
var dist_156 = dist.QuestionCircleFill;
var dist_157 = dist.ReadFill;
var dist_158 = dist.ReconciliationFill;
var dist_159 = dist.RedEnvelopeFill;
var dist_160 = dist.RedditCircleFill;
var dist_161 = dist.RedditSquareFill;
var dist_162 = dist.RestFill;
var dist_163 = dist.RightCircleFill;
var dist_164 = dist.RocketFill;
var dist_165 = dist.RightSquareFill;
var dist_166 = dist.SafetyCertificateFill;
var dist_167 = dist.SaveFill;
var dist_168 = dist.ScheduleFill;
var dist_169 = dist.SecurityScanFill;
var dist_170 = dist.SettingFill;
var dist_171 = dist.ShopFill;
var dist_172 = dist.ShoppingFill;
var dist_173 = dist.SketchCircleFill;
var dist_174 = dist.SketchSquareFill;
var dist_175 = dist.SkinFill;
var dist_176 = dist.SlackCircleFill;
var dist_177 = dist.SlackSquareFill;
var dist_178 = dist.SkypeFill;
var dist_179 = dist.SlidersFill;
var dist_180 = dist.SmileFill;
var dist_181 = dist.SnippetsFill;
var dist_182 = dist.SoundFill;
var dist_183 = dist.StarFill;
var dist_184 = dist.StepBackwardFill;
var dist_185 = dist.StepForwardFill;
var dist_186 = dist.StopFill;
var dist_187 = dist.SwitcherFill;
var dist_188 = dist.TabletFill;
var dist_189 = dist.TagFill;
var dist_190 = dist.TagsFill;
var dist_191 = dist.TaobaoCircleFill;
var dist_192 = dist.TaobaoSquareFill;
var dist_193 = dist.ToolFill;
var dist_194 = dist.ThunderboltFill;
var dist_195 = dist.TrademarkCircleFill;
var dist_196 = dist.TwitterCircleFill;
var dist_197 = dist.TrophyFill;
var dist_198 = dist.TwitterSquareFill;
var dist_199 = dist.UnlockFill;
var dist_200 = dist.UpCircleFill;
var dist_201 = dist.UpSquareFill;
var dist_202 = dist.UsbFill;
var dist_203 = dist.WalletFill;
var dist_204 = dist.VideoCameraFill;
var dist_205 = dist.WarningFill;
var dist_206 = dist.WeiboCircleFill;
var dist_207 = dist.WechatFill;
var dist_208 = dist.WindowsFill;
var dist_209 = dist.YahooFill;
var dist_210 = dist.WeiboSquareFill;
var dist_211 = dist.YuqueFill;
var dist_212 = dist.YoutubeFill;
var dist_213 = dist.ZhihuSquareFill;
var dist_214 = dist.ZhihuCircleFill;
var dist_215 = dist.AccountBookOutline;
var dist_216 = dist.AlertOutline;
var dist_217 = dist.AlipayCircleOutline;
var dist_218 = dist.AliwangwangOutline;
var dist_219 = dist.AndroidOutline;
var dist_220 = dist.ApiOutline;
var dist_221 = dist.AppstoreOutline;
var dist_222 = dist.AudioOutline;
var dist_223 = dist.AppleOutline;
var dist_224 = dist.BackwardOutline;
var dist_225 = dist.BankOutline;
var dist_226 = dist.BellOutline;
var dist_227 = dist.BehanceSquareOutline;
var dist_228 = dist.BookOutline;
var dist_229 = dist.BoxPlotOutline;
var dist_230 = dist.BulbOutline;
var dist_231 = dist.BugOutline;
var dist_232 = dist.CalculatorOutline;
var dist_233 = dist.BuildOutline;
var dist_234 = dist.CalendarOutline;
var dist_235 = dist.CameraOutline;
var dist_236 = dist.CarOutline;
var dist_237 = dist.CaretDownOutline;
var dist_238 = dist.CaretLeftOutline;
var dist_239 = dist.CaretRightOutline;
var dist_240 = dist.CarryOutOutline;
var dist_241 = dist.CheckCircleOutline;
var dist_242 = dist.CaretUpOutline;
var dist_243 = dist.CheckSquareOutline;
var dist_244 = dist.ChromeOutline;
var dist_245 = dist.ClockCircleOutline;
var dist_246 = dist.CloseCircleOutline;
var dist_247 = dist.CloudOutline;
var dist_248 = dist.CloseSquareOutline;
var dist_249 = dist.CodeOutline;
var dist_250 = dist.CodepenCircleOutline;
var dist_251 = dist.CompassOutline;
var dist_252 = dist.ContactsOutline;
var dist_253 = dist.ContainerOutline;
var dist_254 = dist.ControlOutline;
var dist_255 = dist.CopyOutline;
var dist_256 = dist.CreditCardOutline;
var dist_257 = dist.CrownOutline;
var dist_258 = dist.CustomerServiceOutline;
var dist_259 = dist.DashboardOutline;
var dist_260 = dist.DeleteOutline;
var dist_261 = dist.DiffOutline;
var dist_262 = dist.DatabaseOutline;
var dist_263 = dist.DislikeOutline;
var dist_264 = dist.DownCircleOutline;
var dist_265 = dist.DownSquareOutline;
var dist_266 = dist.DribbbleSquareOutline;
var dist_267 = dist.EnvironmentOutline;
var dist_268 = dist.EditOutline;
var dist_269 = dist.ExclamationCircleOutline;
var dist_270 = dist.ExperimentOutline;
var dist_271 = dist.EyeInvisibleOutline;
var dist_272 = dist.EyeOutline;
var dist_273 = dist.FacebookOutline;
var dist_274 = dist.FastBackwardOutline;
var dist_275 = dist.FastForwardOutline;
var dist_276 = dist.FileAddOutline;
var dist_277 = dist.FileExcelOutline;
var dist_278 = dist.FileExclamationOutline;
var dist_279 = dist.FileImageOutline;
var dist_280 = dist.FileMarkdownOutline;
var dist_281 = dist.FilePptOutline;
var dist_282 = dist.FileTextOutline;
var dist_283 = dist.FilePdfOutline;
var dist_284 = dist.FileZipOutline;
var dist_285 = dist.FileOutline;
var dist_286 = dist.FilterOutline;
var dist_287 = dist.FileWordOutline;
var dist_288 = dist.FireOutline;
var dist_289 = dist.FileUnknownOutline;
var dist_290 = dist.FlagOutline;
var dist_291 = dist.FolderAddOutline;
var dist_292 = dist.FolderOutline;
var dist_293 = dist.FolderOpenOutline;
var dist_294 = dist.ForwardOutline;
var dist_295 = dist.FrownOutline;
var dist_296 = dist.FundOutline;
var dist_297 = dist.FunnelPlotOutline;
var dist_298 = dist.GiftOutline;
var dist_299 = dist.GithubOutline;
var dist_300 = dist.GitlabOutline;
var dist_301 = dist.HeartOutline;
var dist_302 = dist.HddOutline;
var dist_303 = dist.HighlightOutline;
var dist_304 = dist.HomeOutline;
var dist_305 = dist.HourglassOutline;
var dist_306 = dist.Html5Outline;
var dist_307 = dist.IdcardOutline;
var dist_308 = dist.InfoCircleOutline;
var dist_309 = dist.InstagramOutline;
var dist_310 = dist.InsuranceOutline;
var dist_311 = dist.InteractionOutline;
var dist_312 = dist.InterationOutline;
var dist_313 = dist.LayoutOutline;
var dist_314 = dist.LeftCircleOutline;
var dist_315 = dist.LeftSquareOutline;
var dist_316 = dist.LikeOutline;
var dist_317 = dist.LinkedinOutline;
var dist_318 = dist.LockOutline;
var dist_319 = dist.MedicineBoxOutline;
var dist_320 = dist.MehOutline;
var dist_321 = dist.MailOutline;
var dist_322 = dist.MessageOutline;
var dist_323 = dist.MinusCircleOutline;
var dist_324 = dist.MinusSquareOutline;
var dist_325 = dist.MobileOutline;
var dist_326 = dist.MoneyCollectOutline;
var dist_327 = dist.PauseCircleOutline;
var dist_328 = dist.PayCircleOutline;
var dist_329 = dist.NotificationOutline;
var dist_330 = dist.PhoneOutline;
var dist_331 = dist.PictureOutline;
var dist_332 = dist.PieChartOutline;
var dist_333 = dist.PlaySquareOutline;
var dist_334 = dist.PlayCircleOutline;
var dist_335 = dist.PlusCircleOutline;
var dist_336 = dist.PrinterOutline;
var dist_337 = dist.PlusSquareOutline;
var dist_338 = dist.ProfileOutline;
var dist_339 = dist.ProjectOutline;
var dist_340 = dist.PushpinOutline;
var dist_341 = dist.PropertySafetyOutline;
var dist_342 = dist.QuestionCircleOutline;
var dist_343 = dist.ReadOutline;
var dist_344 = dist.ReconciliationOutline;
var dist_345 = dist.RedEnvelopeOutline;
var dist_346 = dist.RestOutline;
var dist_347 = dist.RightCircleOutline;
var dist_348 = dist.RocketOutline;
var dist_349 = dist.RightSquareOutline;
var dist_350 = dist.SafetyCertificateOutline;
var dist_351 = dist.ScheduleOutline;
var dist_352 = dist.SaveOutline;
var dist_353 = dist.SecurityScanOutline;
var dist_354 = dist.SettingOutline;
var dist_355 = dist.ShoppingOutline;
var dist_356 = dist.SkinOutline;
var dist_357 = dist.SkypeOutline;
var dist_358 = dist.SlackSquareOutline;
var dist_359 = dist.SlidersOutline;
var dist_360 = dist.SmileOutline;
var dist_361 = dist.SnippetsOutline;
var dist_362 = dist.SoundOutline;
var dist_363 = dist.StarOutline;
var dist_364 = dist.StepBackwardOutline;
var dist_365 = dist.StepForwardOutline;
var dist_366 = dist.StopOutline;
var dist_367 = dist.SwitcherOutline;
var dist_368 = dist.TagOutline;
var dist_369 = dist.TabletOutline;
var dist_370 = dist.ShopOutline;
var dist_371 = dist.TagsOutline;
var dist_372 = dist.TaobaoCircleOutline;
var dist_373 = dist.ToolOutline;
var dist_374 = dist.ThunderboltOutline;
var dist_375 = dist.TrophyOutline;
var dist_376 = dist.UnlockOutline;
var dist_377 = dist.UpCircleOutline;
var dist_378 = dist.UpSquareOutline;
var dist_379 = dist.UsbOutline;
var dist_380 = dist.VideoCameraOutline;
var dist_381 = dist.WalletOutline;
var dist_382 = dist.WarningOutline;
var dist_383 = dist.WechatOutline;
var dist_384 = dist.WeiboCircleOutline;
var dist_385 = dist.WindowsOutline;
var dist_386 = dist.YahooOutline;
var dist_387 = dist.WeiboSquareOutline;
var dist_388 = dist.YuqueOutline;
var dist_389 = dist.YoutubeOutline;
var dist_390 = dist.AlibabaOutline;
var dist_391 = dist.AlignCenterOutline;
var dist_392 = dist.AlignLeftOutline;
var dist_393 = dist.AlignRightOutline;
var dist_394 = dist.AlipayOutline;
var dist_395 = dist.AliyunOutline;
var dist_396 = dist.AmazonOutline;
var dist_397 = dist.AntCloudOutline;
var dist_398 = dist.ApartmentOutline;
var dist_399 = dist.AntDesignOutline;
var dist_400 = dist.AreaChartOutline;
var dist_401 = dist.ArrowLeftOutline;
var dist_402 = dist.ArrowDownOutline;
var dist_403 = dist.ArrowUpOutline;
var dist_404 = dist.ArrowsAltOutline;
var dist_405 = dist.ArrowRightOutline;
var dist_406 = dist.AuditOutline;
var dist_407 = dist.BarChartOutline;
var dist_408 = dist.BarcodeOutline;
var dist_409 = dist.BarsOutline;
var dist_410 = dist.BgColorsOutline;
var dist_411 = dist.BehanceOutline;
var dist_412 = dist.BlockOutline;
var dist_413 = dist.BoldOutline;
var dist_414 = dist.BorderBottomOutline;
var dist_415 = dist.BorderLeftOutline;
var dist_416 = dist.BorderOuterOutline;
var dist_417 = dist.BorderInnerOutline;
var dist_418 = dist.BorderRightOutline;
var dist_419 = dist.BorderHorizontalOutline;
var dist_420 = dist.BorderTopOutline;
var dist_421 = dist.BorderVerticleOutline;
var dist_422 = dist.BorderOutline;
var dist_423 = dist.BranchesOutline;
var dist_424 = dist.CheckOutline;
var dist_425 = dist.CiOutline;
var dist_426 = dist.CloseOutline;
var dist_427 = dist.CloudDownloadOutline;
var dist_428 = dist.CloudServerOutline;
var dist_429 = dist.CloudSyncOutline;
var dist_430 = dist.CloudUploadOutline;
var dist_431 = dist.ClusterOutline;
var dist_432 = dist.CodepenOutline;
var dist_433 = dist.CodeSandboxOutline;
var dist_434 = dist.ColumHeightOutline;
var dist_435 = dist.ColumnWidthOutline;
var dist_436 = dist.ColumnHeightOutline;
var dist_437 = dist.CoffeeOutline;
var dist_438 = dist.CopyrightOutline;
var dist_439 = dist.DashOutline;
var dist_440 = dist.DeploymentUnitOutline;
var dist_441 = dist.DesktopOutline;
var dist_442 = dist.DingdingOutline;
var dist_443 = dist.DisconnectOutline;
var dist_444 = dist.DollarOutline;
var dist_445 = dist.DoubleRightOutline;
var dist_446 = dist.DotChartOutline;
var dist_447 = dist.DoubleLeftOutline;
var dist_448 = dist.DownloadOutline;
var dist_449 = dist.DribbbleOutline;
var dist_450 = dist.DropboxOutline;
var dist_451 = dist.EllipsisOutline;
var dist_452 = dist.EnterOutline;
var dist_453 = dist.EuroOutline;
var dist_454 = dist.ExceptionOutline;
var dist_455 = dist.ExclamationOutline;
var dist_456 = dist.ExportOutline;
var dist_457 = dist.FallOutline;
var dist_458 = dist.FileDoneOutline;
var dist_459 = dist.FileSyncOutline;
var dist_460 = dist.FileProtectOutline;
var dist_461 = dist.FileSearchOutline;
var dist_462 = dist.FileJpgOutline;
var dist_463 = dist.FontColorsOutline;
var dist_464 = dist.FontSizeOutline;
var dist_465 = dist.ForkOutline;
var dist_466 = dist.FormOutline;
var dist_467 = dist.FullscreenExitOutline;
var dist_468 = dist.FullscreenOutline;
var dist_469 = dist.GatewayOutline;
var dist_470 = dist.DownOutline;
var dist_471 = dist.DragOutline;
var dist_472 = dist.GlobalOutline;
var dist_473 = dist.GooglePlusOutline;
var dist_474 = dist.GoogleOutline;
var dist_475 = dist.HeatMapOutline;
var dist_476 = dist.GoldOutline;
var dist_477 = dist.HistoryOutline;
var dist_478 = dist.IeOutline;
var dist_479 = dist.InboxOutline;
var dist_480 = dist.ImportOutline;
var dist_481 = dist.InfoOutline;
var dist_482 = dist.ItalicOutline;
var dist_483 = dist.IssuesCloseOutline;
var dist_484 = dist.KeyOutline;
var dist_485 = dist.LaptopOutline;
var dist_486 = dist.LeftOutline;
var dist_487 = dist.LinkOutline;
var dist_488 = dist.LineChartOutline;
var dist_489 = dist.LineHeightOutline;
var dist_490 = dist.LineOutline;
var dist_491 = dist.Loading3QuartersOutline;
var dist_492 = dist.LoadingOutline;
var dist_493 = dist.LoginOutline;
var dist_494 = dist.LogoutOutline;
var dist_495 = dist.ManOutline;
var dist_496 = dist.MediumOutline;
var dist_497 = dist.MediumWorkmarkOutline;
var dist_498 = dist.MenuUnfoldOutline;
var dist_499 = dist.MenuFoldOutline;
var dist_500 = dist.MenuOutline;
var dist_501 = dist.MinusOutline;
var dist_502 = dist.MonitorOutline;
var dist_503 = dist.MoreOutline;
var dist_504 = dist.OrderedListOutline;
var dist_505 = dist.NumberOutline;
var dist_506 = dist.PauseOutline;
var dist_507 = dist.PercentageOutline;
var dist_508 = dist.PaperClipOutline;
var dist_509 = dist.PicCenterOutline;
var dist_510 = dist.PicLeftOutline;
var dist_511 = dist.PlusOutline;
var dist_512 = dist.PicRightOutline;
var dist_513 = dist.PoundOutline;
var dist_514 = dist.PoweroffOutline;
var dist_515 = dist.PullRequestOutline;
var dist_516 = dist.QqOutline;
var dist_517 = dist.QuestionOutline;
var dist_518 = dist.RadarChartOutline;
var dist_519 = dist.QrcodeOutline;
var dist_520 = dist.RadiusBottomleftOutline;
var dist_521 = dist.RadiusBottomrightOutline;
var dist_522 = dist.RadiusUpleftOutline;
var dist_523 = dist.RadiusUprightOutline;
var dist_524 = dist.RadiusSettingOutline;
var dist_525 = dist.RedditOutline;
var dist_526 = dist.RedoOutline;
var dist_527 = dist.ReloadOutline;
var dist_528 = dist.RetweetOutline;
var dist_529 = dist.RightOutline;
var dist_530 = dist.RiseOutline;
var dist_531 = dist.RollbackOutline;
var dist_532 = dist.SafetyOutline;
var dist_533 = dist.RobotOutline;
var dist_534 = dist.SearchOutline;
var dist_535 = dist.ScanOutline;
var dist_536 = dist.ScissorOutline;
var dist_537 = dist.SelectOutline;
var dist_538 = dist.ShakeOutline;
var dist_539 = dist.ShareAltOutline;
var dist_540 = dist.ShoppingCartOutline;
var dist_541 = dist.ShrinkOutline;
var dist_542 = dist.SlackOutline;
var dist_543 = dist.SmallDashOutline;
var dist_544 = dist.SolutionOutline;
var dist_545 = dist.SketchOutline;
var dist_546 = dist.SortDescendingOutline;
var dist_547 = dist.SortAscendingOutline;
var dist_548 = dist.StockOutline;
var dist_549 = dist.SwapLeftOutline;
var dist_550 = dist.SwapRightOutline;
var dist_551 = dist.StrikethroughOutline;
var dist_552 = dist.SwapOutline;
var dist_553 = dist.SyncOutline;
var dist_554 = dist.TableOutline;
var dist_555 = dist.TeamOutline;
var dist_556 = dist.TaobaoOutline;
var dist_557 = dist.ToTopOutline;
var dist_558 = dist.TrademarkOutline;
var dist_559 = dist.TransactionOutline;
var dist_560 = dist.TwitterOutline;
var dist_561 = dist.UnderlineOutline;
var dist_562 = dist.UndoOutline;
var dist_563 = dist.UnorderedListOutline;
var dist_564 = dist.UpOutline;
var dist_565 = dist.UploadOutline;
var dist_566 = dist.UserAddOutline;
var dist_567 = dist.UsergroupAddOutline;
var dist_568 = dist.UserOutline;
var dist_569 = dist.UserDeleteOutline;
var dist_570 = dist.UsergroupDeleteOutline;
var dist_571 = dist.VerticalAlignBottomOutline;
var dist_572 = dist.VerticalAlignMiddleOutline;
var dist_573 = dist.VerticalAlignTopOutline;
var dist_574 = dist.VerticalRightOutline;
var dist_575 = dist.VerticalLeftOutline;
var dist_576 = dist.WifiOutline;
var dist_577 = dist.ZhihuOutline;
var dist_578 = dist.WeiboOutline;
var dist_579 = dist.WomanOutline;
var dist_580 = dist.ZoomInOutline;
var dist_581 = dist.AccountBookTwoTone;
var dist_582 = dist.ZoomOutOutline;
var dist_583 = dist.AlertTwoTone;
var dist_584 = dist.ApiTwoTone;
var dist_585 = dist.AppstoreTwoTone;
var dist_586 = dist.BankTwoTone;
var dist_587 = dist.AudioTwoTone;
var dist_588 = dist.BellTwoTone;
var dist_589 = dist.BookTwoTone;
var dist_590 = dist.BoxPlotTwoTone;
var dist_591 = dist.BugTwoTone;
var dist_592 = dist.BulbTwoTone;
var dist_593 = dist.CalculatorTwoTone;
var dist_594 = dist.BuildTwoTone;
var dist_595 = dist.CalendarTwoTone;
var dist_596 = dist.CameraTwoTone;
var dist_597 = dist.CarTwoTone;
var dist_598 = dist.CarryOutTwoTone;
var dist_599 = dist.CheckCircleTwoTone;
var dist_600 = dist.CheckSquareTwoTone;
var dist_601 = dist.ClockCircleTwoTone;
var dist_602 = dist.CloseCircleTwoTone;
var dist_603 = dist.CloudTwoTone;
var dist_604 = dist.CloseSquareTwoTone;
var dist_605 = dist.CodeTwoTone;
var dist_606 = dist.CompassTwoTone;
var dist_607 = dist.ContactsTwoTone;
var dist_608 = dist.ContainerTwoTone;
var dist_609 = dist.ControlTwoTone;
var dist_610 = dist.CopyTwoTone;
var dist_611 = dist.CreditCardTwoTone;
var dist_612 = dist.CrownTwoTone;
var dist_613 = dist.CustomerServiceTwoTone;
var dist_614 = dist.DashboardTwoTone;
var dist_615 = dist.DeleteTwoTone;
var dist_616 = dist.DiffTwoTone;
var dist_617 = dist.DatabaseTwoTone;
var dist_618 = dist.DislikeTwoTone;
var dist_619 = dist.DownCircleTwoTone;
var dist_620 = dist.DownSquareTwoTone;
var dist_621 = dist.EnvironmentTwoTone;
var dist_622 = dist.EditTwoTone;
var dist_623 = dist.ExclamationCircleTwoTone;
var dist_624 = dist.ExperimentTwoTone;
var dist_625 = dist.EyeInvisibleTwoTone;
var dist_626 = dist.EyeTwoTone;
var dist_627 = dist.FileAddTwoTone;
var dist_628 = dist.FileExclamationTwoTone;
var dist_629 = dist.FileImageTwoTone;
var dist_630 = dist.FileExcelTwoTone;
var dist_631 = dist.FileMarkdownTwoTone;
var dist_632 = dist.FilePdfTwoTone;
var dist_633 = dist.FilePptTwoTone;
var dist_634 = dist.FileTextTwoTone;
var dist_635 = dist.FileUnknownTwoTone;
var dist_636 = dist.FileZipTwoTone;
var dist_637 = dist.FileWordTwoTone;
var dist_638 = dist.FileTwoTone;
var dist_639 = dist.FilterTwoTone;
var dist_640 = dist.FireTwoTone;
var dist_641 = dist.FolderAddTwoTone;
var dist_642 = dist.FlagTwoTone;
var dist_643 = dist.FolderTwoTone;
var dist_644 = dist.FolderOpenTwoTone;
var dist_645 = dist.FrownTwoTone;
var dist_646 = dist.FundTwoTone;
var dist_647 = dist.FunnelPlotTwoTone;
var dist_648 = dist.GiftTwoTone;
var dist_649 = dist.HddTwoTone;
var dist_650 = dist.HeartTwoTone;
var dist_651 = dist.HighlightTwoTone;
var dist_652 = dist.HomeTwoTone;
var dist_653 = dist.HourglassTwoTone;
var dist_654 = dist.Html5TwoTone;
var dist_655 = dist.IdcardTwoTone;
var dist_656 = dist.InfoCircleTwoTone;
var dist_657 = dist.InsuranceTwoTone;
var dist_658 = dist.InteractionTwoTone;
var dist_659 = dist.InterationTwoTone;
var dist_660 = dist.LayoutTwoTone;
var dist_661 = dist.LeftCircleTwoTone;
var dist_662 = dist.LeftSquareTwoTone;
var dist_663 = dist.LikeTwoTone;
var dist_664 = dist.LockTwoTone;
var dist_665 = dist.MailTwoTone;
var dist_666 = dist.MedicineBoxTwoTone;
var dist_667 = dist.MehTwoTone;
var dist_668 = dist.MessageTwoTone;
var dist_669 = dist.MinusCircleTwoTone;
var dist_670 = dist.MinusSquareTwoTone;
var dist_671 = dist.MobileTwoTone;
var dist_672 = dist.PauseCircleTwoTone;
var dist_673 = dist.MoneyCollectTwoTone;
var dist_674 = dist.NotificationTwoTone;
var dist_675 = dist.PhoneTwoTone;
var dist_676 = dist.PictureTwoTone;
var dist_677 = dist.PlayCircleTwoTone;
var dist_678 = dist.PlaySquareTwoTone;
var dist_679 = dist.PieChartTwoTone;
var dist_680 = dist.PlusCircleTwoTone;
var dist_681 = dist.PlusSquareTwoTone;
var dist_682 = dist.PoundCircleTwoTone;
var dist_683 = dist.PrinterTwoTone;
var dist_684 = dist.ProfileTwoTone;
var dist_685 = dist.ProjectTwoTone;
var dist_686 = dist.PushpinTwoTone;
var dist_687 = dist.PropertySafetyTwoTone;
var dist_688 = dist.QuestionCircleTwoTone;
var dist_689 = dist.ReconciliationTwoTone;
var dist_690 = dist.RedEnvelopeTwoTone;
var dist_691 = dist.RestTwoTone;
var dist_692 = dist.RightCircleTwoTone;
var dist_693 = dist.RocketTwoTone;
var dist_694 = dist.RightSquareTwoTone;
var dist_695 = dist.SafetyCertificateTwoTone;
var dist_696 = dist.SaveTwoTone;
var dist_697 = dist.ScheduleTwoTone;
var dist_698 = dist.SecurityScanTwoTone;
var dist_699 = dist.SettingTwoTone;
var dist_700 = dist.ShopTwoTone;
var dist_701 = dist.ShoppingTwoTone;
var dist_702 = dist.SkinTwoTone;
var dist_703 = dist.SlidersTwoTone;
var dist_704 = dist.SmileTwoTone;
var dist_705 = dist.SnippetsTwoTone;
var dist_706 = dist.SoundTwoTone;
var dist_707 = dist.StarTwoTone;
var dist_708 = dist.StopTwoTone;
var dist_709 = dist.SwitcherTwoTone;
var dist_710 = dist.TabletTwoTone;
var dist_711 = dist.TagTwoTone;
var dist_712 = dist.TagsTwoTone;
var dist_713 = dist.ToolTwoTone;
var dist_714 = dist.TrademarkCircleTwoTone;
var dist_715 = dist.UnlockTwoTone;
var dist_716 = dist.TrophyTwoTone;
var dist_717 = dist.UpCircleTwoTone;
var dist_718 = dist.ThunderboltTwoTone;
var dist_719 = dist.UpSquareTwoTone;
var dist_720 = dist.UsbTwoTone;
var dist_721 = dist.VideoCameraTwoTone;
var dist_722 = dist.WalletTwoTone;
var dist_723 = dist.WarningTwoTone;
var dist_724 = dist.CiTwoTone;
var dist_725 = dist.CopyrightTwoTone;
var dist_726 = dist.DollarTwoTone;
var dist_727 = dist.EuroTwoTone;
var dist_728 = dist.GoldTwoTone;
var dist_729 = dist.CanlendarTwoTone;
var objectWithoutProperties = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };
});

var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

var tinycolor = createCommonjsModule(function (module) {
  // TinyColor v1.4.1
  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License
  (function (Math) {
    var trimLeft = /^\s+/,
        trimRight = /\s+$/,
        tinyCounter = 0,
        mathRound = Math.round,
        mathMin = Math.min,
        mathMax = Math.max,
        mathRandom = Math.random;

    function tinycolor(color, opts) {
      color = color ? color : '';
      opts = opts || {}; // If input is already a tinycolor, return itself

      if (color instanceof tinycolor) {
        return color;
      } // If we are called as a function, call using new instead


      if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
      }

      var rgb = inputToRGB(color);
      this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
      this._gradientType = opts.gradientType; // Don't let the range of [0,255] come back in [0,1].
      // Potentially lose a little bit of precision here, but will fix issues where
      // .5 gets interpreted as half of the total, instead of half of 1
      // If it was supposed to be 128, this was already taken care of by `inputToRgb`

      if (this._r < 1) {
        this._r = mathRound(this._r);
      }

      if (this._g < 1) {
        this._g = mathRound(this._g);
      }

      if (this._b < 1) {
        this._b = mathRound(this._b);
      }

      this._ok = rgb.ok;
      this._tc_id = tinyCounter++;
    }

    tinycolor.prototype = {
      isDark: function isDark() {
        return this.getBrightness() < 128;
      },
      isLight: function isLight() {
        return !this.isDark();
      },
      isValid: function isValid() {
        return this._ok;
      },
      getOriginalInput: function getOriginalInput() {
        return this._originalInput;
      },
      getFormat: function getFormat() {
        return this._format;
      },
      getAlpha: function getAlpha() {
        return this._a;
      },
      getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
      },
      getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;

        if (RsRGB <= 0.03928) {
          R = RsRGB / 12.92;
        } else {
          R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        }

        if (GsRGB <= 0.03928) {
          G = GsRGB / 12.92;
        } else {
          G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        }

        if (BsRGB <= 0.03928) {
          B = BsRGB / 12.92;
        } else {
          B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        }

        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
      },
      setAlpha: function setAlpha(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100 * this._a) / 100;
        return this;
      },
      toHsv: function toHsv() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return {
          h: hsv.h * 360,
          s: hsv.s,
          v: hsv.v,
          a: this._a
        };
      },
      toHsvString: function toHsvString() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360),
            s = mathRound(hsv.s * 100),
            v = mathRound(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
      },
      toHsl: function toHsl() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return {
          h: hsl.h * 360,
          s: hsl.s,
          l: hsl.l,
          a: this._a
        };
      },
      toHslString: function toHslString() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360),
            s = mathRound(hsl.s * 100),
            l = mathRound(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
      },
      toHex: function toHex(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
      },
      toHexString: function toHexString(allow3Char) {
        return '#' + this.toHex(allow3Char);
      },
      toHex8: function toHex8(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
      },
      toHex8String: function toHex8String(allow4Char) {
        return '#' + this.toHex8(allow4Char);
      },
      toRgb: function toRgb() {
        return {
          r: mathRound(this._r),
          g: mathRound(this._g),
          b: mathRound(this._b),
          a: this._a
        };
      },
      toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function toPercentageRgb() {
        return {
          r: mathRound(bound01(this._r, 255) * 100) + "%",
          g: mathRound(bound01(this._g, 255) * 100) + "%",
          b: mathRound(bound01(this._b, 255) * 100) + "%",
          a: this._a
        };
      },
      toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function toName() {
        if (this._a === 0) {
          return "transparent";
        }

        if (this._a < 1) {
          return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
      },
      toFilter: function toFilter(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
          var s = tinycolor(secondColor);
          secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
      },
      toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
          // Special case for "transparent", all other non-alpha formats
          // will return rgba when there is transparency.
          if (format === "name" && this._a === 0) {
            return this.toName();
          }

          return this.toRgbString();
        }

        if (format === "rgb") {
          formattedString = this.toRgbString();
        }

        if (format === "prgb") {
          formattedString = this.toPercentageRgbString();
        }

        if (format === "hex" || format === "hex6") {
          formattedString = this.toHexString();
        }

        if (format === "hex3") {
          formattedString = this.toHexString(true);
        }

        if (format === "hex4") {
          formattedString = this.toHex8String(true);
        }

        if (format === "hex8") {
          formattedString = this.toHex8String();
        }

        if (format === "name") {
          formattedString = this.toName();
        }

        if (format === "hsl") {
          formattedString = this.toHslString();
        }

        if (format === "hsv") {
          formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
      },
      clone: function clone() {
        return tinycolor(this.toString());
      },
      _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
      },
      lighten: function lighten() {
        return this._applyModification(_lighten, arguments);
      },
      brighten: function brighten() {
        return this._applyModification(_brighten, arguments);
      },
      darken: function darken() {
        return this._applyModification(_darken, arguments);
      },
      desaturate: function desaturate() {
        return this._applyModification(_desaturate, arguments);
      },
      saturate: function saturate() {
        return this._applyModification(_saturate, arguments);
      },
      greyscale: function greyscale() {
        return this._applyModification(_greyscale, arguments);
      },
      spin: function spin() {
        return this._applyModification(_spin, arguments);
      },
      _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
      },
      analogous: function analogous() {
        return this._applyCombination(_analogous, arguments);
      },
      complement: function complement() {
        return this._applyCombination(_complement, arguments);
      },
      monochromatic: function monochromatic() {
        return this._applyCombination(_monochromatic, arguments);
      },
      splitcomplement: function splitcomplement() {
        return this._applyCombination(_splitcomplement, arguments);
      },
      triad: function triad() {
        return this._applyCombination(_triad, arguments);
      },
      tetrad: function tetrad() {
        return this._applyCombination(_tetrad, arguments);
      }
    }; // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1

    tinycolor.fromRatio = function (color, opts) {
      if (typeof color == "object") {
        var newColor = {};

        for (var i in color) {
          if (color.hasOwnProperty(i)) {
            if (i === "a") {
              newColor[i] = color[i];
            } else {
              newColor[i] = convertToPercentage(color[i]);
            }
          }
        }

        color = newColor;
      }

      return tinycolor(color, opts);
    }; // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //


    function inputToRGB(color) {
      var rgb = {
        r: 0,
        g: 0,
        b: 0
      };
      var a = 1;
      var s = null;
      var v = null;
      var l = null;
      var ok = false;
      var format = false;

      if (typeof color == "string") {
        color = stringInputToObject(color);
      }

      if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
          rgb = rgbToRgb(color.r, color.g, color.b);
          ok = true;
          format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
          s = convertToPercentage(color.s);
          v = convertToPercentage(color.v);
          rgb = hsvToRgb(color.h, s, v);
          ok = true;
          format = "hsv";
        } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
          s = convertToPercentage(color.s);
          l = convertToPercentage(color.l);
          rgb = hslToRgb(color.h, s, l);
          ok = true;
          format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
          a = color.a;
        }
      }

      a = boundAlpha(a);
      return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
      };
    } // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]


    function rgbToRgb(r, g, b) {
      return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
      };
    } // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]


    function rgbToHsl(r, g, b) {
      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);
      var max = mathMax(r, g, b),
          min = mathMin(r, g, b);
      var h,
          s,
          l = (max + min) / 2;

      if (max == min) {
        h = s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      return {
        h: h,
        s: s,
        l: l
      };
    } // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]


    function hslToRgb(h, s, l) {
      var r, g, b;
      h = bound01(h, 360);
      s = bound01(s, 100);
      l = bound01(l, 100);

      function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }

      if (s === 0) {
        r = g = b = l; // achromatic
      } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      return {
        r: r * 255,
        g: g * 255,
        b: b * 255
      };
    } // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]


    function rgbToHsv(r, g, b) {
      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);
      var max = mathMax(r, g, b),
          min = mathMin(r, g, b);
      var h,
          s,
          v = max;
      var d = max - min;
      s = max === 0 ? 0 : d / max;

      if (max == min) {
        h = 0; // achromatic
      } else {
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      return {
        h: h,
        s: s,
        v: v
      };
    } // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]


    function hsvToRgb(h, s, v) {
      h = bound01(h, 360) * 6;
      s = bound01(s, 100);
      v = bound01(v, 100);
      var i = Math.floor(h),
          f = h - i,
          p = v * (1 - s),
          q = v * (1 - f * s),
          t = v * (1 - (1 - f) * s),
          mod = i % 6,
          r = [v, q, p, p, t, v][mod],
          g = [t, v, v, q, p, p][mod],
          b = [p, p, t, v, v, q][mod];
      return {
        r: r * 255,
        g: g * 255,
        b: b * 255
      };
    } // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex


    function rgbToHex(r, g, b, allow3Char) {
      var hex = [pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16))]; // Return a 3 character hex if possible

      if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
      }

      return hex.join("");
    } // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex


    function rgbaToHex(r, g, b, a, allow4Char) {
      var hex = [pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16)), pad2(convertDecimalToHex(a))]; // Return a 4 character hex if possible

      if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
      }

      return hex.join("");
    } // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"


    function rgbaToArgbHex(r, g, b, a) {
      var hex = [pad2(convertDecimalToHex(a)), pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16))];
      return hex.join("");
    } // `equals`
    // Can be called with any tinycolor input


    tinycolor.equals = function (color1, color2) {
      if (!color1 || !color2) {
        return false;
      }

      return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };

    tinycolor.random = function () {
      return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
      });
    }; // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>


    function _desaturate(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.s -= amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
    }

    function _saturate(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.s += amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
    }

    function _greyscale(color) {
      return tinycolor(color).desaturate(100);
    }

    function _lighten(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.l += amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
    }

    function _brighten(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var rgb = tinycolor(color).toRgb();
      rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
      rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
      rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
      return tinycolor(rgb);
    }

    function _darken(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.l -= amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
    } // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.


    function _spin(color, amount) {
      var hsl = tinycolor(color).toHsl();
      var hue = (hsl.h + amount) % 360;
      hsl.h = hue < 0 ? 360 + hue : hue;
      return tinycolor(hsl);
    } // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>


    function _complement(color) {
      var hsl = tinycolor(color).toHsl();
      hsl.h = (hsl.h + 180) % 360;
      return tinycolor(hsl);
    }

    function _triad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 120) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 240) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }

    function _tetrad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 90) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 180) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 270) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }

    function _splitcomplement(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 72) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 216) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }

    function _analogous(color, results, slices) {
      results = results || 6;
      slices = slices || 30;
      var hsl = tinycolor(color).toHsl();
      var part = 360 / slices;
      var ret = [tinycolor(color)];

      for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
      }

      return ret;
    }

    function _monochromatic(color, results) {
      results = results || 6;
      var hsv = tinycolor(color).toHsv();
      var h = hsv.h,
          s = hsv.s,
          v = hsv.v;
      var ret = [];
      var modification = 1 / results;

      while (results--) {
        ret.push(tinycolor({
          h: h,
          s: s,
          v: v
        }));
        v = (v + modification) % 1;
      }

      return ret;
    } // Utility Functions
    // ---------------------


    tinycolor.mix = function (color1, color2, amount) {
      amount = amount === 0 ? 0 : amount || 50;
      var rgb1 = tinycolor(color1).toRgb();
      var rgb2 = tinycolor(color2).toRgb();
      var p = amount / 100;
      var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
      };
      return tinycolor(rgba);
    }; // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)


    tinycolor.readability = function (color1, color2) {
      var c1 = tinycolor(color1);
      var c2 = tinycolor(color2);
      return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    }; // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false


    tinycolor.isReadable = function (color1, color2, wcag2) {
      var readability = tinycolor.readability(color1, color2);
      var wcag2Parms, out;
      out = false;
      wcag2Parms = validateWCAG2Parms(wcag2);

      switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
          out = readability >= 4.5;
          break;

        case "AAlarge":
          out = readability >= 3;
          break;

        case "AAAsmall":
          out = readability >= 7;
          break;
      }

      return out;
    }; // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"


    tinycolor.mostReadable = function (baseColor, colorList, args) {
      var bestColor = null;
      var bestScore = 0;
      var readability;
      var includeFallbackColors, level, size;
      args = args || {};
      includeFallbackColors = args.includeFallbackColors;
      level = args.level;
      size = args.size;

      for (var i = 0; i < colorList.length; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);

        if (readability > bestScore) {
          bestScore = readability;
          bestColor = tinycolor(colorList[i]);
        }
      }

      if (tinycolor.isReadable(baseColor, bestColor, {
        "level": level,
        "size": size
      }) || !includeFallbackColors) {
        return bestColor;
      } else {
        args.includeFallbackColors = false;
        return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
      }
    }; // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>


    var names = tinycolor.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    }; // Make it easy to access colors via `hexNames[hex]`

    var hexNames = tinycolor.hexNames = flip(names); // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`

    function flip(o) {
      var flipped = {};

      for (var i in o) {
        if (o.hasOwnProperty(i)) {
          flipped[o[i]] = i;
        }
      }

      return flipped;
    } // Return a valid alpha value [0,1] with all invalid values being set to 1


    function boundAlpha(a) {
      a = parseFloat(a);

      if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
      }

      return a;
    } // Take input from [0, n] and return it as [0, 1]


    function bound01(n, max) {
      if (isOnePointZero(n)) {
        n = "100%";
      }

      var processPercent = isPercentage(n);
      n = mathMin(max, mathMax(0, parseFloat(n))); // Automatically convert percentage into number

      if (processPercent) {
        n = parseInt(n * max, 10) / 100;
      } // Handle floating point rounding errors


      if (Math.abs(n - max) < 0.000001) {
        return 1;
      } // Convert into [0, 1] range if it isn't already


      return n % max / parseFloat(max);
    } // Force a number between 0 and 1


    function clamp01(val) {
      return mathMin(1, mathMax(0, val));
    } // Parse a base-16 hex value into a base-10 integer


    function parseIntFromHex(val) {
      return parseInt(val, 16);
    } // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>


    function isOnePointZero(n) {
      return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    } // Check to see if string passed in is a percentage


    function isPercentage(n) {
      return typeof n === "string" && n.indexOf('%') != -1;
    } // Force a hex value to have 2 characters


    function pad2(c) {
      return c.length == 1 ? '0' + c : '' + c;
    } // Replace a decimal with it's percentage value


    function convertToPercentage(n) {
      if (n <= 1) {
        n = n * 100 + "%";
      }

      return n;
    } // Converts a decimal to a hex value


    function convertDecimalToHex(d) {
      return Math.round(parseFloat(d) * 255).toString(16);
    } // Converts a hex value to a decimal


    function convertHexToDecimal(h) {
      return parseIntFromHex(h) / 255;
    }

    var matchers = function () {
      // <http://www.w3.org/TR/css3-values/#integers>
      var CSS_INTEGER = "[-\\+]?\\d+%?"; // <http://www.w3.org/TR/css3-values/#number-value>

      var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?"; // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.

      var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")"; // Actual matching.
      // Parentheses and commas are optional, but not required.
      // Whitespace can take the place of commas or opening paren

      var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }(); // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).


    function isValidCSSUnit(color) {
      return !!matchers.CSS_UNIT.exec(color);
    } // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`


    function stringInputToObject(color) {
      color = color.replace(trimLeft, '').replace(trimRight, '').toLowerCase();
      var named = false;

      if (names[color]) {
        color = names[color];
        named = true;
      } else if (color == 'transparent') {
        return {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
          format: "name"
        };
      } // Try to match string input using regular expressions.
      // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
      // Just return an object and let the conversion functions handle that.
      // This way the result will be the same whether the tinycolor is initialized with string or object.


      var match;

      if (match = matchers.rgb.exec(color)) {
        return {
          r: match[1],
          g: match[2],
          b: match[3]
        };
      }

      if (match = matchers.rgba.exec(color)) {
        return {
          r: match[1],
          g: match[2],
          b: match[3],
          a: match[4]
        };
      }

      if (match = matchers.hsl.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          l: match[3]
        };
      }

      if (match = matchers.hsla.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          l: match[3],
          a: match[4]
        };
      }

      if (match = matchers.hsv.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          v: match[3]
        };
      }

      if (match = matchers.hsva.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          v: match[3],
          a: match[4]
        };
      }

      if (match = matchers.hex8.exec(color)) {
        return {
          r: parseIntFromHex(match[1]),
          g: parseIntFromHex(match[2]),
          b: parseIntFromHex(match[3]),
          a: convertHexToDecimal(match[4]),
          format: named ? "name" : "hex8"
        };
      }

      if (match = matchers.hex6.exec(color)) {
        return {
          r: parseIntFromHex(match[1]),
          g: parseIntFromHex(match[2]),
          b: parseIntFromHex(match[3]),
          format: named ? "name" : "hex"
        };
      }

      if (match = matchers.hex4.exec(color)) {
        return {
          r: parseIntFromHex(match[1] + '' + match[1]),
          g: parseIntFromHex(match[2] + '' + match[2]),
          b: parseIntFromHex(match[3] + '' + match[3]),
          a: convertHexToDecimal(match[4] + '' + match[4]),
          format: named ? "name" : "hex8"
        };
      }

      if (match = matchers.hex3.exec(color)) {
        return {
          r: parseIntFromHex(match[1] + '' + match[1]),
          g: parseIntFromHex(match[2] + '' + match[2]),
          b: parseIntFromHex(match[3] + '' + match[3]),
          format: named ? "name" : "hex"
        };
      }

      return false;
    }

    function validateWCAG2Parms(parms) {
      // return valid WCAG2 parms for isReadable.
      // If input parms are invalid, return {"level":"AA", "size":"small"}
      var level, size;
      parms = parms || {
        "level": "AA",
        "size": "small"
      };
      level = (parms.level || "AA").toUpperCase();
      size = (parms.size || "small").toLowerCase();

      if (level !== "AA" && level !== "AAA") {
        level = "AA";
      }

      if (size !== "small" && size !== "large") {
        size = "small";
      }

      return {
        "level": level,
        "size": size
      };
    } // Node: Export function


    if (module.exports) {
      module.exports = tinycolor;
    } // AMD/requirejs: Define the module
    else {
        window.tinycolor = tinycolor;
      }
  })(Math);
});
var generate_1 = createCommonjsModule(function (module, exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var tinycolor2_1 = __importDefault(tinycolor);

  var hueStep = 2; // 色相阶梯

  var saturationStep = 16; // 饱和度阶梯，浅色部分

  var saturationStep2 = 5; // 饱和度阶梯，深色部分

  var brightnessStep1 = 5; // 亮度阶梯，浅色部分

  var brightnessStep2 = 15; // 亮度阶梯，深色部分

  var lightColorCount = 5; // 浅色数量，主色上

  var darkColorCount = 4; // 深色数量，主色下

  function getHue(hsv, i, light) {
    var hue; // 根据色相不同，色相转向不同

    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
      hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
    } else {
      hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
    }

    if (hue < 0) {
      hue += 360;
    } else if (hue >= 360) {
      hue -= 360;
    }

    return hue;
  }

  function getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) {
      return hsv.s;
    }

    var saturation;

    if (light) {
      saturation = Math.round(hsv.s * 100) - saturationStep * i;
    } else if (i === darkColorCount) {
      saturation = Math.round(hsv.s * 100) + saturationStep;
    } else {
      saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
    } // 边界值修正


    if (saturation > 100) {
      saturation = 100;
    } // 第一格的 s 限制在 6-10 之间


    if (light && i === lightColorCount && saturation > 10) {
      saturation = 10;
    }

    if (saturation < 6) {
      saturation = 6;
    }

    return saturation;
  }

  function getValue(hsv, i, light) {
    if (light) {
      return Math.round(hsv.v * 100) + brightnessStep1 * i;
    }

    return Math.round(hsv.v * 100) - brightnessStep2 * i;
  }

  function generate(color) {
    var patterns = [];
    var pColor = tinycolor2_1.default(color);

    for (var i = lightColorCount; i > 0; i -= 1) {
      var hsv = pColor.toHsv();
      var colorString = tinycolor2_1.default({
        h: getHue(hsv, i, true),
        s: getSaturation(hsv, i, true),
        v: getValue(hsv, i, true)
      }).toHexString();
      patterns.push(colorString);
    }

    patterns.push(pColor.toHexString());

    for (var i = 1; i <= darkColorCount; i += 1) {
      var hsv = pColor.toHsv();
      var colorString = tinycolor2_1.default({
        h: getHue(hsv, i),
        s: getSaturation(hsv, i),
        v: getValue(hsv, i)
      }).toHexString();
      patterns.push(colorString);
    }

    return patterns;
  }

  exports.default = generate;
});
unwrapExports(generate_1);
var lib$1 = createCommonjsModule(function (module, exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var generate_1$$1 = __importDefault(generate_1);

  exports.generate = generate_1$$1.default;
  var presetPrimaryColors = {
    red: '#F5222D',
    volcano: '#FA541C',
    orange: '#FA8C16',
    gold: '#FAAD14',
    yellow: '#FADB14',
    lime: '#A0D911',
    green: '#52C41A',
    cyan: '#13C2C2',
    blue: '#1890FF',
    geekblue: '#2F54EB',
    purple: '#722ED1',
    magenta: '#EB2F96',
    grey: '#666666'
  };
  exports.presetPrimaryColors = presetPrimaryColors;
  var presetPalettes = {};
  exports.presetPalettes = presetPalettes;
  Object.keys(presetPrimaryColors).forEach(function (key) {
    presetPalettes[key] = generate_1$$1.default(presetPrimaryColors[key]);
    presetPalettes[key].primary = presetPalettes[key][5];
  });
  var red = presetPalettes.red;
  exports.red = red;
  var volcano = presetPalettes.volcano;
  exports.volcano = volcano;
  var gold = presetPalettes.gold;
  exports.gold = gold;
  var orange = presetPalettes.orange;
  exports.orange = orange;
  var yellow = presetPalettes.yellow;
  exports.yellow = yellow;
  var lime = presetPalettes.lime;
  exports.lime = lime;
  var green = presetPalettes.green;
  exports.green = green;
  var cyan = presetPalettes.cyan;
  exports.cyan = cyan;
  var blue = presetPalettes.blue;
  exports.blue = blue;
  var geekblue = presetPalettes.geekblue;
  exports.geekblue = geekblue;
  var purple = presetPalettes.purple;
  exports.purple = purple;
  var magenta = presetPalettes.magenta;
  exports.magenta = magenta;
  var grey = presetPalettes.grey;
  exports.grey = grey;
});
unwrapExports(lib$1);
var lib_1 = lib$1.generate;
var lib_2 = lib$1.presetPrimaryColors;
var lib_3 = lib$1.presetPalettes;
var lib_4 = lib$1.red;
var lib_5 = lib$1.volcano;
var lib_6 = lib$1.gold;
var lib_7 = lib$1.orange;
var lib_8 = lib$1.yellow;
var lib_9 = lib$1.lime;
var lib_10 = lib$1.green;
var lib_11 = lib$1.cyan;
var lib_12 = lib$1.blue;
var lib_13 = lib$1.geekblue;
var lib_14 = lib$1.purple;
var lib_15 = lib$1.magenta;
var lib_16 = lib$1.grey;

function log(message) {
  if (!(process && process.env && process.env.NODE_ENV === 'production')) {
    console.error('[@ant-design/icons-react]: ' + message + '.');
  }
}

function isIconDefinition(target) {
  return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}

function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];

    switch (key) {
      case 'class':
        acc.className = val;
        delete acc['class'];
        break;

      default:
        acc[key] = val;
    }

    return acc;
  }, {});
}

var MiniMap = function () {
  function MiniMap() {
    _classCallCheck$1(this, MiniMap);

    this.collection = {};
  }

  _createClass$1(MiniMap, [{
    key: 'clear',
    value: function clear() {
      this.collection = {};
    }
  }, {
    key: 'delete',
    value: function _delete(key) {
      return delete this.collection[key];
    }
  }, {
    key: 'get',
    value: function get(key) {
      return this.collection[key];
    }
  }, {
    key: 'has',
    value: function has(key) {
      return Boolean(this.collection[key]);
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      this.collection[key] = value;
      return this;
    }
  }, {
    key: 'size',
    get: function get() {
      return Object.keys(this.collection).length;
    }
  }]);

  return MiniMap;
}();

function generate$1(node, key, rootProps) {
  if (!rootProps) {
    return createElement(node.tag, _extends$1({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate$1(child, key + '-' + node.tag + '-' + index);
    }));
  }

  return createElement(node.tag, _extends$1({
    key: key
  }, normalizeAttrs(node.attrs), rootProps), (node.children || []).map(function (child, index) {
    return generate$1(child, key + '-' + node.tag + '-' + index);
  }));
}

function getSecondaryColor(primaryColor) {
  // choose the second color
  return lib_1(primaryColor)[0];
}

function withSuffix(name, theme) {
  switch (theme) {
    case 'fill':
      return name + '-fill';

    case 'outline':
      return name + '-o';

    case 'twotone':
      return name + '-twotone';

    default:
      throw new TypeError('Unknown theme type: ' + theme + ', name: ' + name);
  }
}

var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6'
};

var Icon$1 = function (_React$Component) {
  _inherits$1(Icon, _React$Component);

  function Icon() {
    _classCallCheck$1(this, Icon);

    return _possibleConstructorReturn$1(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass$1(Icon, [{
    key: 'render',
    value: function render() {
      var _extends2;

      var _props = this.props,
          type = _props.type,
          className = _props.className,
          onClick = _props.onClick,
          style = _props.style,
          primaryColor = _props.primaryColor,
          secondaryColor = _props.secondaryColor,
          rest = _objectWithoutProperties(_props, ['type', 'className', 'onClick', 'style', 'primaryColor', 'secondaryColor']);

      var target = void 0;
      var colors = twoToneColorPalette;

      if (primaryColor) {
        colors = {
          primaryColor: primaryColor,
          secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
        };
      }

      if (isIconDefinition(type)) {
        target = type;
      } else if (typeof type === 'string') {
        target = Icon.get(type, colors);

        if (!target) {
          // log(`Could not find icon: ${type}`);
          return null;
        }
      }

      if (!target) {
        log('type should be string or icon definiton, but got ' + type);
        return null;
      }

      if (target && typeof target.icon === 'function') {
        target = _extends$1({}, target, {
          icon: target.icon(colors.primaryColor, colors.secondaryColor)
        });
      }

      return generate$1(target.icon, 'svg-' + target.name, _extends$1((_extends2 = {
        className: className,
        onClick: onClick,
        style: style
      }, _defineProperty$2(_extends2, 'data-icon', target.name), _defineProperty$2(_extends2, 'width', '1em'), _defineProperty$2(_extends2, 'height', '1em'), _defineProperty$2(_extends2, 'fill', 'currentColor'), _defineProperty$2(_extends2, 'aria-hidden', 'true'), _defineProperty$2(_extends2, 'focusable', 'false'), _extends2), rest));
    }
  }], [{
    key: 'add',
    value: function add() {
      var _this2 = this;

      for (var _len = arguments.length, icons = Array(_len), _key = 0; _key < _len; _key++) {
        icons[_key] = arguments[_key];
      }

      icons.forEach(function (icon) {
        _this2.definitions.set(withSuffix(icon.name, icon.theme), icon);
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.definitions.clear();
    }
  }, {
    key: 'get',
    value: function get(key) {
      var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : twoToneColorPalette;

      if (key) {
        var target = this.definitions.get(key);

        if (target && typeof target.icon === 'function') {
          target = _extends$1({}, target, {
            icon: target.icon(colors.primaryColor, colors.secondaryColor)
          });
        }

        return target;
      }
    }
  }, {
    key: 'setTwoToneColors',
    value: function setTwoToneColors(_ref) {
      var primaryColor = _ref.primaryColor,
          secondaryColor = _ref.secondaryColor;
      twoToneColorPalette.primaryColor = primaryColor;
      twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
    }
  }, {
    key: 'getTwoToneColors',
    value: function getTwoToneColors() {
      return _extends$1({}, twoToneColorPalette);
    }
  }]);

  return Icon;
}(Component);

Icon$1.displayName = 'IconReact';
Icon$1.definitions = new MiniMap();
var IconFont = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = create;

  var _index = _interopRequireDefault(icon);

  var React = _interopRequireWildcard(React__default);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var __rest = function __rest(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };

  var customCache = new Set();

  function create() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var scriptUrl = options.scriptUrl,
        _options$extraCommonP = options.extraCommonProps,
        extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
    /**
     * DOM API required.
     * Make sure in browser environment.
     * The Custom Icon will create a <script/>
     * that loads SVG symbols and insert the SVG Element into the document body.
     */

    if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
      var script = document.createElement('script');
      script.setAttribute('src', scriptUrl);
      script.setAttribute('data-namespace', scriptUrl);
      customCache.add(scriptUrl);
      document.body.appendChild(script);
    }

    var Iconfont = function Iconfont(props) {
      var type = props.type,
          children = props.children,
          restProps = __rest(props, ["type", "children"]); // component > children > type


      var content = null;

      if (props.type) {
        content = React.createElement("use", {
          xlinkHref: "#".concat(type)
        });
      }

      if (children) {
        content = children;
      }

      return React.createElement(_index["default"], _extends({}, restProps, extraCommonProps), content);
    };

    Iconfont.displayName = 'Iconfont';
    return Iconfont;
  }
});
unwrapExports(IconFont);
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning$1 = function warning$1() {};

if (__DEV__) {
  var printWarning$4 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);

    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$1 = function warning$1(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (!condition) {
      printWarning$4.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning$1;
var warning$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.resetWarned = resetWarned;
  exports["default"] = void 0;

  var _warning = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var warned = {};

  function resetWarned() {
    warned = {};
  }

  var _default = function _default(valid, component, message) {
    if (!valid && !warned[message]) {
      (0, _warning["default"])(false, "[antd: ".concat(component, "] ").concat(message));
      warned[message] = true;
    }
  };

  exports["default"] = _default;
});
unwrapExports(warning$2);
var warning_1$1 = warning$2.resetWarned;
var utils$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getThemeFromTypeName = getThemeFromTypeName;
  exports.removeTypeTheme = removeTypeTheme;
  exports.withThemeSuffix = withThemeSuffix;
  exports.alias = alias;
  exports.svgBaseProps = void 0;

  var _warning = _interopRequireDefault(warning$2);

  var _svgBaseProps;

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  } // These props make sure that the SVG behaviours like general text.
  // Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4


  var svgBaseProps = (_svgBaseProps = {
    width: '1em',
    height: '1em',
    fill: 'currentColor'
  }, _defineProperty(_svgBaseProps, 'aria-hidden', true), _defineProperty(_svgBaseProps, "focusable", 'false'), _svgBaseProps);
  exports.svgBaseProps = svgBaseProps;
  var fillTester = /-fill$/;
  var outlineTester = /-o$/;
  var twoToneTester = /-twotone$/;

  function getThemeFromTypeName(type) {
    var result = null;

    if (fillTester.test(type)) {
      result = 'filled';
    } else if (outlineTester.test(type)) {
      result = 'outlined';
    } else if (twoToneTester.test(type)) {
      result = 'twoTone';
    }

    return result;
  }

  function removeTypeTheme(type) {
    return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
  }

  function withThemeSuffix(type, theme) {
    var result = type;

    if (theme === 'filled') {
      result += '-fill';
    } else if (theme === 'outlined') {
      result += '-o';
    } else if (theme === 'twoTone') {
      result += '-twotone';
    } else {
      (0, _warning["default"])(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
    }

    return result;
  } // For alias or compatibility


  function alias(type) {
    var newType = type;

    switch (type) {
      case 'cross':
        newType = 'close';
        break;
      // https://github.com/ant-design/ant-design/issues/13007

      case 'interation':
        newType = 'interaction';
        break;
      // https://github.com/ant-design/ant-design/issues/16810

      case 'canlendar':
        newType = 'calendar';
        break;
      // https://github.com/ant-design/ant-design/issues/17448

      case 'colum-height':
        newType = 'column-height';
        break;

      default:
    }

    (0, _warning["default"])(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
    return newType;
  }
});
unwrapExports(utils$2);
var utils_1$1 = utils$2.getThemeFromTypeName;
var utils_2$1 = utils$2.removeTypeTheme;
var utils_3 = utils$2.withThemeSuffix;
var utils_4 = utils$2.alias;
var utils_5 = utils$2.svgBaseProps;

var _default_1$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _default2 = _interopRequireDefault(_default_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _default2["default"];
  exports["default"] = _default;
});

unwrapExports(_default_1$1);
var LocaleReceiver_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var PropTypes = _interopRequireWildcard(propTypes$1);

  var _default = _interopRequireDefault(_default_1$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  var LocaleReceiver =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(LocaleReceiver, _React$Component);

    function LocaleReceiver() {
      _classCallCheck(this, LocaleReceiver);

      return _possibleConstructorReturn(this, _getPrototypeOf(LocaleReceiver).apply(this, arguments));
    }

    _createClass(LocaleReceiver, [{
      key: "getLocale",
      value: function getLocale() {
        var _this$props = this.props,
            componentName = _this$props.componentName,
            defaultLocale = _this$props.defaultLocale;
        var locale = defaultLocale || _default["default"][componentName || 'global'];
        var antLocale = this.context.antLocale;
        var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
        return _extends({}, typeof locale === 'function' ? locale() : locale, localeFromContext || {});
      }
    }, {
      key: "getLocaleCode",
      value: function getLocaleCode() {
        var antLocale = this.context.antLocale;
        var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

        if (antLocale && antLocale.exist && !localeCode) {
          return _default["default"].locale;
        }

        return localeCode;
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children(this.getLocale(), this.getLocaleCode());
      }
    }]);

    return LocaleReceiver;
  }(React.Component);

  exports["default"] = LocaleReceiver;
  LocaleReceiver.defaultProps = {
    componentName: 'global'
  };
  LocaleReceiver.contextTypes = {
    antLocale: PropTypes.object
  };
});
unwrapExports(LocaleReceiver_1);
var twoTonePrimaryColor = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setTwoToneColor = setTwoToneColor;
  exports.getTwoToneColor = getTwoToneColor;

  var _iconsReact = _interopRequireDefault(Icon$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function setTwoToneColor(primaryColor) {
    return _iconsReact["default"].setTwoToneColors({
      primaryColor: primaryColor
    });
  }

  function getTwoToneColor() {
    var colors = _iconsReact["default"].getTwoToneColors();

    return colors.primaryColor;
  }
});
unwrapExports(twoTonePrimaryColor);
var twoTonePrimaryColor_1 = twoTonePrimaryColor.setTwoToneColor;
var twoTonePrimaryColor_2 = twoTonePrimaryColor.getTwoToneColor;
var icon = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var _classnames = _interopRequireDefault(classnames);

  var allIcons = _interopRequireWildcard(dist);

  var _iconsReact = _interopRequireDefault(Icon$1);

  var _IconFont = _interopRequireDefault(IconFont);

  var _warning = _interopRequireDefault(warning$2);

  var _LocaleReceiver = _interopRequireDefault(LocaleReceiver_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }
  }

  var __rest = function __rest(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  }; // Initial setting


  _iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
    return allIcons[key];
  })));

  (0, twoTonePrimaryColor.setTwoToneColor)('#1890ff');
  var defaultTheme = 'outlined';
  var dangerousTheme = undefined;

  var Icon = function Icon(props) {
    var _classNames;

    var className = props.className,
        type = props.type,
        Component$$1 = props.component,
        viewBox = props.viewBox,
        spin = props.spin,
        rotate = props.rotate,
        tabIndex = props.tabIndex,
        onClick = props.onClick,
        children = props.children,
        theme = props.theme,
        twoToneColor = props.twoToneColor,
        restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children", "theme", "twoToneColor"]);

    (0, _warning["default"])(Boolean(type || Component$$1 || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');
    var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
    var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
    var innerNode;
    var svgStyle = rotate ? {
      msTransform: "rotate(".concat(rotate, "deg)"),
      transform: "rotate(".concat(rotate, "deg)")
    } : undefined;

    var innerSvgProps = _extends({}, utils$2.svgBaseProps, {
      className: svgClassString,
      style: svgStyle,
      viewBox: viewBox
    });

    if (!viewBox) {
      delete innerSvgProps.viewBox;
    } // component > children > type


    if (Component$$1) {
      innerNode = React.createElement(Component$$1, innerSvgProps, children);
    }

    if (children) {
      (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && React.isValidElement(children) && React.Children.only(children).type === 'use', 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      innerNode = React.createElement("svg", _extends({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    if (typeof type === 'string') {
      var computedType = type;

      if (theme) {
        var themeInName = (0, utils$2.getThemeFromTypeName)(type);
        (0, _warning["default"])(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
      }

      computedType = (0, utils$2.withThemeSuffix)((0, utils$2.removeTypeTheme)((0, utils$2.alias)(computedType)), dangerousTheme || theme || defaultTheme);
      innerNode = React.createElement(_iconsReact["default"], {
        className: svgClassString,
        type: computedType,
        primaryColor: twoToneColor,
        style: svgStyle
      });
    }

    var iconTabIndex = tabIndex;

    if (iconTabIndex === undefined && onClick) {
      iconTabIndex = -1;
    }

    return React.createElement(_LocaleReceiver["default"], {
      componentName: "Icon"
    }, function (locale) {
      return React.createElement("i", _extends({
        "aria-label": type && "".concat(locale.icon, ": ").concat(type)
      }, restProps, {
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
      }), innerNode);
    });
  };

  Icon.createFromIconfontCN = _IconFont["default"];
  Icon.getTwoToneColor = twoTonePrimaryColor.getTwoToneColor;
  Icon.setTwoToneColor = twoTonePrimaryColor.setTwoToneColor;
  var _default = Icon;
  exports["default"] = _default;
});
unwrapExports(icon);

function omit(obj, fields) {
  var shallowCopy = _extends$1({}, obj);

  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }

  return shallowCopy;
}

var key = '__global_unique_id__';

var gud = function gud() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};

var implementation = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _gud2 = _interopRequireDefault(gud);

  var _warning2 = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MAX_SIGNED_31_BIT_INT = 1073741823; // Inlined Object.is polyfill.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is

  function objectIs(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }

  function createEventEmitter(value) {
    var handlers = [];
    return {
      on: function on(handler) {
        handlers.push(handler);
      },
      off: function off(handler) {
        handlers = handlers.filter(function (h) {
          return h !== handler;
        });
      },
      get: function get() {
        return value;
      },
      set: function set(newValue, changedBits) {
        value = newValue;
        handlers.forEach(function (handler) {
          return handler(value, changedBits);
        });
      }
    };
  }

  function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
  }

  function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;

    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

    var Provider = function (_Component) {
      _inherits(Provider, _Component);

      function Provider() {
        var _temp, _this, _ret;

        _classCallCheck(this, Provider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
      }

      Provider.prototype.getChildContext = function getChildContext() {
        var _ref;

        return _ref = {}, _ref[contextProp] = this.emitter, _ref;
      };

      Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          var oldValue = this.props.value;
          var newValue = nextProps.value;
          var changedBits = void 0;

          if (objectIs(oldValue, newValue)) {
            changedBits = 0; // No change
          } else {
            changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

            if (process.env.NODE_ENV !== 'production') {
              (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
            }

            changedBits |= 0;

            if (changedBits !== 0) {
              this.emitter.set(nextProps.value, changedBits);
            }
          }
        }
      };

      Provider.prototype.render = function render() {
        return this.props.children;
      };

      return Provider;
    }(React__default.Component);

    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

    var Consumer = function (_Component2) {
      _inherits(Consumer, _Component2);

      function Consumer() {
        var _temp2, _this2, _ret2;

        _classCallCheck(this, Consumer);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
          value: _this2.getValue()
        }, _this2.onUpdate = function (newValue, changedBits) {
          var observedBits = _this2.observedBits | 0;

          if ((observedBits & changedBits) !== 0) {
            _this2.setState({
              value: _this2.getValue()
            });
          }
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
      }

      Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var observedBits = nextProps.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };

      Consumer.prototype.componentDidMount = function componentDidMount() {
        if (this.context[contextProp]) {
          this.context[contextProp].on(this.onUpdate);
        }

        var observedBits = this.props.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };

      Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.context[contextProp]) {
          this.context[contextProp].off(this.onUpdate);
        }
      };

      Consumer.prototype.getValue = function getValue() {
        if (this.context[contextProp]) {
          return this.context[contextProp].get();
        } else {
          return defaultValue;
        }
      };

      Consumer.prototype.render = function render() {
        return onlyChild(this.props.children)(this.state.value);
      };

      return Consumer;
    }(React__default.Component);

    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
      Provider: Provider,
      Consumer: Consumer
    };
  }

  exports.default = createReactContext;
  module.exports = exports['default'];
});
unwrapExports(implementation);
var lib$2 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _react2 = _interopRequireDefault(React__default);

  var _implementation2 = _interopRequireDefault(implementation);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _react2.default.createContext || _implementation2.default;
  module.exports = exports['default'];
});
unwrapExports(lib$2);
var empty$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  var _default = function _default() {
    return React.createElement("svg", {
      width: "184",
      height: "152",
      viewBox: "0 0 184 152",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, React.createElement("g", {
      transform: "translate(24 31.67)"
    }, React.createElement("ellipse", {
      fillOpacity: ".8",
      fill: "#F5F5F7",
      cx: "67.797",
      cy: "106.89",
      rx: "67.797",
      ry: "12.668"
    }), React.createElement("path", {
      d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
      fill: "#AEB8C2"
    }), React.createElement("path", {
      d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
      fill: "url(#linearGradient-1)",
      transform: "translate(13.56)"
    }), React.createElement("path", {
      d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
      fill: "#F5F5F7"
    }), React.createElement("path", {
      d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
      fill: "#DCE0E6"
    })), React.createElement("path", {
      d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
      fill: "#DCE0E6"
    }), React.createElement("g", {
      transform: "translate(149.65 15.383)",
      fill: "#FFF"
    }, React.createElement("ellipse", {
      cx: "20.654",
      cy: "3.167",
      rx: "2.849",
      ry: "2.815"
    }), React.createElement("path", {
      d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
  };

  exports["default"] = _default;
});
unwrapExports(empty$1);
var simple = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  var _default = function _default() {
    return React.createElement("svg", {
      width: "64",
      height: "41",
      viewBox: "0 0 64 41",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("g", {
      transform: "translate(0 1)",
      fill: "none",
      fillRule: "evenodd"
    }, React.createElement("ellipse", {
      fill: "#F5F5F5",
      cx: "32",
      cy: "33",
      rx: "32",
      ry: "7"
    }), React.createElement("g", {
      fillRule: "nonzero",
      stroke: "#D9D9D9"
    }, React.createElement("path", {
      d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), React.createElement("path", {
      d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
      fill: "#FAFAFA"
    }))));
  };

  exports["default"] = _default;
});
unwrapExports(simple);
var empty$3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var _classnames = _interopRequireDefault(classnames);

  var _LocaleReceiver = _interopRequireDefault(LocaleReceiver_1);

  var _empty = _interopRequireDefault(empty$1);

  var _simple = _interopRequireDefault(simple);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var __rest = function __rest(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };

  var defaultEmptyImg = React.createElement(_empty["default"], null);
  var simpleEmptyImg = React.createElement(_simple["default"], null);

  var Empty = function Empty(props) {
    return React.createElement(configProvider.ConfigConsumer, null, function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var className = props.className,
          customizePrefixCls = props.prefixCls,
          _props$image = props.image,
          image = _props$image === void 0 ? defaultEmptyImg : _props$image,
          description = props.description,
          children = props.children,
          imageStyle = props.imageStyle,
          restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);

      return React.createElement(_LocaleReceiver["default"], {
        componentName: "Empty"
      }, function (locale) {
        var prefixCls = getPrefixCls('empty', customizePrefixCls);
        var des = typeof description !== 'undefined' ? description : locale.description;
        var alt = typeof des === 'string' ? des : 'empty';
        var imageNode = null;

        if (typeof image === 'string') {
          imageNode = React.createElement("img", {
            alt: alt,
            src: image
          });
        } else {
          imageNode = image;
        }

        return React.createElement("div", _extends({
          className: (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), className)
        }, restProps), React.createElement("div", {
          className: "".concat(prefixCls, "-image"),
          style: imageStyle
        }, imageNode), des && React.createElement("p", {
          className: "".concat(prefixCls, "-description")
        }, des), children && React.createElement("div", {
          className: "".concat(prefixCls, "-footer")
        }, children));
      });
    });
  };

  Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
  Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
  var _default = Empty;
  exports["default"] = _default;
});
unwrapExports(empty$3);
var renderEmpty_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var _empty = _interopRequireDefault(empty$3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  var renderEmpty = function renderEmpty(componentName) {
    return React.createElement(configProvider.ConfigConsumer, null, function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var prefix = getPrefixCls('empty');

      switch (componentName) {
        case 'Table':
        case 'List':
          return React.createElement(_empty["default"], {
            image: _empty["default"].PRESENTED_IMAGE_SIMPLE
          });

        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
          return React.createElement(_empty["default"], {
            image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
            className: "".concat(prefix, "-small")
          });

        default:
          return React.createElement(_empty["default"], null);
      }
    });
  };

  var _default = renderEmpty;
  exports["default"] = _default;
});
unwrapExports(renderEmpty_1);
var moment = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    var hookCallback;

    function hooks() {
      return hookCallback.apply(null, arguments);
    } // This is done to register the method called with moment()
    // without creating circular dependencies.


    function setHookCallback(callback) {
      hookCallback = callback;
    }

    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
      // IE8 will treat undefined and null as object if it wasn't for
      // input != null
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;

        for (k in obj) {
          if (obj.hasOwnProperty(k)) {
            return false;
          }
        }

        return true;
      }
    }

    function isUndefined(input) {
      return input === void 0;
    }

    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
      var res = [],
          i;

      for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
      }

      return res;
    }

    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }

      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }

      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }

      return a;
    }

    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
      // We need to deep clone this object.
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }

    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }

      return m._pf;
    }

    var some;

    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }

        return false;
      };
    }

    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
          return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }

      return m._isValid;
    }

    function createInvalid(flags) {
      var m = createUTC(NaN);

      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }

      return m;
    } // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.


    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
      var i, prop, val;

      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }

      if (!isUndefined(from._i)) {
        to._i = from._i;
      }

      if (!isUndefined(from._f)) {
        to._f = from._f;
      }

      if (!isUndefined(from._l)) {
        to._l = from._l;
      }

      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }

      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }

      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }

      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }

      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }

      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }

      if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
          prop = momentProperties[i];
          val = from[prop];

          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }

      return to;
    }

    var updateInProgress = false; // Moment prototype object

    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);

      if (!this.isValid()) {
        this._d = new Date(NaN);
      } // Prevent infinite loop in case updateOffset creates new moment
      // objects.


      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }

    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function absFloor(number) {
      if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }

    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
          value = 0;

      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }

      return value;
    } // compare two arrays, return the number of differences


    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
          lengthDiff = Math.abs(array1.length - array2.length),
          diffs = 0,
          i;

      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }

      return diffs + lengthDiff;
    }

    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }

    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }

        if (firstTime) {
          var args = [];
          var arg;

          for (var i = 0; i < arguments.length; i++) {
            arg = '';

            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';

              for (var key in arguments[0]) {
                arg += key + ': ' + arguments[0][key] + ', ';
              }

              arg = arg.slice(0, -2); // Remove trailing comma and space
            } else {
              arg = arguments[i];
            }

            args.push(arg);
          }

          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }

        return fn.apply(this, arguments);
      }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }

      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
      return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
      var prop, i;

      for (i in config) {
        prop = config[i];

        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this['_' + i] = prop;
        }
      }

      this._config = config; // Lenient ordinal parsing accepts just a number in addition to
      // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
      // TODO: Remove "ordinalParse" fallback in next major release.

      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
          prop;

      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }

      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          // make sure changes to properties don't modify parent config
          res[prop] = extend({}, res[prop]);
        }
      }

      return res;
    }

    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }

    var keys;

    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
            res = [];

        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }

        return res;
      };
    }

    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };

    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
      var format = this._longDateFormat[key],
          formatUpper = this._longDateFormat[key.toUpperCase()];

      if (format || !formatUpper) {
        return format;
      }

      this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
      });
      return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
      return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
          normalizedProp,
          prop;

      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);

          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }

      return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
      var units = [];

      for (var u in unitsObj) {
        units.push({
          unit: u,
          priority: priorities[u]
        });
      }

      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }

    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
          zerosToFill = targetLength - absNumber.length,
          sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
    var formatFunctions = {};
    var formatTokenFunctions = {}; // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }

    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;

      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }

      if (token) {
        formatTokenFunctions[token] = func;
      }

      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }

      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }

    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }

      return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
          i,
          length;

      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }

      return function (mom) {
        var output = '',
            i;

        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }

        return output;
      };
    } // format date using native date object


    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }

      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
      var i = 5;

      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }

      localFormattingTokens.lastIndex = 0;

      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }

      return format;
    }

    var match1 = /\d/; //       0 - 9

    var match2 = /\d\d/; //      00 - 99

    var match3 = /\d{3}/; //     000 - 999

    var match4 = /\d{4}/; //    0000 - 9999

    var match6 = /[+-]?\d{6}/; // -999999 - 999999

    var match1to2 = /\d\d?/; //       0 - 99

    var match3to4 = /\d\d\d\d?/; //     999 - 9999

    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999

    var match1to3 = /\d{1,3}/; //       0 - 999

    var match1to4 = /\d{1,4}/; //       0 - 9999

    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

    var matchUnsigned = /\d+/; //       0 - inf

    var matchSigned = /[+-]?\d+/; //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z

    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months

    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }

    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }

      return regexes[token](config._strict, config._locale);
    } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }

    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
      var i,
          func = callback;

      if (typeof token === 'string') {
        token = [token];
      }

      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }

      for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
      }
    }

    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }

    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8; // FORMATTING

    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? '' + y : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

    addUnitAlias('year', 'y'); // PRIORITIES

    addUnitPriority('year', 1); // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    }); // HELPERS

    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    } // HOOKS


    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    }; // MOMENTS


    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
      return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }

    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    } // MOMENTS


    function stringGet(units) {
      units = normalizeUnits(units);

      if (isFunction(this[units])) {
        return this[units]();
      }

      return this;
    }

    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);

        for (var i = 0; i < prioritized.length; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);

        if (isFunction(this[units])) {
          return this[units](value);
        }
      }

      return this;
    }

    function mod(n, x) {
      return (n % x + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        // I know
        var i;

        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }

        return -1;
      };
    }

    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }

      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    } // FORMATTING


    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    }); // ALIASES

    addUnitAlias('month', 'M'); // PRIORITY

    addUnitPriority('month', 8); // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    }); // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');

    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }

      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');

    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }

      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
      var i,
          ii,
          mom,
          llc = monthName.toLocaleLowerCase();

      if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];

        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;

      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }

      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      } // TODO: add sorting
      // Sorting makes sure if one month (or abbr) is a prefix of another
      // see sorting in computeMonthsParse


      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);

        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }

        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        } // test the regex


        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    } // MOMENTS


    function setMonth(mom, value) {
      var dayOfMonth;

      if (!mom.isValid()) {
        // No op
        return mom;
      }

      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

          if (!isNumber(value)) {
            return mom;
          }
        }
      }

      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

      return mom;
    }

    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }

    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;

    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }

        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }

        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }

    var defaultMonthsRegex = matchWord;

    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }

        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }

        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }

    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var shortPieces = [],
          longPieces = [],
          mixedPieces = [],
          i,
          mom;

      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      } // Sorting makes sure if one month (or abbr) is a prefix of another it
      // will match the longer piece.


      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);

      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }

      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate(y, m, d, h, M, s, ms) {
      // can't just apply() to create a date:
      // https://stackoverflow.com/q/181348
      var date; // the date constructor remaps years 0-99 to 1900-1999

      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);

        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }

      return date;
    }

    function createUTCDate(y) {
      var date; // the Date.UTC function remaps years 0-99 to 1900-1999

      if (y < 100 && y >= 0) {
        var args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));

        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }

      return date;
    } // start-of-first-week - start-of-year


    function firstWeekOffset(year, dow, doy) {
      var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
      fwd = 7 + dow - doy,
          // first-week day local weekday -- which local weekday is fwd
      fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
          weekOffset = firstWeekOffset(year, dow, doy),
          dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
          resYear,
          resDayOfYear;

      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }

      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }

    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
          week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
          resWeek,
          resYear;

      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }

      return {
        week: resWeek,
        year: resYear
      };
    }

    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
          weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    } // FORMATTING


    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W'); // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5); // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    }); // HELPERS
    // LOCALES

    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6 // The week that contains Jan 6th is the first week of the year.

    };

    function localeFirstDayOfWeek() {
      return this._week.dow;
    }

    function localeFirstDayOfYear() {
      return this._week.doy;
    } // MOMENTS


    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    } // FORMATTING


    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E'); // PRIORITY

    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11); // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    }); // HELPERS

    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }

      if (!isNaN(input)) {
        return parseInt(input, 10);
      }

      input = locale.weekdaysParse(input);

      if (typeof input === 'number') {
        return input;
      }

      return null;
    }

    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }

      return isNaN(input) ? null : input;
    } // LOCALES


    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');

    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');

    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');

    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
          ii,
          mom,
          llc = weekdayName.toLocaleLowerCase();

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;

      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);

        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }

        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        } // test the regex


        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    } // MOMENTS


    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }

    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      } // behaves the same as moment#day except
      // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
      // as a setter, sunday should belong to the previous week.


      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }

    var defaultWeekdaysRegex = matchWord;

    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }

        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }

    var defaultWeekdaysShortRegex = matchWord;

    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }

        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }

    var defaultWeekdaysMinRegex = matchWord;

    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }

        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }

    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var minPieces = [],
          shortPieces = [],
          longPieces = [],
          mixedPieces = [],
          i,
          mom,
          minp,
          shortp,
          longp;

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
      // will match the longer piece.


      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);

      for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    } // FORMATTING


    function hFormat() {
      return this.hours() % 12 || 12;
    }

    function kFormat() {
      return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }

    meridiem('a', true);
    meridiem('A', false); // ALIASES

    addUnitAlias('hour', 'h'); // PRIORITY

    addUnitPriority('hour', 13); // PARSING

    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4;
      var pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4;
      var pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    }); // LOCALES

    function localeIsPM(input) {
      // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
      // Using charAt should be more compatible.
      return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;

    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    } // MOMENTS
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.


    var getSetHour = makeGetSet('Hours', true);
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    }; // internal storage for locale config files

    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    } // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


    function chooseLocale(names) {
      var i = 0,
          j,
          next,
          locale,
          split;

      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;

        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));

          if (locale) {
            return locale;
          }

          if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
            //the next array item is better than a shallower substring of this one
            break;
          }

          j--;
        }

        i++;
      }

      return globalLocale;
    }

    function loadLocale(name) {
      var oldLocale = null; // TODO: Find a better way to register and load all the locales in Node

      if (!locales[name] && 'object' !== 'undefined' && module && module.exports) {
        try {
          oldLocale = globalLocale._abbr;
          var aliasedRequire = commonjsRequire;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {}
      }

      return locales[name];
    } // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.


    function getSetGlobalLocale(key, values) {
      var data;

      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }

        if (data) {
          // moment.duration._locale = moment._locale = data;
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }

      return globalLocale._abbr;
    }

    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
            parentConfig = baseConfig;
        config.abbr = name;

        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);

            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }

              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }

        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        } // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.


        getSetGlobalLocale(name);
        return locales[name];
      } else {
        // useful for testing
        delete locales[name];
        return null;
      }
    }

    function updateLocale(name, config) {
      if (config != null) {
        var locale,
            tmpLocale,
            parentConfig = baseConfig; // MERGE

        tmpLocale = loadLocale(name);

        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }

        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale; // backwards compat for now: also set the locale

        getSetGlobalLocale(name);
      } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }

      return locales[name];
    } // returns locale data


    function getLocale(key) {
      var locale;

      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }

      if (!key) {
        return globalLocale;
      }

      if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);

        if (locale) {
          return locale;
        }

        key = [key];
      }

      return chooseLocale(key);
    }

    function listLocales() {
      return keys(locales);
    }

    function checkOverflow(m) {
      var overflow;
      var a = m._a;

      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }

        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }

        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
      }

      return m;
    } // Pick the first defined of two or three arguments.


    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }

      if (b != null) {
        return b;
      }

      return c;
    }

    function currentDateArray(config) {
      // hooks is actually the exported moment object
      var nowValue = new Date(hooks.now());

      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }

      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    } // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]


    function configFromArray(config) {
      var i,
          date,
          input = [],
          currentDate,
          expectedWeekday,
          yearToUse;

      if (config._d) {
        return;
      }

      currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      } //if the day of the year is set, figure out what it is


      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      } // Default to current date.
      // * if no year, month, day of month are given, default to today
      // * if day of month is given, default month and year
      // * if month is given, default only year
      // * if year is given, don't default anything


      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      } // Zero out whatever was not defaulted, including time


      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      } // Check for 24:00:00.000


      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }

      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
      // with parseZone.

      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }

      if (config._nextDay) {
        config._a[HOUR] = 24;
      } // check for mismatching day of week


      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }

    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
      w = config._w;

      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).

        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);

        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        var curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
          // weekday -- low day numbers are considered next week
          weekday = w.d;

          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          // local weekday -- counting starts from beginning of week
          weekday = w.e + dow;

          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          // default to beginning of week
          weekday = dow;
        }
      }

      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    } // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
    var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]]; // iso time formats and regexes

    var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];
    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i; // date from iso format

    function configFromISO(config) {
      var i,
          l,
          string = config._i,
          match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
          allowTime,
          dateFormat,
          timeFormat,
          tzFormat;

      if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }

        if (dateFormat == null) {
          config._isValid = false;
          return;
        }

        if (match[3]) {
          for (i = 0, l = isoTimes.length; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              // match[2] should be 'T' or space
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }

          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }

        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }

        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }

        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    } // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3


    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }

      return result;
    }

    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);

      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }

      return year;
    }

    function preprocessRFC2822(s) {
      // Remove comments and folding whitespace and replace multiple-spaces with a single space
      return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }

      return true;
    }

    var obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
      } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100,
            h = (hm - m) / 100;
        return h * 60 + m;
      }
    } // date and time from ref 2822 format


    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i));

      if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);

        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    } // date from iso format or fallback


    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);

      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }

      configFromISO(config);

      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }

      configFromRFC2822(config);

      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      } // Final attempt, use Input Fallback


      hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }); // constant that refers to the ISO standard

    hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


    hooks.RFC_2822 = function () {}; // date from string and format string


    function configFromStringAndFormat(config) {
      // TODO: Move this to another part of the creation flow to prevent circular deps
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }

      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }

      config._a = [];
      getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

      var string = '' + config._i,
          i,
          parsedInput,
          tokens,
          token,
          skipped,
          stringLength = string.length,
          totalParsedInputLength = 0;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

      for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0]; // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));

        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));

          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }

          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        } // don't parse if it's not a known token


        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }

          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      } // add remaining unparsed input length to the string


      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      } // clear _12h flag if hour is <= 12


      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }

      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
      configFromArray(config);
      checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;

      if (meridiem == null) {
        // nothing to do
        return hour;
      }

      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);

        if (isPm && hour < 12) {
          hour += 12;
        }

        if (!isPm && hour === 12) {
          hour = 0;
        }

        return hour;
      } else {
        // this is not supposed to happen
        return hour;
      }
    } // date from string and array of format strings


    function configFromStringAndArray(config) {
      var tempConfig, bestMoment, scoreToBeat, i, currentScore;

      if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }

      for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);

        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }

        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
          continue;
        } // if there is any input that was not parsed add a penalty for that format


        currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }

      extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
      if (config._d) {
        return;
      }

      var i = normalizeObjectUnits(config._i);
      config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }

    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));

      if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
      }

      return res;
    }

    function prepareConfig(config) {
      var input = config._i,
          format = config._f;
      config._locale = config._locale || getLocale(config._l);

      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }

      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }

      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }

      if (!isValid(config)) {
        config._d = null;
      }

      return config;
    }

    function configFromInput(config) {
      var input = config._i;

      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};

      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }

      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      } // object construction must be done this way.
      // https://github.com/moment/moment/issues/1423


      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);

      if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
      } else {
        return createInvalid();
      }
    });
    var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);

      if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
      } else {
        return createInvalid();
      }
    }); // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.

    function pickBy(fn, moments) {
      var res, i;

      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }

      if (!moments.length) {
        return createLocal();
      }

      res = moments[0];

      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }

      return res;
    } // TODO: Use [].sort instead?


    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }

    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }

    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
      for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }

      var unitHasDecimal = false;

      for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false; // only allow non-integers for smallest unit
          }

          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }

      return true;
    }

    function isValid$1() {
      return this._isValid;
    }

    function createInvalid$1() {
      return createDuration(NaN);
    }

    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
          years = normalizedInput.year || 0,
          quarters = normalizedInput.quarter || 0,
          months = normalizedInput.month || 0,
          weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
          days = normalizedInput.day || 0,
          hours = normalizedInput.hour || 0,
          minutes = normalizedInput.minute || 0,
          seconds = normalizedInput.second || 0,
          milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

      this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
      minutes * 6e4 + // 1000 * 60
      hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
      // Because of dateAddRemove treats 24 hours as different from a
      // day when working around DST, we need to store them separately

      this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
      // which months you are are talking about, so we have to store
      // it separately.

      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();

      this._bubble();
    }

    function isDuration(obj) {
      return obj instanceof Duration;
    }

    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    } // FORMATTING


    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';

        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }

        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }

    offset('Z', ':');
    offset('ZZ', ''); // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    }); // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']

    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher);

      if (matches === null) {
        return null;
      }

      var chunk = matches[matches.length - 1] || [];
      var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      var minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    } // Return a moment from input, that is local/utc/zone equivalent to model.


    function cloneWithOffset(input, model) {
      var res, diff;

      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

        res._d.setTime(res._d.valueOf() + diff);

        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }

    function getDateOffset(m) {
      // On Firefox.24 Date#getTimezoneOffset returns a floating point.
      // https://github.com/moment/moment/pull/1871
      return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    } // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.


    hooks.updateOffset = function () {}; // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.


    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
          localAdjust;

      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);

          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }

        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }

        this._offset = input;
        this._isUTC = true;

        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }

        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }

        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }

    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }

        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }

    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }

      return this;
    }

    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);

        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }

      return this;
    }

    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }

      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }

      var c = {};
      copyConfig(c, this);
      c = prepareConfig(c);

      if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }

      return this._isDSTShifted;
    }

    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    } // ASP.NET json date format regex


    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/; // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day

    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
      var duration = input,
          // matching against regexp is expensive, do it on demand
      match = null,
          sign,
          ret,
          diffRes;

      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input)) {
        duration = {};

        if (key) {
          duration[key] = input;
        } else {
          duration.milliseconds = input;
        }
      } else if (!!(match = aspNetRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

        };
      } else if (!!(match = isoRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        // checks for null or undefined
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }

      ret = new Duration(duration);

      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }

      return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
      // We'd normally use ~~inp for this, but unfortunately it also
      // converts floats to ints.
      // inp may be undefined, so careful calling replace on it.
      var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

      return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }

      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }

    function momentsDifference(base, other) {
      var res;

      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }

      other = cloneWithOffset(other, base);

      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }

      return res;
    } // TODO: remove 'name' arg after deprecation is removed


    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp; //invert the arguments, but complain about it

        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
          days = absRound(duration._days),
          months = absRound(duration._months);

      if (!mom.isValid()) {
        // No op
        return;
      }

      updateOffset = updateOffset == null ? true : updateOffset;

      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }

      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }

      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }

      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
      // We want to compare the start of today, vs this.
      // Getting start-of-today depends on whether we're local/utc/offset or not.
      var now = time || createLocal(),
          sod = cloneWithOffset(now, this).startOf('day'),
          format = hooks.calendarFormat(this, sod) || 'sameElse';
      var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
      return new Moment(this);
    }

    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }

    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }

    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
          localTo = isMoment(to) ? to : createLocal(to);

      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }

      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
          inputMs;

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }

    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
      var that, zoneDelta, output;

      if (!this.isValid()) {
        return NaN;
      }

      that = cloneWithOffset(input, this);

      if (!that.isValid()) {
        return NaN;
      }

      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);

      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;

        case 'month':
          output = monthDiff(this, that);
          break;

        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;

        case 'second':
          output = (this - that) / 1e3;
          break;
        // 1000

        case 'minute':
          output = (this - that) / 6e4;
          break;
        // 1000 * 60

        case 'hour':
          output = (this - that) / 36e5;
          break;
        // 1000 * 60 * 60

        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        // 1000 * 60 * 60 * 24, negate dst

        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        // 1000 * 60 * 60 * 24 * 7, negate dst

        default:
          output = this - that;
      }

      return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
      // difference in months
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
          // b is in (anchor - 1 month, anchor + 1 month)
      anchor = a.clone().add(wholeMonthDiff, 'months'),
          anchor2,
          adjust;

      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

        adjust = (b - anchor) / (anchor2 - anchor);
      } //check for negative zero, return zero if negative zero


      return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }

      var utc = keepOffset !== true;
      var m = utc ? this.clone().utc() : this;

      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }

      if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }

      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */


    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }

      var func = 'moment';
      var zone = '';

      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }

      var prefix = '[' + func + '("]';
      var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      var datetime = '-MM-DD[T]HH:mm:ss.SSS';
      var suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }

      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    } // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.


    function locale(key) {
      var newLocaleData;

      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);

        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }

        return this;
      }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });

    function localeData() {
      return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }

    function utcStartOfDate(y, m, d) {
      // Date.UTC remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }

    function startOf(units) {
      var time;
      units = normalizeUnits(units);

      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }

      var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;

        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;

        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;

        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;

        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;

        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;

        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;

        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }

      this._d.setTime(time);

      hooks.updateOffset(this, true);
      return this;
    }

    function endOf(units) {
      var time;
      units = normalizeUnits(units);

      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }

      var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;

        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;

        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;

        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;

        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;

        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;

        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;

        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }

      this._d.setTime(time);

      hooks.updateOffset(this, true);
      return this;
    }

    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
      return new Date(this.valueOf());
    }

    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }

    function toJSON() {
      // new Date(NaN).toJSON() === null
      return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
      return isValid(this);
    }

    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
      return getParsingFlags(this).overflow;
    }

    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    } // FORMATTING


    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1); // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    }); // MOMENTS

    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;

      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;

      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);

        if (week > weeksTarget) {
          week = weeksTarget;
        }

        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
          date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    } // FORMATTING


    addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

    addUnitAlias('quarter', 'Q'); // PRIORITY

    addUnitPriority('quarter', 7); // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    }); // MOMENTS

    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    } // FORMATTING


    addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

    addUnitAlias('date', 'D'); // PRIORITY

    addUnitPriority('date', 9); // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      // TODO: Remove "ordinalParse" fallback in next major release.
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    }); // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

    addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

    addUnitPriority('dayOfYear', 4); // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    }); // HELPERS
    // MOMENTS

    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    } // FORMATTING


    addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

    addUnitAlias('minute', 'm'); // PRIORITY

    addUnitPriority('minute', 14); // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE); // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

    addUnitAlias('second', 's'); // PRIORITY

    addUnitPriority('second', 15); // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND); // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    }); // ALIASES

    addUnitAlias('millisecond', 'ms'); // PRIORITY

    addUnitPriority('millisecond', 16); // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token;

    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    } // MOMENTS


    var getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
      return createLocal(input * 1000);
    }

    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
      return string;
    }

    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
      var locale = getLocale();
      var utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';

      if (index != null) {
        return get$1(format, index, field, 'month');
      }

      var i;
      var out = [];

      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }

      return out;
    } // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)


    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || '';
      }

      var locale = getLocale(),
          shift = localeSorted ? locale._week.dow : 0;

      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }

      var i;
      var out = [];

      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }

      return out;
    }

    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
            output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    }); // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;

    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }

    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    } // supports only 2.0-style add(1, 's') or add(duration)


    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    } // supports only 2.0-style subtract(1, 's') or subtract(duration)


    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }

    function bubble() {
      var milliseconds = this._milliseconds;
      var days = this._days;
      var months = this._months;
      var data = this._data;
      var seconds, minutes, hours, years, monthsFromDays; // if we have a mix of positive and negative values, bubble down first
      // check: https://github.com/moment/moment/issues/2166

      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      } // The following code bubbles up values, see the tests for
      // examples of what that means.


      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24); // convert days to months

      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }

    function daysToMonths(days) {
      // 400 years have 146097 days (taking into account leap year rules)
      // 400 years have 12 months === 4800
      return days * 4800 / 146097;
    }

    function monthsToDays(months) {
      // the reverse of daysToMonths
      return months * 146097 / 4800;
    }

    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }

      var days;
      var months;
      var milliseconds = this._milliseconds;
      units = normalizeUnits(units);

      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);

        switch (units) {
          case 'month':
            return months;

          case 'quarter':
            return months / 3;

          case 'year':
            return months / 12;
        }
      } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));

        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;

          case 'day':
            return days + milliseconds / 864e5;

          case 'hour':
            return days * 24 + milliseconds / 36e5;

          case 'minute':
            return days * 1440 + milliseconds / 6e4;

          case 'second':
            return days * 86400 + milliseconds / 1000;
          // Math.floor prevents floating point math errors here

          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;

          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    } // TODO: Use this.as('ms')?


    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }

      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asQuarters = makeAs('Q');
    var asYears = makeAs('y');

    function clone$1() {
      return createDuration(this);
    }

    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
      return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month
      M: 11 // months to year

    }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
      var duration = createDuration(posNegDuration).abs();
      var seconds = round(duration.as('s'));
      var minutes = round(duration.as('m'));
      var hours = round(duration.as('h'));
      var days = round(duration.as('d'));
      var months = round(duration.as('M'));
      var years = round(duration.as('y'));
      var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    } // This function allows you to set the rounding function for relative time strings


    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }

      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }

      return false;
    } // This function allows you to set a threshold for relative time strings


    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }

      if (limit === undefined) {
        return thresholds[threshold];
      }

      thresholds[threshold] = limit;

      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }

      return true;
    }

    function humanize(withSuffix) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var locale = this.localeData();
      var output = relativeTime$1(this, !withSuffix, locale);

      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }

      return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
      // for ISO strings we do not use the normal bubbling rules:
      //  * milliseconds bubble up until they become hours
      //  * days do not bubble at all
      //  * months bubble up until they become years
      // This is because there is no context-free conversion between hours and days
      // (think of clock changes)
      // and also not between days and months (28-31 days per month)
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var seconds = abs$1(this._milliseconds) / 1000;
      var days = abs$1(this._days);
      var months = abs$1(this._months);
      var minutes, hours, years; // 3600 seconds -> 60 minutes -> 1 hour

      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60; // 12 months -> 1 year

      years = absFloor(months / 12);
      months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

      var Y = years;
      var M = months;
      var D = days;
      var h = hours;
      var m = minutes;
      var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      var total = this.asSeconds();

      if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
      }

      var totalSign = total < 0 ? '-' : '';
      var ymSign = sign(this._months) !== sign(total) ? '-' : '';
      var daysSign = sign(this._days) !== sign(total) ? '-' : '';
      var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (Y ? ymSign + Y + 'Y' : '') + (M ? ymSign + M + 'M' : '') + (D ? daysSign + D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? hmsSign + h + 'H' : '') + (m ? hmsSign + m + 'M' : '') + (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang; // Side effect imports
    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf'); // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    }); // Side effect imports

    hooks.version = '2.24.0';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      // <input type="datetime-local" step="0.001" />
      DATE: 'YYYY-MM-DD',
      // <input type="date" />
      TIME: 'HH:mm',
      // <input type="time" />
      TIME_SECONDS: 'HH:mm:ss',
      // <input type="time" step="1" />
      TIME_MS: 'HH:mm:ss.SSS',
      // <input type="time" step="0.001" />
      WEEK: 'GGGG-[W]WW',
      // <input type="week" />
      MONTH: 'YYYY-MM' // <input type="month" />

    };
    return hooks;
  });
});
var interopDefault_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = interopDefault; // https://github.com/moment/moment/issues/3650
  // since we are using ts 3.5.1, it should be safe to remove.

  function interopDefault(m) {
    return m["default"] || m;
  }
});
unwrapExports(interopDefault_1);
var localeProvider = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.ANT_MARK = void 0;

  var React = _interopRequireWildcard(React__default);

  var PropTypes = _interopRequireWildcard(propTypes$1);

  var moment$$1 = _interopRequireWildcard(moment);

  var _interopDefault = _interopRequireDefault(interopDefault_1);

  var _warning = _interopRequireDefault(warning$2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  var ANT_MARK = 'internalMark';
  exports.ANT_MARK = ANT_MARK;

  function setMomentLocale(locale$$1) {
    if (locale$$1 && locale$$1.locale) {
      (0, _interopDefault["default"])(moment$$1).locale(locale$$1.locale);
    } else {
      (0, _interopDefault["default"])(moment$$1).locale('en');
    }
  }

  var LocaleProvider =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(LocaleProvider, _React$Component);

    function LocaleProvider(props) {
      var _this;

      _classCallCheck(this, LocaleProvider);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(LocaleProvider).call(this, props));
      setMomentLocale(props.locale);
      (0, locale.changeConfirmLocale)(props.locale && props.locale.Modal);
      (0, _warning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
      return _this;
    }

    _createClass(LocaleProvider, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          antLocale: _extends({}, this.props.locale, {
            exist: true
          })
        };
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var locale$$1 = this.props.locale;

        if (prevProps.locale !== locale$$1) {
          setMomentLocale(locale$$1);
        }

        (0, locale.changeConfirmLocale)(locale$$1 && locale$$1.Modal);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        (0, locale.changeConfirmLocale)();
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children;
      }
    }]);

    return LocaleProvider;
  }(React.Component);

  exports["default"] = LocaleProvider;
  LocaleProvider.propTypes = {
    locale: PropTypes.object
  };
  LocaleProvider.defaultProps = {
    locale: {}
  };
  LocaleProvider.childContextTypes = {
    antLocale: PropTypes.object
  };
});
unwrapExports(localeProvider);
var localeProvider_1 = localeProvider.ANT_MARK;
var configProvider = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.withConfigConsumer = withConfigConsumer;
  exports["default"] = exports.ConfigConsumer = exports.configConsumerProps = void 0;

  var React = _interopRequireWildcard(React__default);

  var _createReactContext = _interopRequireDefault(lib$2);

  var _renderEmpty = _interopRequireDefault(renderEmpty_1);

  var _localeProvider = _interopRequireWildcard(localeProvider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  var configConsumerProps = ['getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale'];
  exports.configConsumerProps = configConsumerProps;
  var ConfigContext = (0, _createReactContext["default"])({
    // We provide a default function for Context without provider
    getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
      if (customizePrefixCls) return customizePrefixCls;
      return "ant-".concat(suffixCls);
    },
    renderEmpty: _renderEmpty["default"]
  });
  var ConfigConsumer = ConfigContext.Consumer;
  exports.ConfigConsumer = ConfigConsumer;

  var ConfigProvider =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ConfigProvider, _React$Component);

    function ConfigProvider() {
      var _this;

      _classCallCheck(this, ConfigProvider);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfigProvider).apply(this, arguments));

      _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
        var _this$props$prefixCls = _this.props.prefixCls,
            prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
        if (customizePrefixCls) return customizePrefixCls;
        return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
      };

      _this.renderProvider = function (context) {
        var _this$props = _this.props,
            children = _this$props.children,
            getPopupContainer = _this$props.getPopupContainer,
            renderEmpty = _this$props.renderEmpty,
            csp = _this$props.csp,
            autoInsertSpaceInButton = _this$props.autoInsertSpaceInButton,
            locale = _this$props.locale;

        var config = _extends({}, context, {
          getPrefixCls: _this.getPrefixCls,
          csp: csp,
          autoInsertSpaceInButton: autoInsertSpaceInButton
        });

        if (getPopupContainer) {
          config.getPopupContainer = getPopupContainer;
        }

        if (renderEmpty) {
          config.renderEmpty = renderEmpty;
        }

        return React.createElement(ConfigContext.Provider, {
          value: config
        }, React.createElement(_localeProvider["default"], {
          locale: locale,
          _ANT_MARK__: _localeProvider.ANT_MARK
        }, children));
      };

      return _this;
    }

    _createClass(ConfigProvider, [{
      key: "render",
      value: function render() {
        return React.createElement(ConfigConsumer, null, this.renderProvider);
      }
    }]);

    return ConfigProvider;
  }(React.Component);

  function withConfigConsumer(config) {
    return function (Component$$1) {
      // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
      var SFC = function SFC(props) {
        return React.createElement(ConfigConsumer, null, function (configProps) {
          var basicPrefixCls = config.prefixCls;
          var getPrefixCls = configProps.getPrefixCls;
          var customizePrefixCls = props.prefixCls;
          var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
          return React.createElement(Component$$1, _extends({}, configProps, props, {
            prefixCls: prefixCls
          }));
        });
      };

      var cons = Component$$1.constructor;
      var name = cons && cons.displayName || Component$$1.name || 'Component';
      SFC.displayName = "withConfigConsumer(".concat(name, ")");
      return SFC;
    };
  }

  var _default = ConfigProvider;
  exports["default"] = _default;
});
unwrapExports(configProvider);
var configProvider_1 = configProvider.withConfigConsumer;
var configProvider_2 = configProvider.ConfigConsumer;
var configProvider_3 = configProvider.configConsumerProps;
var Event = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var START_EVENT_NAME_MAP = {
    transitionstart: {
      transition: 'transitionstart',
      WebkitTransition: 'webkitTransitionStart',
      MozTransition: 'mozTransitionStart',
      OTransition: 'oTransitionStart',
      msTransition: 'MSTransitionStart'
    },
    animationstart: {
      animation: 'animationstart',
      WebkitAnimation: 'webkitAnimationStart',
      MozAnimation: 'mozAnimationStart',
      OAnimation: 'oAnimationStart',
      msAnimation: 'MSAnimationStart'
    }
  };
  var END_EVENT_NAME_MAP = {
    transitionend: {
      transition: 'transitionend',
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'mozTransitionEnd',
      OTransition: 'oTransitionEnd',
      msTransition: 'MSTransitionEnd'
    },
    animationend: {
      animation: 'animationend',
      WebkitAnimation: 'webkitAnimationEnd',
      MozAnimation: 'mozAnimationEnd',
      OAnimation: 'oAnimationEnd',
      msAnimation: 'MSAnimationEnd'
    }
  };
  var startEvents = [];
  var endEvents = [];

  function detectEvents() {
    var testEl = document.createElement('div');
    var style = testEl.style;

    if (!('AnimationEvent' in window)) {
      delete START_EVENT_NAME_MAP.animationstart.animation;
      delete END_EVENT_NAME_MAP.animationend.animation;
    }

    if (!('TransitionEvent' in window)) {
      delete START_EVENT_NAME_MAP.transitionstart.transition;
      delete END_EVENT_NAME_MAP.transitionend.transition;
    }

    function process(EVENT_NAME_MAP, events) {
      for (var baseEventName in EVENT_NAME_MAP) {
        if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
          var baseEvents = EVENT_NAME_MAP[baseEventName];

          for (var styleName in baseEvents) {
            if (styleName in style) {
              events.push(baseEvents[styleName]);
              break;
            }
          }
        }
      }
    }

    process(START_EVENT_NAME_MAP, startEvents);
    process(END_EVENT_NAME_MAP, endEvents);
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    detectEvents();
  }

  function addEventListener(node, eventName, eventListener) {
    node.addEventListener(eventName, eventListener, false);
  }

  function removeEventListener(node, eventName, eventListener) {
    node.removeEventListener(eventName, eventListener, false);
  }

  var TransitionEvents = {
    // Start events
    startEvents: startEvents,
    addStartEventListener: function addStartEventListener(node, eventListener) {
      if (startEvents.length === 0) {
        window.setTimeout(eventListener, 0);
        return;
      }

      startEvents.forEach(function (startEvent) {
        addEventListener(node, startEvent, eventListener);
      });
    },
    removeStartEventListener: function removeStartEventListener(node, eventListener) {
      if (startEvents.length === 0) {
        return;
      }

      startEvents.forEach(function (startEvent) {
        removeEventListener(node, startEvent, eventListener);
      });
    },
    // End events
    endEvents: endEvents,
    addEndEventListener: function addEndEventListener(node, eventListener) {
      if (endEvents.length === 0) {
        window.setTimeout(eventListener, 0);
        return;
      }

      endEvents.forEach(function (endEvent) {
        addEventListener(node, endEvent, eventListener);
      });
    },
    removeEndEventListener: function removeEndEventListener(node, eventListener) {
      if (endEvents.length === 0) {
        return;
      }

      endEvents.forEach(function (endEvent) {
        removeEventListener(node, endEvent, eventListener);
      });
    }
  };
  exports['default'] = TransitionEvents;
  module.exports = exports['default'];
});
unwrapExports(Event);
var performanceNow = createCommonjsModule(function (module) {
  // Generated by CoffeeScript 1.12.2
  (function () {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

    if (typeof performance !== "undefined" && performance !== null && performance.now) {
      module.exports = function () {
        return performance.now();
      };
    } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
      module.exports = function () {
        return (getNanoSeconds() - nodeLoadTime) / 1e6;
      };

      hrtime = process.hrtime;

      getNanoSeconds = function getNanoSeconds() {
        var hr;
        hr = hrtime();
        return hr[0] * 1e9 + hr[1];
      };

      moduleLoadTime = getNanoSeconds();
      upTime = process.uptime() * 1e9;
      nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
      module.exports = function () {
        return Date.now() - loadTime;
      };

      loadTime = Date.now();
    } else {
      module.exports = function () {
        return new Date().getTime() - loadTime;
      };

      loadTime = new Date().getTime();
    }
  }).call(commonjsGlobal);
});
var root$1 = typeof window === 'undefined' ? commonjsGlobal : window,
    vendors = ['moz', 'webkit'],
    suffix = 'AnimationFrame',
    raf = root$1['request' + suffix],
    caf = root$1['cancel' + suffix] || root$1['cancelRequest' + suffix];

for (var i$1 = 0; !raf && i$1 < vendors.length; i$1++) {
  raf = root$1[vendors[i$1] + 'Request' + suffix];
  caf = root$1[vendors[i$1] + 'Cancel' + suffix] || root$1[vendors[i$1] + 'CancelRequest' + suffix];
} // Some versions of FF have rAF but not cAF


if (!raf || !caf) {
  var last = 0,
      id$1 = 0,
      queue$1 = [],
      frameDuration = 1000 / 60;

  raf = function raf(callback) {
    if (queue$1.length === 0) {
      var _now = performanceNow(),
          next = Math.max(0, frameDuration - (_now - last));

      last = next + _now;
      setTimeout(function () {
        var cp = queue$1.slice(0); // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue

        queue$1.length = 0;

        for (var i = 0; i < cp.length; i++) {
          if (!cp[i].cancelled) {
            try {
              cp[i].callback(last);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }

    queue$1.push({
      handle: ++id$1,
      callback: callback,
      cancelled: false
    });
    return id$1;
  };

  caf = function caf(handle) {
    for (var i = 0; i < queue$1.length; i++) {
      if (queue$1[i].handle === handle) {
        queue$1[i].cancelled = true;
      }
    }
  };
}

var raf_1 = function raf_1(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root$1, fn);
};

var cancel = function cancel() {
  caf.apply(root$1, arguments);
};

var polyfill$1 = function polyfill$1(object) {
  if (!object) {
    object = root$1;
  }

  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};

raf_1.cancel = cancel;
raf_1.polyfill = polyfill$1;
var raf$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = wrapperRaf;

  var _raf = _interopRequireDefault(raf_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var id = 0;
  var ids = {}; // Support call raf with delay specified frame

  function wrapperRaf(callback) {
    var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var myId = id++;
    var restFrames = delayFrames;

    function internalCallback() {
      restFrames -= 1;

      if (restFrames <= 0) {
        callback();
        delete ids[myId];
      } else {
        ids[myId] = (0, _raf["default"])(internalCallback);
      }
    }

    ids[myId] = (0, _raf["default"])(internalCallback);
    return myId;
  }

  wrapperRaf.cancel = function (pid) {
    if (pid === undefined) return;

    _raf["default"].cancel(ids[pid]);

    delete ids[pid];
  };

  wrapperRaf.ids = ids; // export this for test usage
});
unwrapExports(raf$1);
var wave = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var _Event = _interopRequireDefault(Event);

  var _raf = _interopRequireDefault(raf$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  var styleForPesudo; // Where el is the DOM element you'd like to test for visibility

  function isHidden(element) {
    if (process.env.NODE_ENV === 'test') {
      return false;
    }

    return !element || element.offsetParent === null;
  }

  var Wave =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Wave, _React$Component);

    function Wave() {
      var _this;

      _classCallCheck(this, Wave);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Wave).apply(this, arguments));
      _this.animationStart = false;
      _this.destroy = false;

      _this.onClick = function (node, waveColor) {
        if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
          return;
        }

        var insertExtraNode = _this.props.insertExtraNode;
        _this.extraNode = document.createElement('div');
        var extraNode = _this.extraNode;
        extraNode.className = 'ant-click-animating-node';

        var attributeName = _this.getAttributeName();

        node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey

        styleForPesudo = styleForPesudo || document.createElement('style');

        if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && _this.isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
        waveColor !== 'transparent') {
          // Add nonce if CSP exist
          if (_this.csp && _this.csp.nonce) {
            styleForPesudo.nonce = _this.csp.nonce;
          }

          extraNode.style.borderColor = waveColor;
          styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");

          if (!document.body.contains(styleForPesudo)) {
            document.body.appendChild(styleForPesudo);
          }
        }

        if (insertExtraNode) {
          node.appendChild(extraNode);
        }

        _Event["default"].addStartEventListener(node, _this.onTransitionStart);

        _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
      };

      _this.bindAnimationEvent = function (node) {
        if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
          return;
        }

        var onClick = function onClick(e) {
          // Fix radio button click twice
          if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
            return;
          }

          _this.resetEffect(node); // Get wave color from target


          var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
          getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
          _this.clickWaveTimeoutId = window.setTimeout(function () {
            return _this.onClick(node, waveColor);
          }, 0);

          _raf["default"].cancel(_this.animationStartId);

          _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.

          _this.animationStartId = (0, _raf["default"])(function () {
            _this.animationStart = false;
          }, 10);
        };

        node.addEventListener('click', onClick, true);
        return {
          cancel: function cancel() {
            node.removeEventListener('click', onClick, true);
          }
        };
      };

      _this.onTransitionStart = function (e) {
        if (_this.destroy) return;
        var node = (0, ReactDOM__default.findDOMNode)(_assertThisInitialized(_this));

        if (!e || e.target !== node) {
          return;
        }

        if (!_this.animationStart) {
          _this.resetEffect(node);
        }
      };

      _this.onTransitionEnd = function (e) {
        if (!e || e.animationName !== 'fadeEffect') {
          return;
        }

        _this.resetEffect(e.target);
      };

      _this.renderWave = function (_ref) {
        var csp = _ref.csp;
        var children = _this.props.children;
        _this.csp = csp;
        return children;
      };

      return _this;
    }

    _createClass(Wave, [{
      key: "isNotGrey",
      value: function isNotGrey(color) {
        var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);

        if (match && match[1] && match[2] && match[3]) {
          return !(match[1] === match[2] && match[2] === match[3]);
        }

        return true;
      }
    }, {
      key: "getAttributeName",
      value: function getAttributeName() {
        var insertExtraNode = this.props.insertExtraNode;
        return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
      }
    }, {
      key: "resetEffect",
      value: function resetEffect(node) {
        if (!node || node === this.extraNode || !(node instanceof Element)) {
          return;
        }

        var insertExtraNode = this.props.insertExtraNode;
        var attributeName = this.getAttributeName();
        node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466

        this.removeExtraStyleNode();

        if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
          node.removeChild(this.extraNode);
        }

        _Event["default"].removeStartEventListener(node, this.onTransitionStart);

        _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
      }
    }, {
      key: "removeExtraStyleNode",
      value: function removeExtraStyleNode() {
        if (styleForPesudo) {
          styleForPesudo.innerHTML = '';
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var node = (0, ReactDOM__default.findDOMNode)(this);

        if (!node || node.nodeType !== 1) {
          return;
        }

        this.instance = this.bindAnimationEvent(node);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.instance) {
          this.instance.cancel();
        }

        if (this.clickWaveTimeoutId) {
          clearTimeout(this.clickWaveTimeoutId);
        }

        this.destroy = true;
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(configProvider.ConfigConsumer, null, this.renderWave);
      }
    }]);

    return Wave;
  }(React.Component);

  exports["default"] = Wave;
});
unwrapExports(wave);
var type = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.tupleNum = exports.tuple = void 0; // https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead

  var tuple = function tuple() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args;
  };

  exports.tuple = tuple;

  var tupleNum = function tupleNum() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return args;
  };

  exports.tupleNum = tupleNum;
});
unwrapExports(type);
var type_1 = type.tupleNum;
var type_2 = type.tuple;
var button = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var PropTypes = _interopRequireWildcard(propTypes$1);

  var _classnames = _interopRequireDefault(classnames);

  var _omit = _interopRequireDefault(omit);

  var _icon = _interopRequireDefault(icon);

  var _wave = _interopRequireDefault(wave);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var __rest = function __rest(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };

  var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
  var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);

  function isString(str) {
    return typeof str === 'string';
  }

  function spaceChildren(children, needInserted) {
    var isPrevChildPure = false;
    var childList = [];
    React.Children.forEach(children, function (child) {
      var type$$1 = _typeof(child);

      var isCurrentChildPure = type$$1 === 'string' || type$$1 === 'number';

      if (isPrevChildPure && isCurrentChildPure) {
        var lastIndex = childList.length - 1;
        var lastChild = childList[lastIndex];
        childList[lastIndex] = "".concat(lastChild).concat(child);
      } else {
        childList.push(child);
      }

      isPrevChildPure = isCurrentChildPure;
    }); // Pass to React.Children.map to auto fill key

    return React.Children.map(childList, function (child) {
      return insertSpace(child, needInserted);
    });
  } // Insert one space between two chinese characters automatically.


  function insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child == null) {
      return;
    }

    var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.

    if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
      return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
    }

    if (typeof child === 'string') {
      if (isTwoCNChar(child)) {
        child = child.split('').join(SPACE);
      }

      return React.createElement("span", null, child);
    }

    return child;
  }

  var ButtonTypes = (0, type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
  var ButtonShapes = (0, type.tuple)('circle', 'circle-outline', 'round');
  var ButtonSizes = (0, type.tuple)('large', 'default', 'small');
  var ButtonHTMLTypes = (0, type.tuple)('submit', 'button', 'reset');

  var Button =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Button, _React$Component);

    function Button(props) {
      var _this;

      _classCallCheck(this, Button);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this, props));

      _this.saveButtonRef = function (node) {
        _this.buttonNode = node;
      };

      _this.handleClick = function (e) {
        var loading = _this.state.loading;
        var onClick = _this.props.onClick;

        if (!!loading) {
          return;
        }

        if (onClick) {
          onClick(e);
        }
      };

      _this.renderButton = function (_ref) {
        var _classNames;

        var getPrefixCls = _ref.getPrefixCls,
            autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;

        var _a = _this.props,
            customizePrefixCls = _a.prefixCls,
            type$$1 = _a.type,
            shape = _a.shape,
            size = _a.size,
            className = _a.className,
            children = _a.children,
            icon$$1 = _a.icon,
            ghost = _a.ghost,
            _loadingProp = _a.loading,
            block = _a.block,
            rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "loading", "block"]);

        var _this$state = _this.state,
            loading = _this$state.loading,
            hasTwoCNChar = _this$state.hasTwoCNChar;
        var prefixCls = getPrefixCls('btn', customizePrefixCls);
        var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
        // small => sm

        var sizeCls = '';

        switch (size) {
          case 'large':
            sizeCls = 'lg';
            break;

          case 'small':
            sizeCls = 'sm';
            break;

          default:
            break;
        }

        var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type$$1), type$$1), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && icon$$1), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
        var iconType = loading ? 'loading' : icon$$1;
        var iconNode = iconType ? React.createElement(_icon["default"], {
          type: iconType
        }) : null;
        var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
        var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType']);

        if (linkButtonRestProps.href !== undefined) {
          return React.createElement("a", _extends({}, linkButtonRestProps, {
            className: classes,
            onClick: _this.handleClick,
            ref: _this.saveButtonRef
          }), iconNode, kids);
        } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.


        var _b = rest,
            htmlType = _b.htmlType,
            otherProps = __rest(_b, ["htmlType"]);

        var buttonNode = React.createElement("button", _extends({}, otherProps, {
          type: htmlType,
          className: classes,
          onClick: _this.handleClick,
          ref: _this.saveButtonRef
        }), iconNode, kids);

        if (type$$1 === 'link') {
          return buttonNode;
        }

        return React.createElement(_wave["default"], null, buttonNode);
      };

      _this.state = {
        loading: props.loading,
        hasTwoCNChar: false
      };
      return _this;
    }

    _createClass(Button, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.fixTwoCNChar();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        this.fixTwoCNChar();

        if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
          clearTimeout(this.delayTimeout);
        }

        var loading = this.props.loading;

        if (loading && typeof loading !== 'boolean' && loading.delay) {
          this.delayTimeout = window.setTimeout(function () {
            return _this2.setState({
              loading: loading
            });
          }, loading.delay);
        } else if (prevProps.loading === this.props.loading) {
          return;
        } else {
          this.setState({
            loading: loading
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.delayTimeout) {
          clearTimeout(this.delayTimeout);
        }
      }
    }, {
      key: "fixTwoCNChar",
      value: function fixTwoCNChar() {
        // Fix for HOC usage like <FormatMessage />
        if (!this.buttonNode) {
          return;
        }

        var buttonText = this.buttonNode.textContent || this.buttonNode.innerText;

        if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
          if (!this.state.hasTwoCNChar) {
            this.setState({
              hasTwoCNChar: true
            });
          }
        } else if (this.state.hasTwoCNChar) {
          this.setState({
            hasTwoCNChar: false
          });
        }
      }
    }, {
      key: "isNeedInserted",
      value: function isNeedInserted() {
        var _this$props = this.props,
            icon$$1 = _this$props.icon,
            children = _this$props.children;
        return React.Children.count(children) === 1 && !icon$$1;
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(configProvider.ConfigConsumer, null, this.renderButton);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.loading instanceof Boolean) {
          return _extends({}, prevState, {
            loading: nextProps.loading
          });
        }

        return null;
      }
    }]);

    return Button;
  }(React.Component);

  Button.__ANT_BUTTON = true;
  Button.defaultProps = {
    loading: false,
    ghost: false,
    block: false,
    htmlType: 'button'
  };
  Button.propTypes = {
    type: PropTypes.string,
    shape: PropTypes.oneOf(ButtonShapes),
    size: PropTypes.oneOf(ButtonSizes),
    htmlType: PropTypes.oneOf(ButtonHTMLTypes),
    onClick: PropTypes.func,
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    className: PropTypes.string,
    icon: PropTypes.string,
    block: PropTypes.bool
  };
  (0, reactLifecyclesCompat_es.polyfill)(Button);
  var _default = Button;
  exports["default"] = _default;
});
unwrapExports(button);
var buttonGroup = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var _classnames = _interopRequireDefault(classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var __rest = function __rest(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };

  var ButtonGroup = function ButtonGroup(props) {
    return React.createElement(configProvider.ConfigConsumer, null, function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var customizePrefixCls = props.prefixCls,
          size = props.size,
          className = props.className,
          others = __rest(props, ["prefixCls", "size", "className"]);

      var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
      // small => sm

      var sizeCls = '';

      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;

        case 'small':
          sizeCls = 'sm';

        default:
          break;
      }

      var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
      return React.createElement("div", _extends({}, others, {
        className: classes
      }));
    });
  };

  var _default = ButtonGroup;
  exports["default"] = _default;
});
unwrapExports(buttonGroup);
var button$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _button = _interopRequireDefault(button);

  var _buttonGroup = _interopRequireDefault(buttonGroup);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  _button["default"].Group = _buttonGroup["default"];
  var _default = _button["default"];
  exports["default"] = _default;
});
unwrapExports(button$2);
var Modal_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.destroyFns = void 0;

  var React = _interopRequireWildcard(React__default);

  var _rcDialog = _interopRequireDefault(require$$1);

  var PropTypes = _interopRequireWildcard(propTypes$1);

  var _classnames = _interopRequireDefault(classnames);

  var _addEventListener = _interopRequireDefault(addEventListener$2);

  var _icon = _interopRequireDefault(icon);

  var _button = _interopRequireDefault(button$2);

  var _LocaleReceiver = _interopRequireDefault(LocaleReceiver_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  var __rest = function __rest(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };

  var mousePosition;
  var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795

  exports.destroyFns = destroyFns;

  var getClickPosition = function getClickPosition(e) {
    mousePosition = {
      x: e.pageX,
      y: e.pageY
    }; // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开

    setTimeout(function () {
      return mousePosition = null;
    }, 100);
  }; // 只有点击事件支持从鼠标位置动画展开


  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
    (0, _addEventListener["default"])(document.documentElement, 'click', getClickPosition);
  }

  var Modal =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Modal, _React$Component);

    function Modal() {
      var _this;

      _classCallCheck(this, Modal);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));

      _this.handleCancel = function (e) {
        var onCancel = _this.props.onCancel;

        if (onCancel) {
          onCancel(e);
        }
      };

      _this.handleOk = function (e) {
        var onOk = _this.props.onOk;

        if (onOk) {
          onOk(e);
        }
      };

      _this.renderFooter = function (locale$$1) {
        var _this$props = _this.props,
            okText = _this$props.okText,
            okType = _this$props.okType,
            cancelText = _this$props.cancelText,
            confirmLoading = _this$props.confirmLoading;
        return React.createElement("div", null, React.createElement(_button["default"], _extends({
          onClick: _this.handleCancel
        }, _this.props.cancelButtonProps), cancelText || locale$$1.cancelText), React.createElement(_button["default"], _extends({
          type: okType,
          loading: confirmLoading,
          onClick: _this.handleOk
        }, _this.props.okButtonProps), okText || locale$$1.okText));
      };

      _this.renderModal = function (_ref) {
        var getContextPopupContainer = _ref.getPopupContainer,
            getPrefixCls = _ref.getPrefixCls;

        var _a = _this.props,
            customizePrefixCls = _a.prefixCls,
            footer = _a.footer,
            visible = _a.visible,
            wrapClassName = _a.wrapClassName,
            centered = _a.centered,
            getContainer = _a.getContainer,
            restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer"]);

        var prefixCls = getPrefixCls('modal', customizePrefixCls);
        var defaultFooter = React.createElement(_LocaleReceiver["default"], {
          componentName: "Modal",
          defaultLocale: (0, locale.getConfirmLocale)()
        }, _this.renderFooter);
        var closeIcon = React.createElement("span", {
          className: "".concat(prefixCls, "-close-x")
        }, React.createElement(_icon["default"], {
          className: "".concat(prefixCls, "-close-icon"),
          type: "close"
        }));
        return React.createElement(_rcDialog["default"], _extends({}, restProps, {
          getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
          prefixCls: prefixCls,
          wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
          footer: footer === undefined ? defaultFooter : footer,
          visible: visible,
          mousePosition: mousePosition,
          onClose: _this.handleCancel,
          closeIcon: closeIcon
        }));
      };

      return _this;
    }

    _createClass(Modal, [{
      key: "render",
      value: function render() {
        return React.createElement(configProvider.ConfigConsumer, null, this.renderModal);
      }
    }]);

    return Modal;
  }(React.Component);

  exports["default"] = Modal;
  Modal.defaultProps = {
    width: 520,
    transitionName: 'zoom',
    maskTransitionName: 'fade',
    confirmLoading: false,
    visible: false,
    okType: 'primary'
  };
  Modal.propTypes = {
    prefixCls: PropTypes.string,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    okText: PropTypes.node,
    cancelText: PropTypes.node,
    centered: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    confirmLoading: PropTypes.bool,
    visible: PropTypes.bool,
    footer: PropTypes.node,
    title: PropTypes.node,
    closable: PropTypes.bool
  };
});
unwrapExports(Modal_1);
var Modal_2 = Modal_1.destroyFns;
var ActionButton_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var ReactDOM = _interopRequireWildcard(ReactDOM__default);

  var _button = _interopRequireDefault(button$2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  var ActionButton =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ActionButton, _React$Component);

    function ActionButton(props) {
      var _this;

      _classCallCheck(this, ActionButton);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionButton).call(this, props));

      _this.onClick = function () {
        var _this$props = _this.props,
            actionFn = _this$props.actionFn,
            closeModal = _this$props.closeModal;

        if (actionFn) {
          var ret;

          if (actionFn.length) {
            ret = actionFn(closeModal);
          } else {
            ret = actionFn();

            if (!ret) {
              closeModal();
            }
          }

          if (ret && ret.then) {
            _this.setState({
              loading: true
            });

            ret.then(function () {
              // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
              // this.setState({ loading: false });
              closeModal.apply(void 0, arguments);
            }, function (e) {
              // Emit error when catch promise reject
              console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183

              _this.setState({
                loading: false
              });
            });
          }
        } else {
          closeModal();
        }
      };

      _this.state = {
        loading: false
      };
      return _this;
    }

    _createClass(ActionButton, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.autoFocus) {
          var $this = ReactDOM.findDOMNode(this);
          this.timeoutId = setTimeout(function () {
            return $this.focus();
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        clearTimeout(this.timeoutId);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            type = _this$props2.type,
            children = _this$props2.children,
            buttonProps = _this$props2.buttonProps;
        var loading = this.state.loading;
        return React.createElement(_button["default"], _extends({
          type: type,
          onClick: this.onClick,
          loading: loading
        }, buttonProps), children);
      }
    }]);

    return ActionButton;
  }(React.Component);

  exports["default"] = ActionButton;
});
unwrapExports(ActionButton_1);
var confirm_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = confirm;

  var React = _interopRequireWildcard(React__default);

  var ReactDOM = _interopRequireWildcard(ReactDOM__default);

  var _classnames = _interopRequireDefault(classnames);

  var _icon = _interopRequireDefault(icon);

  var _Modal = _interopRequireWildcard(Modal_1);

  var _ActionButton = _interopRequireDefault(ActionButton_1);

  var _warning = _interopRequireDefault(warning$2);

  var _this = void 0;

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var IS_REACT_16 = !!ReactDOM.createPortal;

  var ConfirmDialog = function ConfirmDialog(props) {
    var onCancel = props.onCancel,
        onOk = props.onOk,
        close = props.close,
        zIndex = props.zIndex,
        afterClose = props.afterClose,
        visible = props.visible,
        keyboard = props.keyboard,
        centered = props.centered,
        getContainer = props.getContainer,
        maskStyle = props.maskStyle,
        okButtonProps = props.okButtonProps,
        cancelButtonProps = props.cancelButtonProps,
        _props$iconType = props.iconType,
        iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
    (0, _warning["default"])(!('iconType' in props), 'Modal', "The property 'iconType' is deprecated. Use the property 'icon' instead."); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon

    var icon$$1 = props.icon === undefined ? iconType : props.icon;
    var okType = props.okType || 'primary';
    var prefixCls = props.prefixCls || 'ant-modal';
    var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容

    var okCancel = 'okCancel' in props ? props.okCancel : true;
    var width = props.width || 416;
    var style = props.style || {};
    var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为

    var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    var runtimeLocale = (0, locale.getConfirmLocale)();
    var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
    var cancelText = props.cancelText || runtimeLocale.cancelText;
    var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    var transitionName = props.transitionName || 'zoom';
    var maskTransitionName = props.maskTransitionName || 'fade';
    var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
    var cancelButton = okCancel && React.createElement(_ActionButton["default"], {
      actionFn: onCancel,
      closeModal: close,
      autoFocus: autoFocusButton === 'cancel',
      buttonProps: cancelButtonProps
    }, cancelText);
    var iconNode = typeof icon$$1 === 'string' ? React.createElement(_icon["default"], {
      type: icon$$1
    }) : icon$$1;
    return React.createElement(_Modal["default"], {
      prefixCls: prefixCls,
      className: classString,
      wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
      onCancel: close.bind(_this, {
        triggerCancel: true
      }),
      visible: visible,
      title: "",
      transitionName: transitionName,
      footer: "",
      maskTransitionName: maskTransitionName,
      mask: mask,
      maskClosable: maskClosable,
      maskStyle: maskStyle,
      style: style,
      width: width,
      zIndex: zIndex,
      afterClose: afterClose,
      keyboard: keyboard,
      centered: centered,
      getContainer: getContainer
    }, React.createElement("div", {
      className: "".concat(contentPrefixCls, "-body-wrapper")
    }, React.createElement("div", {
      className: "".concat(contentPrefixCls, "-body")
    }, iconNode, React.createElement("span", {
      className: "".concat(contentPrefixCls, "-title")
    }, props.title), React.createElement("div", {
      className: "".concat(contentPrefixCls, "-content")
    }, props.content)), React.createElement("div", {
      className: "".concat(contentPrefixCls, "-btns")
    }, cancelButton, React.createElement(_ActionButton["default"], {
      type: okType,
      actionFn: onOk,
      closeModal: close,
      autoFocus: autoFocusButton === 'ok',
      buttonProps: okButtonProps
    }, okText))));
  };

  function confirm(config) {
    var div = document.createElement('div');
    document.body.appendChild(div);

    var currentConfig = _extends({}, config, {
      close: close,
      visible: true
    });

    function close() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      currentConfig = _extends({}, currentConfig, {
        visible: false,
        afterClose: destroy.bind.apply(destroy, [this].concat(args))
      });

      if (IS_REACT_16) {
        render(currentConfig);
      } else {
        destroy.apply(void 0, args);
      }
    }

    function update(newConfig) {
      currentConfig = _extends({}, currentConfig, newConfig);
      render(currentConfig);
    }

    function destroy() {
      var unmountResult = ReactDOM.unmountComponentAtNode(div);

      if (unmountResult && div.parentNode) {
        div.parentNode.removeChild(div);
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var triggerCancel = args.some(function (param) {
        return param && param.triggerCancel;
      });

      if (config.onCancel && triggerCancel) {
        config.onCancel.apply(config, args);
      }

      for (var i = 0; i < _Modal.destroyFns.length; i++) {
        var fn = _Modal.destroyFns[i];

        if (fn === close) {
          _Modal.destroyFns.splice(i, 1);

          break;
        }
      }
    }

    function render(props) {
      ReactDOM.render(React.createElement(ConfirmDialog, _extends({}, props, {
        getContainer: false
      })), div);
    }

    render(currentConfig);

    _Modal.destroyFns.push(close);

    return {
      destroy: close,
      update: update
    };
  }
});
unwrapExports(confirm_1);
var modal = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var React = _interopRequireWildcard(React__default);

  var _Modal = _interopRequireWildcard(Modal_1);

  var _confirm = _interopRequireDefault(confirm_1);

  var _icon = _interopRequireDefault(icon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  _Modal["default"].info = function (props) {
    var config = _extends({
      type: 'info',
      icon: React.createElement(_icon["default"], {
        type: "info-circle"
      }),
      okCancel: false
    }, props);

    return (0, _confirm["default"])(config);
  };

  _Modal["default"].success = function (props) {
    var config = _extends({
      type: 'success',
      icon: React.createElement(_icon["default"], {
        type: "check-circle"
      }),
      okCancel: false
    }, props);

    return (0, _confirm["default"])(config);
  };

  _Modal["default"].error = function (props) {
    var config = _extends({
      type: 'error',
      icon: React.createElement(_icon["default"], {
        type: "close-circle"
      }),
      okCancel: false
    }, props);

    return (0, _confirm["default"])(config);
  };

  _Modal["default"].warning = _Modal["default"].warn = function (props) {
    var config = _extends({
      type: 'warning',
      icon: React.createElement(_icon["default"], {
        type: "exclamation-circle"
      }),
      okCancel: false
    }, props);

    return (0, _confirm["default"])(config);
  };

  _Modal["default"].confirm = function (props) {
    var config = _extends({
      type: 'confirm',
      okCancel: true
    }, props);

    return (0, _confirm["default"])(config);
  };

  _Modal["default"].destroyAll = function () {
    while (_Modal.destroyFns.length) {
      var close = _Modal.destroyFns.pop();

      if (close) {
        close();
      }
    }
  };

  var _default = _Modal["default"];
  exports["default"] = _default;
});

var _Modal = unwrapExports(modal);

var confirm$1 = _Modal.confirm;

var FollowupVisitButton =
/*#__PURE__*/
function (_PureComponent) {
  inherits(FollowupVisitButton, _PureComponent);

  function FollowupVisitButton() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, FollowupVisitButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(FollowupVisitButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      dropdownVisible: _this.props.dropdownVisible,
      disabled: false
    });
    defineProperty(assertThisInitialized(_this), "onClick", function () {
      var state = !_this.state.dropdownVisible;
      var followupLen = _this.props.followupLen;

      if (followupLen === 0) {
        confirm$1({
          title: '提示',
          content: '该病例没有随访记录',
          okText: '知道了',
          okType: 'danger',
          cancelText: '关闭',
          cancelButtonProps: {
            disabled: true
          },
          onOk: function onOk() {}
        });

        _this.setState({
          disabled: true
        });
      } else {
        _this.setState({
          dropdownVisible: state
        });

        if (_this.props.followupVisibleCallBack) _this.props.followupVisibleCallBack(state);
      }
    });
    return _this;
  }

  createClass(FollowupVisitButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var dropdownVisible = this.props.dropdownVisible;

      if (dropdownVisible !== prevProps.dropdownVisible) {
        this.setState({
          dropdownVisible: dropdownVisible
        });
        if (this.props.followupVisibleCallBack) this.props.followupVisibleCallBack(dropdownVisible);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "btn-group"
      }, React__default.createElement(ToolbarButton$1, {
        isActive: this.state.dropdownVisible,
        disabled: this.state.disabled,
        label: '历史',
        icon: "followup",
        onClick: this.onClick
      }));
    }
  }]);
  return FollowupVisitButton;
}(PureComponent);

defineProperty(FollowupVisitButton, "defaultProps", {
  dropdownVisible: false,
  followupLen: 0
});
defineProperty(FollowupVisitButton, "propTypes", {
  dropdownVisible: propTypes.bool.isRequired,

  /** Called with the selectedCell number when grid sell is selected */

  /** The cell to show as selected */
  selectedCell: propTypes.object,
  followupLen: propTypes.number,
  onClick: propTypes.func,
  followupVisibleCallBack: propTypes.func
});
var css$d = ".measurementTable {\n  background-color: var(--primary-background-color);\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.measurementTable .maxMeasurements {\n  border-radius: 3px;\n  color: var(--primary-background-color);\n  font-size: 12px;\n  font-weight: 500;\n  height: 19px;\n  line-height: 17px;\n  margin-top: 22px;\n  margin-right: 15px;\n  padding: 2px 6px 0;\n  text-transform: uppercase;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  background-color: var(--default-color);\n}\n.measurementTable .measurementTableHeader {\n  padding-left: 45px;\n}\n.measurementTable .measurementTableHeader .measurementTableHeaderItem {\n  display: inline-block;\n  margin-top: 9px;\n  margin-left: 9px;\n  padding-left: 9px;\n  width: 90px;\n  font-size: 14px;\n  line-height: 20px;\n  border-left: 1px solid var(--text-secondary-color);\n  color: var(--text-primary-color);\n}\n.measurementTable .measurementTableHeader .measurementTableHeaderItem .timepointLabel {\n  color: var(--text-secondary-color);\n  font-size: 12px;\n}\n.measurementTable .measurementTableHeader .warning-status {\n  display: block;\n  position: absolute;\n  width: 50px;\n  height: 40px;\n  padding-left: 7px;\n  left: 15px;\n  top: 7px;\n}\n.measurementTable .measurementTableHeader .warning-status .warning-border {\n  display: block;\n  border: 2px solid #e29e4a;\n  border-radius: 36px;\n  padding: 6px 7px;\n  width: 40px;\n  height: 40px;\n}\n.measurementTable .measurementTableHeader .warning-status svg {\n  color: #e29e4a;\n  width: 22px;\n  height: 20px;\n  pointer-events: inherit;\n}\n.tooltip-warning.in {\n  opacity: 1;\n}\n.tooltip-warning .tooltip-inner {\n  padding: 0;\n}\n.tooltip-warning .tooltip-inner .warningTitle {\n  text-align: left;\n  background-color: var(--ui-gray-darkest);\n  padding: 7px 15px;\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px;\n}\n.tooltip-warning .tooltip-inner .warningContent {\n  text-align: center;\n  background-color: var(--ui-gray);\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n}\n.tooltip-warning .tooltip-inner .warningContent ol {\n  margin-top: auto;\n  -webkit-padding-start: 20px;\n          padding-inline-start: 20px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 25px;\n  text-align: left;\n}\n.tooltip-warning .tooltip-inner .warningContent ol li {\n  padding-right: 10px;\n}\n";
styleInject(css$d);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties$1 = _objectWithoutProperties$1;
var interopRequireDefault = createCommonjsModule(function (module) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  module.exports = _interopRequireDefault;
});
unwrapExports(interopRequireDefault);
var inDOM = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

  exports.default = _default;
  module.exports = exports["default"];
});
unwrapExports(inDOM);
var contains$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var _inDOM = interopRequireDefault(inDOM);

  var _default = function () {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    return _inDOM.default ? function (context, node) {
      if (context.contains) {
        return context.contains(node);
      } else if (context.compareDocumentPosition) {
        return context === node || !!(context.compareDocumentPosition(node) & 16);
      } else {
        return fallback(context, node);
      }
    } : fallback;
  }();

  exports.default = _default;

  function fallback(context, node) {
    if (node) do {
      if (node === context) return true;
    } while (node = node.parentNode);
    return false;
  }

  module.exports = exports["default"];
});
var contains$2 = unwrapExports(contains$1);
var isWindow = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = getWindow;

  function getWindow(node) {
    return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
  }

  module.exports = exports["default"];
});
unwrapExports(isWindow);
var ownerDocument_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = ownerDocument;

  function ownerDocument(node) {
    return node && node.ownerDocument || document;
  }

  module.exports = exports["default"];
});
unwrapExports(ownerDocument_1);
var offset_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = offset;

  var _contains = interopRequireDefault(contains$1);

  var _isWindow = interopRequireDefault(isWindow);

  var _ownerDocument = interopRequireDefault(ownerDocument_1);

  function offset(node) {
    var doc = (0, _ownerDocument.default)(node),
        win = (0, _isWindow.default)(doc),
        docElem = doc && doc.documentElement,
        box = {
      top: 0,
      left: 0,
      height: 0,
      width: 0
    };
    if (!doc) return; // Make sure it's not a disconnected DOM node

    if (!(0, _contains.default)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

    box = {
      top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
      left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
      width: (box.width == null ? node.offsetWidth : box.width) || 0,
      height: (box.height == null ? node.offsetHeight : box.height) || 0
    };
    return box;
  }

  module.exports = exports["default"];
});
unwrapExports(offset_1);
var height_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = height;

  var _offset = interopRequireDefault(offset_1);

  var _isWindow = interopRequireDefault(isWindow);

  function height(node, client) {
    var win = (0, _isWindow.default)(node);
    return win ? win.innerHeight : client ? node.clientHeight : (0, _offset.default)(node).height;
  }

  module.exports = exports["default"];
});
unwrapExports(height_1);
var camelize_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = camelize;
  var rHyphen = /-(.)/g;

  function camelize(string) {
    return string.replace(rHyphen, function (_, chr) {
      return chr.toUpperCase();
    });
  }

  module.exports = exports["default"];
});
unwrapExports(camelize_1);
var camelizeStyle = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = camelizeStyleName;

  var _camelize = interopRequireDefault(camelize_1);
  /**
   * Copyright 2014-2015, Facebook, Inc.
   * All rights reserved.
   * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
   */


  var msPattern = /^-ms-/;

  function camelizeStyleName(string) {
    return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
  }

  module.exports = exports["default"];
});
unwrapExports(camelizeStyle);
var hyphenate_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = hyphenate;
  var rUpper = /([A-Z])/g;

  function hyphenate(string) {
    return string.replace(rUpper, '-$1').toLowerCase();
  }

  module.exports = exports["default"];
});
unwrapExports(hyphenate_1);
var hyphenateStyle = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = hyphenateStyleName;

  var _hyphenate = interopRequireDefault(hyphenate_1);
  /**
   * Copyright 2013-2014, Facebook, Inc.
   * All rights reserved.
   * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
   */


  var msPattern = /^ms-/;

  function hyphenateStyleName(string) {
    return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
  }

  module.exports = exports["default"];
});
unwrapExports(hyphenateStyle);
var getComputedStyle$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = _getComputedStyle;

  var _camelizeStyle = interopRequireDefault(camelizeStyle);

  var rposition = /^(top|right|bottom|left)$/;
  var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

  function _getComputedStyle(node) {
    if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
    var doc = node.ownerDocument;
    return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
      //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
      getPropertyValue: function getPropertyValue(prop) {
        var style = node.style;
        prop = (0, _camelizeStyle.default)(prop);
        if (prop == 'float') prop = 'styleFloat';
        var current = node.currentStyle[prop] || null;
        if (current == null && style && style[prop]) current = style[prop];

        if (rnumnonpx.test(current) && !rposition.test(prop)) {
          // Remember the original values
          var left = style.left;
          var runStyle = node.runtimeStyle;
          var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

          if (rsLeft) runStyle.left = node.currentStyle.left;
          style.left = prop === 'fontSize' ? '1em' : current;
          current = style.pixelLeft + 'px'; // Revert the changed values

          style.left = left;
          if (rsLeft) runStyle.left = rsLeft;
        }

        return current;
      }
    };
  }

  module.exports = exports["default"];
});
unwrapExports(getComputedStyle$1);
var removeStyle_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = removeStyle;

  function removeStyle(node, key) {
    return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
  }

  module.exports = exports["default"];
});
unwrapExports(removeStyle_1);
var properties = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

  var _inDOM = interopRequireDefault(inDOM);

  var transform = 'transform';
  exports.transform = transform;
  var prefix, transitionEnd, animationEnd;
  exports.animationEnd = animationEnd;
  exports.transitionEnd = transitionEnd;
  var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
  exports.transitionDelay = transitionDelay;
  exports.transitionTiming = transitionTiming;
  exports.transitionDuration = transitionDuration;
  exports.transitionProperty = transitionProperty;
  var animationName, animationDuration, animationTiming, animationDelay;
  exports.animationDelay = animationDelay;
  exports.animationTiming = animationTiming;
  exports.animationDuration = animationDuration;
  exports.animationName = animationName;

  if (_inDOM.default) {
    var _getTransitionPropert = getTransitionProperties();

    prefix = _getTransitionPropert.prefix;
    exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
    exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
    exports.transform = transform = prefix + "-" + transform;
    exports.transitionProperty = transitionProperty = prefix + "-transition-property";
    exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
    exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
    exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
    exports.animationName = animationName = prefix + "-animation-name";
    exports.animationDuration = animationDuration = prefix + "-animation-duration";
    exports.animationTiming = animationTiming = prefix + "-animation-delay";
    exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
  }

  var _default = {
    transform: transform,
    end: transitionEnd,
    property: transitionProperty,
    timing: transitionTiming,
    delay: transitionDelay,
    duration: transitionDuration
  };
  exports.default = _default;

  function getTransitionProperties() {
    var style = document.createElement('div').style;
    var vendorMap = {
      O: function O(e) {
        return "o" + e.toLowerCase();
      },
      Moz: function Moz(e) {
        return e.toLowerCase();
      },
      Webkit: function Webkit(e) {
        return "webkit" + e;
      },
      ms: function ms(e) {
        return "MS" + e;
      }
    };
    var vendors = Object.keys(vendorMap);
    var transitionEnd, animationEnd;
    var prefix = '';

    for (var i = 0; i < vendors.length; i++) {
      var vendor = vendors[i];

      if (vendor + "TransitionProperty" in style) {
        prefix = "-" + vendor.toLowerCase();
        transitionEnd = vendorMap[vendor]('TransitionEnd');
        animationEnd = vendorMap[vendor]('AnimationEnd');
        break;
      }
    }

    if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
    if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
    style = null;
    return {
      animationEnd: animationEnd,
      transitionEnd: transitionEnd,
      prefix: prefix
    };
  }
});
unwrapExports(properties);
var properties_1 = properties.animationEnd;
var properties_2 = properties.animationDelay;
var properties_3 = properties.animationTiming;
var properties_4 = properties.animationDuration;
var properties_5 = properties.animationName;
var properties_6 = properties.transitionEnd;
var properties_7 = properties.transitionDuration;
var properties_8 = properties.transitionDelay;
var properties_9 = properties.transitionTiming;
var properties_10 = properties.transitionProperty;
var properties_11 = properties.transform;
var isTransform_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = isTransform;
  var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

  function isTransform(property) {
    return !!(property && supportedTransforms.test(property));
  }

  module.exports = exports["default"];
});
unwrapExports(isTransform_1);
var style_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = style;

  var _camelizeStyle = interopRequireDefault(camelizeStyle);

  var _hyphenateStyle = interopRequireDefault(hyphenateStyle);

  var _getComputedStyle2 = interopRequireDefault(getComputedStyle$1);

  var _removeStyle = interopRequireDefault(removeStyle_1);

  var _isTransform = interopRequireDefault(isTransform_1);

  function style(node, property, value) {
    var css = '';
    var transforms = '';
    var props = property;

    if (typeof property === 'string') {
      if (value === undefined) {
        return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
      } else {
        (props = {})[property] = value;
      }
    }

    Object.keys(props).forEach(function (key) {
      var value = props[key];

      if (!value && value !== 0) {
        (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
      } else if ((0, _isTransform.default)(key)) {
        transforms += key + "(" + value + ") ";
      } else {
        css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
      }
    });

    if (transforms) {
      css += properties.transform + ": " + transforms + ";";
    }

    node.style.cssText += ';' + css;
  }

  module.exports = exports["default"];
});
unwrapExports(style_1);
var offsetParent_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = offsetParent;

  var _ownerDocument = interopRequireDefault(ownerDocument_1);

  var _style = interopRequireDefault(style_1);

  function nodeName(node) {
    return node.nodeName && node.nodeName.toLowerCase();
  }

  function offsetParent(node) {
    var doc = (0, _ownerDocument.default)(node),
        offsetParent = node && node.offsetParent;

    while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
      offsetParent = offsetParent.offsetParent;
    }

    return offsetParent || doc.documentElement;
  }

  module.exports = exports["default"];
});
unwrapExports(offsetParent_1);
var scrollTop_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = scrollTop;

  var _isWindow = interopRequireDefault(isWindow);

  function scrollTop(node, val) {
    var win = (0, _isWindow.default)(node);
    if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
    if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
  }

  module.exports = exports["default"];
});
unwrapExports(scrollTop_1);
var requestAnimationFrame$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var _inDOM = interopRequireDefault(inDOM);

  var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
  var cancel = 'clearTimeout';
  var raf = fallback;
  var compatRaf;

  var getKey = function getKey(vendor, k) {
    return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
  };

  if (_inDOM.default) {
    vendors.some(function (vendor) {
      var rafKey = getKey(vendor, 'request');

      if (rafKey in window) {
        cancel = getKey(vendor, 'cancel');
        return raf = function raf(cb) {
          return window[rafKey](cb);
        };
      }
    });
  }
  /* https://github.com/component/raf */


  var prev = new Date().getTime();

  function fallback(fn) {
    var curr = new Date().getTime(),
        ms = Math.max(0, 16 - (curr - prev)),
        req = setTimeout(fn, ms);
    prev = curr;
    return req;
  }

  compatRaf = function compatRaf(cb) {
    return raf(cb);
  };

  compatRaf.cancel = function (id) {
    window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
  };

  var _default = compatRaf;
  exports.default = _default;
  module.exports = exports["default"];
});
unwrapExports(requestAnimationFrame$1);
var on_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var _inDOM = interopRequireDefault(inDOM);

  var on = function on() {};

  if (_inDOM.default) {
    on = function () {
      if (document.addEventListener) return function (node, eventName, handler, capture) {
        return node.addEventListener(eventName, handler, capture || false);
      };else if (document.attachEvent) return function (node, eventName, handler) {
        return node.attachEvent('on' + eventName, function (e) {
          e = e || window.event;
          e.target = e.target || e.srcElement;
          e.currentTarget = node;
          handler.call(node, e);
        });
      };
    }();
  }

  var _default = on;
  exports.default = _default;
  module.exports = exports["default"];
});
unwrapExports(on_1);
var off_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var _inDOM = interopRequireDefault(inDOM);

  var off = function off() {};

  if (_inDOM.default) {
    off = function () {
      if (document.addEventListener) return function (node, eventName, handler, capture) {
        return node.removeEventListener(eventName, handler, capture || false);
      };else if (document.attachEvent) return function (node, eventName, handler) {
        return node.detachEvent('on' + eventName, handler);
      };
    }();
  }

  var _default = off;
  exports.default = _default;
  module.exports = exports["default"];
});
unwrapExports(off_1);
var addEventListener$4 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (node, event, handler, capture) {
    (0, _on2.default)(node, event, handler, capture);
    return {
      remove: function remove() {
        (0, _off2.default)(node, event, handler, capture);
      }
    };
  };

  var _on2 = _interopRequireDefault(on_1);

  var _off2 = _interopRequireDefault(off_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  module.exports = exports['default'];
});
unwrapExports(addEventListener$4);
var getDocumentHeight = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (doc) {
    return Math.max(doc.documentElement.offsetHeight || 0, doc.height || 0, doc.body.scrollHeight || 0, doc.body.offsetHeight || 0);
  };

  module.exports = exports["default"];
  /**
   * Get the height of the document
   *
   * @returns {documentHeight: number}
   */
});
unwrapExports(getDocumentHeight);
var ownerDocument$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (componentOrElement) {
    return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
  };

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  module.exports = exports['default'];
});
unwrapExports(ownerDocument$1);
var ownerWindow_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = ownerWindow;

  var _ownerDocument = interopRequireDefault(ownerDocument_1);

  function ownerWindow(node) {
    var doc = (0, _ownerDocument.default)(node);
    return doc && doc.defaultView || doc.parentWindow;
  }

  module.exports = exports["default"];
});
unwrapExports(ownerWindow_1);
var ownerWindow$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (componentOrElement) {
    return (0, _ownerWindow2.default)(_reactDom2.default.findDOMNode(componentOrElement));
  };

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  var _ownerWindow2 = _interopRequireDefault(ownerWindow_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  module.exports = exports['default'];
});
unwrapExports(ownerWindow$1);
var Affix_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _classnames2 = _interopRequireDefault(classnames);

  var _height2 = _interopRequireDefault(height_1);

  var _offset2 = _interopRequireDefault(offset_1);

  var _offsetParent2 = _interopRequireDefault(offsetParent_1);

  var _scrollTop2 = _interopRequireDefault(scrollTop_1);

  var _requestAnimationFrame2 = _interopRequireDefault(requestAnimationFrame$1);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _react2 = _interopRequireDefault(React__default);

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  var _addEventListener2 = _interopRequireDefault(addEventListener$4);

  var _getDocumentHeight2 = _interopRequireDefault(getDocumentHeight);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument$1);

  var _ownerWindow2 = _interopRequireDefault(ownerWindow$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The `<Affix/>` component toggles `position: fixed;` on and off, emulating
   * the effect found with `position: sticky;`.
   */


  var Affix = function (_React$Component) {
    _inherits(Affix, _React$Component);

    function Affix(props, context) {
      _classCallCheck(this, Affix);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.onWindowScroll = function () {
        _this.onUpdate();
      };

      _this.onDocumentClick = function () {
        (0, _requestAnimationFrame2.default)(function () {
          return _this.onUpdate();
        });
      };

      _this.onUpdate = function () {
        if (!_this._isMounted) {
          return;
        }

        var _this$props = _this.props,
            offsetTop = _this$props.offsetTop,
            viewportOffsetTop = _this$props.viewportOffsetTop;
        var scrollTop = (0, _scrollTop2.default)((0, _ownerWindow2.default)(_this));
        var positionTopMin = scrollTop + (viewportOffsetTop || 0);

        if (positionTopMin <= offsetTop) {
          _this.updateState('top', null, null);

          return;
        }

        if (positionTopMin > _this.getPositionTopMax()) {
          if (_this.state.affixed === 'bottom') {
            _this.updateStateAtBottom();
          } else {
            // Setting position away from `fixed` can change the offset parent of
            // the affix, so we can't calculate the correct position until after
            // we've updated its position.
            _this.setState({
              affixed: 'bottom',
              position: 'absolute',
              top: null
            }, function () {
              if (!_this._isMounted) {
                return;
              }

              _this.updateStateAtBottom();
            });
          }

          return;
        }

        _this.updateState('affix', 'fixed', viewportOffsetTop);
      };

      _this.getPositionTopMax = function () {
        var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));
        var height = (0, _height2.default)(_reactDom2.default.findDOMNode(_this));
        return documentHeight - height - _this.props.offsetBottom;
      };

      _this.updateState = function (affixed, position, top) {
        if (affixed === _this.state.affixed && position === _this.state.position && top === _this.state.top) {
          return;
        }

        var upperName = affixed === 'affix' ? '' : affixed.charAt(0).toUpperCase() + affixed.substr(1);

        if (_this.props['onAffix' + upperName]) {
          _this.props['onAffix' + upperName]();
        }

        _this.setState({
          affixed: affixed,
          position: position,
          top: top
        }, function () {
          if (_this.props['onAffixed' + upperName]) {
            _this.props['onAffixed' + upperName]();
          }
        });
      };

      _this.updateStateAtBottom = function () {
        var positionTopMax = _this.getPositionTopMax();

        var offsetParent = (0, _offsetParent2.default)(_reactDom2.default.findDOMNode(_this));
        var parentTop = (0, _offset2.default)(offsetParent).top;

        _this.updateState('bottom', 'absolute', positionTopMax - parentTop);
      };

      _this.state = {
        affixed: 'top',
        position: null,
        top: null
      };
      _this._needPositionUpdate = false;
      return _this;
    }

    Affix.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
        return _this2.onWindowScroll();
      });
      this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
        return _this2.onDocumentClick();
      });
      this.onUpdate();
    };

    Affix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
      this._needPositionUpdate = true;
    };

    Affix.prototype.componentDidUpdate = function componentDidUpdate() {
      if (this._needPositionUpdate) {
        this._needPositionUpdate = false;
        this.onUpdate();
      }
    };

    Affix.prototype.componentWillUnmount = function componentWillUnmount() {
      this._isMounted = false;

      if (this._windowScrollListener) {
        this._windowScrollListener.remove();
      }

      if (this._documentClickListener) {
        this._documentClickListener.remove();
      }
    };

    Affix.prototype.render = function render() {
      var child = _react2.default.Children.only(this.props.children);

      var _child$props = child.props,
          className = _child$props.className,
          style = _child$props.style;
      var _state = this.state,
          affixed = _state.affixed,
          position = _state.position,
          top = _state.top;
      var positionStyle = {
        position: position,
        top: top
      };
      var affixClassName = void 0;
      var affixStyle = void 0;

      if (affixed === 'top') {
        affixClassName = this.props.topClassName;
        affixStyle = this.props.topStyle;
      } else if (affixed === 'bottom') {
        affixClassName = this.props.bottomClassName;
        affixStyle = this.props.bottomStyle;
      } else {
        affixClassName = this.props.affixClassName;
        affixStyle = this.props.affixStyle;
      }

      return _react2.default.cloneElement(child, {
        className: (0, _classnames2.default)(affixClassName, className),
        style: _extends({}, positionStyle, affixStyle, style)
      });
    };

    return Affix;
  }(_react2.default.Component);

  Affix.propTypes = {
    /**
     * Pixels to offset from top of screen when calculating position
     */
    offsetTop: _propTypes2.default.number,

    /**
     * When affixed, pixels to offset from top of viewport
     */
    viewportOffsetTop: _propTypes2.default.number,

    /**
     * Pixels to offset from bottom of screen when calculating position
     */
    offsetBottom: _propTypes2.default.number,

    /**
     * CSS class or classes to apply when at top
     */
    topClassName: _propTypes2.default.string,

    /**
     * Style to apply when at top
     */
    topStyle: _propTypes2.default.object,

    /**
     * CSS class or classes to apply when affixed
     */
    affixClassName: _propTypes2.default.string,

    /**
     * Style to apply when affixed
     */
    affixStyle: _propTypes2.default.object,

    /**
     * CSS class or classes to apply when at bottom
     */
    bottomClassName: _propTypes2.default.string,

    /**
     * Style to apply when at bottom
     */
    bottomStyle: _propTypes2.default.object,

    /**
     * Callback fired when the right before the `affixStyle` and `affixStyle` props are rendered
     */
    onAffix: _propTypes2.default.func,

    /**
     * Callback fired after the component `affixStyle` and `affixClassName` props have been rendered.
     */
    onAffixed: _propTypes2.default.func,

    /**
     * Callback fired when the right before the `topStyle` and `topClassName` props are rendered
     */
    onAffixTop: _propTypes2.default.func,

    /**
     * Callback fired after the component `topStyle` and `topClassName` props have been rendered.
     */
    onAffixedTop: _propTypes2.default.func,

    /**
     * Callback fired when the right before the `bottomStyle` and `bottomClassName` props are rendered
     */
    onAffixBottom: _propTypes2.default.func,

    /**
     * Callback fired after the component `bottomStyle` and `bottomClassName` props have been rendered.
     */
    onAffixedBottom: _propTypes2.default.func
  };
  Affix.defaultProps = {
    offsetTop: 0,
    viewportOffsetTop: null,
    offsetBottom: 0
  };
  exports.default = Affix;
  module.exports = exports['default'];
});
unwrapExports(Affix_1);
var createChainableTypeChecker_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = createChainableTypeChecker;
  /**
   * Copyright 2013-present, Facebook, Inc.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   */
  // Mostly taken from ReactPropTypes.

  function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      if (props[propName] == null) {
        if (isRequired) {
          return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
        }

        return null;
      }

      for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
        args[_key - 6] = arguments[_key];
      }

      return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  module.exports = exports['default'];
});
unwrapExports(createChainableTypeChecker_1);
var componentOrElement = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _react2 = _interopRequireDefault(React__default);

  var _createChainableTypeChecker2 = _interopRequireDefault(createChainableTypeChecker_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

    if (_react2.default.isValidElement(propValue)) {
      return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
    }

    if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
      return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
    }

    return null;
  }

  exports.default = (0, _createChainableTypeChecker2.default)(validate);
  module.exports = exports['default'];
});
unwrapExports(componentOrElement);
var getContainer_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = getContainer;

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function getContainer(container, defaultContainer) {
    container = typeof container === 'function' ? container() : container;
    return _reactDom2.default.findDOMNode(container) || defaultContainer;
  }

  module.exports = exports['default'];
});
unwrapExports(getContainer_1);
var AutoAffix_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _offset2 = _interopRequireDefault(offset_1);

  var _requestAnimationFrame2 = _interopRequireDefault(requestAnimationFrame$1);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _componentOrElement2 = _interopRequireDefault(componentOrElement);

  var _react2 = _interopRequireDefault(React__default);

  var _Affix2 = _interopRequireDefault(Affix_1);

  var _addEventListener2 = _interopRequireDefault(addEventListener$4);

  var _getContainer2 = _interopRequireDefault(getContainer_1);

  var _getDocumentHeight2 = _interopRequireDefault(getDocumentHeight);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument$1);

  var _ownerWindow2 = _interopRequireDefault(ownerWindow$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var displayName = 'AutoAffix';

  var propTypes = _extends({}, _Affix2.default.propTypes, {
    /**
     * The logical container node or component for determining offset from bottom
     * of viewport, or a function that returns it
     */
    container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

    /**
     * Automatically set width when affixed
     */
    autoWidth: _propTypes2.default.bool
  }); // This intentionally doesn't inherit default props from `<Affix>`, so that the
  // auto-calculated offsets can apply.


  var defaultProps = {
    viewportOffsetTop: 0,
    autoWidth: true
  };
  /**
   * The `<AutoAffix/>` component wraps `<Affix/>` to automatically calculate
   * offsets in many common cases.
   */

  var AutoAffix = function (_React$Component) {
    _inherits(AutoAffix, _React$Component);

    function AutoAffix(props, context) {
      _classCallCheck(this, AutoAffix);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.onWindowScroll = function () {
        _this.onUpdate();
      };

      _this.onWindowResize = function () {
        if (_this.props.autoWidth) {
          (0, _requestAnimationFrame2.default)(function () {
            return _this.onUpdate();
          });
        }
      };

      _this.onDocumentClick = function () {
        (0, _requestAnimationFrame2.default)(function () {
          return _this.onUpdate();
        });
      };

      _this.onUpdate = function () {
        if (!_this._isMounted) {
          return;
        }

        var _getOffset = (0, _offset2.default)(_this.positioner),
            offsetTop = _getOffset.top,
            width = _getOffset.width;

        var container = (0, _getContainer2.default)(_this.props.container);
        var offsetBottom = void 0;

        if (container) {
          var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));

          var _getOffset2 = (0, _offset2.default)(container),
              top = _getOffset2.top,
              height = _getOffset2.height;

          offsetBottom = documentHeight - top - height;
        } else {
          offsetBottom = null;
        }

        _this.updateState(offsetTop, offsetBottom, width);
      };

      _this.updateState = function (offsetTop, offsetBottom, width) {
        if (offsetTop === _this.state.offsetTop && offsetBottom === _this.state.offsetBottom && width === _this.state.width) {
          return;
        }

        _this.setState({
          offsetTop: offsetTop,
          offsetBottom: offsetBottom,
          width: width
        });
      };

      _this.state = {
        offsetTop: null,
        offsetBottom: null,
        width: null
      };
      return _this;
    }

    AutoAffix.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
        return _this2.onWindowScroll();
      });
      this._windowResizeListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'resize', function () {
        return _this2.onWindowResize();
      });
      this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
        return _this2.onDocumentClick();
      });
      this.onUpdate();
    };

    AutoAffix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
      this._needPositionUpdate = true;
    };

    AutoAffix.prototype.componentDidUpdate = function componentDidUpdate() {
      if (this._needPositionUpdate) {
        this._needPositionUpdate = false;
        this.onUpdate();
      }
    };

    AutoAffix.prototype.componentWillUnmount = function componentWillUnmount() {
      this._isMounted = false;

      if (this._windowScrollListener) {
        this._windowScrollListener.remove();
      }

      if (this._documentClickListener) {
        this._documentClickListener.remove();
      }

      if (this._windowResizeListener) {
        this._windowResizeListener.remove();
      }
    };

    AutoAffix.prototype.render = function render() {
      var _this3 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          viewportOffsetTop = _props.viewportOffsetTop,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['autoWidth', 'viewportOffsetTop', 'children']);

      var _state = this.state,
          offsetTop = _state.offsetTop,
          offsetBottom = _state.offsetBottom,
          width = _state.width;
      delete props.container;
      var effectiveOffsetTop = Math.max(offsetTop, viewportOffsetTop || 0);
      var _props2 = this.props,
          affixStyle = _props2.affixStyle,
          bottomStyle = _props2.bottomStyle;

      if (autoWidth) {
        affixStyle = _extends({
          width: width
        }, affixStyle);
        bottomStyle = _extends({
          width: width
        }, bottomStyle);
      }

      return _react2.default.createElement('div', null, _react2.default.createElement('div', {
        ref: function ref(c) {
          _this3.positioner = c;
        }
      }), _react2.default.createElement(_Affix2.default, _extends({}, props, {
        offsetTop: effectiveOffsetTop,
        viewportOffsetTop: viewportOffsetTop,
        offsetBottom: offsetBottom,
        affixStyle: affixStyle,
        bottomStyle: bottomStyle
      }), children));
    };

    return AutoAffix;
  }(_react2.default.Component);

  AutoAffix.displayName = displayName;
  AutoAffix.propTypes = propTypes;
  AutoAffix.defaultProps = defaultProps;
  exports.default = AutoAffix;
  module.exports = exports['default'];
});
unwrapExports(AutoAffix_1);
var activeElement_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = activeElement;

  var _ownerDocument = interopRequireDefault(ownerDocument_1);

  function activeElement(doc) {
    if (doc === void 0) {
      doc = (0, _ownerDocument.default)();
    }

    try {
      return doc.activeElement;
    } catch (e) {
      /* ie throws if no active element */
    }
  }

  module.exports = exports["default"];
});
unwrapExports(activeElement_1);
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning$4 = function warning$4() {};

if (process.env.NODE_ENV !== 'production') {
  warning$4 = function warning$4(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

var browser$1 = warning$4;
var deprecated_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = deprecated;

  var _warning2 = _interopRequireDefault(browser$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var warned = {};

  function deprecated(validator, reason) {
    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      if (props[propName] != null) {
        var messageKey = componentName + '.' + propName;
        (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
        warned[messageKey] = true;
      }

      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        args[_key - 5] = arguments[_key];
      }

      return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
    };
  }
  /* eslint-disable no-underscore-dangle */


  function _resetWarned() {
    warned = {};
  }

  deprecated._resetWarned = _resetWarned;
  /* eslint-enable no-underscore-dangle */

  module.exports = exports['default'];
});
unwrapExports(deprecated_1);
var reactIs_production_min$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.memo") : 60115,
      r = b ? Symbol.for("react.lazy") : 60116;

  function t(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case r:
        case q:
        case d:
          return u;
      }
    }
  }

  function v(a) {
    return t(a) === m;
  }

  exports.typeOf = t;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = r;
  exports.Memo = q;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
  };

  exports.isAsyncMode = function (a) {
    return v(a) || t(a) === l;
  };

  exports.isConcurrentMode = v;

  exports.isContextConsumer = function (a) {
    return t(a) === k;
  };

  exports.isContextProvider = function (a) {
    return t(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return t(a) === n;
  };

  exports.isFragment = function (a) {
    return t(a) === e;
  };

  exports.isLazy = function (a) {
    return t(a) === r;
  };

  exports.isMemo = function (a) {
    return t(a) === q;
  };

  exports.isPortal = function (a) {
    return t(a) === d;
  };

  exports.isProfiler = function (a) {
    return t(a) === g;
  };

  exports.isStrictMode = function (a) {
    return t(a) === f;
  };

  exports.isSuspense = function (a) {
    return t(a) === p;
  };
});
unwrapExports(reactIs_production_min$2);
var reactIs_production_min_1 = reactIs_production_min$2.typeOf;
var reactIs_production_min_2 = reactIs_production_min$2.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min$2.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min$2.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min$2.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min$2.Element;
var reactIs_production_min_7 = reactIs_production_min$2.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min$2.Fragment;
var reactIs_production_min_9 = reactIs_production_min$2.Lazy;
var reactIs_production_min_10 = reactIs_production_min$2.Memo;
var reactIs_production_min_11 = reactIs_production_min$2.Portal;
var reactIs_production_min_12 = reactIs_production_min$2.Profiler;
var reactIs_production_min_13 = reactIs_production_min$2.StrictMode;
var reactIs_production_min_14 = reactIs_production_min$2.Suspense;
var reactIs_production_min_15 = reactIs_production_min$2.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min$2.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min$2.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min$2.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min$2.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min$2.isElement;
var reactIs_production_min_21 = reactIs_production_min$2.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min$2.isFragment;
var reactIs_production_min_23 = reactIs_production_min$2.isLazy;
var reactIs_production_min_24 = reactIs_production_min$2.isMemo;
var reactIs_production_min_25 = reactIs_production_min$2.isPortal;
var reactIs_production_min_26 = reactIs_production_min$2.isProfiler;
var reactIs_production_min_27 = reactIs_production_min$2.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min$2.isSuspense;
var reactIs_development$2 = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      Object.defineProperty(exports, '__esModule', {
        value: true
      }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
      }
      /**
       * Forked from fbjs/warning:
       * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
       *
       * Only change is we use console.warn instead of console.error,
       * and do nothing when 'console' is not supported.
       * This really simplifies the code.
       * ---
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var lowPriorityWarning = function lowPriorityWarning() {};

      {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.warn(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        lowPriorityWarning = function lowPriorityWarning(condition, format) {
          if (format === undefined) {
            throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(undefined, [format].concat(args));
          }
        };
      }
      var lowPriorityWarning$1 = lowPriorityWarning;

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_LAZY_TYPE:
            case REACT_MEMO_TYPE:
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.typeOf = typeOf;
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isValidElementType = isValidElementType;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
    })();
  }
});
unwrapExports(reactIs_development$2);
var reactIs_development_1$2 = reactIs_development$2.typeOf;
var reactIs_development_2$2 = reactIs_development$2.AsyncMode;
var reactIs_development_3$2 = reactIs_development$2.ConcurrentMode;
var reactIs_development_4$2 = reactIs_development$2.ContextConsumer;
var reactIs_development_5$2 = reactIs_development$2.ContextProvider;
var reactIs_development_6$2 = reactIs_development$2.Element;
var reactIs_development_7$2 = reactIs_development$2.ForwardRef;
var reactIs_development_8$2 = reactIs_development$2.Fragment;
var reactIs_development_9$2 = reactIs_development$2.Lazy;
var reactIs_development_10$2 = reactIs_development$2.Memo;
var reactIs_development_11$2 = reactIs_development$2.Portal;
var reactIs_development_12$2 = reactIs_development$2.Profiler;
var reactIs_development_13$2 = reactIs_development$2.StrictMode;
var reactIs_development_14$2 = reactIs_development$2.Suspense;
var reactIs_development_15$2 = reactIs_development$2.isValidElementType;
var reactIs_development_16$2 = reactIs_development$2.isAsyncMode;
var reactIs_development_17$2 = reactIs_development$2.isConcurrentMode;
var reactIs_development_18$2 = reactIs_development$2.isContextConsumer;
var reactIs_development_19$2 = reactIs_development$2.isContextProvider;
var reactIs_development_20$2 = reactIs_development$2.isElement;
var reactIs_development_21$2 = reactIs_development$2.isForwardRef;
var reactIs_development_22$2 = reactIs_development$2.isFragment;
var reactIs_development_23$2 = reactIs_development$2.isLazy;
var reactIs_development_24$2 = reactIs_development$2.isMemo;
var reactIs_development_25$2 = reactIs_development$2.isPortal;
var reactIs_development_26$2 = reactIs_development$2.isProfiler;
var reactIs_development_27$2 = reactIs_development$2.isStrictMode;
var reactIs_development_28$2 = reactIs_development$2.isSuspense;
var reactIs$2 = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$2;
  } else {
    module.exports = reactIs_development$2;
  }
});
var elementType_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(React__default);

  var _createChainableTypeChecker2 = _interopRequireDefault(createChainableTypeChecker_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function elementType(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];

    if (_react2.default.isValidElement(propValue)) {
      return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
    }

    if (!(0, reactIs$2.isValidElementType)(propValue)) {
      return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
    }

    return null;
  }

  exports.default = (0, _createChainableTypeChecker2.default)(elementType);
  module.exports = exports['default'];
});
var elementType = unwrapExports(elementType_1);
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning$5 = function warning$5() {};

if (process.env.NODE_ENV !== 'production') {
  warning$5 = function warning$5(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

var browser$2 = warning$5;
var hasClass_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = hasClass;

  function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
  }

  module.exports = exports["default"];
});
unwrapExports(hasClass_1);
var addClass_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = addClass;

  var _hasClass = interopRequireDefault(hasClass_1);

  function addClass(element, className) {
    if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
  }

  module.exports = exports["default"];
});
unwrapExports(addClass_1);

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

var _class = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var _addClass = interopRequireDefault(addClass_1);

  exports.addClass = _addClass.default;

  var _removeClass = interopRequireDefault(removeClass);

  exports.removeClass = _removeClass.default;

  var _hasClass = interopRequireDefault(hasClass_1);

  exports.hasClass = _hasClass.default;
  var _default = {
    addClass: _addClass.default,
    removeClass: _removeClass.default,
    hasClass: _hasClass.default
  };
  exports.default = _default;
});

unwrapExports(_class);
var _class_1 = _class.addClass;
var _class_2 = _class.removeClass;
var _class_3 = _class.hasClass;
var scrollbarSize_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = scrollbarSize;

  var _inDOM = interopRequireDefault(inDOM);

  var size;

  function scrollbarSize(recalc) {
    if (!size && size !== 0 || recalc) {
      if (_inDOM.default) {
        var scrollDiv = document.createElement('div');
        scrollDiv.style.position = 'absolute';
        scrollDiv.style.top = '-9999px';
        scrollDiv.style.width = '50px';
        scrollDiv.style.height = '50px';
        scrollDiv.style.overflow = 'scroll';
        document.body.appendChild(scrollDiv);
        size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
      }
    }

    return size;
  }

  module.exports = exports["default"];
});
unwrapExports(scrollbarSize_1);
var isOverflowing_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = isOverflowing;

  var _isWindow2 = _interopRequireDefault(isWindow);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function isBody(node) {
    return node && node.tagName.toLowerCase() === 'body';
  }

  function bodyIsOverflowing(node) {
    var doc = (0, _ownerDocument2.default)(node);
    var win = (0, _isWindow2.default)(doc);
    var fullWidth = win.innerWidth; // Support: ie8, no innerWidth

    if (!fullWidth) {
      var documentElementRect = doc.documentElement.getBoundingClientRect();
      fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
    }

    return doc.body.clientWidth < fullWidth;
  }

  function isOverflowing(container) {
    var win = (0, _isWindow2.default)(container);
    return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
  }

  module.exports = exports['default'];
});
unwrapExports(isOverflowing_1);
var manageAriaHidden = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.ariaHidden = ariaHidden;
  exports.hideSiblings = hideSiblings;
  exports.showSiblings = showSiblings;
  var BLACKLIST = ['template', 'script', 'style'];

  var isHidable = function isHidable(_ref) {
    var nodeType = _ref.nodeType,
        tagName = _ref.tagName;
    return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
  };

  var siblings = function siblings(container, mount, cb) {
    mount = [].concat(mount);
    [].forEach.call(container.children, function (node) {
      if (mount.indexOf(node) === -1 && isHidable(node)) {
        cb(node);
      }
    });
  };

  function ariaHidden(show, node) {
    if (!node) {
      return;
    }

    if (show) {
      node.setAttribute('aria-hidden', 'true');
    } else {
      node.removeAttribute('aria-hidden');
    }
  }

  function hideSiblings(container, mountNode) {
    siblings(container, mountNode, function (node) {
      return ariaHidden(true, node);
    });
  }

  function showSiblings(container, mountNode) {
    siblings(container, mountNode, function (node) {
      return ariaHidden(false, node);
    });
  }
});
unwrapExports(manageAriaHidden);
var manageAriaHidden_1 = manageAriaHidden.ariaHidden;
var manageAriaHidden_2 = manageAriaHidden.hideSiblings;
var manageAriaHidden_3 = manageAriaHidden.showSiblings;
var ModalManager_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _class2 = _interopRequireDefault(_class);

  var _style2 = _interopRequireDefault(style_1);

  var _scrollbarSize2 = _interopRequireDefault(scrollbarSize_1);

  var _isOverflowing2 = _interopRequireDefault(isOverflowing_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function findIndexOf(arr, cb) {
    var idx = -1;
    arr.some(function (d, i) {
      if (cb(d, i)) {
        idx = i;
        return true;
      }
    });
    return idx;
  }

  function findContainer(data, modal) {
    return findIndexOf(data, function (d) {
      return d.modals.indexOf(modal) !== -1;
    });
  }

  function setContainerStyle(state, container) {
    var style = {
      overflow: 'hidden'
    }; // we are only interested in the actual `style` here
    // becasue we will override it

    state.style = {
      overflow: container.style.overflow,
      paddingRight: container.style.paddingRight
    };

    if (state.overflowing) {
      // use computed style, here to get the real padding
      // to add our scrollbar width
      style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
    }

    (0, _style2.default)(container, style);
  }

  function removeContainerStyle(_ref, container) {
    var style = _ref.style;
    Object.keys(style).forEach(function (key) {
      return container.style[key] = style[key];
    });
  }
  /**
   * Proper state managment for containers and the modals in those containers.
   *
   * @internal Used by the Modal to ensure proper styling of containers.
   */


  var ModalManager = function ModalManager() {
    var _this = this;

    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
        _ref2$handleContainer = _ref2.handleContainerOverflow,
        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

    _classCallCheck(this, ModalManager);

    this.add = function (modal, container, className) {
      var modalIdx = _this.modals.indexOf(modal);

      var containerIdx = _this.containers.indexOf(container);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = _this.modals.length;

      _this.modals.push(modal);

      if (_this.hideSiblingNodes) {
        (0, manageAriaHidden.hideSiblings)(container, modal.mountNode);
      }

      if (containerIdx !== -1) {
        _this.data[containerIdx].modals.push(modal);

        return modalIdx;
      }

      var data = {
        modals: [modal],
        //right now only the first modal of a container will have its classes applied
        classes: className ? className.split(/\s+/) : [],
        overflowing: (0, _isOverflowing2.default)(container)
      };

      if (_this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      data.classes.forEach(_class2.default.addClass.bind(null, container));

      _this.containers.push(container);

      _this.data.push(data);

      return modalIdx;
    };

    this.remove = function (modal) {
      var modalIdx = _this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return;
      }

      var containerIdx = findContainer(_this.data, modal);
      var data = _this.data[containerIdx];
      var container = _this.containers[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);

      _this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
      // clean up the container


      if (data.modals.length === 0) {
        data.classes.forEach(_class2.default.removeClass.bind(null, container));

        if (_this.handleContainerOverflow) {
          removeContainerStyle(data, container);
        }

        if (_this.hideSiblingNodes) {
          (0, manageAriaHidden.showSiblings)(container, modal.mountNode);
        }

        _this.containers.splice(containerIdx, 1);

        _this.data.splice(containerIdx, 1);
      } else if (_this.hideSiblingNodes) {
        //otherwise make sure the next top modal is visible to a SR
        (0, manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
      }
    };

    this.isTopModal = function (modal) {
      return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
    };

    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow;
    this.modals = [];
    this.containers = [];
    this.data = [];
  };

  exports.default = ModalManager;
  module.exports = exports['default'];
});
unwrapExports(ModalManager_1);
var LegacyPortal = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _componentOrElement2 = _interopRequireDefault(componentOrElement);

  var _react2 = _interopRequireDefault(React__default);

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  var _getContainer2 = _interopRequireDefault(getContainer_1);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
   * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
   * The children of `<Portal/>` component will be appended to the `container` specified.
   */


  var Portal = function (_React$Component) {
    _inherits(Portal, _React$Component);

    function Portal() {
      var _temp, _this, _ret;

      _classCallCheck(this, Portal);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
        if (!_this._overlayTarget) {
          _this._overlayTarget = document.createElement('div');
          _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);

          _this._portalContainerNode.appendChild(_this._overlayTarget);
        }
      }, _this._unmountOverlayTarget = function () {
        if (_this._overlayTarget) {
          _this._portalContainerNode.removeChild(_this._overlayTarget);

          _this._overlayTarget = null;
        }

        _this._portalContainerNode = null;
      }, _this._renderOverlay = function () {
        var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children); // Save reference for future access.

        if (overlay !== null) {
          _this._mountOverlayTarget();

          var initialRender = !_this._overlayInstance;
          _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
            if (initialRender && _this.props.onRendered) {
              _this.props.onRendered();
            }
          });
        } else {
          // Unrender if the component is null for transitions to null
          _this._unrenderOverlay();

          _this._unmountOverlayTarget();
        }
      }, _this._unrenderOverlay = function () {
        if (_this._overlayTarget) {
          _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);

          _this._overlayInstance = null;
        }
      }, _this.getMountNode = function () {
        return _this._overlayTarget;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Portal.prototype.componentDidMount = function componentDidMount() {
      this._isMounted = true;

      this._renderOverlay();
    };

    Portal.prototype.componentDidUpdate = function componentDidUpdate() {
      this._renderOverlay();
    };

    Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this._overlayTarget && nextProps.container !== this.props.container) {
        this._portalContainerNode.removeChild(this._overlayTarget);

        this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);

        this._portalContainerNode.appendChild(this._overlayTarget);
      }
    };

    Portal.prototype.componentWillUnmount = function componentWillUnmount() {
      this._isMounted = false;

      this._unrenderOverlay();

      this._unmountOverlayTarget();
    };

    Portal.prototype.render = function render() {
      return null;
    };

    return Portal;
  }(_react2.default.Component);

  Portal.displayName = 'Portal';
  Portal.propTypes = {
    /**
     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
     * appended to it.
     */
    container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
    onRendered: _propTypes2.default.func
  };
  exports.default = Portal;
  module.exports = exports['default'];
});
unwrapExports(LegacyPortal);
var Portal_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _componentOrElement2 = _interopRequireDefault(componentOrElement);

  var _react2 = _interopRequireDefault(React__default);

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  var _getContainer2 = _interopRequireDefault(getContainer_1);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument$1);

  var _LegacyPortal2 = _interopRequireDefault(LegacyPortal);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
   * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
   * The children of `<Portal/>` component will be appended to the `container` specified.
   */


  var Portal = function (_React$Component) {
    _inherits(Portal, _React$Component);

    function Portal() {
      var _temp, _this, _ret;

      _classCallCheck(this, Portal);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
      }, _this.getMountNode = function () {
        return _this._portalContainerNode;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Portal.prototype.componentDidMount = function componentDidMount() {
      this.setContainer();
      this.forceUpdate(this.props.onRendered);
    };

    Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (nextProps.container !== this.props.container) {
        this.setContainer(nextProps);
      }
    };

    Portal.prototype.componentWillUnmount = function componentWillUnmount() {
      this._portalContainerNode = null;
    };

    Portal.prototype.render = function render() {
      return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
    };

    return Portal;
  }(_react2.default.Component);

  Portal.displayName = 'Portal';
  Portal.propTypes = {
    /**
     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
     * appended to it.
     */
    container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
    onRendered: _propTypes2.default.func
  };
  exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
  module.exports = exports['default'];
});
unwrapExports(Portal_1);
var RefHolder_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _react2 = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var propTypes = {
    children: _propTypes2.default.node
  };
  /**
   * Internal helper component to allow attaching a non-conflicting ref to a
   * child element that may not accept refs.
   */

  var RefHolder = function (_React$Component) {
    _inherits(RefHolder, _React$Component);

    function RefHolder() {
      _classCallCheck(this, RefHolder);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    RefHolder.prototype.render = function render() {
      return this.props.children;
    };

    return RefHolder;
  }(_react2.default.Component);

  RefHolder.propTypes = propTypes;
  exports.default = RefHolder;
  module.exports = exports['default'];
});
unwrapExports(RefHolder_1);
var addFocusListener_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = addFocusListener;
  /**
   * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
   * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
   *
   * We only allow one Listener at a time to avoid stack overflows
   */

  function addFocusListener(handler) {
    var useFocusin = !document.addEventListener;
    var remove = void 0;

    if (useFocusin) {
      document.attachEvent('onfocusin', handler);

      remove = function remove() {
        return document.detachEvent('onfocusin', handler);
      };
    } else {
      document.addEventListener('focus', handler, true);

      remove = function remove() {
        return document.removeEventListener('focus', handler, true);
      };
    }

    return {
      remove: remove
    };
  }

  module.exports = exports['default'];
});
unwrapExports(addFocusListener_1);
var Modal_1$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _activeElement2 = _interopRequireDefault(activeElement_1);

  var _contains2 = _interopRequireDefault(contains$1);

  var _inDOM2 = _interopRequireDefault(inDOM);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _componentOrElement2 = _interopRequireDefault(componentOrElement);

  var _deprecated2 = _interopRequireDefault(deprecated_1);

  var _elementType2 = _interopRequireDefault(elementType_1);

  var _react2 = _interopRequireDefault(React__default);

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  var _warning2 = _interopRequireDefault(browser$2);

  var _ModalManager2 = _interopRequireDefault(ModalManager_1);

  var _Portal2 = _interopRequireDefault(Portal_1);

  var _RefHolder2 = _interopRequireDefault(RefHolder_1);

  var _addEventListener2 = _interopRequireDefault(addEventListener$4);

  var _addFocusListener2 = _interopRequireDefault(addFocusListener_1);

  var _getContainer2 = _interopRequireDefault(getContainer_1);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /* eslint-disable react/prop-types */


  var modalManager = new _ModalManager2.default();
  /**
   * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
   * The Modal component renders its `children` node in front of a backdrop component.
   *
   * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
   *
   * - Manages dialog stacking when one-at-a-time just isn't enough.
   * - Creates a backdrop, for disabling interaction below the modal.
   * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
   * - It disables scrolling of the page content while open.
   * - Adds the appropriate ARIA roles are automatically.
   * - Easily pluggable animations via a `<Transition/>` component.
   *
   * Note that, in the same way the backdrop element prevents users from clicking or interacting
   * with the page content underneath the Modal, Screen readers also need to be signaled to not to
   * interact with page content while the Modal is open. To do this, we use a common technique of applying
   * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
   * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
   * React hierarchy (such as the default: document.body).
   */

  var Modal = function (_React$Component) {
    _inherits(Modal, _React$Component);

    function Modal() {
      var _temp, _this, _ret;

      _classCallCheck(this, Modal);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Modal.prototype.omitProps = function omitProps(props, propTypes) {
      var keys = Object.keys(props);
      var newProps = {};
      keys.map(function (prop) {
        if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
          newProps[prop] = props[prop];
        }
      });
      return newProps;
    };

    Modal.prototype.render = function render() {
      var _props = this.props,
          show = _props.show,
          container = _props.container,
          children = _props.children,
          Transition = _props.transition,
          backdrop = _props.backdrop,
          className = _props.className,
          style = _props.style,
          onExit = _props.onExit,
          onExiting = _props.onExiting,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onEntered = _props.onEntered;

      var dialog = _react2.default.Children.only(children);

      var filteredProps = this.omitProps(this.props, Modal.propTypes);
      var mountModal = show || Transition && !this.state.exited;

      if (!mountModal) {
        return null;
      }

      var _dialog$props = dialog.props,
          role = _dialog$props.role,
          tabIndex = _dialog$props.tabIndex;

      if (role === undefined || tabIndex === undefined) {
        dialog = (0, React__default.cloneElement)(dialog, {
          role: role === undefined ? 'document' : role,
          tabIndex: tabIndex == null ? '-1' : tabIndex
        });
      }

      if (Transition) {
        dialog = _react2.default.createElement(Transition, {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        }, dialog);
      }

      return _react2.default.createElement(_Portal2.default, {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      }, _react2.default.createElement('div', _extends({
        ref: this.setModalNodeRef,
        role: role || 'dialog'
      }, filteredProps, {
        style: style,
        className: className
      }), backdrop && this.renderBackdrop(), _react2.default.createElement(_RefHolder2.default, {
        ref: this.setDialogRef
      }, dialog)));
    };

    Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.setState({
          exited: false
        });
      } else if (!nextProps.transition) {
        // Otherwise let handleHidden take care of marking exited.
        this.setState({
          exited: true
        });
      }
    };

    Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
      if (!this.props.show && nextProps.show) {
        this.checkForFocus();
      }
    };

    Modal.prototype.componentDidMount = function componentDidMount() {
      this._isMounted = true;

      if (this.props.show) {
        this.onShow();
      }
    };

    Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
      var transition = this.props.transition;

      if (prevProps.show && !this.props.show && !transition) {
        // Otherwise handleHidden will call this.
        this.onHide();
      } else if (!prevProps.show && this.props.show) {
        this.onShow();
      }
    };

    Modal.prototype.componentWillUnmount = function componentWillUnmount() {
      var _props2 = this.props,
          show = _props2.show,
          transition = _props2.transition;
      this._isMounted = false;

      if (show || transition && !this.state.exited) {
        this.onHide();
      }
    };

    Modal.prototype.autoFocus = function autoFocus() {
      if (!this.props.autoFocus) {
        return;
      }

      var dialogElement = this.getDialogElement();
      var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!dialogElement.hasAttribute('tabIndex')) {
          (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
          dialogElement.setAttribute('tabIndex', -1);
        }

        dialogElement.focus();
      }
    };

    Modal.prototype.restoreLastFocus = function restoreLastFocus() {
      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
      if (this.lastFocus && this.lastFocus.focus) {
        this.lastFocus.focus();
        this.lastFocus = null;
      }
    };

    Modal.prototype.getDialogElement = function getDialogElement() {
      return _reactDom2.default.findDOMNode(this.dialog);
    };

    Modal.prototype.isTopModal = function isTopModal() {
      return this.props.manager.isTopModal(this);
    };

    return Modal;
  }(_react2.default.Component);

  Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
    /**
     * Set the visibility of the Modal
     */
    show: _propTypes2.default.bool,

    /**
     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
     *
     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
     * page content can be placed behind a virtual backdrop as well as a visual one.
     */
    container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

    /**
     * A callback fired when the Modal is opening.
     */
    onShow: _propTypes2.default.func,

    /**
     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
     *
     * The `onHide` callback only signals intent from the Modal,
     * you must actually set the `show` prop to `false` for the Modal to close.
     */
    onHide: _propTypes2.default.func,

    /**
     * Include a backdrop component.
     */
    backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

    /**
     * A function that returns a backdrop component. Useful for custom
     * backdrop rendering.
     *
     * ```js
     *  renderBackdrop={props => <MyBackdrop {...props} />}
     * ```
     */
    renderBackdrop: _propTypes2.default.func,

    /**
     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
     */
    onEscapeKeyDown: _propTypes2.default.func,

    /**
     * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
     * @deprecated
     */
    onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

    /**
     * A callback fired when the backdrop, if specified, is clicked.
     */
    onBackdropClick: _propTypes2.default.func,

    /**
     * A style object for the backdrop component.
     */
    backdropStyle: _propTypes2.default.object,

    /**
     * A css class or classes for the backdrop component.
     */
    backdropClassName: _propTypes2.default.string,

    /**
     * A css class or set of classes applied to the modal container when the modal is open,
     * and removed when it is closed.
     */
    containerClassName: _propTypes2.default.string,

    /**
     * Close the modal when escape key is pressed
     */
    keyboard: _propTypes2.default.bool,

    /**
     * A `react-transition-group@2.0.0` `<Transition/>` component used
     * to control animations for the dialog component.
     */
    transition: _elementType2.default,

    /**
     * A `react-transition-group@2.0.0` `<Transition/>` component used
     * to control animations for the backdrop components.
     */
    backdropTransition: _elementType2.default,

    /**
     * When `true` The modal will automatically shift focus to itself when it opens, and
     * replace it to the last focused element when it closes. This also
     * works correctly with any Modal children that have the `autoFocus` prop.
     *
     * Generally this should never be set to `false` as it makes the Modal less
     * accessible to assistive technologies, like screen readers.
     */
    autoFocus: _propTypes2.default.bool,

    /**
     * When `true` The modal will prevent focus from leaving the Modal while open.
     *
     * Generally this should never be set to `false` as it makes the Modal less
     * accessible to assistive technologies, like screen readers.
     */
    enforceFocus: _propTypes2.default.bool,

    /**
     * When `true` The modal will restore focus to previously focused element once
     * modal is hidden
     */
    restoreFocus: _propTypes2.default.bool,

    /**
     * Callback fired before the Modal transitions in
     */
    onEnter: _propTypes2.default.func,

    /**
     * Callback fired as the Modal begins to transition in
     */
    onEntering: _propTypes2.default.func,

    /**
     * Callback fired after the Modal finishes transitioning in
     */
    onEntered: _propTypes2.default.func,

    /**
     * Callback fired right before the Modal transitions out
     */
    onExit: _propTypes2.default.func,

    /**
     * Callback fired as the Modal begins to transition out
     */
    onExiting: _propTypes2.default.func,

    /**
     * Callback fired after the Modal finishes transitioning out
     */
    onExited: _propTypes2.default.func,

    /**
     * A ModalManager instance used to track and manage the state of open
     * Modals. Useful when customizing how modals interact within a container
     */
    manager: _propTypes2.default.object.isRequired
  });
  Modal.defaultProps = {
    show: false,
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    enforceFocus: true,
    restoreFocus: true,
    onHide: function onHide() {},
    manager: modalManager,
    renderBackdrop: function renderBackdrop(props) {
      return _react2.default.createElement('div', props);
    }
  };

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.state = {
      exited: !this.props.show
    };

    this.renderBackdrop = function () {
      var _props3 = _this2.props,
          backdropStyle = _props3.backdropStyle,
          backdropClassName = _props3.backdropClassName,
          renderBackdrop = _props3.renderBackdrop,
          Transition = _props3.backdropTransition;

      var backdropRef = function backdropRef(ref) {
        return _this2.backdrop = ref;
      };

      var backdrop = renderBackdrop({
        ref: backdropRef,
        style: backdropStyle,
        className: backdropClassName,
        onClick: _this2.handleBackdropClick
      });

      if (Transition) {
        backdrop = _react2.default.createElement(Transition, {
          appear: true,
          'in': _this2.props.show
        }, backdrop);
      }

      return backdrop;
    };

    this.onPortalRendered = function () {
      _this2.autoFocus();

      if (_this2.props.onShow) {
        _this2.props.onShow();
      }
    };

    this.onShow = function () {
      var doc = (0, _ownerDocument2.default)(_this2);
      var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

      _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

      _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
      _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
      _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
    };

    this.onHide = function () {
      _this2.props.manager.remove(_this2);

      _this2._onDocumentKeydownListener.remove();

      _this2._onDocumentKeyupListener.remove();

      _this2._onFocusinListener.remove();

      if (_this2.props.restoreFocus) {
        _this2.restoreLastFocus();
      }
    };

    this.setMountNode = function (ref) {
      _this2.mountNode = ref ? ref.getMountNode() : ref;
    };

    this.setModalNodeRef = function (ref) {
      _this2.modalNode = ref;
    };

    this.setDialogRef = function (ref) {
      _this2.dialog = ref;
    };

    this.handleHidden = function () {
      _this2.setState({
        exited: true
      });

      _this2.onHide();

      if (_this2.props.onExited) {
        var _props4;

        (_props4 = _this2.props).onExited.apply(_props4, arguments);
      }
    };

    this.handleBackdropClick = function (e) {
      if (e.target !== e.currentTarget) {
        return;
      }

      if (_this2.props.onBackdropClick) {
        _this2.props.onBackdropClick(e);
      }

      if (_this2.props.backdrop === true) {
        _this2.props.onHide();
      }
    };

    this.handleDocumentKeyDown = function (e) {
      if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
        if (_this2.props.onEscapeKeyDown) {
          _this2.props.onEscapeKeyDown(e);
        }

        _this2.props.onHide();
      }
    };

    this.handleDocumentKeyUp = function (e) {
      if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
        if (_this2.props.onEscapeKeyUp) {
          _this2.props.onEscapeKeyUp(e);
        }
      }
    };

    this.checkForFocus = function () {
      if (_inDOM2.default) {
        _this2.lastFocus = (0, _activeElement2.default)();
      }
    };

    this.enforceFocus = function () {
      if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
        return;
      }

      var dialogElement = _this2.getDialogElement();

      var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
        dialogElement.focus();
      }
    };
  };

  Modal.Manager = _ModalManager2.default;
  exports.default = Modal;
  module.exports = exports['default'];
});
unwrapExports(Modal_1$1);

var _extends_1$1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

var scrollLeft = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = scrollTop;

  var _isWindow = interopRequireDefault(isWindow);

  function scrollTop(node, val) {
    var win = (0, _isWindow.default)(node);
    if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
    if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
  }

  module.exports = exports["default"];
});
unwrapExports(scrollLeft);
var position_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = position;

  var _extends2 = interopRequireDefault(_extends_1$1);

  var _offset = interopRequireDefault(offset_1);

  var _offsetParent = interopRequireDefault(offsetParent_1);

  var _scrollTop = interopRequireDefault(scrollTop_1);

  var _scrollLeft = interopRequireDefault(scrollLeft);

  var _style = interopRequireDefault(style_1);

  function nodeName(node) {
    return node.nodeName && node.nodeName.toLowerCase();
  }

  function position(node, offsetParent) {
    var parentOffset = {
      top: 0,
      left: 0
    },
        offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent

    if ((0, _style.default)(node, 'position') === 'fixed') {
      offset = node.getBoundingClientRect();
    } else {
      offsetParent = offsetParent || (0, _offsetParent.default)(node);
      offset = (0, _offset.default)(node);
      if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
      parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
      parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
    } // Subtract parent offsets and node margins


    return (0, _extends2.default)({}, offset, {
      top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
      left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
    });
  }

  module.exports = exports["default"];
});
unwrapExports(position_1);
var calculatePosition_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = calculatePosition;

  var _offset2 = _interopRequireDefault(offset_1);

  var _position2 = _interopRequireDefault(position_1);

  var _scrollTop2 = _interopRequireDefault(scrollTop_1);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function getContainerDimensions(containerNode) {
    var width = void 0,
        height = void 0,
        scroll = void 0;

    if (containerNode.tagName === 'BODY') {
      width = window.innerWidth;
      height = window.innerHeight;
      scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
    } else {
      var _getOffset = (0, _offset2.default)(containerNode);

      width = _getOffset.width;
      height = _getOffset.height;
      scroll = (0, _scrollTop2.default)(containerNode);
    }

    return {
      width: width,
      height: height,
      scroll: scroll
    };
  }

  function getTopDelta(top, overlayHeight, container, padding) {
    var containerDimensions = getContainerDimensions(container);
    var containerScroll = containerDimensions.scroll;
    var containerHeight = containerDimensions.height;
    var topEdgeOffset = top - padding - containerScroll;
    var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

    if (topEdgeOffset < 0) {
      return -topEdgeOffset;
    } else if (bottomEdgeOffset > containerHeight) {
      return containerHeight - bottomEdgeOffset;
    } else {
      return 0;
    }
  }

  function getLeftDelta(left, overlayWidth, container, padding) {
    var containerDimensions = getContainerDimensions(container);
    var containerWidth = containerDimensions.width;
    var leftEdgeOffset = left - padding;
    var rightEdgeOffset = left + padding + overlayWidth;

    if (leftEdgeOffset < 0) {
      return -leftEdgeOffset;
    } else if (rightEdgeOffset > containerWidth) {
      return containerWidth - rightEdgeOffset;
    }

    return 0;
  }

  function calculatePosition(placement, overlayNode, target, container, padding) {
    var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

    var _getOffset2 = (0, _offset2.default)(overlayNode),
        overlayHeight = _getOffset2.height,
        overlayWidth = _getOffset2.width;

    var positionLeft = void 0,
        positionTop = void 0,
        arrowOffsetLeft = void 0,
        arrowOffsetTop = void 0;

    if (placement === 'left' || placement === 'right') {
      positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

      if (placement === 'left') {
        positionLeft = childOffset.left - overlayWidth;
      } else {
        positionLeft = childOffset.left + childOffset.width;
      }

      var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
      positionTop += topDelta;
      arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
      arrowOffsetLeft = void 0;
    } else if (placement === 'top' || placement === 'bottom') {
      positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

      if (placement === 'top') {
        positionTop = childOffset.top - overlayHeight;
      } else {
        positionTop = childOffset.top + childOffset.height;
      }

      var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
      positionLeft += leftDelta;
      arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
      arrowOffsetTop = void 0;
    } else {
      throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
    }

    return {
      positionLeft: positionLeft,
      positionTop: positionTop,
      arrowOffsetLeft: arrowOffsetLeft,
      arrowOffsetTop: arrowOffsetTop
    };
  }

  module.exports = exports['default'];
});
unwrapExports(calculatePosition_1);
var Position_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _classnames2 = _interopRequireDefault(classnames);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _componentOrElement2 = _interopRequireDefault(componentOrElement);

  var _react2 = _interopRequireDefault(React__default);

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  var _calculatePosition2 = _interopRequireDefault(calculatePosition_1);

  var _getContainer2 = _interopRequireDefault(getContainer_1);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The Position component calculates the coordinates for its child, to position
   * it relative to a `target` component or node. Useful for creating callouts
   * and tooltips, the Position component injects a `style` props with `left` and
   * `top` values for positioning your component.
   *
   * It also injects "arrow" `left`, and `top` values for styling callout arrows
   * for giving your components a sense of directionality.
   */


  var Position = function (_React$Component) {
    _inherits(Position, _React$Component);

    function Position(props, context) {
      _classCallCheck(this, Position);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.getTarget = function () {
        var target = _this.props.target;
        var targetElement = typeof target === 'function' ? target() : target;
        return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
      };

      _this.maybeUpdatePosition = function (placementChanged) {
        var target = _this.getTarget();

        if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
          return;
        }

        _this.updatePosition(target);
      };

      _this.state = {
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      };
      _this._needsFlush = false;
      _this._lastTarget = null;
      return _this;
    }

    Position.prototype.componentDidMount = function componentDidMount() {
      this.updatePosition(this.getTarget());
    };

    Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
      this._needsFlush = true;
    };

    Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (this._needsFlush) {
        this._needsFlush = false;
        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
      }
    };

    Position.prototype.render = function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['children', 'className']);

      var _state = this.state,
          positionLeft = _state.positionLeft,
          positionTop = _state.positionTop,
          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']); // These should not be forwarded to the child.


      delete props.target;
      delete props.container;
      delete props.containerPadding;
      delete props.shouldUpdatePosition;

      var child = _react2.default.Children.only(children);

      return (0, React__default.cloneElement)(child, _extends({}, props, arrowPosition, {
        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
        // and `props.style`.
        positionLeft: positionLeft,
        positionTop: positionTop,
        className: (0, _classnames2.default)(className, child.props.className),
        style: _extends({}, child.props.style, {
          left: positionLeft,
          top: positionTop
        })
      }));
    };

    Position.prototype.updatePosition = function updatePosition(target) {
      this._lastTarget = target;

      if (!target) {
        this.setState({
          positionLeft: 0,
          positionTop: 0,
          arrowOffsetLeft: null,
          arrowOffsetTop: null
        });
        return;
      }

      var overlay = _reactDom2.default.findDOMNode(this);

      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
    };

    return Position;
  }(_react2.default.Component);

  Position.propTypes = {
    /**
     * A node, element, or function that returns either. The child will be
     * be positioned next to the `target` specified.
     */
    target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

    /**
     * "offsetParent" of the component
     */
    container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

    /**
     * Minimum spacing in pixels between container border and component border
     */
    containerPadding: _propTypes2.default.number,

    /**
     * How to position the component relative to the target
     */
    placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),

    /**
     * Whether the position should be changed on each update
     */
    shouldUpdatePosition: _propTypes2.default.bool
  };
  Position.displayName = 'Position';
  Position.defaultProps = {
    containerPadding: 0,
    placement: 'right',
    shouldUpdatePosition: false
  };
  exports.default = Position;
  module.exports = exports['default'];
});
unwrapExports(Position_1);
var RootCloseWrapper_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _contains2 = _interopRequireDefault(contains$1);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _react2 = _interopRequireDefault(React__default);

  var _reactDom2 = _interopRequireDefault(ReactDOM__default);

  var _addEventListener2 = _interopRequireDefault(addEventListener$4);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var escapeKeyCode = 27;

  function isLeftClickEvent(event) {
    return event.button === 0;
  }

  function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
  }
  /**
   * The `<RootCloseWrapper/>` component registers your callback on the document
   * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
   * style behavior where your callback is triggered when the user tries to
   * interact with the rest of the document or hits the `esc` key.
   */


  var RootCloseWrapper = function (_React$Component) {
    _inherits(RootCloseWrapper, _React$Component);

    function RootCloseWrapper(props, context) {
      _classCallCheck(this, RootCloseWrapper);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.addEventListeners = function () {
        var event = _this.props.event;
        var doc = (0, _ownerDocument2.default)(_this); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.

        _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
        _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
        _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
      };

      _this.removeEventListeners = function () {
        if (_this.documentMouseCaptureListener) {
          _this.documentMouseCaptureListener.remove();
        }

        if (_this.documentMouseListener) {
          _this.documentMouseListener.remove();
        }

        if (_this.documentKeyupListener) {
          _this.documentKeyupListener.remove();
        }
      };

      _this.handleMouseCapture = function (e) {
        _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
      };

      _this.handleMouse = function (e) {
        if (!_this.preventMouseRootClose && _this.props.onRootClose) {
          _this.props.onRootClose(e);
        }
      };

      _this.handleKeyUp = function (e) {
        if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
          _this.props.onRootClose(e);
        }
      };

      _this.preventMouseRootClose = false;
      return _this;
    }

    RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
      if (!this.props.disabled) {
        this.addEventListeners();
      }
    };

    RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (!this.props.disabled && prevProps.disabled) {
        this.addEventListeners();
      } else if (this.props.disabled && !prevProps.disabled) {
        this.removeEventListeners();
      }
    };

    RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
      if (!this.props.disabled) {
        this.removeEventListeners();
      }
    };

    RootCloseWrapper.prototype.render = function render() {
      return this.props.children;
    };

    return RootCloseWrapper;
  }(_react2.default.Component);

  RootCloseWrapper.displayName = 'RootCloseWrapper';
  RootCloseWrapper.propTypes = {
    /**
     * Callback fired after click or mousedown. Also triggers when user hits `esc`.
     */
    onRootClose: _propTypes2.default.func,

    /**
     * Children to render.
     */
    children: _propTypes2.default.element,

    /**
     * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
     */
    disabled: _propTypes2.default.bool,

    /**
     * Choose which document mouse event to bind to.
     */
    event: _propTypes2.default.oneOf(['click', 'mousedown'])
  };
  RootCloseWrapper.defaultProps = {
    event: 'click'
  };
  exports.default = RootCloseWrapper;
  module.exports = exports['default'];
});
unwrapExports(RootCloseWrapper_1);
var Overlay_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _elementType2 = _interopRequireDefault(elementType_1);

  var _react2 = _interopRequireDefault(React__default);

  var _Portal2 = _interopRequireDefault(Portal_1);

  var _Position2 = _interopRequireDefault(Position_1);

  var _RootCloseWrapper2 = _interopRequireDefault(RootCloseWrapper_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
   */


  var Overlay = function (_React$Component) {
    _inherits(Overlay, _React$Component);

    function Overlay(props, context) {
      _classCallCheck(this, Overlay);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.handleHidden = function () {
        _this.setState({
          exited: true
        });

        if (_this.props.onExited) {
          var _this$props;

          (_this$props = _this.props).onExited.apply(_this$props, arguments);
        }
      };

      _this.state = {
        exited: !props.show
      };
      _this.onHiddenListener = _this.handleHidden.bind(_this);
      return _this;
    }

    Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.setState({
          exited: false
        });
      } else if (!nextProps.transition) {
        // Otherwise let handleHidden take care of marking exited.
        this.setState({
          exited: true
        });
      }
    };

    Overlay.prototype.render = function render() {
      var _props = this.props,
          container = _props.container,
          containerPadding = _props.containerPadding,
          target = _props.target,
          placement = _props.placement,
          shouldUpdatePosition = _props.shouldUpdatePosition,
          rootClose = _props.rootClose,
          children = _props.children,
          Transition = _props.transition,
          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']); // Don't un-render the overlay while it's transitioning out.


      var mountOverlay = props.show || Transition && !this.state.exited;

      if (!mountOverlay) {
        // Don't bother showing anything if we don't have to.
        return null;
      }

      var child = children; // Position is be inner-most because it adds inline styles into the child,
      // which the other wrappers don't forward correctly.

      child = _react2.default.createElement(_Position2.default, {
        container: container,
        containerPadding: containerPadding,
        target: target,
        placement: placement,
        shouldUpdatePosition: shouldUpdatePosition
      }, child);

      if (Transition) {
        var onExit = props.onExit,
            onExiting = props.onExiting,
            onEnter = props.onEnter,
            onEntering = props.onEntering,
            onEntered = props.onEntered; // This animates the child node by injecting props, so it must precede
        // anything that adds a wrapping div.

        child = _react2.default.createElement(Transition, {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        }, child);
      } // This goes after everything else because it adds a wrapping div.


      if (rootClose) {
        child = _react2.default.createElement(_RootCloseWrapper2.default, {
          onRootClose: props.onHide
        }, child);
      }

      return _react2.default.createElement(_Portal2.default, {
        container: container
      }, child);
    };

    return Overlay;
  }(_react2.default.Component);

  Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
    /**
     * Set the visibility of the Overlay
     */
    show: _propTypes2.default.bool,

    /**
     * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
     */
    rootClose: _propTypes2.default.bool,

    /**
     * A Callback fired by the Overlay when it wishes to be hidden.
     *
     * __required__ when `rootClose` is `true`.
     *
     * @type func
     */
    onHide: function onHide(props) {
      var propType = _propTypes2.default.func;

      if (props.rootClose) {
        propType = propType.isRequired;
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return propType.apply(undefined, [props].concat(args));
    },

    /**
     * A `react-transition-group@2.0.0` `<Transition/>` component
     * used to animate the overlay as it changes visibility.
     */
    transition: _elementType2.default,

    /**
     * Callback fired before the Overlay transitions in
     */
    onEnter: _propTypes2.default.func,

    /**
     * Callback fired as the Overlay begins to transition in
     */
    onEntering: _propTypes2.default.func,

    /**
     * Callback fired after the Overlay finishes transitioning in
     */
    onEntered: _propTypes2.default.func,

    /**
     * Callback fired right before the Overlay transitions out
     */
    onExit: _propTypes2.default.func,

    /**
     * Callback fired as the Overlay begins to transition out
     */
    onExiting: _propTypes2.default.func,

    /**
     * Callback fired after the Overlay finishes transitioning out
     */
    onExited: _propTypes2.default.func
  });
  exports.default = Overlay;
  module.exports = exports['default'];
});
unwrapExports(Overlay_1);
var lib$3 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.RootCloseWrapper = exports.Position = exports.Portal = exports.Overlay = exports.Modal = exports.AutoAffix = exports.Affix = undefined;

  var _Affix3 = _interopRequireDefault(Affix_1);

  var _AutoAffix3 = _interopRequireDefault(AutoAffix_1);

  var _Modal3 = _interopRequireDefault(Modal_1$1);

  var _Overlay3 = _interopRequireDefault(Overlay_1);

  var _Portal3 = _interopRequireDefault(Portal_1);

  var _Position3 = _interopRequireDefault(Position_1);

  var _RootCloseWrapper3 = _interopRequireDefault(RootCloseWrapper_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.Affix = _Affix3.default;
  exports.AutoAffix = _AutoAffix3.default;
  exports.Modal = _Modal3.default;
  exports.Overlay = _Overlay3.default;
  exports.Portal = _Portal3.default;
  exports.Position = _Position3.default;
  exports.RootCloseWrapper = _RootCloseWrapper3.default;
});
unwrapExports(lib$3);
var lib_1$1 = lib$3.RootCloseWrapper;
var lib_2$1 = lib$3.Position;
var lib_3$1 = lib$3.Portal;
var lib_4$1 = lib$3.Overlay;
var lib_5$1 = lib$3.Modal;
var lib_6$1 = lib$3.AutoAffix;
var lib_7$1 = lib$3.Affix;

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var config = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes$1.oneOfType([propTypes$1.number, propTypes$1.shape({
  enter: propTypes$1.number,
  exit: propTypes$1.number,
  appear: propTypes$1.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
  enter: propTypes$1.string,
  exit: propTypes$1.string,
  active: propTypes$1.string
}), propTypes$1.shape({
  enter: propTypes$1.string,
  enterDone: propTypes$1.string,
  enterActive: propTypes$1.string,
  exit: propTypes$1.string,
  exitDone: propTypes$1.string,
  exitActive: propTypes$1.string
})]) : null;
var TransitionGroupContext = React__default.createContext(null);
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = ReactDOM__default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      // allows for nested Transitions
      return React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, children(status, childProps));
    }

    var child = React__default.Children.only(children);
    return (// allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, React__default.cloneElement(child, childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes$1.oneOfType([propTypes$1.func.isRequired, propTypes$1.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: propTypes$1.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes$1.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes$1.bool,

  /**
   * Normally a component is not transitioned if it is shown when the
   * `<Transition>` component mounts. If you want to transition on the first
   * mount set `appear` to `true`, and the component will transition in as soon
   * as the `<Transition>` mounts.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes$1.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes$1.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes$1.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes$1.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes$1.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes$1.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes$1.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes$1.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes$1.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes$1.func // Name the function so it is clearer in the documentation

} : {};

function noop$2() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$2,
  onEntering: noop$2,
  onEntered: noop$2,
  onExit: noop$2,
  onExiting: noop$2,
  onExited: noop$2
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _fadeStyles;

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(source, true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var propTypes$2 = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: propTypes.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: propTypes.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: propTypes.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: propTypes.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: propTypes.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: propTypes.func,

  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: propTypes.func,

  /**
   * Callback fired after the has component faded in
   */
  onEntered: propTypes.func,

  /**
   * Callback fired before the component fades out
   */
  onExit: propTypes.func,

  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: propTypes.func,

  /**
   * Callback fired after the component has faded out
   */
  onExited: propTypes.func
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, defineProperty(_fadeStyles, ENTERING, 'in'), defineProperty(_fadeStyles, ENTERED, 'in'), _fadeStyles);

var Fade =
/*#__PURE__*/
function (_React$Component) {
  inherits(Fade, _React$Component);

  function Fade() {
    classCallCheck(this, Fade);
    return possibleConstructorReturn(this, getPrototypeOf(Fade).apply(this, arguments));
  }

  createClass(Fade, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          props = objectWithoutProperties$1(_this$props, ["className", "children"]);
      return React__default.createElement(Transition, props, function (status, innerProps) {
        return React__default.cloneElement(children, _objectSpread$2({}, innerProps, {
          className: classnames('fade', className, children.props.className, fadeStyles[status])
        }));
      });
    }
  }]);
  return Fade;
}(React__default.Component);

Fade.propTypes = propTypes$2;
Fade.defaultProps = defaultProps;
var propTypes$3 = {
  /**
   * Set the visibility of the Overlay
   */
  show: propTypes.bool,

  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: propTypes.bool,

  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: propTypes.func,

  /**
   * Use animation
   */
  animation: propTypes.oneOfType([propTypes.bool, elementType]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: propTypes.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: propTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: propTypes.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: propTypes.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: propTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: propTypes.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: propTypes.oneOf(['top', 'right', 'bottom', 'left'])
};
var defaultProps$1 = {
  animation: Fade,
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay$1 =
/*#__PURE__*/
function (_React$Component) {
  inherits(Overlay$$1, _React$Component);

  function Overlay$$1() {
    classCallCheck(this, Overlay$$1);
    return possibleConstructorReturn(this, getPrototypeOf(Overlay$$1).apply(this, arguments));
  }

  createClass(Overlay$$1, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animation = _this$props.animation,
          children = _this$props.children,
          props = objectWithoutProperties$1(_this$props, ["animation", "children"]);
      var transition = animation === true ? Fade : animation || null;
      var child;

      if (!transition) {
        child = cloneElement(children, {
          className: classnames(children.props.className, 'in')
        });
      } else {
        child = children;
      }

      return React__default.createElement(lib_4$1, _extends_1({}, props, {
        transition: transition
      }), child);
    }
  }]);
  return Overlay$$1;
}(React__default.Component);

Overlay$1.propTypes = propTypes$3;
Overlay$1.defaultProps = defaultProps$1;
var connectedComponent = withTranslation$1()(Overlay$1);
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */

function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}
/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */


function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }

  return one === of;
}

var triggerType = propTypes.oneOf(['click', 'hover', 'focus']);
var propTypes$4 = {
  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: propTypes.oneOfType([triggerType, propTypes.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: propTypes.number,

  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: propTypes.number,

  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: propTypes.number,
  // FIXME: This should be `defaultShow`.

  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: propTypes.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: propTypes.node.isRequired,

  /**
   * A function to be called once the hide is triggered
   */
  handleHide: propTypes.func,

  /**
   * @private
   */
  onBlur: propTypes.func,

  /**
   * @private
   */
  onClick: propTypes.func,

  /**
   * @private
   */
  onFocus: propTypes.func,

  /**
   * @private
   */
  onMouseOut: propTypes.func,

  /**
   * @private
   */
  onMouseOver: propTypes.func,
  // Overridden props from `<Overlay>`.

  /**
   * @private
   */
  target: propTypes.oneOf([null]),

  /**
   * @private
   */
  onHide: propTypes.oneOf([null]),

  /**
   * @private
   */
  show: propTypes.oneOf([null])
};
var defaultProps$2 = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger =
/*#__PURE__*/
function (_React$Component) {
  inherits(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    var _this;

    classCallCheck(this, OverlayTrigger);
    _this = possibleConstructorReturn(this, getPrototypeOf(OverlayTrigger).call(this, props, context));
    _this.handleToggle = _this.handleToggle.bind(assertThisInitialized(_this));
    _this.handleDelayedShow = _this.handleDelayedShow.bind(assertThisInitialized(_this));
    _this.handleDelayedHide = _this.handleDelayedHide.bind(assertThisInitialized(_this));
    _this.handleHide = createChainedFunction(_this.handleHide.bind(assertThisInitialized(_this)), props.handleHide);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };

    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;
    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  createClass(OverlayTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mountNode = document.createElement('div');
      this.renderOverlay();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderOverlay();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      ReactDOM__default.unmountComponentAtNode(this._mountNode);
      this._mountNode = null;
      clearTimeout(this._hoverShowDelay);
      clearTimeout(this._hoverHideDelay);
    }
  }, {
    key: "handleDelayedHide",
    value: function handleDelayedHide() {
      var _this2 = this;

      if (this._hoverShowDelay != null) {
        clearTimeout(this._hoverShowDelay);
        this._hoverShowDelay = null;
        return;
      }

      if (!this.state.show || this._hoverHideDelay != null) {
        return;
      }

      var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

      if (!delay) {
        this.hide();
        return;
      }

      this._hoverHideDelay = setTimeout(function () {
        _this2._hoverHideDelay = null;

        _this2.hide();
      }, delay);
    }
  }, {
    key: "handleDelayedShow",
    value: function handleDelayedShow() {
      var _this3 = this;

      if (this._hoverHideDelay != null) {
        clearTimeout(this._hoverHideDelay);
        this._hoverHideDelay = null;
        return;
      }

      if (this.state.show || this._hoverShowDelay != null) {
        return;
      }

      var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

      if (!delay) {
        this.show();
        return;
      }

      this._hoverShowDelay = setTimeout(function () {
        _this3._hoverShowDelay = null;

        _this3.show();
      }, delay);
    }
  }, {
    key: "handleHide",
    value: function handleHide() {
      this.hide();
    } // Simple implementation of mouseEnter and mouseLeave.
    // React's built version is broken: https://github.com/facebook/react/issues/4251
    // for cases when the trigger is disabled and mouseOut/Over can cause flicker
    // moving from one child element to another.

  }, {
    key: "handleMouseOverOut",
    value: function handleMouseOverOut(handler, e, relatedNative) {
      var target = e.currentTarget;
      var related = e.relatedTarget || e.nativeEvent[relatedNative];

      if ((!related || related !== target) && !contains$2(target, related)) {
        handler(e);
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      if (this.state.show) {
        this.hide();
      } else {
        this.show();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        show: false
      });
    }
  }, {
    key: "makeOverlay",
    value: function makeOverlay(overlay, props) {
      return React__default.createElement(connectedComponent, _extends_1({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }), overlay);
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        show: true
      });
    }
  }, {
    key: "renderOverlay",
    value: function renderOverlay() {
      ReactDOM__default.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trigger = _this$props.trigger,
          overlay = _this$props.overlay,
          children = _this$props.children,
          onBlur = _this$props.onBlur,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onMouseOut = _this$props.onMouseOut,
          onMouseOver = _this$props.onMouseOver,
          props = objectWithoutProperties$1(_this$props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);
      delete props.delay;
      delete props.delayShow;
      delete props.delayHide;
      delete props.defaultOverlayShown;
      var child = React__default.Children.only(children);
      var childProps = child.props;
      var triggerProps = {};

      if (this.state.show) {
        triggerProps['aria-describedby'] = overlay.props.id;
      } // FIXME: The logic here for passing through handlers on this component is
      // inconsistent. We shouldn't be passing any of these props through.


      triggerProps.onClick = createChainedFunction(childProps.onClick, onClick);

      if (isOneOf('click', trigger)) {
        triggerProps.onClick = createChainedFunction(triggerProps.onClick, this.handleToggle);
      }

      if (isOneOf('hover', trigger)) {
        warning_1(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.');
        triggerProps.onMouseOver = createChainedFunction(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
        triggerProps.onMouseOut = createChainedFunction(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
      }

      if (isOneOf('focus', trigger)) {
        triggerProps.onFocus = createChainedFunction(childProps.onFocus, onFocus, this.handleDelayedShow);
        triggerProps.onBlur = createChainedFunction(childProps.onBlur, onBlur, this.handleDelayedHide);
      }

      this._overlay = this.makeOverlay(overlay, props);
      return cloneElement(child, triggerProps);
    }
  }]);
  return OverlayTrigger;
}(React__default.Component);

OverlayTrigger.propTypes = propTypes$4;
OverlayTrigger.defaultProps = defaultProps$2;
var css$e = "* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  opacity: 0;\n  line-break: auto;\n}\n.tooltip.in {\n  opacity: 0.9;\n}\n.tooltip.top {\n  margin-top: -3px;\n  padding: 5px 0;\n}\n.tooltip.right {\n  margin-left: 3px;\n  padding: 0 5px;\n}\n.tooltip.bottom {\n  margin-top: 3px;\n  padding: 5px 0;\n}\n.tooltip.left {\n  margin-left: -3px;\n  padding: 0 5px;\n}\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000;\n}\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.tooltip.in {\n  opacity: 0.9;\n}\n";
styleInject(css$e);

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(source, true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var propTypes$5 = {
  /** Sets the direction the Tooltip is positioned towards. */
  placement: propTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** The "top" position value for the Tooltip. */
  positionTop: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /** The "left" position value for the Tooltip. */
  positionLeft: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /** The "top" position value for the Tooltip arrow. */
  arrowOffsetTop: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /** The "left" position value for the Tooltip arrow. */
  arrowOffsetLeft: propTypes.oneOfType([propTypes.number, propTypes.string])
};
var defaultProps$3 = {
  placement: 'right'
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip() {
    classCallCheck(this, Tooltip);
    return possibleConstructorReturn(this, getPrototypeOf(Tooltip).apply(this, arguments));
  }

  createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placement = _this$props.placement,
          positionTop = _this$props.positionTop,
          positionLeft = _this$props.positionLeft,
          arrowOffsetTop = _this$props.arrowOffsetTop,
          arrowOffsetLeft = _this$props.arrowOffsetLeft,
          className = _this$props.className,
          style = _this$props.style,
          children = _this$props.children;

      var outerStyle = _objectSpread$3({
        top: positionTop,
        left: positionLeft
      }, style);

      var arrowStyle = {
        top: arrowOffsetTop,
        left: arrowOffsetLeft
      };
      return React__default.createElement("div", {
        role: "tooltip",
        className: classnames(className, 'tooltip', placement),
        style: outerStyle
      }, React__default.createElement("div", {
        className: "tooltip-arrow",
        style: arrowStyle
      }), React__default.createElement("div", {
        className: "tooltip-inner"
      }, children));
    }
  }]);
  return Tooltip;
}(React__default.Component);

Tooltip.propTypes = propTypes$5;
Tooltip.defaultProps = defaultProps$3;
var css$f = ".tableListItem {\n  display: -webkit-box;\n  display: flex;\n  margin-left: -6px;\n  margin-top: 2px;\n  padding-left: 6px;\n  opacity: 0.7;\n  cursor: pointer;\n  width: calc(100% + 6px);\n}\n.tableListItem:hover {\n  opacity: 1;\n}\n.tableListItem.selected {\n  opacity: 1;\n}\n.tableListItem.selected .itemIndex {\n  color: $activeColor;\n}\n.tableListItem.hasWarning .warning {\n  display: block;\n}\n.tableListItem .itemIndex {\n  background-color: var(--ui-gray);\n  color: var(--text-secondary-color);\n  cursor: pointer;\n  -webkit-box-flex: 1;\n          flex: 1;\n  max-width: 25px;\n  font-size: 14px;\n  font-weight: 400;\n  margin-right: 5px;\n  padding: 10px;\n  text-align: center;\n  box-sizing: initial;\n}\n.tableListItem .itemContent {\n  -webkit-box-flex: 1;\n          flex: 1;\n  color: var(--text-secondary-color);\n  font-weight: 400;\n  margin-left: 9px;\n  margin-top: 9px;\n}\n.tableListItem .warning-icon {\n  display: none;\n}\n";
styleInject(css$f);

var TableListItem =
/*#__PURE__*/
function (_Component) {
  inherits(TableListItem, _Component);

  function TableListItem() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TableListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TableListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "onItemClick", function (event) {
      if (_this.props.onItemClick) {
        event.preventDefault();
        event.stopPropagation();

        _this.props.onItemClick(event, _this.props.itemKey);
      }
    });
    return _this;
  }

  createClass(TableListItem, [{
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "tableListItem ".concat(this.props.itemClass),
        onClick: this.onItemClick
      }, React__default.createElement("div", {
        className: "itemIndex"
      }, this.props.itemIndex, React__default.createElement("span", {
        className: "warning-icon"
      }, React__default.createElement(Icon, {
        name: "exclamation-triangle"
      }))), React__default.createElement("div", {
        className: "itemContent"
      }, this.props.children));
    }
  }]);
  return TableListItem;
}(Component);

defineProperty(TableListItem, "propTypes", {
  children: propTypes.node,
  itemClass: propTypes.string,
  itemIndex: propTypes.number,
  itemKey: propTypes.oneOfType([propTypes.number, propTypes.string]),
  onItemClick: propTypes.func.isRequired
});
var css$g = ".measurementItem .rowActions {\n  background-color: var(--ui-gray-darker);\n  height: 0;\n  overflow: hidden;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  visibility: hidden;\n  padding-left: 14px;\n}\n.measurementItem .rowActions .btnAction {\n  background-color: transparent;\n  border: none;\n  color: var(--default-color);\n  cursor: pointer;\n  line-height: 35px;\n  height: 35px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.measurementItem .rowActions .btnAction:hover,\n.measurementItem .rowActions .btnAction:active {\n  color: var(--text-primary-color);\n}\n.measurementItem .rowActions .btnAction i {\n  margin-right: 4px;\n}\n.measurementItem.selected .rowActions {\n  height: 35px;\n  visibility: visible;\n}\n.measurementItem .measurementLocation {\n  margin-left: 9px;\n  margin-top: 9px;\n}\n.measurementItem .measurementDisplayText {\n  display: inline-block;\n  margin-top: 9px;\n  margin-left: 9px;\n  padding-left: 9px;\n  width: 90px;\n  border-left: 1px solid var(--text-secondary-color);\n  color: var(--text-primary-color);\n}\n.measurementItem .itemIndex {\n  box-sizing: initial;\n}\n.measurementItem.hasWarnings .itemIndex {\n  opacity: 1;\n  background-color: #e29e4a;\n  color: #fff;\n}\n.measurementItem.hasWarnings .warning-icon {\n  display: block;\n  margin: 7px auto 0;\n}\n.measurementItem.hasWarnings .warning-icon svg {\n  width: 22px;\n  height: 20px;\n  pointer-events: inherit;\n}\n";
styleInject(css$g);

var MeasurementTableItem =
/*#__PURE__*/
function (_Component) {
  inherits(MeasurementTableItem, _Component);

  function MeasurementTableItem() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, MeasurementTableItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(MeasurementTableItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "getActionButton", function (btnLabel, onClickCallback) {
      return React__default.createElement("button", {
        key: btnLabel,
        className: "btnAction",
        onClick: onClickCallback
      }, React__default.createElement("span", {
        style: {
          marginRight: '4px'
        }
      }, React__default.createElement(Icon, {
        name: "edit",
        width: "14px",
        height: "14px"
      })), _this.props.t(btnLabel));
    });
    defineProperty(assertThisInitialized(_this), "getTableListItem", function () {
      var hasWarningClass = _this.props.measurementData.hasWarnings ? 'hasWarnings' : '';
      var actionButtons = [];

      if (typeof _this.props.onRelabel === 'function') {
        var relabelButton = _this.getActionButton('Relabel', _this.onRelabelClick);

        actionButtons.push(relabelButton);
      }

      if (typeof _this.props.onEditDescription === 'function') {
        var descriptionButton = _this.getActionButton('Description', _this.onEditDescriptionClick);

        actionButtons.push(descriptionButton);
      }

      if (typeof _this.props.onDelete === 'function') {
        var deleteButton = _this.getActionButton('Delete', _this.onDeleteClick);

        actionButtons.push(deleteButton);
      }

      return React__default.createElement(TableListItem, {
        itemKey: _this.props.measurementData.measurementNumber,
        itemClass: "measurementItem ".concat(_this.props.itemClass, " ").concat(hasWarningClass),
        itemIndex: _this.props.itemIndex,
        onItemClick: _this.onItemClick
      }, React__default.createElement("div", null, React__default.createElement("div", {
        className: "measurementLocation"
      }, _this.props.t(_this.props.measurementData.label, {
        keySeparator: '>',
        nsSeparator: '|'
      })), React__default.createElement("div", null, _this.getDataDisplayText()), React__default.createElement("div", {
        className: "rowActions"
      }, actionButtons)));
    });
    defineProperty(assertThisInitialized(_this), "onItemClick", function (event) {
      _this.props.onItemClick(event, _this.props.measurementData);
    });
    defineProperty(assertThisInitialized(_this), "onRelabelClick", function (event) {
      // Prevent onItemClick from firing
      event.stopPropagation();

      _this.props.onRelabel(event, _this.props.measurementData);
    });
    defineProperty(assertThisInitialized(_this), "onEditDescriptionClick", function (event) {
      // Prevent onItemClick from firing
      event.stopPropagation();

      _this.props.onEditDescription(event, _this.props.measurementData);
    });
    defineProperty(assertThisInitialized(_this), "onDeleteClick", function (event) {
      // Prevent onItemClick from firing
      event.stopPropagation();

      _this.props.onDelete(event, _this.props.measurementData);
    });
    defineProperty(assertThisInitialized(_this), "getDataDisplayText", function () {
      return _this.props.measurementData.data.map(function (data, index) {
        return React__default.createElement("div", {
          key: "displayText_".concat(index),
          className: "measurementDisplayText"
        }, data.displayText ? data.displayText : '...');
      });
    });
    defineProperty(assertThisInitialized(_this), "getWarningContent", function () {
      var _this$props$measureme = _this.props.measurementData.warningList,
          warningList = _this$props$measureme === void 0 ? '' : _this$props$measureme;

      if (Array.isArray(warningList)) {
        var listedWarnings = warningList.map(function (warn, index) {
          return React__default.createElement("li", {
            key: index
          }, warn);
        });
        return React__default.createElement("ol", null, listedWarnings);
      } else {
        return React__default.createElement(React__default.Fragment, null, warningList);
      }
    });
    return _this;
  }

  createClass(MeasurementTableItem, [{
    key: "render",
    value: function render() {
      var _this$props$measureme2 = this.props.measurementData,
          _this$props$measureme3 = _this$props$measureme2.warningTitle,
          warningTitle = _this$props$measureme3 === void 0 ? '' : _this$props$measureme3,
          hasWarnings = _this$props$measureme2.hasWarnings;
      return React__default.createElement(React__default.Fragment, null, hasWarnings ? React__default.createElement(OverlayTrigger, {
        key: this.props.itemIndex,
        placement: "left",
        overlay: React__default.createElement(Tooltip, {
          placement: "left",
          className: "in tooltip-warning",
          id: "tooltip-left"
        }, React__default.createElement("div", {
          className: "warningTitle"
        }, this.props.t(warningTitle)), React__default.createElement("div", {
          className: "warningContent"
        }, this.getWarningContent()))
      }, React__default.createElement("div", null, this.getTableListItem())) : React__default.createElement(React__default.Fragment, null, this.getTableListItem()));
    }
  }]);
  return MeasurementTableItem;
}(Component);

defineProperty(MeasurementTableItem, "propTypes", {
  measurementData: propTypes.object.isRequired,
  onItemClick: propTypes.func.isRequired,
  onRelabel: propTypes.func,
  onDelete: propTypes.func,
  onEditDescription: propTypes.func,
  itemClass: propTypes.string,
  itemIndex: propTypes.number,
  t: propTypes.func
});
var connectedComponent$1 = withTranslation$1('MeasurementTable')(MeasurementTableItem);
var css$h = ".scrollArea {\n  overflow: hidden;\n  position: relative;\n}\n.scrollArea .scrollable {\n  max-height: inherit;\n  overflow: hidden;\n  zoom: 1;\n}\n.scrollArea .scrollable.scrollX {\n  overflow-x: scroll;\n}\n.scrollArea .scrollable.scrollY {\n  overflow-y: scroll;\n}\n.scrollArea.fit {\n  height: 100%;\n  width: 100%;\n}\n.scrollArea.fit .scrollable {\n  bottom: 0;\n  left: 0;\n  max-height: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.scrollArea .scrollNav {\n  background-color: rgba(0,0,0,0.75);\n  box-shadow: 0 0 10px 10px rgba(0,0,0,0.75);\n  cursor: pointer;\n  height: 24px;\n  left: 10px;\n  opacity: 0;\n  position: absolute;\n  right: 10px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.scrollArea .scrollNav .scrollNavIcon {\n  color: var(--active-color);\n  display: block;\n  width: 18px;\n  height: 18px;\n  margin: 0 auto;\n  -webkit-transition: color 0.3s ease;\n  transition: color 0.3s ease;\n}\n.scrollArea .scrollNav:hover {\n  background-color: rgba(0,0,0,0.9);\n  box-shadow: 0 0 10px 10px rgba(0,0,0,0.9);\n}\n.scrollArea .scrollNav:hover .scrollNavIcon {\n  color: var(--hover-color);\n}\n.scrollArea .scrollNavUp {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  top: 0;\n  -webkit-transform: translateY(-24px);\n          transform: translateY(-24px);\n}\n.scrollArea .scrollNavDown {\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  bottom: 0;\n  -webkit-transform: translateY(24px);\n          transform: translateY(24px);\n}\n.scrollArea.canScrollUp .scrollNavUp,\n.scrollArea.canScrollDown .scrollNavDown {\n  opacity: 1;\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n}\n";
styleInject(css$h);
/**
 * Get the vertical and horizontal scrollbar sizes
 * Got from https://stackoverflow.com/questions/986937/how-can-i-get-the-browsers-scrollbar-sizes
 *
 * @returns {Array} Array containing the scrollbar horizontal and vertical sizes
 */

function getScrollbarSize() {
  var inner = document.createElement('p');
  inner.style.width = '100%';
  inner.style.height = '100%';
  var outer = document.createElement('div');
  outer.style.position = 'absolute';
  outer.style.top = '0px';
  outer.style.left = '0px';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.height = '100px';
  outer.style.overflow = 'hidden';
  outer.appendChild(inner);
  document.body.appendChild(outer);
  var w1 = inner.offsetWidth;
  var h1 = inner.offsetHeight;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  var h2 = inner.offsetHeight;

  if (w1 === w2) {
    w2 = outer.clientWidth;
  }

  if (h1 === h2) {
    h2 = outer.clientHeight;
  }

  document.body.removeChild(outer);
  return [w1 - w2, h1 - h2];
}

function throttled(delay, callback) {
  var isThrottled = false,
      args,
      context;

  function wrapper() {
    if (isThrottled) {
      args = arguments;
      context = this;
      return;
    }

    isThrottled = true;
    callback.apply(this, arguments);
    setTimeout(function () {
      isThrottled = false;

      if (args) {
        wrapper.apply(context, args);
        args = context = null;
      }
    }, delay);
  }

  return wrapper;
}

var ScrollableArea =
/*#__PURE__*/
function (_Component) {
  inherits(ScrollableArea, _Component);

  function ScrollableArea(props) {
    var _this;

    classCallCheck(this, ScrollableArea);
    _this = possibleConstructorReturn(this, getPrototypeOf(ScrollableArea).call(this, props));
    defineProperty(assertThisInitialized(_this), "scrollNavDown", function (event) {
      var _this$scrollableEleme = _this.scrollableElement,
          currentTop = _this$scrollableEleme.scrollTop,
          height = _this$scrollableEleme.offsetHeight,
          scrollHeight = _this$scrollableEleme.scrollHeight;
      var limit = scrollHeight - height;
      var scrollTop = currentTop + _this.props.scrollStep;
      scrollTop = scrollTop > limit ? limit : scrollTop;
      _this.scrollableElement.scrollTop = scrollTop;
    });
    defineProperty(assertThisInitialized(_this), "scrollNavUp", function (event) {
      var currentTop = _this.scrollableElement.scrollTop;
      var scrollTop = currentTop - _this.props.scrollStep;
      scrollTop = scrollTop < 0 ? 0 : scrollTop;
      _this.scrollableElement.scrollTop = scrollTop;
    });
    defineProperty(assertThisInitialized(_this), "adjustMargins", function () {
      if (_this.props.hideScrollbar) {
        var x = _this.props.scrollX ? 1 : 0;
        var y = _this.props.scrollY ? 1 : 0;
        var scrollbarSize = getScrollbarSize();
        _this.scrollableElement.style.marginRight = "".concat(0 - scrollbarSize[0] * y, "px");
        _this.scrollableElement.style.marginBottom = "".concat(0 - scrollbarSize[1] * x, "px");
      }
    });
    defineProperty(assertThisInitialized(_this), "scrollHandler", function () {
      var _this$scrollableEleme2 = _this.scrollableElement,
          height = _this$scrollableEleme2.offsetHeight,
          scrollTop = _this$scrollableEleme2.scrollTop,
          scrollHeight = _this$scrollableEleme2.scrollHeight;
      var scrollAreaClasses = ''; // Check if can scroll up

      if (scrollTop) {
        scrollAreaClasses += 'canScrollUp';
      } // Check if can scroll down


      if (scrollTop + height < scrollHeight) {
        scrollAreaClasses += ' canScrollDown';
      }

      if (_this.state.scrollAreaClasses !== scrollAreaClasses) {
        _this.setState({
          scrollAreaClasses: scrollAreaClasses
        });
      }
    });
    _this.state = {
      scrollAreaClasses: ''
    };
    _this.scrollHandlerThrottled = throttled(150, _this.scrollHandler);
    return _this;
  }

  createClass(ScrollableArea, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var scrollableClass = 'scrollable';

      if (this.props.scrollableClass) {
        scrollableClass += " ".concat(this.props.scrollableClass);
      }

      if (this.props.scrollX) {
        scrollableClass += " scrollX";
      }

      if (this.props.scrollY) {
        scrollableClass += " scrollY";
      }

      return React__default.createElement("div", {
        className: "scrollArea ".concat(this.props.class, " ").concat(this.state.scrollAreaClasses)
      }, React__default.createElement("div", {
        className: scrollableClass,
        ref: function ref(element) {
          _this2.scrollableElement = element;
        },
        onScroll: this.scrollHandlerThrottled,
        onMouseEnter: this.scrollHandlerThrottled,
        onTransitionEnd: this.scrollHandlerThrottled
      }, this.props.children), React__default.createElement("div", {
        className: "scrollNav scrollNavUp",
        onClick: this.scrollNavUp
      }, React__default.createElement(Icon, {
        name: "angle-double-up"
      })), React__default.createElement("div", {
        className: "scrollNav scrollNavDown",
        onClick: this.scrollNavDown
      }, React__default.createElement(Icon, {
        name: "angle-double-down"
      })));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.adjustMargins();
      this.scrollHandler();
      window.addEventListener('resize', this.adjustMargins);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.adjustMargins();
      this.scrollHandler();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.adjustMargins);
    }
  }]);
  return ScrollableArea;
}(Component);

defineProperty(ScrollableArea, "propTypes", {
  children: propTypes.node.isRequired,
  class: propTypes.string,
  scrollableClass: propTypes.string,
  scrollX: propTypes.bool,
  scrollY: propTypes.bool,
  hideScrollbar: propTypes.bool,
  scrollStep: propTypes.number
});
defineProperty(ScrollableArea, "defaultProps", {
  hideScrollbar: true,
  class: 'flex-grow fit',
  scrollY: true,
  scrollX: false,
  scrollStep: 100
});
var css$i = ".tableList {\n  background-color: var(--primary-background-color);\n  height: 100%;\n  width: 100%;\n}\n.tableList .tableListHeader {\n  background-color: var(--ui-gray-darker);\n  color: var(--text-secondary-color);\n  display: -webkit-box;\n  display: flex;\n  height: 63px;\n  line-height: 63px;\n  margin-top: 2px;\n  overflow: hidden;\n  width: 100%;\n}\n.tableList .tableListHeader .tableListHeaderTitle {\n  color: var(--text-secondary-color);\n  font-size: 22px;\n  font-weight: 300;\n  line-height: 63px;\n  padding: 0 10px;\n  text-align: left;\n  -webkit-box-flex: 1;\n          flex: 1;\n}\n.tableList .tableListHeader .numberOfItems {\n  color: var(--ui-sky-blue);\n  float: right;\n  font-weight: 300;\n  font-size: 40px;\n  max-width: 54px;\n  height: 63px;\n  line-height: 66px;\n  -webkit-box-flex: 1;\n          flex: 1;\n}\n";
styleInject(css$i);

var TableList =
/*#__PURE__*/
function (_Component) {
  inherits(TableList, _Component);

  function TableList() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TableList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TableList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "getHeader", function () {
      if (_this.props.customHeader) {
        return _this.props.customHeader;
      } else {
        return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
          className: "tableListHeaderTitle"
        }, _this.props.headerTitle), React__default.createElement("div", {
          className: "numberOfItems"
        }, _this.props.children.length));
      }
    });
    return _this;
  }

  createClass(TableList, [{
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "tableList"
      }, React__default.createElement("div", {
        className: "tableListHeader",
        onClick: this.onHeaderClick
      }, this.getHeader()), React__default.createElement("div", {
        className: "tableListContent"
      }, this.props.children));
    }
  }]);
  return TableList;
}(Component);

defineProperty(TableList, "propTypes", {
  customHeader: propTypes.node,
  defaultItems: propTypes.object,
  children: propTypes.node.isRequired,
  headerTitle: propTypes.string
});

var MeasurementTable =
/*#__PURE__*/
function (_Component) {
  inherits(MeasurementTable, _Component);

  function MeasurementTable() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, MeasurementTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(MeasurementTable)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      selectedKey: null
    });
    defineProperty(assertThisInitialized(_this), "getMeasurementsGroups", function () {
      return _this.props.measurementCollection.map(function (measureGroup, index) {
        return React__default.createElement(TableList, {
          key: index,
          customHeader: _this.getCustomHeader(measureGroup)
        }, _this.getMeasurements(measureGroup));
      });
    });
    defineProperty(assertThisInitialized(_this), "getMeasurements", function (measureGroup) {
      var selectedKey = _this.props.selectedMeasurementNumber ? _this.props.selectedMeasurementNumber : _this.state.selectedKey;
      return measureGroup.measurements.map(function (measurement, index) {
        var key = measurement.measurementNumber;
        var itemIndex = measurement.itemNumber || index + 1;
        var itemClass = selectedKey === key && !_this.props.readOnly ? 'selected' : '';
        return React__default.createElement(connectedComponent$1, {
          key: key,
          itemIndex: itemIndex,
          itemClass: itemClass,
          measurementData: measurement,
          onItemClick: _this.onItemClick,
          onRelabel: _this.props.onRelabelClick,
          onDelete: _this.props.onDeleteClick,
          onEditDescription: _this.props.onEditDescriptionClick
        });
      });
    });
    defineProperty(assertThisInitialized(_this), "onItemClick", function (event, measurementData) {
      if (_this.props.readOnly) return;

      _this.setState({
        selectedKey: measurementData.measurementNumber
      });

      if (_this.props.onItemClick) {
        _this.props.onItemClick(event, measurementData);
      }
    });
    defineProperty(assertThisInitialized(_this), "getCustomHeader", function (measureGroup) {
      return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: "tableListHeaderTitle"
      }, _this.props.t(measureGroup.groupName)), measureGroup.maxMeasurements && React__default.createElement("div", {
        className: "maxMeasurements"
      }, _this.props.t('MAX'), " ", measureGroup.maxMeasurements), React__default.createElement("div", {
        className: "numberOfItems"
      }, measureGroup.measurements.length));
    });
    defineProperty(assertThisInitialized(_this), "getTimepointsHeader", function () {
      return _this.props.timepoints.map(function (timepoint, index) {
        return React__default.createElement("div", {
          key: index,
          className: "measurementTableHeaderItem"
        }, React__default.createElement("div", {
          className: "timepointLabel"
        }, _this.props.t(timepoint.key)), React__default.createElement("div", {
          className: "timepointDate"
        }, timepoint.date));
      });
    });
    defineProperty(assertThisInitialized(_this), "getWarningContent", function () {
      var _this$props$overwallW = _this.props.overwallWarnings.warningList,
          warningList = _this$props$overwallW === void 0 ? '' : _this$props$overwallW;

      if (Array.isArray(warningList)) {
        var listedWarnings = warningList.map(function (warn, index) {
          return React__default.createElement("li", {
            key: index
          }, warn);
        });
        return React__default.createElement("ol", null, listedWarnings);
      } else {
        return React__default.createElement(React__default.Fragment, null, warningList);
      }
    });
    return _this;
  }

  createClass(MeasurementTable, [{
    key: "render",
    value: function render() {
      var hasOverallWarnings = this.props.overallWarnings.warningList.length > 0;
      return React__default.createElement("div", {
        className: "measurementTable"
      }, React__default.createElement("div", {
        className: "measurementTableHeader"
      }, hasOverallWarnings && React__default.createElement(OverlayTrigger, {
        key: 'overwall-warning',
        placement: "left",
        overlay: React__default.createElement(Tooltip, {
          placement: "left",
          className: "in tooltip-warning",
          id: "tooltip-left",
          style: {}
        }, React__default.createElement("div", {
          className: "warningTitle"
        }, this.props.t('Criteria nonconformities')), React__default.createElement("div", {
          className: "warningContent"
        }, this.getWarningContent()))
      }, React__default.createElement("span", {
        className: "warning-status"
      }, React__default.createElement("span", {
        className: "warning-border"
      }, React__default.createElement(Icon, {
        name: "exclamation-triangle"
      })))), this.getTimepointsHeader()), React__default.createElement(ScrollableArea, null, React__default.createElement("div", null, this.getMeasurementsGroups())));
    }
  }]);
  return MeasurementTable;
}(Component);

defineProperty(MeasurementTable, "propTypes", {
  measurementCollection: propTypes.array.isRequired,
  timepoints: propTypes.array.isRequired,
  overallWarnings: propTypes.object.isRequired,
  readOnly: propTypes.bool,
  onItemClick: propTypes.func,
  onRelabelClick: propTypes.func,
  onDeleteClick: propTypes.func,
  onEditDescriptionClick: propTypes.func,
  selectedMeasurementNumber: propTypes.number,
  overwallWarnings: propTypes.object,
  t: propTypes.func
});
defineProperty(MeasurementTable, "defaultProps", {
  overallWarnings: {
    warningList: []
  },
  readOnly: false
});
var connectedComponent$2 = withTranslation$1(['MeasurementTable', 'Common'])(MeasurementTable);
var css$j = ".HotKeysPreferences {\n  display: -webkit-box;\n  display: flex;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.HotKeysPreferences .column {\n  width: 50%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.HotKeysPreferences .column-full {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n";
styleInject(css$j);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

var range = function range(start, end) {
  return new Array(end - start).fill().map(function (d, i) {
    return i + start;
  });
};

var disallowedCombinations = {
  '': [],
  ALT: ['SPACE'],
  SHIFT: [],
  CTRL: ['F4', 'F5', 'F11', 'W', 'R', 'T', 'O', 'P', 'A', 'D', 'F', 'G', 'H', 'J', 'L', 'Z', 'X', 'C', 'V', 'B', 'N', 'PAGEDOWN', 'PAGEUP'],
  'CTRL+SHIFT': ['Q', 'W', 'R', 'T', 'P', 'A', 'H', 'V', 'B', 'N']
};
var allowedKeys = [8, 13, 27, 32, 46].concat([12, 106, 107, 109, 110, 111], toConsumableArray(range(218, 220)), toConsumableArray(range(185, 190)), toConsumableArray(range(111, 131)), toConsumableArray(range(32, 41)), toConsumableArray(range(47, 58)), toConsumableArray(range(64, 91)));
var specialKeys = {
  8: 'backspace',
  9: 'tab',
  13: 'return',
  16: 'shift',
  17: 'ctrl',
  18: 'alt',
  19: 'pause',
  20: 'capslock',
  27: 'esc',
  32: 'space',
  33: 'pageup',
  34: 'pagedown',
  35: 'end',
  36: 'home',
  37: 'left',
  38: 'up',
  39: 'right',
  40: 'down',
  45: 'insert',
  46: 'del',
  96: '0',
  97: '1',
  98: '2',
  99: '3',
  100: '4',
  101: '5',
  102: '6',
  103: '7',
  104: '8',
  105: '9',
  106: '*',
  107: '+',
  109: '-',
  110: '.',
  111: '/',
  112: 'f1',
  113: 'f2',
  114: 'f3',
  115: 'f4',
  116: 'f5',
  117: 'f6',
  118: 'f7',
  119: 'f8',
  120: 'f9',
  121: 'f10',
  122: 'f11',
  123: 'f12',
  144: 'numlock',
  145: 'scroll',
  191: '/',
  224: 'meta'
};

var HotKeysPreferences =
/*#__PURE__*/
function (_Component) {
  inherits(HotKeysPreferences, _Component);

  function HotKeysPreferences(props) {
    var _this;

    classCallCheck(this, HotKeysPreferences);
    _this = possibleConstructorReturn(this, getPrototypeOf(HotKeysPreferences).call(this, props));
    var hotkeyCommands = Object.keys(_this.props.hotKeysData);
    var localHotKeys = hotkeyCommands.map(function (commandName) {
      var definition = _this.props.hotKeysData[commandName];
      return {
        commandName: commandName,
        keys: definition.keys,
        label: definition.label
      };
    });
    _this.state = {
      hotKeys: localHotKeys,
      errorMessages: {}
    };
    _this.onInputKeyDown = _this.onInputKeyDown.bind(assertThisInitialized(_this));
    return _this;
  }
  /**
   * Normalizes the keys used in a KeyPress event and returns an array of the
   * keys pressed
   *
   * @param {KeyDownEvent} keyDownEvent
   * @returns {string[]}
   */


  createClass(HotKeysPreferences, [{
    key: "getKeysPressedArray",
    value: function getKeysPressedArray(keyDownEvent) {
      var keysPressedArray = [];
      var ctrlKey = keyDownEvent.ctrlKey,
          altKey = keyDownEvent.altKey,
          shiftKey = keyDownEvent.shiftKey;

      if (ctrlKey && !altKey) {
        keysPressedArray.push('CTRL');
      }

      if (shiftKey && !altKey) {
        keysPressedArray.push('SHIFT');
      }

      if (altKey && !ctrlKey) {
        keysPressedArray.push('ALT');
      }

      return keysPressedArray;
    }
  }, {
    key: "getConflictingCommand",
    value: function getConflictingCommand(currentToolKey, hotKeyCommand) {
      var _this2 = this;

      return Object.keys(this.state.hotKeys).find(function (tool) {
        var value = _this2.state.hotKeys[tool].command;
        return value && value === hotKeyCommand && tool !== currentToolKey;
      });
    }
    /**
     *
     * @param {String} commandName
     * @param {KeyDownEvent} keyDownEvent
     * @param {Boolean} [displayPressedKey=false]
     */

  }, {
    key: "updateInputText",
    value: function updateInputText(commandName, keyDownEvent) {
      var displayPressedKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var pressedKeys = this.getKeysPressedArray(keyDownEvent);

      if (displayPressedKey) {
        var specialKeyName = specialKeys[keyDownEvent.which];
        var keyName = specialKeyName || keyDownEvent.key || String.fromCharCode(keyDownEvent.keyCode);
        pressedKeys.push(keyName.toUpperCase());
      }

      this.updateHotKeysState(commandName, pressedKeys.join('+'));
    }
  }, {
    key: "updateHotKeysState",
    value: function updateHotKeysState(commandName, keys) {
      var hotKeys = this.state.hotKeys;
      var hotKeyIndex = this.state.hotKeys.findIndex(function (x) {
        return x.commandName === commandName;
      });
      hotKeys[hotKeyIndex].keys[0] = keys;
      this.setState({
        hotKeys: hotKeys
      });
    }
  }, {
    key: "updateErrorsState",
    value: function updateErrorsState(toolKey, errorMessage) {
      var errorMessages = this.state.errorMessages;
      errorMessages[toolKey] = errorMessage;
      this.setState({
        errorMessages: errorMessages
      });
    }
  }, {
    key: "onInputKeyDown",
    value: function onInputKeyDown(event, commandName) {
      // Prevent ESC key from propagating and closing the modal
      if (event.key === 'Escape') {
        event.stopPropagation();
      }

      if (allowedKeys.includes(event.keyCode)) {
        this.updateInputText(commandName, event, true);
      } else {
        this.updateInputText(commandName, event, false);
      }

      event.preventDefault();
    }
  }, {
    key: "onChange",
    value: function onChange(event, commandName) {
      var _this3 = this;

      if (event.ctrlKey || event.altKey || event.shiftKey) {
        return;
      }

      var hotKeyIndex = this.state.hotKeys.findIndex(function (x) {
        return x.commandName === commandName;
      });
      var hotKey = this.state.hotKeys[hotKeyIndex];
      var keys = hotKey.keys[0];
      var pressedKeys = keys.split('+');
      var lastPressedKey = pressedKeys[pressedKeys.length - 1].toUpperCase(); // clear the prior errors

      this.setState({
        errorMessages: {}
      }, function () {
        // Check if it has a valid modifier
        var isModifier = ['CTRL', 'ALT', 'SHIFT'].includes(lastPressedKey);

        if (isModifier) {
          _this3.updateHotKeysState(commandName, '');

          _this3.updateErrorsState(commandName, "It's not possible to define only modifier keys (CTRL, ALT and SHIFT) as a shortcut");

          return;
        }
        /*
         * Check if it has some conflict
         */


        var conflictedCommandKey = _this3.getConflictingCommand(commandName, keys);

        if (conflictedCommandKey) {
          var conflictedCommand = _this3.state.hotKeys[conflictedCommandKey];

          _this3.updateErrorsState(commandName, "\"".concat(conflictedCommand.label, "\" is already using the \"").concat(conflictedCommand.command, "\" shortcut."));

          _this3.updateErrorsState(conflictedCommandKey, '');

          _this3.updateHotKeysState(commandName, '');

          return;
        }
        /*
         * Check if is a valid combination
         */


        var modifierCommand = pressedKeys.slice(0, pressedKeys.length - 1).join('+').toUpperCase();
        var disallowedCombination = disallowedCombinations[modifierCommand];
        var hasDisallowedCombinations = disallowedCombination ? disallowedCombination.includes(lastPressedKey) : false;

        if (hasDisallowedCombinations) {
          _this3.updateHotKeysState(commandName, '');

          _this3.updateErrorsState(commandName, "It's not possible to define only modifier keys (CTRL, ALT and SHIFT) as a shortcut");

          return;
        }
      });
    }
  }, {
    key: "renderRow",
    value: function renderRow(_ref) {
      var _this4 = this;

      var commandName = _ref.commandName,
          label = _ref.label,
          keys = _ref.keys;
      return React__default.createElement("tr", {
        key: commandName
      }, React__default.createElement("td", {
        className: "text-right p-r-1"
      }, label), React__default.createElement("td", {
        width: "200"
      }, React__default.createElement("label", {
        className: "wrapperLabel ".concat(this.state.errorMessages[commandName] !== undefined ? 'state-error' : '', " "),
        ref: function ref(input) {
          return _this4[commandName] = input;
        },
        "data-key": "defaultTool"
      }, React__default.createElement("input", {
        readOnly: true,
        type: "text",
        value: keys[0],
        vali: "true",
        className: "form-control hotkey text-center",
        onKeyDown: function onKeyDown(event) {
          return _this4.onInputKeyDown(event, commandName);
        },
        onKeyUp: function onKeyUp(event) {
          return _this4.onChange(event, commandName);
        }
      }), React__default.createElement("span", {
        className: "wrapperText"
      }), React__default.createElement("span", {
        className: "errorMessage"
      }, this.state.errorMessages[commandName]))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var halfWayThough = Math.floor(this.state.hotKeys.length / 2);
      var firstHalfHotkeys = this.state.hotKeys.slice(0, halfWayThough);
      var secondHalfHotkeys = this.state.hotKeys.slice(halfWayThough, this.state.hotKeys.length);
      return React__default.createElement("div", {
        className: "HotKeysPreferences"
      }, React__default.createElement("div", {
        className: "column"
      }, React__default.createElement("table", {
        className: "full-width"
      }, React__default.createElement("thead", null, React__default.createElement("tr", null, React__default.createElement("th", {
        className: "text-right p-r-1"
      }, "Function"), React__default.createElement("th", {
        className: "text-center"
      }, "Shortcut"))), React__default.createElement("tbody", null, firstHalfHotkeys.map(function (hotkeyDefinition) {
        return _this5.renderRow(hotkeyDefinition);
      })))), React__default.createElement("div", {
        className: "column"
      }, React__default.createElement("table", {
        className: "full-width"
      }, React__default.createElement("thead", null, React__default.createElement("tr", null, React__default.createElement("th", {
        className: "text-right p-r-1"
      }, "Function"), React__default.createElement("th", {
        className: "text-center"
      }, "Shortcut"))), React__default.createElement("tbody", null, secondHalfHotkeys.map(function (hotkeyDefinition) {
        return _this5.renderRow(hotkeyDefinition);
      })))));
    }
  }]);
  return HotKeysPreferences;
}(Component);

defineProperty(HotKeysPreferences, "propTypes", {
  hotKeysData: propTypes.objectOf(propTypes.shape({
    keys: propTypes.arrayOf(propTypes.string).isRequired,
    label: propTypes.string.isRequired
  })).isRequired,
  onChange: propTypes.func
});
var css$k = ".form-themed table {\n  color: var(--text-primary-color);\n}\n.form-themed table th,\n.form-themed table td {\n  font-size: 15px;\n  font-weight: normal;\n}\n.form-themed table th {\n  line-height: 60px;\n}\n.form-themed table td {\n  line-height: 18px;\n  padding: 0;\n}\n.form-themed .p-r-1 {\n  padding-right: 1rem !important;\n}\n.form-themed label {\n  margin-bottom: 5px;\n}\n.form-themed label.wrapperLabel {\n  cursor: pointer;\n}\n.form-themed label.wrapperLabel:not(.checkboxLabel) {\n  cursor: pointer;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.form-themed label.wrapperLabel:not(.checkboxLabel) .wrapperText {\n  display: block;\n  -webkit-box-ordinal-group: 0;\n          order: -1;\n}\n.form-themed .btn[disabled],\n.form-themed input[type=text][disabled],\n.form-themed input[type=password][disabled],\n.form-themed input[type=number][disabled],\n.form-themed .btn.disabled,\n.form-themed input[type=text].disabled,\n.form-themed input[type=password].disabled,\n.form-themed input[type=number].disabled,\n.form-themed .btn[disabled]:hover,\n.form-themed input[type=text][disabled]:hover,\n.form-themed input[type=password][disabled]:hover,\n.form-themed input[type=number][disabled]:hover,\n.form-themed .btn.disabled:hover,\n.form-themed input[type=text].disabled:hover,\n.form-themed input[type=password].disabled:hover,\n.form-themed input[type=number].disabled:hover,\n.form-themed .btn[disabled]:active,\n.form-themed input[type=text][disabled]:active,\n.form-themed input[type=password][disabled]:active,\n.form-themed input[type=number][disabled]:active,\n.form-themed .btn.disabled:active,\n.form-themed input[type=text].disabled:active,\n.form-themed input[type=password].disabled:active,\n.form-themed input[type=number].disabled:active {\n  background-color: var(--ui-gray-darker);\n  border-color: var(--ui-gray-light);\n  color: var(--text-primary-color);\n}\n.form-themed .btn[disabled] + .wrapperText,\n.form-themed input[type=text][disabled] + .wrapperText,\n.form-themed input[type=password][disabled] + .wrapperText,\n.form-themed input[type=number][disabled] + .wrapperText,\n.form-themed .btn.disabled + .wrapperText,\n.form-themed input[type=text].disabled + .wrapperText,\n.form-themed input[type=password].disabled + .wrapperText,\n.form-themed input[type=number].disabled + .wrapperText,\n.form-themed .btn[disabled]:hover + .wrapperText,\n.form-themed input[type=text][disabled]:hover + .wrapperText,\n.form-themed input[type=password][disabled]:hover + .wrapperText,\n.form-themed input[type=number][disabled]:hover + .wrapperText,\n.form-themed .btn.disabled:hover + .wrapperText,\n.form-themed input[type=text].disabled:hover + .wrapperText,\n.form-themed input[type=password].disabled:hover + .wrapperText,\n.form-themed input[type=number].disabled:hover + .wrapperText,\n.form-themed .btn[disabled]:active + .wrapperText,\n.form-themed input[type=text][disabled]:active + .wrapperText,\n.form-themed input[type=password][disabled]:active + .wrapperText,\n.form-themed input[type=number][disabled]:active + .wrapperText,\n.form-themed .btn.disabled:active + .wrapperText,\n.form-themed input[type=text].disabled:active + .wrapperText,\n.form-themed input[type=password].disabled:active + .wrapperText,\n.form-themed input[type=number].disabled:active + .wrapperText {\n  color: var(--text-primary-color);\n  cursor: auto;\n}\n.form-themed input[type=text],\n.form-themed input[type=password],\n.form-themed input[type=number] {\n  background-color: var(--ui-gray);\n  border-color: var(--ui-border-color);\n  color: var(--text-primary-color);\n  font-weight: normal;\n}\n.form-themed input[type=text]:active,\n.form-themed input[type=password]:active,\n.form-themed input[type=number]:active,\n.form-themed input[type=text]:focus,\n.form-themed input[type=password]:focus,\n.form-themed input[type=number]:focus {\n  background-color: var(--ui-gray-dark);\n  border: 2px solid var(--active-color);\n  box-shadow: none;\n}\n.form-themed input[type=text]:active + .wrapperText,\n.form-themed input[type=password]:active + .wrapperText,\n.form-themed input[type=number]:active + .wrapperText,\n.form-themed input[type=text]:focus + .wrapperText,\n.form-themed input[type=password]:focus + .wrapperText,\n.form-themed input[type=number]:focus + .wrapperText {\n  color: var(--active-color);\n}\n.form-themed .btn-primary {\n  background-color: var(--active-color);\n  border-collapse: var(--ui-border-color-active);\n  color: var(--ui-text-color-active);\n}\n.form-themed .btn-primary:hover,\n.form-themed .btn-primary:active,\n.form-themed .btn-primary:focus,\n.form-themed .btn-primary:focus:active {\n  background-color: var(--ui-active-color);\n  border-collapse: var(--ui-border-color-active);\n  color: var(--ui-text-color-active);\n}\n.form-themed .form-control {\n  background-color: #fff;\n  border: 0;\n  font-size: 14px;\n  height: 30px;\n  line-height: 16px;\n  padding: 8px 9px 6px;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);\n}\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);\n}\n.form-control::-ms-expand {\n  border: 0;\n  background-color: transparent;\n}\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: ;\n  opacity: 1;\n}\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: ;\n}\ninput[type=range] {\n  display: block;\n  width: 100%;\n}\n.nav-tabs {\n  border-bottom: 0;\n  margin-bottom: 3px;\n  position: relative;\n  z-index: 1;\n}\n.nav-tabs :hover {\n  cursor: pointer;\n}\n.nav-tabs>li {\n  font-size: 14px;\n  font-weight: normal;\n  height: 40px;\n  line-height: 40px;\n  margin-bottom: 0;\n}\n.nav-tabs>li>button {\n  display: block;\n  width: 100%;\n  line-height: inherit;\n  margin: 0;\n  height: inherit;\n  padding: 0 10px 0 10px;\n  outline: none;\n}\n.nav-tabs>li>button:after {\n  background-color: transparent;\n  bottom: -3px;\n  content: ' ';\n  display: block;\n  height: 3px;\n  width: 100%;\n}\n.nav-tabs>li>button,\n.nav-tabs>li.active>button,\n.nav-tabs>li>button:hover,\n.nav-tabs>li.active>button:hover,\n.nav-tabs>li>button:active,\n.nav-tabs>li.active>button:active,\n.nav-tabs>li>button:focus,\n.nav-tabs>li.active>button:focus {\n  color: var(--active-color);\n  background-color: transparent;\n  border: 0;\n}\n.nav-tabs>li.active>button {\n  font-weight: bold;\n}\n.nav-tabs>li.active>button:after {\n  background-color: var(--active-color);\n}\n.nav {\n  padding-left: 0;\n  list-style: none;\n}\n.nav > li {\n  position: relative;\n  display: block;\n}\n.nav > li {\n  float: left;\n  margin-bottom: -1px;\n}\n.form-themed .state-error.wrapperLabel input + .wrapperText,\n.state-error.wrapperLabel input + .wrapperText {\n  color: var(--state-error-text);\n}\n.form-themed .state-error+.tooltip .tooltip-inner,\n.state-error+.tooltip .tooltip-inner {\n  color: #fff;\n  background-color: var(--state-error-border);\n}\n.form-themed .state-error+.tooltip.top .tooltip-arrow,\n.state-error+.tooltip.top .tooltip-arrow {\n  border-top-color: var(--state-error-border);\n}\n.form-themed .state-error+.tooltip.right .tooltip-arrow,\n.state-error+.tooltip.right .tooltip-arrow {\n  border-right-color: var(--state-error-border);\n}\n.form-themed .state-error+.tooltip.bottom .tooltip-arrow,\n.state-error+.tooltip.bottom .tooltip-arrow {\n  border-bottom-color: var(--state-error-border);\n}\n.form-themed .state-error+.tooltip.left .tooltip-arrow,\n.state-error+.tooltip.left .tooltip-arrow {\n  border-left-color: var(--state-error-border);\n}\n.form-themed .state-error:not(.component-group).form-control,\n.state-error:not(.component-group).form-control,\n.form-themed .state-error:not(.component-group) .form-control,\n.state-error:not(.component-group) .form-control {\n  background-color: var(--state-error-border);\n  border-color: var(--state-error-border);\n}\n* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.modal-body {\n  overflow: hidden;\n}\n.errorMessage {\n  color: var(--state-error-text);\n  font-size: 10px;\n  text-transform: uppercase;\n}\n.form-content {\n  border-bottom: 3px solid var(--primary-background-color);\n  margin-bottom: 20px;\n  margin-left: -22px;\n  margin-right: -22px;\n  max-height: 70vh;\n  overflow-y: auto;\n  padding: 22px;\n  min-height: 500px;\n}\n.popover {\n  width: 300px;\n}\n.presetIndex {\n  padding: 0px 10px 0px 10px;\n}\n";
styleInject(css$k);

var WindowLevelPreferences =
/*#__PURE__*/
function (_Component) {
  inherits(WindowLevelPreferences, _Component);

  function WindowLevelPreferences(props) {
    var _this;

    classCallCheck(this, WindowLevelPreferences);
    _this = possibleConstructorReturn(this, getPrototypeOf(WindowLevelPreferences).call(this, props));
    _this.state = {
      data: _this.props.windowLevelData
    };
    return _this;
  }

  createClass(WindowLevelPreferences, [{
    key: "onChange",
    value: function onChange(event, key, field) {
      var data = this.state.data;
      var entry = data[key];
      entry[field] = event.target.value;
      this.setState({
        data: data
      });

      if (this.props.onChange) {
        this.props.onChange(data);
      }
    }
  }, {
    key: "getWLPreferencesRows",
    value: function getWLPreferencesRows(key) {
      var _this2 = this;

      var entry = this.state.data[key];
      return React__default.createElement("tr", {
        key: key
      }, React__default.createElement("td", {
        className: "p-r-1 text-center"
      }, key), React__default.createElement("td", {
        className: "p-r-1"
      }, React__default.createElement("label", {
        className: "wrapperLabel"
      }, React__default.createElement("input", {
        value: entry.description,
        type: "text",
        className: "form-control",
        onChange: function onChange(event) {
          _this2.onChange(event, key, 'description');
        }
      }))), React__default.createElement("td", {
        className: "p-r-1"
      }, React__default.createElement("label", {
        className: "wrapperLabel"
      }, React__default.createElement("input", {
        value: entry.window,
        type: "number",
        className: "form-control",
        onChange: function onChange(event) {
          _this2.onChange(event, key, 'window');
        }
      }))), React__default.createElement("td", {
        className: "p-r-1"
      }, React__default.createElement("label", {
        className: "wrapperLabel"
      }, React__default.createElement("input", {
        value: entry.level,
        type: "number",
        className: "form-control",
        onChange: function onChange(event) {
          _this2.onChange(event, key, 'level');
        }
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement("table", {
        className: "full-width"
      }, React__default.createElement("thead", null, React__default.createElement("tr", null, React__default.createElement("th", {
        className: "p-x-1 text-center presetIndex"
      }, "Preset"), React__default.createElement("th", {
        className: "p-x-1"
      }, "Description"), React__default.createElement("th", {
        className: "p-x-1"
      }, "Window"), React__default.createElement("th", {
        className: "p-x-1"
      }, "Level"))), React__default.createElement("tbody", null, Object.keys(this.state.data).map(function (key) {
        return _this3.getWLPreferencesRows(key);
      })));
    }
  }]);
  return WindowLevelPreferences;
}(Component);

defineProperty(WindowLevelPreferences, "propTypes", {
  windowLevelData: propTypes.object.isRequired,
  onChange: propTypes.func
});

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;
var css$l = "";
styleInject(css$l);

var LanguageSwitcher = function LanguageSwitcher() {
  var getCurrentLanguage = function getCurrentLanguage() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i18n.language;
    return language.split('-')[0];
  };

  var _useState = useState(getCurrentLanguage()),
      _useState2 = slicedToArray(_useState, 2),
      currentLanguage = _useState2[0],
      setCurrentLanguage = _useState2[1];

  var languages = [// TODO: list of available languages should come from i18n.options.resources
  {
    value: 'en',
    label: 'English'
  }, {
    value: 'es',
    label: 'Spanish'
  }];

  var onChange = function onChange() {
    var value = event.target.value;
    var language = getCurrentLanguage(value);
    setCurrentLanguage(language);
    i18n.init({
      fallbackLng: language,
      lng: language
    });
  };

  useEffect(function () {
    var mounted = true;
    i18n.on('languageChanged', function () {
      if (mounted) {
        setCurrentLanguage(getCurrentLanguage());
      }
    });
    return function () {
      mounted = false;
    };
  }, []);
  return React__default.createElement("select", {
    name: "language-select",
    id: "language-select",
    className: "language-select",
    value: currentLanguage,
    onChange: onChange
  }, languages.map(function (language) {
    return React__default.createElement("option", {
      key: language.value,
      value: language.value
    }, language.label);
  }));
};

var LanguageSwitcher$1 = withTranslation$1('UserPreferencesModal')(LanguageSwitcher);

var GeneralPreferences =
/*#__PURE__*/
function (_Component) {
  inherits(GeneralPreferences, _Component);

  function GeneralPreferences() {
    classCallCheck(this, GeneralPreferences);
    return possibleConstructorReturn(this, getPrototypeOf(GeneralPreferences).apply(this, arguments));
  }

  createClass(GeneralPreferences, [{
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "general-preferences-wrapper"
      }, React__default.createElement("div", {
        className: "col-sm-3"
      }, React__default.createElement("label", {
        htmlFor: "language-select",
        className: "p-r-1"
      }, "Language"), React__default.createElement(LanguageSwitcher$1, null)));
    }
  }]);
  return GeneralPreferences;
}(Component);

var css$m = ".form-themed table {\n  color: var(--text-primary-color);\n}\n.form-themed table th,\n.form-themed table td {\n  font-size: 15px;\n  font-weight: normal;\n}\n.form-themed table th {\n  line-height: 60px;\n}\n.form-themed table td {\n  line-height: 18px;\n  padding: 0;\n}\n.form-themed .p-r-1 {\n  padding-right: 1rem !important;\n}\n.form-themed label {\n  margin-bottom: 5px;\n}\n.form-themed label.wrapperLabel {\n  cursor: pointer;\n}\n.form-themed label.wrapperLabel:not(.checkboxLabel) {\n  cursor: pointer;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.form-themed label.wrapperLabel:not(.checkboxLabel) .wrapperText {\n  display: block;\n  -webkit-box-ordinal-group: 0;\n          order: -1;\n}\n.form-themed .btn[disabled],\n.form-themed input[type=text][disabled],\n.form-themed input[type=password][disabled],\n.form-themed input[type=number][disabled],\n.form-themed .btn.disabled,\n.form-themed input[type=text].disabled,\n.form-themed input[type=password].disabled,\n.form-themed input[type=number].disabled,\n.form-themed .btn[disabled]:hover,\n.form-themed input[type=text][disabled]:hover,\n.form-themed input[type=password][disabled]:hover,\n.form-themed input[type=number][disabled]:hover,\n.form-themed .btn.disabled:hover,\n.form-themed input[type=text].disabled:hover,\n.form-themed input[type=password].disabled:hover,\n.form-themed input[type=number].disabled:hover,\n.form-themed .btn[disabled]:active,\n.form-themed input[type=text][disabled]:active,\n.form-themed input[type=password][disabled]:active,\n.form-themed input[type=number][disabled]:active,\n.form-themed .btn.disabled:active,\n.form-themed input[type=text].disabled:active,\n.form-themed input[type=password].disabled:active,\n.form-themed input[type=number].disabled:active {\n  background-color: var(--ui-gray-darker);\n  border-color: var(--ui-gray-light);\n  color: var(--text-primary-color);\n}\n.form-themed .btn[disabled] + .wrapperText,\n.form-themed input[type=text][disabled] + .wrapperText,\n.form-themed input[type=password][disabled] + .wrapperText,\n.form-themed input[type=number][disabled] + .wrapperText,\n.form-themed .btn.disabled + .wrapperText,\n.form-themed input[type=text].disabled + .wrapperText,\n.form-themed input[type=password].disabled + .wrapperText,\n.form-themed input[type=number].disabled + .wrapperText,\n.form-themed .btn[disabled]:hover + .wrapperText,\n.form-themed input[type=text][disabled]:hover + .wrapperText,\n.form-themed input[type=password][disabled]:hover + .wrapperText,\n.form-themed input[type=number][disabled]:hover + .wrapperText,\n.form-themed .btn.disabled:hover + .wrapperText,\n.form-themed input[type=text].disabled:hover + .wrapperText,\n.form-themed input[type=password].disabled:hover + .wrapperText,\n.form-themed input[type=number].disabled:hover + .wrapperText,\n.form-themed .btn[disabled]:active + .wrapperText,\n.form-themed input[type=text][disabled]:active + .wrapperText,\n.form-themed input[type=password][disabled]:active + .wrapperText,\n.form-themed input[type=number][disabled]:active + .wrapperText,\n.form-themed .btn.disabled:active + .wrapperText,\n.form-themed input[type=text].disabled:active + .wrapperText,\n.form-themed input[type=password].disabled:active + .wrapperText,\n.form-themed input[type=number].disabled:active + .wrapperText {\n  color: var(--text-primary-color);\n  cursor: auto;\n}\n.form-themed input[type=text],\n.form-themed input[type=password],\n.form-themed input[type=number] {\n  background-color: var(--ui-gray);\n  border-color: var(--ui-border-color);\n  color: var(--text-primary-color);\n  font-weight: normal;\n}\n.form-themed input[type=text]:active,\n.form-themed input[type=password]:active,\n.form-themed input[type=number]:active,\n.form-themed input[type=text]:focus,\n.form-themed input[type=password]:focus,\n.form-themed input[type=number]:focus {\n  background-color: var(--ui-gray-dark);\n  border: 2px solid var(--active-color);\n  box-shadow: none;\n}\n.form-themed input[type=text]:active + .wrapperText,\n.form-themed input[type=password]:active + .wrapperText,\n.form-themed input[type=number]:active + .wrapperText,\n.form-themed input[type=text]:focus + .wrapperText,\n.form-themed input[type=password]:focus + .wrapperText,\n.form-themed input[type=number]:focus + .wrapperText {\n  color: var(--active-color);\n}\n.form-themed .btn-primary {\n  background-color: var(--active-color);\n  border-collapse: var(--ui-border-color-active);\n  color: var(--ui-text-color-active);\n}\n.form-themed .btn-primary:hover,\n.form-themed .btn-primary:active,\n.form-themed .btn-primary:focus,\n.form-themed .btn-primary:focus:active {\n  background-color: var(--ui-active-color);\n  border-collapse: var(--ui-border-color-active);\n  color: var(--ui-text-color-active);\n}\n.form-themed .form-control {\n  background-color: #fff;\n  border: 0;\n  font-size: 14px;\n  height: 30px;\n  line-height: 16px;\n  padding: 8px 9px 6px;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);\n}\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);\n}\n.form-control::-ms-expand {\n  border: 0;\n  background-color: transparent;\n}\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: ;\n  opacity: 1;\n}\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: ;\n}\ninput[type=range] {\n  display: block;\n  width: 100%;\n}\n.nav-tabs {\n  border-bottom: 0;\n  margin-bottom: 3px;\n  position: relative;\n  z-index: 1;\n}\n.nav-tabs :hover {\n  cursor: pointer;\n}\n.nav-tabs>li {\n  font-size: 14px;\n  font-weight: normal;\n  height: 40px;\n  line-height: 40px;\n  margin-bottom: 0;\n}\n.nav-tabs>li>button {\n  display: block;\n  width: 100%;\n  line-height: inherit;\n  margin: 0;\n  height: inherit;\n  padding: 0 10px 0 10px;\n  outline: none;\n}\n.nav-tabs>li>button:after {\n  background-color: transparent;\n  bottom: -3px;\n  content: ' ';\n  display: block;\n  height: 3px;\n  width: 100%;\n}\n.nav-tabs>li>button,\n.nav-tabs>li.active>button,\n.nav-tabs>li>button:hover,\n.nav-tabs>li.active>button:hover,\n.nav-tabs>li>button:active,\n.nav-tabs>li.active>button:active,\n.nav-tabs>li>button:focus,\n.nav-tabs>li.active>button:focus {\n  color: var(--active-color);\n  background-color: transparent;\n  border: 0;\n}\n.nav-tabs>li.active>button {\n  font-weight: bold;\n}\n.nav-tabs>li.active>button:after {\n  background-color: var(--active-color);\n}\n.nav {\n  padding-left: 0;\n  list-style: none;\n}\n.nav > li {\n  position: relative;\n  display: block;\n}\n.nav > li {\n  float: left;\n  margin-bottom: -1px;\n}\n.form-themed .state-error.wrapperLabel input + .wrapperText,\n.state-error.wrapperLabel input + .wrapperText {\n  color: var(--state-error-text);\n}\n.form-themed .state-error+.tooltip .tooltip-inner,\n.state-error+.tooltip .tooltip-inner {\n  color: #fff;\n  background-color: var(--state-error-border);\n}\n.form-themed .state-error+.tooltip.top .tooltip-arrow,\n.state-error+.tooltip.top .tooltip-arrow {\n  border-top-color: var(--state-error-border);\n}\n.form-themed .state-error+.tooltip.right .tooltip-arrow,\n.state-error+.tooltip.right .tooltip-arrow {\n  border-right-color: var(--state-error-border);\n}\n.form-themed .state-error+.tooltip.bottom .tooltip-arrow,\n.state-error+.tooltip.bottom .tooltip-arrow {\n  border-bottom-color: var(--state-error-border);\n}\n.form-themed .state-error+.tooltip.left .tooltip-arrow,\n.state-error+.tooltip.left .tooltip-arrow {\n  border-left-color: var(--state-error-border);\n}\n.form-themed .state-error:not(.component-group).form-control,\n.state-error:not(.component-group).form-control,\n.form-themed .state-error:not(.component-group) .form-control,\n.state-error:not(.component-group) .form-control {\n  background-color: var(--state-error-border);\n  border-color: var(--state-error-border);\n}\n* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.modal-body {\n  overflow: hidden;\n}\n.errorMessage {\n  color: var(--state-error-text);\n  font-size: 10px;\n  text-transform: uppercase;\n}\n.form-content {\n  border-bottom: 3px solid var(--primary-background-color);\n  margin-bottom: 20px;\n  margin-left: -22px;\n  margin-right: -22px;\n  max-height: 70vh;\n  overflow-y: auto;\n  padding: 22px;\n  min-height: 500px;\n}\n.popover {\n  width: 300px;\n}\n";
styleInject(css$m);

var UserPreferences =
/*#__PURE__*/
function (_Component) {
  inherits(UserPreferences, _Component);

  function UserPreferences() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, UserPreferences);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(UserPreferences)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      tabIndex: 0
    });
    return _this;
  }

  createClass(UserPreferences, [{
    key: "tabClick",
    value: function tabClick(tabIndex) {
      this.setState({
        tabIndex: tabIndex
      });
    }
  }, {
    key: "renderHotkeysTab",
    value: function renderHotkeysTab() {
      return React__default.createElement("form", {
        className: "form-themed themed"
      }, React__default.createElement("div", {
        className: "form-content"
      }, React__default.createElement(HotKeysPreferences, {
        hotKeysData: this.props.hotKeysData
      })));
    }
  }, {
    key: "renderWindowLevelTab",
    value: function renderWindowLevelTab() {
      if (this.props.windowLevelData) {
        return React__default.createElement("form", {
          className: "form-themed themed"
        }, React__default.createElement("div", {
          className: "form-content"
        }, React__default.createElement(WindowLevelPreferences, {
          windowLevelData: this.props.windowLevelData
        })));
      }
    }
  }, {
    key: "renderGeneralTab",
    value: function renderGeneralTab() {
      return React__default.createElement("form", {
        className: "form-themed themed"
      }, React__default.createElement("div", {
        className: "form-content"
      }, React__default.createElement(GeneralPreferences, {
        generalData: this.props.generalData
      })));
    }
  }, {
    key: "renderTabs",
    value: function renderTabs(tabIndex) {
      switch (tabIndex) {
        case 0:
          return this.renderHotkeysTab();

        case 1:
          return this.renderWindowLevelTab();

        case 2:
          return this.renderGeneralTab();

        default:
          break;
      }
    }
  }, {
    key: "getTabClass",
    value: function getTabClass(tabIndex) {
      return tabIndex === this.state.tabIndex ? 'nav-link active' : 'nav-link';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement("div", null, React__default.createElement("div", {
        className: "dialog-separator-after"
      }, React__default.createElement("ul", {
        className: "nav nav-tabs"
      }, React__default.createElement("li", {
        onClick: function onClick() {
          _this2.tabClick(0);
        },
        className: this.getTabClass(0)
      }, React__default.createElement("button", null, "Hotkeys")), React__default.createElement("li", {
        onClick: function onClick() {
          _this2.tabClick(1);
        },
        className: this.getTabClass(1)
      }, React__default.createElement("button", null, "Window Level")), React__default.createElement("li", {
        onClick: function onClick() {
          _this2.tabClick(2);
        },
        className: this.getTabClass(2)
      }, React__default.createElement("button", null, "General")))), this.renderTabs(this.state.tabIndex));
    }
  }]);
  return UserPreferences;
}(Component);

defineProperty(UserPreferences, "defaultProps", {
  hotKeysData: {},
  windowLevelData: {},
  generalData: {}
});
defineProperty(UserPreferences, "propTypes", {
  hotKeysData: propTypes.object.isRequired,
  windowLevelData: propTypes.object.isRequired,
  generalData: propTypes.object.isRequired
});
var PropTypes = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var timeoutsShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number,
    appear: _propTypes.default.number
  }).isRequired]) : null;
  exports.timeoutsShape = timeoutsShape;
  var classNamesShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    enter: _propTypes.default.string,
    exit: _propTypes.default.string,
    active: _propTypes.default.string
  }), _propTypes.default.shape({
    enter: _propTypes.default.string,
    enterDone: _propTypes.default.string,
    enterActive: _propTypes.default.string,
    exit: _propTypes.default.string,
    exitDone: _propTypes.default.string,
    exitActive: _propTypes.default.string
  })]) : null;
  exports.classNamesShape = classNamesShape;
});
unwrapExports(PropTypes);
var PropTypes_1 = PropTypes.classNamesShape;
var PropTypes_2 = PropTypes.timeoutsShape;
var Transition_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

  var PropTypes$$1 = _interopRequireWildcard(propTypes$1);

  var _react = _interopRequireDefault(React__default);

  var _reactDom = _interopRequireDefault(ReactDOM__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  var UNMOUNTED = 'unmounted';
  exports.UNMOUNTED = UNMOUNTED;
  var EXITED = 'exited';
  exports.EXITED = EXITED;
  var ENTERING = 'entering';
  exports.ENTERING = ENTERING;
  var ENTERED = 'entered';
  exports.ENTERED = ENTERED;
  var EXITING = 'exiting';
  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * ---
   *
   * **Note**: `Transition` is a platform-agnostic base component. If you're using
   * transitions in CSS, you'll probably want to use
   * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
   * instead. It inherits all the features of `Transition`, but contains
   * additional features necessary to play nice with CSS transitions (hence the
   * name of the component).
   *
   * ---
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the
   * components. It's up to you to give meaning and effect to those states. For
   * example we can add styles to a component when it enters or exits:
   *
   * ```jsx
   * import { Transition } from 'react-transition-group';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {state => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm a fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * There are 4 main states a Transition can be in:
   *  - `'entering'`
   *  - `'entered'`
   *  - `'exiting'`
   *  - `'exited'`
   *
   * Transition state is toggled via the `in` prop. When `true` the component
   * begins the "Enter" stage. During this stage, the component will shift from
   * its current transition state, to `'entering'` for the duration of the
   * transition and then to the `'entered'` stage once it's complete. Let's take
   * the following example (we'll use the
   * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
   *
   * ```jsx
   * function App() {
   *   const [inProp, setInProp] = useState(false);
   *   return (
   *     <div>
   *       <Transition in={inProp} timeout={500}>
   *         {state => (
   *           // ...
   *         )}
   *       </Transition>
   *       <button onClick={() => setInProp(true)}>
   *         Click to Enter
   *       </button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state
   * and stay there for 500ms (the value of `timeout`) before it finally switches
   * to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from
   * `'exiting'` to `'exited'`.
   */

  exports.EXITING = EXITING;

  var Transition =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(Transition, _React$Component);

    function Transition(props, context) {
      var _this;

      _this = _React$Component.call(this, props, context) || this;
      var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
      var initialStatus;
      _this.appearStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.appearStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = {
        status: initialStatus
      };
      _this.nextCallback = null;
      return _this;
    }

    var _proto = Transition.prototype;

    _proto.getChildContext = function getChildContext() {
      return {
        transitionGroup: null // allows for nested Transitions

      };
    };

    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
      var nextIn = _ref.in;

      if (nextIn && prevState.status === UNMOUNTED) {
        return {
          status: EXITED
        };
      }

      return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }


    _proto.componentDidMount = function componentDidMount() {
      this.updateStatus(true, this.appearStatus);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var nextStatus = null;

      if (prevProps !== this.props) {
        var status = this.state.status;

        if (this.props.in) {
          if (status !== ENTERING && status !== ENTERED) {
            nextStatus = ENTERING;
          }
        } else {
          if (status === ENTERING || status === ENTERED) {
            nextStatus = EXITING;
          }
        }
      }

      this.updateStatus(false, nextStatus);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    _proto.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;
      var exit, enter, appear;
      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter; // TODO: remove fallback for next major

        appear = timeout.appear !== undefined ? timeout.appear : enter;
      }

      return {
        exit: exit,
        enter: enter,
        appear: appear
      };
    };

    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
      if (mounting === void 0) {
        mounting = false;
      }

      if (nextStatus !== null) {
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();

        var node = _reactDom.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({
          status: UNMOUNTED
        });
      }
    };

    _proto.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;
      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
      var timeouts = this.getTimeouts();
      var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set

      if (!mounting && !enter) {
        this.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);
      this.safeSetState({
        status: ENTERING
      }, function () {
        _this2.props.onEntering(node, appearing);

        _this2.onTransitionEnd(node, enterTimeout, function () {
          _this2.safeSetState({
            status: ENTERED
          }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    _proto.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;
      var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

      if (!exit) {
        this.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
        return;
      }

      this.props.onExit(node);
      this.safeSetState({
        status: EXITING
      }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({
            status: EXITED
          }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    _proto.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    _proto.safeSetState = function safeSetState(nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, callback);
    };

    _proto.setNextCallback = function setNextCallback(callback) {
      var _this4 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this4.nextCallback = null;
          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);
      var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

      if (!node || doesNotHaveTimeoutOrListener) {
        setTimeout(this.nextCallback, 0);
        return;
      }

      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    };

    _proto.render = function render() {
      var status = this.state.status;

      if (status === UNMOUNTED) {
        return null;
      }

      var _this$props = this.props,
          children = _this$props.children,
          childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react.default.Children.only(children);

      return _react.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };
  Transition.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * A `function` child can be used instead of a React element. This function is
     * called with the current transition status (`'entering'`, `'entered'`,
     * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
     * specific props to a component.
     *
     * ```jsx
     * <Transition in={this.state.in} timeout={150}>
     *   {state => (
     *     <MyComponent className={`fade fade-${state}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEndListener` is provided.
     *
     * You may specify a single timeout for all transitions:
     *
     * ```jsx
     * timeout={500}
     * ```
     *
     * or individually:
     *
     * ```jsx
     * timeout={{
     *  appear: 500,
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * - `appear` defaults to the value of `enter`
     * - `enter` defaults to `0`
     * - `exit` defaults to `0`
     *
     * @type {number | { enter?: number, exit?: number, appear?: number }}
     */
    timeout: function timeout(props) {
      var pt = PropTypes.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return pt.apply(void 0, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func // Name the function so it is clearer in the documentation

  } : {};

  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
  };
  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  var _default = (0, reactLifecyclesCompat_es.polyfill)(Transition);

  exports.default = _default;
});
unwrapExports(Transition_1);
var Transition_2 = Transition_1.EXITING;
var Transition_3 = Transition_1.ENTERED;
var Transition_4 = Transition_1.ENTERING;
var Transition_5 = Transition_1.EXITED;
var Transition_6 = Transition_1.UNMOUNTED;
var Fade_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _fadeStyles;

  var _react2 = _interopRequireDefault(React__default);

  var _Transition2 = _interopRequireDefault(Transition_1);

  var _classnames2 = _interopRequireDefault(classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var fadeStyles = (_fadeStyles = {}, _fadeStyles[Transition_1.ENTERING] = 'in', _fadeStyles[Transition_1.ENTERED] = 'in', _fadeStyles);

  var Fade = function (_React$Component) {
    _inherits(Fade, _React$Component);

    function Fade(props, context) {
      _classCallCheck(this, Fade);

      return _possibleConstructorReturn(this, _React$Component.call(this, props, context));
    }

    Fade.prototype.render = function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['className', 'children']);

      return _react2.default.createElement(_Transition2.default, props, function (status, innerProps) {
        return _react2.default.cloneElement(children, _extends({}, innerProps, {
          className: (0, _classnames2.default)('fade', className, children.props.className, fadeStyles[status])
        }));
      });
    };

    return Fade;
  }(_react2.default.Component);

  exports.default = Fade;
  module.exports = exports['default'];
});
unwrapExports(Fade_1);
var Body = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _classnames2 = _interopRequireDefault(classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ModalBody = function (_React$Component) {
    _inherits(ModalBody, _React$Component);

    function ModalBody() {
      _classCallCheck(this, ModalBody);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    ModalBody.getDefaultPrefix = function getDefaultPrefix() {
      return 'modal';
    };

    ModalBody.prototype.render = function render() {
      var _props = this.props,
          modalPrefix = _props.modalPrefix,
          children = _props.children,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['modalPrefix', 'children', 'className']);

      var prefix = modalPrefix || ModalBody.getDefaultPrefix();
      return _react2.default.createElement('div', _extends({}, props, {
        className: (0, _classnames2.default)(className, prefix + '-body')
      }), children);
    };

    return ModalBody;
  }(_react2.default.Component);

  ModalBody.propTypes = {
    /**
     * A css class applied to the Component
     */
    modalPrefix: _propTypes2.default.string
  };
  exports.default = ModalBody;
  module.exports = exports['default'];
});
unwrapExports(Body);
var Dismiss_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var chain = function chain(a, b) {
    return function () {
      a && a.apply(undefined, arguments);
      b && b.apply(undefined, arguments);
    };
  };

  var Dismiss = function (_React$Component) {
    _inherits(Dismiss, _React$Component);

    function Dismiss() {
      _classCallCheck(this, Dismiss);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    Dismiss.prototype.render = function render() {
      var _props = this.props,
          Tag = _props.component,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['component', 'children']);

      return _react2.default.createElement(Tag, _extends({}, props, {
        onClick: chain(props.onClick, this.context.onModalHide)
      }), children);
    };

    return Dismiss;
  }(_react2.default.Component);

  Dismiss.propTypes = {
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
  };
  Dismiss.defaultProps = {
    component: 'button'
  };
  Dismiss.contextTypes = {
    onModalHide: _propTypes2.default.func
  };
  exports.default = Dismiss;
  module.exports = exports['default'];
});
unwrapExports(Dismiss_1);
var Header = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _classnames2 = _interopRequireDefault(classnames);

  var _Dismiss2 = _interopRequireDefault(Dismiss_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ModalHeader = function (_React$Component) {
    _inherits(ModalHeader, _React$Component);

    function ModalHeader() {
      _classCallCheck(this, ModalHeader);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    ModalHeader.getDefaultPrefix = function getDefaultPrefix() {
      return 'modal';
    };

    ModalHeader.prototype.render = function render() {
      var _props = this.props,
          modalPrefix = _props.modalPrefix,
          closeButton = _props.closeButton,
          children = _props.children,
          className = _props.className,
          label = _props['aria-label'],
          props = _objectWithoutProperties(_props, ['modalPrefix', 'closeButton', 'children', 'className', 'aria-label']);

      var prefix = modalPrefix || ModalHeader.getDefaultPrefix();
      return _react2.default.createElement('div', _extends({}, props, {
        className: (0, _classnames2.default)(className, prefix + '-header')
      }), closeButton && _react2.default.createElement(_Dismiss2.default, {
        className: 'close',
        'aria-label': label
      }, _react2.default.createElement('span', {
        'aria-hidden': 'true'
      }, '\xD7')), children);
    };

    return ModalHeader;
  }(_react2.default.Component);

  ModalHeader._isModalHeader = true;
  ModalHeader.propTypes = {
    closeButton: _propTypes2.default.bool,

    /**
     * A css class applied to the Component
     */
    modalPrefix: _propTypes2.default.string,
    'aria-label': _propTypes2.default.string
  };
  ModalHeader.defaultProps = {
    closeButton: false,
    'aria-label': 'Close Modal'
  };
  ModalHeader.contextTypes = {
    onModalHide: _propTypes2.default.func
  };
  exports.default = ModalHeader;
  module.exports = exports['default'];
});
unwrapExports(Header);
var Title = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _classnames2 = _interopRequireDefault(classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ModalTitle = function (_React$Component) {
    _inherits(ModalTitle, _React$Component);

    function ModalTitle() {
      _classCallCheck(this, ModalTitle);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    ModalTitle.getDefaultPrefix = function getDefaultPrefix() {
      return 'modal';
    };

    ModalTitle.prototype.render = function render() {
      var _props = this.props,
          modalPrefix = _props.modalPrefix,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['modalPrefix', 'className']);

      var prefix = modalPrefix || ModalTitle.getDefaultPrefix();
      return _react2.default.createElement('h4', _extends({}, props, {
        className: (0, _classnames2.default)(className, prefix + '-title')
      }));
    };

    return ModalTitle;
  }(_react2.default.Component);

  ModalTitle.propTypes = {
    /**
     * A css class applied to the Component
     */
    modalPrefix: _propTypes2.default.string
  };
  exports.default = ModalTitle;
  module.exports = exports['default'];
});
unwrapExports(Title);
var Footer = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _classnames2 = _interopRequireDefault(classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ModalFooter = function (_React$Component) {
    _inherits(ModalFooter, _React$Component);

    function ModalFooter() {
      _classCallCheck(this, ModalFooter);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    ModalFooter.getDefaultPrefix = function getDefaultPrefix() {
      return 'modal';
    };

    ModalFooter.prototype.render = function render() {
      var _props = this.props,
          modalPrefix = _props.modalPrefix,
          children = _props.children,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['modalPrefix', 'children', 'className']);

      var prefix = modalPrefix || ModalFooter.getDefaultPrefix();
      return _react2.default.createElement('div', _extends({}, props, {
        className: (0, _classnames2.default)(className, prefix + '-footer')
      }), children);
    };

    return ModalFooter;
  }(_react2.default.Component);

  ModalFooter.propTypes = {
    /**
     * A css class applied to the Component
     */
    modalPrefix: _propTypes2.default.string
  };
  exports.default = ModalFooter;
  module.exports = exports['default'];
});
unwrapExports(Footer);
var Modal_1$2 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _react2 = _interopRequireDefault(React__default);

  var _componentOrElement2 = _interopRequireDefault(componentOrElement);

  var _Modal2 = _interopRequireDefault(Modal_1$1);

  var _isOverflowing2 = _interopRequireDefault(isOverflowing_1);

  var _Fade2 = _interopRequireDefault(Fade_1);

  var _Body2 = _interopRequireDefault(Body);

  var _Header2 = _interopRequireDefault(Header);

  var _Title2 = _interopRequireDefault(Title);

  var _Footer2 = _interopRequireDefault(Footer);

  var _Dismiss2 = _interopRequireDefault(Dismiss_1);

  var _ownerDocument2 = _interopRequireDefault(ownerDocument_1);

  var _inDOM2 = _interopRequireDefault(inDOM);

  var _scrollbarSize2 = _interopRequireDefault(scrollbarSize_1);

  var _style2 = _interopRequireDefault(style_1);

  var _classnames2 = _interopRequireDefault(classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var baseIndex = {};
  var PREFIX = 'modal';
  var getZIndex = void 0;

  var omit = function omit(obj, keys) {
    return Object.keys(obj).reduce(function (o, key) {
      if (keys.indexOf(key) === -1) o[key] = obj[key];
      return o;
    }, {});
  };

  function DialogTransition(props) {
    return _react2.default.createElement(_Fade2.default, _extends({}, props, {
      timeout: Modal.TRANSITION_DURATION
    }));
  }

  function BackdropTransition(props) {
    return _react2.default.createElement(_Fade2.default, _extends({}, props, {
      timeout: Modal.BACKDROP_TRANSITION_DURATION
    }));
  }

  var Modal = function (_React$Component) {
    _inherits(Modal, _React$Component);

    Modal.getDefaultPrefix = function getDefaultPrefix() {
      return PREFIX;
    };

    Modal.prototype.getChildContext = function getChildContext() {
      return this._context || (this._context = {
        onModalHide: this.props.onHide
      });
    };

    function Modal() {
      _classCallCheck(this, Modal);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this));

      _this.handleEntering = _this.handleEntering.bind(_this);
      _this.handleExiting = _this.handleExiting.bind(_this);
      _this.state = {
        classes: ''
      };
      return _this;
    }

    Modal.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      getZIndex = getZIndex || function () {
        var modal = document.createElement('div'),
            backdrop = document.createElement('div'),
            zIndexFactor = void 0;
        modal.className = 'modal hide';
        backdrop.className = 'modal-backdrop hide';
        document.body.appendChild(modal);
        document.body.appendChild(backdrop);
        baseIndex.modal = +(0, _style2.default)(modal, 'z-index');
        baseIndex.backdrop = +(0, _style2.default)(backdrop, 'z-index');
        zIndexFactor = baseIndex.modal - baseIndex.backdrop;
        document.body.removeChild(modal);
        document.body.removeChild(backdrop);
        return function (type) {
          return baseIndex[type] + zIndexFactor * (_this2.props.manager.modals.length - 1);
        };
      }();
    };

    Modal.prototype.handleEntering = function handleEntering() {
      this._show.apply(this, arguments);

      if (this.props.onEntering) {
        this.props.onEntering();
      }
    };

    Modal.prototype.handleExiting = function handleExiting() {
      this._removeAttentionClasses();

      if (this.props.onExiting) {
        this.props.onExiting();
      }
    };

    Modal.prototype.render = function render() {
      var _this3 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          keyboard = _props.keyboard,
          transition = _props.transition,
          modalPrefix = _props.modalPrefix,
          dialogClassName = _props.dialogClassName,
          container = _props.container,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onExit = _props.onExit,
          onExited = _props.onExited,
          props = _objectWithoutProperties(_props, ['className', 'children', 'keyboard', 'transition', 'modalPrefix', 'dialogClassName', 'container', 'onEnter', 'onEntered', 'onExit', 'onExited']);

      var _state = this.state,
          dialog = _state.dialog,
          classes = _state.classes,
          backdrop = _state.backdrop;
      delete props.manager;
      var elementProps = omit(props, Object.keys(Modal.propTypes));
      var prefix = modalPrefix || Modal.getDefaultPrefix();
      if (transition === true) transition = DialogTransition;

      var modal = _react2.default.createElement('div', _extends({}, elementProps, {
        ref: function ref(r) {
          return _this3.dialog = r;
        },
        style: dialog,
        className: (0, _classnames2.default)(className, prefix, {
          in: props.show && !transition
        }),
        onClick: this.props.backdrop ? function (e) {
          return _this3.handleBackdropClick(e);
        } : null
      }), _react2.default.createElement('div', {
        key: 'modal',
        ref: function ref(r) {
          return _this3.innerRef = r;
        },
        className: (0, _classnames2.default)(prefix + '-dialog', dialogClassName, classes, (props.small || props.sm) && prefix + '-sm', (props.large || props.lg) && prefix + '-lg')
      }, _react2.default.createElement('div', {
        className: prefix + '-content'
      }, children)));

      return _react2.default.createElement(_Modal2.default, {
        keyboard: keyboard,
        ref: function ref(_ref) {
          _this3.modal = _ref && _ref.modal;
          _this3.backdrop = _ref && _ref.backdrop;
        },
        container: container,
        backdrop: props.backdrop,
        show: props.show,
        backdropStyle: backdrop,
        backdropClassName: prefix + '-backdrop',
        containerClassName: prefix + '-open',
        transition: transition || undefined,
        backdropTransition: transition ? BackdropTransition : undefined,
        onHide: this.props.onHide,
        onEnter: onEnter,
        onEntering: this.handleEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: this.handleExiting,
        onExited: onExited
      }, modal);
    };

    Modal.prototype.attention = function attention() {
      var _this4 = this;

      var attentionClass = this.props.attentionClass;
      if (attentionClass) this.setState({
        classes: ''
      }, function () {
        if (_this4.props.show) {
          // eslint-disable-next-line no-unused-expressions
          _this4.innerRef.offsetWidth;

          _this4.setState({
            classes: attentionClass + ' animated'
          });
        }
      });
    };

    Modal.prototype.handleBackdropClick = function handleBackdropClick(e) {
      if (e.target !== e.currentTarget) return;
      if (this.props.backdrop === 'static') return this.attention();
      this.props.onHide();
    };

    Modal.prototype._show = function _show() {
      if (this.props.show) this.setState(this._getStyles());
    };

    Modal.prototype._getStyles = function _getStyles() {
      if (!_inDOM2.default) return {};
      var node = (0, ReactDOM__default.findDOMNode)(this.dialog),
          doc = (0, _ownerDocument2.default)(node),
          scrollHt = node.scrollHeight,
          bodyIsOverflowing = (0, _isOverflowing2.default)(this.props.container || doc.body),
          modalIsOverflowing = scrollHt > doc.documentElement.clientHeight;
      return {
        dialog: {
          zIndex: getZIndex('modal'),
          paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : void 0,
          paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : void 0
        },
        backdrop: {
          zIndex: getZIndex('backdrop')
        }
      };
    };

    Modal.prototype._removeAttentionClasses = function _removeAttentionClasses() {
      this.setState({
        classes: ''
      });
    };

    return Modal;
  }(_react2.default.Component);

  Modal.propTypes = {
    show: _propTypes2.default.bool,

    /** sizes **/
    small: _propTypes2.default.bool,
    sm: _propTypes2.default.bool,
    large: _propTypes2.default.bool,
    lg: _propTypes2.default.bool,

    /** --- **/
    backdrop: _propTypes2.default.oneOf(['static', true, false]),
    keyboard: _propTypes2.default.bool,
    animate: _propTypes2.default.bool,
    transition: _propTypes2.default.any,
    container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
    onHide: _propTypes2.default.func,
    onEnter: _propTypes2.default.func,
    onEntering: _propTypes2.default.func,
    onEntered: _propTypes2.default.func,
    onExit: _propTypes2.default.func,
    onExiting: _propTypes2.default.func,
    onExited: _propTypes2.default.func,
    modalPrefix: _propTypes2.default.string,
    dialogClassName: _propTypes2.default.string,
    attentionClass: _propTypes2.default.string
  };
  Modal.defaultProps = {
    backdrop: true,
    keyboard: true,
    animate: true,
    transition: true,
    container: _inDOM2.default ? document.body : null,
    attentionClass: 'shake',
    manager: (_Modal2.default.getDefaultProps ? _Modal2.default.getDefaultProps() : _Modal2.default.defaultProps).manager
  };
  Modal.childContextTypes = {
    onModalHide: _propTypes2.default.func
  };

  Modal.injectCSSPrefix = function (prefix) {
    PREFIX = prefix;
  };

  function getDefaultPrefix() {
    return PREFIX;
  }

  _Body2.default.getDefaultPrefix = getDefaultPrefix;
  _Header2.default.getDefaultPrefix = getDefaultPrefix;
  _Title2.default.getDefaultPrefix = getDefaultPrefix;
  _Footer2.default.getDefaultPrefix = getDefaultPrefix;
  Modal.Body = _Body2.default;
  Modal.Header = _Header2.default;
  Modal.Title = _Title2.default;
  Modal.Footer = _Footer2.default;
  Modal.Dismiss = _Dismiss2.default;
  Modal.BaseModal = Modal;
  Modal.TRANSITION_DURATION = 300;
  Modal.BACKDROP_TRANSITION_DURATION = 150;
  exports.default = Modal;
  module.exports = exports['default'];
});
var Modal$2 = unwrapExports(Modal_1$2);
var css$n = ".btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.btn.disabled,\n.btn[disabled],\nfieldset[disabled] .btn {\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.65;\n}\nbutton.close {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.table-responsive {\n  min-height: 0.01%;\n  overflow-x: auto;\n}\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n}\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\nth {\n  text-align: left;\n}\n.AboutModal .btn {\n  border-color: #ccc;\n}\n.AboutModal .table thead:first-child tr:first-child th,\n.AboutModal .table thead:first-child tr:first-child td {\n  border-top: 0;\n}\n.AboutModal .table thead tr th,\n.AboutModal .table tbody tr th,\n.AboutModal .table tfoot tr th,\n.AboutModal .table thead tr td,\n.AboutModal .table tbody tr td,\n.AboutModal .table tfoot tr td {\n  padding: 8px;\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n";
styleInject(css$n);
var css$o = "/* Licensed MIT; Copyright (c) 2011-2014 Twitter, Inc <https://github.com/twbs/bootstrap/blob/master/LICENSE> */\n/* Licensed MIT; Copyright (c) 2011-2014 Twitter, Inc <https://github.com/twbs/bootstrap/blob/master/LICENSE> */\n/*\nAnimate.css - http://daneden.me/animate\nLicensed under the ☺ license (http://licence.visualidiot.com/)\nCopyright (c) 2012 Dan Eden*/\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n@-webkit-keyframes shake {\n  0%,\n  100% {\n    -webkit-transform: translateX(0);\n  }\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translateX(-10px);\n  }\n  20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translateX(10px);\n  }\n}\n@keyframes shake {\n  0%,\n  100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translateX(-10px);\n            transform: translateX(-10px);\n  }\n  20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translateX(10px);\n            transform: translateX(10px);\n  }\n}\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n.modal {\n  display: block;\n}\n.modal-content > .close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n@media (min-width: 768px) {\n  .modal-sm > .modal-dialog {\n    width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg > .modal-dialog {\n    width: 900px;\n  }\n}\n";
styleInject(css$o);
var css$p = ".modal-open {\n  overflow: hidden;\n}\n.modal {\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal .modal-dialog .modal-content {\n  background-color: var(--ui-gray-darker);\n  border-color: var(--ui-border-color);\n  color: var(--text-secondary-color);\n  border: 0;\n}\n.modal .modal-dialog .modal-content .modal-header,\n.modal .modal-dialog .modal-content .modal-footer {\n  border-color: var(--ui-border-color);\n}\n.modal .modal-dialog .modal-content .dialog-separator,\n.modal .modal-dialog .modal-content .dialog-separator-before,\n.modal .modal-dialog .modal-content .dialog-separator-after {\n  position: relative;\n  height: 40px;\n}\n.modal .modal-dialog .modal-content .dialog-separator:before,\n.modal .modal-dialog .modal-content .dialog-separator:after,\n.modal .modal-dialog .modal-content .dialog-separator-before:before,\n.modal .modal-dialog .modal-content .dialog-separator-after:after {\n  background-color: #000;\n  content: ' ';\n  display: block;\n  height: 3px;\n  left: 0;\n  position: absolute;\n  width: 100%;\n}\n.modal .modal-dialog .modal-content .dialog-separator:before,\n.modal .modal-dialog .modal-content .dialog-separator-before:before {\n  top: -3px;\n}\n.modal .modal-dialog .modal-content .dialog-separator:after,\n.modal .modal-dialog .modal-content .dialog-separator-after:after {\n  bottom: -3px;\n}\n.modal .modal-dialog .modal-content .modal-body {\n  color: var(--text-primary-color);\n  padding: 16px 22px 0px;\n  position: relative;\n}\n.modal .modal-dialog .modal-content .modal-body ::-webkit-scrollbar {\n  width: 6px;\n  background-color: var(--ui-gray-dark);\n}\n.modal .modal-dialog .modal-content .modal-body ::-webkit-scrollbar-thumb {\n  background-color: var(--ui-gray-light);\n  border-radius: 5px;\n}\n.modal .modal-dialog .modal-content .modal-header {\n  border-bottom-width: 3px;\n  border-bottom-style: solid;\n  border-bottom-color: #000;\n  padding: 19px 22px 17px;\n  position: relative;\n}\n.modal .modal-dialog .modal-content .modal-header h4 {\n  color: var(--text-secondary-color);\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 24px;\n  padding-right: 24px;\n}\n.modal .modal-dialog .modal-content .modal-footer {\n  border-top: 0;\n  padding-top: 0;\n}\n.modal .modal-dialog .card-round {\n  background-color: var(--ui-gray-dark);\n  padding: 10px;\n}\n.modal .modal-dialog .modal-header {\n  position: relative;\n}\n.modal.fade .modal-dialog {\n  -webkit-transition: transform 0.3s ease-out;\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n  -webkit-transform: translate(0, -25%);\n  transform: translate(0, -25%);\n}\n.modal.in .modal-dialog {\n  -webkit-transform: translate(0, 0);\n          transform: translate(0, 0);\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,0.2);\n  border-radius: 6px;\n  box-shadow: 0 3px 9px rgba(0,0,0,0.5);\n  background-clip: padding-box;\n  outline: 0;\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  background-color: #fff;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.in {\n  opacity: 0;\n}\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.modal-header .close {\n  margin-top: -2px;\n}\n.modal-title {\n  margin: 0;\n  line-height: 1.42857143;\n}\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n}\n.modal-footer .btn+.btn {\n  margin-left: 5px;\n  margin-bottom: 0;\n}\n.modal-footer .btn-group .btn+.btn {\n  margin-left: -1px;\n}\n.modal-footer .btn-block+.btn-block {\n  margin-left: 0;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n  }\n  .modal-content {\n    box-shadow: 0 5px 15px rgba(0,0,0,0.5);\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg {\n    width: 900px;\n  }\n}\n.button-close,\n.modal-dialog button.close {\n  color: var(--text-secondary-color);\n  height: 25px;\n  opacity: 1;\n  overflow: hidden;\n  text-align: center;\n  text-shadow: none;\n  width: 25px;\n  font-size: 25px;\n  font-weight: lighter;\n}\n";
styleInject(css$p);

var AboutModal =
/*#__PURE__*/
function (_Component) {
  inherits(AboutModal, _Component);

  function AboutModal(props) {
    classCallCheck(this, AboutModal);
    return possibleConstructorReturn(this, getPrototypeOf(AboutModal).call(this, props));
  } // TODO: Make this component more generic to allow things other than W/L and hotkeys...


  createClass(AboutModal, [{
    key: "renderTableRow",
    value: function renderTableRow(item) {
      return React__default.createElement("tr", {
        key: item.name
      }, React__default.createElement("td", null, item.name), React__default.createElement("td", null, React__default.createElement("a", {
        target: "_blank",
        href: item.value
      }, item.value)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return React__default.createElement(Modal$2, {
        show: this.props.isOpen,
        onHide: this.props.onCancel,
        "aria-labelledby": "ModalHeader",
        className: "AboutModal modal fade themed in",
        backdrop: false,
        large: true,
        keyboard: false
      }, React__default.createElement(Modal$2.Header, {
        closeButton: true
      }, React__default.createElement(Modal$2.Title, null, "About")), React__default.createElement(Modal$2.Body, null, React__default.createElement("div", {
        className: "btn-group"
      }, React__default.createElement("a", {
        className: "btn btn-default",
        target: "_blank",
        href: "https://groups.google.com/forum/#!forum/cornerstone-platform"
      }, "Visit the forum"), React__default.createElement("a", {
        className: "btn btn-default",
        target: "_blank",
        href: "https://github.com/OHIF/Viewers/issues"
      }, "Report an issue"), React__default.createElement("a", {
        className: "btn btn-default",
        target: "_blank",
        href: "http://ohif.org"
      }, "More details")), React__default.createElement("div", null, React__default.createElement("h3", null, "Version Information"), React__default.createElement("table", {
        className: "table table-responsive"
      }, React__default.createElement("thead", null, React__default.createElement("tr", null, React__default.createElement("th", null, "Name"), React__default.createElement("th", null, "Value"))), React__default.createElement("tbody", null, AboutModal.itemsPreset.map(function (item) {
        return _this.renderTableRow(item);
      }))))));
    }
  }]);
  return AboutModal;
}(Component);

defineProperty(AboutModal, "propTypes", {
  isOpen: propTypes.bool.isRequired,
  onCancel: propTypes.func
});
defineProperty(AboutModal, "itemsPreset", [{
  name: 'Repository URL',
  value: 'https://github.com/OHIF/Viewers/'
}, {
  name: 'Latest Master Commits',
  value: 'https://github.com/OHIF/Viewers/commits/master'
}]);
defineProperty(AboutModal, "defaultProps", {
  isOpen: false
});
var css$q = ".nav-tabs {\n  border-bottom: 0;\n  margin-bottom: 3px;\n  position: relative;\n  z-index: 1;\n}\n.nav-tabs :hover {\n  cursor: pointer;\n}\n.nav-tabs>li {\n  font-size: 14px;\n  font-weight: normal;\n  height: 40px;\n  line-height: 40px;\n  margin-bottom: 0;\n}\n.nav-tabs>li>button {\n  display: block;\n  width: 100%;\n  line-height: inherit;\n  margin: 0;\n  height: inherit;\n  padding: 0 10px 0 10px;\n  outline: none;\n}\n.nav-tabs>li>button:after {\n  background-color: transparent;\n  bottom: -3px;\n  content: ' ';\n  display: block;\n  height: 3px;\n  width: 100%;\n}\n.nav-tabs>li>button,\n.nav-tabs>li.active>button,\n.nav-tabs>li>button:hover,\n.nav-tabs>li.active>button:hover,\n.nav-tabs>li>button:active,\n.nav-tabs>li.active>button:active,\n.nav-tabs>li>button:focus,\n.nav-tabs>li.active>button:focus {\n  color: var(--active-color);\n  background-color: transparent;\n  border: 0;\n}\n.nav-tabs>li.active>button {\n  font-weight: bold;\n}\n.nav-tabs>li.active>button:after {\n  background-color: var(--active-color);\n}\n.nav {\n  padding-left: 0;\n  list-style: none;\n}\n.nav > li {\n  position: relative;\n  display: block;\n}\n.nav > li {\n  float: left;\n  margin-bottom: -1px;\n}\n* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.modal-open {\n  overflow: hidden;\n}\n.modal {\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal .modal-dialog .modal-content {\n  background-color: var(--ui-gray-darker);\n  border-color: var(--ui-border-color);\n  color: var(--text-secondary-color);\n  border: 0;\n}\n.modal .modal-dialog .modal-content .modal-header,\n.modal .modal-dialog .modal-content .modal-footer {\n  border-color: var(--ui-border-color);\n}\n.modal .modal-dialog .modal-content .dialog-separator,\n.modal .modal-dialog .modal-content .dialog-separator-before,\n.modal .modal-dialog .modal-content .dialog-separator-after {\n  position: relative;\n  height: 40px;\n}\n.modal .modal-dialog .modal-content .dialog-separator:before,\n.modal .modal-dialog .modal-content .dialog-separator:after,\n.modal .modal-dialog .modal-content .dialog-separator-before:before,\n.modal .modal-dialog .modal-content .dialog-separator-after:after {\n  background-color: #000;\n  content: ' ';\n  display: block;\n  height: 3px;\n  left: 0;\n  position: absolute;\n  width: 100%;\n}\n.modal .modal-dialog .modal-content .dialog-separator:before,\n.modal .modal-dialog .modal-content .dialog-separator-before:before {\n  top: -3px;\n}\n.modal .modal-dialog .modal-content .dialog-separator:after,\n.modal .modal-dialog .modal-content .dialog-separator-after:after {\n  bottom: -3px;\n}\n.modal .modal-dialog .modal-content .modal-body {\n  color: var(--text-primary-color);\n  padding: 16px 22px 0px;\n  position: relative;\n}\n.modal .modal-dialog .modal-content .modal-body ::-webkit-scrollbar {\n  width: 6px;\n  background-color: var(--ui-gray-dark);\n}\n.modal .modal-dialog .modal-content .modal-body ::-webkit-scrollbar-thumb {\n  background-color: var(--ui-gray-light);\n  border-radius: 5px;\n}\n.modal .modal-dialog .modal-content .modal-header {\n  border-bottom-width: 3px;\n  border-bottom-style: solid;\n  border-bottom-color: #000;\n  padding: 19px 22px 17px;\n  position: relative;\n}\n.modal .modal-dialog .modal-content .modal-header h4 {\n  color: var(--text-secondary-color);\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 24px;\n  padding-right: 24px;\n}\n.modal .modal-dialog .modal-content .modal-footer {\n  border-top: 0;\n  padding-top: 0;\n}\n.modal .modal-dialog .card-round {\n  background-color: var(--ui-gray-dark);\n  padding: 10px;\n}\n.modal .modal-dialog .modal-header {\n  position: relative;\n}\n.modal.fade .modal-dialog {\n  -webkit-transition: transform 0.3s ease-out;\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n  -webkit-transform: translate(0, -25%);\n  transform: translate(0, -25%);\n}\n.modal.in .modal-dialog {\n  -webkit-transform: translate(0, 0);\n          transform: translate(0, 0);\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,0.2);\n  border-radius: 6px;\n  box-shadow: 0 3px 9px rgba(0,0,0,0.5);\n  background-clip: padding-box;\n  outline: 0;\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  background-color: #fff;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.in {\n  opacity: 0;\n}\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.modal-header .close {\n  margin-top: -2px;\n}\n.modal-title {\n  margin: 0;\n  line-height: 1.42857143;\n}\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n}\n.modal-footer .btn+.btn {\n  margin-left: 5px;\n  margin-bottom: 0;\n}\n.modal-footer .btn-group .btn+.btn {\n  margin-left: -1px;\n}\n.modal-footer .btn-block+.btn-block {\n  margin-left: 0;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n  }\n  .modal-content {\n    box-shadow: 0 5px 15px rgba(0,0,0,0.5);\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg {\n    width: 900px;\n  }\n}\n.button-close,\n.modal-dialog button.close {\n  color: var(--text-secondary-color);\n  height: 25px;\n  opacity: 1;\n  overflow: hidden;\n  text-align: center;\n  text-shadow: none;\n  width: 25px;\n  font-size: 25px;\n  font-weight: lighter;\n}\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.btn.disabled,\n.btn[disabled],\nfieldset[disabled] .btn {\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.65;\n}\nbutton.close {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.close {\n  float: right;\n  font-size: 21px;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.2;\n}\n.ModalHeader ol,\n.ModalHeader ul {\n  margin-top: 0;\n}\n";
styleInject(css$q);
var lodash_clonedeep = createCommonjsModule(function (module, exports) {
  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;
  /** Used to stand-in for `undefined` hash values. */

  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used as references for various `Number` constants. */

  var MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */

  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to match `RegExp` flags from their coerced string values. */

  var reFlags = /\w*$/;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /** Used to identify `toStringTag` values supported by `_.clone`. */

  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */

  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }
  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */


  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }
  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */


  function arrayEach(array, iteratee) {
    var index = -1,
        length = array ? array.length : 0;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }

    return array;
  }
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */


  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }

    return array;
  }
  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */


  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array ? array.length : 0;

    if (initAccum && length) {
      accumulator = array[++index];
    }

    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }

    return accumulator;
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */


  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;

    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }

    return result;
  }
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */


  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */


  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }
  /** Used for built-in method references. */


  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to detect overreaching core-js shims. */

  var coreJsData = root['__core-js_shared__'];
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /** Used to resolve the decompiled source of functions. */


  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var objectToString = objectProto.toString;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols = Object.getOwnPropertySymbols,
      nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeKeys = overArg(Object.keys, Object);
  /* Built-in method references that are verified to be native. */

  var DataView = getNative(root, 'DataView'),
      Map = getNative(root, 'Map'),
      Promise = getNative(root, 'Promise'),
      Set = getNative(root, 'Set'),
      WeakMap = getNative(root, 'WeakMap'),
      nativeCreate = getNative(Object, 'create');
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Hash(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */


  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function ListCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */


  function listCacheClear() {
    this.__data__ = [];
  }
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    return true;
  }
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function MapCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
  }
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Stack(entries) {
    this.__data__ = new ListCache(entries);
  }
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
  }
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function stackDelete(key) {
    return this.__data__['delete'](key);
  }
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function stackGet(key) {
    return this.__data__.get(key);
  }
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function stackHas(key) {
    return this.__data__.has(key);
  }
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */


  function stackSet(key, value) {
    var cache = this.__data__;

    if (cache instanceof ListCache) {
      var pairs = cache.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        return this;
      }

      cache = this.__data__ = new MapCache(pairs);
    }

    cache.set(key, value);
    return this;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length,
        skipIndexes = !!length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function assignValue(object, key, value) {
    var objValue = object[key];

    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
      object[key] = value;
    }
  }
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }
  /**
   * The base implementation of `_.assign` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */


  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }
  /**
   * The base implementation of `_.clone` and `_.cloneDeep` which tracks
   * traversed objects.
   *
   * @private
   * @param {*} value The value to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @param {boolean} [isFull] Specify a clone including symbols.
   * @param {Function} [customizer] The function to customize cloning.
   * @param {string} [key] The key of `value`.
   * @param {Object} [object] The parent object of `value`.
   * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
   * @returns {*} Returns the cloned value.
   */


  function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;

    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }

    if (result !== undefined) {
      return result;
    }

    if (!isObject(value)) {
      return value;
    }

    var isArr = isArray(value);

    if (isArr) {
      result = initCloneArray(value);

      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag(value),
          isFunc = tag == funcTag || tag == genTag;

      if (isBuffer(value)) {
        return cloneBuffer(value, isDeep);
      }

      if (tag == objectTag || tag == argsTag || isFunc && !object) {
        if (isHostObject(value)) {
          return object ? value : {};
        }

        result = initCloneObject(isFunc ? {} : value);

        if (!isDeep) {
          return copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }

        result = initCloneByTag(value, tag, baseClone, isDeep);
      }
    } // Check for circular references and return its corresponding clone.


    stack || (stack = new Stack());
    var stacked = stack.get(value);

    if (stacked) {
      return stacked;
    }

    stack.set(value, result);

    if (!isArr) {
      var props = isFull ? getAllKeys(value) : keys(value);
    }

    arrayEach(props || value, function (subValue, key) {
      if (props) {
        key = subValue;
        subValue = value[key];
      } // Recursively populate clone (susceptible to call stack limits).


      assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
  }
  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} prototype The object to inherit from.
   * @returns {Object} Returns the new object.
   */


  function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
  }
  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  /**
   * The base implementation of `getTag`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */


  function baseGetTag(value) {
    return objectToString.call(value);
  }
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */


  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */


  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
  }
  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */


  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  /**
   * Creates a clone of `dataView`.
   *
   * @private
   * @param {Object} dataView The data view to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned data view.
   */


  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  /**
   * Creates a clone of `map`.
   *
   * @private
   * @param {Object} map The map to clone.
   * @param {Function} cloneFunc The function to clone values.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned map.
   */


  function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor());
  }
  /**
   * Creates a clone of `regexp`.
   *
   * @private
   * @param {Object} regexp The regexp to clone.
   * @returns {Object} Returns the cloned regexp.
   */


  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  /**
   * Creates a clone of `set`.
   *
   * @private
   * @param {Object} set The set to clone.
   * @param {Function} cloneFunc The function to clone values.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned set.
   */


  function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor());
  }
  /**
   * Creates a clone of the `symbol` object.
   *
   * @private
   * @param {Object} symbol The symbol object to clone.
   * @returns {Object} Returns the cloned symbol object.
   */


  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */


  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */


  function copyArray(source, array) {
    var index = -1,
        length = source.length;
    array || (array = Array(length));

    while (++index < length) {
      array[index] = source[index];
    }

    return array;
  }
  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */


  function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
      assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }

    return object;
  }
  /**
   * Copies own symbol properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */


  function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
  }
  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /**
   * Creates an array of the own enumerable symbol properties of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */


  var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11,
  // for data views in Edge < 14, and promises in Node.js.

  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = objectToString.call(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : undefined;

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;

          case mapCtorString:
            return mapTag;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag;

          case weakMapCtorString:
            return weakMapTag;
        }
      }

      return result;
    };
  }
  /**
   * Initializes an array clone.
   *
   * @private
   * @param {Array} array The array to clone.
   * @returns {Array} Returns the initialized clone.
   */


  function initCloneArray(array) {
    var length = array.length,
        result = array.constructor(length); // Add properties assigned by `RegExp#exec`.

    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
      result.index = array.index;
      result.input = array.input;
    }

    return result;
  }
  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */


  function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  /**
   * Initializes an object clone based on its `toStringTag`.
   *
   * **Note:** This function only supports cloning values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {string} tag The `toStringTag` of the object to clone.
   * @param {Function} cloneFunc The function to clone values.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the initialized clone.
   */


  function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;

    switch (tag) {
      case arrayBufferTag:
        return cloneArrayBuffer(object);

      case boolTag:
      case dateTag:
        return new Ctor(+object);

      case dataViewTag:
        return cloneDataView(object, isDeep);

      case float32Tag:
      case float64Tag:
      case int8Tag:
      case int16Tag:
      case int32Tag:
      case uint8Tag:
      case uint8ClampedTag:
      case uint16Tag:
      case uint32Tag:
        return cloneTypedArray(object, isDeep);

      case mapTag:
        return cloneMap(object, isDeep, cloneFunc);

      case numberTag:
      case stringTag:
        return new Ctor(object);

      case regexpTag:
        return cloneRegExp(object);

      case setTag:
        return cloneSet(object, isDeep, cloneFunc);

      case symbolTag:
        return cloneSymbol(object);
    }
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */


  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */


  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * This method is like `_.clone` except that it recursively clones `value`.
   *
   * @static
   * @memberOf _
   * @since 1.0.0
   * @category Lang
   * @param {*} value The value to recursively clone.
   * @returns {*} Returns the deep cloned value.
   * @see _.clone
   * @example
   *
   * var objects = [{ 'a': 1 }, { 'b': 2 }];
   *
   * var deep = _.cloneDeep(objects);
   * console.log(deep[0] === objects[0]);
   * // => false
   */


  function cloneDeep(value) {
    return baseClone(value, true, true);
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
  }
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */


  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */


  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */


  var isBuffer = nativeIsBuffer || stubFalse;
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */


  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */


  function stubArray() {
    return [];
  }
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */


  function stubFalse() {
    return false;
  }

  module.exports = cloneDeep;
});
var lodash_isequal = createCommonjsModule(function (module, exports) {
  /**
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright JS Foundation and other contributors <https://js.foundation/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;
  /** Used to stand-in for `undefined` hash values. */

  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used to compose bitmasks for value comparisons. */

  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /** Used as references for various `Number` constants. */

  var MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */

  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  /* Node.js helper references. */


  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */

  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];

      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }

    return result;
  }
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */


  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }

    return array;
  }
  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */


  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }

    return false;
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */


  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function cacheHas(cache, key) {
    return cache.has(key);
  }
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */


  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */


  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }
  /** Used for built-in method references. */


  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to detect overreaching core-js shims. */

  var coreJsData = root['__core-js_shared__'];
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */


  var nativeObjectToString = objectProto.toString;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = Symbol ? Symbol.toStringTag : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols = Object.getOwnPropertySymbols,
      nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeKeys = overArg(Object.keys, Object);
  /* Built-in method references that are verified to be native. */

  var DataView = getNative(root, 'DataView'),
      Map = getNative(root, 'Map'),
      Promise = getNative(root, 'Promise'),
      Set = getNative(root, 'Set'),
      WeakMap = getNative(root, 'WeakMap'),
      nativeCreate = getNative(Object, 'create');
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */


  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */


  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    --this.size;
    return true;
  }
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */

  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();

    while (++index < length) {
      this.add(values[index]);
    }
  }
  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */


  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);

    return this;
  }
  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */


  function setCacheHas(value) {
    return this.__data__.has(value);
  } // Add methods to `SetCache`.


  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);
    this.size = data.size;
    return result;
  }
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function stackGet(key) {
    return this.__data__.get(key);
  }
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function stackHas(key) {
    return this.__data__.has(key);
  }
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */


  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }
  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */


  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */


  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */


  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }

    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }

    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }

      objIsArr = true;
      objIsObj = false;
    }

    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }

    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }

    if (!isSameTag) {
      return false;
    }

    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */


  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */


  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */


  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    } // Assume cyclic values are equal.


    var stacked = stack.get(array);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array); // Ignore non-index properties.

    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }

      if (compared !== undefined) {
        if (compared) {
          continue;
        }

        result = false;
        break;
      } // Recursively compare arrays (susceptible to call stack limits).


      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }

    stack['delete'](array);
    stack['delete'](other);
    return result;
  }
  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }

        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }

        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        } // Assume cyclic values are equal.


        var stacked = stack.get(object);

        if (stacked) {
          return stacked == other;
        }

        bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }

    }

    return false;
  }
  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }

    var index = objLength;

    while (index--) {
      var key = objProps[index];

      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    } // Assume cyclic values are equal.


    var stacked = stack.get(object);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;

    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      } // Recursively compare objects (susceptible to call stack limits).


      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }

      skipCtor || (skipCtor = key == 'constructor');
    }

    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }

    stack['delete'](object);
    stack['delete'](other);
    return result;
  }
  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */


  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }
  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */


  var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
      return [];
    }

    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;

          case mapCtorString:
            return mapTag;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag;

          case weakMapCtorString:
            return weakMapTag;
        }
      }

      return result;
    };
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */


  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */


  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */


  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */

  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */


  var isBuffer = nativeIsBuffer || stubFalse;
  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are compared by strict equality, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */

  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */


  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */


  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */

  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */


  function stubArray() {
    return [];
  }
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */


  function stubFalse() {
    return false;
  }

  module.exports = isEqual;
});

var UserPreferencesModal =
/*#__PURE__*/
function (_Component) {
  inherits(UserPreferencesModal, _Component); // TODO: Make this component more generic to allow things other than W/L and hotkeys...

  function UserPreferencesModal(props) {
    var _this;

    classCallCheck(this, UserPreferencesModal);
    _this = possibleConstructorReturn(this, getPrototypeOf(UserPreferencesModal).call(this, props));
    defineProperty(assertThisInitialized(_this), "save", function () {
      _this.props.onSave({
        windowLevelData: _this.state.windowLevelData,
        hotKeysData: _this.state.hotKeysData
      });
    });
    _this.state = {
      windowLevelData: lodash_clonedeep(props.windowLevelData),
      hotKeysData: lodash_clonedeep(props.hotKeysData)
    };
    return _this;
  }

  createClass(UserPreferencesModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prev, next) {
      var newStateData = {};

      if (!lodash_isequal(prev.windowLevelData, next.windowLevelData)) {
        newStateData.windowLevelData = prev.windowLevelData;
      }

      if (!lodash_isequal(prev.hotKeysData, next.hotKeysData)) {
        newStateData.hotKeysData = prev.hotKeysData;
      }

      if (newStateData.hotKeysData || newStateData.windowLevelData) {
        this.setState(newStateData);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement(Modal$2, {
        show: this.props.isOpen,
        onHide: this.props.onCancel,
        "aria-labelledby": "ModalHeader",
        className: "ModalHeader modal fade themed in",
        backdrop: false,
        large: true,
        keyboard: false
      }, React__default.createElement(Modal$2.Header, {
        closeButton: true
      }, React__default.createElement(Modal$2.Title, null, this.props.t('User Preferences'))), React__default.createElement(Modal$2.Body, null, React__default.createElement(UserPreferences, {
        windowLevelData: this.state.windowLevelData,
        hotKeysData: this.state.hotKeysData
      })), React__default.createElement(Modal$2.Footer, null, React__default.createElement("button", {
        className: "btn btn-danger pull-left",
        onClick: this.props.onResetToDefaults
      }, this.props.t('Reset to Defaults')), React__default.createElement(Modal$2.Dismiss, {
        className: "btn btn-default"
      }, this.props.t('Cancel')), React__default.createElement("button", {
        className: "btn btn-primary",
        onClick: this.save
      }, this.props.t('Save'))));
    }
  }]);
  return UserPreferencesModal;
}(Component);

defineProperty(UserPreferencesModal, "propTypes", {
  isOpen: propTypes.bool.isRequired,
  onCancel: propTypes.func,
  onSave: propTypes.func,
  onResetToDefaults: propTypes.func,
  windowLevelData: propTypes.object,
  hotKeysData: propTypes.object,
  t: propTypes.func
});
defineProperty(UserPreferencesModal, "defaultProps", {
  isOpen: false
});
var connectedComponent$3 = withTranslation$1('UserPreferencesModal')(UserPreferencesModal);
var css$r = "* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.form-themed table {\n  color: var(--text-primary-color);\n}\n.form-themed table th,\n.form-themed table td {\n  font-size: 15px;\n  font-weight: normal;\n}\n.form-themed table th {\n  line-height: 60px;\n}\n.form-themed table td {\n  line-height: 18px;\n  padding: 0;\n}\n.form-themed .p-r-1 {\n  padding-right: 1rem !important;\n}\n.form-themed label {\n  margin-bottom: 5px;\n}\n.form-themed label.wrapperLabel {\n  cursor: pointer;\n}\n.form-themed label.wrapperLabel:not(.checkboxLabel) {\n  cursor: pointer;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.form-themed label.wrapperLabel:not(.checkboxLabel) .wrapperText {\n  display: block;\n  -webkit-box-ordinal-group: 0;\n          order: -1;\n}\n.form-themed .btn[disabled],\n.form-themed input[type=text][disabled],\n.form-themed input[type=password][disabled],\n.form-themed input[type=number][disabled],\n.form-themed .btn.disabled,\n.form-themed input[type=text].disabled,\n.form-themed input[type=password].disabled,\n.form-themed input[type=number].disabled,\n.form-themed .btn[disabled]:hover,\n.form-themed input[type=text][disabled]:hover,\n.form-themed input[type=password][disabled]:hover,\n.form-themed input[type=number][disabled]:hover,\n.form-themed .btn.disabled:hover,\n.form-themed input[type=text].disabled:hover,\n.form-themed input[type=password].disabled:hover,\n.form-themed input[type=number].disabled:hover,\n.form-themed .btn[disabled]:active,\n.form-themed input[type=text][disabled]:active,\n.form-themed input[type=password][disabled]:active,\n.form-themed input[type=number][disabled]:active,\n.form-themed .btn.disabled:active,\n.form-themed input[type=text].disabled:active,\n.form-themed input[type=password].disabled:active,\n.form-themed input[type=number].disabled:active {\n  background-color: var(--ui-gray-darker);\n  border-color: var(--ui-gray-light);\n  color: var(--text-primary-color);\n}\n.form-themed .btn[disabled] + .wrapperText,\n.form-themed input[type=text][disabled] + .wrapperText,\n.form-themed input[type=password][disabled] + .wrapperText,\n.form-themed input[type=number][disabled] + .wrapperText,\n.form-themed .btn.disabled + .wrapperText,\n.form-themed input[type=text].disabled + .wrapperText,\n.form-themed input[type=password].disabled + .wrapperText,\n.form-themed input[type=number].disabled + .wrapperText,\n.form-themed .btn[disabled]:hover + .wrapperText,\n.form-themed input[type=text][disabled]:hover + .wrapperText,\n.form-themed input[type=password][disabled]:hover + .wrapperText,\n.form-themed input[type=number][disabled]:hover + .wrapperText,\n.form-themed .btn.disabled:hover + .wrapperText,\n.form-themed input[type=text].disabled:hover + .wrapperText,\n.form-themed input[type=password].disabled:hover + .wrapperText,\n.form-themed input[type=number].disabled:hover + .wrapperText,\n.form-themed .btn[disabled]:active + .wrapperText,\n.form-themed input[type=text][disabled]:active + .wrapperText,\n.form-themed input[type=password][disabled]:active + .wrapperText,\n.form-themed input[type=number][disabled]:active + .wrapperText,\n.form-themed .btn.disabled:active + .wrapperText,\n.form-themed input[type=text].disabled:active + .wrapperText,\n.form-themed input[type=password].disabled:active + .wrapperText,\n.form-themed input[type=number].disabled:active + .wrapperText {\n  color: var(--text-primary-color);\n  cursor: auto;\n}\n.form-themed input[type=text],\n.form-themed input[type=password],\n.form-themed input[type=number] {\n  background-color: var(--ui-gray);\n  border-color: var(--ui-border-color);\n  color: var(--text-primary-color);\n  font-weight: normal;\n}\n.form-themed input[type=text]:active,\n.form-themed input[type=password]:active,\n.form-themed input[type=number]:active,\n.form-themed input[type=text]:focus,\n.form-themed input[type=password]:focus,\n.form-themed input[type=number]:focus {\n  background-color: var(--ui-gray-dark);\n  border: 2px solid var(--active-color);\n  box-shadow: none;\n}\n.form-themed input[type=text]:active + .wrapperText,\n.form-themed input[type=password]:active + .wrapperText,\n.form-themed input[type=number]:active + .wrapperText,\n.form-themed input[type=text]:focus + .wrapperText,\n.form-themed input[type=password]:focus + .wrapperText,\n.form-themed input[type=number]:focus + .wrapperText {\n  color: var(--active-color);\n}\n.form-themed .btn-primary {\n  background-color: var(--active-color);\n  border-collapse: var(--ui-border-color-active);\n  color: var(--ui-text-color-active);\n}\n.form-themed .btn-primary:hover,\n.form-themed .btn-primary:active,\n.form-themed .btn-primary:focus,\n.form-themed .btn-primary:focus:active {\n  background-color: var(--ui-active-color);\n  border-collapse: var(--ui-border-color-active);\n  color: var(--ui-text-color-active);\n}\n.form-themed .form-control {\n  background-color: #fff;\n  border: 0;\n  font-size: 14px;\n  height: 30px;\n  line-height: 16px;\n  padding: 8px 9px 6px;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);\n}\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);\n}\n.form-control::-ms-expand {\n  border: 0;\n  background-color: transparent;\n}\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: ;\n  opacity: 1;\n}\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: ;\n}\ninput[type=range] {\n  display: block;\n  width: 100%;\n}\n.CineDialog {\n  background: var(--ui-gray-darkest);\n  color: var(--text-secondary-color);\n  -webkit-filter: drop-shadow(0 0 3px var(--ui-gray-darkest));\n          filter: drop-shadow(0 0 3px var(--ui-gray-darkest));\n  border: none;\n  border-radius: 8px;\n  width: inherit;\n}\n.CineDialog h5 {\n  font-size: 20px;\n  line-height: 35px;\n  margin: 0;\n}\n.CineDialog h5,\n.CineDialog label {\n  font-weight: 400;\n}\n.CineDialog .cine-navigation,\n.CineDialog .cine-controls,\n.CineDialog .cine-options {\n  cursor: default;\n}\n.CineDialog .fps-section input[type=\"range\"] {\n  background-color: transparent;\n  border: 0 none;\n  outline: 0 none;\n}\n.CineDialog .fps-section input[type=\"range\"]::-ms-tooltip {\n  display: none;\n}\n.CineDialog .double-row-style {\n  box-sizing: border-box;\n  width: 290px;\n  height: 70px;\n  padding: 10px;\n  top: 2%;\n  left: 35%;\n}\n.CineDialog .double-row-style .cine-navigation {\n  position: absolute;\n  right: 16px;\n  top: 10px;\n}\n.CineDialog .double-row-style .cine-navigation .btn {\n  padding: 0 4px;\n}\n.CineDialog .double-row-style .cine-navigation .btn i {\n  font-size: 32px;\n  line-height: 32px;\n}\n.CineDialog .double-row-style .cine-controls {\n  left: 0px;\n}\n.CineDialog .double-row-style .cine-options {\n  padding: 0px 0;\n}\n.CineDialog .double-row-style .cine-options .fps-section {\n  width: 175px;\n  float: left;\n}\n.CineDialog .double-row-style .cine-options .fps {\n  float: right;\n}\n.CineDialog .single-row-style {\n  box-sizing: content-box;\n  width: 425px;\n  height: 45px;\n  padding: 4px 8px;\n  top: 2%;\n  left: 35%;\n}\n.CineDialog .single-row-style .cine-navigation {\n  float: right;\n  overflow: hidden;\n  padding-right: 12px;\n  position: relative;\n}\n.CineDialog .single-row-style .cine-navigation .btn {\n  padding: 0 2px;\n  margin: 0 0 0 2px;\n  border: 0 none;\n}\n.CineDialog .single-row-style .cine-navigation .btn:first-of-type {\n  margin-left: 0;\n}\n.CineDialog .single-row-style .cine-navigation .btn i {\n  font-size: 32px;\n  line-height: 45px;\n}\n.CineDialog .single-row-style .cine-controls {\n  position: relative;\n  float: left;\n  overflow: hidden;\n}\n.CineDialog .single-row-style .cine-controls .btn {\n  font-size: 22px;\n  line-height: 45px;\n  min-width: 28px;\n  padding: 0 0px;\n  margin: 0 4px;\n  border: 0 none;\n}\n.CineDialog .single-row-style .cine-options {\n  display: block;\n  position: relative;\n  width: 150px;\n  float: left;\n  overflow: hidden;\n  padding: 0;\n  margin: 0 0 0 10px;\n}\n.CineDialog .single-row-style .cine-options .fps-section {\n  display: block;\n  float: left;\n  width: 80px;\n}\n.CineDialog .single-row-style .cine-options .fps-section input[type=\"range\"] {\n  line-height: 45px;\n  height: 45px;\n}\n.CineDialog .single-row-style .cine-options .fps {\n  display: block;\n  width: 68px;\n  float: left;\n  padding: 0;\n  margin: 0 0 0 2px;\n  text-align: center;\n  line-height: 45px;\n  font-size: 14px;\n  line-height: 1.42857143;\n}\n.CineDialog .btn {\n  color: var(--text-secondary-color);\n  background-color: transparent;\n  border: 0;\n  border-radius: 4px;\n  font-size: 15px;\n  width: 45px;\n  font-weight: normal;\n  height: 37px;\n  line-height: 37px;\n  padding: 0 12px;\n}\n.CineDialog .btn:hover,\n.CineDialog .btn:active,\n.CineDialog .btn.active {\n  color: var(--hover-color);\n}\n.CineDialog .btn[disabled]:hover {\n  color: inherit;\n}\n.CineDialog .btn[disabled]:active {\n  color: var(--text-secondary-color);\n}\n.CineDialog .btn.btn-primary,\n.CineDialog .btn.btn-secondary,\n.CineDialog .btn.btn-danger {\n  -webkit-transition: background-color 0.3s ease;\n  transition: background-color 0.3s ease;\n}\n.CineDialog .btn.btn-primary:hover,\n.CineDialog .btn.btn-secondary:hover,\n.CineDialog .btn.btn-danger:hover,\n.CineDialog .btn.btn-primary:active,\n.CineDialog .btn.btn-secondary:active,\n.CineDialog .btn.btn-danger:active,\n.CineDialog .btn.btn-primary:focus,\n.CineDialog .btn.btn-secondary:focus,\n.CineDialog .btn.btn-danger:focus {\n  opacity: 0.8;\n}\n.CineDialog .btn.btn-primary {\n  background-color: var(--active-color);\n  color: var(--primary-background-color);\n}\n.CineDialog .btn.btn-secondary {\n  background-color: var(--text-secondary-color);\n  color: var(--primary-background-color);\n}\n.CineDialog .btn.btn-danger {\n  background-color: var(--text-destructive-color);\n  color: var(--text-primary-color);\n}\n.CineDialog .btn.active {\n  box-shadow: inset 1px 1px 2px var(--ui-gray-darkest);\n}\n";
styleInject(css$r);

var CineDialog =
/*#__PURE__*/
function (_PureComponent) {
  inherits(CineDialog, _PureComponent);

  function CineDialog(props) {
    var _this;

    classCallCheck(this, CineDialog);
    _this = possibleConstructorReturn(this, getPrototypeOf(CineDialog).call(this, props));
    defineProperty(assertThisInitialized(_this), "handleInputChange", function (event) {
      var target = event.target;
      var value = target.value;

      if (target.type === 'range') {
        value = parseFloat(target.value);
      }

      var name = target.name;

      _this.setState(defineProperty({}, name, value));

      if (name === 'cineFrameRate' && _this.props.onFrameRateChanged) {
        _this.props.onFrameRateChanged(parseFloat(value));
      }
    });
    defineProperty(assertThisInitialized(_this), "onClickPlayPause", function () {
      var value = !_this.state.isPlaying;

      _this.setState({
        isPlaying: value
      });

      if (_this.props.onPlayPauseChanged) {
        _this.props.onPlayPauseChanged(value);
      }
    });
    defineProperty(assertThisInitialized(_this), "onClickNextButton", function (event) {
      if (_this.props.onClickNextButton) {
        _this.props.onClickNextButton(event);
      }
    });
    defineProperty(assertThisInitialized(_this), "onClickBackButton", function (event) {
      if (_this.props.onClickBackButton) {
        _this.props.onClickBackButton(event);
      }
    });
    defineProperty(assertThisInitialized(_this), "onClickSkipToStart", function (event) {
      if (_this.props.onClickSkipToStart) {
        _this.props.onClickSkipToStart(event);
      }
    });
    defineProperty(assertThisInitialized(_this), "onClickSkipToEnd", function (event) {
      if (_this.props.onClickSkipToEnd) {
        _this.props.onClickSkipToEnd(event);
      }
    });
    _this.state = {
      cineFrameRate: props.cineFrameRate,
      isPlaying: props.isPlaying
    };
    return _this;
  }

  createClass(CineDialog, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // TODO: Not sure if we should just switch this to a stateless
      // fully-controlled component instead
      if (this.props.isPlaying !== prevProps.isPlaying || this.props.isPlaying !== this.state.isPlaying) {
        this.setState({
          isPlaying: this.props.isPlaying
        });
      }

      if (this.props.cineFrameRate !== prevProps.cineFrameRate || this.props.cineFrameRate !== this.state.cineFrameRate) {
        this.setState({
          cineFrameRate: this.props.cineFrameRate
        });
      }
    }
  }, {
    key: "render",
    // TODO:
    // - Add next / previous display set buttons which just call
    // onClickNextDisplaySet and onClickPreviousDisplaySet which are passed in as props.
    // See https://github.com/OHIF/Viewers/blob/master/Packages/ohif-viewerbase/client/components/viewer/cineDialog/cineDialog.html#L38
    // - Add 'isEnabled' prop: https://github.com/OHIF/Viewers/blob/master/Packages/ohif-viewerbase/client/components/viewer/cineDialog/cineDialog.js#L301
    value: function render() {
      var t = this.props.t;
      return React__default.createElement("div", {
        className: "CineDialog"
      }, React__default.createElement("div", {
        className: "noselect double-row-style"
      }, React__default.createElement("div", {
        className: "cine-controls"
      }, React__default.createElement("div", {
        className: "btn-group"
      }, React__default.createElement("button", {
        title: t('Skip to first image'),
        className: "btn",
        "data-toggle": "tooltip",
        onClick: this.onClickSkipToStart
      }, React__default.createElement(Icon, {
        name: "fast-backward"
      })), React__default.createElement("button", {
        title: t('Previous image'),
        className: "btn",
        "data-toggle": "tooltip",
        onClick: this.onClickBackButton
      }, React__default.createElement(Icon, {
        name: "step-backward"
      })), React__default.createElement("button", {
        title: t('Play / Stop'),
        className: "btn",
        "data-toggle": "tooltip",
        onClick: this.onClickPlayPause
      }, React__default.createElement(Icon, {
        name: this.state.isPlaying ? 'stop' : 'play'
      })), React__default.createElement("button", {
        title: t('Next image'),
        className: "btn",
        "data-toggle": "tooltip",
        onClick: this.onClickNextButton
      }, React__default.createElement(Icon, {
        name: "step-forward"
      })), React__default.createElement("button", {
        title: t('Skip to last image'),
        className: "btn",
        "data-toggle": "tooltip",
        onClick: this.onClickSkipToEnd
      }, React__default.createElement(Icon, {
        name: "fast-forward"
      })))), React__default.createElement("div", {
        className: "cine-options"
      }, React__default.createElement("div", {
        className: "fps-section"
      }, React__default.createElement("input", {
        type: "range",
        name: "cineFrameRate",
        min: this.props.cineMinFrameRate,
        max: this.props.cineMaxFrameRate,
        step: this.props.cineStepFrameRate,
        value: this.state.cineFrameRate,
        onChange: this.handleInputChange
      })), React__default.createElement("span", {
        className: "fps"
      }, this.state.cineFrameRate.toFixed(1), " ", t('fps')))));
    }
  }]);
  return CineDialog;
}(PureComponent);

defineProperty(CineDialog, "propTypes", {
  /** Minimum value for range slider */
  cineMinFrameRate: propTypes.number.isRequired,

  /** Maximum value for range slider */
  cineMaxFrameRate: propTypes.number.isRequired,

  /** Increment range slider can "step" in either direction. */
  cineStepFrameRate: propTypes.number.isRequired,
  cineFrameRate: propTypes.number.isRequired,

  /** 'True' if playing, 'False' if paused. */
  isPlaying: propTypes.bool.isRequired,
  onPlayPauseChanged: propTypes.func,
  onFrameRateChanged: propTypes.func,
  onClickNextButton: propTypes.func,
  onClickBackButton: propTypes.func,
  onClickSkipToStart: propTypes.func,
  onClickSkipToEnd: propTypes.func,

  /** i18next translation function */
  t: propTypes.func.isRequired
});
defineProperty(CineDialog, "defaultProps", {
  cineMinFrameRate: 1,
  cineMaxFrameRate: 90,
  cineStepFrameRate: 1,
  cineFrameRate: 24,
  isPlaying: false
});
var connectedComponent$4 = withTranslation$1('CineDialog')(CineDialog);
var css$s = ".studyBrowseItem {\n  margin-bottom: 10px;\n  position: relative;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.studyBrowseItem.active .studyItemBox {\n  border-color: var(--active-color);\n}\n.studyBrowseItem.active .studyItemBox .studyModality {\n  color: var(--primary-background-color);\n}\n.studyBrowseItem.active .studyItemBox .studyModality,\n.studyBrowseItem.active .studyItemBox .studyModality:before,\n.studyBrowseItem.active .studyItemBox .studyModality:after {\n  background-color: var(--active-color);\n  border-color: #131d29;\n}\n.studyBrowseItem:not(.active) .studyBrowserSeries {\n  max-height: 0 !important;\n}\n.studyBrowseItem:not(.active) .studyBrowserSeries .studySeriesContainer {\n  opacity: 0;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.studyBrowseItem .studyBrowserSeries {\n  overflow: hidden;\n  -webkit-transition: max-height 0.3s ease;\n  transition: max-height 0.3s ease;\n}\n.studyBrowseItem .studyBrowserSeries .studySeriesContainer {\n  opacity: 1;\n  -webkit-transition: opacity 0.3s ease, -webkit-transform 0.3s ease;\n  transition: opacity 0.3s ease, -webkit-transform 0.3s ease;\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  transition: opacity 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n  -webkit-transform-origin: 50% 0%;\n          transform-origin: 50% 0%;\n}\n.studyItemBox {\n  border: 3px solid var(--ui-border-color-dark);\n  border-radius: 12px;\n  cursor: pointer;\n  padding: 12px 7px 11px;\n  position: relative;\n  -webkit-transition: $sidebarTransition;\n  transition: $sidebarTransition;\n  background-color: #14191e;\n  z-index: 0;\n}\n.studyItemBox:hover {\n  border-color: var(--active-color);\n}\n.studyItemBox:hover.additional {\n  color: var(--text-secondary-color);\n}\n.studyItemBox:hover .studyModality {\n  color: var(--primary-background-color);\n}\n.studyItemBox:hover .studyModality,\n.studyItemBox:hover .studyModality:before,\n.studyItemBox:hover .studyModality:after {\n  background-color: var(--active-color);\n}\n.studyItemBox.additional {\n  color: var(--text-primary-color);\n  font-size: 16px;\n  font-weight: normal;\n  height: 91px;\n  line-height: 91px;\n  padding: 0;\n  text-align: center;\n}\n.studyItemBox .studyText {\n  font-size: 13px;\n  left: 89px;\n  line-height: 14px;\n  position: absolute;\n  right: 7px;\n  top: 12px;\n}\n.studyItemBox .studyText .studyDate {\n  margin-top: 8px;\n  color: var(--text-secondary-color);\n}\n.studyItemBox .studyText .studyDescription {\n  margin-top: 8px;\n  color: var(--text-primary-color);\n}\n.studyItemBox .studyText .studyAvailability {\n  margin-top: 24px;\n  color: var(--text-primary-color);\n}\n.studyItemBox .studyModality {\n  color: var(--text-secondary-color);\n  font-size: 20px;\n  line-height: 50px;\n  margin-left: 12px;\n  margin-top: 12px;\n  position: relative;\n}\n.studyItemBox .studyModality .studyModalityText {\n  height: 100%;\n  overflow: hidden;\n  text-align: center;\n  text-transform: uppercase;\n}\n.studyItemBox .studyModality,\n.studyItemBox .studyModality:before,\n.studyItemBox .studyModality:after {\n  border: 2px solid var(--primary-background-color);\n  background-color: var(--box-background-color);\n  border-radius: 8px;\n  height: 54px;\n  width: 54px;\n}\n.studyItemBox .studyModality:before,\n.studyItemBox .studyModality:after {\n  display: block;\n  content: '';\n  position: absolute;\n}\n.studyItemBox .studyModality:before {\n  top: -8px;\n  left: -8px;\n  z-index: -1;\n}\n.studyItemBox .studyModality:after {\n  top: -14px;\n  left: -14px;\n  z-index: -2;\n}\n";
styleInject(css$s);

var StudiesItem =
/*#__PURE__*/
function (_Component) {
  inherits(StudiesItem, _Component);

  function StudiesItem() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, StudiesItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(StudiesItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "getModalitiesStyle", function () {
      return {};
    });
    return _this;
  }

  createClass(StudiesItem, [{
    key: "render",
    value: function render() {
      var _this$props$studyData = this.props.studyData,
          studyDate = _this$props$studyData.studyDate,
          studyDescription = _this$props$studyData.studyDescription,
          modalities = _this$props$studyData.modalities,
          studyAvailable = _this$props$studyData.studyAvailable;
      var activeClass = this.props.active ? ' active' : '';
      var hasDescriptionAndDate = studyDate && studyDescription;
      return React__default.createElement("div", {
        className: "studyBrowseItem".concat(activeClass),
        onClick: this.props.onClick
      }, React__default.createElement("div", {
        className: "studyItemBox"
      }, React__default.createElement("div", {
        className: "studyModality"
      }, React__default.createElement("div", {
        className: "studyModalityText",
        style: this.getModalitiesStyle()
      }, modalities)), React__default.createElement("div", {
        className: "studyText"
      }, hasDescriptionAndDate ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: "studyDate"
      }, studyDate), React__default.createElement("div", {
        className: "studyDescription"
      }, studyDescription)) : React__default.createElement("div", {
        className: "studyAvailability"
      }, studyAvailable ? React__default.createElement(React__default.Fragment, null, "N/A") : React__default.createElement(React__default.Fragment, null, "Click to load")))));
    }
  }]);
  return StudiesItem;
}(Component);

defineProperty(StudiesItem, "propTypes", {
  onClick: propTypes.func.isRequired,
  studyData: propTypes.object.isRequired,
  active: propTypes.bool
});
var css$t = "";
styleInject(css$t);

var StudiesList =
/*#__PURE__*/
function (_Component) {
  inherits(StudiesList, _Component);

  function StudiesList() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, StudiesList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(StudiesList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "getBrowserItems", function () {
      return _this.props.studyListData.map(function (studyData, index) {
        return React__default.createElement(StudiesItem, {
          key: index,
          studyData: studyData,
          active: studyData.studyInstanceUid === _this.props.activeStudyInstanceUid,
          onClick: function onClick(event) {
            return _this.props.onClick(studyData);
          }
        });
      });
    });
    return _this;
  }

  createClass(StudiesList, [{
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "studiesList ".concat(this.props.class)
      }, this.getBrowserItems());
    }
  }]);
  return StudiesList;
}(Component);

defineProperty(StudiesList, "propTypes", {
  class: propTypes.string,
  studyListData: propTypes.array.isRequired,
  onClick: propTypes.func.isRequired,
  activeStudyInstanceUid: propTypes.string
});
var css$u = "";
styleInject(css$u);

var SeriesList =
/*#__PURE__*/
function (_Component) {
  inherits(SeriesList, _Component);

  function SeriesList() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, SeriesList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(SeriesList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "getSeriesItems", function () {
      return _this.props.seriesItems.map(function (seriesData, index) {
        return React__default.createElement(ThumbnailEntry, _extends_1({
          key: seriesData.displaySetInstanceUid,
          id: "series_thumb_".concat(index)
        }, seriesData, {
          active: seriesData.displaySetInstanceUid === _this.props.activeDisplaySetInstanceUid,
          onClick: function onClick() {
            return _this.props.onClick(seriesData);
          }
        }));
      });
    });
    return _this;
  }

  createClass(SeriesList, [{
    key: "render",
    value: function render() {
      return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: "study-browser-series clearfix thumbnails-wrapper"
      }, React__default.createElement("div", {
        className: "study-series-container"
      }, this.getSeriesItems())));
    }
  }]);
  return SeriesList;
}(Component);

defineProperty(SeriesList, "propTypes", {
  seriesItems: propTypes.array.isRequired,
  onClick: propTypes.func.isRequired,
  activeDisplaySetInstanceUid: propTypes.string
});
var css$v = ".series-quick-switch {\n  position: relative;\n}\n.series-quick-switch:before {\n  box-shadow: 0 0 0 5000px rgba(0,0,0,0.8);\n  -webkit-transition: opacity 0.3s ease;\n  transition: opacity 0.3s ease;\n  opacity: 0;\n  content: '';\n}\n.series-quick-switch:hover {\n  z-index: 50;\n}\n.series-quick-switch:hover:before {\n  display: table;\n  opacity: 1;\n  content: '';\n}\n.series-quick-switch:not(.left):not(.right) {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.series-quick-switch.left {\n  border-right: 1px solid var(--ui-border-color);\n  right: 0;\n}\n.series-quick-switch.right {\n  left: 0;\n}\n.series-quick-switch.right .series-switch {\n  float: right;\n}\n.series-quick-switch.right .study-switch {\n  float: left;\n}\n.series-quick-switch.right .study-browser {\n  left: auto;\n  right: 0;\n  -webkit-transform-origin: calc(100% - 1em) calc(1em + 17px);\n          transform-origin: calc(100% - 1em) calc(1em + 17px);\n}\n.series-quick-switch.right .series-browser {\n  left: 0;\n  right: auto;\n  -webkit-transform-origin: 1em calc(1em + 15px);\n          transform-origin: 1em calc(1em + 15px);\n}\n.series-quick-switch.right .series-browser .thumbnails-wrapper {\n  -webkit-transform-origin: 0% 0%;\n          transform-origin: 0% 0%;\n}\n.series-quick-switch.right .series-browser .ThumbnailEntry {\n  float: left;\n}\n.series-quick-switch.right .series-item {\n  float: left;\n}\n.series-quick-switch .title-label {\n  color: var(--text-secondary-color);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  opacity: 1;\n  padding-bottom: 3px;\n  text-align: center;\n  -webkit-transition: opacity 0.3s ease;\n  transition: opacity 0.3s ease;\n}\n.series-quick-switch .series-switch {\n  padding-right: 10px;\n}\n.series-quick-switch .series-switch,\n.series-quick-switch .study-switch {\n  float: left;\n  position: relative;\n}\n.series-quick-switch .study-switch:hover:after {\n  content: '';\n  display: block;\n  height: 100px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 300px;\n}\n.series-quick-switch .study-browser {\n  left: 0;\n  padding-top: 60px;\n  max-height: calc(100vh - 60px);\n  -webkit-transform-origin: 1em calc(1em + 17px);\n          transform-origin: 1em calc(1em + 17px);\n  width: 300px;\n}\n.series-quick-switch .study-browser .study-browser-list {\n  padding: 0 10px;\n}\n.series-quick-switch .series-browser {\n  max-height: 100vh;\n  max-width: 720px;\n  right: 0;\n  -webkit-transform-origin: calc(100% - 1em) calc(1em + 15px);\n          transform-origin: calc(100% - 1em) calc(1em + 15px);\n}\n.series-quick-switch .series-browser .thumbnails-wrapper {\n  -webkit-transition: -webkit-transform 0.3s ease;\n  transition: -webkit-transform 0.3s ease;\n  transition: transform 0.3s ease;\n  transition: transform 0.3s ease, -webkit-transform 0.3s ease;\n  -webkit-transform-origin: 100% 0%;\n          transform-origin: 100% 0%;\n}\n.series-quick-switch .series-browser .ThumbnailEntry {\n  float: right;\n}\n.series-quick-switch .series-browser .ThumbnailEntry .series-details {\n  opacity: 0;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n  -webkit-transition: opacity 0.3s ease, -webkit-transform 0.3s ease;\n  transition: opacity 0.3s ease, -webkit-transform 0.3s ease;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  transition: transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease;\n}\n.series-quick-switch .series-browser .scrollable {\n  padding-top: 15px;\n  -webkit-transition: padding-bottom 0.3s ease;\n  transition: padding-bottom 0.3s ease;\n}\n.series-quick-switch .series-browser .study-browser-series {\n  overflow: hidden;\n}\n.series-quick-switch .series-browser,\n.series-quick-switch .study-browser {\n  min-height: 120px;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  -webkit-transition: opacity 0.3s ease, -webkit-transform 0.3s ease;\n  transition: opacity 0.3s ease, -webkit-transform 0.3s ease;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  transition: transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease;\n  z-index: 3;\n}\n.series-quick-switch .series-box,\n.series-quick-switch .study-box {\n  height: 57px;\n  width: 57px;\n}\n.series-quick-switch .study-box {\n  background-color: var(--ui-gray-dark);\n  border: solid 2px var(--ui-border-color-dark);\n  border-radius: 11px;\n}\n.series-quick-switch .series-item {\n  background-color: var(--box-background-color);\n  border-radius: 3px;\n  float: right;\n  height: 15px;\n  margin: 2px;\n  -webkit-transition: opacity 0.3s ease;\n  transition: opacity 0.3s ease;\n  width: 15px;\n}\n.series-quick-switch .series-item.count {\n  color: var(--text-primary-color);\n  background-color: transparent;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 17px;\n  text-align: center;\n}\n.series-quick-switch .series-item.active {\n  background-color: var(--active-color);\n}\n.series-quick-switch.series-triggered .series-browser,\n.series-quick-switch .series-switch:hover .series-browser,\n.series-quick-switch .study-switch:hover .study-browser {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.series-quick-switch.series-triggered .series-item,\n.series-quick-switch .series-switch:hover .title-label {\n  opacity: 0;\n}\n.series-quick-switch.series-triggered .thumbnails-wrapper {\n  -webkit-transform: scale(0.9) translateY(80px);\n          transform: scale(0.9) translateY(80px);\n}\n.series-quick-switch.series-triggered .series-browser:not(:hover)>.scrollable {\n  padding-bottom: 80px;\n}\n.series-quick-switch.series-triggered .series-browser:not(:hover)>.scrollNav {\n  opacity: 0;\n}\n.series-quick-switch .series-switch:hover .series-browser .thumbnails-wrapper {\n  -webkit-transform: scale(1) translateY(0);\n          transform: scale(1) translateY(0);\n}\n.series-quick-switch .series-switch:hover .series-browser .ThumbnailEntry .series-details {\n  opacity: 1;\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n  -webkit-transition-delay: 0.3s;\n          transition-delay: 0.3s;\n}\n.series-quick-switch .study-browser-item.active .study-item-box {\n  box-shadow: inset 0 0 0 3px var(--active-color);\n}\n@media screen and (max-width: 1599px) {\n  .series-quick-switch .series-box,\n  .series-quick-switch .study-box {\n    width: 36px;\n    height: 36px;\n  }\n  .series-quick-switch .study-box {\n    border-radius: 7px;\n  }\n  .series-quick-switch .series-item {\n    height: 10px;\n    margin: 1px;\n    width: 10px;\n  }\n  .series-quick-switch .series-item.count {\n    font-size: 10px;\n    font-weight: 300;\n    line-height: 10px;\n  }\n}\n";
styleInject(css$v);

var QuickSwitch =
/*#__PURE__*/
function (_Component) {
  inherits(QuickSwitch, _Component);

  function QuickSwitch(props) {
    var _this;

    classCallCheck(this, QuickSwitch);
    _this = possibleConstructorReturn(this, getPrototypeOf(QuickSwitch).call(this, props));
    defineProperty(assertThisInitialized(_this), "getSeriesItems", function () {
      var seriesListData;

      if (_this.props.seriesListData) {
        seriesListData = _this.props.seriesListData;
      } else if (_this.state.activeStudyInstanceUid) {
        var study = _this.props.studyListData.find(function (study) {
          return study.studyInstanceUid === _this.state.activeStudyInstanceUid;
        });

        seriesListData = study.thumbnails;
      } else {
        seriesListData = _this.props.studyListData[0].thumbnails;
      }

      return seriesListData || [];
    });
    defineProperty(assertThisInitialized(_this), "getSmallListItems", function () {
      var seriesItems = _this.getSeriesItems() || [];
      return seriesItems.map(function (seriesData, index) {
        var active = seriesData.displaySetInstanceUid === _this.state.activeDisplaySetInstanceUid;
        return React__default.createElement("div", {
          key: index,
          className: "series-item ".concat(active ? 'active' : '')
        });
      });
    });
    defineProperty(assertThisInitialized(_this), "onStudyClick", function (studyDataSelected) {
      if (_this.props.onStudySelected) {
        _this.props.onStudySelected(studyDataSelected);
      }

      _this.setState({
        activeStudyInstanceUid: studyDataSelected.studyInstanceUid,
        seriesQuickSwitchOpen: true
      });
    });
    defineProperty(assertThisInitialized(_this), "onSeriesClick", function (seriesDataSelected) {
      _this.setState({
        activeDisplaySetInstanceUid: seriesDataSelected.displaySetInstanceUid
      });

      _this.props.onSeriesSelected(seriesDataSelected);
    });
    defineProperty(assertThisInitialized(_this), "showSeriesSwitch", function () {
      _this.setState({
        seriesQuickSwitchOpen: true
      });
    });
    defineProperty(assertThisInitialized(_this), "hideSeriesSwitch", function () {
      _this.setState({
        seriesQuickSwitchOpen: false
      });
    });
    _this.state = {
      seriesQuickSwitchOpen: false,
      sideClass: _this.props.side || '',
      activeStudyInstanceUid: _this.props.activeStudyInstanceUid,
      activeDisplaySetInstanceUid: _this.props.activeDisplaySetInstanceUid
    };
    return _this;
  }

  createClass(QuickSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;

      if (props.activeStudyInstanceUid !== prevProps.activeStudyInstanceUid) {
        this.setState({
          activeStudyInstanceUid: props.activeStudyInstanceUid
        });
      }

      if (props.activeDisplaySetInstanceUid !== prevProps.activeDisplaySetInstanceUid) {
        this.setState({
          activeDisplaySetInstanceUid: props.activeDisplaySetInstanceUid
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var quickSwitchClass = this.state.seriesQuickSwitchOpen ? 'series-triggered' : '';
      return React__default.createElement("div", {
        className: "series-quick-switch clearfix noselect ".concat(this.state.sideClass, " ").concat(quickSwitchClass),
        onMouseLeave: this.hideSeriesSwitch
      }, React__default.createElement("div", {
        className: "series-switch",
        onMouseEnter: this.showSeriesSwitch
      }, React__default.createElement("div", {
        className: "title-label"
      }, "Series"), React__default.createElement("div", {
        className: "series-box"
      }, this.getSmallListItems(), React__default.createElement(ScrollableArea, {
        scrollStep: 201,
        class: "series-browser"
      }, React__default.createElement(SeriesList, {
        seriesItems: this.getSeriesItems(),
        onClick: this.onSeriesClick,
        activeDisplaySetInstanceUid: this.state.activeDisplaySetInstanceUid
      })))), React__default.createElement("div", {
        className: "study-switch"
      }, React__default.createElement("div", {
        className: "title-label"
      }, "Study"), React__default.createElement("div", {
        className: "study-box"
      }, React__default.createElement(ScrollableArea, {
        scrollStep: 91,
        class: "study-browser"
      }, React__default.createElement(StudiesList, {
        studyListData: this.props.studyListData,
        onClick: this.onStudyClick,
        activeStudyInstanceUid: this.state.activeStudyInstanceUid
      })))));
    }
  }]);
  return QuickSwitch;
}(Component);

defineProperty(QuickSwitch, "propTypes", {
  side: propTypes.string,
  studyListData: propTypes.array.isRequired,
  onSeriesSelected: propTypes.func.isRequired,
  seriesListData: propTypes.array,
  onStudySelected: propTypes.func,
  activeStudyInstanceUid: propTypes.string,
  activeDisplaySetInstanceUid: propTypes.string
});
var css$w = ".RoundedButtonGroup {\n  --height: 25px;\n\n  position: relative;\n  z-index: 0;\n  float: right;\n}\n\n.roundedButtonWrapper {\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  margin-left: -2px;\n  text-decoration: none;\n  text-align: center;\n}\n\n.roundedButtonWrapper.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.RoundedButtonGroup .roundedButtonWrapper .roundedButton {\n  -webkit-box-align: center;\n          align-items: center;\n  background-color: var(--ui-gray-dark);\n  border: 2px solid var(--ui-border-color-dark);\n  color: var(--text-secondary-color);\n  display: -webkit-box;\n  display: flex;\n  font-size: 15px;\n  font-weight: 500;\n  -webkit-box-pack: center;\n          justify-content: center;\n  height: var(--height);\n  line-height: var(--height);\n  padding: 0 22px;\n  position: relative;\n  text-transform: uppercase;\n  -webkit-transition: var(--sidebar-transition);\n  transition: var(--sidebar-transition);\n  z-index: 1;\n}\n\n.roundedButtonWrapper\n  .roundedButton\n  svg\n  .roundedButtonWrapper\n  .roundedButton\n  span {\n  margin: 0 2px;\n}\n\n.roundedButtonWrapper .roundedButton i {\n  line-height: 15px;\n  font-size: 15px;\n}\n\n.bottomLabel {\n  color: var(--text-secondary-color);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  margin-top: 8px;\n}\n\n.roundedButtonWrapper:first-child {\n  margin-left: 0;\n}\n\n.RoundedButtonGroup .roundedButtonWrapper:first-child .roundedButton {\n  border-bottom-left-radius: var(--height);\n  border-top-left-radius: var(--height);\n}\n\n.RoundedButtonGroup .roundedButtonWrapper:last-child .roundedButton {\n  border-bottom-right-radius: var(--height);\n  border-top-right-radius: var(--height);\n}\n\n.roundedButtonWrapper:hover .roundedButton {\n  background-color: var(--box-background-color);\n  color: var(--ui-gray-dark);\n}\n\n.roundedButtonWrapper.disabled:hover .roundedButton {\n  background: none;\n  color: var(--text-secondary-color);\n}\n\n.roundedButtonWrapper.active .roundedButton {\n  background-color: var(--active-color);\n  border-color: var(--ui-border-color-active);\n  color: var(--ui-gray-dark);\n  z-index: 2;\n}\n";
styleInject(css$w);

var RoundedButtonGroup =
/*#__PURE__*/
function (_Component) {
  inherits(RoundedButtonGroup, _Component);

  function RoundedButtonGroup() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, RoundedButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(RoundedButtonGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "onClickOption", function (value) {
      if (value === 'demo') {
        var url = "http://qc.jfhealthcare.cn/index.html?id=2&systemType=0";
        window.open(url, '_blank');
        if (_this.props.onValueChanged) _this.props.onValueChanged('demo');
      } else if (!_this.props.rightSidePanelDisabled) {
        var newValue = value;
        if (_this.props.value === value) newValue = null;
        if (_this.props.onValueChanged) _this.props.onValueChanged(newValue);
      }
    });
    return _this;
  }

  createClass(RoundedButtonGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = classnames(RoundedButtonGroup.className, 'clearfix center-table');
      var buttons = this.props.options.map(function (option, index) {
        var className = classnames({
          roundedButtonWrapper: true,
          noselect: true,
          active: _this2.props.value === option.value
        });
        if (option.value === 'charts-panel' && _this2.props.rightSidePanelDisabled) className += ' disabled';
        var optionText = option.label && React__default.createElement("span", null, i18n$1.t(option.label));
        var iconProps = typeof option.icon === 'string' ? {
          name: option.icon
        } : option.icon;
        var bottomLabel = option.bottomLabel && React__default.createElement("div", {
          className: "bottomLabel"
        }, i18n$1.t(option.bottomLabel));
        return React__default.createElement("div", {
          key: index,
          className: className,
          onClick: function onClick() {
            return _this2.onClickOption(option.value);
          }
        }, React__default.createElement("div", {
          className: "roundedButton"
        }, optionText, iconProps && React__default.createElement(Icon, iconProps)), bottomLabel);
      });
      return React__default.createElement("div", {
        className: className
      }, buttons);
    }
  }]);
  return RoundedButtonGroup;
}(Component);

defineProperty(RoundedButtonGroup, "className", 'RoundedButtonGroup');
defineProperty(RoundedButtonGroup, "propTypes", {
  options: propTypes.arrayOf(propTypes.shape({
    value: propTypes.any,
    label: propTypes.string,
    icon: propTypes.oneOfType([propTypes.string, propTypes.shape({
      name: propTypes.string.isRequired
    })])
  })),
  value: propTypes.string,
  onValueChanged: propTypes.func,
  rightSidePanelDisabled: propTypes.bool
});
defineProperty(RoundedButtonGroup, "defaultProps", {
  options: [],
  value: null
});
var css$x = "* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.selectTreeRoot {\n  text-align: initial;\n  width: 320px;\n  max-height: inherit;\n  font-size: 14px;\n  line-height: 26px;\n}\n.selectTreeRoot .treeContent {\n  max-height: inherit;\n  overflow: hidden;\n  border: 1px solid #c4c4c4;\n  border-radius: 5px;\n  background-color: #fff;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.selectTreeRoot .treeHeader {\n  background-color: #c0c0c0;\n  border-bottom: 1px solid #c4c4c4;\n  color: #303030;\n  padding: 5px;\n  text-align: center;\n}\n.selectTreeRoot .treeHeader .wrapperText {\n  font-weight: bold;\n  padding-bottom: 2px;\n}\n.selectTreeRoot .treeHeader .wrapperSearch {\n  width: 100%;\n}\n.selectTreeRoot .treeHeader .searchIcon {\n  position: absolute;\n  width: 18px;\n  height: 15px;\n  margin: 7px 10px 13px 10px;\n  color: #a3a3a3;\n}\n.selectTreeRoot .treeHeader .searchInput {\n  width: 100%;\n  padding: 6px 12px 6px 35px;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);\n  -webkit-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.selectTreeRoot .treeHeader .searchInput:focus {\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);\n}\n.selectTreeRoot .wrapperText {\n  white-space: nowrap;\n  cursor: pointer;\n}\n.selectTreeRoot .selectTreeBreadcrumb .wrapperLabel {\n  cursor: pointer;\n  padding: 0 12px;\n  height: 41px;\n  width: 100%;\n  line-height: 41px;\n}\n.selectTreeRoot .selectTreeBreadcrumb .backIcon {\n  padding-right: 10px;\n}\n.selectTreeRoot .selectTreeBreadcrumb .backIcon svg {\n  width: 14px;\n  height: 14px;\n  position: relative;\n  top: 2px;\n  color: #457fb0;\n}\n.selectTreeRoot .treeOptions {\n  overflow: auto;\n  height: 100%;\n}\n.selectTreeRoot .treeOptions .selectTreeBreadcrumb + .treeInputsWrapper .treeInputs .treeLeaf {\n  border: none;\n  height: initial;\n  line-height: 26px;\n}\n.selectTreeRoot .treeOptions > .treeInputsWrapper > .treeInputs .treeLeaf {\n  border-bottom: 1px solid #ccc;\n  height: 41px;\n  line-height: 41px;\n}\n.selectTreeRoot .treeNode,\n.selectTreeRoot .treeLeaf {\n  cursor: pointer;\n  display: block;\n  overflow: hidden;\n  font-weight: normal;\n  box-shadow: 0 0 0 200px transparent;\n  padding: 0 12px;\n}\n.selectTreeRoot .treeNode {\n  border-bottom: 1px solid #ccc;\n  height: 41px;\n  line-height: 41px;\n}\n.selectTreeRoot .radioLabel .radioInput {\n  display: none;\n}\n";
styleInject(css$x);

var InputRadio =
/*#__PURE__*/
function (_Component) {
  inherits(InputRadio, _Component);

  function InputRadio() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, InputRadio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(InputRadio)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "onSelected", function (evt) {
      _this.props.onSelected(evt, _this.props.itemData);
    });
    return _this;
  }

  createClass(InputRadio, [{
    key: "render",
    value: function render() {
      var labelClass = this.props.labelClass ? this.props.labelClass : '';
      return React__default.createElement("label", {
        className: 'wrapperLabel radioLabel ' + labelClass,
        htmlFor: this.props.id
      }, React__default.createElement("input", {
        type: "radio",
        id: this.props.id,
        className: "radioInput",
        value: this.props.value,
        onChange: this.onSelected
      }), React__default.createElement("span", {
        className: "wrapperText"
      }, this.props.label));
    }
  }]);
  return InputRadio;
}(Component);

defineProperty(InputRadio, "propTypes", {
  value: propTypes.string,
  label: propTypes.string.isRequired,
  itemData: propTypes.object.isRequired,
  labelClass: propTypes.string,
  id: propTypes.string.isRequired,
  onSelected: propTypes.func.isRequired
});

var SelectTreeBreadcrumb =
/*#__PURE__*/
function (_Component) {
  inherits(SelectTreeBreadcrumb, _Component);

  function SelectTreeBreadcrumb() {
    classCallCheck(this, SelectTreeBreadcrumb);
    return possibleConstructorReturn(this, getPrototypeOf(SelectTreeBreadcrumb).apply(this, arguments));
  }

  createClass(SelectTreeBreadcrumb, [{
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "selectTreeBreadcrumb"
      }, React__default.createElement("label", {
        className: "wrapperLabel radioLabel",
        htmlFor: "selectTreeBreadcrumb"
      }, React__default.createElement("input", {
        type: "radio",
        id: "selectTreeBreadcrumb",
        className: "treeNode radioInput",
        value: this.props.value,
        onChange: this.props.onSelected
      }), React__default.createElement("span", {
        className: "wrapperText"
      }, React__default.createElement("span", {
        className: "backIcon"
      }, React__default.createElement(Icon, {
        name: "fast-backward"
      })), this.props.label)));
    }
  }]);
  return SelectTreeBreadcrumb;
}(Component);

defineProperty(SelectTreeBreadcrumb, "propTypes", {
  label: propTypes.string.isRequired,
  value: propTypes.string.isRequired,
  onSelected: propTypes.func.isRequired
});

var SelectTree =
/*#__PURE__*/
function (_Component) {
  inherits(SelectTree, _Component);

  function SelectTree(props) {
    var _this;

    classCallCheck(this, SelectTree);
    _this = possibleConstructorReturn(this, getPrototypeOf(SelectTree).call(this, props));
    defineProperty(assertThisInitialized(_this), "componentDidUpdate", function () {
      if (_this.props.onComponentChange) {
        _this.props.onComponentChange();
      }
    });
    defineProperty(assertThisInitialized(_this), "isLeafSelected", function (item) {
      return item && !Array.isArray(item.items);
    });
    defineProperty(assertThisInitialized(_this), "getLabelClass", function (item) {
      var labelClass = 'treeLeaf';

      if (_this.state.searchTerm || Array.isArray(item.items)) {
        labelClass = 'treeNode';
      }

      return labelClass;
    });
    defineProperty(assertThisInitialized(_this), "headerItem", function () {
      var title = _this.props.selectTreeFirstTitle;

      if (_this.state.currentNode && _this.props.selectTreeSecondTitle) {
        title = _this.props.selectTreeSecondTitle;
      }

      return React__default.createElement("div", {
        className: "wrapperLabel treeHeader"
      }, React__default.createElement("div", {
        className: "wrapperText"
      }, title), _this.props.searchEnabled && React__default.createElement("div", {
        className: "wrapperSearch"
      }, React__default.createElement("div", {
        className: "searchIcon"
      }, React__default.createElement(Icon, {
        name: "search"
      })), React__default.createElement("input", {
        type: "text",
        className: "searchInput",
        placeholder: "Search labels",
        autoFocus: _this.props.autoFocus,
        onChange: _this.searchLocations,
        value: _this.state.searchTerm ? _this.state.searchTerm : ''
      })));
    });
    defineProperty(assertThisInitialized(_this), "searchLocations", function (evt) {
      _this.setState({
        currentNode: null,
        searchTerm: evt.currentTarget.value
      });
    });
    defineProperty(assertThisInitialized(_this), "onSelected", function (event, item) {
      if (_this.isLeafSelected(item)) {
        _this.setState({
          searchTerm: null,
          currentNode: null,
          value: null
        });
      } else {
        _this.setState({
          currentNode: item
        });
      }

      return _this.props.onSelected(event, item);
    });
    defineProperty(assertThisInitialized(_this), "onBreadcrumbSelected", function () {
      _this.setState({
        currentNode: null
      });
    });
    _this.state = {
      searchTerm: null,
      currentNode: null,
      value: null
    };
    return _this;
  }

  createClass(SelectTree, [{
    key: "render",
    value: function render() {
      var treeItems = this.getTreeItems();
      return React__default.createElement("div", {
        className: "selectTree selectTreeRoot"
      }, React__default.createElement("div", {
        className: "treeContent"
      }, this.headerItem(), React__default.createElement("div", {
        className: "treeOptions"
      }, this.state.currentNode && React__default.createElement(SelectTreeBreadcrumb, {
        onSelected: this.onBreadcrumbSelected,
        label: this.state.currentNode.label,
        value: this.state.currentNode.value
      }), React__default.createElement("div", {
        className: "treeInputsWrapper"
      }, React__default.createElement("div", {
        className: "treeInputs"
      }, treeItems)))));
    }
  }, {
    key: "filterItems",
    value: function filterItems() {
      var _this2 = this;

      var filteredItems = [];
      var rawItems = lodash_clonedeep(this.props.items);
      rawItems.forEach(function (item) {
        if (Array.isArray(item.items)) {
          item.items.forEach(function (item) {
            var label = item.label.toLowerCase();

            var searchTerm = _this2.state.searchTerm.toLowerCase();

            if (label.indexOf(searchTerm) !== -1) {
              filteredItems.push(item);
            }
          });
        } else {
          var label = item.label.toLowerCase();

          var searchTerm = _this2.state.searchTerm.toLowerCase();

          if (label.indexOf(searchTerm) !== -1) {
            filteredItems.push(item);
          }
        }
      });
      return filteredItems;
    }
  }, {
    key: "getTreeItems",
    value: function getTreeItems() {
      var _this3 = this;

      var storageKey = 'SelectTree';
      var treeItems;

      if (this.state.searchTerm) {
        treeItems = this.filterItems();
      } else if (this.state.currentNode) {
        treeItems = lodash_clonedeep(this.state.currentNode.items);
      } else {
        treeItems = lodash_clonedeep(this.props.items);
      }

      return treeItems.map(function (item, index) {
        var itemKey = index;

        if (_this3.state.currentNode) {
          itemKey += "_".concat(_this3.state.currentNode.value);
        }

        return React__default.createElement(InputRadio, {
          key: itemKey,
          id: "".concat(storageKey, "_").concat(item.value),
          name: index,
          itemData: item,
          value: item.value,
          label: item.label,
          labelClass: _this3.getLabelClass(item),
          onSelected: _this3.onSelected
        });
      });
    }
  }]);
  return SelectTree;
}(Component);

defineProperty(SelectTree, "propTypes", {
  autoFocus: propTypes.bool,
  searchEnabled: propTypes.bool,
  selectTreeFirstTitle: propTypes.string,
  selectTreeSecondTitle: propTypes.string,

  /** Called when 'componentDidUpdate' is triggered */
  onComponentChange: propTypes.func,

  /** [{ label, value, items[]}] - An array of items than can be expanded to show child items */
  items: propTypes.array.isRequired,

  /** fn(evt, item) - Called when a child item is selected; receives event and selected item */
  onSelected: propTypes.func.isRequired
});
defineProperty(SelectTree, "defaultProps", {
  searchEnabled: true,
  autoFocus: true,
  selectTreeFirstTitle: 'First Level itens',
  items: []
});
var css$y = ".btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.btn.disabled,\n.btn[disabled],\nfieldset[disabled] .btn {\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.65;\n}\nbutton.close {\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.simpleDialog {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  z-index: 1000;\n  border: 0;\n  border-radius: 6px;\n  background-color: var(--ui-gray-darker);\n}\n.simpleDialog .header {\n  border-bottom: 3px solid var(--primary-background-color);\n  padding: 19px 22px 17px;\n  position: relative;\n}\n.simpleDialog .header .title {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  padding-right: 40px;\n  color: var(--text-secondary-color);\n  margin: 0;\n}\n.simpleDialog .header .closeBtn {\n  -webkit-transform: translateY(-50%);\n  color: var(--text-secondary-color);\n  height: 20px;\n  opacity: 1;\n  overflow: hidden;\n  padding: 2px;\n  position: absolute;\n  right: 21px;\n  text-align: center;\n  text-shadow: none;\n  top: 50%;\n  transform: translateY(-50%);\n  -webkit-transition: color 0.3s ease;\n  transition: color 0.3s ease;\n  width: 20px;\n}\n.simpleDialog .header .closeIcon {\n  color: transparent;\n  display: block;\n  font-size: 0;\n  height: 100%;\n  line-height: 0;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.simpleDialog .header .closeIcon:after,\n.simpleDialog .header .closeIcon:before {\n  content: ' ';\n  display: block;\n  height: 2px;\n  -webkit-transition: background-color 0.3s ease;\n  transition: background-color 0.3s ease;\n  width: 19px;\n  background-color: var(--text-secondary-color);\n}\n.simpleDialog .header .closeIcon:before {\n  left: 1px;\n  position: absolute;\n  top: 1px;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  -webkit-transform-origin: 1px 50%;\n  transform-origin: 1px 50%;\n}\n.simpleDialog .header .closeIcon:after {\n  right: 1px;\n  position: absolute;\n  top: 1px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: calc(100% - 1px) 50%;\n  transform-origin: calc(100% - 1px) 50%;\n}\n.simpleDialog .content {\n  padding: 16px 22px 25px;\n  position: relative;\n  color: var(--text-primary-color);\n}\n.simpleDialog .content .simpleDialogSelect,\n.simpleDialog .content .simpleDialogInput {\n  background-color: var(--input-background-color);\n  color: var(--text-primary-color);\n  border: 0;\n  border-radius: 2px;\n  font-size: 14px;\n  height: 30px;\n  width: 100%;\n  line-height: 16px;\n  padding: 8px 9px 6px;\n  margin-top: 10px;\n  display: block;\n}\n.simpleDialog .content .simpleDialogLabelFor {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 16px;\n  margin: 10px 0 0 0;\n  color: var(--text-primary-color);\n}\n.simpleDialog .footer {\n  padding: 15px;\n  text-align: right;\n}\n.simpleDialog .footer .btn {\n  margin-left: 5px;\n}\n";
styleInject(css$y);

var SimpleDialog =
/*#__PURE__*/
function (_Component) {
  inherits(SimpleDialog, _Component);

  function SimpleDialog() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, SimpleDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(SimpleDialog)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "onClose", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onClose();
    });
    defineProperty(assertThisInitialized(_this), "onConfirm", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onConfirm();
    });
    return _this;
  }

  createClass(SimpleDialog, [{
    key: "render",
    value: function render() {
      return React__default.createElement(React__default.Fragment, null, this.props.isOpen && React__default.createElement("div", {
        className: "simpleDialog ".concat(this.props.rootClass, " "),
        ref: this.props.componentRef,
        style: this.props.componentStyle
      }, React__default.createElement("form", null, React__default.createElement("div", {
        className: "header"
      }, React__default.createElement("span", {
        className: "closeBtn",
        onClick: this.onClose
      }, React__default.createElement("span", {
        className: "closeIcon"
      }, "x")), React__default.createElement("h4", {
        className: "title"
      }, this.props.headerTitle)), React__default.createElement("div", {
        className: "content"
      }, this.props.children), React__default.createElement("div", {
        className: "footer"
      }, React__default.createElement("button", {
        className: "btn btn-default",
        onClick: this.onClose
      }, "Cancel"), React__default.createElement("button", {
        className: "btn btn-primary",
        onClick: this.onConfirm
      }, "Confirm")))));
    }
  }]);
  return SimpleDialog;
}(Component);

defineProperty(SimpleDialog, "propTypes", {
  children: propTypes.node,
  componentRef: propTypes.any,
  componentStyle: propTypes.object,
  rootClass: propTypes.string,
  isOpen: propTypes.bool,
  headerTitle: propTypes.string.isRequired,
  onClose: propTypes.func.isRequired,
  onConfirm: propTypes.func.isRequired
});
defineProperty(SimpleDialog, "defaultProps", {
  isOpen: true,
  componentStyle: {},
  rootClass: ''
});
var runtime = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  !function (global) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var runtime = global.regeneratorRuntime;

    if (runtime) {
      {
        // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        module.exports = runtime;
      } // Don't bother evaluating the rest of this file if the runtime was
      // already defined globally.

      return;
    } // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.


    runtime = global.regeneratorRuntime = module.exports;

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    runtime.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    runtime.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    runtime.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    runtime.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          if (delegate.iterator.return) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    runtime.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    runtime.values = values;

    function doneResult() {
      return {
        value: undefined,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }

        return ContinueSentinel;
      }
    };
  }( // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  function () {
    return this || typeof self === "object" && self;
  }() || Function("return this")());
});
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js

var g$2 = function () {
  return this || typeof self === "object" && self;
}() || Function("return this")(); // Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.


var hadRuntime = g$2.regeneratorRuntime && Object.getOwnPropertyNames(g$2).indexOf("regeneratorRuntime") >= 0; // Save the old regeneratorRuntime in case it needs to be restored later.

var oldRuntime = hadRuntime && g$2.regeneratorRuntime; // Force reevalutation of runtime.js.

g$2.regeneratorRuntime = undefined;
var runtimeModule = runtime;

if (hadRuntime) {
  // Restore the original runtime.
  g$2.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g$2.regeneratorRuntime;
  } catch (e) {
    g$2.regeneratorRuntime = undefined;
  }
}

var regenerator = runtimeModule;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator;
var css$z = ".form-themed table {\n  color: var(--text-primary-color);\n}\n.form-themed table th,\n.form-themed table td {\n  font-size: 15px;\n  font-weight: normal;\n}\n.form-themed table th {\n  line-height: 60px;\n}\n.form-themed table td {\n  line-height: 18px;\n  padding: 0;\n}\n.form-themed .p-r-1 {\n  padding-right: 1rem !important;\n}\n.form-themed label {\n  margin-bottom: 5px;\n}\n.form-themed label.wrapperLabel {\n  cursor: pointer;\n}\n.form-themed label.wrapperLabel:not(.checkboxLabel) {\n  cursor: pointer;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.form-themed label.wrapperLabel:not(.checkboxLabel) .wrapperText {\n  display: block;\n  -webkit-box-ordinal-group: 0;\n          order: -1;\n}\n.form-themed .btn[disabled],\n.form-themed input[type=text][disabled],\n.form-themed input[type=password][disabled],\n.form-themed input[type=number][disabled],\n.form-themed .btn.disabled,\n.form-themed input[type=text].disabled,\n.form-themed input[type=password].disabled,\n.form-themed input[type=number].disabled,\n.form-themed .btn[disabled]:hover,\n.form-themed input[type=text][disabled]:hover,\n.form-themed input[type=password][disabled]:hover,\n.form-themed input[type=number][disabled]:hover,\n.form-themed .btn.disabled:hover,\n.form-themed input[type=text].disabled:hover,\n.form-themed input[type=password].disabled:hover,\n.form-themed input[type=number].disabled:hover,\n.form-themed .btn[disabled]:active,\n.form-themed input[type=text][disabled]:active,\n.form-themed input[type=password][disabled]:active,\n.form-themed input[type=number][disabled]:active,\n.form-themed .btn.disabled:active,\n.form-themed input[type=text].disabled:active,\n.form-themed input[type=password].disabled:active,\n.form-themed input[type=number].disabled:active {\n  background-color: var(--ui-gray-darker);\n  border-color: var(--ui-gray-light);\n  color: var(--text-primary-color);\n}\n.form-themed .btn[disabled] + .wrapperText,\n.form-themed input[type=text][disabled] + .wrapperText,\n.form-themed input[type=password][disabled] + .wrapperText,\n.form-themed input[type=number][disabled] + .wrapperText,\n.form-themed .btn.disabled + .wrapperText,\n.form-themed input[type=text].disabled + .wrapperText,\n.form-themed input[type=password].disabled + .wrapperText,\n.form-themed input[type=number].disabled + .wrapperText,\n.form-themed .btn[disabled]:hover + .wrapperText,\n.form-themed input[type=text][disabled]:hover + .wrapperText,\n.form-themed input[type=password][disabled]:hover + .wrapperText,\n.form-themed input[type=number][disabled]:hover + .wrapperText,\n.form-themed .btn.disabled:hover + .wrapperText,\n.form-themed input[type=text].disabled:hover + .wrapperText,\n.form-themed input[type=password].disabled:hover + .wrapperText,\n.form-themed input[type=number].disabled:hover + .wrapperText,\n.form-themed .btn[disabled]:active + .wrapperText,\n.form-themed input[type=text][disabled]:active + .wrapperText,\n.form-themed input[type=password][disabled]:active + .wrapperText,\n.form-themed input[type=number][disabled]:active + .wrapperText,\n.form-themed .btn.disabled:active + .wrapperText,\n.form-themed input[type=text].disabled:active + .wrapperText,\n.form-themed input[type=password].disabled:active + .wrapperText,\n.form-themed input[type=number].disabled:active + .wrapperText {\n  color: var(--text-primary-color);\n  cursor: auto;\n}\n.form-themed input[type=text],\n.form-themed input[type=password],\n.form-themed input[type=number] {\n  background-color: var(--ui-gray);\n  border-color: var(--ui-border-color);\n  color: var(--text-primary-color);\n  font-weight: normal;\n}\n.form-themed input[type=text]:active,\n.form-themed input[type=password]:active,\n.form-themed input[type=number]:active,\n.form-themed input[type=text]:focus,\n.form-themed input[type=password]:focus,\n.form-themed input[type=number]:focus {\n  background-color: var(--ui-gray-dark);\n  border: 2px solid var(--active-color);\n  box-shadow: none;\n}\n.form-themed input[type=text]:active + .wrapperText,\n.form-themed input[type=password]:active + .wrapperText,\n.form-themed input[type=number]:active + .wrapperText,\n.form-themed input[type=text]:focus + .wrapperText,\n.form-themed input[type=password]:focus + .wrapperText,\n.form-themed input[type=number]:focus + .wrapperText {\n  color: var(--active-color);\n}\n.form-themed .btn-primary {\n  background-color: var(--active-color);\n  border-collapse: var(--ui-border-color-active);\n  color: var(--ui-text-color-active);\n}\n.form-themed .btn-primary:hover,\n.form-themed .btn-primary:active,\n.form-themed .btn-primary:focus,\n.form-themed .btn-primary:focus:active {\n  background-color: var(--ui-active-color);\n  border-collapse: var(--ui-border-color-active);\n  color: var(--ui-text-color-active);\n}\n.form-themed .form-control {\n  background-color: #fff;\n  border: 0;\n  font-size: 14px;\n  height: 30px;\n  line-height: 16px;\n  padding: 8px 9px 6px;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);\n}\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);\n}\n.form-control::-ms-expand {\n  border: 0;\n  background-color: transparent;\n}\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: ;\n  opacity: 1;\n}\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: ;\n}\ninput[type=range] {\n  display: block;\n  width: 100%;\n}\n* {\n  box-sizing: border-box;\n}\n.full-width {\n  width: 100%;\n}\n.full-height {\n  height: 100%;\n}\n.flex-h {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.flex-v {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n          flex-direction: column;\n}\n.flex-grow {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n}\n.nowrap {\n  white-space: nowrap;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\nh1 {\n  font-size: 36px;\n}\nh3,\nh1 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.row {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.pull-left {\n  float: left !important;\n}\n.pull-right {\n  float: right !important;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n.DateRangePicker {\n  height: 40px;\n  margin: 0 5px 20px 5px;\n  cursor: pointer;\n  border: none;\n  position: block;\n}\n.studyListToolbar {\n  background-color: var(--ui-gray-darker);\n  height: 75px;\n  margin-bottom: 2px;\n  padding: 0 8%;\n}\n.studyListToolbar>div {\n  display: inline-block;\n}\n.studyListToolbar .header {\n  font-size: 22px;\n  font-weight: 300;\n  color: var(--table-text-secondary-color);\n  line-height: 75px;\n}\n.studyListToolbar .studylistToolbar {\n  height: 75px;\n  line-height: 75px;\n}\n.studyListToolbar .studyCount {\n  color: var(--large-numbers-color);\n  font-size: 40px;\n  font-weight: 100;\n  line-height: 75px;\n}\n.theadBackground {\n  height: 121px;\n  position: absolute;\n  width: 100%;\n}\n.theadBackground:before,\n.theadBackground:after {\n  content: '';\n  display: block;\n  left: 0;\n  position: absolute;\n  width: 100%;\n}\n.theadBackground:before {\n  background-color: var(--ui-gray-darker);\n  height: 100%;\n  top: 0;\n  z-index: 1;\n}\n.theadBackground:after {\n  background-color: var(--ui-border-color-active);\n  bottom: -1px;\n  height: 1px;\n  z-index: 2;\n}\n#studyListContainer {\n  width: 100%;\n  padding: 0 8%;\n  position: absolute;\n  z-index: 2;\n}\n#studyListContainer .loading-text {\n  color: var(--table-text-secondary-color);\n  font-size: 30px;\n}\n#studyListContainer .notFound {\n  color: var(--table-text-secondary-color);\n  font-size: 30px;\n  font-weight: 200;\n  text-align: center;\n}\n#studyListContainer table#tblStudyList {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n#studyListContainer table#tblStudyList > tr {\n  height: 20px;\n}\n#studyListContainer table#tblStudyList > thead {\n  white-space: nowrap;\n}\n#studyListContainer table#tblStudyList > thead tr th {\n  padding: 0;\n  border-bottom: 1px solid var(--ui-border-color-active);\n  width: 100%;\n  text-align: left;\n  border-top: 0;\n}\n#studyListContainer table#tblStudyList > thead tr th.studyDate {\n  min-width: 230px;\n}\n#studyListContainer table#tblStudyList > thead tr th .display-text {\n  display: inline-block;\n  cursor: pointer;\n  width: 100%;\n  min-width: 95px;\n  margin: 0 auto;\n  color: var(--table-text-primary-color);\n  font-weight: 400;\n  padding: 20px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n#studyListContainer table#tblStudyList > thead tr th .display-text span {\n  font-size: 15px;\n  float: left;\n}\n#studyListContainer table#tblStudyList > thead tr th .display-text i {\n  margin: 0 5px;\n}\n#studyListContainer table#tblStudyList > thead tr th .display-text:hover {\n  color: var(--active-color);\n}\n#studyListContainer table#tblStudyList > thead tr th .display-text.active,\n#studyListContainer table#tblStudyList > thead tr th .display-text:active {\n  color: var(--active-color);\n}\n#studyListContainer table#tblStudyList > thead tr th input.studylist-search {\n  height: 40px;\n  margin: 0 5px 20px 5px;\n  padding: 0 20px;\n  cursor: pointer;\n  border: none;\n  background-color: var(--input-background-color);\n  color: var(--input-placeholder-color);\n  font-size: 10pt;\n  font-weight: normal;\n  width: calc(100% - 10px);\n  border-radius: 4px;\n}\n#studyListContainer table#tblStudyList > thead tr th input.studylist-search::-webkit-input-placeholder {\n  color: var(--input-placeholder-color);\n}\n#studyListContainer table#tblStudyList > thead tr th input.studylist-search:-moz-placeholder {\n  color: var(--input-placeholder-color);\n}\n#studyListContainer table#tblStudyList > thead tr th input.studylist-search::-moz-placeholder {\n  color: var(--input-placeholder-color);\n}\n#studyListContainer table#tblStudyList > thead tr th input.studylist-search:-ms-input-placeholder {\n  color: var(--input-placeholder-color);\n}\n#studyListContainer table#tblStudyList > thead tr th input.studylist-search.invisible {\n  visibility: hidden;\n}\n#studyListContainer table#tblStudyList > thead tr th input.studylist-search:active,\n#studyListContainer table#tblStudyList > thead tr th input.studylist-search:hover {\n  background-color: var(--input-background-color);\n}\n#studyListContainer table#tblStudyList > thead ::-webkit-datetime-edit-year-field:not([aria-valuenow]),\n#studyListContainer table#tblStudyList > thead ::-webkit-datetime-edit-month-field:not([aria-valuenow]),\n#studyListContainer table#tblStudyList > thead ::-webkit-datetime-edit-day-field:not([aria-valuenow]) {\n  color: transparent;\n}\n#studyListContainer table#tblStudyList > tbody tr {\n  padding: 5px;\n  background-color: #000;\n}\n#studyListContainer table#tblStudyList > tbody tr:nth-child(even) {\n  background-color: var(--ui-gray-darker);\n}\n#studyListContainer table#tblStudyList > tbody tr td {\n  padding: 8px;\n  height: 40px;\n  line-height: 40px;\n  color: var(--table-text-primary-color);\n  font-weight: 300;\n  border-top: 1px solid var(--ui-gray-lighter);\n  border-bottom: 1px solid var(--ui-gray-lighter);\n  white-space: nowrap;\n}\n#studyListContainer table#tblStudyList > tbody tr td.emptyCell {\n  color: #516873;\n}\n#studyListContainer table#tblStudyList > tbody tr td.emptyValue {\n  color: var(--ui-gray-light);\n}\n#studyListContainer table#tblStudyList > tbody tr:hover,\n#studyListContainer table#tblStudyList > tbody tr:active,\n#studyListContainer table#tblStudyList > tbody tr.active {\n  background-color: var(--table-hover-color);\n  color: var(--text-primary-color);\n}\n#studyListContainer table#tblStudyList > tbody tr:hover td,\n#studyListContainer table#tblStudyList > tbody tr:active td,\n#studyListContainer table#tblStudyList > tbody tr.active td {\n  border-top: 1px solid var(--ui-gray-lighter);\n  border-bottom: 1px solid var(--ui-gray-lighter);\n  background-color: var(--table-hover-color);\n}\n@media only screen and (max-width: 1362px) {\n  #studyListContainer {\n    padding: 0 5%;\n  }\n  #studyListContainer table#tblStudyList thead tr th:first-child,\n  #studyListContainer table#tblStudyList tbody tr th:first-child,\n  #studyListContainer table#tblStudyList thead tr td:first-child,\n  #studyListContainer table#tblStudyList tbody tr td:first-child {\n    padding-left: 5%;\n  }\n  #studyListContainer table#tblStudyList thead tr th:last-child,\n  #studyListContainer table#tblStudyList tbody tr th:last-child,\n  #studyListContainer table#tblStudyList thead tr td:last-child,\n  #studyListContainer table#tblStudyList tbody tr td:last-child {\n    padding-right: 5%;\n  }\n}\n@media only screen and (max-width: 1161px) {\n  #studyListContainer {\n    padding: 0 $tablePaddingBigWidth;\n  }\n  #studyListContainer table#tblStudyList thead tr th:first-child,\n  #studyListContainer table#tblStudyList tbody tr th:first-child,\n  #studyListContainer table#tblStudyList thead tr td:first-child,\n  #studyListContainer table#tblStudyList tbody tr td:first-child {\n    padding-left: 3%;\n  }\n  #studyListContainer table#tblStudyList thead tr th:last-child,\n  #studyListContainer table#tblStudyList tbody tr th:last-child,\n  #studyListContainer table#tblStudyList thead tr td:last-child,\n  #studyListContainer table#tblStudyList tbody tr td:last-child {\n    padding-right: 3%;\n  }\n}\n@media only screen and (max-width: 1069px) {\n  .theadBackground {\n    height: 101px;\n  }\n  .studylist-pagination > .row {\n    margin-right: 0;\n  }\n  .studyListToolbar {\n    padding: 0 5px;\n  }\n  #studyListContainer {\n    padding: 0;\n  }\n  #studyListContainer table#tblStudyList thead > tr > th:first-child {\n    padding-left: 5px;\n  }\n  #studyListContainer table#tblStudyList thead > tr > th:last-child {\n    padding-right: 5px;\n  }\n  #studyListContainer table#tblStudyList thead > tr > th input.worklist-search {\n    padding: 10px;\n  }\n  #studyListContainer table#tblStudyList thead > tr > th .display-text {\n    padding: 10px 5px;\n  }\n  #studyListContainer table#tblStudyList thead > tr > th .display-text i {\n    width: auto;\n  }\n  #studyListContainer table#tblStudyList tbody > tr > td:first-child {\n    padding-left: 5px;\n  }\n  #studyListContainer table#tblStudyList tbody > tr > td:last-child {\n    padding-right: 5px;\n  }\n  #studyListContainer .worklistPagination .row {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n";
styleInject(css$z);
var toStr = Object.prototype.toString;

var isArguments = function isArguments(value) {
  var str = toStr.call(value);
  var isArgs = str === '[object Arguments]';

  if (!isArgs) {
    isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
  }

  return isArgs;
};

var keysShim;

if (!Object.keys) {
  // modified from https://github.com/es-shims/es5-shim
  var has$2 = Object.prototype.hasOwnProperty;
  var toStr$1 = Object.prototype.toString;
  var isArgs = isArguments; // eslint-disable-line global-require

  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var hasDontEnumBug = !isEnumerable.call({
    toString: null
  }, 'toString');
  var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
  var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];

  var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
    var ctor = o.constructor;
    return ctor && ctor.prototype === o;
  };

  var excludedKeys = {
    $applicationCache: true,
    $console: true,
    $external: true,
    $frame: true,
    $frameElement: true,
    $frames: true,
    $innerHeight: true,
    $innerWidth: true,
    $onmozfullscreenchange: true,
    $onmozfullscreenerror: true,
    $outerHeight: true,
    $outerWidth: true,
    $pageXOffset: true,
    $pageYOffset: true,
    $parent: true,
    $scrollLeft: true,
    $scrollTop: true,
    $scrollX: true,
    $scrollY: true,
    $self: true,
    $webkitIndexedDB: true,
    $webkitStorageInfo: true,
    $window: true
  };

  var hasAutomationEqualityBug = function () {
    /* global window */
    if (typeof window === 'undefined') {
      return false;
    }

    for (var k in window) {
      try {
        if (!excludedKeys['$' + k] && has$2.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
          try {
            equalsConstructorPrototype(window[k]);
          } catch (e) {
            return true;
          }
        }
      } catch (e) {
        return true;
      }
    }

    return false;
  }();

  var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
    /* global window */
    if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
      return equalsConstructorPrototype(o);
    }

    try {
      return equalsConstructorPrototype(o);
    } catch (e) {
      return false;
    }
  };

  keysShim = function keys(object) {
    var isObject = object !== null && typeof object === 'object';
    var isFunction = toStr$1.call(object) === '[object Function]';
    var isArguments$$1 = isArgs(object);
    var isString = isObject && toStr$1.call(object) === '[object String]';
    var theKeys = [];

    if (!isObject && !isFunction && !isArguments$$1) {
      throw new TypeError('Object.keys called on a non-object');
    }

    var skipProto = hasProtoEnumBug && isFunction;

    if (isString && object.length > 0 && !has$2.call(object, 0)) {
      for (var i = 0; i < object.length; ++i) {
        theKeys.push(String(i));
      }
    }

    if (isArguments$$1 && object.length > 0) {
      for (var j = 0; j < object.length; ++j) {
        theKeys.push(String(j));
      }
    } else {
      for (var name in object) {
        if (!(skipProto && name === 'prototype') && has$2.call(object, name)) {
          theKeys.push(String(name));
        }
      }
    }

    if (hasDontEnumBug) {
      var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

      for (var k = 0; k < dontEnums.length; ++k) {
        if (!(skipConstructor && dontEnums[k] === 'constructor') && has$2.call(object, dontEnums[k])) {
          theKeys.push(dontEnums[k]);
        }
      }
    }

    return theKeys;
  };
}

var implementation$2 = keysShim;
var slice = Array.prototype.slice;
var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) {
  return origKeys(o);
} : implementation$2;
var originalKeys = Object.keys;

keysShim$1.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function () {
      // Safari 5.0 bug
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);

    if (!keysWorksWithArguments) {
      Object.keys = function keys(object) {
        // eslint-disable-line func-name-matching
        if (isArguments(object)) {
          return originalKeys(slice.call(object));
        }

        return originalKeys(object);
      };
    }
  } else {
    Object.keys = keysShim$1;
  }

  return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var toStr$2 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction$1 = function isFunction$1(fn) {
  return typeof fn === 'function' && toStr$2.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
  var obj = {};

  try {
    origDefineProperty(obj, 'x', {
      enumerable: false,
      value: obj
    }); // eslint-disable-next-line no-unused-vars, no-restricted-syntax

    for (var _ in obj) {
      // jscs:ignore disallowUnusedVariables
      return false;
    }

    return obj.x === obj;
  } catch (e) {
    /* this is IE 8. */
    return false;
  }
};

var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty$7 = function defineProperty$7(object, name, value, predicate) {
  if (name in object && (!isFunction$1(predicate) || !predicate())) {
    return;
  }

  if (supportsDescriptors) {
    origDefineProperty(object, name, {
      configurable: true,
      enumerable: false,
      value: value,
      writable: true
    });
  } else {
    object[name] = value;
  }
};

var defineProperties = function defineProperties(object, map) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props = objectKeys(map);

  if (hasSymbols) {
    props = concat.call(props, Object.getOwnPropertySymbols(map));
  }

  for (var i = 0; i < props.length; i += 1) {
    defineProperty$7(object, props[i], map[props[i]], predicates[props[i]]);
  }
};

defineProperties.supportsDescriptors = !!supportsDescriptors;
var defineProperties_1 = defineProperties;
/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice$1 = Array.prototype.slice;
var toStr$3 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$3 = function bind(that) {
  var target = this;

  if (typeof target !== 'function' || toStr$3.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }

  var args = slice$1.call(arguments, 1);
  var bound;

  var binder = function binder() {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice$1.call(arguments)));

      if (Object(result) === result) {
        return result;
      }

      return this;
    } else {
      return target.apply(that, args.concat(slice$1.call(arguments)));
    }
  };

  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];

  for (var i = 0; i < boundLength; i++) {
    boundArgs.push('$' + i);
  }

  bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

  if (target.prototype) {
    var Empty = function Empty() {};

    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }

  return bound;
};

var functionBind = Function.prototype.bind || implementation$3;
var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var isPrimitive = function isPrimitive(value) {
  return value === null || typeof value !== 'function' && typeof value !== 'object';
};

var fnToStr = Function.prototype.toString;
var constructorRegex = /^\s*class\b/;

var isES6ClassFn = function isES6ClassFunction(value) {
  try {
    var fnStr = fnToStr.call(value);
    return constructorRegex.test(fnStr);
  } catch (e) {
    return false; // not a function
  }
};

var tryFunctionObject = function tryFunctionToStr(value) {
  try {
    if (isES6ClassFn(value)) {
      return false;
    }

    fnToStr.call(value);
    return true;
  } catch (e) {
    return false;
  }
};

var toStr$4 = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isCallable = function isCallable(value) {
  if (!value) {
    return false;
  }

  if (typeof value !== 'function' && typeof value !== 'object') {
    return false;
  }

  if (typeof value === 'function' && !value.prototype) {
    return true;
  }

  if (hasToStringTag) {
    return tryFunctionObject(value);
  }

  if (isES6ClassFn(value)) {
    return false;
  }

  var strClass = toStr$4.call(value);
  return strClass === fnClass || strClass === genClass;
};

var getDay = Date.prototype.getDay;

var tryDateObject = function tryDateObject(value) {
  try {
    getDay.call(value);
    return true;
  } catch (e) {
    return false;
  }
};

var toStr$5 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$1 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isDateObject = function isDateObject(value) {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  return hasToStringTag$1 ? tryDateObject(value) : toStr$5.call(value) === dateClass;
};
/* eslint complexity: [2, 17], max-statements: [2, 33] */


var shams = function hasSymbols() {
  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
    return false;
  }

  if (typeof Symbol.iterator === 'symbol') {
    return true;
  }

  var obj = {};
  var sym = Symbol('test');
  var symObj = Object(sym);

  if (typeof sym === 'string') {
    return false;
  }

  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
    return false;
  }

  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
    return false;
  } // temp disabled per https://github.com/ljharb/object.assign/issues/17
  // if (sym instanceof Symbol) { return false; }
  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
  // if (!(symObj instanceof Symbol)) { return false; }
  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }


  var symVal = 42;
  obj[sym] = symVal;

  for (sym in obj) {
    return false;
  } // eslint-disable-line no-restricted-syntax


  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
    return false;
  }

  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }

  var syms = Object.getOwnPropertySymbols(obj);

  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }

  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }

  if (typeof Object.getOwnPropertyDescriptor === 'function') {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);

    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }

  return true;
};

var origSymbol = commonjsGlobal.Symbol;

var hasSymbols$1 = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }

  if (typeof Symbol !== 'function') {
    return false;
  }

  if (typeof origSymbol('foo') !== 'symbol') {
    return false;
  }

  if (typeof Symbol('bar') !== 'symbol') {
    return false;
  }

  return shams();
};

var isSymbol$1 = createCommonjsModule(function (module) {
  var toStr = Object.prototype.toString;
  var hasSymbols = hasSymbols$1();

  if (hasSymbols) {
    var symToStr = Symbol.prototype.toString;
    var symStringRegex = /^Symbol\(.*\)$/;

    var isSymbolObject = function isRealSymbolObject(value) {
      if (typeof value.valueOf() !== 'symbol') {
        return false;
      }

      return symStringRegex.test(symToStr.call(value));
    };

    module.exports = function isSymbol(value) {
      if (typeof value === 'symbol') {
        return true;
      }

      if (toStr.call(value) !== '[object Symbol]') {
        return false;
      }

      try {
        return isSymbolObject(value);
      } catch (e) {
        return false;
      }
    };
  } else {
    module.exports = function isSymbol(value) {
      // this environment does not support Symbols.
      return false;
    };
  }
});
var hasSymbols$2 = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
  if (typeof O === 'undefined' || O === null) {
    throw new TypeError('Cannot call method on ' + O);
  }

  if (typeof hint !== 'string' || hint !== 'number' && hint !== 'string') {
    throw new TypeError('hint must be "string" or "number"');
  }

  var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
  var method, result, i;

  for (i = 0; i < methodNames.length; ++i) {
    method = O[methodNames[i]];

    if (isCallable(method)) {
      result = method.call(O);

      if (isPrimitive(result)) {
        return result;
      }
    }
  }

  throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
  var func = O[P];

  if (func !== null && typeof func !== 'undefined') {
    if (!isCallable(func)) {
      throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
    }

    return func;
  }

  return void 0;
}; // http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive


var es2015 = function ToPrimitive(input) {
  if (isPrimitive(input)) {
    return input;
  }

  var hint = 'default';

  if (arguments.length > 1) {
    if (arguments[1] === String) {
      hint = 'string';
    } else if (arguments[1] === Number) {
      hint = 'number';
    }
  }

  var exoticToPrim;

  if (hasSymbols$2) {
    if (Symbol.toPrimitive) {
      exoticToPrim = GetMethod(input, Symbol.toPrimitive);
    } else if (isSymbol$1(input)) {
      exoticToPrim = Symbol.prototype.valueOf;
    }
  }

  if (typeof exoticToPrim !== 'undefined') {
    var result = exoticToPrim.call(input, hint);

    if (isPrimitive(result)) {
      return result;
    }

    throw new TypeError('unable to convert exotic object to primitive');
  }

  if (hint === 'default' && (isDateObject(input) || isSymbol$1(input))) {
    hint = 'string';
  }

  return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

var es6 = es2015;
/* globals
	Set,
	Map,
	WeakSet,
	WeakMap,

	Promise,

	Symbol,
	Proxy,

	Atomics,
	SharedArrayBuffer,

	ArrayBuffer,
	DataView,
	Uint8Array,
	Float32Array,
	Float64Array,
	Int8Array,
	Int16Array,
	Int32Array,
	Uint8ClampedArray,
	Uint16Array,
	Uint32Array,
*/

var undefined$1; // eslint-disable-line no-shadow-restricted-names

var ThrowTypeError = Object.getOwnPropertyDescriptor ? function () {
  return Object.getOwnPropertyDescriptor(arguments, 'callee').get;
}() : function () {
  throw new TypeError();
};
var hasSymbols$3 = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var getProto = Object.getPrototypeOf || function (x) {
  return x.__proto__;
}; // eslint-disable-line no-proto


var generatorFunction = undefined$1;
var asyncFunction = undefined$1;
var asyncGenFunction = undefined$1;
var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  '$ %Array%': Array,
  '$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
  '$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer.prototype,
  '$ %ArrayIteratorPrototype%': hasSymbols$3 ? getProto([][Symbol.iterator]()) : undefined$1,
  '$ %ArrayPrototype%': Array.prototype,
  '$ %ArrayProto_entries%': Array.prototype.entries,
  '$ %ArrayProto_forEach%': Array.prototype.forEach,
  '$ %ArrayProto_keys%': Array.prototype.keys,
  '$ %ArrayProto_values%': Array.prototype.values,
  '$ %AsyncFromSyncIteratorPrototype%': undefined$1,
  '$ %AsyncFunction%': asyncFunction,
  '$ %AsyncFunctionPrototype%': undefined$1,
  '$ %AsyncGenerator%': undefined$1,
  '$ %AsyncGeneratorFunction%': asyncGenFunction,
  '$ %AsyncGeneratorPrototype%': undefined$1,
  '$ %AsyncIteratorPrototype%': undefined$1,
  '$ %Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
  '$ %Boolean%': Boolean,
  '$ %BooleanPrototype%': Boolean.prototype,
  '$ %DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
  '$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined$1 : DataView.prototype,
  '$ %Date%': Date,
  '$ %DatePrototype%': Date.prototype,
  '$ %decodeURI%': decodeURI,
  '$ %decodeURIComponent%': decodeURIComponent,
  '$ %encodeURI%': encodeURI,
  '$ %encodeURIComponent%': encodeURIComponent,
  '$ %Error%': Error,
  '$ %ErrorPrototype%': Error.prototype,
  '$ %eval%': eval,
  // eslint-disable-line no-eval
  '$ %EvalError%': EvalError,
  '$ %EvalErrorPrototype%': EvalError.prototype,
  '$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
  '$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array.prototype,
  '$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
  '$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array.prototype,
  '$ %Function%': Function,
  '$ %FunctionPrototype%': Function.prototype,
  '$ %Generator%': undefined$1,
  '$ %GeneratorFunction%': generatorFunction,
  '$ %GeneratorPrototype%': undefined$1,
  '$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
  '$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array.prototype,
  '$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
  '$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined$1 : Int8Array.prototype,
  '$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
  '$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array.prototype,
  '$ %isFinite%': isFinite,
  '$ %isNaN%': isNaN,
  '$ %IteratorPrototype%': hasSymbols$3 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  '$ %JSON%': JSON,
  '$ %JSONParse%': JSON.parse,
  '$ %Map%': typeof Map === 'undefined' ? undefined$1 : Map,
  '$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$3 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
  '$ %MapPrototype%': typeof Map === 'undefined' ? undefined$1 : Map.prototype,
  '$ %Math%': Math,
  '$ %Number%': Number,
  '$ %NumberPrototype%': Number.prototype,
  '$ %Object%': Object,
  '$ %ObjectPrototype%': Object.prototype,
  '$ %ObjProto_toString%': Object.prototype.toString,
  '$ %ObjProto_valueOf%': Object.prototype.valueOf,
  '$ %parseFloat%': parseFloat,
  '$ %parseInt%': parseInt,
  '$ %Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
  '$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined$1 : Promise.prototype,
  '$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined$1 : Promise.prototype.then,
  '$ %Promise_all%': typeof Promise === 'undefined' ? undefined$1 : Promise.all,
  '$ %Promise_reject%': typeof Promise === 'undefined' ? undefined$1 : Promise.reject,
  '$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined$1 : Promise.resolve,
  '$ %Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
  '$ %RangeError%': RangeError,
  '$ %RangeErrorPrototype%': RangeError.prototype,
  '$ %ReferenceError%': ReferenceError,
  '$ %ReferenceErrorPrototype%': ReferenceError.prototype,
  '$ %Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
  '$ %RegExp%': RegExp,
  '$ %RegExpPrototype%': RegExp.prototype,
  '$ %Set%': typeof Set === 'undefined' ? undefined$1 : Set,
  '$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$3 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
  '$ %SetPrototype%': typeof Set === 'undefined' ? undefined$1 : Set.prototype,
  '$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
  '$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer.prototype,
  '$ %String%': String,
  '$ %StringIteratorPrototype%': hasSymbols$3 ? getProto(''[Symbol.iterator]()) : undefined$1,
  '$ %StringPrototype%': String.prototype,
  '$ %Symbol%': hasSymbols$3 ? Symbol : undefined$1,
  '$ %SymbolPrototype%': hasSymbols$3 ? Symbol.prototype : undefined$1,
  '$ %SyntaxError%': SyntaxError,
  '$ %SyntaxErrorPrototype%': SyntaxError.prototype,
  '$ %ThrowTypeError%': ThrowTypeError,
  '$ %TypedArray%': TypedArray,
  '$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined$1,
  '$ %TypeError%': TypeError,
  '$ %TypeErrorPrototype%': TypeError.prototype,
  '$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
  '$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array.prototype,
  '$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
  '$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray.prototype,
  '$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
  '$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array.prototype,
  '$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
  '$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array.prototype,
  '$ %URIError%': URIError,
  '$ %URIErrorPrototype%': URIError.prototype,
  '$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
  '$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap.prototype,
  '$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet,
  '$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet.prototype
};

var GetIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
    throw new TypeError('"allowMissing" argument must be a boolean');
  }

  var key = '$ ' + name;

  if (!(key in INTRINSICS)) {
    throw new SyntaxError('intrinsic ' + name + ' does not exist!');
  } // istanbul ignore if // hopefully this is impossible to test :-)


  if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
    throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
  }

  return INTRINSICS[key];
};

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var predicates = {
  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
  'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
    if (ES.Type(Desc) !== 'Object') {
      return false;
    }

    var allowed = {
      '[[Configurable]]': true,
      '[[Enumerable]]': true,
      '[[Get]]': true,
      '[[Set]]': true,
      '[[Value]]': true,
      '[[Writable]]': true
    };

    for (var key in Desc) {
      // eslint-disable-line
      if (src(Desc, key) && !allowed[key]) {
        return false;
      }
    }

    var isData = src(Desc, '[[Value]]');
    var IsAccessor = src(Desc, '[[Get]]') || src(Desc, '[[Set]]');

    if (isData && IsAccessor) {
      throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
    }

    return true;
  }
};

var assertRecord = function assertRecord(ES, recordType, argumentName, value) {
  var predicate = predicates[recordType];

  if (typeof predicate !== 'function') {
    throw new $SyntaxError('unknown record type: ' + recordType);
  }

  if (!predicate(ES, value)) {
    throw new $TypeError(argumentName + ' must be a ' + recordType);
  }

  console.log(predicate(ES, value), value);
};

var _isNaN = Number.isNaN || function isNaN(a) {
  return a !== a;
};

var $isNaN = Number.isNaN || function (a) {
  return a !== a;
};

var _isFinite = Number.isFinite || function (x) {
  return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity;
};

var has$3 = functionBind.call(Function.call, Object.prototype.hasOwnProperty);
var $assign$1 = Object.assign;

var assign$3 = function assign(target, source) {
  if ($assign$1) {
    return $assign$1(target, source);
  }

  for (var key in source) {
    if (has$3(source, key)) {
      target[key] = source[key];
    }
  }

  return target;
};

var sign = function sign(number) {
  return number >= 0 ? 1 : -1;
};

var mod = function mod(number, modulo) {
  var remain = number % modulo;
  return Math.floor(remain >= 0 ? remain : remain + modulo);
};

var isPrimitive$1 = function isPrimitive(value) {
  return value === null || typeof value !== 'function' && typeof value !== 'object';
};

var toStr$6 = Object.prototype.toString; // http://ecma-international.org/ecma-262/5.1/#sec-8.12.8

var ES5internalSlots = {
  '[[DefaultValue]]': function DefaultValue(O) {
    var actualHint;

    if (arguments.length > 1) {
      actualHint = arguments[1];
    } else {
      actualHint = toStr$6.call(O) === '[object Date]' ? String : Number;
    }

    if (actualHint === String || actualHint === Number) {
      var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
      var value, i;

      for (i = 0; i < methods.length; ++i) {
        if (isCallable(O[methods[i]])) {
          value = O[methods[i]]();

          if (isPrimitive(value)) {
            return value;
          }
        }
      }

      throw new TypeError('No default value');
    }

    throw new TypeError('invalid [[DefaultValue]] hint supplied');
  }
}; // http://ecma-international.org/ecma-262/5.1/#sec-9.1

var es5 = function ToPrimitive(input) {
  if (isPrimitive(input)) {
    return input;
  }

  if (arguments.length > 1) {
    return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
  }

  return ES5internalSlots['[[DefaultValue]]'](input);
};

var $Object$2 = GetIntrinsic('%Object%');
var $TypeError$1 = GetIntrinsic('%TypeError%');
var $String = GetIntrinsic('%String%'); // https://es5.github.io/#x9

var ES5 = {
  ToPrimitive: es5,
  ToBoolean: function ToBoolean(value) {
    return !!value;
  },
  ToNumber: function ToNumber(value) {
    return +value; // eslint-disable-line no-implicit-coercion
  },
  ToInteger: function ToInteger(value) {
    var number = this.ToNumber(value);

    if (_isNaN(number)) {
      return 0;
    }

    if (number === 0 || !_isFinite(number)) {
      return number;
    }

    return sign(number) * Math.floor(Math.abs(number));
  },
  ToInt32: function ToInt32(x) {
    return this.ToNumber(x) >> 0;
  },
  ToUint32: function ToUint32(x) {
    return this.ToNumber(x) >>> 0;
  },
  ToUint16: function ToUint16(value) {
    var number = this.ToNumber(value);

    if (_isNaN(number) || number === 0 || !_isFinite(number)) {
      return 0;
    }

    var posInt = sign(number) * Math.floor(Math.abs(number));
    return mod(posInt, 0x10000);
  },
  ToString: function ToString(value) {
    return $String(value);
  },
  ToObject: function ToObject(value) {
    this.CheckObjectCoercible(value);
    return $Object$2(value);
  },
  CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
    /* jshint eqnull:true */
    if (value == null) {
      throw new $TypeError$1(optMessage || 'Cannot call method on ' + value);
    }

    return value;
  },
  IsCallable: isCallable,
  SameValue: function SameValue(x, y) {
    if (x === y) {
      // 0 === -0, but they are not identical.
      if (x === 0) {
        return 1 / x === 1 / y;
      }

      return true;
    }

    return _isNaN(x) && _isNaN(y);
  },
  // https://www.ecma-international.org/ecma-262/5.1/#sec-8
  Type: function Type(x) {
    if (x === null) {
      return 'Null';
    }

    if (typeof x === 'undefined') {
      return 'Undefined';
    }

    if (typeof x === 'function' || typeof x === 'object') {
      return 'Object';
    }

    if (typeof x === 'number') {
      return 'Number';
    }

    if (typeof x === 'boolean') {
      return 'Boolean';
    }

    if (typeof x === 'string') {
      return 'String';
    }
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
  IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
    if (this.Type(Desc) !== 'Object') {
      return false;
    }

    var allowed = {
      '[[Configurable]]': true,
      '[[Enumerable]]': true,
      '[[Get]]': true,
      '[[Set]]': true,
      '[[Value]]': true,
      '[[Writable]]': true
    };

    for (var key in Desc) {
      // eslint-disable-line
      if (src(Desc, key) && !allowed[key]) {
        return false;
      }
    }

    var isData = src(Desc, '[[Value]]');
    var IsAccessor = src(Desc, '[[Get]]') || src(Desc, '[[Set]]');

    if (isData && IsAccessor) {
      throw new $TypeError$1('Property Descriptors may not be both accessor and data descriptors');
    }

    return true;
  },
  // https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
  IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
    if (typeof Desc === 'undefined') {
      return false;
    }

    assertRecord(this, 'Property Descriptor', 'Desc', Desc);

    if (!src(Desc, '[[Get]]') && !src(Desc, '[[Set]]')) {
      return false;
    }

    return true;
  },
  // https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
  IsDataDescriptor: function IsDataDescriptor(Desc) {
    if (typeof Desc === 'undefined') {
      return false;
    }

    assertRecord(this, 'Property Descriptor', 'Desc', Desc);

    if (!src(Desc, '[[Value]]') && !src(Desc, '[[Writable]]')) {
      return false;
    }

    return true;
  },
  // https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
  IsGenericDescriptor: function IsGenericDescriptor(Desc) {
    if (typeof Desc === 'undefined') {
      return false;
    }

    assertRecord(this, 'Property Descriptor', 'Desc', Desc);

    if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
      return true;
    }

    return false;
  },
  // https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
  FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
    if (typeof Desc === 'undefined') {
      return Desc;
    }

    assertRecord(this, 'Property Descriptor', 'Desc', Desc);

    if (this.IsDataDescriptor(Desc)) {
      return {
        value: Desc['[[Value]]'],
        writable: !!Desc['[[Writable]]'],
        enumerable: !!Desc['[[Enumerable]]'],
        configurable: !!Desc['[[Configurable]]']
      };
    } else if (this.IsAccessorDescriptor(Desc)) {
      return {
        get: Desc['[[Get]]'],
        set: Desc['[[Set]]'],
        enumerable: !!Desc['[[Enumerable]]'],
        configurable: !!Desc['[[Configurable]]']
      };
    } else {
      throw new $TypeError$1('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
    }
  },
  // https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
  ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
    if (this.Type(Obj) !== 'Object') {
      throw new $TypeError$1('ToPropertyDescriptor requires an object');
    }

    var desc = {};

    if (src(Obj, 'enumerable')) {
      desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
    }

    if (src(Obj, 'configurable')) {
      desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
    }

    if (src(Obj, 'value')) {
      desc['[[Value]]'] = Obj.value;
    }

    if (src(Obj, 'writable')) {
      desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
    }

    if (src(Obj, 'get')) {
      var getter = Obj.get;

      if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
        throw new TypeError('getter must be a function');
      }

      desc['[[Get]]'] = getter;
    }

    if (src(Obj, 'set')) {
      var setter = Obj.set;

      if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
        throw new $TypeError$1('setter must be a function');
      }

      desc['[[Set]]'] = setter;
    }

    if ((src(desc, '[[Get]]') || src(desc, '[[Set]]')) && (src(desc, '[[Value]]') || src(desc, '[[Writable]]'))) {
      throw new $TypeError$1('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
    }

    return desc;
  }
};
var es5$1 = ES5;
var regexExec = RegExp.prototype.exec;
var gOPD$2 = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
  try {
    var lastIndex = value.lastIndex;
    value.lastIndex = 0;
    regexExec.call(value);
    return true;
  } catch (e) {
    return false;
  } finally {
    value.lastIndex = lastIndex;
  }
};

var toStr$7 = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag$2 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isRegex = function isRegex(value) {
  if (!value || typeof value !== 'object') {
    return false;
  }

  if (!hasToStringTag$2) {
    return toStr$7.call(value) === regexClass;
  }

  var descriptor = gOPD$2(value, 'lastIndex');
  var hasLastIndexDataProperty = descriptor && src(descriptor, 'value');

  if (!hasLastIndexDataProperty) {
    return false;
  }

  return tryRegexExecCall(value);
};

var $TypeError$2 = GetIntrinsic('%TypeError%');
var $SyntaxError$1 = GetIntrinsic('%SyntaxError%');
var $Array = GetIntrinsic('%Array%');
var $String$1 = GetIntrinsic('%String%');
var $Object$3 = GetIntrinsic('%Object%');
var $Number = GetIntrinsic('%Number%');
var $Symbol$1 = GetIntrinsic('%Symbol%', true);
var $RegExp = GetIntrinsic('%RegExp%');
var hasSymbols$4 = !!$Symbol$1;
var MAX_SAFE_INTEGER = $Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
var parseInteger = parseInt;
var arraySlice = functionBind.call(Function.call, $Array.prototype.slice);
var strSlice = functionBind.call(Function.call, $String$1.prototype.slice);
var isBinary = functionBind.call(Function.call, $RegExp.prototype.test, /^0b[01]+$/i);
var isOctal = functionBind.call(Function.call, $RegExp.prototype.test, /^0o[0-7]+$/i);
var regexExec$1 = functionBind.call(Function.call, $RegExp.prototype.exec);
var nonWS = ["\x85", "\u200B", "\uFFFE"].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = functionBind.call(Function.call, $RegExp.prototype.test, nonWSregex);
var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
var isInvalidHexLiteral = functionBind.call(Function.call, $RegExp.prototype.test, invalidHexLiteral);
var $charCodeAt = functionBind.call(Function.call, $String$1.prototype.charCodeAt);
var toStr$8 = functionBind.call(Function.call, Object.prototype.toString);
var $NumberValueOf = functionBind.call(Function.call, GetIntrinsic('%NumberPrototype%').valueOf);
var $BooleanValueOf = functionBind.call(Function.call, GetIntrinsic('%BooleanPrototype%').valueOf);
var $StringValueOf = functionBind.call(Function.call, GetIntrinsic('%StringPrototype%').valueOf);
var $DateValueOf = functionBind.call(Function.call, GetIntrinsic('%DatePrototype%').valueOf);
var $floor = Math.floor;
var $abs = Math.abs;
var $ObjectCreate = Object.create;
var $gOPD = $Object$3.getOwnPropertyDescriptor;
var $isExtensible = $Object$3.isExtensible;
var $defineProperty$1 = $Object$3.defineProperty; // whitespace from: http://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324

var ws = ["\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003", "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028", "\u2029\uFEFF"].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var replace = functionBind.call(Function.call, $String$1.prototype.replace);

var trim = function trim(value) {
  return replace(value, trimRegex, '');
}; // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations


var ES6 = assign$3(assign$3({}, es5$1), {
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
  Call: function Call(F, V) {
    var args = arguments.length > 2 ? arguments[2] : [];

    if (!this.IsCallable(F)) {
      throw new $TypeError$2(F + ' is not a function');
    }

    return F.apply(V, args);
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
  ToPrimitive: es6,
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
  // ToBoolean: ES5.ToBoolean,
  // https://ecma-international.org/ecma-262/6.0/#sec-tonumber
  ToNumber: function ToNumber(argument) {
    var value = isPrimitive$1(argument) ? argument : es6(argument, $Number);

    if (typeof value === 'symbol') {
      throw new $TypeError$2('Cannot convert a Symbol value to a number');
    }

    if (typeof value === 'string') {
      if (isBinary(value)) {
        return this.ToNumber(parseInteger(strSlice(value, 2), 2));
      } else if (isOctal(value)) {
        return this.ToNumber(parseInteger(strSlice(value, 2), 8));
      } else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
        return NaN;
      } else {
        var trimmed = trim(value);

        if (trimmed !== value) {
          return this.ToNumber(trimmed);
        }
      }
    }

    return $Number(value);
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
  // ToInteger: ES5.ToNumber,
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
  // ToInt32: ES5.ToInt32,
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
  // ToUint32: ES5.ToUint32,
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
  ToInt16: function ToInt16(argument) {
    var int16bit = this.ToUint16(argument);
    return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
  // ToUint16: ES5.ToUint16,
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
  ToInt8: function ToInt8(argument) {
    var int8bit = this.ToUint8(argument);
    return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
  ToUint8: function ToUint8(argument) {
    var number = this.ToNumber(argument);

    if (_isNaN(number) || number === 0 || !_isFinite(number)) {
      return 0;
    }

    var posInt = sign(number) * $floor($abs(number));
    return mod(posInt, 0x100);
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
  ToUint8Clamp: function ToUint8Clamp(argument) {
    var number = this.ToNumber(argument);

    if (_isNaN(number) || number <= 0) {
      return 0;
    }

    if (number >= 0xFF) {
      return 0xFF;
    }

    var f = $floor(argument);

    if (f + 0.5 < number) {
      return f + 1;
    }

    if (number < f + 0.5) {
      return f;
    }

    if (f % 2 !== 0) {
      return f + 1;
    }

    return f;
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
  ToString: function ToString(argument) {
    if (typeof argument === 'symbol') {
      throw new $TypeError$2('Cannot convert a Symbol value to a string');
    }

    return $String$1(argument);
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
  ToObject: function ToObject(value) {
    this.RequireObjectCoercible(value);
    return $Object$3(value);
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
  ToPropertyKey: function ToPropertyKey(argument) {
    var key = this.ToPrimitive(argument, $String$1);
    return typeof key === 'symbol' ? key : this.ToString(key);
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  ToLength: function ToLength(argument) {
    var len = this.ToInteger(argument);

    if (len <= 0) {
      return 0;
    } // includes converting -0 to +0


    if (len > MAX_SAFE_INTEGER) {
      return MAX_SAFE_INTEGER;
    }

    return len;
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
  CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
    if (toStr$8(argument) !== '[object String]') {
      throw new $TypeError$2('must be a string');
    }

    if (argument === '-0') {
      return -0;
    }

    var n = this.ToNumber(argument);

    if (this.SameValue(this.ToString(n), argument)) {
      return n;
    }

    return void 0;
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
  RequireObjectCoercible: es5$1.CheckObjectCoercible,
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
  IsArray: $Array.isArray || function IsArray(argument) {
    return toStr$8(argument) === '[object Array]';
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
  // IsCallable: ES5.IsCallable,
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
  IsConstructor: function IsConstructor(argument) {
    return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
  IsExtensible: Object.preventExtensions ? function IsExtensible(obj) {
    if (isPrimitive$1(obj)) {
      return false;
    }

    return $isExtensible(obj);
  } : function isExtensible(obj) {
    return true;
  },
  // eslint-disable-line no-unused-vars
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
  IsInteger: function IsInteger(argument) {
    if (typeof argument !== 'number' || _isNaN(argument) || !_isFinite(argument)) {
      return false;
    }

    var abs = $abs(argument);
    return $floor(abs) === abs;
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
  IsPropertyKey: function IsPropertyKey(argument) {
    return typeof argument === 'string' || typeof argument === 'symbol';
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-isregexp
  IsRegExp: function IsRegExp(argument) {
    if (!argument || typeof argument !== 'object') {
      return false;
    }

    if (hasSymbols$4) {
      var isRegExp = argument[$Symbol$1.match];

      if (typeof isRegExp !== 'undefined') {
        return es5$1.ToBoolean(isRegExp);
      }
    }

    return isRegex(argument);
  },
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
  // SameValue: ES5.SameValue,
  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
  SameValueZero: function SameValueZero(x, y) {
    return x === y || _isNaN(x) && _isNaN(y);
  },

  /**
   * 7.3.2 GetV (V, P)
   * 1. Assert: IsPropertyKey(P) is true.
   * 2. Let O be ToObject(V).
   * 3. ReturnIfAbrupt(O).
   * 4. Return O.[[Get]](P, V).
   */
  GetV: function GetV(V, P) {
    // 7.3.2.1
    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('Assertion failed: IsPropertyKey(P) is not true');
    } // 7.3.2.2-3


    var O = this.ToObject(V); // 7.3.2.4

    return O[P];
  },

  /**
   * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
   * 1. Assert: IsPropertyKey(P) is true.
   * 2. Let func be GetV(O, P).
   * 3. ReturnIfAbrupt(func).
   * 4. If func is either undefined or null, return undefined.
   * 5. If IsCallable(func) is false, throw a TypeError exception.
   * 6. Return func.
   */
  GetMethod: function GetMethod(O, P) {
    // 7.3.9.1
    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('Assertion failed: IsPropertyKey(P) is not true');
    } // 7.3.9.2


    var func = this.GetV(O, P); // 7.3.9.4

    if (func == null) {
      return void 0;
    } // 7.3.9.5


    if (!this.IsCallable(func)) {
      throw new $TypeError$2(P + 'is not a function');
    } // 7.3.9.6


    return func;
  },

  /**
   * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
   * 1. Assert: Type(O) is Object.
   * 2. Assert: IsPropertyKey(P) is true.
   * 3. Return O.[[Get]](P, O).
   */
  Get: function Get(O, P) {
    // 7.3.1.1
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(O) is not Object');
    } // 7.3.1.2


    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('Assertion failed: IsPropertyKey(P) is not true');
    } // 7.3.1.3


    return O[P];
  },
  Type: function Type(x) {
    if (typeof x === 'symbol') {
      return 'Symbol';
    }

    return es5$1.Type(x);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
  SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(O) is not Object');
    }

    var C = O.constructor;

    if (typeof C === 'undefined') {
      return defaultConstructor;
    }

    if (this.Type(C) !== 'Object') {
      throw new $TypeError$2('O.constructor is not an Object');
    }

    var S = hasSymbols$4 && $Symbol$1.species ? C[$Symbol$1.species] : void 0;

    if (S == null) {
      return defaultConstructor;
    }

    if (this.IsConstructor(S)) {
      return S;
    }

    throw new $TypeError$2('no constructor found');
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
  CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
    assertRecord(this, 'Property Descriptor', 'Desc', Desc);

    if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
      if (!src(Desc, '[[Value]]')) {
        Desc['[[Value]]'] = void 0;
      }

      if (!src(Desc, '[[Writable]]')) {
        Desc['[[Writable]]'] = false;
      }
    } else {
      if (!src(Desc, '[[Get]]')) {
        Desc['[[Get]]'] = void 0;
      }

      if (!src(Desc, '[[Set]]')) {
        Desc['[[Set]]'] = void 0;
      }
    }

    if (!src(Desc, '[[Enumerable]]')) {
      Desc['[[Enumerable]]'] = false;
    }

    if (!src(Desc, '[[Configurable]]')) {
      Desc['[[Configurable]]'] = false;
    }

    return Desc;
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
  Set: function Set(O, P, V, Throw) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('O must be an Object');
    }

    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('P must be a Property Key');
    }

    if (this.Type(Throw) !== 'Boolean') {
      throw new $TypeError$2('Throw must be a Boolean');
    }

    if (Throw) {
      O[P] = V;
      return true;
    } else {
      try {
        O[P] = V;
      } catch (e) {
        return false;
      }
    }
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
  HasOwnProperty: function HasOwnProperty(O, P) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('O must be an Object');
    }

    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('P must be a Property Key');
    }

    return src(O, P);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-hasproperty
  HasProperty: function HasProperty(O, P) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('O must be an Object');
    }

    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('P must be a Property Key');
    }

    return P in O;
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
  IsConcatSpreadable: function IsConcatSpreadable(O) {
    if (this.Type(O) !== 'Object') {
      return false;
    }

    if (hasSymbols$4 && typeof $Symbol$1.isConcatSpreadable === 'symbol') {
      var spreadable = this.Get(O, Symbol.isConcatSpreadable);

      if (typeof spreadable !== 'undefined') {
        return this.ToBoolean(spreadable);
      }
    }

    return this.IsArray(O);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-invoke
  Invoke: function Invoke(O, P) {
    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('P must be a Property Key');
    }

    var argumentsList = arraySlice(arguments, 2);
    var func = this.GetV(O, P);
    return this.Call(func, O, argumentsList);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-getiterator
  GetIterator: function GetIterator(obj, method) {
    if (!hasSymbols$4) {
      throw new SyntaxError('ES.GetIterator depends on native iterator support.');
    }

    var actualMethod = method;

    if (arguments.length < 2) {
      actualMethod = this.GetMethod(obj, $Symbol$1.iterator);
    }

    var iterator = this.Call(actualMethod, obj);

    if (this.Type(iterator) !== 'Object') {
      throw new $TypeError$2('iterator must return an object');
    }

    return iterator;
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-iteratornext
  IteratorNext: function IteratorNext(iterator, value) {
    var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);

    if (this.Type(result) !== 'Object') {
      throw new $TypeError$2('iterator next must return an object');
    }

    return result;
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
  IteratorComplete: function IteratorComplete(iterResult) {
    if (this.Type(iterResult) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(iterResult) is not Object');
    }

    return this.ToBoolean(this.Get(iterResult, 'done'));
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
  IteratorValue: function IteratorValue(iterResult) {
    if (this.Type(iterResult) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(iterResult) is not Object');
    }

    return this.Get(iterResult, 'value');
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
  IteratorStep: function IteratorStep(iterator) {
    var result = this.IteratorNext(iterator);
    var done = this.IteratorComplete(result);
    return done === true ? false : result;
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
  IteratorClose: function IteratorClose(iterator, completion) {
    if (this.Type(iterator) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(iterator) is not Object');
    }

    if (!this.IsCallable(completion)) {
      throw new $TypeError$2('Assertion failed: completion is not a thunk for a Completion Record');
    }

    var completionThunk = completion;
    var iteratorReturn = this.GetMethod(iterator, 'return');

    if (typeof iteratorReturn === 'undefined') {
      return completionThunk();
    }

    var completionRecord;

    try {
      var innerResult = this.Call(iteratorReturn, iterator, []);
    } catch (e) {
      // if we hit here, then "e" is the innerResult completion that needs re-throwing
      // if the completion is of type "throw", this will throw.
      completionRecord = completionThunk();
      completionThunk = null; // ensure it's not called twice.
      // if not, then return the innerResult completion

      throw e;
    }

    completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does

    completionThunk = null; // ensure it's not called twice.

    if (this.Type(innerResult) !== 'Object') {
      throw new $TypeError$2('iterator .return must return an object');
    }

    return completionRecord;
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
  CreateIterResultObject: function CreateIterResultObject(value, done) {
    if (this.Type(done) !== 'Boolean') {
      throw new $TypeError$2('Assertion failed: Type(done) is not Boolean');
    }

    return {
      value: value,
      done: done
    };
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-regexpexec
  RegExpExec: function RegExpExec(R, S) {
    if (this.Type(R) !== 'Object') {
      throw new $TypeError$2('R must be an Object');
    }

    if (this.Type(S) !== 'String') {
      throw new $TypeError$2('S must be a String');
    }

    var exec = this.Get(R, 'exec');

    if (this.IsCallable(exec)) {
      var result = this.Call(exec, R, [S]);

      if (result === null || this.Type(result) === 'Object') {
        return result;
      }

      throw new $TypeError$2('"exec" method must return `null` or an Object');
    }

    return regexExec$1(R, S);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
  ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
    if (!this.IsInteger(length) || length < 0) {
      throw new $TypeError$2('Assertion failed: length must be an integer >= 0');
    }

    var len = length === 0 ? 0 : length;
    var C;
    var isArray = this.IsArray(originalArray);

    if (isArray) {
      C = this.Get(originalArray, 'constructor'); // TODO: figure out how to make a cross-realm normal Array, a same-realm Array
      // if (this.IsConstructor(C)) {
      // 	if C is another realm's Array, C = undefined
      // 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
      // }

      if (this.Type(C) === 'Object' && hasSymbols$4 && $Symbol$1.species) {
        C = this.Get(C, $Symbol$1.species);

        if (C === null) {
          C = void 0;
        }
      }
    }

    if (typeof C === 'undefined') {
      return $Array(len);
    }

    if (!this.IsConstructor(C)) {
      throw new $TypeError$2('C must be a constructor');
    }

    return new C(len); // this.Construct(C, len);
  },
  CreateDataProperty: function CreateDataProperty(O, P, V) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(O) is not Object');
    }

    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('Assertion failed: IsPropertyKey(P) is not true');
    }

    var oldDesc = $gOPD(O, P);
    var extensible = oldDesc || typeof $isExtensible !== 'function' || $isExtensible(O);
    var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);

    if (immutable || !extensible) {
      return false;
    }

    var newDesc = {
      configurable: true,
      enumerable: true,
      value: V,
      writable: true
    };
    $defineProperty$1(O, P, newDesc);
    return true;
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
  CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(O) is not Object');
    }

    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('Assertion failed: IsPropertyKey(P) is not true');
    }

    var success = this.CreateDataProperty(O, P, V);

    if (!success) {
      throw new $TypeError$2('unable to create data property');
    }

    return success;
  },
  // https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate
  ObjectCreate: function ObjectCreate(proto, internalSlotsList) {
    if (proto !== null && this.Type(proto) !== 'Object') {
      throw new $TypeError$2('Assertion failed: proto must be null or an object');
    }

    var slots = arguments.length < 2 ? [] : internalSlotsList;

    if (slots.length > 0) {
      throw new $SyntaxError$1('es-abstract does not yet support internal slots');
    }

    if (proto === null && !$ObjectCreate) {
      throw new $SyntaxError$1('native Object.create support is required to create null objects');
    }

    return $ObjectCreate(proto);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
  AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
    if (this.Type(S) !== 'String') {
      throw new $TypeError$2('S must be a String');
    }

    if (!this.IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
      throw new $TypeError$2('Assertion failed: length must be an integer >= 0 and <= 2**53');
    }

    if (this.Type(unicode) !== 'Boolean') {
      throw new $TypeError$2('Assertion failed: unicode must be a Boolean');
    }

    if (!unicode) {
      return index + 1;
    }

    var length = S.length;

    if (index + 1 >= length) {
      return index + 1;
    }

    var first = $charCodeAt(S, index);

    if (first < 0xD800 || first > 0xDBFF) {
      return index + 1;
    }

    var second = $charCodeAt(S, index + 1);

    if (second < 0xDC00 || second > 0xDFFF) {
      return index + 1;
    }

    return index + 2;
  },
  // https://www.ecma-international.org/ecma-262/6.0/#sec-createmethodproperty
  CreateMethodProperty: function CreateMethodProperty(O, P, V) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(O) is not Object');
    }

    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('Assertion failed: IsPropertyKey(P) is not true');
    }

    var newDesc = {
      configurable: true,
      enumerable: false,
      value: V,
      writable: true
    };
    return !!$defineProperty$1(O, P, newDesc);
  },
  // https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow
  DefinePropertyOrThrow: function DefinePropertyOrThrow(O, P, desc) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(O) is not Object');
    }

    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('Assertion failed: IsPropertyKey(P) is not true');
    }

    return !!$defineProperty$1(O, P, desc);
  },
  // https://www.ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow
  DeletePropertyOrThrow: function DeletePropertyOrThrow(O, P) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(O) is not Object');
    }

    if (!this.IsPropertyKey(P)) {
      throw new $TypeError$2('Assertion failed: IsPropertyKey(P) is not true');
    }

    var success = delete O[P];

    if (!success) {
      throw new TypeError('Attempt to delete property failed.');
    }

    return success;
  },
  // https://www.ecma-international.org/ecma-262/6.0/#sec-enumerableownnames
  EnumerableOwnNames: function EnumerableOwnNames(O) {
    if (this.Type(O) !== 'Object') {
      throw new $TypeError$2('Assertion failed: Type(O) is not Object');
    }

    return objectKeys(O);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object
  thisNumberValue: function thisNumberValue(value) {
    if (this.Type(value) === 'Number') {
      return value;
    }

    return $NumberValueOf(value);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object
  thisBooleanValue: function thisBooleanValue(value) {
    if (this.Type(value) === 'Boolean') {
      return value;
    }

    return $BooleanValueOf(value);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object
  thisStringValue: function thisStringValue(value) {
    if (this.Type(value) === 'String') {
      return value;
    }

    return $StringValueOf(value);
  },
  // https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object
  thisTimeValue: function thisTimeValue(value) {
    return $DateValueOf(value);
  }
});
delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

var es2015$1 = ES6;
var ES2016 = assign$3(assign$3({}, es2015$1), {
  // https://github.com/tc39/ecma262/pull/60
  SameValueNonNumber: function SameValueNonNumber(x, y) {
    if (typeof x === 'number' || typeof x !== typeof y) {
      throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
    }

    return this.SameValue(x, y);
  }
});
var es2016 = ES2016;

var forEach = function forEach(array, callback) {
  for (var i = 0; i < array.length; i += 1) {
    callback(array[i], i, array);
  }
};

var $TypeError$3 = GetIntrinsic('%TypeError%');
var $isEnumerable = functionBind.call(Function.call, GetIntrinsic('%ObjectPrototype%').propertyIsEnumerable);
var $pushApply = functionBind.call(Function.apply, GetIntrinsic('%ArrayPrototype%').push);
var ES2017 = assign$3(assign$3({}, es2016), {
  ToIndex: function ToIndex(value) {
    if (typeof value === 'undefined') {
      return 0;
    }

    var integerIndex = this.ToInteger(value);

    if (integerIndex < 0) {
      throw new RangeError('index must be >= 0');
    }

    var index = this.ToLength(integerIndex);

    if (!this.SameValueZero(integerIndex, index)) {
      throw new RangeError('index must be >= 0 and < 2 ** 53 - 1');
    }

    return index;
  },
  // https://www.ecma-international.org/ecma-262/8.0/#sec-enumerableownproperties
  EnumerableOwnProperties: function EnumerableOwnProperties(O, kind) {
    var keys = es2016.EnumerableOwnNames(O);

    if (kind === 'key') {
      return keys;
    }

    if (kind === 'value' || kind === 'key+value') {
      var results = [];
      forEach(keys, function (key) {
        if ($isEnumerable(O, key)) {
          $pushApply(results, [kind === 'value' ? O[key] : [key, O[key]]]);
        }
      });
      return results;
    }

    throw new $TypeError$3('Assertion failed: "kind" is not "key", "value", or "key+value": ' + kind);
  }
});
delete ES2017.EnumerableOwnNames; // replaced with EnumerableOwnProperties

var es2017 = ES2017;
var MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1; // eslint-disable-next-line max-params, max-statements

var FlattenIntoArray = function FlattenIntoArray(target, source, sourceLen, start, depth) {
  var targetIndex = start;
  var sourceIndex = 0;
  /*
  var mapperFunction;
  if (arguments.length > 5) {
  	mapperFunction = arguments[5];
  }
  */

  while (sourceIndex < sourceLen) {
    var P = es2017.ToString(sourceIndex);
    var exists = es2017.HasProperty(source, P);

    if (exists) {
      var element = es2017.Get(source, P);
      /*
      if (typeof mapperFunction !== 'undefined') {
      	if (arguments.length <= 6) {
      		throw new TypeError('Assertion failed: thisArg is required when mapperFunction is provided');
      	}
      	element = ES.Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
      }
      */

      var shouldFlatten = false;

      if (depth > 0) {
        shouldFlatten = es2017.IsArray(element);
      }

      if (shouldFlatten) {
        var elementLen = es2017.ToLength(es2017.Get(element, 'length'));
        targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
      } else {
        if (targetIndex >= MAX_SAFE_INTEGER$1) {
          throw new TypeError('index too large');
        }

        es2017.CreateDataPropertyOrThrow(target, es2017.ToString(targetIndex), element);
        targetIndex += 1;
      }
    }

    sourceIndex += 1;
  }

  return targetIndex;
};

var implementation$4 = function flat() {
  var O = es2017.ToObject(this);
  var sourceLen = es2017.ToLength(es2017.Get(O, 'length'));
  var depthNum = 1;

  if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
    depthNum = es2017.ToInteger(arguments[0]);
  }

  var A = es2017.ArraySpeciesCreate(O, 0);
  FlattenIntoArray(A, O, sourceLen, 0, depthNum);
  return A;
};

var polyfill$2 = function getPolyfill() {
  return Array.prototype.flat || implementation$4;
};

var shim = function shimFlat() {
  var polyfill = polyfill$2();
  defineProperties_1(Array.prototype, {
    flat: polyfill
  }, {
    flat: function flat() {
      return Array.prototype.flat !== polyfill;
    }
  });
  return polyfill;
};

var polyfill$3 = polyfill$2();
var boundFlat = functionBind.call(Function.call, polyfill$3);
defineProperties_1(boundFlat, {
  getPolyfill: polyfill$2,
  implementation: implementation$4,
  shim: shim
});
var array_prototype_flat = boundFlat;
var globalKey = '__ global cache key __';
/* istanbul ignore else */
// eslint-disable-next-line no-restricted-properties

if (typeof Symbol === 'function' && isSymbol$1(Symbol('foo')) && typeof Symbol['for'] === 'function') {
  // eslint-disable-next-line no-restricted-properties
  globalKey = Symbol['for'](globalKey);
}

var trueThunk = function trueThunk() {
  return true;
};

var ensureCache = function ensureCache() {
  if (!commonjsGlobal[globalKey]) {
    var properties = {};
    properties[globalKey] = {};
    var predicates = {};
    predicates[globalKey] = trueThunk;
    defineProperties_1(commonjsGlobal, properties, predicates);
  }

  return commonjsGlobal[globalKey];
};

var cache = ensureCache();

var isPrimitive$2 = function isPrimitive(val) {
  return val === null || typeof val !== 'object' && typeof val !== 'function';
};

var getPrimitiveKey = function getPrimitiveKey(val) {
  if (isSymbol$1(val)) {
    return Symbol.prototype.valueOf.call(val);
  }

  return typeof val + ' | ' + String(val);
};

var requirePrimitiveKey = function requirePrimitiveKey(val) {
  if (!isPrimitive$2(val)) {
    throw new TypeError('key must not be an object');
  }
};

var globalCache = {
  clear: function clear() {
    delete commonjsGlobal[globalKey];
    cache = ensureCache();
  },
  'delete': function deleteKey(key) {
    requirePrimitiveKey(key);
    delete cache[getPrimitiveKey(key)];
    return !globalCache.has(key);
  },
  get: function get(key) {
    requirePrimitiveKey(key);
    return cache[getPrimitiveKey(key)];
  },
  has: function has(key) {
    requirePrimitiveKey(key);
    return getPrimitiveKey(key) in cache;
  },
  set: function set(key, value) {
    requirePrimitiveKey(key);
    var primitiveKey = getPrimitiveKey(key);
    var props = {};
    props[primitiveKey] = value;
    var predicates = {};
    predicates[primitiveKey] = trueThunk;
    defineProperties_1(cache, props, predicates);
    return globalCache.has(key);
  },
  setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
    if (globalCache.has(key)) {
      return globalCache.get(key);
    }

    var item = valueThunk();
    globalCache.set(key, item);
    return item;
  }
};
var globalCache_1 = globalCache;
var constants = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
  var MAX_SPECIFICITY = 20;
  exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
  exports.MAX_SPECIFICITY = MAX_SPECIFICITY;
});
unwrapExports(constants);
var constants_1 = constants.GLOBAL_CACHE_KEY;
var constants_2 = constants.MAX_SPECIFICITY;
var getClassName_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = getClassName;
  /**
   * Construct a class name.
   *
   * namespace {String} Used to construct unique class names.
   * styleName {String} Name identifying the specific style.
   *
   * Return the class name.
   */

  function getClassName(namespace, styleName) {
    var namespaceSegment = namespace.length > 0 ? String(namespace) + '__' : '';
    return '' + namespaceSegment + String(styleName);
  }
});
unwrapExports(getClassName_1);
var separateStyles_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  }); // This function takes an array of styles and separates them into styles that
  // are handled by Aphrodite and inline styles.

  function separateStyles(stylesArray) {
    var classNames = []; // Since determining if an Object is empty requires collecting all of its
    // keys, and we want the best performance in this code because we are in the
    // render path, we are going to do a little bookkeeping ourselves.

    var hasInlineStyles = false;
    var inlineStyles = {}; // This is run on potentially every node in the tree when rendering, where
    // performance is critical. Normally we would prefer using `forEach`, but
    // old-fashioned for loops are faster so that's what we have chosen here.

    for (var i = 0; i < stylesArray.length; i++) {
      // eslint-disable-line no-plusplus
      var style = stylesArray[i]; // If this  style is falsy, we just want to disregard it. This allows for
      // syntax like:
      //
      //   css(isFoo && styles.foo)

      if (style) {
        if (typeof style === 'string') {
          classNames.push(style);
        } else {
          Object.assign(inlineStyles, style);
          hasInlineStyles = true;
        }
      }
    }

    return {
      classNames: classNames,
      hasInlineStyles: hasInlineStyles,
      inlineStyles: inlineStyles
    };
  }

  exports['default'] = separateStyles;
});
unwrapExports(separateStyles_1);
var dist$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _arrayPrototype2 = _interopRequireDefault(array_prototype_flat);

  var _globalCache2 = _interopRequireDefault(globalCache_1);

  var _getClassName2 = _interopRequireDefault(getClassName_1);

  var _separateStyles3 = _interopRequireDefault(separateStyles_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  /**
   * Function required as part of the react-with-styles interface. Parses the styles provided by
   * react-with-styles to produce class names based on the style name and optionally the namespace if
   * available.
   *
   * stylesObject {Object} The styles object passed to withStyles.
   *
   * Return an object mapping style names to class names.
   */


  function create(stylesObject) {
    var stylesToClasses = {};
    var styleNames = Object.keys(stylesObject);
    var sharedState = _globalCache2['default'].get(constants.GLOBAL_CACHE_KEY) || {};
    var _sharedState$namespac = sharedState.namespace,
        namespace = _sharedState$namespac === undefined ? '' : _sharedState$namespac;
    styleNames.forEach(function (styleName) {
      var className = (0, _getClassName2['default'])(namespace, styleName);
      stylesToClasses[styleName] = className;
    });
    return stylesToClasses;
  }
  /**
   * Process styles to be consumed by a component.
   *
   * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
   * representing inline styles, or arrays thereof.
   *
   * Return an object with optional className and style properties to be spread on a component.
   */


  function resolve(stylesArray) {
    var flattenedStyles = (0, _arrayPrototype2['default'])(stylesArray, Infinity);

    var _separateStyles = (0, _separateStyles3['default'])(flattenedStyles),
        classNames = _separateStyles.classNames,
        hasInlineStyles = _separateStyles.hasInlineStyles,
        inlineStyles = _separateStyles.inlineStyles;

    var specificClassNames = classNames.map(function (name, index) {
      return String(name) + ' ' + String(name) + '_' + String(index + 1);
    });
    var className = specificClassNames.join(' ');
    var result = {
      className: className
    };
    if (hasInlineStyles) result.style = inlineStyles;
    return result;
  }

  exports['default'] = {
    create: create,
    resolve: resolve
  };
});
unwrapExports(dist$2); // eslint-disable-next-line import/no-unresolved

var reactWithStylesInterfaceCss = dist$2.default;
var ThemedStyleSheet = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var styleInterface = void 0;
  var styleTheme = void 0;
  var START_MARK = 'react-with-styles.resolve.start';
  var END_MARK = 'react-with-styles.resolve.end';
  var MEASURE_MARK = "\uD83D\uDC69\u200D\uD83C\uDFA8 [resolve]";

  function registerTheme(theme) {
    styleTheme = theme;
  }

  function registerInterface(interfaceToRegister) {
    styleInterface = interfaceToRegister;
  }

  function create(makeFromTheme, createWithDirection) {
    var styles = createWithDirection(makeFromTheme(styleTheme));
    return function () {
      return styles;
    };
  }

  function createLTR(makeFromTheme) {
    return create(makeFromTheme, styleInterface.createLTR || styleInterface.create);
  }

  function createRTL(makeFromTheme) {
    return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
  }

  function get() {
    return styleTheme;
  }

  function resolve() {
    if (process.env.NODE_ENV !== 'production' && typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
      performance.clearMarks(START_MARK);
      performance.mark(START_MARK);
    }

    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    var result = styleInterface.resolve(styles);

    if (process.env.NODE_ENV !== 'production' && typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
      performance.clearMarks(END_MARK);
      performance.mark(END_MARK);
      performance.measure(MEASURE_MARK, START_MARK, END_MARK);
      performance.clearMarks(MEASURE_MARK);
    }

    return result;
  }

  function resolveLTR() {
    for (var _len2 = arguments.length, styles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      styles[_key2] = arguments[_key2];
    }

    if (styleInterface.resolveLTR) {
      return styleInterface.resolveLTR(styles);
    }

    return resolve(styles);
  }

  function resolveRTL() {
    for (var _len3 = arguments.length, styles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      styles[_key3] = arguments[_key3];
    }

    if (styleInterface.resolveRTL) {
      return styleInterface.resolveRTL(styles);
    }

    return resolve(styles);
  }

  function flush() {
    if (styleInterface.flush) {
      styleInterface.flush();
    }
  }

  exports['default'] = {
    registerTheme: registerTheme,
    registerInterface: registerInterface,
    create: createLTR,
    createLTR: createLTR,
    createRTL: createRTL,
    get: get,
    resolve: resolveLTR,
    resolveLTR: resolveLTR,
    resolveRTL: resolveRTL,
    flush: flush
  };
});
unwrapExports(ThemedStyleSheet);
var DefaultTheme = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var core = {
    white: '#fff',
    gray: '#484848',
    grayLight: '#82888a',
    grayLighter: '#cacccd',
    grayLightest: '#f2f2f2',
    borderMedium: '#c4c4c4',
    border: '#dbdbdb',
    borderLight: '#e4e7e7',
    borderLighter: '#eceeee',
    borderBright: '#f4f5f5',
    primary: '#00a699',
    primaryShade_1: '#33dacd',
    primaryShade_2: '#66e2da',
    primaryShade_3: '#80e8e0',
    primaryShade_4: '#b2f1ec',
    primary_dark: '#008489',
    secondary: '#007a87',
    yellow: '#ffe8bc',
    yellow_dark: '#ffce71'
  };
  var _default = {
    reactDates: {
      zIndex: 0,
      border: {
        input: {
          border: 0,
          borderTop: 0,
          borderRight: 0,
          borderBottom: '2px solid transparent',
          borderLeft: 0,
          outlineFocused: 0,
          borderFocused: 0,
          borderTopFocused: 0,
          borderLeftFocused: 0,
          borderBottomFocused: "2px solid ".concat(core.primary_dark),
          borderRightFocused: 0,
          borderRadius: 0
        },
        pickerInput: {
          borderWidth: 1,
          borderStyle: 'solid',
          borderRadius: 2
        }
      },
      color: {
        core: core,
        disabled: core.grayLightest,
        background: core.white,
        backgroundDark: '#f2f2f2',
        backgroundFocused: core.white,
        border: 'rgb(219, 219, 219)',
        text: core.gray,
        textDisabled: core.border,
        textFocused: '#007a87',
        placeholderText: '#757575',
        outside: {
          backgroundColor: core.white,
          backgroundColor_active: core.white,
          backgroundColor_hover: core.white,
          color: core.gray,
          color_active: core.gray,
          color_hover: core.gray
        },
        highlighted: {
          backgroundColor: core.yellow,
          backgroundColor_active: core.yellow_dark,
          backgroundColor_hover: core.yellow_dark,
          color: core.gray,
          color_active: core.gray,
          color_hover: core.gray
        },
        minimumNights: {
          backgroundColor: core.white,
          backgroundColor_active: core.white,
          backgroundColor_hover: core.white,
          borderColor: core.borderLighter,
          color: core.grayLighter,
          color_active: core.grayLighter,
          color_hover: core.grayLighter
        },
        hoveredSpan: {
          backgroundColor: core.primaryShade_4,
          backgroundColor_active: core.primaryShade_3,
          backgroundColor_hover: core.primaryShade_4,
          borderColor: core.primaryShade_3,
          borderColor_active: core.primaryShade_3,
          borderColor_hover: core.primaryShade_3,
          color: core.secondary,
          color_active: core.secondary,
          color_hover: core.secondary
        },
        selectedSpan: {
          backgroundColor: core.primaryShade_2,
          backgroundColor_active: core.primaryShade_1,
          backgroundColor_hover: core.primaryShade_1,
          borderColor: core.primaryShade_1,
          borderColor_active: core.primary,
          borderColor_hover: core.primary,
          color: core.white,
          color_active: core.white,
          color_hover: core.white
        },
        selected: {
          backgroundColor: core.primary,
          backgroundColor_active: core.primary,
          backgroundColor_hover: core.primary,
          borderColor: core.primary,
          borderColor_active: core.primary,
          borderColor_hover: core.primary,
          color: core.white,
          color_active: core.white,
          color_hover: core.white
        },
        blocked_calendar: {
          backgroundColor: core.grayLighter,
          backgroundColor_active: core.grayLighter,
          backgroundColor_hover: core.grayLighter,
          borderColor: core.grayLighter,
          borderColor_active: core.grayLighter,
          borderColor_hover: core.grayLighter,
          color: core.grayLight,
          color_active: core.grayLight,
          color_hover: core.grayLight
        },
        blocked_out_of_range: {
          backgroundColor: core.white,
          backgroundColor_active: core.white,
          backgroundColor_hover: core.white,
          borderColor: core.borderLight,
          borderColor_active: core.borderLight,
          borderColor_hover: core.borderLight,
          color: core.grayLighter,
          color_active: core.grayLighter,
          color_hover: core.grayLighter
        }
      },
      spacing: {
        dayPickerHorizontalPadding: 9,
        captionPaddingTop: 22,
        captionPaddingBottom: 37,
        inputPadding: 0,
        displayTextPaddingVertical: undefined,
        displayTextPaddingTop: 11,
        displayTextPaddingBottom: 9,
        displayTextPaddingHorizontal: undefined,
        displayTextPaddingLeft: 11,
        displayTextPaddingRight: 11,
        displayTextPaddingVertical_small: undefined,
        displayTextPaddingTop_small: 7,
        displayTextPaddingBottom_small: 5,
        displayTextPaddingHorizontal_small: undefined,
        displayTextPaddingLeft_small: 7,
        displayTextPaddingRight_small: 7
      },
      sizing: {
        inputWidth: 130,
        inputWidth_small: 97,
        arrowWidth: 24
      },
      noScrollBarOnVerticalScrollable: false,
      font: {
        size: 14,
        captionSize: 18,
        input: {
          size: 19,
          lineHeight: '24px',
          size_small: 15,
          lineHeight_small: '18px',
          letterSpacing_small: '0.2px',
          styleDisabled: 'italic'
        }
      }
    }
  };
  exports["default"] = _default;
});
unwrapExports(DefaultTheme);
var registerInterfaceWithDefaultTheme_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = registerInterfaceWithDefaultTheme;

  var _ThemedStyleSheet = _interopRequireDefault(ThemedStyleSheet);

  var _DefaultTheme = _interopRequireDefault(DefaultTheme);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
    _ThemedStyleSheet["default"].registerInterface(reactWithStylesInterface);

    _ThemedStyleSheet["default"].registerTheme(_DefaultTheme["default"]);
  }
});
unwrapExports(registerInterfaceWithDefaultTheme_1);
var registerCSSInterfaceWithDefaultTheme_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = registerCSSInterfaceWithDefaultTheme;

  var _reactWithStylesInterfaceCss = _interopRequireDefault(reactWithStylesInterfaceCss);

  var _registerInterfaceWithDefaultTheme = _interopRequireDefault(registerInterfaceWithDefaultTheme_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function registerCSSInterfaceWithDefaultTheme() {
    (0, _registerInterfaceWithDefaultTheme["default"])(_reactWithStylesInterfaceCss["default"]);
  }
});
unwrapExports(registerCSSInterfaceWithDefaultTheme_1);
var initialize = createCommonjsModule(function (module) {
  var _registerCSSInterfaceWithDefaultTheme = _interopRequireDefault(registerCSSInterfaceWithDefaultTheme_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  (0, _registerCSSInterfaceWithDefaultTheme["default"])();
});
unwrapExports(initialize);
var css$A = ".PresetDateRangePicker_panel {\n  padding: 0 22px 11px\n}\n.PresetDateRangePicker_button {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  background: 0 0;\n  border: 2px solid #00a699;\n  color: #00a699;\n  padding: 4px 12px;\n  margin-right: 8px;\n  font: inherit;\n  font-weight: 700;\n  line-height: normal;\n  overflow: visible;\n  box-sizing: border-box;\n  cursor: pointer\n}\n.PresetDateRangePicker_button:active {\n  outline: 0\n}\n.PresetDateRangePicker_button__selected {\n  color: #fff;\n  background: #00a699\n}\n.SingleDatePickerInput {\n  display: inline-block;\n  background-color: #fff\n}\n.SingleDatePickerInput__withBorder {\n  border-radius: 2px;\n  border: 1px solid #dbdbdb\n}\n.SingleDatePickerInput__rtl {\n  direction: rtl\n}\n.SingleDatePickerInput__disabled {\n  background-color: #f2f2f2\n}\n.SingleDatePickerInput__block {\n  display: block\n}\n.SingleDatePickerInput__showClearDate {\n  padding-right: 30px\n}\n.SingleDatePickerInput_clearDate {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%)\n}\n.SingleDatePickerInput_clearDate__default:focus,\n.SingleDatePickerInput_clearDate__default:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n.SingleDatePickerInput_clearDate__small {\n  padding: 6px\n}\n.SingleDatePickerInput_clearDate__hide {\n  visibility: hidden\n}\n.SingleDatePickerInput_clearDate_svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n.SingleDatePickerInput_clearDate_svg__small {\n  height: 9px\n}\n.SingleDatePickerInput_calendarIcon {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n.SingleDatePickerInput_calendarIcon_svg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n.SingleDatePicker {\n  position: relative;\n  display: inline-block\n}\n.SingleDatePicker__block {\n  display: block\n}\n.SingleDatePicker_picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n.SingleDatePicker_picker__rtl {\n  direction: rtl\n}\n.SingleDatePicker_picker__directionLeft {\n  left: 0\n}\n.SingleDatePicker_picker__directionRight {\n  right: 0\n}\n.SingleDatePicker_picker__portal {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n.SingleDatePicker_picker__fullScreenPortal {\n  background-color: #fff\n}\n.SingleDatePicker_closeButton {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n.SingleDatePicker_closeButton:focus,\n.SingleDatePicker_closeButton:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n.SingleDatePicker_closeButton_svg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n.DayPickerKeyboardShortcuts_buttonReset {\n  background: 0 0;\n  border: 0;\n  border-radius: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  font-size: 14px\n}\n.DayPickerKeyboardShortcuts_buttonReset:active {\n  outline: 0\n}\n.DayPickerKeyboardShortcuts_show {\n  width: 33px;\n  height: 26px;\n  position: absolute;\n  z-index: 2\n}\n.DayPickerKeyboardShortcuts_show::before {\n  content: \"\";\n  display: block;\n  position: absolute\n}\n.DayPickerKeyboardShortcuts_show__bottomRight {\n  bottom: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__bottomRight::before {\n  border-top: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  bottom: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__bottomRight:hover::before {\n  border-right: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_show__topRight {\n  top: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__topRight::before {\n  border-bottom: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  top: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__topRight:hover::before {\n  border-right: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_show__topLeft {\n  top: 0;\n  left: 0\n}\n.DayPickerKeyboardShortcuts_show__topLeft::before {\n  border-bottom: 26px solid transparent;\n  border-left: 33px solid #00a699;\n  top: 0;\n  left: 0\n}\n.DayPickerKeyboardShortcuts_show__topLeft:hover::before {\n  border-left: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_showSpan {\n  color: #fff;\n  position: absolute\n}\n.DayPickerKeyboardShortcuts_showSpan__bottomRight {\n  bottom: 0;\n  right: 5px\n}\n.DayPickerKeyboardShortcuts_showSpan__topRight {\n  top: 1px;\n  right: 5px\n}\n.DayPickerKeyboardShortcuts_showSpan__topLeft {\n  top: 1px;\n  left: 5px\n}\n.DayPickerKeyboardShortcuts_panel {\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  padding: 22px;\n  margin: 33px;\n  text-align: left\n}\n.DayPickerKeyboardShortcuts_title {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0\n}\n.DayPickerKeyboardShortcuts_list {\n  list-style: none;\n  padding: 0;\n  font-size: 14px\n}\n.DayPickerKeyboardShortcuts_close {\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 2\n}\n.DayPickerKeyboardShortcuts_close:active {\n  outline: 0\n}\n.DayPickerKeyboardShortcuts_closeSvg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n.DayPickerKeyboardShortcuts_closeSvg:focus,\n.DayPickerKeyboardShortcuts_closeSvg:hover {\n  fill: #82888a\n}\n.CalendarDay {\n  box-sizing: border-box;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center\n}\n.CalendarDay:active {\n  outline: 0\n}\n.CalendarDay__defaultCursor {\n  cursor: default\n}\n.CalendarDay__default {\n  border: 1px solid #e4e7e7;\n  color: #484848;\n  background: #fff\n}\n.CalendarDay__default:hover {\n  background: #e4e7e7;\n  border: 1px solid #e4e7e7;\n  color: inherit\n}\n.CalendarDay__hovered_offset {\n  background: #f4f5f5;\n  border: 1px double #e4e7e7;\n  color: inherit\n}\n.CalendarDay__outside {\n  border: 0;\n  background: #fff;\n  color: #484848\n}\n.CalendarDay__outside:hover {\n  border: 0\n}\n.CalendarDay__blocked_minimum_nights {\n  background: #fff;\n  border: 1px solid #eceeee;\n  color: #cacccd\n}\n.CalendarDay__blocked_minimum_nights:active,\n.CalendarDay__blocked_minimum_nights:hover {\n  background: #fff;\n  color: #cacccd\n}\n.CalendarDay__highlighted_calendar {\n  background: #ffe8bc;\n  color: #484848\n}\n.CalendarDay__highlighted_calendar:active,\n.CalendarDay__highlighted_calendar:hover {\n  background: #ffce71;\n  color: #484848\n}\n.CalendarDay__selected_span {\n  background: #66e2da;\n  border: 1px double #33dacd;\n  color: #fff\n}\n.CalendarDay__selected_span:active,\n.CalendarDay__selected_span:hover {\n  background: #33dacd;\n  border: 1px double #33dacd;\n  color: #fff\n}\n.CalendarDay__last_in_range,\n.CalendarDay__last_in_range:hover {\n  border-style: solid\n}\n.CalendarDay__selected,\n.CalendarDay__selected:active,\n.CalendarDay__selected:hover {\n  background: #00a699;\n  border: 1px double #00a699;\n  color: #fff\n}\n.CalendarDay__hovered_span,\n.CalendarDay__hovered_span:hover {\n  background: #b2f1ec;\n  border: 1px double #80e8e0;\n  color: #007a87\n}\n.CalendarDay__hovered_span:active {\n  background: #80e8e0;\n  border: 1px double #80e8e0;\n  color: #007a87\n}\n.CalendarDay__blocked_calendar,\n.CalendarDay__blocked_calendar:active,\n.CalendarDay__blocked_calendar:hover {\n  background: #cacccd;\n  border: 1px solid #cacccd;\n  color: #82888a\n}\n.CalendarDay__blocked_out_of_range,\n.CalendarDay__blocked_out_of_range:active,\n.CalendarDay__blocked_out_of_range:hover {\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  color: #cacccd\n}\n.CalendarMonth {\n  background: #fff;\n  text-align: center;\n  vertical-align: top;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n.CalendarMonth_table {\n  border-collapse: collapse;\n  border-spacing: 0\n}\n.CalendarMonth_verticalSpacing {\n  border-collapse: separate\n}\n.CalendarMonth_caption {\n  color: #484848;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 22px;\n  padding-bottom: 37px;\n  caption-side: initial\n}\n.CalendarMonth_caption__verticalScrollable {\n  padding-top: 12px;\n  padding-bottom: 7px\n}\n.CalendarMonthGrid {\n  background: #fff;\n  text-align: left;\n  z-index: 0\n}\n.CalendarMonthGrid__animating {\n  z-index: 1\n}\n.CalendarMonthGrid__horizontal {\n  position: absolute;\n  left: 9px\n}\n.CalendarMonthGrid__vertical {\n  margin: 0 auto\n}\n.CalendarMonthGrid__vertical_scrollable {\n  margin: 0 auto;\n  overflow-y: scroll\n}\n.CalendarMonthGrid_month__horizontal {\n  display: inline-block;\n  vertical-align: top;\n  min-height: 100%\n}\n.CalendarMonthGrid_month__hideForAnimation {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none\n}\n.CalendarMonthGrid_month__hidden {\n  visibility: hidden\n}\n.DayPickerNavigation {\n  position: relative;\n  z-index: 2\n}\n.DayPickerNavigation__horizontal {\n  height: 0\n}\n.DayPickerNavigation__verticalDefault {\n  position: absolute;\n  width: 100%;\n  height: 52px;\n  bottom: 0;\n  left: 0\n}\n.DayPickerNavigation__verticalScrollableDefault {\n  position: relative\n}\n.DayPickerNavigation_button {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 0;\n  padding: 0;\n  margin: 0\n}\n.DayPickerNavigation_button__default {\n  border: 1px solid #e4e7e7;\n  background-color: #fff;\n  color: #757575\n}\n.DayPickerNavigation_button__default:focus,\n.DayPickerNavigation_button__default:hover {\n  border: 1px solid #c4c4c4\n}\n.DayPickerNavigation_button__default:active {\n  background: #f2f2f2\n}\n.DayPickerNavigation_button__disabled {\n  cursor: default;\n  border: 1px solid #f2f2f2\n}\n.DayPickerNavigation_button__disabled:focus,\n.DayPickerNavigation_button__disabled:hover {\n  border: 1px solid #f2f2f2\n}\n.DayPickerNavigation_button__disabled:active {\n  background: 0 0\n}\n.DayPickerNavigation_button__horizontalDefault {\n  position: absolute;\n  top: 18px;\n  line-height: .78;\n  border-radius: 3px;\n  padding: 6px 9px\n}\n.DayPickerNavigation_leftButton__horizontalDefault {\n  left: 22px\n}\n.DayPickerNavigation_rightButton__horizontalDefault {\n  right: 22px\n}\n.DayPickerNavigation_button__verticalDefault {\n  padding: 5px;\n  background: #fff;\n  box-shadow: 0 0 5px 2px rgba(0,0,0,.1);\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  height: 100%;\n  width: 50%\n}\n.DayPickerNavigation_nextButton__verticalDefault {\n  border-left: 0\n}\n.DayPickerNavigation_nextButton__verticalScrollableDefault {\n  width: 100%\n}\n.DayPickerNavigation_svg__horizontal {\n  height: 19px;\n  width: 19px;\n  fill: #82888a;\n  display: block\n}\n.DayPickerNavigation_svg__vertical {\n  height: 42px;\n  width: 42px;\n  fill: #484848\n}\n.DayPickerNavigation_svg__disabled {\n  fill: #f2f2f2\n}\n.DayPicker {\n  background: #fff;\n  position: relative;\n  text-align: left\n}\n.DayPicker__horizontal {\n  background: #fff\n}\n.DayPicker__verticalScrollable {\n  height: 100%\n}\n.DayPicker__hidden {\n  visibility: hidden\n}\n.DayPicker__withBorder {\n  box-shadow: 0 2px 6px rgba(0,0,0,.05),0 0 0 1px rgba(0,0,0,.07);\n  border-radius: 3px\n}\n.DayPicker_portal__horizontal {\n  box-shadow: none;\n  position: absolute;\n  left: 50%;\n  top: 50%\n}\n.DayPicker_portal__vertical {\n  position: initial\n}\n.DayPicker_focusRegion {\n  outline: 0\n}\n.DayPicker_calendarInfo__horizontal,\n.DayPicker_wrapper__horizontal {\n  display: inline-block;\n  vertical-align: top\n}\n.DayPicker_weekHeaders {\n  position: relative\n}\n.DayPicker_weekHeaders__horizontal {\n  margin-left: 9px\n}\n.DayPicker_weekHeader {\n  color: #757575;\n  position: absolute;\n  top: 62px;\n  z-index: 2;\n  text-align: left\n}\n.DayPicker_weekHeader__vertical {\n  left: 50%\n}\n.DayPicker_weekHeader__verticalScrollable {\n  top: 0;\n  display: table-row;\n  border-bottom: 1px solid #dbdbdb;\n  background: #fff;\n  margin-left: 0;\n  left: 0;\n  width: 100%;\n  text-align: center\n}\n.DayPicker_weekHeader_ul {\n  list-style: none;\n  margin: 1px 0;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 14px\n}\n.DayPicker_weekHeader_li {\n  display: inline-block;\n  text-align: center\n}\n.DayPicker_transitionContainer {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px\n}\n.DayPicker_transitionContainer__horizontal {\n  -webkit-transition: height .2s ease-in-out;\n  transition: height .2s ease-in-out\n}\n.DayPicker_transitionContainer__vertical {\n  width: 100%\n}\n.DayPicker_transitionContainer__verticalScrollable {\n  padding-top: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  overflow-y: scroll\n}\n.DateInput {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: inline-block;\n  width: 130px;\n  vertical-align: middle\n}\n.DateInput__small {\n  width: 97px\n}\n.DateInput__block {\n  width: 100%\n}\n.DateInput__disabled {\n  background: #f2f2f2;\n  color: #dbdbdb\n}\n.DateInput_input {\n  font-weight: 200;\n  font-size: 19px;\n  line-height: 24px;\n  color: #484848;\n  background-color: #fff;\n  width: 100%;\n  padding: 11px 11px 9px;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid transparent;\n  border-left: 0;\n  border-radius: 0\n}\n.DateInput_input__small {\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: .2px;\n  padding: 7px 7px 5px\n}\n.DateInput_input__regular {\n  font-weight: auto\n}\n.DateInput_input__readOnly {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n.DateInput_input__focused {\n  outline: 0;\n  background: #fff;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid #008489;\n  border-left: 0\n}\n.DateInput_input__disabled {\n  background: #f2f2f2;\n  font-style: italic\n}\n.DateInput_screenReaderMessage {\n  border: 0;\n  clip: rect(0,0,0,0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px\n}\n.DateInput_fang {\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  left: 22px;\n  z-index: 2\n}\n.DateInput_fangShape {\n  fill: #fff\n}\n.DateInput_fangStroke {\n  stroke: #dbdbdb;\n  fill: transparent\n}\n.DateRangePickerInput {\n  background-color: #fff;\n  display: inline-block\n}\n.DateRangePickerInput__disabled {\n  background: #f2f2f2\n}\n.DateRangePickerInput__withBorder {\n  border-radius: 2px;\n  border: 1px solid #dbdbdb\n}\n.DateRangePickerInput__rtl {\n  direction: rtl\n}\n.DateRangePickerInput__block {\n  display: block\n}\n.DateRangePickerInput__showClearDates {\n  padding-right: 30px\n}\n.DateRangePickerInput_arrow {\n  display: inline-block;\n  vertical-align: middle;\n  color: #484848\n}\n.DateRangePickerInput_arrow_svg {\n  vertical-align: middle;\n  fill: #484848;\n  height: 24px;\n  width: 24px\n}\n.DateRangePickerInput_clearDates {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%)\n}\n.DateRangePickerInput_clearDates__small {\n  padding: 6px\n}\n.DateRangePickerInput_clearDates_default:focus,\n.DateRangePickerInput_clearDates_default:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n.DateRangePickerInput_clearDates__hide {\n  visibility: hidden\n}\n.DateRangePickerInput_clearDates_svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n.DateRangePickerInput_clearDates_svg__small {\n  height: 9px\n}\n.DateRangePickerInput_calendarIcon {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n.DateRangePickerInput_calendarIcon_svg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n.DateRangePicker {\n  position: relative;\n  display: inline-block\n}\n.DateRangePicker__block {\n  display: block\n}\n.DateRangePicker_picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n.DateRangePicker_picker__rtl {\n  direction: rtl\n}\n.DateRangePicker_picker__directionLeft {\n  left: 0\n}\n.DateRangePicker_picker__directionRight {\n  right: 0\n}\n.DateRangePicker_picker__portal {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n.DateRangePicker_picker__fullScreenPortal {\n  background-color: #fff\n}\n.DateRangePicker_closeButton {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n.DateRangePicker_closeButton:focus,\n.DateRangePicker_closeButton:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n.DateRangePicker_closeButton_svg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}";
styleInject(css$A);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */

function is$1(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */


function shallowEqual(objA, objB) {
  if (is$1(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$2.call(objB, keysA[i]) || !is$1(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

var shallowEqual_1 = shallowEqual;
/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual_1(instance.props, nextProps) || !shallowEqual_1(instance.state, nextState);
}

var reactAddonsShallowCompare = shallowCompare;

function isValidMoment(testMoment) {
  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
    return false;
  }
  /* istanbul ignore else  */


  if (typeof testMoment.isValid === 'function') {
    // moment 1.7.0+
    return testMoment.isValid();
  }
  /* istanbul ignore next */


  return !isNaN(testMoment);
}

var momentValidationWrapper = {
  isValidMoment: isValidMoment
};
var messages = {
  invalidPredicate: '`predicate` must be a function',
  invalidPropValidator: '`propValidator` must be a function',
  requiredCore: 'is marked as required',
  invalidTypeCore: 'Invalid input type',
  predicateFailureCore: 'Failed to succeed with predicate',
  anonymousMessage: '<<anonymous>>',
  baseInvalidMessage: 'Invalid '
};

function constructPropValidatorVariations(propValidator) {
  if (typeof propValidator !== 'function') {
    throw new Error(messages.invalidPropValidator);
  }

  var requiredPropValidator = propValidator.bind(null, false, null);
  requiredPropValidator.isRequired = propValidator.bind(null, true, null);

  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
    if (typeof predicate !== 'function') {
      throw new Error(messages.invalidPredicate);
    }

    var basePropValidator = propValidator.bind(null, false, predicate);
    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
    return basePropValidator;
  };

  return requiredPropValidator;
}

function createInvalidRequiredErrorMessage(propName, componentName, value) {
  return new Error('The prop `' + propName + '` ' + messages.requiredCore + ' in `' + componentName + '`, but its value is `' + value + '`.');
}

var independentGuardianValue = -1;

function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
  var isPropValueUndefined = typeof propValue === 'undefined';
  var isPropValueNull = propValue === null;

  if (isRequired) {
    if (isPropValueUndefined) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
    } else if (isPropValueNull) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
    }
  }

  if (isPropValueUndefined || isPropValueNull) {
    return null;
  }

  return independentGuardianValue;
}

function createMomentChecker(type, typeValidator, validator, momentType) {
  function propValidator(isRequired, // Bound parameter to indicate with the propType is required
  predicate, // Bound parameter to allow user to add dynamic validation
  props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = typeof propValue;
    componentName = componentName || messages.anonymousMessage;
    propFullName = propFullName || propName;
    var preValidationRequireCheckValue = preValidationRequireCheck(isRequired, componentName, propFullName, propValue);

    if (preValidationRequireCheckValue !== independentGuardianValue) {
      return preValidationRequireCheckValue;
    }

    if (typeValidator && !typeValidator(propValue)) {
      return new Error(messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' + 'supplied to `' + componentName + '`, expected `' + type + '`.');
    }

    if (!validator(propValue)) {
      return new Error(messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' + 'supplied to `' + componentName + '`, expected `' + momentType + '`.');
    }

    if (predicate && !predicate(propValue)) {
      var predicateName = predicate.name || messages.anonymousMessage;
      return new Error(messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' + 'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' + predicateName + '`.');
    }

    return null;
  }

  return constructPropValidatorVariations(propValidator);
}

var core = {
  constructPropValidatorVariations: constructPropValidatorVariations,
  createMomentChecker: createMomentChecker,
  messages: messages
};
var src$1 = {
  momentObj: core.createMomentChecker('object', function (obj) {
    return typeof obj === 'object';
  }, function isValid(value) {
    return momentValidationWrapper.isValidMoment(value);
  }, 'Moment'),
  momentString: core.createMomentChecker('string', function (str) {
    return typeof str === 'string';
  }, function isValid(value) {
    return momentValidationWrapper.isValidMoment(moment(value));
  }, 'Moment'),
  momentDurationObj: core.createMomentChecker('object', function (obj) {
    return typeof obj === 'object';
  }, function isValid(value) {
    return moment.isDuration(value);
  }, 'Duration')
};

function noop$3() {
  return null;
}

noop$3.isRequired = noop$3;

function noopThunk() {
  return noop$3;
}

var mocks = {
  and: noopThunk,
  between: noopThunk,
  booleanSome: noopThunk,
  childrenHavePropXorChildren: noopThunk,
  childrenOf: noopThunk,
  childrenOfType: noopThunk,
  childrenSequenceOf: noopThunk,
  componentWithName: noopThunk,
  disallowedIf: noopThunk,
  elementType: noopThunk,
  empty: noopThunk,
  explicitNull: noopThunk,
  forbidExtraProps: Object,
  integer: noopThunk,
  keysOf: noopThunk,
  mutuallyExclusiveProps: noopThunk,
  mutuallyExclusiveTrueProps: noopThunk,
  nChildren: noopThunk,
  nonNegativeInteger: noop$3,
  nonNegativeNumber: noopThunk,
  numericString: noopThunk,
  object: noopThunk,
  or: noopThunk,
  range: noopThunk,
  ref: noopThunk,
  requiredBy: noopThunk,
  restrictedProp: noopThunk,
  sequenceOf: noopThunk,
  shape: noopThunk,
  stringEndsWith: noopThunk,
  stringStartsWith: noopThunk,
  uniqueArray: noopThunk,
  uniqueArrayOf: noopThunk,
  valuesOf: noopThunk,
  withShape: noopThunk
}; // modified from https://github.com/es-shims/es6-shim

var canBeObject = function canBeObject(obj) {
  return typeof obj !== 'undefined' && obj !== null;
};

var hasSymbols$5 = shams();
var toObject$1 = Object;
var push = functionBind.call(Function.call, Array.prototype.push);
var propIsEnumerable$1 = functionBind.call(Function.call, Object.prototype.propertyIsEnumerable);
var originalGetSymbols = hasSymbols$5 ? Object.getOwnPropertySymbols : null;

var implementation$5 = function assign(target, source1) {
  if (!canBeObject(target)) {
    throw new TypeError('target must be an object');
  }

  var objTarget = toObject$1(target);
  var s, source, i, props, syms, value, key;

  for (s = 1; s < arguments.length; ++s) {
    source = toObject$1(arguments[s]);
    props = objectKeys(source);
    var getSymbols = hasSymbols$5 && (Object.getOwnPropertySymbols || originalGetSymbols);

    if (getSymbols) {
      syms = getSymbols(source);

      for (i = 0; i < syms.length; ++i) {
        key = syms[i];

        if (propIsEnumerable$1(source, key)) {
          push(props, key);
        }
      }
    }

    for (i = 0; i < props.length; ++i) {
      key = props[i];
      value = source[key];

      if (propIsEnumerable$1(source, key)) {
        objTarget[key] = value;
      }
    }
  }

  return objTarget;
};

var lacksProperEnumerationOrder = function lacksProperEnumerationOrder() {
  if (!Object.assign) {
    return false;
  } // v8, specifically in node 4.x, has a bug with incorrect property enumeration order
  // note: this does not detect the bug unless there's 20 characters


  var str = 'abcdefghijklmnopqrst';
  var letters = str.split('');
  var map = {};

  for (var i = 0; i < letters.length; ++i) {
    map[letters[i]] = letters[i];
  }

  var obj = Object.assign({}, map);
  var actual = '';

  for (var k in obj) {
    actual += k;
  }

  return str !== actual;
};

var assignHasPendingExceptions = function assignHasPendingExceptions() {
  if (!Object.assign || !Object.preventExtensions) {
    return false;
  } // Firefox 37 still has "pending exception" logic in its Object.assign implementation,
  // which is 72% slower than our shim, and Firefox 40's native implementation.


  var thrower = Object.preventExtensions({
    1: 2
  });

  try {
    Object.assign(thrower, 'xy');
  } catch (e) {
    return thrower[1] === 'y';
  }

  return false;
};

var polyfill$4 = function getPolyfill() {
  if (!Object.assign) {
    return implementation$5;
  }

  if (lacksProperEnumerationOrder()) {
    return implementation$5;
  }

  if (assignHasPendingExceptions()) {
    return implementation$5;
  }

  return Object.assign;
};

var shim$1 = function shimAssign() {
  var polyfill = polyfill$4();
  defineProperties_1(Object, {
    assign: polyfill
  }, {
    assign: function assign() {
      return Object.assign !== polyfill;
    }
  });
  return polyfill;
};

var polyfill$5 = polyfill$4();
defineProperties_1(polyfill$5, {
  getPolyfill: polyfill$4,
  implementation: implementation$5,
  shim: shim$1
});
var object_assign = polyfill$5;
var isPlainObject_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  exports['default'] = isPlainObject;

  function isPlainObject(x) {
    return x && (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && !Array.isArray(x);
  }

  module.exports = exports['default'];
});
unwrapExports(isPlainObject_1);
var build = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = forbidExtraProps;

  var _object2 = _interopRequireDefault(object_assign);

  var _has2 = _interopRequireDefault(src);

  var _isPlainObject2 = _interopRequireDefault(isPlainObject_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var zeroWidthSpace = "\u200B";
  var specialProperty = 'prop-types-exact: ' + zeroWidthSpace;
  var semaphore = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' ? Symbol['for'](specialProperty) :
  /* istanbul ignore next */
  specialProperty;

  function brand(fn) {
    return (0, _object2['default'])(fn, _defineProperty({}, specialProperty, semaphore));
  }

  function isBranded(value) {
    return value && value[specialProperty] === semaphore;
  }

  function forbidExtraProps(propTypes) {
    if (!(0, _isPlainObject2['default'])(propTypes)) {
      throw new TypeError('given propTypes must be an object');
    }

    if ((0, _has2['default'])(propTypes, specialProperty) && !isBranded(propTypes[specialProperty])) {
      throw new TypeError('Against all odds, you created a propType for a prop that uses both the zero-width space and our custom string - which, sadly, conflicts with `prop-types-exact`');
    }

    return (0, _object2['default'])({}, propTypes, _defineProperty({}, specialProperty, brand(function () {
      function forbidUnknownProps(props, _, componentName) {
        var unknownProps = Object.keys(props).filter(function (prop) {
          return !(0, _has2['default'])(propTypes, prop);
        });

        if (unknownProps.length > 0) {
          return new TypeError(String(componentName) + ': unknown props found: ' + String(unknownProps.join(', ')));
        }

        return null;
      }

      return forbidUnknownProps;
    }())));
  }

  module.exports = exports['default'];
});
unwrapExports(build);
var wrapValidator_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = wrapValidator;

  var _object = _interopRequireDefault(object_assign);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function wrapValidator(validator, typeName) {
    var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return (0, _object["default"])(validator.bind(), {
      typeName: typeName,
      typeChecker: typeChecker,
      isRequired: (0, _object["default"])(validator.isRequired.bind(), {
        typeName: typeName,
        typeChecker: typeChecker,
        typeRequired: true
      })
    });
  }
});
unwrapExports(wrapValidator_1);
var and = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = andValidator;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function andValidator(validators) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';

    if (!Array.isArray(validators)) {
      throw new TypeError('and: 2 or more validators are required');
    }

    if (validators.length <= 1) {
      throw new RangeError('and: 2 or more validators are required');
    }

    var validator = function and() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var firstError = null;
      validators.some(function (validatorFn) {
        firstError = validatorFn.apply(void 0, args);
        return firstError != null;
      });
      return firstError == null ? null : firstError;
    };

    validator.isRequired = function andIsRequired() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var firstError = null;
      validators.some(function (validatorFn) {
        firstError = validatorFn.isRequired.apply(validatorFn, args);
        return firstError != null;
      });
      return firstError == null ? null : firstError;
    };

    return (0, _wrapValidator["default"])(validator, name, validators);
  }
});
unwrapExports(and);
var es7 = es2016;
var isEnumerable$1 = functionBind.call(Function.call, Object.prototype.propertyIsEnumerable);

var implementation$6 = function entries(O) {
  var obj = es7.RequireObjectCoercible(O);
  var entrys = [];

  for (var key in obj) {
    if (src(obj, key) && isEnumerable$1(obj, key)) {
      entrys.push([key, obj[key]]);
    }
  }

  return entrys;
};

var polyfill$6 = function getPolyfill() {
  return typeof Object.entries === 'function' ? Object.entries : implementation$6;
};

var shim$2 = function shimEntries() {
  var polyfill = polyfill$6();
  defineProperties_1(Object, {
    entries: polyfill
  }, {
    entries: function testEntries() {
      return Object.entries !== polyfill;
    }
  });
  return polyfill;
};

var polyfill$7 = polyfill$6();
defineProperties_1(polyfill$7, {
  getPolyfill: polyfill$6,
  implementation: implementation$6,
  shim: shim$2
});
var object_entries = polyfill$7;
var isPlainObject$3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _isPlainObject = _interopRequireDefault(isPlainObject_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _isPlainObject["default"];
  exports["default"] = _default;
});
unwrapExports(isPlainObject$3);
var shape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = shapeValidator;

  var _isPlainObject = _interopRequireDefault(isPlainObject$3);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function shapeValidator(shapeTypes) {
    if (!(0, _isPlainObject["default"])(shapeTypes)) {
      throw new TypeError('shape must be a normal object');
    }

    function shape(props, propName, componentName, location) {
      var propValue = props[propName];

      if (propValue == null) {
        return null;
      } // code adapted from PropTypes.shape: https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L381
      // eslint-disable-next-line guard-for-in, no-restricted-syntax


      for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        rest[_key - 4] = arguments[_key];
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (checker) {
          var error = checker.apply(void 0, [propValue, key, componentName, location].concat(rest));

          if (error) {
            return error;
          }
        }
      }

      return null;
    }

    shape.isRequired = function shapeRequired(props, propName, componentName) {
      var propValue = props[propName];

      if (propValue == null) {
        return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return shape.apply(void 0, [props, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(shape, 'shape', shapeTypes);
  }
});
unwrapExports(shape);
var isPrimitive_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isPrimitive;

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function isPrimitive(x) {
    return !x || _typeof(x) !== 'object' && typeof x !== 'function';
  }
});
unwrapExports(isPrimitive_1);
var valuesOf = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = valuesOfValidator;

  var _isPrimitive = _interopRequireDefault(isPrimitive_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  } // code adapted from https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L307-L340


  function valuesOfValidator(propType) {
    if (typeof propType !== 'function') {
      throw new TypeError('objectOf: propType must be a function');
    }

    var validator = function valuesOf(props, propName, componentName, location, propFullName) {
      for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        rest[_key - 5] = arguments[_key];
      }

      var propValue = props[propName];

      if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
        return null;
      }

      var firstError;
      Object.keys(propValue).some(function (key) {
        firstError = propType.apply(void 0, [propValue, key, componentName, location, "".concat(propFullName, ".").concat(key)].concat(rest));
        return firstError;
      });
      return firstError || null;
    };

    validator.isRequired = function valuesOfRequired(props, propName, componentName) {
      var propValue = props[propName];

      if (propValue == null) {
        return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return validator.apply(void 0, [props, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(validator, 'valuesOf', propType);
  }
});
unwrapExports(valuesOf);
var between = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = betweenValidator;

  var _object = _interopRequireDefault(object_entries);

  var _shape = _interopRequireDefault(shape);

  var _valuesOf = _interopRequireDefault(valuesOf);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function number(props, propName, componentName) {
    var value = props[propName];

    if (typeof value === 'number' && !isNaN(value)) {
      return null;
    }

    return new TypeError("".concat(componentName, ": ").concat(propName, " must be a non-NaN number."));
  }

  function numberOrPropsFunc(props, propName) {
    var value = props[propName];

    if (typeof value === 'function') {
      return null;
    }

    if (typeof value === 'number' && !isNaN(value)) {
      return null;
    }

    return new TypeError("".concat(propName, ": a function, or a non-NaN number is required"));
  }

  function lowerCompare(value, _ref) {
    var gt = _ref.gt,
        gte = _ref.gte;

    if (typeof gt === 'number') {
      return value > gt;
    }

    if (typeof gte === 'number') {
      return value >= gte;
    }

    return true;
  }

  function upperCompare(value, _ref2) {
    var lt = _ref2.lt,
        lte = _ref2.lte;

    if (typeof lt === 'number') {
      return value < lt;
    }

    if (typeof lte === 'number') {
      return value <= lte;
    }

    return true;
  }

  function greaterThanError(_ref3) {
    var gt = _ref3.gt,
        gte = _ref3.gte;

    if (typeof gt === 'number') {
      return "greater than ".concat(gt);
    }

    if (typeof gte === 'number') {
      return "greater than or equal to ".concat(gte);
    }

    return '';
  }

  function lessThanError(_ref4) {
    var lt = _ref4.lt,
        lte = _ref4.lte;

    if (typeof lt === 'number') {
      return "less than ".concat(lt);
    }

    if (typeof lte === 'number') {
      return "less than or equal to ".concat(lte);
    }

    return '';
  }

  function errorMessage(componentName, propName, opts) {
    var errors = [greaterThanError(opts), lessThanError(opts)].filter(Boolean).join(' and ');
    return "".concat(componentName, ": ").concat(propName, " must be ").concat(errors);
  }

  function propsThunkify(opts) {
    return (0, _object["default"])(opts).reduce(function (acc, _ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      var numberThunk = typeof value === 'number' ? function () {
        return value;
      } : value;
      return _objectSpread({}, acc, _defineProperty({}, key, numberThunk));
    }, {});
  }

  function invokeWithProps(optsThunks, props) {
    return (0, _object["default"])(optsThunks).reduce(function (acc, _ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          thunk = _ref8[1];

      var value = thunk(props);
      return _objectSpread({}, acc, _defineProperty({}, key, value));
    }, {});
  }

  var argValidators = [(0, _shape["default"])({
    lt: numberOrPropsFunc,
    gt: numberOrPropsFunc
  }).isRequired, (0, _shape["default"])({
    lte: numberOrPropsFunc,
    gt: numberOrPropsFunc
  }).isRequired, (0, _shape["default"])({
    lt: numberOrPropsFunc,
    gte: numberOrPropsFunc
  }).isRequired, (0, _shape["default"])({
    lte: numberOrPropsFunc,
    gte: numberOrPropsFunc
  }).isRequired, (0, _shape["default"])({
    lt: numberOrPropsFunc
  }).isRequired, (0, _shape["default"])({
    lte: numberOrPropsFunc
  }).isRequired, (0, _shape["default"])({
    gt: numberOrPropsFunc
  }).isRequired, (0, _shape["default"])({
    gte: numberOrPropsFunc
  }).isRequired];

  function argValidator(props, propName) {
    return argValidators.every(function (validator) {
      return !!validator(props, propName);
    });
  }

  var thunkValueValidator = (0, _valuesOf["default"])(number).isRequired;

  function betweenValidator(options) {
    var argError = argValidator({
      options: options
    }, 'options');

    if (argError) {
      throw new TypeError('between: only one of the pairs of `lt`/`lte`, and `gt`/`gte`, may be supplied, and at least one pair must be provided.');
    }

    var optsThunks = propsThunkify(options);

    var validator = function between(props, propName, componentName) {
      var propValue = props[propName];

      if (propValue == null) {
        return null;
      }

      if (typeof propValue !== 'number') {
        return new RangeError("".concat(componentName, ": ").concat(propName, " must be a number, got \"").concat(_typeof(propValue), "\""));
      }

      var opts = invokeWithProps(optsThunks, props);

      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty({}, propName, opts), propName, componentName].concat(rest));

      if (thunkValuesError) {
        return thunkValuesError;
      }

      if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
        return new RangeError(errorMessage(componentName, propName, opts));
      }

      return null;
    };

    validator.isRequired = function betweenRequired(props, propName, componentName) {
      var propValue = props[propName];

      if (typeof propValue !== 'number') {
        return new RangeError("".concat(componentName, ": ").concat(propName, " must be a number, got \"").concat(_typeof(propValue), "\""));
      }

      var opts = invokeWithProps(optsThunks, props);

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty({}, propName, opts), propName, componentName].concat(rest));

      if (thunkValuesError) {
        return thunkValuesError;
      }

      if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
        return new RangeError(errorMessage(componentName, propName, opts));
      }

      return null;
    };

    return (0, _wrapValidator["default"])(validator, 'between', options);
  }
});
unwrapExports(between);
var booleanSome = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = booleanSomeValidator;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function booleanSomeValidator() {
    for (var _len = arguments.length, notAllPropsFalse = new Array(_len), _key = 0; _key < _len; _key++) {
      notAllPropsFalse[_key] = arguments[_key];
    }

    if (notAllPropsFalse.length < 1) {
      throw new TypeError('at least one prop (one of which must be `true`) is required');
    }

    if (!notAllPropsFalse.every(function (x) {
      return typeof x === 'string';
    })) {
      throw new TypeError('all booleanSome props must be strings');
    }

    var propsList = notAllPropsFalse.join(', or ');

    var validator = function booleanSome(props, propName, componentName) {
      var countFalse = function countFalse(count, prop) {
        return count + (props[prop] === false ? 1 : 0);
      };

      var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);

      if (falsePropCount === notAllPropsFalse.length) {
        return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return propTypes$1.bool.apply(void 0, [props, propName, componentName].concat(rest));
    };

    validator.isRequired = function booleanSomeRequired(props, propName, componentName) {
      var countFalse = function countFalse(count, prop) {
        return count + (props[prop] === false ? 1 : 0);
      };

      var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);

      if (falsePropCount === notAllPropsFalse.length) {
        return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
      }

      for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        rest[_key3 - 3] = arguments[_key3];
      }

      return propTypes$1.bool.isRequired.apply(propTypes$1.bool, [props, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(validator, "booleanSome: ".concat(propsList), notAllPropsFalse);
  }
});
unwrapExports(booleanSome);
var childrenHavePropXorChildren_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = childrenHavePropXorChildren;

  var _react = _interopRequireDefault(React__default);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function childrenHavePropXorChildren(prop) {
    if (typeof prop !== 'string' && _typeof(prop) !== 'symbol') {
      throw new TypeError('invalid prop: must be string or symbol');
    }

    var validator = function childrenHavePropXorChildrenWithProp(_ref, _, componentName) {
      var children = _ref.children;
      var truthyChildrenCount = 0;
      var propCount = 0;
      var grandchildrenCount = 0;

      _react["default"].Children.forEach(children, function (child) {
        if (!child) {
          return;
        }

        truthyChildrenCount += 1;

        if (child.props[prop]) {
          propCount += 1;
        }

        if (_react["default"].Children.count(child.props.children)) {
          grandchildrenCount += 1;
        }
      });

      if (propCount === truthyChildrenCount && grandchildrenCount === 0 || propCount === 0 && grandchildrenCount === truthyChildrenCount || propCount === 0 && grandchildrenCount === 0) {
        return null;
      }

      return new TypeError("`".concat(componentName, "` requires children to all have prop \u201C").concat(prop, "\u201D, all have children, or all have neither."));
    };

    validator.isRequired = validator;
    return (0, _wrapValidator["default"])(validator, "childrenHavePropXorChildrenWithProp:".concat(prop), prop);
  }
});
unwrapExports(childrenHavePropXorChildren_1);
var renderableChildren_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = renderableChildren;

  var _react = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function renderableChildren(childrenProp) {
    return _react["default"].Children.toArray(childrenProp).filter(function (child) {
      return child === 0 || child;
    });
  }
});
unwrapExports(renderableChildren_1);
var childrenOf_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = childrenOf;

  var _renderableChildren = _interopRequireDefault(renderableChildren_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function validateChildren(propType, children, props) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var error;
    children.some(function (child) {
      error = propType.apply(void 0, [_objectSpread({}, props, {
        children: child
      }), 'children'].concat(rest));
      return error;
    });
    return error || null;
  }

  function childrenOf(propType) {
    function childrenOfPropType(props, propName, componentName) {
      if (propName !== 'children') {
        return new TypeError("".concat(componentName, " is using the childrenOf validator on non-children prop \"").concat(propName, "\""));
      }

      var propValue = props[propName];

      if (propValue == null) {
        return null;
      }

      var children = (0, _renderableChildren["default"])(propValue);

      if (children.length === 0) {
        return null;
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
    }

    childrenOfPropType.isRequired = function (props, propName, componentName) {
      if (propName !== 'children') {
        return new TypeError("".concat(componentName, " is using the childrenOf validator on non-children prop \"").concat(propName, "\""));
      }

      var children = (0, _renderableChildren["default"])(props[propName]);

      if (children.length === 0) {
        return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(propType.typeName || propType.name));
      }

      for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        rest[_key3 - 3] = arguments[_key3];
      }

      return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(childrenOfPropType, 'childrenOf', propType);
  }
});
unwrapExports(childrenOf_1);
var es6$1 = es2015$1;

var implementation$7 = function find(predicate) {
  var list = es6$1.ToObject(this);
  var length = es6$1.ToLength(list.length);

  if (!es6$1.IsCallable(predicate)) {
    throw new TypeError('Array#find: predicate must be a function');
  }

  if (length === 0) {
    return void 0;
  }

  var thisArg;

  if (arguments.length > 0) {
    thisArg = arguments[1];
  }

  for (var i = 0, value; i < length; i++) {
    value = list[i]; // inlined for performance: if (ES.Call(predicate, thisArg, [value, i, list])) {

    if (predicate.apply(thisArg, [value, i, list])) {
      return value;
    }
  }

  return void 0;
};

var polyfill$8 = function getPolyfill() {
  // Detect if an implementation exists
  // Detect early implementations which skipped holes in sparse arrays
  // eslint-disable-next-line no-sparse-arrays
  var implemented = Array.prototype.find && [, 1].find(function () {
    return true;
  }) !== 1; // eslint-disable-next-line global-require

  return implemented ? Array.prototype.find : implementation$7;
};

var shim$3 = function shimArrayPrototypeFind() {
  var polyfill = polyfill$8();
  defineProperties_1(Array.prototype, {
    find: polyfill
  }, {
    find: function find() {
      return Array.prototype.find !== polyfill;
    }
  });
  return polyfill;
};

var slice$2 = Array.prototype.slice;
var polyfill$9 = polyfill$8();

var boundFindShim = function find(array, predicate) {
  // eslint-disable-line no-unused-vars
  es6$1.RequireObjectCoercible(array);
  var args = slice$2.call(arguments, 1);
  return polyfill$9.apply(array, args);
};

defineProperties_1(boundFindShim, {
  getPolyfill: polyfill$8,
  implementation: implementation$7,
  shim: shim$3
});
var array_prototype_find = boundFindShim;

var functionsHaveNames = function functionsHaveNames() {
  return typeof function f() {}.name === 'string';
};

var gOPD$3 = Object.getOwnPropertyDescriptor;

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
  return functionsHaveNames() && gOPD$3 && !!gOPD$3(function () {}, 'name').configurable;
};

var functionsHaveNames_1 = functionsHaveNames;
var functionsHaveNames$1 = functionsHaveNames_1();
var functionToString = functionBind.call(Function.call, Function.prototype.toString);
var stringMatch = functionBind.call(Function.call, String.prototype.match);
var classRegex = /^class /;

var isClass = function isClassConstructor(fn) {
  if (isCallable(fn)) {
    return false;
  }

  if (typeof fn !== 'function') {
    return false;
  }

  try {
    var match = stringMatch(functionToString(fn), classRegex);
    return !!match;
  } catch (e) {}

  return false;
};

var regex = /\s*function\s+([^(\s]*)\s*/;
var functionProto = Function.prototype;

var implementation$8 = function getName() {
  if (!isClass(this) && !isCallable(this)) {
    throw new TypeError('Function.prototype.name sham getter called on non-function');
  }

  if (functionsHaveNames$1) {
    return this.name;
  }

  if (this === functionProto) {
    return '';
  }

  var str = functionToString(this);
  var match = stringMatch(str, regex);
  var name = match && match[1];
  return name;
};

var polyfill$a = function getPolyfill() {
  return implementation$8;
};

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var functionsHaveNames$2 = functionsHaveNames_1();
var defineProperty$8 = Object.defineProperty;
var TypeErr = TypeError;

var shim$4 = function shimName() {
  var polyfill = polyfill$a();

  if (functionsHaveNames$2) {
    return polyfill;
  }

  if (!supportsDescriptors$1) {
    throw new TypeErr('Shimming Function.prototype.name support requires ES5 property descriptor support.');
  }

  var functionProto = Function.prototype;
  defineProperty$8(functionProto, 'name', {
    configurable: true,
    enumerable: false,
    get: function get() {
      var name = polyfill.call(this);

      if (this !== functionProto) {
        defineProperty$8(this, 'name', {
          configurable: true,
          enumerable: false,
          value: name,
          writable: false
        });
      }

      return name;
    }
  });
  return polyfill;
};

var bound = functionBind.call(Function.call, implementation$8);
defineProperties_1(bound, {
  getPolyfill: polyfill$a,
  implementation: implementation$8,
  shim: shim$4
});
var function_prototype_name = bound;
var getComponentName_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getComponentName;

  var _functionPrototype = _interopRequireDefault(function_prototype_name);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function getComponentName(Component$$1) {
    if (typeof Component$$1 === 'string') {
      return Component$$1;
    }

    if (typeof Component$$1 === 'function') {
      return Component$$1.displayName || (0, _functionPrototype["default"])(Component$$1);
    }

    if ((0, reactIs$2.isForwardRef)({
      type: Component$$1,
      $$typeof: reactIs$2.Element
    })) {
      return Component$$1.displayName;
    }

    return null;
  }
});
unwrapExports(getComponentName_1);
var childrenOfType_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _arrayPrototype = _interopRequireDefault(array_prototype_find);

  var _getComponentName = _interopRequireDefault(getComponentName_1);

  var _renderableChildren = _interopRequireDefault(renderableChildren_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function onlyTypes(types, children, componentName) {
    if (!children.every(function (child) {
      return child && (0, _arrayPrototype["default"])(types, function (Type) {
        return Type === '*' || child.type === Type;
      });
    })) {
      var typeNames = types.map(_getComponentName["default"]).join(', or ');
      return new TypeError("`".concat(componentName, "` only accepts children of type ").concat(typeNames));
    }

    return null;
  }

  function isRequired(types, children, componentName) {
    if (children.length === 0) {
      var typeNames = types.map(_getComponentName["default"]).join(', or ');
      return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(typeNames));
    }

    return null;
  }

  function childrenOfType() {
    for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
      types[_key] = arguments[_key];
    }

    if (types.length < 1) {
      throw new TypeError('childrenOfType: at least 1 type is required');
    }

    function validator(props, propName, componentName) {
      return onlyTypes(types, (0, _renderableChildren["default"])(props[propName]), componentName);
    }

    validator.isRequired = function (props, propName, componentName) {
      var children = (0, _renderableChildren["default"])(props[propName]);
      return isRequired(types, children, componentName) || onlyTypes(types, children, componentName);
    };

    return (0, _wrapValidator["default"])(validator, 'childrenOfType', types);
  }

  var _default = childrenOfType;
  exports["default"] = _default;
});
unwrapExports(childrenOfType_1);
var isInteger = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var floor = Math.floor;
  var finite = isFinite;

  var _default = Number.isInteger ||
  /* istanbul ignore next */
  function (x) {
    return typeof x === 'number' && finite(x) && floor(x) === x;
  };

  exports["default"] = _default;
});
unwrapExports(isInteger);
var integer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _isInteger = _interopRequireDefault(isInteger);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function requiredInteger(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null || !(0, _isInteger["default"])(propValue)) {
      return new RangeError("".concat(propName, " in ").concat(componentName, " must be an integer"));
    }

    return null;
  }

  var validator = function integer(props, propName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    return requiredInteger.apply(void 0, [props, propName].concat(rest));
  };

  validator.isRequired = requiredInteger;

  var _default = function _default() {
    return (0, _wrapValidator["default"])(validator, 'integer');
  };

  exports["default"] = _default;
});
unwrapExports(integer);
/* https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.is */

var NumberIsNaN = function NumberIsNaN(value) {
  return value !== value;
};

var objectIs = function is(a, b) {
  if (a === 0 && b === 0) {
    return 1 / a === 1 / b;
  } else if (a === b) {
    return true;
  } else if (NumberIsNaN(a) && NumberIsNaN(b)) {
    return true;
  }

  return false;
};

var nonNegativeNumber_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _objectIs = _interopRequireDefault(objectIs);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isNonNegative(x) {
    return typeof x === 'number' && isFinite(x) && x >= 0 && !(0, _objectIs["default"])(x, -0);
  }

  function nonNegativeNumber(props, propName, componentName) {
    var value = props[propName];

    if (value == null || isNonNegative(value)) {
      return null;
    }

    return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
  }

  function requiredNonNegativeNumber(props, propName, componentName) {
    var value = props[propName];

    if (isNonNegative(value)) {
      return null;
    }

    return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
  }

  nonNegativeNumber.isRequired = requiredNonNegativeNumber;

  var _default = function _default() {
    return (0, _wrapValidator["default"])(nonNegativeNumber, 'nonNegativeNumber');
  };

  exports["default"] = _default;
});
unwrapExports(nonNegativeNumber_1);
var nonNegativeInteger = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _and = _interopRequireDefault(and);

  var _integer = _interopRequireDefault(integer);

  var _nonNegativeNumber = _interopRequireDefault(nonNegativeNumber_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = (0, _and["default"])([(0, _integer["default"])(), (0, _nonNegativeNumber["default"])()], 'nonNegativeInteger');

  exports["default"] = _default;
});
unwrapExports(nonNegativeInteger);
var typeOf_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = typeOf;

  var _react = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function typeOf(child) {
    if (child === null) {
      return 'null';
    }

    if (Array.isArray(child)) {
      return 'array';
    }

    if (_typeof(child) !== 'object') {
      return _typeof(child);
    }

    if (_react["default"].isValidElement(child)) {
      return child.type;
    }

    return child;
  }
});
unwrapExports(typeOf_1);
var object_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _isPlainObject = _interopRequireDefault(isPlainObject$3);

  var _typeOf = _interopRequireDefault(typeOf_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  /*
    code adapted from https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L202-L206
    so that it can be called outside of React's normal PropType flow
  */


  var ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };

  function object(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    if ((0, _isPlainObject["default"])(propValue)) {
      return null;
    }

    var locationName = ReactPropTypeLocationNames[location] || location;
    return new TypeError("Invalid ".concat(locationName, " `").concat(propFullName, "` of type `").concat((0, _typeOf["default"])(propValue), "` supplied to `").concat(componentName, "`, expected `object`."));
  }

  object.isRequired = function objectRequired(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];

    if (propValue == null) {
      var locationName = ReactPropTypeLocationNames[location] || location;
      return new TypeError("The ".concat(locationName, " `").concat(propFullName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(propValue, "`."));
    }

    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    return object.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
  };

  var _default = function _default() {
    return (0, _wrapValidator["default"])(object, 'object');
  };

  exports["default"] = _default;
});
unwrapExports(object_1);
var withShape_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = withShape;

  var _and = _interopRequireDefault(and);

  var _shape = _interopRequireDefault(shape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function withShape(type, shapeTypes) {
    if (typeof type !== 'function') {
      throw new TypeError('type must be a valid PropType');
    }

    var shapeValidator = (0, _shape["default"])(shapeTypes);
    return (0, _and["default"])([type, shapeValidator], 'withShape');
  }
});
unwrapExports(withShape_1);
var sequenceOf = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = sequenceOfValidator;

  var _and = _interopRequireDefault(and);

  var _between = _interopRequireDefault(between);

  var _nonNegativeInteger = _interopRequireDefault(nonNegativeInteger);

  var _object = _interopRequireDefault(object_1);

  var _withShape = _interopRequireDefault(withShape_1);

  var _typeOf = _interopRequireDefault(typeOf_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var minValidator = _nonNegativeInteger["default"];
  var maxValidator = (0, _and["default"])([_nonNegativeInteger["default"], (0, _between["default"])({
    gte: 1
  })]);

  function validateRange(min, max) {
    if (typeof max !== 'number' || typeof min !== 'number') {
      return null; // no additional checking needed unless both are present
    }

    if (min <= max) {
      return null;
    }

    return new RangeError('min must be less than or equal to max');
  }

  var specifierShape = {
    validator: function validator(props, propName) {
      var propValue = props[propName];

      if (typeof propValue !== 'function') {
        return new TypeError('"validator" must be a propType validator function');
      }

      return null;
    },
    min: function min(props, propName) {
      return minValidator(props, propName) || validateRange(props.min, props.max);
    },
    max: function max(props, propName) {
      return maxValidator(props, propName) || validateRange(props.min, props.max);
    }
  };

  function getMinMax(_ref) {
    var min = _ref.min,
        max = _ref.max;
    var minimum;
    var maximum;

    if (typeof min !== 'number' && typeof max !== 'number') {
      // neither provided, default to "1"
      minimum = 1;
      maximum = 1;
    } else {
      minimum = typeof min === 'number' ? min : 1;
      maximum = typeof max === 'number' ? max : Infinity;
    }

    return {
      minimum: minimum,
      maximum: maximum
    };
  }

  function chunkByType(items) {
    var chunk = [];
    var lastType;
    return items.reduce(function (chunks, item) {
      var itemType = (0, _typeOf["default"])(item);

      if (!lastType || itemType === lastType) {
        chunk.push(item);
      } else {
        chunks.push(chunk);
        chunk = [item];
      }

      lastType = itemType;
      return chunks;
    }, []).concat(chunk.length > 0 ? [chunk] : []);
  }

  function validateChunks(specifiers, props, propName, componentName) {
    var items = props[propName];
    var chunks = chunkByType(items);

    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    for (var i = 0; i < specifiers.length; i += 1) {
      var _specifiers$i = specifiers[i],
          validator = _specifiers$i.validator,
          min = _specifiers$i.min,
          max = _specifiers$i.max;

      var _getMinMax = getMinMax({
        min: min,
        max: max
      }),
          minimum = _getMinMax.minimum,
          maximum = _getMinMax.maximum;

      if (chunks.length === 0 && minimum === 0) {
        // no chunks left, but this specifier does not require any items
        continue; // eslint-disable-line no-continue
      }

      var arrayOfValidator = (0, propTypes$1.arrayOf)(validator).isRequired;
      var chunk = chunks.shift(); // extract the next chunk to test

      var chunkError = arrayOfValidator.apply(void 0, [_objectSpread({}, props, _defineProperty({}, propName, chunk)), propName, componentName].concat(rest));

      if (chunkError) {
        // this chunk is invalid
        if (minimum === 0) {
          // but, specifier has a min of 0 and can be skipped
          chunks.unshift(chunk); // put the chunk back, for the next iteration

          continue; // eslint-disable-line no-continue
        }

        return chunkError;
      } // chunk is valid!


      if (chunk.length < minimum) {
        return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a minimum of ").concat(min, " items, but only has ").concat(chunk.length, "."));
      }

      if (chunk.length > maximum) {
        return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a maximum of ").concat(max, " items, but has ").concat(chunk.length, "."));
      }
    }

    if (chunks.length > 0) {
      return new TypeError("".concat(componentName, ": after all ").concat(specifiers.length, " specifiers matched, ").concat(chunks.length, " types of items were remaining."));
    }

    return null;
  }

  var specifierValidator = (0, _withShape["default"])((0, _object["default"])(), specifierShape).isRequired;

  function sequenceOfValidator() {
    for (var _len2 = arguments.length, specifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      specifiers[_key2] = arguments[_key2];
    }

    if (specifiers.length === 0) {
      throw new RangeError('sequenceOf: at least one specifier is required');
    }

    var errors = specifiers.map(function (specifier, i) {
      return specifierValidator({
        specifier: specifier
      }, 'specifier', 'sequenceOf specifier', "suequenceOf specifier, index ".concat(i), "specifier, index ".concat(i));
    });

    if (errors.some(Boolean)) {
      throw new TypeError("\n      sequenceOf: all specifiers must match the appropriate shape.\n\n      Errors:\n        ".concat(errors.map(function (e, i) {
        return " - Argument index ".concat(i, ": ").concat(e.message);
      }).join(',\n        '), "\n    "));
    }

    var validator = function sequenceOf(props, propName) {
      var propValue = props[propName];

      if (propValue == null) {
        return null;
      }

      for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }

      var error = propTypes$1.array.apply(void 0, [props, propName].concat(rest));

      if (error) {
        return error;
      }

      return validateChunks.apply(void 0, [specifiers, props, propName].concat(rest));
    };

    validator.isRequired = function sequenceOfRequired(props, propName, componentName) {
      for (var _len4 = arguments.length, rest = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
        rest[_key4 - 3] = arguments[_key4];
      }

      var error = propTypes$1.array.isRequired.apply(propTypes$1.array, [props, propName, componentName].concat(rest));

      if (error) {
        return error;
      }

      return validateChunks.apply(void 0, [specifiers, props, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(validator, 'sequenceOf', specifiers);
  }
});
unwrapExports(sequenceOf);
var childrenSequenceOf = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = childrenSequenceOfValidator;

  var _sequenceOf = _interopRequireDefault(sequenceOf);

  var _renderableChildren = _interopRequireDefault(renderableChildren_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function childrenSequenceOfValidator() {
    for (var _len = arguments.length, specifiers = new Array(_len), _key = 0; _key < _len; _key++) {
      specifiers[_key] = arguments[_key];
    }

    var seq = _sequenceOf["default"].apply(void 0, specifiers);

    var validator = function childrenSequenceOf(props, propName, componentName) {
      if (propName !== 'children') {
        return new TypeError("".concat(componentName, " is using the childrenSequenceOf validator on non-children prop \"").concat(propName, "\""));
      }

      var propValue = props[propName];
      var children = (0, _renderableChildren["default"])(propValue);

      if (children.length === 0) {
        return null;
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return seq.apply(void 0, [_objectSpread({}, props, {
        children: children
      }), propName, componentName].concat(rest));
    };

    validator.isRequired = function childrenSequenceOfRequired(props, propName, componentName) {
      if (propName !== 'children') {
        return new TypeError("".concat(componentName, " is using the childrenSequenceOf validator on non-children prop \"").concat(propName, "\""));
      }

      var propValue = props[propName];
      var children = (0, _renderableChildren["default"])(propValue);

      if (children.length === 0) {
        return new TypeError("".concat(componentName, ": renderable children are required."));
      }

      for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        rest[_key3 - 3] = arguments[_key3];
      }

      return seq.isRequired.apply(seq, [_objectSpread({}, props, {
        children: children
      }), propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(validator, 'childrenSequenceOf', specifiers);
  }
});
unwrapExports(childrenSequenceOf);
var componentWithName_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = componentWithName;

  var _react = _interopRequireDefault(React__default);

  var _isRegex = _interopRequireDefault(isRegex);

  var _arrayPrototype = _interopRequireDefault(array_prototype_find);

  var _getComponentName = _interopRequireDefault(getComponentName_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function stripHOCs(fullName, namesOfHOCsToStrip) {
    var innerName = fullName;

    while (/\([^()]*\)/g.test(innerName)) {
      var HOC = innerName;
      var previousHOC = void 0;

      do {
        previousHOC = HOC;
        HOC = previousHOC.replace(/\([^()]*\)/g, '');
      } while (previousHOC !== HOC);

      if (namesOfHOCsToStrip.indexOf(HOC) === -1) {
        return innerName;
      }

      innerName = innerName.replace(RegExp("^".concat(HOC, "\\(|\\)$"), 'g'), '');
    }

    return innerName;
  }

  function hasName(name, namesOfHOCsToStrip, propValue, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    if (Array.isArray(propValue)) {
      return (0, _arrayPrototype["default"])(propValue.map(function (item) {
        return hasName.apply(void 0, [name, namesOfHOCsToStrip, item, propName, componentName].concat(rest));
      }), Boolean) || null;
    }

    if (!_react["default"].isValidElement(propValue)) {
      return new TypeError("".concat(componentName, ".").concat(propName, " is not a valid React element"));
    }

    var type = propValue.type;
    var componentNameFromType = (0, _getComponentName["default"])(type);
    var innerComponentName = namesOfHOCsToStrip.length > 0 ? stripHOCs(componentNameFromType, namesOfHOCsToStrip) : componentNameFromType;

    if ((0, _isRegex["default"])(name) && !name.test(innerComponentName)) {
      return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components matching the regular expression ").concat(name));
    }

    if (!(0, _isRegex["default"])(name) && innerComponentName !== name) {
      return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components named ").concat(name, ", got ").concat(innerComponentName));
    }

    return null;
  }

  function componentWithName(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (typeof name !== 'string' && !(0, _isRegex["default"])(name)) {
      throw new TypeError('name must be a string or a regex');
    }

    var passedOptions = Object.keys(options);

    if (passedOptions.length > 1 || passedOptions.length === 1 && passedOptions[0] !== 'stripHOCs') {
      throw new TypeError("The only options supported are: \u201CstripHOCs\u201D, got: \u201C".concat(passedOptions.join('”, “'), "\u201D"));
    }

    var _options$stripHOCs = options.stripHOCs,
        namesOfHOCsToStrip = _options$stripHOCs === void 0 ? [] : _options$stripHOCs;
    var allHOCNamesAreValid = namesOfHOCsToStrip.every(function (x) {
      if (typeof x !== 'string' || /[()]/g.test(x)) {
        return false;
      }

      return /^(?:[a-z][a-zA-Z0-9]+|[A-Z][a-z][a-zA-Z0-9]+)$/.test(x);
    });

    if (!allHOCNamesAreValid) {
      throw new TypeError('every provided HOC name must be a string with no parens, and in camelCase');
    }

    function componentWithNameValidator(props, propName, componentName) {
      var propValue = props[propName];

      if (props[propName] == null) {
        return null;
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
    }

    componentWithNameValidator.isRequired = function componentWithNameRequired(props, propName, componentName) {
      var propValue = props[propName];

      if (propValue == null) {
        return new TypeError("`".concat(componentName, ".").concat(propName, "` requires at least one component named ").concat(name));
      }

      for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        rest[_key3 - 3] = arguments[_key3];
      }

      return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(componentWithNameValidator, "componentWithName:".concat(name), name);
  }
});
unwrapExports(componentWithName_1);
var disallowedIf_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = disallowedIf;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function disallowedIf(propType, otherPropName, otherPropType) {
    if (typeof propType !== 'function' || typeof propType.isRequired !== 'function') {
      throw new TypeError('a propType validator is required; propType validators must also provide `.isRequired`');
    }

    if (typeof otherPropName !== 'string') {
      throw new TypeError('other prop name must be a string');
    }

    if (typeof otherPropType !== 'function') {
      throw new TypeError('other prop type validator is required');
    }

    function disallowedIfRequired(props, propName, componentName) {
      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      var error = propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));

      if (error) {
        return error;
      }

      if (props[otherPropName] == null) {
        return null;
      }

      var otherError = otherPropType.apply(void 0, [props, otherPropName, componentName].concat(rest));

      if (otherError) {
        return null;
      }

      return new Error("prop \u201C".concat(propName, "\u201D is disallowed when \u201C").concat(otherPropName, "\u201D matches the provided validator"));
    }

    var validator = function disallowedIfPropType(props, propName) {
      if (props[propName] == null) {
        return null;
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }

      return disallowedIfRequired.apply(void 0, [props, propName].concat(rest));
    };

    validator.isRequired = disallowedIfRequired;
    return (0, _wrapValidator["default"])(validator, 'disallowedIf', {
      propType: propType,
      otherPropName: otherPropName,
      otherPropType: otherPropType
    });
  }
});
unwrapExports(disallowedIf_1);
var elementType$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = elementTypeValidator;

  var _and = _interopRequireDefault(and);

  var _getComponentName = _interopRequireDefault(getComponentName_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function getTypeName(Type) {
    if (typeof Type === 'string') {
      return Type;
    }

    var type = (0, _getComponentName["default"])(Type);
    /* istanbul ignore next */
    // in environments where functions do not have names

    return type || 'Anonymous Component';
  }

  function validateElementType(Type, props, propName, componentName) {
    var type = props[propName].type;

    if (type === Type) {
      return null;
    }

    return new TypeError("".concat(componentName, ".").concat(propName, " must be a React element of type ").concat(getTypeName(Type)));
  }

  function elementTypeValidator(Type) {
    if (Type === '*') {
      return (0, _wrapValidator["default"])(propTypes$1.element, 'elementType(*)', Type);
    }

    if (!(0, reactIs$2.isValidElementType)(Type)) {
      throw new TypeError("Type must be a React Component, an HTML element tag name, or \"*\". Got an ".concat(_typeof(Type)));
    }

    function elementType(props, propName, componentName) {
      if (props[propName] == null) {
        return null;
      }

      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      return validateElementType.apply(void 0, [Type, props, propName, componentName].concat(rest));
    }

    elementType.isRequired = elementType; // covered by and + element

    var typeName = getTypeName(Type);
    var validatorName = "elementType(".concat(typeName, ")");
    return (0, _wrapValidator["default"])((0, _and["default"])([propTypes$1.element, elementType], validatorName), validatorName, Type);
  }
});
unwrapExports(elementType$1);
var or_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = or;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }
  }

  function oneOfTypeValidator(validators) {
    var validator = function oneOfType(props, propName, componentName) {
      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      var propValue = props[propName];

      if (typeof propValue === 'undefined') {
        return null;
      }

      var errors = validators.map(function (v) {
        return v.apply(void 0, [props, propName, componentName].concat(rest));
      }).filter(Boolean);

      if (errors.length < validators.length) {
        return null;
      }

      return new TypeError("".concat(componentName, ": invalid value supplied to ").concat(propName, "."));
    };

    validator.isRequired = function oneOfTypeRequired(props, propName, componentName) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      var propValue = props[propName];

      if (typeof propValue === 'undefined') {
        return new TypeError("".concat(componentName, ": missing value for required ").concat(propName, "."));
      }

      var errors = validators.map(function (v) {
        return v.apply(void 0, [props, propName, componentName].concat(rest));
      }).filter(Boolean);

      if (errors.length === validators.length) {
        return new TypeError("".concat(componentName, ": invalid value ").concat(errors, " supplied to required ").concat(propName, "."));
      }

      return null;
    };

    return (0, _wrapValidator["default"])(validator, 'oneOfType', validators);
  }

  function or(validators) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';

    if (!Array.isArray(validators)) {
      throw new TypeError('or: 2 or more validators are required');
    }

    if (validators.length <= 1) {
      throw new RangeError('or: 2 or more validators are required');
    }

    var validator = oneOfTypeValidator([(0, propTypes$1.arrayOf)(oneOfTypeValidator(validators))].concat(_toConsumableArray(validators)));
    return (0, _wrapValidator["default"])(validator, name, validators);
  }
});
unwrapExports(or_1);
var explicitNull_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function explicitNull(props, propName, componentName) {
    if (props[propName] == null) {
      return null;
    }

    return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null or undefined; received ").concat(_typeof(props[propName])));
  }

  explicitNull.isRequired = function explicitNullRequired(props, propName, componentName) {
    if (props[propName] === null) {
      return null;
    }

    return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null; received ").concat(_typeof(props[propName])));
  };

  var _default = function _default() {
    return (0, _wrapValidator["default"])(explicitNull, 'explicitNull');
  };

  exports["default"] = _default;
});
unwrapExports(explicitNull_1);
var empty$4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _or = _interopRequireDefault(or_1);

  var _explicitNull = _interopRequireDefault(explicitNull_1);

  var _withShape = _interopRequireDefault(withShape_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var arrayOfValidator;
  var validator = (0, _or["default"])([_explicitNull["default"], // null/undefined
  (0, propTypes$1.oneOf)([false, '', NaN]), (0, _withShape["default"])(propTypes$1.array, {
    length: (0, propTypes$1.oneOf)([0]).isRequired
  }).isRequired, function () {
    return arrayOfValidator.apply(void 0, arguments);
  }]);
  arrayOfValidator = (0, propTypes$1.arrayOf)(validator).isRequired;

  var _default = function _default() {
    return (0, _wrapValidator["default"])(validator, 'empty');
  };

  exports["default"] = _default;
});
unwrapExports(empty$4);
var keysOf = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = keysOfValidator;

  var _isPrimitive = _interopRequireDefault(isPrimitive_1);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function keysOfValidator(propType) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'keysOf';

    if (typeof propType !== 'function') {
      throw new TypeError('argument to keysOf must be a valid PropType function');
    }

    var validator = function keysOf(props, propName, componentName, location, propFullName) {
      for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        rest[_key - 5] = arguments[_key];
      }

      var propValue = props[propName];

      if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
        return null;
      }

      var firstError = null;
      Object.keys(propValue).some(function (key) {
        firstError = propType.apply(void 0, [_defineProperty({}, key, key), key, componentName, location, "(".concat(propFullName, ").").concat(key)].concat(rest));
        return firstError != null;
      });
      return firstError || null;
    };

    validator.isRequired = function keyedByRequired(props, propName, componentName) {
      var propValue = props[propName];

      if (propValue == null) {
        return new TypeError("".concat(componentName, ": ").concat(propName, " is required, but value is ").concat(propValue));
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return validator.apply(void 0, [props, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(validator, name, propType);
  }
});
unwrapExports(keysOf);
var mutuallyExclusiveProps = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = mutuallyExclusiveOfType;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function mutuallyExclusiveOfType(propType) {
    if (typeof propType !== 'function') {
      throw new TypeError('a propType is required');
    }

    for (var _len = arguments.length, exclusiveProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      exclusiveProps[_key - 1] = arguments[_key];
    }

    if (exclusiveProps.length < 1) {
      throw new TypeError('at least one prop that is mutually exclusive with this propType is required');
    }

    var propList = exclusiveProps.join(', or ');
    var map = exclusiveProps.reduce(function (acc, prop) {
      return _objectSpread({}, acc, _defineProperty({}, prop, true));
    }, {});

    var countProps = function countProps(count, prop) {
      return count + (map[prop] ? 1 : 0);
    };

    var validator = function mutuallyExclusiveProps(props, propName, componentName) {
      var exclusivePropCount = Object.keys(props).filter(function (prop) {
        return props[prop] != null;
      }).reduce(countProps, 0);

      if (exclusivePropCount > 1) {
        return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return propType.apply(void 0, [props, propName, componentName].concat(rest));
    };

    validator.isRequired = function mutuallyExclusivePropsRequired(props, propName, componentName) {
      var exclusivePropCount = Object.keys(props).filter(function (prop) {
        return prop === propName || props[prop] != null;
      }).reduce(countProps, 0);

      if (exclusivePropCount > 1) {
        return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
      }

      for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        rest[_key3 - 3] = arguments[_key3];
      }

      return propType.apply(void 0, [props, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveProps:".concat(propList), exclusiveProps);
  }
});
unwrapExports(mutuallyExclusiveProps);
var mutuallyExclusiveTrueProps = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = mutuallyExclusiveTrue;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function mutuallyExclusiveTrue() {
    for (var _len = arguments.length, exclusiveProps = new Array(_len), _key = 0; _key < _len; _key++) {
      exclusiveProps[_key] = arguments[_key];
    }

    if (exclusiveProps.length < 1) {
      throw new TypeError('at least one prop that is mutually exclusive is required');
    }

    if (!exclusiveProps.every(function (x) {
      return typeof x === 'string';
    })) {
      throw new TypeError('all exclusive true props must be strings');
    }

    var propsList = exclusiveProps.join(', or ');

    var validator = function mutuallyExclusiveTrueProps(props, propName, componentName) {
      var countProps = function countProps(count, prop) {
        return count + (props[prop] ? 1 : 0);
      };

      var exclusivePropCount = exclusiveProps.reduce(countProps, 0);

      if (exclusivePropCount > 1) {
        return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return propTypes$1.bool.apply(void 0, [props, propName, componentName].concat(rest));
    };

    validator.isRequired = function mutuallyExclusiveTruePropsRequired(props, propName, componentName) {
      var countProps = function countProps(count, prop) {
        return count + (props[prop] ? 1 : 0);
      };

      var exclusivePropCount = exclusiveProps.reduce(countProps, 0);

      if (exclusivePropCount > 1) {
        return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
      }

      for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        rest[_key3 - 3] = arguments[_key3];
      }

      return propTypes$1.bool.isRequired.apply(propTypes$1.bool, [props, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveTrueProps: ".concat(propsList), exclusiveProps);
  }
});
unwrapExports(mutuallyExclusiveTrueProps);
var nChildren_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = nChildren;

  var _react = _interopRequireDefault(React__default);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function nChildren(n) {
    var propType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : propTypes$1.node;

    if (typeof n !== 'number' || isNaN(n) || n < 0) {
      throw new TypeError('a non-negative number is required');
    }

    var validator = function nChildrenValidator(props, propName, componentName) {
      if (propName !== 'children') {
        return new TypeError("".concat(componentName, " is using the nChildren validator on a non-children prop"));
      }

      var children = props.children;

      var childrenCount = _react["default"].Children.count(children);

      if (childrenCount !== n) {
        return new RangeError("".concat(componentName, " expects to receive ").concat(n, " children, but received ").concat(childrenCount, " children."));
      }

      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      return propType.apply(void 0, [props, propName, componentName].concat(rest));
    };

    validator.isRequired = validator;
    return (0, _wrapValidator["default"])(validator, "nChildren:".concat(n), n);
  }
});
unwrapExports(nChildren_1);
var numericString = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var validNumericChars = /^[-+]?(?:[1-9][0-9]*(?:\.[0-9]+)?|0|0\.[0-9]+)$/;

  var validator = function numericString(props, propName, componentName) {
    if (props[propName] == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var stringError = propTypes$1.string.apply(void 0, [props, propName, componentName].concat(rest));

    if (stringError) {
      return stringError;
    }

    var value = props[propName];
    var passesRegex = validNumericChars.test(value);

    if (passesRegex) {
      return null;
    }

    return new TypeError("".concat(componentName, ": prop \"").concat(propName, "\" (value \"").concat(value, "\") must be a numeric string:\n    - starting with an optional + or -\n    - that does not have a leading zero\n    - with an optional decimal part (that contains only one decimal point, if present)\n    - that otherwise only contains digits (0-9)\n    - not +-NaN, or +-Infinity\n  "));
  };

  validator.isRequired = function numericStringRequired(props, propName, componentName) {
    if (props[propName] == null) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " is required"));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return validator.apply(void 0, [props, propName, componentName].concat(rest));
  };

  var _default = function _default() {
    return (0, _wrapValidator["default"])(validator, 'numericString');
  };

  exports["default"] = _default;
});
unwrapExports(numericString);
var range_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = range;

  var _and = _interopRequireDefault(and);

  var _between = _interopRequireDefault(between);

  var _integer = _interopRequireDefault(integer);

  var _isInteger = _interopRequireDefault(isInteger);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
  /* istanbul ignore next */
  Math.pow(2, 53) - 1;

  function isValidLength(x) {
    return (0, _isInteger["default"])(x) && Math.abs(x) < MAX_SAFE_INTEGER;
  }

  function range(min, max) {
    if (!isValidLength(min) || !isValidLength(max)) {
      throw new RangeError("\"range\" requires two integers: ".concat(min, " and ").concat(max, " given"));
    }

    if (min === max) {
      throw new RangeError('min and max must not be the same');
    }

    return (0, _wrapValidator["default"])((0, _and["default"])([(0, _integer["default"])(), (0, _between["default"])({
      gte: min,
      lt: max
    })], 'range'), 'range', {
      min: min,
      max: max
    });
  }
});
unwrapExports(range_1);
var ref_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _isPlainObject = _interopRequireDefault(isPlainObject$3);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var isPrototypeOf = Object.prototype.isPrototypeOf;

  function isNewRef(prop) {
    if (!(0, _isPlainObject["default"])(prop)) {
      return false;
    }

    var ownProperties = Object.keys(prop);
    return ownProperties.length === 1 && ownProperties[0] === 'current';
  }

  function isCallbackRef(prop) {
    return typeof prop === 'function' && !isPrototypeOf.call(React__default.Component, prop) && (!React__default.PureComponent || !isPrototypeOf.call(React__default.PureComponent, prop));
  }

  function requiredRef(props, propName, componentName) {
    var propValue = props[propName];

    if (isCallbackRef(propValue) || isNewRef(propValue)) {
      return null;
    }

    return new TypeError("".concat(propName, " in ").concat(componentName, " must be a ref"));
  }

  function ref(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return requiredRef.apply(void 0, [props, propName, componentName].concat(rest));
  }

  ref.isRequired = requiredRef;

  var _default = function _default() {
    return (0, _wrapValidator["default"])(ref, 'ref');
  };

  exports["default"] = _default;
});
unwrapExports(ref_1);
var requiredBy = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getRequiredBy;

  var _objectIs = _interopRequireDefault(objectIs);

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function getRequiredBy(requiredByPropName, propType) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    function requiredBy(props, propName, componentName) {
      if (props[requiredByPropName]) {
        var propValue = props[propName];

        if ((0, _objectIs["default"])(propValue, defaultValue) || typeof propValue === 'undefined') {
          return new TypeError("".concat(componentName, ": when ").concat(requiredByPropName, " is true, prop \u201C").concat(propName, "\u201D must be present."));
        }
      }

      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      return propType.apply(void 0, [props, propName, componentName].concat(rest));
    }

    requiredBy.isRequired = function requiredByRequired(props, propName, componentName) {
      var propValue = props[propName];

      if ((0, _objectIs["default"])(propValue, defaultValue)) {
        return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be present."));
      }

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));
    };

    return (0, _wrapValidator["default"])(requiredBy, "requiredBy \u201C".concat(requiredByPropName, "\u201D"), [requiredByPropName, defaultValue]);
  }
});
unwrapExports(requiredBy);
var restrictedProp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function customMessageWrapper(messsageFunction) {
    function restrictedProp(props, propName, componentName, location) {
      if (props[propName] == null) {
        return null;
      }

      if (messsageFunction && typeof messsageFunction === 'function') {
        for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
          rest[_key - 4] = arguments[_key];
        }

        return new TypeError(messsageFunction.apply(void 0, [props, propName, componentName, location].concat(rest)));
      }

      return new TypeError("The ".concat(propName, " ").concat(location, " on ").concat(componentName, " is not allowed."));
    }

    restrictedProp.isRequired = restrictedProp;
    return restrictedProp;
  }

  var _default = function _default() {
    var messsageFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return (0, _wrapValidator["default"])(customMessageWrapper(messsageFunction), 'restrictedProp');
  };

  exports["default"] = _default;
});
unwrapExports(restrictedProp);
var stringEndsWith = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = stringEndsWithValidator;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function stringEndsWithValidator(end) {
    if (typeof end !== 'string' || end.length === 0) {
      throw new TypeError('a non-empty string is required');
    }

    var validator = function stringEndsWith(props, propName, componentName) {
      var propValue = props[propName];

      if (propValue == null) {
        return null;
      }

      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      var stringError = propTypes$1.string.apply(void 0, [props, propName, componentName].concat(rest));

      if (stringError) {
        return stringError;
      }

      if (!propValue.endsWith(end) || propValue.length <= end.length) {
        return new TypeError("".concat(componentName, ": ").concat(propName, " does not end with \"").concat(end, "\""));
      }

      return null;
    };

    validator.isRequired = function requiredStringEndsWith() {
      var stringError = propTypes$1.string.isRequired.apply(propTypes$1.string, arguments);

      if (stringError) {
        return stringError;
      }

      return validator.apply(void 0, arguments);
    };

    return (0, _wrapValidator["default"])(validator, "stringEndsWith: ".concat(end));
  }
});
unwrapExports(stringEndsWith);
var stringStartsWith = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = stringStartsWithValidator;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function stringStartsWithValidator(start) {
    if (typeof start !== 'string' || start.length === 0) {
      throw new TypeError('a non-empty string is required');
    }

    var validator = function stringStartsWith(props, propName, componentName) {
      var propValue = props[propName];

      if (propValue == null) {
        return null;
      }

      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      var stringError = propTypes$1.string.apply(void 0, [props, propName, componentName].concat(rest));

      if (stringError) {
        return stringError;
      }

      if (!propValue.startsWith(start) || propValue.length <= start.length) {
        return new TypeError("".concat(componentName, ": ").concat(propName, " does not start with \"").concat(start, "\""));
      }

      return null;
    };

    validator.isRequired = function requiredStringStartsWith() {
      var stringError = propTypes$1.string.isRequired.apply(propTypes$1.string, arguments);

      if (stringError) {
        return stringError;
      }

      return validator.apply(void 0, arguments);
    };

    return (0, _wrapValidator["default"])(validator, "stringStartsWith: ".concat(start));
  }
});
unwrapExports(stringStartsWith);
var uniqueArray_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _wrapValidator = _interopRequireDefault(wrapValidator_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function uniqueCountWithSet(arr) {
    return new Set(arr).size;
  }
  /* istanbul ignore next */


  function uniqueCountLegacy(arr) {
    var seen = [];
    arr.forEach(function (item) {
      if (seen.indexOf(item) === -1) {
        seen.push(item);
      }
    });
    return seen.length;
  }

  var getUniqueCount = typeof Set === 'function' ? uniqueCountWithSet :
  /* istanbul ignore next */
  uniqueCountLegacy;

  function requiredUniqueArray(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var result = propTypes$1.array.isRequired.apply(propTypes$1.array, [props, propName, componentName].concat(rest));

    if (result != null) {
      return result;
    }

    var propValue = props[propName];
    var uniqueCount = getUniqueCount(propValue);

    if (uniqueCount !== propValue.length) {
      return new RangeError("".concat(componentName, ": values must be unique. ").concat(propValue.length - uniqueCount, " duplicate values found."));
    }

    return null;
  }

  function uniqueArray(props, propName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }

    return requiredUniqueArray.apply(void 0, [props, propName].concat(rest));
  }

  uniqueArray.isRequired = requiredUniqueArray;

  var _default = function _default() {
    return (0, _wrapValidator["default"])(uniqueArray, 'uniqueArray');
  };

  exports["default"] = _default;
});
unwrapExports(uniqueArray_1);
var uniqueArrayOf = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = uniqueArrayOfTypeValidator;

  var _and = _interopRequireDefault(and);

  var _uniqueArray = _interopRequireDefault(uniqueArray_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var unique = (0, _uniqueArray["default"])();

  function uniqueArrayOfTypeValidator(type) {
    if (typeof type !== 'function') {
      throw new TypeError('type must be a validator function');
    }

    var mapper = null;
    var name = 'uniqueArrayOfType';

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    if (rest.length === 1) {
      if (typeof rest[0] === 'function') {
        mapper = rest[0];
      } else if (typeof rest[0] === 'string') {
        name = rest[0];
      } else {
        throw new TypeError('single input must either be string or function');
      }
    } else if (rest.length === 2) {
      if (typeof rest[0] === 'function' && typeof rest[1] === 'string') {
        mapper = rest[0];
        name = rest[1];
      } else {
        throw new TypeError('multiple inputs must be in [function, string] order');
      }
    } else if (rest.length > 2) {
      throw new TypeError('only [], [name], [mapper], and [mapper, name] are valid inputs');
    }

    function uniqueArrayOfMapped(props, propName) {
      var propValue = props[propName];

      if (propValue == null) {
        return null;
      }

      var values = propValue.map(mapper);

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return unique.apply(void 0, [_objectSpread({}, props, _defineProperty({}, propName, values)), propName].concat(args));
    }

    uniqueArrayOfMapped.isRequired = function isRequired(props, propName) {
      var propValue = props[propName];

      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      if (propValue == null) {
        return propTypes$1.array.isRequired.apply(propTypes$1.array, [props, propName].concat(args));
      }

      return uniqueArrayOfMapped.apply(void 0, [props, propName].concat(args));
    };

    var arrayValidator = (0, propTypes$1.arrayOf)(type);
    var uniqueValidator = mapper ? uniqueArrayOfMapped : unique;
    var validator = (0, _and["default"])([arrayValidator, uniqueValidator], name);
    validator.isRequired = (0, _and["default"])([uniqueValidator.isRequired, arrayValidator.isRequired], "".concat(name, ".isRequired"));
    return validator;
  }
});
unwrapExports(uniqueArrayOf);
var build$1 = createCommonjsModule(function (module) {
  var _propTypesExact = _interopRequireDefault(build);

  var _and = _interopRequireDefault(and);

  var _between = _interopRequireDefault(between);

  var _booleanSome = _interopRequireDefault(booleanSome);

  var _childrenHavePropXorChildren = _interopRequireDefault(childrenHavePropXorChildren_1);

  var _childrenOf = _interopRequireDefault(childrenOf_1);

  var _childrenOfType = _interopRequireDefault(childrenOfType_1);

  var _childrenSequenceOf = _interopRequireDefault(childrenSequenceOf);

  var _componentWithName = _interopRequireDefault(componentWithName_1);

  var _disallowedIf = _interopRequireDefault(disallowedIf_1);

  var _elementType = _interopRequireDefault(elementType$1);

  var _empty = _interopRequireDefault(empty$4);

  var _explicitNull = _interopRequireDefault(explicitNull_1);

  var _integer = _interopRequireDefault(integer);

  var _keysOf = _interopRequireDefault(keysOf);

  var _mutuallyExclusiveProps = _interopRequireDefault(mutuallyExclusiveProps);

  var _mutuallyExclusiveTrueProps = _interopRequireDefault(mutuallyExclusiveTrueProps);

  var _nChildren = _interopRequireDefault(nChildren_1);

  var _nonNegativeInteger = _interopRequireDefault(nonNegativeInteger);

  var _nonNegativeNumber = _interopRequireDefault(nonNegativeNumber_1);

  var _numericString = _interopRequireDefault(numericString);

  var _object = _interopRequireDefault(object_1);

  var _or = _interopRequireDefault(or_1);

  var _range = _interopRequireDefault(range_1);

  var _ref = _interopRequireDefault(ref_1);

  var _requiredBy = _interopRequireDefault(requiredBy);

  var _restrictedProp = _interopRequireDefault(restrictedProp);

  var _sequenceOf = _interopRequireDefault(sequenceOf);

  var _shape = _interopRequireDefault(shape);

  var _stringEndsWith = _interopRequireDefault(stringEndsWith);

  var _stringStartsWith = _interopRequireDefault(stringStartsWith);

  var _uniqueArray = _interopRequireDefault(uniqueArray_1);

  var _uniqueArrayOf = _interopRequireDefault(uniqueArrayOf);

  var _valuesOf = _interopRequireDefault(valuesOf);

  var _withShape = _interopRequireDefault(withShape_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  module.exports = {
    and: _and["default"],
    between: _between["default"],
    booleanSome: _booleanSome["default"],
    childrenHavePropXorChildren: _childrenHavePropXorChildren["default"],
    childrenOf: _childrenOf["default"],
    childrenOfType: _childrenOfType["default"],
    childrenSequenceOf: _childrenSequenceOf["default"],
    componentWithName: _componentWithName["default"],
    disallowedIf: _disallowedIf["default"],
    elementType: _elementType["default"],
    empty: _empty["default"],
    explicitNull: _explicitNull["default"],
    forbidExtraProps: _propTypesExact["default"],
    integer: _integer["default"],
    keysOf: _keysOf["default"],
    mutuallyExclusiveProps: _mutuallyExclusiveProps["default"],
    mutuallyExclusiveTrueProps: _mutuallyExclusiveTrueProps["default"],
    nChildren: _nChildren["default"],
    nonNegativeInteger: _nonNegativeInteger["default"],
    nonNegativeNumber: _nonNegativeNumber["default"],
    numericString: _numericString["default"],
    object: _object["default"],
    or: _or["default"],
    range: _range["default"],
    ref: _ref["default"],
    requiredBy: _requiredBy["default"],
    restrictedProp: _restrictedProp["default"],
    sequenceOf: _sequenceOf["default"],
    shape: _shape["default"],
    stringEndsWith: _stringEndsWith["default"],
    stringStartsWith: _stringStartsWith["default"],
    uniqueArray: _uniqueArray["default"],
    uniqueArrayOf: _uniqueArrayOf["default"],
    valuesOf: _valuesOf["default"],
    withShape: _withShape["default"]
  };
});
unwrapExports(build$1);
var build_1 = build$1.and;
var build_2 = build$1.between;
var build_3 = build$1.booleanSome;
var build_4 = build$1.childrenHavePropXorChildren;
var build_5 = build$1.childrenOf;
var build_6 = build$1.childrenOfType;
var build_7 = build$1.childrenSequenceOf;
var build_8 = build$1.componentWithName;
var build_9 = build$1.disallowedIf;
var build_10 = build$1.elementType;
var build_11 = build$1.empty;
var build_12 = build$1.explicitNull;
var build_13 = build$1.forbidExtraProps;
var build_14 = build$1.integer;
var build_15 = build$1.keysOf;
var build_16 = build$1.mutuallyExclusiveProps;
var build_17 = build$1.mutuallyExclusiveTrueProps;
var build_18 = build$1.nChildren;
var build_19 = build$1.nonNegativeInteger;
var build_20 = build$1.nonNegativeNumber;
var build_21 = build$1.numericString;
var build_22 = build$1.object;
var build_23 = build$1.or;
var build_24 = build$1.range;
var build_25 = build$1.ref;
var build_26 = build$1.requiredBy;
var build_27 = build$1.restrictedProp;
var build_28 = build$1.sequenceOf;
var build_29 = build$1.shape;
var build_30 = build$1.stringEndsWith;
var build_31 = build$1.stringStartsWith;
var build_32 = build$1.uniqueArray;
var build_33 = build$1.uniqueArrayOf;
var build_34 = build$1.valuesOf;
var build_35 = build$1.withShape;
var airbnbPropTypes = process.env.NODE_ENV === 'production' ? mocks : build$1;
/** @license React v16.13.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b$2 = "function" === typeof Symbol && Symbol.for,
    c$2 = b$2 ? Symbol.for("react.element") : 60103,
    d$2 = b$2 ? Symbol.for("react.portal") : 60106,
    e$2 = b$2 ? Symbol.for("react.fragment") : 60107,
    f$9 = b$2 ? Symbol.for("react.strict_mode") : 60108,
    g$3 = b$2 ? Symbol.for("react.profiler") : 60114,
    h$2 = b$2 ? Symbol.for("react.provider") : 60109,
    k$3 = b$2 ? Symbol.for("react.context") : 60110,
    l$2 = b$2 ? Symbol.for("react.async_mode") : 60111,
    m$2 = b$2 ? Symbol.for("react.concurrent_mode") : 60111,
    n$2 = b$2 ? Symbol.for("react.forward_ref") : 60112,
    p$2 = b$2 ? Symbol.for("react.suspense") : 60113,
    q$2 = b$2 ? Symbol.for("react.suspense_list") : 60120,
    r$2 = b$2 ? Symbol.for("react.memo") : 60115,
    t$2 = b$2 ? Symbol.for("react.lazy") : 60116,
    v$2 = b$2 ? Symbol.for("react.block") : 60121,
    w$2 = b$2 ? Symbol.for("react.fundamental") : 60117,
    x$2 = b$2 ? Symbol.for("react.responder") : 60118,
    y$2 = b$2 ? Symbol.for("react.scope") : 60119;

function z$2(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c$2:
        switch (a = a.type, a) {
          case l$2:
          case m$2:
          case e$2:
          case g$3:
          case f$9:
          case p$2:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$3:
              case n$2:
              case t$2:
              case r$2:
              case h$2:
                return a;

              default:
                return u;
            }

        }

      case d$2:
        return u;
    }
  }
}

function A$2(a) {
  return z$2(a) === m$2;
}

var AsyncMode$2 = l$2;
var ConcurrentMode$2 = m$2;
var ContextConsumer$2 = k$3;
var ContextProvider$2 = h$2;
var Element$3 = c$2;
var ForwardRef$2 = n$2;
var Fragment$2 = e$2;
var Lazy$2 = t$2;
var Memo$2 = r$2;
var Portal$5 = d$2;
var Profiler$2 = g$3;
var StrictMode$2 = f$9;
var Suspense$2 = p$2;

var isAsyncMode$2 = function isAsyncMode$2(a) {
  return A$2(a) || z$2(a) === l$2;
};

var isConcurrentMode$2 = A$2;

var isContextConsumer$2 = function isContextConsumer$2(a) {
  return z$2(a) === k$3;
};

var isContextProvider$2 = function isContextProvider$2(a) {
  return z$2(a) === h$2;
};

var isElement$2 = function isElement$2(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$2;
};

var isForwardRef$2 = function isForwardRef$2(a) {
  return z$2(a) === n$2;
};

var isFragment$2 = function isFragment$2(a) {
  return z$2(a) === e$2;
};

var isLazy$2 = function isLazy$2(a) {
  return z$2(a) === t$2;
};

var isMemo$2 = function isMemo$2(a) {
  return z$2(a) === r$2;
};

var isPortal$2 = function isPortal$2(a) {
  return z$2(a) === d$2;
};

var isProfiler$2 = function isProfiler$2(a) {
  return z$2(a) === g$3;
};

var isStrictMode$2 = function isStrictMode$2(a) {
  return z$2(a) === f$9;
};

var isSuspense$2 = function isSuspense$2(a) {
  return z$2(a) === p$2;
};

var isValidElementType$2 = function isValidElementType$2(a) {
  return "string" === typeof a || "function" === typeof a || a === e$2 || a === m$2 || a === g$3 || a === f$9 || a === p$2 || a === q$2 || "object" === typeof a && null !== a && (a.$$typeof === t$2 || a.$$typeof === r$2 || a.$$typeof === h$2 || a.$$typeof === k$3 || a.$$typeof === n$2 || a.$$typeof === w$2 || a.$$typeof === x$2 || a.$$typeof === y$2 || a.$$typeof === v$2);
};

var typeOf$3 = z$2;
var reactIs_production_min$4 = {
  AsyncMode: AsyncMode$2,
  ConcurrentMode: ConcurrentMode$2,
  ContextConsumer: ContextConsumer$2,
  ContextProvider: ContextProvider$2,
  Element: Element$3,
  ForwardRef: ForwardRef$2,
  Fragment: Fragment$2,
  Lazy: Lazy$2,
  Memo: Memo$2,
  Portal: Portal$5,
  Profiler: Profiler$2,
  StrictMode: StrictMode$2,
  Suspense: Suspense$2,
  isAsyncMode: isAsyncMode$2,
  isConcurrentMode: isConcurrentMode$2,
  isContextConsumer: isContextConsumer$2,
  isContextProvider: isContextProvider$2,
  isElement: isElement$2,
  isForwardRef: isForwardRef$2,
  isFragment: isFragment$2,
  isLazy: isLazy$2,
  isMemo: isMemo$2,
  isPortal: isPortal$2,
  isProfiler: isProfiler$2,
  isStrictMode: isStrictMode$2,
  isSuspense: isSuspense$2,
  isValidElementType: isValidElementType$2,
  typeOf: typeOf$3
};
var reactIs_development$4 = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1$3 = reactIs_development$4.AsyncMode;
var reactIs_development_2$3 = reactIs_development$4.ConcurrentMode;
var reactIs_development_3$3 = reactIs_development$4.ContextConsumer;
var reactIs_development_4$3 = reactIs_development$4.ContextProvider;
var reactIs_development_5$3 = reactIs_development$4.Element;
var reactIs_development_6$3 = reactIs_development$4.ForwardRef;
var reactIs_development_7$3 = reactIs_development$4.Fragment;
var reactIs_development_8$3 = reactIs_development$4.Lazy;
var reactIs_development_9$3 = reactIs_development$4.Memo;
var reactIs_development_10$3 = reactIs_development$4.Portal;
var reactIs_development_11$3 = reactIs_development$4.Profiler;
var reactIs_development_12$3 = reactIs_development$4.StrictMode;
var reactIs_development_13$3 = reactIs_development$4.Suspense;
var reactIs_development_14$3 = reactIs_development$4.isAsyncMode;
var reactIs_development_15$3 = reactIs_development$4.isConcurrentMode;
var reactIs_development_16$3 = reactIs_development$4.isContextConsumer;
var reactIs_development_17$3 = reactIs_development$4.isContextProvider;
var reactIs_development_18$3 = reactIs_development$4.isElement;
var reactIs_development_19$3 = reactIs_development$4.isForwardRef;
var reactIs_development_20$3 = reactIs_development$4.isFragment;
var reactIs_development_21$3 = reactIs_development$4.isLazy;
var reactIs_development_22$3 = reactIs_development$4.isMemo;
var reactIs_development_23$3 = reactIs_development$4.isPortal;
var reactIs_development_24$3 = reactIs_development$4.isProfiler;
var reactIs_development_25$3 = reactIs_development$4.isStrictMode;
var reactIs_development_26$3 = reactIs_development$4.isSuspense;
var reactIs_development_27$3 = reactIs_development$4.isValidElementType;
var reactIs_development_28$3 = reactIs_development$4.typeOf;
var reactIs$3 = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$4;
  } else {
    module.exports = reactIs_development$4;
  }
});
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS$1 = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS$1 = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS$1 = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS$1 = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS$1 = {};
TYPE_STATICS$1[reactIs$3.ForwardRef] = FORWARD_REF_STATICS$1;

function getStatics$1(component) {
  if (reactIs$3.isMemo(component)) {
    return MEMO_STATICS$1;
  }

  return TYPE_STATICS$1[component['$$typeof']] || REACT_STATICS$1;
}

var defineProperty$9 = Object.defineProperty;
var getOwnPropertyNames$1 = Object.getOwnPropertyNames;
var getOwnPropertySymbols$2 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$2 = Object.getPrototypeOf;
var objectPrototype$1 = Object.prototype;

function hoistNonReactStatics$1(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype$1) {
      var inheritedComponent = getPrototypeOf$2(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype$1) {
        hoistNonReactStatics$1(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames$1(sourceComponent);

    if (getOwnPropertySymbols$2) {
      keys = keys.concat(getOwnPropertySymbols$2(sourceComponent));
    }

    var targetStatics = getStatics$1(targetComponent);
    var sourceStatics = getStatics$1(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS$1[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$9(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs$1 = hoistNonReactStatics$1;
var constants$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CHANNEL = exports.CHANNEL = '__direction__';
  var DIRECTIONS = exports.DIRECTIONS = {
    LTR: 'ltr',
    RTL: 'rtl'
  };
});
unwrapExports(constants$2);
var constants_1$1 = constants$2.CHANNEL;
var constants_2$1 = constants$2.DIRECTIONS;
var brcast = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  exports['default'] = _propTypes2['default'].shape({
    getState: _propTypes2['default'].func,
    setState: _propTypes2['default'].func,
    subscribe: _propTypes2['default'].func
  });
});
unwrapExports(brcast);
var withStyles_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.withStylesPropTypes = exports.css = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  exports.withStyles = withStyles;

  var _object2 = _interopRequireDefault(object_assign);

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _hoistNonReactStatics2 = _interopRequireDefault(hoistNonReactStatics_cjs$1);

  var _brcast2 = _interopRequireDefault(brcast);

  var _ThemedStyleSheet2 = _interopRequireDefault(ThemedStyleSheet);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /* eslint react/forbid-foreign-prop-types: off */
  // Add some named exports to assist in upgrading and for convenience


  var css = exports.css = _ThemedStyleSheet2['default'].resolveLTR;
  var withStylesPropTypes = exports.withStylesPropTypes = {
    styles: _propTypes2['default'].object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    theme: _propTypes2['default'].object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    css: _propTypes2['default'].func.isRequired
  };
  var EMPTY_STYLES = {};

  var EMPTY_STYLES_FN = function EMPTY_STYLES_FN() {
    return EMPTY_STYLES;
  };

  var START_MARK = 'react-with-styles.createStyles.start';
  var END_MARK = 'react-with-styles.createStyles.end';

  function baseClass(pureComponent) {
    if (pureComponent) {
      if (!_react2['default'].PureComponent) {
        throw new ReferenceError('withStyles() pureComponent option requires React 15.3.0 or later');
      }

      return _react2['default'].PureComponent;
    }

    return _react2['default'].Component;
  }

  var contextTypes = _defineProperty({}, constants$2.CHANNEL, _brcast2['default']);

  var defaultDirection = constants$2.DIRECTIONS.LTR;

  function withStyles(styleFn) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$stylesPropName = _ref.stylesPropName,
        stylesPropName = _ref$stylesPropName === undefined ? 'styles' : _ref$stylesPropName,
        _ref$themePropName = _ref.themePropName,
        themePropName = _ref$themePropName === undefined ? 'theme' : _ref$themePropName,
        _ref$cssPropName = _ref.cssPropName,
        cssPropName = _ref$cssPropName === undefined ? 'css' : _ref$cssPropName,
        _ref$flushBefore = _ref.flushBefore,
        flushBefore = _ref$flushBefore === undefined ? false : _ref$flushBefore,
        _ref$pureComponent = _ref.pureComponent,
        pureComponent = _ref$pureComponent === undefined ? false : _ref$pureComponent;

    var styleDefLTR = void 0;
    var styleDefRTL = void 0;
    var currentThemeLTR = void 0;
    var currentThemeRTL = void 0;
    var BaseClass = baseClass(pureComponent);

    function getResolveMethod(direction) {
      return direction === constants$2.DIRECTIONS.LTR ? _ThemedStyleSheet2['default'].resolveLTR : _ThemedStyleSheet2['default'].resolveRTL;
    }

    function getCurrentTheme(direction) {
      return direction === constants$2.DIRECTIONS.LTR ? currentThemeLTR : currentThemeRTL;
    }

    function getStyleDef(direction, wrappedComponentName) {
      var currentTheme = getCurrentTheme(direction);
      var styleDef = direction === constants$2.DIRECTIONS.LTR ? styleDefLTR : styleDefRTL;

      var registeredTheme = _ThemedStyleSheet2['default'].get(); // Return the existing styles if they've already been defined
      // and if the theme used to create them corresponds to the theme
      // registered with ThemedStyleSheet


      if (styleDef && currentTheme === registeredTheme) {
        return styleDef;
      }

      if (process.env.NODE_ENV !== 'production' && typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
        performance.clearMarks(START_MARK);
        performance.mark(START_MARK);
      }

      var isRTL = direction === constants$2.DIRECTIONS.RTL;

      if (isRTL) {
        styleDefRTL = styleFn ? _ThemedStyleSheet2['default'].createRTL(styleFn) : EMPTY_STYLES_FN;
        currentThemeRTL = registeredTheme;
        styleDef = styleDefRTL;
      } else {
        styleDefLTR = styleFn ? _ThemedStyleSheet2['default'].createLTR(styleFn) : EMPTY_STYLES_FN;
        currentThemeLTR = registeredTheme;
        styleDef = styleDefLTR;
      }

      if (process.env.NODE_ENV !== 'production' && typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
        performance.clearMarks(END_MARK);
        performance.mark(END_MARK);
        var measureName = "\uD83D\uDC69\u200D\uD83C\uDFA8 withStyles(" + String(wrappedComponentName) + ') [create styles]';
        performance.measure(measureName, START_MARK, END_MARK);
        performance.clearMarks(measureName);
      }

      return styleDef;
    }

    function getState(direction, wrappedComponentName) {
      return {
        resolveMethod: getResolveMethod(direction),
        styleDef: getStyleDef(direction, wrappedComponentName)
      };
    }

    return function () {
      function withStylesHOC(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component'; // NOTE: Use a class here so components are ref-able if need be:
        // eslint-disable-next-line react/prefer-stateless-function

        var WithStyles = function (_BaseClass) {
          _inherits(WithStyles, _BaseClass);

          function WithStyles(props, context) {
            _classCallCheck(this, WithStyles);

            var _this = _possibleConstructorReturn(this, (WithStyles.__proto__ || Object.getPrototypeOf(WithStyles)).call(this, props, context));

            var direction = _this.context[constants$2.CHANNEL] ? _this.context[constants$2.CHANNEL].getState() : defaultDirection;
            _this.state = getState(direction, wrappedComponentName);
            return _this;
          }

          _createClass(WithStyles, [{
            key: 'componentDidMount',
            value: function () {
              function componentDidMount() {
                var _this2 = this;

                if (this.context[constants$2.CHANNEL]) {
                  // subscribe to future direction changes
                  this.channelUnsubscribe = this.context[constants$2.CHANNEL].subscribe(function (direction) {
                    _this2.setState(getState(direction, wrappedComponentName));
                  });
                }
              }

              return componentDidMount;
            }()
          }, {
            key: 'componentWillUnmount',
            value: function () {
              function componentWillUnmount() {
                if (this.channelUnsubscribe) {
                  this.channelUnsubscribe();
                }
              }

              return componentWillUnmount;
            }()
          }, {
            key: 'render',
            value: function () {
              function render() {
                var _ref2; // As some components will depend on previous styles in
                // the component tree, we provide the option of flushing the
                // buffered styles (i.e. to a style tag) **before** the rendering
                // cycle begins.
                //
                // The interfaces provide the optional "flush" method which
                // is run in turn by ThemedStyleSheet.flush.


                if (flushBefore) {
                  _ThemedStyleSheet2['default'].flush();
                }

                var _state = this.state,
                    resolveMethod = _state.resolveMethod,
                    styleDef = _state.styleDef;
                return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, (_ref2 = {}, _defineProperty(_ref2, themePropName, _ThemedStyleSheet2['default'].get()), _defineProperty(_ref2, stylesPropName, styleDef()), _defineProperty(_ref2, cssPropName, resolveMethod), _ref2)));
              }

              return render;
            }()
          }]);

          return WithStyles;
        }(BaseClass);

        WithStyles.WrappedComponent = WrappedComponent;
        WithStyles.displayName = 'withStyles(' + String(wrappedComponentName) + ')';
        WithStyles.contextTypes = contextTypes;

        if (WrappedComponent.propTypes) {
          WithStyles.propTypes = (0, _object2['default'])({}, WrappedComponent.propTypes);
          delete WithStyles.propTypes[stylesPropName];
          delete WithStyles.propTypes[themePropName];
          delete WithStyles.propTypes[cssPropName];
        }

        if (WrappedComponent.defaultProps) {
          WithStyles.defaultProps = (0, _object2['default'])({}, WrappedComponent.defaultProps);
        }

        return (0, _hoistNonReactStatics2['default'])(WithStyles, WrappedComponent);
      }

      return withStylesHOC;
    }();
  }
});
unwrapExports(withStyles_1);
var withStyles_2 = withStyles_1.withStylesPropTypes;
var withStyles_3 = withStyles_1.css;
var withStyles_4 = withStyles_1.withStyles;
var defaultPhrases = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CalendarDayPhrases = exports.DayPickerNavigationPhrases = exports.DayPickerKeyboardShortcutsPhrases = exports.DayPickerPhrases = exports.SingleDatePickerInputPhrases = exports.SingleDatePickerPhrases = exports.DateRangePickerInputPhrases = exports.DateRangePickerPhrases = exports["default"] = void 0;
  var calendarLabel = 'Calendar';
  var closeDatePicker = 'Close';
  var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
  var clearDate = 'Clear Date';
  var clearDates = 'Clear Dates';
  var jumpToPrevMonth = 'Move backward to switch to the previous month.';
  var jumpToNextMonth = 'Move forward to switch to the next month.';
  var keyboardShortcuts = 'Keyboard Shortcuts';
  var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
  var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
  var openThisPanel = 'Open this panel.';
  var enterKey = 'Enter key';
  var leftArrowRightArrow = 'Right and left arrow keys';
  var upArrowDownArrow = 'up and down arrow keys';
  var pageUpPageDown = 'page up and page down keys';
  var homeEnd = 'Home and end keys';
  var escape = 'Escape key';
  var questionMark = 'Question mark';
  var selectFocusedDate = 'Select the date in focus.';
  var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
  var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
  var moveFocusByOneMonth = 'Switch months.';
  var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
  var returnFocusToInput = 'Return to the date input field.';
  var keyboardNavigationInstructions = "Press the down arrow key to interact with the calendar and\n  select a date. Press the question mark key to get the keyboard shortcuts for changing dates.";

  var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
    var date = _ref.date;
    return "Choose ".concat(date, " as your check-in date. It\u2019s available.");
  };

  var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
    var date = _ref2.date;
    return "Choose ".concat(date, " as your check-out date. It\u2019s available.");
  };

  var chooseAvailableDate = function chooseAvailableDate(_ref3) {
    var date = _ref3.date;
    return date;
  };

  var dateIsUnavailable = function dateIsUnavailable(_ref4) {
    var date = _ref4.date;
    return "Not available. ".concat(date);
  };

  var dateIsSelected = function dateIsSelected(_ref5) {
    var date = _ref5.date;
    return "Selected. ".concat(date);
  };

  var dateIsSelectedAsStartDate = function dateIsSelectedAsStartDate(_ref6) {
    var date = _ref6.date;
    return "Selected as start date. ".concat(date);
  };

  var dateIsSelectedAsEndDate = function dateIsSelectedAsEndDate(_ref7) {
    var date = _ref7.date;
    return "Selected as end date. ".concat(date);
  };

  var _default = {
    calendarLabel: calendarLabel,
    closeDatePicker: closeDatePicker,
    focusStartDate: focusStartDate,
    clearDate: clearDate,
    clearDates: clearDates,
    jumpToPrevMonth: jumpToPrevMonth,
    jumpToNextMonth: jumpToNextMonth,
    keyboardShortcuts: keyboardShortcuts,
    showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
    hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
    openThisPanel: openThisPanel,
    enterKey: enterKey,
    leftArrowRightArrow: leftArrowRightArrow,
    upArrowDownArrow: upArrowDownArrow,
    pageUpPageDown: pageUpPageDown,
    homeEnd: homeEnd,
    escape: escape,
    questionMark: questionMark,
    selectFocusedDate: selectFocusedDate,
    moveFocusByOneDay: moveFocusByOneDay,
    moveFocusByOneWeek: moveFocusByOneWeek,
    moveFocusByOneMonth: moveFocusByOneMonth,
    moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
    returnFocusToInput: returnFocusToInput,
    keyboardNavigationInstructions: keyboardNavigationInstructions,
    chooseAvailableStartDate: chooseAvailableStartDate,
    chooseAvailableEndDate: chooseAvailableEndDate,
    dateIsUnavailable: dateIsUnavailable,
    dateIsSelected: dateIsSelected,
    dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
    dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
  };
  exports["default"] = _default;
  var DateRangePickerPhrases = {
    calendarLabel: calendarLabel,
    closeDatePicker: closeDatePicker,
    clearDates: clearDates,
    focusStartDate: focusStartDate,
    jumpToPrevMonth: jumpToPrevMonth,
    jumpToNextMonth: jumpToNextMonth,
    keyboardShortcuts: keyboardShortcuts,
    showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
    hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
    openThisPanel: openThisPanel,
    enterKey: enterKey,
    leftArrowRightArrow: leftArrowRightArrow,
    upArrowDownArrow: upArrowDownArrow,
    pageUpPageDown: pageUpPageDown,
    homeEnd: homeEnd,
    escape: escape,
    questionMark: questionMark,
    selectFocusedDate: selectFocusedDate,
    moveFocusByOneDay: moveFocusByOneDay,
    moveFocusByOneWeek: moveFocusByOneWeek,
    moveFocusByOneMonth: moveFocusByOneMonth,
    moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
    returnFocusToInput: returnFocusToInput,
    keyboardNavigationInstructions: keyboardNavigationInstructions,
    chooseAvailableStartDate: chooseAvailableStartDate,
    chooseAvailableEndDate: chooseAvailableEndDate,
    dateIsUnavailable: dateIsUnavailable,
    dateIsSelected: dateIsSelected,
    dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
    dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
  };
  exports.DateRangePickerPhrases = DateRangePickerPhrases;
  var DateRangePickerInputPhrases = {
    focusStartDate: focusStartDate,
    clearDates: clearDates,
    keyboardNavigationInstructions: keyboardNavigationInstructions
  };
  exports.DateRangePickerInputPhrases = DateRangePickerInputPhrases;
  var SingleDatePickerPhrases = {
    calendarLabel: calendarLabel,
    closeDatePicker: closeDatePicker,
    clearDate: clearDate,
    jumpToPrevMonth: jumpToPrevMonth,
    jumpToNextMonth: jumpToNextMonth,
    keyboardShortcuts: keyboardShortcuts,
    showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
    hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
    openThisPanel: openThisPanel,
    enterKey: enterKey,
    leftArrowRightArrow: leftArrowRightArrow,
    upArrowDownArrow: upArrowDownArrow,
    pageUpPageDown: pageUpPageDown,
    homeEnd: homeEnd,
    escape: escape,
    questionMark: questionMark,
    selectFocusedDate: selectFocusedDate,
    moveFocusByOneDay: moveFocusByOneDay,
    moveFocusByOneWeek: moveFocusByOneWeek,
    moveFocusByOneMonth: moveFocusByOneMonth,
    moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
    returnFocusToInput: returnFocusToInput,
    keyboardNavigationInstructions: keyboardNavigationInstructions,
    chooseAvailableDate: chooseAvailableDate,
    dateIsUnavailable: dateIsUnavailable,
    dateIsSelected: dateIsSelected
  };
  exports.SingleDatePickerPhrases = SingleDatePickerPhrases;
  var SingleDatePickerInputPhrases = {
    clearDate: clearDate,
    keyboardNavigationInstructions: keyboardNavigationInstructions
  };
  exports.SingleDatePickerInputPhrases = SingleDatePickerInputPhrases;
  var DayPickerPhrases = {
    calendarLabel: calendarLabel,
    jumpToPrevMonth: jumpToPrevMonth,
    jumpToNextMonth: jumpToNextMonth,
    keyboardShortcuts: keyboardShortcuts,
    showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
    hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
    openThisPanel: openThisPanel,
    enterKey: enterKey,
    leftArrowRightArrow: leftArrowRightArrow,
    upArrowDownArrow: upArrowDownArrow,
    pageUpPageDown: pageUpPageDown,
    homeEnd: homeEnd,
    escape: escape,
    questionMark: questionMark,
    selectFocusedDate: selectFocusedDate,
    moveFocusByOneDay: moveFocusByOneDay,
    moveFocusByOneWeek: moveFocusByOneWeek,
    moveFocusByOneMonth: moveFocusByOneMonth,
    moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
    returnFocusToInput: returnFocusToInput,
    chooseAvailableStartDate: chooseAvailableStartDate,
    chooseAvailableEndDate: chooseAvailableEndDate,
    chooseAvailableDate: chooseAvailableDate,
    dateIsUnavailable: dateIsUnavailable,
    dateIsSelected: dateIsSelected,
    dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
    dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
  };
  exports.DayPickerPhrases = DayPickerPhrases;
  var DayPickerKeyboardShortcutsPhrases = {
    keyboardShortcuts: keyboardShortcuts,
    showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
    hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
    openThisPanel: openThisPanel,
    enterKey: enterKey,
    leftArrowRightArrow: leftArrowRightArrow,
    upArrowDownArrow: upArrowDownArrow,
    pageUpPageDown: pageUpPageDown,
    homeEnd: homeEnd,
    escape: escape,
    questionMark: questionMark,
    selectFocusedDate: selectFocusedDate,
    moveFocusByOneDay: moveFocusByOneDay,
    moveFocusByOneWeek: moveFocusByOneWeek,
    moveFocusByOneMonth: moveFocusByOneMonth,
    moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
    returnFocusToInput: returnFocusToInput
  };
  exports.DayPickerKeyboardShortcutsPhrases = DayPickerKeyboardShortcutsPhrases;
  var DayPickerNavigationPhrases = {
    jumpToPrevMonth: jumpToPrevMonth,
    jumpToNextMonth: jumpToNextMonth
  };
  exports.DayPickerNavigationPhrases = DayPickerNavigationPhrases;
  var CalendarDayPhrases = {
    chooseAvailableDate: chooseAvailableDate,
    dateIsUnavailable: dateIsUnavailable,
    dateIsSelected: dateIsSelected,
    dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
    dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
  };
  exports.CalendarDayPhrases = CalendarDayPhrases;
});
unwrapExports(defaultPhrases);
var defaultPhrases_1 = defaultPhrases.CalendarDayPhrases;
var defaultPhrases_2 = defaultPhrases.DayPickerNavigationPhrases;
var defaultPhrases_3 = defaultPhrases.DayPickerKeyboardShortcutsPhrases;
var defaultPhrases_4 = defaultPhrases.DayPickerPhrases;
var defaultPhrases_5 = defaultPhrases.SingleDatePickerInputPhrases;
var defaultPhrases_6 = defaultPhrases.SingleDatePickerPhrases;
var defaultPhrases_7 = defaultPhrases.DateRangePickerInputPhrases;
var defaultPhrases_8 = defaultPhrases.DateRangePickerPhrases;
var getPhrasePropTypes_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getPhrasePropTypes;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function getPhrasePropTypes(defaultPhrases) {
    return Object.keys(defaultPhrases).reduce(function (phrases, key) {
      return _objectSpread({}, phrases, _defineProperty({}, key, _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node])));
    }, {});
  }
});
unwrapExports(getPhrasePropTypes_1);
var getPhrase_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getPhrase;

  function getPhrase(phrase, args) {
    if (typeof phrase === 'string') return phrase;

    if (typeof phrase === 'function') {
      return phrase(args);
    }

    return '';
  }
});
unwrapExports(getPhrase_1);
var constants$4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MODIFIER_KEY_NAMES = exports.DEFAULT_VERTICAL_SPACING = exports.FANG_HEIGHT_PX = exports.FANG_WIDTH_PX = exports.WEEKDAYS = exports.BLOCKED_MODIFIER = exports.DAY_SIZE = exports.OPEN_UP = exports.OPEN_DOWN = exports.ANCHOR_RIGHT = exports.ANCHOR_LEFT = exports.INFO_POSITION_AFTER = exports.INFO_POSITION_BEFORE = exports.INFO_POSITION_BOTTOM = exports.INFO_POSITION_TOP = exports.ICON_AFTER_POSITION = exports.ICON_BEFORE_POSITION = exports.VERTICAL_SCROLLABLE = exports.VERTICAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = exports.END_DATE = exports.START_DATE = exports.ISO_MONTH_FORMAT = exports.ISO_FORMAT = exports.DISPLAY_FORMAT = void 0;
  var DISPLAY_FORMAT = 'L';
  exports.DISPLAY_FORMAT = DISPLAY_FORMAT;
  var ISO_FORMAT = 'YYYY-MM-DD';
  exports.ISO_FORMAT = ISO_FORMAT;
  var ISO_MONTH_FORMAT = 'YYYY-MM';
  exports.ISO_MONTH_FORMAT = ISO_MONTH_FORMAT;
  var START_DATE = 'startDate';
  exports.START_DATE = START_DATE;
  var END_DATE = 'endDate';
  exports.END_DATE = END_DATE;
  var HORIZONTAL_ORIENTATION = 'horizontal';
  exports.HORIZONTAL_ORIENTATION = HORIZONTAL_ORIENTATION;
  var VERTICAL_ORIENTATION = 'vertical';
  exports.VERTICAL_ORIENTATION = VERTICAL_ORIENTATION;
  var VERTICAL_SCROLLABLE = 'verticalScrollable';
  exports.VERTICAL_SCROLLABLE = VERTICAL_SCROLLABLE;
  var ICON_BEFORE_POSITION = 'before';
  exports.ICON_BEFORE_POSITION = ICON_BEFORE_POSITION;
  var ICON_AFTER_POSITION = 'after';
  exports.ICON_AFTER_POSITION = ICON_AFTER_POSITION;
  var INFO_POSITION_TOP = 'top';
  exports.INFO_POSITION_TOP = INFO_POSITION_TOP;
  var INFO_POSITION_BOTTOM = 'bottom';
  exports.INFO_POSITION_BOTTOM = INFO_POSITION_BOTTOM;
  var INFO_POSITION_BEFORE = 'before';
  exports.INFO_POSITION_BEFORE = INFO_POSITION_BEFORE;
  var INFO_POSITION_AFTER = 'after';
  exports.INFO_POSITION_AFTER = INFO_POSITION_AFTER;
  var ANCHOR_LEFT = 'left';
  exports.ANCHOR_LEFT = ANCHOR_LEFT;
  var ANCHOR_RIGHT = 'right';
  exports.ANCHOR_RIGHT = ANCHOR_RIGHT;
  var OPEN_DOWN = 'down';
  exports.OPEN_DOWN = OPEN_DOWN;
  var OPEN_UP = 'up';
  exports.OPEN_UP = OPEN_UP;
  var DAY_SIZE = 39;
  exports.DAY_SIZE = DAY_SIZE;
  var BLOCKED_MODIFIER = 'blocked';
  exports.BLOCKED_MODIFIER = BLOCKED_MODIFIER;
  var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
  exports.WEEKDAYS = WEEKDAYS;
  var FANG_WIDTH_PX = 20;
  exports.FANG_WIDTH_PX = FANG_WIDTH_PX;
  var FANG_HEIGHT_PX = 10;
  exports.FANG_HEIGHT_PX = FANG_HEIGHT_PX;
  var DEFAULT_VERTICAL_SPACING = 22;
  exports.DEFAULT_VERTICAL_SPACING = DEFAULT_VERTICAL_SPACING;
  var MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);
  exports.MODIFIER_KEY_NAMES = MODIFIER_KEY_NAMES;
});
unwrapExports(constants$4);
var constants_1$2 = constants$4.MODIFIER_KEY_NAMES;
var constants_2$2 = constants$4.DEFAULT_VERTICAL_SPACING;
var constants_3 = constants$4.FANG_HEIGHT_PX;
var constants_4 = constants$4.FANG_WIDTH_PX;
var constants_5 = constants$4.WEEKDAYS;
var constants_6 = constants$4.BLOCKED_MODIFIER;
var constants_7 = constants$4.DAY_SIZE;
var constants_8 = constants$4.OPEN_UP;
var constants_9 = constants$4.OPEN_DOWN;
var constants_10 = constants$4.ANCHOR_RIGHT;
var constants_11 = constants$4.ANCHOR_LEFT;
var constants_12 = constants$4.INFO_POSITION_AFTER;
var constants_13 = constants$4.INFO_POSITION_BEFORE;
var constants_14 = constants$4.INFO_POSITION_BOTTOM;
var constants_15 = constants$4.INFO_POSITION_TOP;
var constants_16 = constants$4.ICON_AFTER_POSITION;
var constants_17 = constants$4.ICON_BEFORE_POSITION;
var constants_18 = constants$4.VERTICAL_SCROLLABLE;
var constants_19 = constants$4.VERTICAL_ORIENTATION;
var constants_20 = constants$4.HORIZONTAL_ORIENTATION;
var constants_21 = constants$4.END_DATE;
var constants_22 = constants$4.START_DATE;
var constants_23 = constants$4.ISO_MONTH_FORMAT;
var constants_24 = constants$4.ISO_FORMAT;
var constants_25 = constants$4.DISPLAY_FORMAT;
var getCalendarDaySettings_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getCalendarDaySettings;

  var _getPhrase = _interopRequireDefault(getPhrase_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function getCalendarDaySettings(day, ariaLabelFormat, daySize, modifiers, phrases) {
    var chooseAvailableDate = phrases.chooseAvailableDate,
        dateIsUnavailable = phrases.dateIsUnavailable,
        dateIsSelected = phrases.dateIsSelected,
        dateIsSelectedAsStartDate = phrases.dateIsSelectedAsStartDate,
        dateIsSelectedAsEndDate = phrases.dateIsSelectedAsEndDate;
    var daySizeStyles = {
      width: daySize,
      height: daySize - 1
    };
    var useDefaultCursor = modifiers.has('blocked-minimum-nights') || modifiers.has('blocked-calendar') || modifiers.has('blocked-out-of-range');
    var selected = modifiers.has('selected') || modifiers.has('selected-start') || modifiers.has('selected-end');
    var hoveredSpan = !selected && (modifiers.has('hovered-span') || modifiers.has('after-hovered-start'));
    var isOutsideRange = modifiers.has('blocked-out-of-range');
    var formattedDate = {
      date: day.format(ariaLabelFormat)
    };
    var ariaLabel = (0, _getPhrase["default"])(chooseAvailableDate, formattedDate);

    if (selected) {
      if (modifiers.has('selected-start') && dateIsSelectedAsStartDate) {
        ariaLabel = (0, _getPhrase["default"])(dateIsSelectedAsStartDate, formattedDate);
      } else if (modifiers.has('selected-end') && dateIsSelectedAsEndDate) {
        ariaLabel = (0, _getPhrase["default"])(dateIsSelectedAsEndDate, formattedDate);
      } else {
        ariaLabel = (0, _getPhrase["default"])(dateIsSelected, formattedDate);
      }
    } else if (modifiers.has(constants$4.BLOCKED_MODIFIER)) {
      ariaLabel = (0, _getPhrase["default"])(dateIsUnavailable, formattedDate);
    }

    return {
      daySizeStyles: daySizeStyles,
      useDefaultCursor: useDefaultCursor,
      selected: selected,
      hoveredSpan: hoveredSpan,
      isOutsideRange: isOutsideRange,
      ariaLabel: ariaLabel
    };
  }
});
unwrapExports(getCalendarDaySettings_1);
var ModifiersShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }
  }

  var _default = (0, airbnbPropTypes.and)([_propTypes["default"].instanceOf(Set), function () {
    function modifiers(props, propName) {
      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      var propValue = props[propName];
      var firstError;

      _toConsumableArray(propValue).some(function (v, i) {
        var _PropTypes$string;

        var fakePropName = "".concat(propName, ": index ").concat(i);
        firstError = (_PropTypes$string = _propTypes["default"].string).isRequired.apply(_PropTypes$string, [_defineProperty({}, fakePropName, v), fakePropName].concat(rest));
        return firstError != null;
      });

      return firstError == null ? null : firstError;
    }

    return modifiers;
  }()], 'Modifiers (Set of Strings)');

  exports["default"] = _default;
});
unwrapExports(ModifiersShape);
var CalendarDay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.PureCalendarDay = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _moment = _interopRequireDefault(moment);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _getCalendarDaySettings = _interopRequireDefault(getCalendarDaySettings_1);

  var _ModifiersShape = _interopRequireDefault(ModifiersShape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    day: _reactMomentProptypes["default"].momentObj,
    daySize: airbnbPropTypes.nonNegativeInteger,
    isOutsideDay: _propTypes["default"].bool,
    modifiers: _ModifiersShape["default"],
    isFocused: _propTypes["default"].bool,
    tabIndex: _propTypes["default"].oneOf([0, -1]),
    onDayClick: _propTypes["default"].func,
    onDayMouseEnter: _propTypes["default"].func,
    onDayMouseLeave: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    ariaLabelFormat: _propTypes["default"].string,
    // internationalization
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases))
  })) : {};
  var defaultProps = {
    day: (0, _moment["default"])(),
    daySize: constants$4.DAY_SIZE,
    isOutsideDay: false,
    modifiers: new Set(),
    isFocused: false,
    tabIndex: -1,
    onDayClick: function () {
      function onDayClick() {}

      return onDayClick;
    }(),
    onDayMouseEnter: function () {
      function onDayMouseEnter() {}

      return onDayMouseEnter;
    }(),
    onDayMouseLeave: function () {
      function onDayMouseLeave() {}

      return onDayMouseLeave;
    }(),
    renderDayContents: null,
    ariaLabelFormat: 'dddd, LL',
    // internationalization
    phrases: defaultPhrases.CalendarDayPhrases
  };

  var CalendarDay =
  /*#__PURE__*/
  function (_ref) {
    _inherits(CalendarDay, _ref);

    _createClass(CalendarDay, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function CalendarDay() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, CalendarDay);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CalendarDay)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.setButtonRef = _this.setButtonRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(CalendarDay, [{
      key: "componentDidUpdate",
      value: function () {
        function componentDidUpdate(prevProps) {
          var _this$props = this.props,
              isFocused = _this$props.isFocused,
              tabIndex = _this$props.tabIndex;

          if (tabIndex === 0) {
            if (isFocused || tabIndex !== prevProps.tabIndex) {
              this.buttonRef.focus();
            }
          }
        }

        return componentDidUpdate;
      }()
    }, {
      key: "onDayClick",
      value: function () {
        function onDayClick(day, e) {
          var onDayClick = this.props.onDayClick;
          onDayClick(day, e);
        }

        return onDayClick;
      }()
    }, {
      key: "onDayMouseEnter",
      value: function () {
        function onDayMouseEnter(day, e) {
          var onDayMouseEnter = this.props.onDayMouseEnter;
          onDayMouseEnter(day, e);
        }

        return onDayMouseEnter;
      }()
    }, {
      key: "onDayMouseLeave",
      value: function () {
        function onDayMouseLeave(day, e) {
          var onDayMouseLeave = this.props.onDayMouseLeave;
          onDayMouseLeave(day, e);
        }

        return onDayMouseLeave;
      }()
    }, {
      key: "onKeyDown",
      value: function () {
        function onKeyDown(day, e) {
          var onDayClick = this.props.onDayClick;
          var key = e.key;

          if (key === 'Enter' || key === ' ') {
            onDayClick(day, e);
          }
        }

        return onKeyDown;
      }()
    }, {
      key: "setButtonRef",
      value: function () {
        function setButtonRef(ref) {
          this.buttonRef = ref;
        }

        return setButtonRef;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this2 = this;

          var _this$props2 = this.props,
              day = _this$props2.day,
              ariaLabelFormat = _this$props2.ariaLabelFormat,
              daySize = _this$props2.daySize,
              isOutsideDay = _this$props2.isOutsideDay,
              modifiers = _this$props2.modifiers,
              renderDayContents = _this$props2.renderDayContents,
              tabIndex = _this$props2.tabIndex,
              styles = _this$props2.styles,
              phrases = _this$props2.phrases;
          if (!day) return _react["default"].createElement("td", null);

          var _getCalendarDaySettin = (0, _getCalendarDaySettings["default"])(day, ariaLabelFormat, daySize, modifiers, phrases),
              daySizeStyles = _getCalendarDaySettin.daySizeStyles,
              useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
              selected = _getCalendarDaySettin.selected,
              hoveredSpan = _getCalendarDaySettin.hoveredSpan,
              isOutsideRange = _getCalendarDaySettin.isOutsideRange,
              ariaLabel = _getCalendarDaySettin.ariaLabel;

          return _react["default"].createElement("td", _extends({}, (0, withStyles_1.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, styles.CalendarDay__default, isOutsideDay && styles.CalendarDay__outside, modifiers.has('today') && styles.CalendarDay__today, modifiers.has('first-day-of-week') && styles.CalendarDay__firstDayOfWeek, modifiers.has('last-day-of-week') && styles.CalendarDay__lastDayOfWeek, modifiers.has('hovered-offset') && styles.CalendarDay__hovered_offset, modifiers.has('highlighted-calendar') && styles.CalendarDay__highlighted_calendar, modifiers.has('blocked-minimum-nights') && styles.CalendarDay__blocked_minimum_nights, modifiers.has('blocked-calendar') && styles.CalendarDay__blocked_calendar, hoveredSpan && styles.CalendarDay__hovered_span, modifiers.has('selected-span') && styles.CalendarDay__selected_span, modifiers.has('last-in-range') && styles.CalendarDay__last_in_range, modifiers.has('selected-start') && styles.CalendarDay__selected_start, modifiers.has('selected-end') && styles.CalendarDay__selected_end, selected && styles.CalendarDay__selected, isOutsideRange && styles.CalendarDay__blocked_out_of_range, daySizeStyles), {
            role: "button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
            ,
            ref: this.setButtonRef,
            "aria-label": ariaLabel,
            onMouseEnter: function () {
              function onMouseEnter(e) {
                _this2.onDayMouseEnter(day, e);
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave(e) {
                _this2.onDayMouseLeave(day, e);
              }

              return onMouseLeave;
            }(),
            onMouseUp: function () {
              function onMouseUp(e) {
                e.currentTarget.blur();
              }

              return onMouseUp;
            }(),
            onClick: function () {
              function onClick(e) {
                _this2.onDayClick(day, e);
              }

              return onClick;
            }(),
            onKeyDown: function () {
              function onKeyDown(e) {
                _this2.onKeyDown(day, e);
              }

              return onKeyDown;
            }(),
            tabIndex: tabIndex
          }), renderDayContents ? renderDayContents(day, modifiers) : day.format('D'));
        }

        return render;
      }()
    }]);

    return CalendarDay;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports.PureCalendarDay = CalendarDay;
  CalendarDay.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  CalendarDay.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var _ref2$reactDates = _ref2.reactDates,
        color = _ref2$reactDates.color,
        font = _ref2$reactDates.font;
    return {
      CalendarDay: {
        boxSizing: 'border-box',
        cursor: 'pointer',
        fontSize: font.size,
        textAlign: 'center',
        ':active': {
          outline: 0
        }
      },
      CalendarDay__defaultCursor: {
        cursor: 'default'
      },
      CalendarDay__default: {
        border: "1px solid ".concat(color.core.borderLight),
        color: color.text,
        background: color.background,
        ':hover': {
          background: color.core.borderLight,
          border: "1px solid ".concat(color.core.borderLight),
          color: 'inherit'
        }
      },
      CalendarDay__hovered_offset: {
        background: color.core.borderBright,
        border: "1px double ".concat(color.core.borderLight),
        color: 'inherit'
      },
      CalendarDay__outside: {
        border: 0,
        background: color.outside.backgroundColor,
        color: color.outside.color,
        ':hover': {
          border: 0
        }
      },
      CalendarDay__blocked_minimum_nights: {
        background: color.minimumNights.backgroundColor,
        border: "1px solid ".concat(color.minimumNights.borderColor),
        color: color.minimumNights.color,
        ':hover': {
          background: color.minimumNights.backgroundColor_hover,
          color: color.minimumNights.color_active
        },
        ':active': {
          background: color.minimumNights.backgroundColor_active,
          color: color.minimumNights.color_active
        }
      },
      CalendarDay__highlighted_calendar: {
        background: color.highlighted.backgroundColor,
        color: color.highlighted.color,
        ':hover': {
          background: color.highlighted.backgroundColor_hover,
          color: color.highlighted.color_active
        },
        ':active': {
          background: color.highlighted.backgroundColor_active,
          color: color.highlighted.color_active
        }
      },
      CalendarDay__selected_span: {
        background: color.selectedSpan.backgroundColor,
        border: "1px double ".concat(color.selectedSpan.borderColor),
        color: color.selectedSpan.color,
        ':hover': {
          background: color.selectedSpan.backgroundColor_hover,
          border: "1px double ".concat(color.selectedSpan.borderColor),
          color: color.selectedSpan.color_active
        },
        ':active': {
          background: color.selectedSpan.backgroundColor_active,
          border: "1px double ".concat(color.selectedSpan.borderColor),
          color: color.selectedSpan.color_active
        }
      },
      CalendarDay__last_in_range: {
        borderStyle: 'solid',
        ':hover': {
          borderStyle: 'solid'
        }
      },
      CalendarDay__selected: {
        background: color.selected.backgroundColor,
        border: "1px double ".concat(color.selected.borderColor),
        color: color.selected.color,
        ':hover': {
          background: color.selected.backgroundColor_hover,
          border: "1px double ".concat(color.selected.borderColor),
          color: color.selected.color_active
        },
        ':active': {
          background: color.selected.backgroundColor_active,
          border: "1px double ".concat(color.selected.borderColor),
          color: color.selected.color_active
        }
      },
      CalendarDay__hovered_span: {
        background: color.hoveredSpan.backgroundColor,
        border: "1px double ".concat(color.hoveredSpan.borderColor),
        color: color.hoveredSpan.color,
        ':hover': {
          background: color.hoveredSpan.backgroundColor_hover,
          border: "1px double ".concat(color.hoveredSpan.borderColor),
          color: color.hoveredSpan.color_active
        },
        ':active': {
          background: color.hoveredSpan.backgroundColor_active,
          border: "1px double ".concat(color.hoveredSpan.borderColor),
          color: color.hoveredSpan.color_active
        }
      },
      CalendarDay__blocked_calendar: {
        background: color.blocked_calendar.backgroundColor,
        border: "1px solid ".concat(color.blocked_calendar.borderColor),
        color: color.blocked_calendar.color,
        ':hover': {
          background: color.blocked_calendar.backgroundColor_hover,
          border: "1px solid ".concat(color.blocked_calendar.borderColor),
          color: color.blocked_calendar.color_active
        },
        ':active': {
          background: color.blocked_calendar.backgroundColor_active,
          border: "1px solid ".concat(color.blocked_calendar.borderColor),
          color: color.blocked_calendar.color_active
        }
      },
      CalendarDay__blocked_out_of_range: {
        background: color.blocked_out_of_range.backgroundColor,
        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
        color: color.blocked_out_of_range.color,
        ':hover': {
          background: color.blocked_out_of_range.backgroundColor_hover,
          border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
          color: color.blocked_out_of_range.color_active
        },
        ':active': {
          background: color.blocked_out_of_range.backgroundColor_active,
          border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
          color: color.blocked_out_of_range.color_active
        }
      },
      CalendarDay__selected_start: {},
      CalendarDay__selected_end: {},
      CalendarDay__today: {},
      CalendarDay__firstDayOfWeek: {},
      CalendarDay__lastDayOfWeek: {}
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(CalendarDay);

  exports["default"] = _default;
});
unwrapExports(CalendarDay_1);
var CalendarDay_2 = CalendarDay_1.PureCalendarDay;
var CustomizableCalendarDay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.PureCustomizableCalendarDay = exports.selectedStyles = exports.lastInRangeStyles = exports.selectedSpanStyles = exports.hoveredSpanStyles = exports.blockedOutOfRangeStyles = exports.blockedCalendarStyles = exports.blockedMinNightsStyles = exports.highlightedCalendarStyles = exports.outsideStyles = exports.defaultStyles = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _moment = _interopRequireDefault(moment);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _getCalendarDaySettings = _interopRequireDefault(getCalendarDaySettings_1);

  var _DefaultTheme = _interopRequireDefault(DefaultTheme);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var color = _DefaultTheme["default"].reactDates.color;

  function getStyles(stylesObj, isHovered) {
    if (!stylesObj) return null;
    var hover = stylesObj.hover;

    if (isHovered && hover) {
      return hover;
    }

    return stylesObj;
  }

  var DayStyleShape = process.env.NODE_ENV !== "production" ? _propTypes["default"].shape({
    background: _propTypes["default"].string,
    border: (0, airbnbPropTypes.or)([_propTypes["default"].string, _propTypes["default"].number]),
    color: _propTypes["default"].string,
    hover: _propTypes["default"].shape({
      background: _propTypes["default"].string,
      border: (0, airbnbPropTypes.or)([_propTypes["default"].string, _propTypes["default"].number]),
      color: _propTypes["default"].string
    })
  }) : {};
  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    day: _reactMomentProptypes["default"].momentObj,
    daySize: airbnbPropTypes.nonNegativeInteger,
    isOutsideDay: _propTypes["default"].bool,
    modifiers: _propTypes["default"].instanceOf(Set),
    isFocused: _propTypes["default"].bool,
    tabIndex: _propTypes["default"].oneOf([0, -1]),
    onDayClick: _propTypes["default"].func,
    onDayMouseEnter: _propTypes["default"].func,
    onDayMouseLeave: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    ariaLabelFormat: _propTypes["default"].string,
    // style overrides
    defaultStyles: DayStyleShape,
    outsideStyles: DayStyleShape,
    todayStyles: DayStyleShape,
    firstDayOfWeekStyles: DayStyleShape,
    lastDayOfWeekStyles: DayStyleShape,
    highlightedCalendarStyles: DayStyleShape,
    blockedMinNightsStyles: DayStyleShape,
    blockedCalendarStyles: DayStyleShape,
    blockedOutOfRangeStyles: DayStyleShape,
    hoveredSpanStyles: DayStyleShape,
    selectedSpanStyles: DayStyleShape,
    lastInRangeStyles: DayStyleShape,
    selectedStyles: DayStyleShape,
    selectedStartStyles: DayStyleShape,
    selectedEndStyles: DayStyleShape,
    afterHoveredStartStyles: DayStyleShape,
    // internationalization
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases))
  })) : {};
  var defaultStyles = {
    border: "1px solid ".concat(color.core.borderLight),
    color: color.text,
    background: color.background,
    hover: {
      background: color.core.borderLight,
      border: "1px solid ".concat(color.core.borderLight),
      color: 'inherit'
    }
  };
  exports.defaultStyles = defaultStyles;
  var outsideStyles = {
    background: color.outside.backgroundColor,
    border: 0,
    color: color.outside.color
  };
  exports.outsideStyles = outsideStyles;
  var highlightedCalendarStyles = {
    background: color.highlighted.backgroundColor,
    color: color.highlighted.color,
    hover: {
      background: color.highlighted.backgroundColor_hover,
      color: color.highlighted.color_active
    }
  };
  exports.highlightedCalendarStyles = highlightedCalendarStyles;
  var blockedMinNightsStyles = {
    background: color.minimumNights.backgroundColor,
    border: "1px solid ".concat(color.minimumNights.borderColor),
    color: color.minimumNights.color,
    hover: {
      background: color.minimumNights.backgroundColor_hover,
      color: color.minimumNights.color_active
    }
  };
  exports.blockedMinNightsStyles = blockedMinNightsStyles;
  var blockedCalendarStyles = {
    background: color.blocked_calendar.backgroundColor,
    border: "1px solid ".concat(color.blocked_calendar.borderColor),
    color: color.blocked_calendar.color,
    hover: {
      background: color.blocked_calendar.backgroundColor_hover,
      border: "1px solid ".concat(color.blocked_calendar.borderColor),
      color: color.blocked_calendar.color_active
    }
  };
  exports.blockedCalendarStyles = blockedCalendarStyles;
  var blockedOutOfRangeStyles = {
    background: color.blocked_out_of_range.backgroundColor,
    border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
    color: color.blocked_out_of_range.color,
    hover: {
      background: color.blocked_out_of_range.backgroundColor_hover,
      border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
      color: color.blocked_out_of_range.color_active
    }
  };
  exports.blockedOutOfRangeStyles = blockedOutOfRangeStyles;
  var hoveredSpanStyles = {
    background: color.hoveredSpan.backgroundColor,
    border: "1px double ".concat(color.hoveredSpan.borderColor),
    color: color.hoveredSpan.color,
    hover: {
      background: color.hoveredSpan.backgroundColor_hover,
      border: "1px double ".concat(color.hoveredSpan.borderColor),
      color: color.hoveredSpan.color_active
    }
  };
  exports.hoveredSpanStyles = hoveredSpanStyles;
  var selectedSpanStyles = {
    background: color.selectedSpan.backgroundColor,
    border: "1px double ".concat(color.selectedSpan.borderColor),
    color: color.selectedSpan.color,
    hover: {
      background: color.selectedSpan.backgroundColor_hover,
      border: "1px double ".concat(color.selectedSpan.borderColor),
      color: color.selectedSpan.color_active
    }
  };
  exports.selectedSpanStyles = selectedSpanStyles;
  var lastInRangeStyles = {
    borderStyle: 'solid',
    hover: {
      borderStyle: 'solid'
    }
  };
  exports.lastInRangeStyles = lastInRangeStyles;
  var selectedStyles = {
    background: color.selected.backgroundColor,
    border: "1px double ".concat(color.selected.borderColor),
    color: color.selected.color,
    hover: {
      background: color.selected.backgroundColor_hover,
      border: "1px double ".concat(color.selected.borderColor),
      color: color.selected.color_active
    }
  };
  exports.selectedStyles = selectedStyles;
  var defaultProps = {
    day: (0, _moment["default"])(),
    daySize: constants$4.DAY_SIZE,
    isOutsideDay: false,
    modifiers: new Set(),
    isFocused: false,
    tabIndex: -1,
    onDayClick: function () {
      function onDayClick() {}

      return onDayClick;
    }(),
    onDayMouseEnter: function () {
      function onDayMouseEnter() {}

      return onDayMouseEnter;
    }(),
    onDayMouseLeave: function () {
      function onDayMouseLeave() {}

      return onDayMouseLeave;
    }(),
    renderDayContents: null,
    ariaLabelFormat: 'dddd, LL',
    // style defaults
    defaultStyles: defaultStyles,
    outsideStyles: outsideStyles,
    todayStyles: {},
    highlightedCalendarStyles: highlightedCalendarStyles,
    blockedMinNightsStyles: blockedMinNightsStyles,
    blockedCalendarStyles: blockedCalendarStyles,
    blockedOutOfRangeStyles: blockedOutOfRangeStyles,
    hoveredSpanStyles: hoveredSpanStyles,
    selectedSpanStyles: selectedSpanStyles,
    lastInRangeStyles: lastInRangeStyles,
    selectedStyles: selectedStyles,
    selectedStartStyles: {},
    selectedEndStyles: {},
    afterHoveredStartStyles: {},
    firstDayOfWeekStyles: {},
    lastDayOfWeekStyles: {},
    // internationalization
    phrases: defaultPhrases.CalendarDayPhrases
  };

  var CustomizableCalendarDay =
  /*#__PURE__*/
  function (_ref) {
    _inherits(CustomizableCalendarDay, _ref);

    _createClass(CustomizableCalendarDay, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function CustomizableCalendarDay() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, CustomizableCalendarDay);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CustomizableCalendarDay)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.state = {
        isHovered: false
      };
      _this.setButtonRef = _this.setButtonRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(CustomizableCalendarDay, [{
      key: "componentDidUpdate",
      value: function () {
        function componentDidUpdate(prevProps) {
          var _this$props = this.props,
              isFocused = _this$props.isFocused,
              tabIndex = _this$props.tabIndex;

          if (tabIndex === 0) {
            if (isFocused || tabIndex !== prevProps.tabIndex) {
              this.buttonRef.focus();
            }
          }
        }

        return componentDidUpdate;
      }()
    }, {
      key: "onDayClick",
      value: function () {
        function onDayClick(day, e) {
          var onDayClick = this.props.onDayClick;
          onDayClick(day, e);
        }

        return onDayClick;
      }()
    }, {
      key: "onDayMouseEnter",
      value: function () {
        function onDayMouseEnter(day, e) {
          var onDayMouseEnter = this.props.onDayMouseEnter;
          this.setState({
            isHovered: true
          });
          onDayMouseEnter(day, e);
        }

        return onDayMouseEnter;
      }()
    }, {
      key: "onDayMouseLeave",
      value: function () {
        function onDayMouseLeave(day, e) {
          var onDayMouseLeave = this.props.onDayMouseLeave;
          this.setState({
            isHovered: false
          });
          onDayMouseLeave(day, e);
        }

        return onDayMouseLeave;
      }()
    }, {
      key: "onKeyDown",
      value: function () {
        function onKeyDown(day, e) {
          var onDayClick = this.props.onDayClick;
          var key = e.key;

          if (key === 'Enter' || key === ' ') {
            onDayClick(day, e);
          }
        }

        return onKeyDown;
      }()
    }, {
      key: "setButtonRef",
      value: function () {
        function setButtonRef(ref) {
          this.buttonRef = ref;
        }

        return setButtonRef;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this2 = this;

          var _this$props2 = this.props,
              day = _this$props2.day,
              ariaLabelFormat = _this$props2.ariaLabelFormat,
              daySize = _this$props2.daySize,
              isOutsideDay = _this$props2.isOutsideDay,
              modifiers = _this$props2.modifiers,
              tabIndex = _this$props2.tabIndex,
              renderDayContents = _this$props2.renderDayContents,
              styles = _this$props2.styles,
              phrases = _this$props2.phrases,
              defaultStylesWithHover = _this$props2.defaultStyles,
              outsideStylesWithHover = _this$props2.outsideStyles,
              todayStylesWithHover = _this$props2.todayStyles,
              firstDayOfWeekStylesWithHover = _this$props2.firstDayOfWeekStyles,
              lastDayOfWeekStylesWithHover = _this$props2.lastDayOfWeekStyles,
              highlightedCalendarStylesWithHover = _this$props2.highlightedCalendarStyles,
              blockedMinNightsStylesWithHover = _this$props2.blockedMinNightsStyles,
              blockedCalendarStylesWithHover = _this$props2.blockedCalendarStyles,
              blockedOutOfRangeStylesWithHover = _this$props2.blockedOutOfRangeStyles,
              hoveredSpanStylesWithHover = _this$props2.hoveredSpanStyles,
              selectedSpanStylesWithHover = _this$props2.selectedSpanStyles,
              lastInRangeStylesWithHover = _this$props2.lastInRangeStyles,
              selectedStylesWithHover = _this$props2.selectedStyles,
              selectedStartStylesWithHover = _this$props2.selectedStartStyles,
              selectedEndStylesWithHover = _this$props2.selectedEndStyles,
              afterHoveredStartStylesWithHover = _this$props2.afterHoveredStartStyles;
          var isHovered = this.state.isHovered;
          if (!day) return _react["default"].createElement("td", null);

          var _getCalendarDaySettin = (0, _getCalendarDaySettings["default"])(day, ariaLabelFormat, daySize, modifiers, phrases),
              daySizeStyles = _getCalendarDaySettin.daySizeStyles,
              useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
              selected = _getCalendarDaySettin.selected,
              hoveredSpan = _getCalendarDaySettin.hoveredSpan,
              isOutsideRange = _getCalendarDaySettin.isOutsideRange,
              ariaLabel = _getCalendarDaySettin.ariaLabel;

          return _react["default"].createElement("td", _extends({}, (0, withStyles_1.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, daySizeStyles, getStyles(defaultStylesWithHover, isHovered), isOutsideDay && getStyles(outsideStylesWithHover, isHovered), modifiers.has('today') && getStyles(todayStylesWithHover, isHovered), modifiers.has('first-day-of-week') && getStyles(firstDayOfWeekStylesWithHover, isHovered), modifiers.has('last-day-of-week') && getStyles(lastDayOfWeekStylesWithHover, isHovered), modifiers.has('highlighted-calendar') && getStyles(highlightedCalendarStylesWithHover, isHovered), modifiers.has('blocked-minimum-nights') && getStyles(blockedMinNightsStylesWithHover, isHovered), modifiers.has('blocked-calendar') && getStyles(blockedCalendarStylesWithHover, isHovered), hoveredSpan && getStyles(hoveredSpanStylesWithHover, isHovered), modifiers.has('after-hovered-start') && getStyles(afterHoveredStartStylesWithHover, isHovered), modifiers.has('selected-span') && getStyles(selectedSpanStylesWithHover, isHovered), modifiers.has('last-in-range') && getStyles(lastInRangeStylesWithHover, isHovered), selected && getStyles(selectedStylesWithHover, isHovered), modifiers.has('selected-start') && getStyles(selectedStartStylesWithHover, isHovered), modifiers.has('selected-end') && getStyles(selectedEndStylesWithHover, isHovered), isOutsideRange && getStyles(blockedOutOfRangeStylesWithHover, isHovered)), {
            role: "button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
            ,
            ref: this.setButtonRef,
            "aria-label": ariaLabel,
            onMouseEnter: function () {
              function onMouseEnter(e) {
                _this2.onDayMouseEnter(day, e);
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave(e) {
                _this2.onDayMouseLeave(day, e);
              }

              return onMouseLeave;
            }(),
            onMouseUp: function () {
              function onMouseUp(e) {
                e.currentTarget.blur();
              }

              return onMouseUp;
            }(),
            onClick: function () {
              function onClick(e) {
                _this2.onDayClick(day, e);
              }

              return onClick;
            }(),
            onKeyDown: function () {
              function onKeyDown(e) {
                _this2.onKeyDown(day, e);
              }

              return onKeyDown;
            }(),
            tabIndex: tabIndex
          }), renderDayContents ? renderDayContents(day, modifiers) : day.format('D'));
        }

        return render;
      }()
    }]);

    return CustomizableCalendarDay;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports.PureCustomizableCalendarDay = CustomizableCalendarDay;
  CustomizableCalendarDay.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  CustomizableCalendarDay.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var font = _ref2.reactDates.font;
    return {
      CalendarDay: {
        boxSizing: 'border-box',
        cursor: 'pointer',
        fontSize: font.size,
        textAlign: 'center',
        ':active': {
          outline: 0
        }
      },
      CalendarDay__defaultCursor: {
        cursor: 'default'
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(CustomizableCalendarDay);

  exports["default"] = _default;
});
unwrapExports(CustomizableCalendarDay_1);
var CustomizableCalendarDay_2 = CustomizableCalendarDay_1.PureCustomizableCalendarDay;
var CustomizableCalendarDay_3 = CustomizableCalendarDay_1.selectedStyles;
var CustomizableCalendarDay_4 = CustomizableCalendarDay_1.lastInRangeStyles;
var CustomizableCalendarDay_5 = CustomizableCalendarDay_1.selectedSpanStyles;
var CustomizableCalendarDay_6 = CustomizableCalendarDay_1.hoveredSpanStyles;
var CustomizableCalendarDay_7 = CustomizableCalendarDay_1.blockedOutOfRangeStyles;
var CustomizableCalendarDay_8 = CustomizableCalendarDay_1.blockedCalendarStyles;
var CustomizableCalendarDay_9 = CustomizableCalendarDay_1.blockedMinNightsStyles;
var CustomizableCalendarDay_10 = CustomizableCalendarDay_1.highlightedCalendarStyles;
var CustomizableCalendarDay_11 = CustomizableCalendarDay_1.outsideStyles;
var CustomizableCalendarDay_12 = CustomizableCalendarDay_1.defaultStyles;
var CalendarWeek_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = CalendarWeek;

  var _react = _interopRequireDefault(React__default);

  var _CalendarDay = _interopRequireDefault(CalendarDay_1);

  var _CustomizableCalendarDay = _interopRequireDefault(CustomizableCalendarDay_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
    children: (0, airbnbPropTypes.or)([(0, airbnbPropTypes.childrenOfType)(_CalendarDay["default"]), (0, airbnbPropTypes.childrenOfType)(_CustomizableCalendarDay["default"])]).isRequired
  }) : {};

  function CalendarWeek(_ref) {
    var children = _ref.children;
    return _react["default"].createElement("tr", null, children);
  }

  CalendarWeek.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
});
unwrapExports(CalendarWeek_1);
var calculateDimension_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = calculateDimension;

  function calculateDimension(el, axis) {
    var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!el) {
      return 0;
    }

    var axisStart = axis === 'width' ? 'Left' : 'Top';
    var axisEnd = axis === 'width' ? 'Right' : 'Bottom'; // Only read styles if we need to

    var style = !borderBox || withMargin ? window.getComputedStyle(el) : null; // Offset includes border and padding

    var offsetWidth = el.offsetWidth,
        offsetHeight = el.offsetHeight;
    var size = axis === 'width' ? offsetWidth : offsetHeight; // Get the inner size

    if (!borderBox) {
      size -= parseFloat(style["padding".concat(axisStart)]) + parseFloat(style["padding".concat(axisEnd)]) + parseFloat(style["border".concat(axisStart, "Width")]) + parseFloat(style["border".concat(axisEnd, "Width")]);
    } // Apply margin


    if (withMargin) {
      size += parseFloat(style["margin".concat(axisStart)]) + parseFloat(style["margin".concat(axisEnd)]);
    }

    return size;
  }
});
unwrapExports(calculateDimension_1);
var getCalendarMonthWeeks_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getCalendarMonthWeeks;

  var _moment = _interopRequireDefault(moment);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function getCalendarMonthWeeks(month, enableOutsideDays) {
    var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment["default"].localeData().firstDayOfWeek();

    if (!_moment["default"].isMoment(month) || !month.isValid()) {
      throw new TypeError('`month` must be a valid moment object');
    }

    if (constants$4.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
      throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
    } // set utc offset to get correct dates in future (when timezone changes)


    var firstOfMonth = month.clone().startOf('month').hour(12);
    var lastOfMonth = month.clone().endOf('month').hour(12); // calculate the exact first and last days to fill the entire matrix
    // (considering days outside month)

    var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
    var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
    var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
    var lastDay = lastOfMonth.clone().add(nextDays, 'day');
    var totalDays = lastDay.diff(firstDay, 'days') + 1;
    var currentDay = firstDay.clone();
    var weeksInMonth = [];

    for (var i = 0; i < totalDays; i += 1) {
      if (i % 7 === 0) {
        weeksInMonth.push([]);
      }

      var day = null;

      if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
        day = currentDay.clone();
      }

      weeksInMonth[weeksInMonth.length - 1].push(day);
      currentDay.add(1, 'day');
    }

    return weeksInMonth;
  }
});
unwrapExports(getCalendarMonthWeeks_1);
var isSameDay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isSameDay;

  var _moment = _interopRequireDefault(moment);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isSameDay(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
    // Moment's isSame clones moment inputs and is a tad slow

    return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
  }
});
unwrapExports(isSameDay_1);
var toMomentObject_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = toMomentObject;

  var _moment = _interopRequireDefault(moment);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function toMomentObject(dateString, customFormat) {
    var dateFormats = customFormat ? [customFormat, constants$4.DISPLAY_FORMAT, constants$4.ISO_FORMAT] : [constants$4.DISPLAY_FORMAT, constants$4.ISO_FORMAT];
    var date = (0, _moment["default"])(dateString, dateFormats, true);
    return date.isValid() ? date.hour(12) : null;
  }
});
unwrapExports(toMomentObject_1);
var toISODateString_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = toISODateString;

  var _moment = _interopRequireDefault(moment);

  var _toMomentObject = _interopRequireDefault(toMomentObject_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function toISODateString(date, currentFormat) {
    var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
    if (!dateObj) return null;
    return dateObj.format(constants$4.ISO_FORMAT);
  }
});
unwrapExports(toISODateString_1);
var ScrollableOrientationShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOf([constants$4.HORIZONTAL_ORIENTATION, constants$4.VERTICAL_ORIENTATION, constants$4.VERTICAL_SCROLLABLE]);

  exports["default"] = _default;
});
unwrapExports(ScrollableOrientationShape);
var DayOfWeekShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOf(constants$4.WEEKDAYS);

  exports["default"] = _default;
});
unwrapExports(DayOfWeekShape);
var CalendarMonth_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _moment = _interopRequireDefault(moment);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _CalendarWeek = _interopRequireDefault(CalendarWeek_1);

  var _CalendarDay = _interopRequireDefault(CalendarDay_1);

  var _calculateDimension = _interopRequireDefault(calculateDimension_1);

  var _getCalendarMonthWeeks = _interopRequireDefault(getCalendarMonthWeeks_1);

  var _isSameDay = _interopRequireDefault(isSameDay_1);

  var _toISODateString = _interopRequireDefault(toISODateString_1);

  var _ModifiersShape = _interopRequireDefault(ModifiersShape);

  var _ScrollableOrientationShape = _interopRequireDefault(ScrollableOrientationShape);

  var _DayOfWeekShape = _interopRequireDefault(DayOfWeekShape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    month: _reactMomentProptypes["default"].momentObj,
    horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
    isVisible: _propTypes["default"].bool,
    enableOutsideDays: _propTypes["default"].bool,
    modifiers: _propTypes["default"].objectOf(_ModifiersShape["default"]),
    orientation: _ScrollableOrientationShape["default"],
    daySize: airbnbPropTypes.nonNegativeInteger,
    onDayClick: _propTypes["default"].func,
    onDayMouseEnter: _propTypes["default"].func,
    onDayMouseLeave: _propTypes["default"].func,
    onMonthSelect: _propTypes["default"].func,
    onYearSelect: _propTypes["default"].func,
    renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    renderCalendarDay: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    firstDayOfWeek: _DayOfWeekShape["default"],
    setMonthTitleHeight: _propTypes["default"].func,
    verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
    focusedDate: _reactMomentProptypes["default"].momentObj,
    // indicates focusable day
    isFocused: _propTypes["default"].bool,
    // indicates whether or not to move focus to focusable day
    // i18n
    monthFormat: _propTypes["default"].string,
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases)),
    dayAriaLabelFormat: _propTypes["default"].string
  })) : {};
  var defaultProps = {
    month: (0, _moment["default"])(),
    horizontalMonthPadding: 13,
    isVisible: true,
    enableOutsideDays: false,
    modifiers: {},
    orientation: constants$4.HORIZONTAL_ORIENTATION,
    daySize: constants$4.DAY_SIZE,
    onDayClick: function () {
      function onDayClick() {}

      return onDayClick;
    }(),
    onDayMouseEnter: function () {
      function onDayMouseEnter() {}

      return onDayMouseEnter;
    }(),
    onDayMouseLeave: function () {
      function onDayMouseLeave() {}

      return onDayMouseLeave;
    }(),
    onMonthSelect: function () {
      function onMonthSelect() {}

      return onMonthSelect;
    }(),
    onYearSelect: function () {
      function onYearSelect() {}

      return onYearSelect;
    }(),
    renderMonthText: null,
    renderCalendarDay: function () {
      function renderCalendarDay(props) {
        return _react["default"].createElement(_CalendarDay["default"], props);
      }

      return renderCalendarDay;
    }(),
    renderDayContents: null,
    renderMonthElement: null,
    firstDayOfWeek: null,
    setMonthTitleHeight: null,
    focusedDate: null,
    isFocused: false,
    // i18n
    monthFormat: 'MMMM YYYY',
    // english locale
    phrases: defaultPhrases.CalendarDayPhrases,
    dayAriaLabelFormat: undefined,
    verticalBorderSpacing: undefined
  };

  var CalendarMonth =
  /*#__PURE__*/
  function (_ref) {
    _inherits(CalendarMonth, _ref);

    _createClass(CalendarMonth, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function CalendarMonth(props) {
      var _this;

      _classCallCheck(this, CalendarMonth);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(CalendarMonth).call(this, props));
      _this.state = {
        weeks: (0, _getCalendarMonthWeeks["default"])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : props.firstDayOfWeek)
      };
      _this.setCaptionRef = _this.setCaptionRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(CalendarMonth, [{
      key: "componentDidMount",
      value: function () {
        function componentDidMount() {
          this.setMonthTitleHeightTimeout = setTimeout(this.setMonthTitleHeight, 0);
        }

        return componentDidMount;
      }()
    }, {
      key: "componentWillReceiveProps",
      value: function () {
        function componentWillReceiveProps(nextProps) {
          var month = nextProps.month,
              enableOutsideDays = nextProps.enableOutsideDays,
              firstDayOfWeek = nextProps.firstDayOfWeek;
          var _this$props = this.props,
              prevMonth = _this$props.month,
              prevEnableOutsideDays = _this$props.enableOutsideDays,
              prevFirstDayOfWeek = _this$props.firstDayOfWeek;

          if (!month.isSame(prevMonth) || enableOutsideDays !== prevEnableOutsideDays || firstDayOfWeek !== prevFirstDayOfWeek) {
            this.setState({
              weeks: (0, _getCalendarMonthWeeks["default"])(month, enableOutsideDays, firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : firstDayOfWeek)
            });
          }
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: "componentWillUnmount",
      value: function () {
        function componentWillUnmount() {
          if (this.setMonthTitleHeightTimeout) {
            clearTimeout(this.setMonthTitleHeightTimeout);
          }
        }

        return componentWillUnmount;
      }()
    }, {
      key: "setMonthTitleHeight",
      value: function () {
        function setMonthTitleHeight() {
          var setMonthTitleHeight = this.props.setMonthTitleHeight;

          if (setMonthTitleHeight) {
            var captionHeight = (0, _calculateDimension["default"])(this.captionRef, 'height', true, true);
            setMonthTitleHeight(captionHeight);
          }
        }

        return setMonthTitleHeight;
      }()
    }, {
      key: "setCaptionRef",
      value: function () {
        function setCaptionRef(ref) {
          this.captionRef = ref;
        }

        return setCaptionRef;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$props2 = this.props,
              dayAriaLabelFormat = _this$props2.dayAriaLabelFormat,
              daySize = _this$props2.daySize,
              focusedDate = _this$props2.focusedDate,
              horizontalMonthPadding = _this$props2.horizontalMonthPadding,
              isFocused = _this$props2.isFocused,
              isVisible = _this$props2.isVisible,
              modifiers = _this$props2.modifiers,
              month = _this$props2.month,
              monthFormat = _this$props2.monthFormat,
              onDayClick = _this$props2.onDayClick,
              onDayMouseEnter = _this$props2.onDayMouseEnter,
              onDayMouseLeave = _this$props2.onDayMouseLeave,
              onMonthSelect = _this$props2.onMonthSelect,
              onYearSelect = _this$props2.onYearSelect,
              orientation = _this$props2.orientation,
              phrases = _this$props2.phrases,
              renderCalendarDay = _this$props2.renderCalendarDay,
              renderDayContents = _this$props2.renderDayContents,
              renderMonthElement = _this$props2.renderMonthElement,
              renderMonthText = _this$props2.renderMonthText,
              styles = _this$props2.styles,
              verticalBorderSpacing = _this$props2.verticalBorderSpacing;
          var weeks = this.state.weeks;
          var monthTitle = renderMonthText ? renderMonthText(month) : month.format(monthFormat);
          var verticalScrollable = orientation === constants$4.VERTICAL_SCROLLABLE;
          return _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.CalendarMonth, {
            padding: "0 ".concat(horizontalMonthPadding, "px")
          }), {
            "data-visible": isVisible
          }), _react["default"].createElement("div", _extends({
            ref: this.setCaptionRef
          }, (0, withStyles_1.css)(styles.CalendarMonth_caption, verticalScrollable && styles.CalendarMonth_caption__verticalScrollable)), renderMonthElement ? renderMonthElement({
            month: month,
            onMonthSelect: onMonthSelect,
            onYearSelect: onYearSelect
          }) : _react["default"].createElement("strong", null, monthTitle)), _react["default"].createElement("table", _extends({}, (0, withStyles_1.css)(!verticalBorderSpacing && styles.CalendarMonth_table, verticalBorderSpacing && styles.CalendarMonth_verticalSpacing, verticalBorderSpacing && {
            borderSpacing: "0px ".concat(verticalBorderSpacing, "px")
          }), {
            role: "presentation"
          }), _react["default"].createElement("tbody", null, weeks.map(function (week, i) {
            return _react["default"].createElement(_CalendarWeek["default"], {
              key: i
            }, week.map(function (day, dayOfWeek) {
              return renderCalendarDay({
                key: dayOfWeek,
                day: day,
                daySize: daySize,
                isOutsideDay: !day || day.month() !== month.month(),
                tabIndex: isVisible && (0, _isSameDay["default"])(day, focusedDate) ? 0 : -1,
                isFocused: isFocused,
                onDayMouseEnter: onDayMouseEnter,
                onDayMouseLeave: onDayMouseLeave,
                onDayClick: onDayClick,
                renderDayContents: renderDayContents,
                phrases: phrases,
                modifiers: modifiers[(0, _toISODateString["default"])(day)],
                ariaLabelFormat: dayAriaLabelFormat
              });
            }));
          }))));
        }

        return render;
      }()
    }]);

    return CalendarMonth;
  }(_react["default"].PureComponent || _react["default"].Component);

  CalendarMonth.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  CalendarMonth.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var _ref2$reactDates = _ref2.reactDates,
        color = _ref2$reactDates.color,
        font = _ref2$reactDates.font,
        spacing = _ref2$reactDates.spacing;
    return {
      CalendarMonth: {
        background: color.background,
        textAlign: 'center',
        verticalAlign: 'top',
        userSelect: 'none'
      },
      CalendarMonth_table: {
        borderCollapse: 'collapse',
        borderSpacing: 0
      },
      CalendarMonth_verticalSpacing: {
        borderCollapse: 'separate'
      },
      CalendarMonth_caption: {
        color: color.text,
        fontSize: font.captionSize,
        textAlign: 'center',
        paddingTop: spacing.captionPaddingTop,
        paddingBottom: spacing.captionPaddingBottom,
        captionSide: 'initial'
      },
      CalendarMonth_caption__verticalScrollable: {
        paddingTop: 12,
        paddingBottom: 7
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(CalendarMonth);

  exports["default"] = _default;
});
unwrapExports(CalendarMonth_1);
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement); // Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37

function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });

    var noop = function noop() {};

    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {// do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }

  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}
/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */


function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  } // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.


  if (normalizedEventOptions === true) {
    return 100;
  } // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).


  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this; // options has already been normalized at this point.


    var eventHandlers = this.getEventHandlers(eventName, options);
    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);
    var isSubscribed = true;

    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;
        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.
          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();

    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__'; // eslint-disable-next-line import/prefer-default-export

function addEventListener$6(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }

  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

var index_esm =
/*#__PURE__*/
Object.freeze({
  addEventListener: addEventListener$6
});
var noflip_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = noflip;
  var NOFLIP = '/* @noflip */'; // Appends a noflip comment to a style rule in order to prevent it from being automatically
  // flipped in RTL contexts. This should be used only in situations where the style must remain
  // unflipped regardless of direction context. See: https://github.com/kentcdodds/rtl-css-js#usage

  function noflip(value) {
    if (typeof value === 'number') return "".concat(value, "px ").concat(NOFLIP);
    if (typeof value === 'string') return "".concat(value, " ").concat(NOFLIP);
    throw new TypeError('noflip expects a string or a number');
  }
});
unwrapExports(noflip_1);
var isTransitionEndSupported_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isTransitionEndSupported;

  function isTransitionEndSupported() {
    return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
  }
});
unwrapExports(isTransitionEndSupported_1);
var getTransformStyles_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getTransformStyles;

  function getTransformStyles(transformValue) {
    return {
      transform: transformValue,
      msTransform: transformValue,
      MozTransform: transformValue,
      WebkitTransform: transformValue
    };
  }
});
unwrapExports(getTransformStyles_1);
var getCalendarMonthWidth_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getCalendarMonthWidth;

  function getCalendarMonthWidth(daySize) {
    var calendarMonthPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return 7 * daySize + 2 * calendarMonthPadding + 1;
  }
});
unwrapExports(getCalendarMonthWidth_1);
var toISOMonthString_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = toISOMonthString;

  var _moment = _interopRequireDefault(moment);

  var _toMomentObject = _interopRequireDefault(toMomentObject_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function toISOMonthString(date, currentFormat) {
    var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
    if (!dateObj) return null;
    return dateObj.format(constants$4.ISO_MONTH_FORMAT);
  }
});
unwrapExports(toISOMonthString_1);
var isSameMonth_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isSameMonth;

  var _moment = _interopRequireDefault(moment);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isSameMonth(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
    // Moment's isSame clones moment inputs and is a tad slow

    return a.month() === b.month() && a.year() === b.year();
  }
});
unwrapExports(isSameMonth_1);
var isPrevMonth_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isPrevMonth;

  var _moment = _interopRequireDefault(moment);

  var _isSameMonth = _interopRequireDefault(isSameMonth_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isPrevMonth(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
    return (0, _isSameMonth["default"])(a.clone().subtract(1, 'month'), b);
  }
});
unwrapExports(isPrevMonth_1);
var isNextMonth_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isNextMonth;

  var _moment = _interopRequireDefault(moment);

  var _isSameMonth = _interopRequireDefault(isSameMonth_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isNextMonth(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
    return (0, _isSameMonth["default"])(a.clone().add(1, 'month'), b);
  }
});
unwrapExports(isNextMonth_1);
var CalendarMonthGrid_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _moment = _interopRequireDefault(moment);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _noflip = _interopRequireDefault(noflip_1);

  var _CalendarMonth = _interopRequireDefault(CalendarMonth_1);

  var _isTransitionEndSupported = _interopRequireDefault(isTransitionEndSupported_1);

  var _getTransformStyles = _interopRequireDefault(getTransformStyles_1);

  var _getCalendarMonthWidth = _interopRequireDefault(getCalendarMonthWidth_1);

  var _toISOMonthString = _interopRequireDefault(toISOMonthString_1);

  var _isPrevMonth = _interopRequireDefault(isPrevMonth_1);

  var _isNextMonth = _interopRequireDefault(isNextMonth_1);

  var _ModifiersShape = _interopRequireDefault(ModifiersShape);

  var _ScrollableOrientationShape = _interopRequireDefault(ScrollableOrientationShape);

  var _DayOfWeekShape = _interopRequireDefault(DayOfWeekShape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    enableOutsideDays: _propTypes["default"].bool,
    firstVisibleMonthIndex: _propTypes["default"].number,
    horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
    initialMonth: _reactMomentProptypes["default"].momentObj,
    isAnimating: _propTypes["default"].bool,
    numberOfMonths: _propTypes["default"].number,
    modifiers: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_ModifiersShape["default"])),
    orientation: _ScrollableOrientationShape["default"],
    onDayClick: _propTypes["default"].func,
    onDayMouseEnter: _propTypes["default"].func,
    onDayMouseLeave: _propTypes["default"].func,
    onMonthTransitionEnd: _propTypes["default"].func,
    onMonthChange: _propTypes["default"].func,
    onYearChange: _propTypes["default"].func,
    renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    renderCalendarDay: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    translationValue: _propTypes["default"].number,
    renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    daySize: airbnbPropTypes.nonNegativeInteger,
    focusedDate: _reactMomentProptypes["default"].momentObj,
    // indicates focusable day
    isFocused: _propTypes["default"].bool,
    // indicates whether or not to move focus to focusable day
    firstDayOfWeek: _DayOfWeekShape["default"],
    setMonthTitleHeight: _propTypes["default"].func,
    isRTL: _propTypes["default"].bool,
    transitionDuration: airbnbPropTypes.nonNegativeInteger,
    verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
    // i18n
    monthFormat: _propTypes["default"].string,
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases)),
    dayAriaLabelFormat: _propTypes["default"].string
  })) : {};
  var defaultProps = {
    enableOutsideDays: false,
    firstVisibleMonthIndex: 0,
    horizontalMonthPadding: 13,
    initialMonth: (0, _moment["default"])(),
    isAnimating: false,
    numberOfMonths: 1,
    modifiers: {},
    orientation: constants$4.HORIZONTAL_ORIENTATION,
    onDayClick: function () {
      function onDayClick() {}

      return onDayClick;
    }(),
    onDayMouseEnter: function () {
      function onDayMouseEnter() {}

      return onDayMouseEnter;
    }(),
    onDayMouseLeave: function () {
      function onDayMouseLeave() {}

      return onDayMouseLeave;
    }(),
    onMonthChange: function () {
      function onMonthChange() {}

      return onMonthChange;
    }(),
    onYearChange: function () {
      function onYearChange() {}

      return onYearChange;
    }(),
    onMonthTransitionEnd: function () {
      function onMonthTransitionEnd() {}

      return onMonthTransitionEnd;
    }(),
    renderMonthText: null,
    renderCalendarDay: undefined,
    renderDayContents: null,
    translationValue: null,
    renderMonthElement: null,
    daySize: constants$4.DAY_SIZE,
    focusedDate: null,
    isFocused: false,
    firstDayOfWeek: null,
    setMonthTitleHeight: null,
    isRTL: false,
    transitionDuration: 200,
    verticalBorderSpacing: undefined,
    // i18n
    monthFormat: 'MMMM YYYY',
    // english locale
    phrases: defaultPhrases.CalendarDayPhrases,
    dayAriaLabelFormat: undefined
  };

  function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
    var month = initialMonth.clone();
    if (!withoutTransitionMonths) month = month.subtract(1, 'month');
    var months = [];

    for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
      months.push(month);
      month = month.clone().add(1, 'month');
    }

    return months;
  }

  var CalendarMonthGrid =
  /*#__PURE__*/
  function (_ref) {
    _inherits(CalendarMonthGrid, _ref);

    _createClass(CalendarMonthGrid, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function CalendarMonthGrid(props) {
      var _this;

      _classCallCheck(this, CalendarMonthGrid);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(CalendarMonthGrid).call(this, props));
      var withoutTransitionMonths = props.orientation === constants$4.VERTICAL_SCROLLABLE;
      _this.state = {
        months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
      };
      _this.isTransitionEndSupported = (0, _isTransitionEndSupported["default"])();
      _this.onTransitionEnd = _this.onTransitionEnd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.locale = _moment["default"].locale();
      _this.onMonthSelect = _this.onMonthSelect.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onYearSelect = _this.onYearSelect.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(CalendarMonthGrid, [{
      key: "componentDidMount",
      value: function () {
        function componentDidMount() {
          this.removeEventListener = (0, index_esm.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
        }

        return componentDidMount;
      }()
    }, {
      key: "componentWillReceiveProps",
      value: function () {
        function componentWillReceiveProps(nextProps) {
          var _this2 = this;

          var initialMonth = nextProps.initialMonth,
              numberOfMonths = nextProps.numberOfMonths,
              orientation = nextProps.orientation;
          var months = this.state.months;
          var _this$props = this.props,
              prevInitialMonth = _this$props.initialMonth,
              prevNumberOfMonths = _this$props.numberOfMonths;
          var hasMonthChanged = !prevInitialMonth.isSame(initialMonth, 'month');
          var hasNumberOfMonthsChanged = prevNumberOfMonths !== numberOfMonths;
          var newMonths = months;

          if (hasMonthChanged && !hasNumberOfMonthsChanged) {
            if ((0, _isNextMonth["default"])(prevInitialMonth, initialMonth)) {
              newMonths = months.slice(1);
              newMonths.push(months[months.length - 1].clone().add(1, 'month'));
            } else if ((0, _isPrevMonth["default"])(prevInitialMonth, initialMonth)) {
              newMonths = months.slice(0, months.length - 1);
              newMonths.unshift(months[0].clone().subtract(1, 'month'));
            } else {
              var withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;
              newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
            }
          }

          if (hasNumberOfMonthsChanged) {
            var _withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;

            newMonths = getMonths(initialMonth, numberOfMonths, _withoutTransitionMonths);
          }

          var momentLocale = _moment["default"].locale();

          if (this.locale !== momentLocale) {
            this.locale = momentLocale;
            newMonths = newMonths.map(function (m) {
              return m.locale(_this2.locale);
            });
          }

          this.setState({
            months: newMonths
          });
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: "componentDidUpdate",
      value: function () {
        function componentDidUpdate() {
          var _this$props2 = this.props,
              isAnimating = _this$props2.isAnimating,
              transitionDuration = _this$props2.transitionDuration,
              onMonthTransitionEnd = _this$props2.onMonthTransitionEnd; // For IE9, immediately call onMonthTransitionEnd instead of
          // waiting for the animation to complete. Similarly, if transitionDuration
          // is set to 0, also immediately invoke the onMonthTransitionEnd callback

          if ((!this.isTransitionEndSupported || !transitionDuration) && isAnimating) {
            onMonthTransitionEnd();
          }
        }

        return componentDidUpdate;
      }()
    }, {
      key: "componentWillUnmount",
      value: function () {
        function componentWillUnmount() {
          if (this.removeEventListener) this.removeEventListener();
        }

        return componentWillUnmount;
      }()
    }, {
      key: "onTransitionEnd",
      value: function () {
        function onTransitionEnd() {
          var onMonthTransitionEnd = this.props.onMonthTransitionEnd;
          onMonthTransitionEnd();
        }

        return onTransitionEnd;
      }()
    }, {
      key: "onMonthSelect",
      value: function () {
        function onMonthSelect(currentMonth, newMonthVal) {
          var newMonth = currentMonth.clone();
          var _this$props3 = this.props,
              onMonthChange = _this$props3.onMonthChange,
              orientation = _this$props3.orientation;
          var months = this.state.months;
          var withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;
          var initialMonthSubtraction = months.indexOf(currentMonth);

          if (!withoutTransitionMonths) {
            initialMonthSubtraction -= 1;
          }

          newMonth.set('month', newMonthVal).subtract(initialMonthSubtraction, 'months');
          onMonthChange(newMonth);
        }

        return onMonthSelect;
      }()
    }, {
      key: "onYearSelect",
      value: function () {
        function onYearSelect(currentMonth, newYearVal) {
          var newMonth = currentMonth.clone();
          var _this$props4 = this.props,
              onYearChange = _this$props4.onYearChange,
              orientation = _this$props4.orientation;
          var months = this.state.months;
          var withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;
          var initialMonthSubtraction = months.indexOf(currentMonth);

          if (!withoutTransitionMonths) {
            initialMonthSubtraction -= 1;
          }

          newMonth.set('year', newYearVal).subtract(initialMonthSubtraction, 'months');
          onYearChange(newMonth);
        }

        return onYearSelect;
      }()
    }, {
      key: "setContainerRef",
      value: function () {
        function setContainerRef(ref) {
          this.container = ref;
        }

        return setContainerRef;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this3 = this;

          var _this$props5 = this.props,
              enableOutsideDays = _this$props5.enableOutsideDays,
              firstVisibleMonthIndex = _this$props5.firstVisibleMonthIndex,
              horizontalMonthPadding = _this$props5.horizontalMonthPadding,
              isAnimating = _this$props5.isAnimating,
              modifiers = _this$props5.modifiers,
              numberOfMonths = _this$props5.numberOfMonths,
              monthFormat = _this$props5.monthFormat,
              orientation = _this$props5.orientation,
              translationValue = _this$props5.translationValue,
              daySize = _this$props5.daySize,
              onDayMouseEnter = _this$props5.onDayMouseEnter,
              onDayMouseLeave = _this$props5.onDayMouseLeave,
              onDayClick = _this$props5.onDayClick,
              renderMonthText = _this$props5.renderMonthText,
              renderCalendarDay = _this$props5.renderCalendarDay,
              renderDayContents = _this$props5.renderDayContents,
              renderMonthElement = _this$props5.renderMonthElement,
              onMonthTransitionEnd = _this$props5.onMonthTransitionEnd,
              firstDayOfWeek = _this$props5.firstDayOfWeek,
              focusedDate = _this$props5.focusedDate,
              isFocused = _this$props5.isFocused,
              isRTL = _this$props5.isRTL,
              styles = _this$props5.styles,
              phrases = _this$props5.phrases,
              dayAriaLabelFormat = _this$props5.dayAriaLabelFormat,
              transitionDuration = _this$props5.transitionDuration,
              verticalBorderSpacing = _this$props5.verticalBorderSpacing,
              setMonthTitleHeight = _this$props5.setMonthTitleHeight;
          var months = this.state.months;
          var isVertical = orientation === constants$4.VERTICAL_ORIENTATION;
          var isVerticalScrollable = orientation === constants$4.VERTICAL_SCROLLABLE;
          var isHorizontal = orientation === constants$4.HORIZONTAL_ORIENTATION;
          var calendarMonthWidth = (0, _getCalendarMonthWidth["default"])(daySize, horizontalMonthPadding);
          var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
          var transformType = isVertical || isVerticalScrollable ? 'translateY' : 'translateX';
          var transformValue = "".concat(transformType, "(").concat(translationValue, "px)");
          return _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.CalendarMonthGrid, isHorizontal && styles.CalendarMonthGrid__horizontal, isVertical && styles.CalendarMonthGrid__vertical, isVerticalScrollable && styles.CalendarMonthGrid__vertical_scrollable, isAnimating && styles.CalendarMonthGrid__animating, isAnimating && transitionDuration && {
            transition: "transform ".concat(transitionDuration, "ms ease-in-out")
          }, _objectSpread({}, (0, _getTransformStyles["default"])(transformValue), {
            width: width
          })), {
            ref: this.setContainerRef,
            onTransitionEnd: onMonthTransitionEnd
          }), months.map(function (month, i) {
            var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
            var hideForAnimation = i === 0 && !isVisible;
            var showForAnimation = i === 0 && isAnimating && isVisible;
            var monthString = (0, _toISOMonthString["default"])(month);
            return _react["default"].createElement("div", _extends({
              key: monthString
            }, (0, withStyles_1.css)(isHorizontal && styles.CalendarMonthGrid_month__horizontal, hideForAnimation && styles.CalendarMonthGrid_month__hideForAnimation, showForAnimation && !isVertical && !isRTL && {
              position: 'absolute',
              left: -calendarMonthWidth
            }, showForAnimation && !isVertical && isRTL && {
              position: 'absolute',
              right: 0
            }, showForAnimation && isVertical && {
              position: 'absolute',
              top: -translationValue
            }, !isVisible && !isAnimating && styles.CalendarMonthGrid_month__hidden)), _react["default"].createElement(_CalendarMonth["default"], {
              month: month,
              isVisible: isVisible,
              enableOutsideDays: enableOutsideDays,
              modifiers: modifiers[monthString],
              monthFormat: monthFormat,
              orientation: orientation,
              onDayMouseEnter: onDayMouseEnter,
              onDayMouseLeave: onDayMouseLeave,
              onDayClick: onDayClick,
              onMonthSelect: _this3.onMonthSelect,
              onYearSelect: _this3.onYearSelect,
              renderMonthText: renderMonthText,
              renderCalendarDay: renderCalendarDay,
              renderDayContents: renderDayContents,
              renderMonthElement: renderMonthElement,
              firstDayOfWeek: firstDayOfWeek,
              daySize: daySize,
              focusedDate: isVisible ? focusedDate : null,
              isFocused: isFocused,
              phrases: phrases,
              setMonthTitleHeight: setMonthTitleHeight,
              dayAriaLabelFormat: dayAriaLabelFormat,
              verticalBorderSpacing: verticalBorderSpacing,
              horizontalMonthPadding: horizontalMonthPadding
            }));
          }));
        }

        return render;
      }()
    }]);

    return CalendarMonthGrid;
  }(_react["default"].PureComponent || _react["default"].Component);

  CalendarMonthGrid.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  CalendarMonthGrid.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var _ref2$reactDates = _ref2.reactDates,
        color = _ref2$reactDates.color,
        noScrollBarOnVerticalScrollable = _ref2$reactDates.noScrollBarOnVerticalScrollable,
        spacing = _ref2$reactDates.spacing,
        zIndex = _ref2$reactDates.zIndex;
    return {
      CalendarMonthGrid: {
        background: color.background,
        textAlign: (0, _noflip["default"])('left'),
        zIndex: zIndex
      },
      CalendarMonthGrid__animating: {
        zIndex: zIndex + 1
      },
      CalendarMonthGrid__horizontal: {
        position: 'absolute',
        left: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
      },
      CalendarMonthGrid__vertical: {
        margin: '0 auto'
      },
      CalendarMonthGrid__vertical_scrollable: _objectSpread({
        margin: '0 auto',
        overflowY: 'scroll'
      }, noScrollBarOnVerticalScrollable && {
        '-webkitOverflowScrolling': 'touch',
        '::-webkit-scrollbar': {
          '-webkit-appearance': 'none',
          display: 'none'
        }
      }),
      CalendarMonthGrid_month__horizontal: {
        display: 'inline-block',
        verticalAlign: 'top',
        minHeight: '100%'
      },
      CalendarMonthGrid_month__hideForAnimation: {
        position: 'absolute',
        zIndex: zIndex - 1,
        opacity: 0,
        pointerEvents: 'none'
      },
      CalendarMonthGrid_month__hidden: {
        visibility: 'hidden'
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(CalendarMonthGrid);

  exports["default"] = _default;
});
unwrapExports(CalendarMonthGrid_1);
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var _createClass$5 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$5(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Portal$6 = function (_React$Component) {
  _inherits$5(Portal, _React$Component);

  function Portal() {
    _classCallCheck$5(this, Portal);

    return _possibleConstructorReturn$5(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$5(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }

      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      return ReactDOM__default.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(React__default.Component);

Portal$6.propTypes = {
  children: propTypes$1.node.isRequired,
  node: propTypes$1.any
};

var _createClass$6 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$6(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Portal$7 = function (_React$Component) {
  _inherits$6(Portal, _React$Component);

  function Portal() {
    _classCallCheck$6(this, Portal);

    return _possibleConstructorReturn$6(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$6(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      ReactDOM__default.unmountComponentAtNode(this.defaultNode || this.props.node);

      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }

      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children; // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b

      if (typeof this.props.children.type === 'function') {
        children = React__default.cloneElement(this.props.children);
      }

      this.portal = ReactDOM__default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(React__default.Component);

Portal$7.propTypes = {
  children: propTypes$1.node.isRequired,
  node: propTypes$1.any
};
var Portal$8 = void 0;

if (ReactDOM__default.createPortal) {
  Portal$8 = Portal$6;
} else {
  Portal$8 = Portal$7;
}

var Portal$9 = Portal$8;

var _createClass$7 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$7(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var KEYCODES = {
  ESCAPE: 27
};

var PortalWithState = function (_React$Component) {
  _inherits$7(PortalWithState, _React$Component);

  function PortalWithState(props) {
    _classCallCheck$7(this, PortalWithState);

    var _this = _possibleConstructorReturn$7(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));

    _this.portalNode = null;
    _this.state = {
      active: !!props.defaultOpen
    };
    _this.openPortal = _this.openPortal.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    return _this;
  }

  _createClass$7(PortalWithState, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal(e) {
      if (this.state.active) {
        return;
      }

      if (e && e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }

      this.setState({
        active: true
      }, this.props.onOpen);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (!this.state.active) {
        return;
      }

      this.setState({
        active: false
      }, this.props.onClose);
    }
  }, {
    key: 'wrapWithPortal',
    value: function wrapWithPortal(children) {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }

      return React__default.createElement(Portal$9, {
        node: this.props.node,
        key: 'react-portal',
        ref: function ref(portalNode) {
          return _this2.portalNode = portalNode;
        }
      }, children);
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = this.portalNode.props.node || this.portalNode.defaultNode;

      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]);

  return PortalWithState;
}(React__default.Component);

PortalWithState.propTypes = {
  children: propTypes$1.func.isRequired,
  defaultOpen: propTypes$1.bool,
  node: propTypes$1.any,
  closeOnEsc: propTypes$1.bool,
  closeOnOutsideClick: propTypes$1.bool,
  onOpen: propTypes$1.func,
  onClose: propTypes$1.func
};
PortalWithState.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};
var es =
/*#__PURE__*/
Object.freeze({
  Portal: Portal$9,
  PortalWithState: PortalWithState
});
var build$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = isTouchDevice;

  function isTouchDevice() {
    return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
  }

  module.exports = exports['default'];
});
unwrapExports(build$2);
var isEnumerable$2 = functionBind.call(Function.call, Object.prototype.propertyIsEnumerable);

var implementation$9 = function values(O) {
  var obj = es7.RequireObjectCoercible(O);
  var vals = [];

  for (var key in obj) {
    if (src(obj, key) && isEnumerable$2(obj, key)) {
      vals.push(obj[key]);
    }
  }

  return vals;
};

var polyfill$b = function getPolyfill() {
  return typeof Object.values === 'function' ? Object.values : implementation$9;
};

var shim$5 = function shimValues() {
  var polyfill = polyfill$b();
  defineProperties_1(Object, {
    values: polyfill
  }, {
    values: function testValues() {
      return Object.values !== polyfill;
    }
  });
  return polyfill;
};

var polyfill$c = polyfill$b();
defineProperties_1(polyfill$c, {
  getPolyfill: polyfill$b,
  implementation: implementation$9,
  shim: shim$5
});
var object_values = polyfill$c;

var implementation$a = function contains(other) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument is required');
  }

  if (typeof other !== 'object') {
    throw new TypeError('Argument 1 (”other“) to Node.contains must be an instance of Node');
  }

  var node = other;

  do {
    if (this === node) {
      return true;
    }

    if (node) {
      node = node.parentNode;
    }
  } while (node);

  return false;
};

var polyfill$d = function getPolyfill() {
  if (typeof document !== 'undefined') {
    if (document.contains) {
      return document.contains;
    }

    if (document.body && document.body.contains) {
      return document.body.contains;
    }
  }

  return implementation$a;
};

var shim$6 = function shimContains() {
  var polyfill = polyfill$d();

  if (typeof document !== 'undefined') {
    defineProperties_1(document, {
      contains: polyfill
    }, {
      contains: function contains() {
        return document.contains !== polyfill;
      }
    });

    if (typeof Element !== 'undefined') {
      defineProperties_1(Element.prototype, {
        contains: polyfill
      }, {
        contains: function contains() {
          return Element.prototype.contains !== polyfill;
        }
      });
    }
  }

  return polyfill;
};

var polyfill$e = polyfill$d();

var boundContains = function contains(node, other) {
  return polyfill$e.apply(node, [other]);
};

defineProperties_1(boundContains, {
  getPolyfill: polyfill$d,
  implementation: implementation$a,
  shim: shim$6
});
var document_contains = boundContains;
var OutsideClickHandler_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(propTypes$1);

  var _object2 = _interopRequireDefault(object_values);

  var _document2 = _interopRequireDefault(document_contains);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DISPLAY = {
    BLOCK: 'block',
    FLEX: 'flex',
    INLINE_BLOCK: 'inline-block'
  };
  var propTypes = (0, airbnbPropTypes.forbidExtraProps)({
    children: _propTypes2['default'].node.isRequired,
    onOutsideClick: _propTypes2['default'].func.isRequired,
    disabled: _propTypes2['default'].bool,
    useCapture: _propTypes2['default'].bool,
    display: _propTypes2['default'].oneOf((0, _object2['default'])(DISPLAY))
  });
  var defaultProps = {
    disabled: false,
    // `useCapture` is set to true by default so that a `stopPropagation` in the
    // children will not prevent all outside click handlers from firing - maja
    useCapture: true,
    display: DISPLAY.BLOCK
  };

  var OutsideClickHandler = function (_React$Component) {
    _inherits(OutsideClickHandler, _React$Component);

    function OutsideClickHandler() {
      var _ref;

      _classCallCheck(this, OutsideClickHandler);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));

      _this.onMouseDown = _this.onMouseDown.bind(_this);
      _this.onMouseUp = _this.onMouseUp.bind(_this);
      _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
      return _this;
    }

    _createClass(OutsideClickHandler, [{
      key: 'componentDidMount',
      value: function () {
        function componentDidMount() {
          var _props = this.props,
              disabled = _props.disabled,
              useCapture = _props.useCapture;
          if (!disabled) this.addMouseDownEventListener(useCapture);
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillReceiveProps',
      value: function () {
        function componentWillReceiveProps(_ref2) {
          var disabled = _ref2.disabled,
              useCapture = _ref2.useCapture;
          var prevDisabled = this.props.disabled;

          if (prevDisabled !== disabled) {
            if (disabled) {
              this.removeEventListeners();
            } else {
              this.addMouseDownEventListener(useCapture);
            }
          }
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function () {
        function componentWillUnmount() {
          this.removeEventListeners();
        }

        return componentWillUnmount;
      }() // Use mousedown/mouseup to enforce that clicks remain outside the root's
      // descendant tree, even when dragged. This should also get triggered on
      // touch devices.

    }, {
      key: 'onMouseDown',
      value: function () {
        function onMouseDown(e) {
          var useCapture = this.props.useCapture;
          var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);

          if (!isDescendantOfRoot) {
            if (this.removeMouseUp) {
              this.removeMouseUp();
              this.removeMouseUp = null;
            }

            this.removeMouseUp = (0, index_esm.addEventListener)(document, 'mouseup', this.onMouseUp, {
              capture: useCapture
            });
          }
        }

        return onMouseDown;
      }() // Use mousedown/mouseup to enforce that clicks remain outside the root's
      // descendant tree, even when dragged. This should also get triggered on
      // touch devices.

    }, {
      key: 'onMouseUp',
      value: function () {
        function onMouseUp(e) {
          var onOutsideClick = this.props.onOutsideClick;
          var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);

          if (this.removeMouseUp) {
            this.removeMouseUp();
            this.removeMouseUp = null;
          }

          if (!isDescendantOfRoot) {
            onOutsideClick(e);
          }
        }

        return onMouseUp;
      }()
    }, {
      key: 'setChildNodeRef',
      value: function () {
        function setChildNodeRef(ref) {
          this.childNode = ref;
        }

        return setChildNodeRef;
      }()
    }, {
      key: 'addMouseDownEventListener',
      value: function () {
        function addMouseDownEventListener(useCapture) {
          this.removeMouseDown = (0, index_esm.addEventListener)(document, 'mousedown', this.onMouseDown, {
            capture: useCapture
          });
        }

        return addMouseDownEventListener;
      }()
    }, {
      key: 'removeEventListeners',
      value: function () {
        function removeEventListeners() {
          if (this.removeMouseDown) this.removeMouseDown();
          if (this.removeMouseUp) this.removeMouseUp();
        }

        return removeEventListeners;
      }()
    }, {
      key: 'render',
      value: function () {
        function render() {
          var _props2 = this.props,
              children = _props2.children,
              display = _props2.display;
          return _react2['default'].createElement('div', {
            ref: this.setChildNodeRef,
            style: display !== DISPLAY.BLOCK && (0, _object2['default'])(DISPLAY).includes(display) ? {
              display: display
            } : undefined
          }, children);
        }

        return render;
      }()
    }]);

    return OutsideClickHandler;
  }(_react2['default'].Component);

  exports['default'] = OutsideClickHandler;
  OutsideClickHandler.propTypes = propTypes;
  OutsideClickHandler.defaultProps = defaultProps;
});
unwrapExports(OutsideClickHandler_1); // eslint-disable-next-line import/no-unresolved

var reactOutsideClickHandler = OutsideClickHandler_1;
var FocusedInputShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOf([constants$4.START_DATE, constants$4.END_DATE]);

  exports["default"] = _default;
});
unwrapExports(FocusedInputShape);
var IconPositionShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOf([constants$4.ICON_BEFORE_POSITION, constants$4.ICON_AFTER_POSITION]);

  exports["default"] = _default;
});
unwrapExports(IconPositionShape);
var OrientationShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOf([constants$4.HORIZONTAL_ORIENTATION, constants$4.VERTICAL_ORIENTATION]);

  exports["default"] = _default;
});
unwrapExports(OrientationShape);
var DisabledShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf([constants$4.START_DATE, constants$4.END_DATE])]);

  exports["default"] = _default;
});
unwrapExports(DisabledShape);
var AnchorDirectionShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOf([constants$4.ANCHOR_LEFT, constants$4.ANCHOR_RIGHT]);

  exports["default"] = _default;
});
unwrapExports(AnchorDirectionShape);
var OpenDirectionShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOf([constants$4.OPEN_DOWN, constants$4.OPEN_UP]);

  exports["default"] = _default;
});
unwrapExports(OpenDirectionShape);
var CalendarInfoPositionShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = _propTypes["default"].oneOf([constants$4.INFO_POSITION_TOP, constants$4.INFO_POSITION_BOTTOM, constants$4.INFO_POSITION_BEFORE, constants$4.INFO_POSITION_AFTER]);

  exports["default"] = _default;
});
unwrapExports(CalendarInfoPositionShape);
var DateRangePickerShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _FocusedInputShape = _interopRequireDefault(FocusedInputShape);

  var _IconPositionShape = _interopRequireDefault(IconPositionShape);

  var _OrientationShape = _interopRequireDefault(OrientationShape);

  var _DisabledShape = _interopRequireDefault(DisabledShape);

  var _AnchorDirectionShape = _interopRequireDefault(AnchorDirectionShape);

  var _OpenDirectionShape = _interopRequireDefault(OpenDirectionShape);

  var _DayOfWeekShape = _interopRequireDefault(DayOfWeekShape);

  var _CalendarInfoPositionShape = _interopRequireDefault(CalendarInfoPositionShape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = {
    // required props for a functional interactive DateRangePicker
    startDate: _reactMomentProptypes["default"].momentObj,
    endDate: _reactMomentProptypes["default"].momentObj,
    onDatesChange: _propTypes["default"].func.isRequired,
    focusedInput: _FocusedInputShape["default"],
    onFocusChange: _propTypes["default"].func.isRequired,
    onClose: _propTypes["default"].func,
    // input related props
    startDateId: _propTypes["default"].string.isRequired,
    startDatePlaceholderText: _propTypes["default"].string,
    endDateId: _propTypes["default"].string.isRequired,
    endDatePlaceholderText: _propTypes["default"].string,
    disabled: _DisabledShape["default"],
    required: _propTypes["default"].bool,
    readOnly: _propTypes["default"].bool,
    screenReaderInputMessage: _propTypes["default"].string,
    showClearDates: _propTypes["default"].bool,
    showDefaultInputIcon: _propTypes["default"].bool,
    inputIconPosition: _IconPositionShape["default"],
    customInputIcon: _propTypes["default"].node,
    customArrowIcon: _propTypes["default"].node,
    customCloseIcon: _propTypes["default"].node,
    noBorder: _propTypes["default"].bool,
    block: _propTypes["default"].bool,
    small: _propTypes["default"].bool,
    regular: _propTypes["default"].bool,
    keepFocusOnInput: _propTypes["default"].bool,
    // calendar presentation and interaction related props
    renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    orientation: _OrientationShape["default"],
    anchorDirection: _AnchorDirectionShape["default"],
    openDirection: _OpenDirectionShape["default"],
    horizontalMargin: _propTypes["default"].number,
    withPortal: _propTypes["default"].bool,
    withFullScreenPortal: _propTypes["default"].bool,
    appendToBody: _propTypes["default"].bool,
    disableScroll: _propTypes["default"].bool,
    daySize: airbnbPropTypes.nonNegativeInteger,
    isRTL: _propTypes["default"].bool,
    firstDayOfWeek: _DayOfWeekShape["default"],
    initialVisibleMonth: _propTypes["default"].func,
    numberOfMonths: _propTypes["default"].number,
    keepOpenOnDateSelect: _propTypes["default"].bool,
    reopenPickerOnClearDates: _propTypes["default"].bool,
    renderCalendarInfo: _propTypes["default"].func,
    calendarInfoPosition: _CalendarInfoPositionShape["default"],
    hideKeyboardShortcutsPanel: _propTypes["default"].bool,
    verticalHeight: airbnbPropTypes.nonNegativeInteger,
    transitionDuration: airbnbPropTypes.nonNegativeInteger,
    verticalSpacing: airbnbPropTypes.nonNegativeInteger,
    horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
    // navigation related props
    navPrev: _propTypes["default"].node,
    navNext: _propTypes["default"].node,
    onPrevMonthClick: _propTypes["default"].func,
    onNextMonthClick: _propTypes["default"].func,
    // day presentation and interaction related props
    renderCalendarDay: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    minimumNights: _propTypes["default"].number,
    enableOutsideDays: _propTypes["default"].bool,
    isDayBlocked: _propTypes["default"].func,
    isOutsideRange: _propTypes["default"].func,
    isDayHighlighted: _propTypes["default"].func,
    // internationalization props
    displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
    monthFormat: _propTypes["default"].string,
    weekDayFormat: _propTypes["default"].string,
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerPhrases)),
    dayAriaLabelFormat: _propTypes["default"].string
  };
  exports["default"] = _default;
});
unwrapExports(DateRangePickerShape);
var getResponsiveContainerStyles_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getResponsiveContainerStyles;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
    var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
    var calculatedOffset = anchorDirection === constants$4.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
    var calculatedMargin = margin || 0;
    return _defineProperty({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
  }
});
unwrapExports(getResponsiveContainerStyles_1);
var getDetachedContainerStyles_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getDetachedContainerStyles;
  /**
   * Calculate and return a CSS transform style to position a detached element
   * next to a reference element. The open and anchor direction indicate wether
   * it should be positioned above/below and/or to the left/right of the
   * reference element.
   *
   * Assuming r(0,0), r(1,1), d(0,0), d(1,1) for the bottom-left and top-right
   * corners of the reference and detached elements, respectively:
   *  - openDirection = DOWN, anchorDirection = LEFT => d(0,1) == r(0,1)
   *  - openDirection = UP, anchorDirection = LEFT => d(0,0) == r(0,0)
   *  - openDirection = DOWN, anchorDirection = RIGHT => d(1,1) == r(1,1)
   *  - openDirection = UP, anchorDirection = RIGHT => d(1,0) == r(1,0)
   *
   * By using a CSS transform, we allow to further position it using
   * top/bottom CSS properties for the anchor gutter.
   *
   * @param {string} openDirection The vertical positioning of the popup
   * @param {string} anchorDirection The horizontal position of the popup
   * @param {HTMLElement} referenceEl The reference element
   */

  function getDetachedContainerStyles(openDirection, anchorDirection, referenceEl) {
    var referenceRect = referenceEl.getBoundingClientRect();
    var offsetX = referenceRect.left;
    var offsetY = referenceRect.top;

    if (openDirection === constants$4.OPEN_UP) {
      offsetY = -(window.innerHeight - referenceRect.bottom);
    }

    if (anchorDirection === constants$4.ANCHOR_RIGHT) {
      offsetX = -(window.innerWidth - referenceRect.right);
    }

    return {
      transform: "translate3d(".concat(Math.round(offsetX), "px, ").concat(Math.round(offsetY), "px, 0)")
    };
  }
});
unwrapExports(getDetachedContainerStyles_1);
var getInputHeight_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getInputHeight;
  /* eslint-disable camelcase */

  function getPadding(vertical, top, bottom) {
    var isTopDefined = typeof top === 'number';
    var isBottomDefined = typeof bottom === 'number';
    var isVerticalDefined = typeof vertical === 'number';

    if (isTopDefined && isBottomDefined) {
      return top + bottom;
    }

    if (isTopDefined && isVerticalDefined) {
      return top + vertical;
    }

    if (isTopDefined) {
      return top;
    }

    if (isBottomDefined && isVerticalDefined) {
      return bottom + vertical;
    }

    if (isBottomDefined) {
      return bottom;
    }

    if (isVerticalDefined) {
      return 2 * vertical;
    }

    return 0;
  }

  function getInputHeight(_ref, small) {
    var _ref$font$input = _ref.font.input,
        lineHeight = _ref$font$input.lineHeight,
        lineHeight_small = _ref$font$input.lineHeight_small,
        _ref$spacing = _ref.spacing,
        inputPadding = _ref$spacing.inputPadding,
        displayTextPaddingVertical = _ref$spacing.displayTextPaddingVertical,
        displayTextPaddingTop = _ref$spacing.displayTextPaddingTop,
        displayTextPaddingBottom = _ref$spacing.displayTextPaddingBottom,
        displayTextPaddingVertical_small = _ref$spacing.displayTextPaddingVertical_small,
        displayTextPaddingTop_small = _ref$spacing.displayTextPaddingTop_small,
        displayTextPaddingBottom_small = _ref$spacing.displayTextPaddingBottom_small;
    var calcLineHeight = small ? lineHeight_small : lineHeight;
    var padding = small ? getPadding(displayTextPaddingVertical_small, displayTextPaddingTop_small, displayTextPaddingBottom_small) : getPadding(displayTextPaddingVertical, displayTextPaddingTop, displayTextPaddingBottom);
    return parseInt(calcLineHeight, 10) + 2 * inputPadding + padding;
  }
});
unwrapExports(getInputHeight_1);
var isBeforeDay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isBeforeDay;

  var _moment = _interopRequireDefault(moment);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isBeforeDay(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
    var aYear = a.year();
    var aMonth = a.month();
    var bYear = b.year();
    var bMonth = b.month();
    var isSameYear = aYear === bYear;
    var isSameMonth = aMonth === bMonth;
    if (isSameYear && isSameMonth) return a.date() < b.date();
    if (isSameYear) return aMonth < bMonth;
    return aYear < bYear;
  }
});
unwrapExports(isBeforeDay_1);
var isInclusivelyAfterDay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isInclusivelyAfterDay;

  var _moment = _interopRequireDefault(moment);

  var _isBeforeDay = _interopRequireDefault(isBeforeDay_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isInclusivelyAfterDay(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
    return !(0, _isBeforeDay["default"])(a, b);
  }
});
unwrapExports(isInclusivelyAfterDay_1);
var disableScroll_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getScrollParent = getScrollParent;
  exports.getScrollAncestorsOverflowY = getScrollAncestorsOverflowY;
  exports["default"] = disableScroll;

  var getScrollingRoot = function getScrollingRoot() {
    return document.scrollingElement || document.documentElement;
  };
  /**
   * Recursively finds the scroll parent of a node. The scroll parrent of a node
   * is the closest node that is scrollable. A node is scrollable if:
   *  - it is allowed to scroll via CSS ('overflow-y' not visible or hidden);
   *  - and its children/content are "bigger" than the node's box height.
   *
   * The root of the document always scrolls by default.
   *
   * @param {HTMLElement} node Any DOM element.
   * @return {HTMLElement} The scroll parent element.
   */


  function getScrollParent(node) {
    var parent = node.parentElement;
    if (parent == null) return getScrollingRoot();

    var _window$getComputedSt = window.getComputedStyle(parent),
        overflowY = _window$getComputedSt.overflowY;

    var canScroll = overflowY !== 'visible' && overflowY !== 'hidden';

    if (canScroll && parent.scrollHeight > parent.clientHeight) {
      return parent;
    }

    return getScrollParent(parent);
  }
  /**
   * Recursively traverses the tree upwards from the given node, capturing all
   * ancestor nodes that scroll along with their current 'overflow-y' CSS
   * property.
   *
   * @param {HTMLElement} node Any DOM element.
   * @param {Map<HTMLElement,string>} [acc] Accumulator map.
   * @return {Map<HTMLElement,string>} Map of ancestors with their 'overflow-y' value.
   */


  function getScrollAncestorsOverflowY(node) {
    var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
    var scrollingRoot = getScrollingRoot();
    var scrollParent = getScrollParent(node);
    acc.set(scrollParent, scrollParent.style.overflowY);
    if (scrollParent === scrollingRoot) return acc;
    return getScrollAncestorsOverflowY(scrollParent, acc);
  }
  /**
   * Disabling the scroll on a node involves finding all the scrollable ancestors
   * and set their 'overflow-y' CSS property to 'hidden'. When all ancestors have
   * 'overflow-y: hidden' (up to the document element) there is no scroll
   * container, thus all the scroll outside of the node is disabled. In order to
   * enable scroll again, we store the previous value of the 'overflow-y' for
   * every ancestor in a closure and reset it back.
   *
   * @param {HTMLElement} node Any DOM element.
   */


  function disableScroll(node) {
    var scrollAncestorsOverflowY = getScrollAncestorsOverflowY(node);

    var toggle = function toggle(on) {
      return scrollAncestorsOverflowY.forEach(function (overflowY, ancestor) {
        ancestor.style.setProperty('overflow-y', on ? 'hidden' : overflowY);
      });
    };

    toggle(true);
    return function () {
      return toggle(false);
    };
  }
});
unwrapExports(disableScroll_1);
var disableScroll_2 = disableScroll_1.getScrollParent;
var disableScroll_3 = disableScroll_1.getScrollAncestorsOverflowY;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$2 = _freeGlobal || freeSelf || Function('return this')();
var _root = root$2;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now = function now() {
  return _root.Date.now();
};

var now_1 = now;
/** Built-in value references. */

var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

var _getRawTag = getRawTag;
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol$2(value) {
  return typeof value == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag;
}

var isSymbol_1 = isSymbol$2;
/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */

var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol_1(value)) {
    return NAN;
  }

  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var toNumber_1 = toNumber;
/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max,
    nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */

function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  wait = toNumber_1(wait) || 0;

  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now_1();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;
/** Error message constants. */

var FUNC_ERROR_TEXT$1 = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */

function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }

  if (isObject_1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  return debounce_1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;
var DateInput_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _throttle = _interopRequireDefault(throttle_1);

  var _isTouchDevice = _interopRequireDefault(build$2);

  var _noflip = _interopRequireDefault(noflip_1);

  var _getInputHeight = _interopRequireDefault(getInputHeight_1);

  var _OpenDirectionShape = _interopRequireDefault(OpenDirectionShape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var FANG_PATH_TOP = "M0,".concat(constants$4.FANG_HEIGHT_PX, " ").concat(constants$4.FANG_WIDTH_PX, ",").concat(constants$4.FANG_HEIGHT_PX, " ").concat(constants$4.FANG_WIDTH_PX / 2, ",0z");
  var FANG_STROKE_TOP = "M0,".concat(constants$4.FANG_HEIGHT_PX, " ").concat(constants$4.FANG_WIDTH_PX / 2, ",0 ").concat(constants$4.FANG_WIDTH_PX, ",").concat(constants$4.FANG_HEIGHT_PX);
  var FANG_PATH_BOTTOM = "M0,0 ".concat(constants$4.FANG_WIDTH_PX, ",0 ").concat(constants$4.FANG_WIDTH_PX / 2, ",").concat(constants$4.FANG_HEIGHT_PX, "z");
  var FANG_STROKE_BOTTOM = "M0,0 ".concat(constants$4.FANG_WIDTH_PX / 2, ",").concat(constants$4.FANG_HEIGHT_PX, " ").concat(constants$4.FANG_WIDTH_PX, ",0");
  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    id: _propTypes["default"].string.isRequired,
    placeholder: _propTypes["default"].string,
    // also used as label
    displayValue: _propTypes["default"].string,
    screenReaderMessage: _propTypes["default"].string,
    focused: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool,
    required: _propTypes["default"].bool,
    readOnly: _propTypes["default"].bool,
    openDirection: _OpenDirectionShape["default"],
    showCaret: _propTypes["default"].bool,
    verticalSpacing: airbnbPropTypes.nonNegativeInteger,
    small: _propTypes["default"].bool,
    block: _propTypes["default"].bool,
    regular: _propTypes["default"].bool,
    onChange: _propTypes["default"].func,
    onFocus: _propTypes["default"].func,
    onKeyDownShiftTab: _propTypes["default"].func,
    onKeyDownTab: _propTypes["default"].func,
    onKeyDownArrowDown: _propTypes["default"].func,
    onKeyDownQuestionMark: _propTypes["default"].func,
    // accessibility
    isFocused: _propTypes["default"].bool // describes actual DOM focus

  })) : {};
  var defaultProps = {
    placeholder: 'Select Date',
    displayValue: '',
    screenReaderMessage: '',
    focused: false,
    disabled: false,
    required: false,
    readOnly: null,
    openDirection: constants$4.OPEN_DOWN,
    showCaret: false,
    verticalSpacing: constants$4.DEFAULT_VERTICAL_SPACING,
    small: false,
    block: false,
    regular: false,
    onChange: function () {
      function onChange() {}

      return onChange;
    }(),
    onFocus: function () {
      function onFocus() {}

      return onFocus;
    }(),
    onKeyDownShiftTab: function () {
      function onKeyDownShiftTab() {}

      return onKeyDownShiftTab;
    }(),
    onKeyDownTab: function () {
      function onKeyDownTab() {}

      return onKeyDownTab;
    }(),
    onKeyDownArrowDown: function () {
      function onKeyDownArrowDown() {}

      return onKeyDownArrowDown;
    }(),
    onKeyDownQuestionMark: function () {
      function onKeyDownQuestionMark() {}

      return onKeyDownQuestionMark;
    }(),
    // accessibility
    isFocused: false
  };

  var DateInput =
  /*#__PURE__*/
  function (_ref) {
    _inherits(DateInput, _ref);

    _createClass(DateInput, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function DateInput(props) {
      var _this;

      _classCallCheck(this, DateInput);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DateInput).call(this, props));
      _this.state = {
        dateString: '',
        isTouchDevice: false
      };
      _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setInputRef = _this.setInputRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 300, {
        trailing: false
      });
      return _this;
    }

    _createClass(DateInput, [{
      key: "componentDidMount",
      value: function () {
        function componentDidMount() {
          this.setState({
            isTouchDevice: (0, _isTouchDevice["default"])()
          });
        }

        return componentDidMount;
      }()
    }, {
      key: "componentWillReceiveProps",
      value: function () {
        function componentWillReceiveProps(nextProps) {
          var dateString = this.state.dateString;

          if (dateString && nextProps.displayValue) {
            this.setState({
              dateString: ''
            });
          }
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: "componentDidUpdate",
      value: function () {
        function componentDidUpdate(prevProps) {
          var _this$props = this.props,
              focused = _this$props.focused,
              isFocused = _this$props.isFocused;
          if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;

          if (focused && isFocused) {
            this.inputRef.focus();
          }
        }

        return componentDidUpdate;
      }()
    }, {
      key: "onChange",
      value: function () {
        function onChange(e) {
          var _this$props2 = this.props,
              onChange = _this$props2.onChange,
              onKeyDownQuestionMark = _this$props2.onKeyDownQuestionMark;
          var dateString = e.target.value; // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
          // special case the `?` key so that it always triggers the appropriate callback, instead of
          // modifying the input value

          if (dateString[dateString.length - 1] === '?') {
            onKeyDownQuestionMark(e);
          } else {
            this.setState({
              dateString: dateString
            }, function () {
              return onChange(dateString);
            });
          }
        }

        return onChange;
      }()
    }, {
      key: "onKeyDown",
      value: function () {
        function onKeyDown(e) {
          e.stopPropagation();

          if (!constants$4.MODIFIER_KEY_NAMES.has(e.key)) {
            this.throttledKeyDown(e);
          }
        }

        return onKeyDown;
      }()
    }, {
      key: "onFinalKeyDown",
      value: function () {
        function onFinalKeyDown(e) {
          var _this$props3 = this.props,
              onKeyDownShiftTab = _this$props3.onKeyDownShiftTab,
              onKeyDownTab = _this$props3.onKeyDownTab,
              onKeyDownArrowDown = _this$props3.onKeyDownArrowDown,
              onKeyDownQuestionMark = _this$props3.onKeyDownQuestionMark;
          var key = e.key;

          if (key === 'Tab') {
            if (e.shiftKey) {
              onKeyDownShiftTab(e);
            } else {
              onKeyDownTab(e);
            }
          } else if (key === 'ArrowDown') {
            onKeyDownArrowDown(e);
          } else if (key === '?') {
            e.preventDefault();
            onKeyDownQuestionMark(e);
          }
        }

        return onFinalKeyDown;
      }()
    }, {
      key: "setInputRef",
      value: function () {
        function setInputRef(ref) {
          this.inputRef = ref;
        }

        return setInputRef;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$state = this.state,
              dateString = _this$state.dateString,
              isTouch = _this$state.isTouchDevice;
          var _this$props4 = this.props,
              id = _this$props4.id,
              placeholder = _this$props4.placeholder,
              displayValue = _this$props4.displayValue,
              screenReaderMessage = _this$props4.screenReaderMessage,
              focused = _this$props4.focused,
              showCaret = _this$props4.showCaret,
              onFocus = _this$props4.onFocus,
              disabled = _this$props4.disabled,
              required = _this$props4.required,
              readOnly = _this$props4.readOnly,
              openDirection = _this$props4.openDirection,
              verticalSpacing = _this$props4.verticalSpacing,
              small = _this$props4.small,
              regular = _this$props4.regular,
              block = _this$props4.block,
              styles = _this$props4.styles,
              reactDates = _this$props4.theme.reactDates;
          var value = dateString || displayValue || '';
          var screenReaderMessageId = "DateInput__screen-reader-message-".concat(id);
          var withFang = showCaret && focused;
          var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
          return _react["default"].createElement("div", (0, withStyles_1.css)(styles.DateInput, small && styles.DateInput__small, block && styles.DateInput__block, withFang && styles.DateInput__withFang, disabled && styles.DateInput__disabled, withFang && openDirection === constants$4.OPEN_DOWN && styles.DateInput__openDown, withFang && openDirection === constants$4.OPEN_UP && styles.DateInput__openUp), _react["default"].createElement("input", _extends({}, (0, withStyles_1.css)(styles.DateInput_input, small && styles.DateInput_input__small, regular && styles.DateInput_input__regular, readOnly && styles.DateInput_input__readOnly, focused && styles.DateInput_input__focused, disabled && styles.DateInput_input__disabled), {
            "aria-label": placeholder,
            type: "text",
            id: id,
            name: id,
            ref: this.setInputRef,
            value: value,
            onChange: this.onChange,
            onKeyDown: this.onKeyDown,
            onFocus: onFocus,
            placeholder: placeholder,
            autoComplete: "off",
            disabled: disabled,
            readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
            required: required,
            "aria-describedby": screenReaderMessage && screenReaderMessageId
          })), withFang && _react["default"].createElement("svg", _extends({
            role: "presentation",
            focusable: "false"
          }, (0, withStyles_1.css)(styles.DateInput_fang, openDirection === constants$4.OPEN_DOWN && {
            top: inputHeight + verticalSpacing - constants$4.FANG_HEIGHT_PX - 1
          }, openDirection === constants$4.OPEN_UP && {
            bottom: inputHeight + verticalSpacing - constants$4.FANG_HEIGHT_PX - 1
          })), _react["default"].createElement("path", _extends({}, (0, withStyles_1.css)(styles.DateInput_fangShape), {
            d: openDirection === constants$4.OPEN_DOWN ? FANG_PATH_TOP : FANG_PATH_BOTTOM
          })), _react["default"].createElement("path", _extends({}, (0, withStyles_1.css)(styles.DateInput_fangStroke), {
            d: openDirection === constants$4.OPEN_DOWN ? FANG_STROKE_TOP : FANG_STROKE_BOTTOM
          }))), screenReaderMessage && _react["default"].createElement("p", _extends({}, (0, withStyles_1.css)(styles.DateInput_screenReaderMessage), {
            id: screenReaderMessageId
          }), screenReaderMessage));
        }

        return render;
      }()
    }]);

    return DateInput;
  }(_react["default"].PureComponent || _react["default"].Component);

  DateInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DateInput.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var _ref2$reactDates = _ref2.reactDates,
        border = _ref2$reactDates.border,
        color = _ref2$reactDates.color,
        sizing = _ref2$reactDates.sizing,
        spacing = _ref2$reactDates.spacing,
        font = _ref2$reactDates.font,
        zIndex = _ref2$reactDates.zIndex;
    return {
      DateInput: {
        margin: 0,
        padding: spacing.inputPadding,
        background: color.background,
        position: 'relative',
        display: 'inline-block',
        width: sizing.inputWidth,
        verticalAlign: 'middle'
      },
      DateInput__small: {
        width: sizing.inputWidth_small
      },
      DateInput__block: {
        width: '100%'
      },
      DateInput__disabled: {
        background: color.disabled,
        color: color.textDisabled
      },
      DateInput_input: {
        fontWeight: 200,
        fontSize: font.input.size,
        lineHeight: font.input.lineHeight,
        color: color.text,
        backgroundColor: color.background,
        width: '100%',
        padding: "".concat(spacing.displayTextPaddingVertical, "px ").concat(spacing.displayTextPaddingHorizontal, "px"),
        paddingTop: spacing.displayTextPaddingTop,
        paddingBottom: spacing.displayTextPaddingBottom,
        paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft),
        paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight),
        border: border.input.border,
        borderTop: border.input.borderTop,
        borderRight: (0, _noflip["default"])(border.input.borderRight),
        borderBottom: border.input.borderBottom,
        borderLeft: (0, _noflip["default"])(border.input.borderLeft),
        borderRadius: border.input.borderRadius
      },
      DateInput_input__small: {
        fontSize: font.input.size_small,
        lineHeight: font.input.lineHeight_small,
        letterSpacing: font.input.letterSpacing_small,
        padding: "".concat(spacing.displayTextPaddingVertical_small, "px ").concat(spacing.displayTextPaddingHorizontal_small, "px"),
        paddingTop: spacing.displayTextPaddingTop_small,
        paddingBottom: spacing.displayTextPaddingBottom_small,
        paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft_small),
        paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight_small)
      },
      DateInput_input__regular: {
        fontWeight: 'auto'
      },
      DateInput_input__readOnly: {
        userSelect: 'none'
      },
      DateInput_input__focused: {
        outline: border.input.outlineFocused,
        background: color.backgroundFocused,
        border: border.input.borderFocused,
        borderTop: border.input.borderTopFocused,
        borderRight: (0, _noflip["default"])(border.input.borderRightFocused),
        borderBottom: border.input.borderBottomFocused,
        borderLeft: (0, _noflip["default"])(border.input.borderLeftFocused)
      },
      DateInput_input__disabled: {
        background: color.disabled,
        fontStyle: font.input.styleDisabled
      },
      DateInput_screenReaderMessage: {
        border: 0,
        clip: 'rect(0, 0, 0, 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: 1
      },
      DateInput_fang: {
        position: 'absolute',
        width: constants$4.FANG_WIDTH_PX,
        height: constants$4.FANG_HEIGHT_PX,
        left: 22,
        // TODO: should be noflip wrapped and handled by an isRTL prop
        zIndex: zIndex + 2
      },
      DateInput_fangShape: {
        fill: color.background
      },
      DateInput_fangStroke: {
        stroke: color.core.border,
        fill: 'transparent'
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(DateInput);

  exports["default"] = _default;
});
unwrapExports(DateInput_1);
var RightArrow_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var RightArrow = function () {
    function RightArrow(props) {
      return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
        d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"
      }));
    }

    return RightArrow;
  }();

  RightArrow.defaultProps = {
    focusable: "false",
    viewBox: "0 0 1000 1000"
  };
  var _default = RightArrow;
  exports["default"] = _default;
});
unwrapExports(RightArrow_1);
var LeftArrow_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var LeftArrow = function () {
    function LeftArrow(props) {
      return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
        d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z"
      }));
    }

    return LeftArrow;
  }();

  LeftArrow.defaultProps = {
    focusable: "false",
    viewBox: "0 0 1000 1000"
  };
  var _default = LeftArrow;
  exports["default"] = _default;
});
unwrapExports(LeftArrow_1);
var CloseButton_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var CloseButton = function () {
    function CloseButton(props) {
      return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"
      }));
    }

    return CloseButton;
  }();

  CloseButton.defaultProps = {
    focusable: "false",
    viewBox: "0 0 12 12"
  };
  var _default = CloseButton;
  exports["default"] = _default;
});
unwrapExports(CloseButton_1);
var CalendarIcon_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var CalendarIcon = function () {
    function CalendarIcon(props) {
      return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
        d: "M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z"
      }));
    }

    return CalendarIcon;
  }();

  CalendarIcon.defaultProps = {
    focusable: "false",
    viewBox: "0 0 1393.1 1500"
  };
  var _default = CalendarIcon;
  exports["default"] = _default;
});
unwrapExports(CalendarIcon_1);
var DateRangePickerInput_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _noflip = _interopRequireDefault(noflip_1);

  var _OpenDirectionShape = _interopRequireDefault(OpenDirectionShape);

  var _DateInput = _interopRequireDefault(DateInput_1);

  var _IconPositionShape = _interopRequireDefault(IconPositionShape);

  var _DisabledShape = _interopRequireDefault(DisabledShape);

  var _RightArrow = _interopRequireDefault(RightArrow_1);

  var _LeftArrow = _interopRequireDefault(LeftArrow_1);

  var _CloseButton = _interopRequireDefault(CloseButton_1);

  var _CalendarIcon = _interopRequireDefault(CalendarIcon_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    children: _propTypes["default"].node,
    startDateId: _propTypes["default"].string,
    startDatePlaceholderText: _propTypes["default"].string,
    screenReaderMessage: _propTypes["default"].string,
    endDateId: _propTypes["default"].string,
    endDatePlaceholderText: _propTypes["default"].string,
    onStartDateFocus: _propTypes["default"].func,
    onEndDateFocus: _propTypes["default"].func,
    onStartDateChange: _propTypes["default"].func,
    onEndDateChange: _propTypes["default"].func,
    onStartDateShiftTab: _propTypes["default"].func,
    onEndDateTab: _propTypes["default"].func,
    onClearDates: _propTypes["default"].func,
    onKeyDownArrowDown: _propTypes["default"].func,
    onKeyDownQuestionMark: _propTypes["default"].func,
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string,
    isStartDateFocused: _propTypes["default"].bool,
    isEndDateFocused: _propTypes["default"].bool,
    showClearDates: _propTypes["default"].bool,
    disabled: _DisabledShape["default"],
    required: _propTypes["default"].bool,
    readOnly: _propTypes["default"].bool,
    openDirection: _OpenDirectionShape["default"],
    showCaret: _propTypes["default"].bool,
    showDefaultInputIcon: _propTypes["default"].bool,
    inputIconPosition: _IconPositionShape["default"],
    customInputIcon: _propTypes["default"].node,
    customArrowIcon: _propTypes["default"].node,
    customCloseIcon: _propTypes["default"].node,
    noBorder: _propTypes["default"].bool,
    block: _propTypes["default"].bool,
    small: _propTypes["default"].bool,
    regular: _propTypes["default"].bool,
    verticalSpacing: airbnbPropTypes.nonNegativeInteger,
    // accessibility
    isFocused: _propTypes["default"].bool,
    // describes actual DOM focus
    // i18n
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerInputPhrases)),
    isRTL: _propTypes["default"].bool
  })) : {};
  var defaultProps = {
    children: null,
    startDateId: constants$4.START_DATE,
    endDateId: constants$4.END_DATE,
    startDatePlaceholderText: 'Start Date',
    endDatePlaceholderText: 'End Date',
    screenReaderMessage: '',
    onStartDateFocus: function () {
      function onStartDateFocus() {}

      return onStartDateFocus;
    }(),
    onEndDateFocus: function () {
      function onEndDateFocus() {}

      return onEndDateFocus;
    }(),
    onStartDateChange: function () {
      function onStartDateChange() {}

      return onStartDateChange;
    }(),
    onEndDateChange: function () {
      function onEndDateChange() {}

      return onEndDateChange;
    }(),
    onStartDateShiftTab: function () {
      function onStartDateShiftTab() {}

      return onStartDateShiftTab;
    }(),
    onEndDateTab: function () {
      function onEndDateTab() {}

      return onEndDateTab;
    }(),
    onClearDates: function () {
      function onClearDates() {}

      return onClearDates;
    }(),
    onKeyDownArrowDown: function () {
      function onKeyDownArrowDown() {}

      return onKeyDownArrowDown;
    }(),
    onKeyDownQuestionMark: function () {
      function onKeyDownQuestionMark() {}

      return onKeyDownQuestionMark;
    }(),
    startDate: '',
    endDate: '',
    isStartDateFocused: false,
    isEndDateFocused: false,
    showClearDates: false,
    disabled: false,
    required: false,
    readOnly: false,
    openDirection: constants$4.OPEN_DOWN,
    showCaret: false,
    showDefaultInputIcon: false,
    inputIconPosition: constants$4.ICON_BEFORE_POSITION,
    customInputIcon: null,
    customArrowIcon: null,
    customCloseIcon: null,
    noBorder: false,
    block: false,
    small: false,
    regular: false,
    verticalSpacing: undefined,
    // accessibility
    isFocused: false,
    // i18n
    phrases: defaultPhrases.DateRangePickerInputPhrases,
    isRTL: false
  };

  function DateRangePickerInput(_ref) {
    var children = _ref.children,
        startDate = _ref.startDate,
        startDateId = _ref.startDateId,
        startDatePlaceholderText = _ref.startDatePlaceholderText,
        screenReaderMessage = _ref.screenReaderMessage,
        isStartDateFocused = _ref.isStartDateFocused,
        onStartDateChange = _ref.onStartDateChange,
        onStartDateFocus = _ref.onStartDateFocus,
        onStartDateShiftTab = _ref.onStartDateShiftTab,
        endDate = _ref.endDate,
        endDateId = _ref.endDateId,
        endDatePlaceholderText = _ref.endDatePlaceholderText,
        isEndDateFocused = _ref.isEndDateFocused,
        onEndDateChange = _ref.onEndDateChange,
        onEndDateFocus = _ref.onEndDateFocus,
        onEndDateTab = _ref.onEndDateTab,
        onKeyDownArrowDown = _ref.onKeyDownArrowDown,
        onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
        onClearDates = _ref.onClearDates,
        showClearDates = _ref.showClearDates,
        disabled = _ref.disabled,
        required = _ref.required,
        readOnly = _ref.readOnly,
        showCaret = _ref.showCaret,
        openDirection = _ref.openDirection,
        showDefaultInputIcon = _ref.showDefaultInputIcon,
        inputIconPosition = _ref.inputIconPosition,
        customInputIcon = _ref.customInputIcon,
        customArrowIcon = _ref.customArrowIcon,
        customCloseIcon = _ref.customCloseIcon,
        isFocused = _ref.isFocused,
        phrases = _ref.phrases,
        isRTL = _ref.isRTL,
        noBorder = _ref.noBorder,
        block = _ref.block,
        verticalSpacing = _ref.verticalSpacing,
        small = _ref.small,
        regular = _ref.regular,
        styles = _ref.styles;

    var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_calendarIcon_svg));

    var arrowIcon = customArrowIcon || _react["default"].createElement(_RightArrow["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_arrow_svg));

    if (isRTL) arrowIcon = _react["default"].createElement(_LeftArrow["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_arrow_svg));
    if (small) arrowIcon = '-';

    var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_clearDates_svg, small && styles.DateRangePickerInput_clearDates_svg__small));

    var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;

    var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", _extends({}, (0, withStyles_1.css)(styles.DateRangePickerInput_calendarIcon), {
      type: "button",
      disabled: disabled,
      "aria-label": phrases.focusStartDate,
      onClick: onKeyDownArrowDown
    }), calendarIcon);

    var startDateDisabled = disabled === constants$4.START_DATE || disabled === true;
    var endDateDisabled = disabled === constants$4.END_DATE || disabled === true;
    return _react["default"].createElement("div", (0, withStyles_1.css)(styles.DateRangePickerInput, disabled && styles.DateRangePickerInput__disabled, isRTL && styles.DateRangePickerInput__rtl, !noBorder && styles.DateRangePickerInput__withBorder, block && styles.DateRangePickerInput__block, showClearDates && styles.DateRangePickerInput__showClearDates), inputIconPosition === constants$4.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
      id: startDateId,
      placeholder: startDatePlaceholderText,
      displayValue: startDate,
      screenReaderMessage: screenReaderText,
      focused: isStartDateFocused,
      isFocused: isFocused,
      disabled: startDateDisabled,
      required: required,
      readOnly: readOnly,
      showCaret: showCaret,
      openDirection: openDirection,
      onChange: onStartDateChange,
      onFocus: onStartDateFocus,
      onKeyDownShiftTab: onStartDateShiftTab,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      verticalSpacing: verticalSpacing,
      small: small,
      regular: regular
    }), _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.DateRangePickerInput_arrow), {
      "aria-hidden": "true",
      role: "presentation"
    }), arrowIcon), isStartDateFocused && children, _react["default"].createElement(_DateInput["default"], {
      id: endDateId,
      placeholder: endDatePlaceholderText,
      displayValue: endDate,
      screenReaderMessage: screenReaderText,
      focused: isEndDateFocused,
      isFocused: isFocused,
      disabled: endDateDisabled,
      required: required,
      readOnly: readOnly,
      showCaret: showCaret,
      openDirection: openDirection,
      onChange: onEndDateChange,
      onFocus: onEndDateFocus,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      onKeyDownTab: onEndDateTab,
      verticalSpacing: verticalSpacing,
      small: small,
      regular: regular
    }), isEndDateFocused && children, showClearDates && _react["default"].createElement("button", _extends({
      type: "button",
      "aria-label": phrases.clearDates
    }, (0, withStyles_1.css)(styles.DateRangePickerInput_clearDates, small && styles.DateRangePickerInput_clearDates__small, !customCloseIcon && styles.DateRangePickerInput_clearDates_default, !(startDate || endDate) && styles.DateRangePickerInput_clearDates__hide), {
      onClick: onClearDates,
      disabled: disabled
    }), closeIcon), inputIconPosition === constants$4.ICON_AFTER_POSITION && inputIcon);
  }

  DateRangePickerInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DateRangePickerInput.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var _ref2$reactDates = _ref2.reactDates,
        border = _ref2$reactDates.border,
        color = _ref2$reactDates.color,
        sizing = _ref2$reactDates.sizing;
    return {
      DateRangePickerInput: {
        backgroundColor: color.background,
        display: 'inline-block'
      },
      DateRangePickerInput__disabled: {
        background: color.disabled
      },
      DateRangePickerInput__withBorder: {
        borderColor: color.border,
        borderWidth: border.pickerInput.borderWidth,
        borderStyle: border.pickerInput.borderStyle,
        borderRadius: border.pickerInput.borderRadius
      },
      DateRangePickerInput__rtl: {
        direction: (0, _noflip["default"])('rtl')
      },
      DateRangePickerInput__block: {
        display: 'block'
      },
      DateRangePickerInput__showClearDates: {
        paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop

      },
      DateRangePickerInput_arrow: {
        display: 'inline-block',
        verticalAlign: 'middle',
        color: color.text
      },
      DateRangePickerInput_arrow_svg: {
        verticalAlign: 'middle',
        fill: color.text,
        height: sizing.arrowWidth,
        width: sizing.arrowWidth
      },
      DateRangePickerInput_clearDates: {
        background: 'none',
        border: 0,
        color: 'inherit',
        font: 'inherit',
        lineHeight: 'normal',
        overflow: 'visible',
        cursor: 'pointer',
        padding: 10,
        margin: '0 10px 0 5px',
        // TODO: should be noflip wrapped and handled by an isRTL prop
        position: 'absolute',
        right: 0,
        // TODO: should be noflip wrapped and handled by an isRTL prop
        top: '50%',
        transform: 'translateY(-50%)'
      },
      DateRangePickerInput_clearDates__small: {
        padding: 6
      },
      DateRangePickerInput_clearDates_default: {
        ':focus': {
          background: color.core.border,
          borderRadius: '50%'
        },
        ':hover': {
          background: color.core.border,
          borderRadius: '50%'
        }
      },
      DateRangePickerInput_clearDates__hide: {
        visibility: 'hidden'
      },
      DateRangePickerInput_clearDates_svg: {
        fill: color.core.grayLight,
        height: 12,
        width: 15,
        verticalAlign: 'middle'
      },
      DateRangePickerInput_clearDates_svg__small: {
        height: 9
      },
      DateRangePickerInput_calendarIcon: {
        background: 'none',
        border: 0,
        color: 'inherit',
        font: 'inherit',
        lineHeight: 'normal',
        overflow: 'visible',
        cursor: 'pointer',
        display: 'inline-block',
        verticalAlign: 'middle',
        padding: 10,
        margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop

      },
      DateRangePickerInput_calendarIcon_svg: {
        fill: color.core.grayLight,
        height: 15,
        width: 14,
        verticalAlign: 'middle'
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(DateRangePickerInput);

  exports["default"] = _default;
});
unwrapExports(DateRangePickerInput_1);
var toLocalizedDateString_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = toLocalizedDateString;

  var _moment = _interopRequireDefault(moment);

  var _toMomentObject = _interopRequireDefault(toMomentObject_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function toLocalizedDateString(date, currentFormat) {
    var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
    if (!dateObj) return null;
    return dateObj.format(constants$4.DISPLAY_FORMAT);
  }
});
unwrapExports(toLocalizedDateString_1);
var DateRangePickerInputController_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _moment = _interopRequireDefault(moment);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _OpenDirectionShape = _interopRequireDefault(OpenDirectionShape);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _DateRangePickerInput = _interopRequireDefault(DateRangePickerInput_1);

  var _IconPositionShape = _interopRequireDefault(IconPositionShape);

  var _DisabledShape = _interopRequireDefault(DisabledShape);

  var _toMomentObject = _interopRequireDefault(toMomentObject_1);

  var _toLocalizedDateString = _interopRequireDefault(toLocalizedDateString_1);

  var _isInclusivelyAfterDay = _interopRequireDefault(isInclusivelyAfterDay_1);

  var _isBeforeDay = _interopRequireDefault(isBeforeDay_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
    children: _propTypes["default"].node,
    startDate: _reactMomentProptypes["default"].momentObj,
    startDateId: _propTypes["default"].string,
    startDatePlaceholderText: _propTypes["default"].string,
    isStartDateFocused: _propTypes["default"].bool,
    endDate: _reactMomentProptypes["default"].momentObj,
    endDateId: _propTypes["default"].string,
    endDatePlaceholderText: _propTypes["default"].string,
    isEndDateFocused: _propTypes["default"].bool,
    screenReaderMessage: _propTypes["default"].string,
    showClearDates: _propTypes["default"].bool,
    showCaret: _propTypes["default"].bool,
    showDefaultInputIcon: _propTypes["default"].bool,
    inputIconPosition: _IconPositionShape["default"],
    disabled: _DisabledShape["default"],
    required: _propTypes["default"].bool,
    readOnly: _propTypes["default"].bool,
    openDirection: _OpenDirectionShape["default"],
    noBorder: _propTypes["default"].bool,
    block: _propTypes["default"].bool,
    small: _propTypes["default"].bool,
    regular: _propTypes["default"].bool,
    verticalSpacing: airbnbPropTypes.nonNegativeInteger,
    keepOpenOnDateSelect: _propTypes["default"].bool,
    reopenPickerOnClearDates: _propTypes["default"].bool,
    withFullScreenPortal: _propTypes["default"].bool,
    minimumNights: airbnbPropTypes.nonNegativeInteger,
    isOutsideRange: _propTypes["default"].func,
    displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
    onFocusChange: _propTypes["default"].func,
    onClose: _propTypes["default"].func,
    onDatesChange: _propTypes["default"].func,
    onKeyDownArrowDown: _propTypes["default"].func,
    onKeyDownQuestionMark: _propTypes["default"].func,
    customInputIcon: _propTypes["default"].node,
    customArrowIcon: _propTypes["default"].node,
    customCloseIcon: _propTypes["default"].node,
    // accessibility
    isFocused: _propTypes["default"].bool,
    // i18n
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerInputPhrases)),
    isRTL: _propTypes["default"].bool
  }) : {};
  var defaultProps = {
    children: null,
    startDate: null,
    startDateId: constants$4.START_DATE,
    startDatePlaceholderText: 'Start Date',
    isStartDateFocused: false,
    endDate: null,
    endDateId: constants$4.END_DATE,
    endDatePlaceholderText: 'End Date',
    isEndDateFocused: false,
    screenReaderMessage: '',
    showClearDates: false,
    showCaret: false,
    showDefaultInputIcon: false,
    inputIconPosition: constants$4.ICON_BEFORE_POSITION,
    disabled: false,
    required: false,
    readOnly: false,
    openDirection: constants$4.OPEN_DOWN,
    noBorder: false,
    block: false,
    small: false,
    regular: false,
    verticalSpacing: undefined,
    keepOpenOnDateSelect: false,
    reopenPickerOnClearDates: false,
    withFullScreenPortal: false,
    minimumNights: 1,
    isOutsideRange: function () {
      function isOutsideRange(day) {
        return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
      }

      return isOutsideRange;
    }(),
    displayFormat: function () {
      function displayFormat() {
        return _moment["default"].localeData().longDateFormat('L');
      }

      return displayFormat;
    }(),
    onFocusChange: function () {
      function onFocusChange() {}

      return onFocusChange;
    }(),
    onClose: function () {
      function onClose() {}

      return onClose;
    }(),
    onDatesChange: function () {
      function onDatesChange() {}

      return onDatesChange;
    }(),
    onKeyDownArrowDown: function () {
      function onKeyDownArrowDown() {}

      return onKeyDownArrowDown;
    }(),
    onKeyDownQuestionMark: function () {
      function onKeyDownQuestionMark() {}

      return onKeyDownQuestionMark;
    }(),
    customInputIcon: null,
    customArrowIcon: null,
    customCloseIcon: null,
    // accessibility
    isFocused: false,
    // i18n
    phrases: defaultPhrases.DateRangePickerInputPhrases,
    isRTL: false
  };

  var DateRangePickerInputController =
  /*#__PURE__*/
  function (_ref) {
    _inherits(DateRangePickerInputController, _ref);

    _createClass(DateRangePickerInputController, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function DateRangePickerInputController(props) {
      var _this;

      _classCallCheck(this, DateRangePickerInputController);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePickerInputController).call(this, props));
      _this.onClearFocus = _this.onClearFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onStartDateChange = _this.onStartDateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onStartDateFocus = _this.onStartDateFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onEndDateChange = _this.onEndDateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onEndDateFocus = _this.onEndDateFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.clearDates = _this.clearDates.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(DateRangePickerInputController, [{
      key: "onClearFocus",
      value: function () {
        function onClearFocus() {
          var _this$props = this.props,
              onFocusChange = _this$props.onFocusChange,
              onClose = _this$props.onClose,
              startDate = _this$props.startDate,
              endDate = _this$props.endDate;
          onFocusChange(null);
          onClose({
            startDate: startDate,
            endDate: endDate
          });
        }

        return onClearFocus;
      }()
    }, {
      key: "onEndDateChange",
      value: function () {
        function onEndDateChange(endDateString) {
          var _this$props2 = this.props,
              startDate = _this$props2.startDate,
              isOutsideRange = _this$props2.isOutsideRange,
              minimumNights = _this$props2.minimumNights,
              keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
              onDatesChange = _this$props2.onDatesChange;
          var endDate = (0, _toMomentObject["default"])(endDateString, this.getDisplayFormat());
          var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days')));

          if (isEndDateValid) {
            onDatesChange({
              startDate: startDate,
              endDate: endDate
            });
            if (!keepOpenOnDateSelect) this.onClearFocus();
          } else {
            onDatesChange({
              startDate: startDate,
              endDate: null
            });
          }
        }

        return onEndDateChange;
      }()
    }, {
      key: "onEndDateFocus",
      value: function () {
        function onEndDateFocus() {
          var _this$props3 = this.props,
              startDate = _this$props3.startDate,
              onFocusChange = _this$props3.onFocusChange,
              withFullScreenPortal = _this$props3.withFullScreenPortal,
              disabled = _this$props3.disabled;

          if (!startDate && withFullScreenPortal && (!disabled || disabled === constants$4.END_DATE)) {
            // When the datepicker is full screen, we never want to focus the end date first
            // because there's no indication that that is the case once the datepicker is open and it
            // might confuse the user
            onFocusChange(constants$4.START_DATE);
          } else if (!disabled || disabled === constants$4.START_DATE) {
            onFocusChange(constants$4.END_DATE);
          }
        }

        return onEndDateFocus;
      }()
    }, {
      key: "onStartDateChange",
      value: function () {
        function onStartDateChange(startDateString) {
          var endDate = this.props.endDate;
          var _this$props4 = this.props,
              isOutsideRange = _this$props4.isOutsideRange,
              minimumNights = _this$props4.minimumNights,
              onDatesChange = _this$props4.onDatesChange,
              onFocusChange = _this$props4.onFocusChange,
              disabled = _this$props4.disabled;
          var startDate = (0, _toMomentObject["default"])(startDateString, this.getDisplayFormat());
          var isEndDateBeforeStartDate = startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days'));
          var isStartDateValid = startDate && !isOutsideRange(startDate) && !(disabled === constants$4.END_DATE && isEndDateBeforeStartDate);

          if (isStartDateValid) {
            if (isEndDateBeforeStartDate) {
              endDate = null;
            }

            onDatesChange({
              startDate: startDate,
              endDate: endDate
            });
            onFocusChange(constants$4.END_DATE);
          } else {
            onDatesChange({
              startDate: null,
              endDate: endDate
            });
          }
        }

        return onStartDateChange;
      }()
    }, {
      key: "onStartDateFocus",
      value: function () {
        function onStartDateFocus() {
          var _this$props5 = this.props,
              disabled = _this$props5.disabled,
              onFocusChange = _this$props5.onFocusChange;

          if (!disabled || disabled === constants$4.END_DATE) {
            onFocusChange(constants$4.START_DATE);
          }
        }

        return onStartDateFocus;
      }()
    }, {
      key: "getDisplayFormat",
      value: function () {
        function getDisplayFormat() {
          var displayFormat = this.props.displayFormat;
          return typeof displayFormat === 'string' ? displayFormat : displayFormat();
        }

        return getDisplayFormat;
      }()
    }, {
      key: "getDateString",
      value: function () {
        function getDateString(date) {
          var displayFormat = this.getDisplayFormat();

          if (date && displayFormat) {
            return date && date.format(displayFormat);
          }

          return (0, _toLocalizedDateString["default"])(date);
        }

        return getDateString;
      }()
    }, {
      key: "clearDates",
      value: function () {
        function clearDates() {
          var _this$props6 = this.props,
              onDatesChange = _this$props6.onDatesChange,
              reopenPickerOnClearDates = _this$props6.reopenPickerOnClearDates,
              onFocusChange = _this$props6.onFocusChange;
          onDatesChange({
            startDate: null,
            endDate: null
          });

          if (reopenPickerOnClearDates) {
            onFocusChange(constants$4.START_DATE);
          }
        }

        return clearDates;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$props7 = this.props,
              children = _this$props7.children,
              startDate = _this$props7.startDate,
              startDateId = _this$props7.startDateId,
              startDatePlaceholderText = _this$props7.startDatePlaceholderText,
              isStartDateFocused = _this$props7.isStartDateFocused,
              endDate = _this$props7.endDate,
              endDateId = _this$props7.endDateId,
              endDatePlaceholderText = _this$props7.endDatePlaceholderText,
              isEndDateFocused = _this$props7.isEndDateFocused,
              screenReaderMessage = _this$props7.screenReaderMessage,
              showClearDates = _this$props7.showClearDates,
              showCaret = _this$props7.showCaret,
              showDefaultInputIcon = _this$props7.showDefaultInputIcon,
              inputIconPosition = _this$props7.inputIconPosition,
              customInputIcon = _this$props7.customInputIcon,
              customArrowIcon = _this$props7.customArrowIcon,
              customCloseIcon = _this$props7.customCloseIcon,
              disabled = _this$props7.disabled,
              required = _this$props7.required,
              readOnly = _this$props7.readOnly,
              openDirection = _this$props7.openDirection,
              isFocused = _this$props7.isFocused,
              phrases = _this$props7.phrases,
              onKeyDownArrowDown = _this$props7.onKeyDownArrowDown,
              onKeyDownQuestionMark = _this$props7.onKeyDownQuestionMark,
              isRTL = _this$props7.isRTL,
              noBorder = _this$props7.noBorder,
              block = _this$props7.block,
              small = _this$props7.small,
              regular = _this$props7.regular,
              verticalSpacing = _this$props7.verticalSpacing;
          var startDateString = this.getDateString(startDate);
          var endDateString = this.getDateString(endDate);
          return _react["default"].createElement(_DateRangePickerInput["default"], {
            startDate: startDateString,
            startDateId: startDateId,
            startDatePlaceholderText: startDatePlaceholderText,
            isStartDateFocused: isStartDateFocused,
            endDate: endDateString,
            endDateId: endDateId,
            endDatePlaceholderText: endDatePlaceholderText,
            isEndDateFocused: isEndDateFocused,
            isFocused: isFocused,
            disabled: disabled,
            required: required,
            readOnly: readOnly,
            openDirection: openDirection,
            showCaret: showCaret,
            showDefaultInputIcon: showDefaultInputIcon,
            inputIconPosition: inputIconPosition,
            customInputIcon: customInputIcon,
            customArrowIcon: customArrowIcon,
            customCloseIcon: customCloseIcon,
            phrases: phrases,
            onStartDateChange: this.onStartDateChange,
            onStartDateFocus: this.onStartDateFocus,
            onStartDateShiftTab: this.onClearFocus,
            onEndDateChange: this.onEndDateChange,
            onEndDateFocus: this.onEndDateFocus,
            showClearDates: showClearDates,
            onClearDates: this.clearDates,
            screenReaderMessage: screenReaderMessage,
            onKeyDownArrowDown: onKeyDownArrowDown,
            onKeyDownQuestionMark: onKeyDownQuestionMark,
            isRTL: isRTL,
            noBorder: noBorder,
            block: block,
            small: small,
            regular: regular,
            verticalSpacing: verticalSpacing
          }, children);
        }

        return render;
      }()
    }]);

    return DateRangePickerInputController;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports["default"] = DateRangePickerInputController;
  DateRangePickerInputController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DateRangePickerInputController.defaultProps = defaultProps;
});
unwrapExports(DateRangePickerInputController_1);
var isNextDay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isNextDay;

  var _moment = _interopRequireDefault(moment);

  var _isSameDay = _interopRequireDefault(isSameDay_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isNextDay(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
    var nextDay = (0, _moment["default"])(a).add(1, 'day');
    return (0, _isSameDay["default"])(nextDay, b);
  }
});
unwrapExports(isNextDay_1);
var isAfterDay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isAfterDay;

  var _moment = _interopRequireDefault(moment);

  var _isBeforeDay = _interopRequireDefault(isBeforeDay_1);

  var _isSameDay = _interopRequireDefault(isSameDay_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isAfterDay(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
    return !(0, _isBeforeDay["default"])(a, b) && !(0, _isSameDay["default"])(a, b);
  }
});
unwrapExports(isAfterDay_1);
var getVisibleDays_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getVisibleDays;

  var _moment = _interopRequireDefault(moment);

  var _toISOMonthString = _interopRequireDefault(toISOMonthString_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
    if (!_moment["default"].isMoment(month)) return {};
    var visibleDaysByMonth = {};
    var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');

    for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
      var visibleDays = []; // set utc offset to get correct dates in future (when timezone changes)

      var baseDate = currentMonth.clone();
      var firstOfMonth = baseDate.clone().startOf('month').hour(12);
      var lastOfMonth = baseDate.clone().endOf('month').hour(12);
      var currentDay = firstOfMonth.clone(); // days belonging to the previous month

      if (enableOutsideDays) {
        for (var j = 0; j < currentDay.weekday(); j += 1) {
          var prevDay = currentDay.clone().subtract(j + 1, 'day');
          visibleDays.unshift(prevDay);
        }
      }

      while (currentDay < lastOfMonth) {
        visibleDays.push(currentDay.clone());
        currentDay.add(1, 'day');
      }

      if (enableOutsideDays) {
        // weekday() returns the index of the day of the week according to the locale
        // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
        if (currentDay.weekday() !== 0) {
          // days belonging to the next month
          for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
            var nextDay = currentDay.clone().add(count, 'day');
            visibleDays.push(nextDay);
          }
        }
      }

      visibleDaysByMonth[(0, _toISOMonthString["default"])(currentMonth)] = visibleDays;
      currentMonth = currentMonth.clone().add(1, 'month');
    }

    return visibleDaysByMonth;
  }
});
unwrapExports(getVisibleDays_1);
var isDayVisible_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isDayVisible;

  var _moment = _interopRequireDefault(moment);

  var _isBeforeDay = _interopRequireDefault(isBeforeDay_1);

  var _isAfterDay = _interopRequireDefault(isAfterDay_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
    if (!_moment["default"].isMoment(day)) return false;
    var firstDayOfFirstMonth = month.clone().startOf('month');
    if (enableOutsideDays) firstDayOfFirstMonth = firstDayOfFirstMonth.startOf('week');
    if ((0, _isBeforeDay["default"])(day, firstDayOfFirstMonth)) return false;
    var lastDayOfLastMonth = month.clone().add(numberOfMonths - 1, 'months').endOf('month');
    if (enableOutsideDays) lastDayOfLastMonth = lastDayOfLastMonth.endOf('week');
    return !(0, _isAfterDay["default"])(day, lastDayOfLastMonth);
  }
});
unwrapExports(isDayVisible_1);
var getSelectedDateOffset_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getSelectedDateOffset;

  var defaultModifier = function defaultModifier(day) {
    return day;
  };

  function getSelectedDateOffset(fn, day) {
    var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModifier;
    if (!fn) return day;
    return modifier(fn(day.clone()));
  }
});
unwrapExports(getSelectedDateOffset_1);
var ChevronUp_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var ChevronUp = function () {
    function ChevronUp(props) {
      return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
        d: "M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z"
      }));
    }

    return ChevronUp;
  }();

  ChevronUp.defaultProps = {
    focusable: "false",
    viewBox: "0 0 1000 1000"
  };
  var _default = ChevronUp;
  exports["default"] = _default;
});
unwrapExports(ChevronUp_1);
var ChevronDown_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var ChevronDown = function () {
    function ChevronDown(props) {
      return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
        d: "M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z"
      }));
    }

    return ChevronDown;
  }();

  ChevronDown.defaultProps = {
    focusable: "false",
    viewBox: "0 0 1000 1000"
  };
  var _default = ChevronDown;
  exports["default"] = _default;
});
unwrapExports(ChevronDown_1);
var DayPickerNavigation_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _noflip = _interopRequireDefault(noflip_1);

  var _LeftArrow = _interopRequireDefault(LeftArrow_1);

  var _RightArrow = _interopRequireDefault(RightArrow_1);

  var _ChevronUp = _interopRequireDefault(ChevronUp_1);

  var _ChevronDown = _interopRequireDefault(ChevronDown_1);

  var _ScrollableOrientationShape = _interopRequireDefault(ScrollableOrientationShape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    disablePrev: _propTypes["default"].bool,
    disableNext: _propTypes["default"].bool,
    navPrev: _propTypes["default"].node,
    navNext: _propTypes["default"].node,
    orientation: _ScrollableOrientationShape["default"],
    onPrevMonthClick: _propTypes["default"].func,
    onNextMonthClick: _propTypes["default"].func,
    // internationalization
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerNavigationPhrases)),
    isRTL: _propTypes["default"].bool
  })) : {};
  var defaultProps = {
    disablePrev: false,
    disableNext: false,
    navPrev: null,
    navNext: null,
    orientation: constants$4.HORIZONTAL_ORIENTATION,
    onPrevMonthClick: function () {
      function onPrevMonthClick() {}

      return onPrevMonthClick;
    }(),
    onNextMonthClick: function () {
      function onNextMonthClick() {}

      return onNextMonthClick;
    }(),
    // internationalization
    phrases: defaultPhrases.DayPickerNavigationPhrases,
    isRTL: false
  };

  function DayPickerNavigation(_ref) {
    var disablePrev = _ref.disablePrev,
        disableNext = _ref.disableNext,
        navPrev = _ref.navPrev,
        navNext = _ref.navNext,
        onPrevMonthClick = _ref.onPrevMonthClick,
        onNextMonthClick = _ref.onNextMonthClick,
        orientation = _ref.orientation,
        phrases = _ref.phrases,
        isRTL = _ref.isRTL,
        styles = _ref.styles;
    var isHorizontal = orientation === constants$4.HORIZONTAL_ORIENTATION;
    var isVertical = orientation !== constants$4.HORIZONTAL_ORIENTATION;
    var isVerticalScrollable = orientation === constants$4.VERTICAL_SCROLLABLE;
    var navPrevIcon = navPrev;
    var navNextIcon = navNext;
    var isDefaultNavPrev = false;
    var isDefaultNavNext = false;

    if (!navPrevIcon) {
      isDefaultNavPrev = true;
      var Icon = isVertical ? _ChevronUp["default"] : _LeftArrow["default"];

      if (isRTL && !isVertical) {
        Icon = _RightArrow["default"];
      }

      navPrevIcon = _react["default"].createElement(Icon, (0, withStyles_1.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disablePrev && styles.DayPickerNavigation_svg__disabled));
    }

    if (!navNextIcon) {
      isDefaultNavNext = true;

      var _Icon = isVertical ? _ChevronDown["default"] : _RightArrow["default"];

      if (isRTL && !isVertical) {
        _Icon = _LeftArrow["default"];
      }

      navNextIcon = _react["default"].createElement(_Icon, (0, withStyles_1.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disableNext && styles.DayPickerNavigation_svg__disabled));
    }

    var isDefaultNav = isVerticalScrollable ? isDefaultNavNext : isDefaultNavNext || isDefaultNavPrev;
    return _react["default"].createElement("div", withStyles_1.css.apply(void 0, [styles.DayPickerNavigation, isHorizontal && styles.DayPickerNavigation__horizontal].concat(_toConsumableArray(isVertical ? [styles.DayPickerNavigation__vertical, isDefaultNav && styles.DayPickerNavigation__verticalDefault] : []), _toConsumableArray(isVerticalScrollable ? [styles.DayPickerNavigation__verticalScrollable, isDefaultNav && styles.DayPickerNavigation__verticalScrollableDefault] : []))), !isVerticalScrollable && _react["default"].createElement("div", _extends({
      role: "button",
      tabIndex: "0"
    }, withStyles_1.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavPrev && styles.DayPickerNavigation_button__default, disablePrev && styles.DayPickerNavigation_button__disabled].concat(_toConsumableArray(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat(_toConsumableArray(isDefaultNavPrev ? [styles.DayPickerNavigation_button__horizontalDefault, !isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), _toConsumableArray(isVertical ? [styles.DayPickerNavigation_button__vertical].concat(_toConsumableArray(isDefaultNavPrev ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_prevButton__verticalDefault] : [])) : []))), {
      "aria-disabled": disablePrev ? true : undefined,
      "aria-label": phrases.jumpToPrevMonth,
      onClick: disablePrev ? undefined : onPrevMonthClick,
      onKeyUp: disablePrev ? undefined : function (e) {
        var key = e.key;
        if (key === 'Enter' || key === ' ') onPrevMonthClick(e);
      },
      onMouseUp: disablePrev ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }), navPrevIcon), _react["default"].createElement("div", _extends({
      role: "button",
      tabIndex: "0"
    }, withStyles_1.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavNext && styles.DayPickerNavigation_button__default, disableNext && styles.DayPickerNavigation_button__disabled].concat(_toConsumableArray(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat(_toConsumableArray(isDefaultNavNext ? [styles.DayPickerNavigation_button__horizontalDefault, isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, !isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), _toConsumableArray(isVertical ? [styles.DayPickerNavigation_button__vertical, styles.DayPickerNavigation_nextButton__vertical].concat(_toConsumableArray(isDefaultNavNext ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_nextButton__verticalDefault, isVerticalScrollable && styles.DayPickerNavigation_nextButton__verticalScrollableDefault] : [])) : []))), {
      "aria-disabled": disableNext ? true : undefined,
      "aria-label": phrases.jumpToNextMonth,
      onClick: disableNext ? undefined : onNextMonthClick,
      onKeyUp: disableNext ? undefined : function (e) {
        var key = e.key;
        if (key === 'Enter' || key === ' ') onNextMonthClick(e);
      },
      onMouseUp: disableNext ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }), navNextIcon));
  }

  DayPickerNavigation.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DayPickerNavigation.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var _ref2$reactDates = _ref2.reactDates,
        color = _ref2$reactDates.color,
        zIndex = _ref2$reactDates.zIndex;
    return {
      DayPickerNavigation: {
        position: 'relative',
        zIndex: zIndex + 2
      },
      DayPickerNavigation__horizontal: {
        height: 0
      },
      DayPickerNavigation__vertical: {},
      DayPickerNavigation__verticalScrollable: {},
      DayPickerNavigation__verticalDefault: {
        position: 'absolute',
        width: '100%',
        height: 52,
        bottom: 0,
        left: (0, _noflip["default"])(0)
      },
      DayPickerNavigation__verticalScrollableDefault: {
        position: 'relative'
      },
      DayPickerNavigation_button: {
        cursor: 'pointer',
        userSelect: 'none',
        border: 0,
        padding: 0,
        margin: 0
      },
      DayPickerNavigation_button__default: {
        border: "1px solid ".concat(color.core.borderLight),
        backgroundColor: color.background,
        color: color.placeholderText,
        ':focus': {
          border: "1px solid ".concat(color.core.borderMedium)
        },
        ':hover': {
          border: "1px solid ".concat(color.core.borderMedium)
        },
        ':active': {
          background: color.backgroundDark
        }
      },
      DayPickerNavigation_button__disabled: {
        cursor: 'default',
        border: "1px solid ".concat(color.disabled),
        ':focus': {
          border: "1px solid ".concat(color.disabled)
        },
        ':hover': {
          border: "1px solid ".concat(color.disabled)
        },
        ':active': {
          background: 'none'
        }
      },
      DayPickerNavigation_button__horizontal: {},
      DayPickerNavigation_button__horizontalDefault: {
        position: 'absolute',
        top: 18,
        lineHeight: 0.78,
        borderRadius: 3,
        padding: '6px 9px'
      },
      DayPickerNavigation_leftButton__horizontalDefault: {
        left: (0, _noflip["default"])(22)
      },
      DayPickerNavigation_rightButton__horizontalDefault: {
        right: (0, _noflip["default"])(22)
      },
      DayPickerNavigation_button__vertical: {},
      DayPickerNavigation_button__verticalDefault: {
        padding: 5,
        background: color.background,
        boxShadow: (0, _noflip["default"])('0 0 5px 2px rgba(0, 0, 0, 0.1)'),
        position: 'relative',
        display: 'inline-block',
        textAlign: 'center',
        height: '100%',
        width: '50%'
      },
      DayPickerNavigation_prevButton__verticalDefault: {},
      DayPickerNavigation_nextButton__verticalDefault: {
        borderLeft: (0, _noflip["default"])(0)
      },
      DayPickerNavigation_nextButton__verticalScrollableDefault: {
        width: '100%'
      },
      DayPickerNavigation_svg__horizontal: {
        height: 19,
        width: 19,
        fill: color.core.grayLight,
        display: 'block'
      },
      DayPickerNavigation_svg__vertical: {
        height: 42,
        width: 42,
        fill: color.text
      },
      DayPickerNavigation_svg__disabled: {
        fill: color.disabled
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(DayPickerNavigation);

  exports["default"] = _default;
});
unwrapExports(DayPickerNavigation_1);
var KeyboardShortcutRow_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    unicode: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].string.isRequired,
    block: _propTypes["default"].bool
  })) : {};
  var defaultProps = {
    block: false
  };

  function KeyboardShortcutRow(_ref) {
    var unicode = _ref.unicode,
        label = _ref.label,
        action = _ref.action,
        block = _ref.block,
        styles = _ref.styles;
    return _react["default"].createElement("li", (0, withStyles_1.css)(styles.KeyboardShortcutRow, block && styles.KeyboardShortcutRow__block), _react["default"].createElement("div", (0, withStyles_1.css)(styles.KeyboardShortcutRow_keyContainer, block && styles.KeyboardShortcutRow_keyContainer__block), _react["default"].createElement("span", _extends({}, (0, withStyles_1.css)(styles.KeyboardShortcutRow_key), {
      role: "img",
      "aria-label": "".concat(label, ",") // add comma so screen readers will pause before reading action

    }), unicode)), _react["default"].createElement("div", (0, withStyles_1.css)(styles.KeyboardShortcutRow_action), action));
  }

  KeyboardShortcutRow.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  KeyboardShortcutRow.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var color = _ref2.reactDates.color;
    return {
      KeyboardShortcutRow: {
        listStyle: 'none',
        margin: '6px 0'
      },
      KeyboardShortcutRow__block: {
        marginBottom: 16
      },
      KeyboardShortcutRow_keyContainer: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textAlign: 'right',
        // is not handled by isRTL
        marginRight: 6 // is not handled by isRTL

      },
      KeyboardShortcutRow_keyContainer__block: {
        textAlign: 'left',
        // is not handled by isRTL
        display: 'inline'
      },
      KeyboardShortcutRow_key: {
        fontFamily: 'monospace',
        fontSize: 12,
        textTransform: 'uppercase',
        background: color.core.grayLightest,
        padding: '2px 6px'
      },
      KeyboardShortcutRow_action: {
        display: 'inline',
        wordBreak: 'break-word',
        marginLeft: 8 // is not handled by isRTL

      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(KeyboardShortcutRow);

  exports["default"] = _default;
});
unwrapExports(KeyboardShortcutRow_1);
var DayPickerKeyboardShortcuts_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _KeyboardShortcutRow = _interopRequireDefault(KeyboardShortcutRow_1);

  var _CloseButton = _interopRequireDefault(CloseButton_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var TOP_LEFT = 'top-left';
  exports.TOP_LEFT = TOP_LEFT;
  var TOP_RIGHT = 'top-right';
  exports.TOP_RIGHT = TOP_RIGHT;
  var BOTTOM_RIGHT = 'bottom-right';
  exports.BOTTOM_RIGHT = BOTTOM_RIGHT;
  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    block: _propTypes["default"].bool,
    // TODO: rename button location to be direction-agnostic
    buttonLocation: _propTypes["default"].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
    showKeyboardShortcutsPanel: _propTypes["default"].bool,
    openKeyboardShortcutsPanel: _propTypes["default"].func,
    closeKeyboardShortcutsPanel: _propTypes["default"].func,
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerKeyboardShortcutsPhrases))
  })) : {};
  var defaultProps = {
    block: false,
    buttonLocation: BOTTOM_RIGHT,
    showKeyboardShortcutsPanel: false,
    openKeyboardShortcutsPanel: function () {
      function openKeyboardShortcutsPanel() {}

      return openKeyboardShortcutsPanel;
    }(),
    closeKeyboardShortcutsPanel: function () {
      function closeKeyboardShortcutsPanel() {}

      return closeKeyboardShortcutsPanel;
    }(),
    phrases: defaultPhrases.DayPickerKeyboardShortcutsPhrases
  };

  function getKeyboardShortcuts(phrases) {
    return [{
      unicode: '↵',
      label: phrases.enterKey,
      action: phrases.selectFocusedDate
    }, {
      unicode: '←/→',
      label: phrases.leftArrowRightArrow,
      action: phrases.moveFocusByOneDay
    }, {
      unicode: '↑/↓',
      label: phrases.upArrowDownArrow,
      action: phrases.moveFocusByOneWeek
    }, {
      unicode: 'PgUp/PgDn',
      label: phrases.pageUpPageDown,
      action: phrases.moveFocusByOneMonth
    }, {
      unicode: 'Home/End',
      label: phrases.homeEnd,
      action: phrases.moveFocustoStartAndEndOfWeek
    }, {
      unicode: 'Esc',
      label: phrases.escape,
      action: phrases.returnFocusToInput
    }, {
      unicode: '?',
      label: phrases.questionMark,
      action: phrases.openThisPanel
    }];
  }

  var DayPickerKeyboardShortcuts =
  /*#__PURE__*/
  function (_ref) {
    _inherits(DayPickerKeyboardShortcuts, _ref);

    _createClass(DayPickerKeyboardShortcuts, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function DayPickerKeyboardShortcuts() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, DayPickerKeyboardShortcuts);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DayPickerKeyboardShortcuts)).call.apply(_getPrototypeOf2, [this].concat(args)));
      var phrases = _this.props.phrases;
      _this.keyboardShortcuts = getKeyboardShortcuts(phrases);
      _this.onShowKeyboardShortcutsButtonClick = _this.onShowKeyboardShortcutsButtonClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setHideKeyboardShortcutsButtonRef = _this.setHideKeyboardShortcutsButtonRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(DayPickerKeyboardShortcuts, [{
      key: "componentWillReceiveProps",
      value: function () {
        function componentWillReceiveProps(nextProps) {
          var phrases = this.props.phrases;

          if (nextProps.phrases !== phrases) {
            this.keyboardShortcuts = getKeyboardShortcuts(nextProps.phrases);
          }
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: "componentDidUpdate",
      value: function () {
        function componentDidUpdate() {
          this.handleFocus();
        }

        return componentDidUpdate;
      }()
    }, {
      key: "onKeyDown",
      value: function () {
        function onKeyDown(e) {
          e.stopPropagation();
          var closeKeyboardShortcutsPanel = this.props.closeKeyboardShortcutsPanel; // Because the close button is the only focusable element inside of the panel, this
          // amounts to a very basic focus trap. The user can exit the panel by "pressing" the
          // close button or hitting escape

          switch (e.key) {
            case 'Escape':
              closeKeyboardShortcutsPanel();
              break;
            // do nothing - this allows the up and down arrows continue their
            // default behavior of scrolling the content of the Keyboard Shortcuts Panel
            // which is needed when only a single month is shown for instance.

            case 'ArrowUp':
            case 'ArrowDown':
              break;
            // completely block the rest of the keys that have functionality outside of this panel

            case 'Tab':
            case 'Home':
            case 'End':
            case 'PageUp':
            case 'PageDown':
            case 'ArrowLeft':
            case 'ArrowRight':
              e.preventDefault();
              break;

            default:
              break;
          }
        }

        return onKeyDown;
      }()
    }, {
      key: "onShowKeyboardShortcutsButtonClick",
      value: function () {
        function onShowKeyboardShortcutsButtonClick() {
          var _this2 = this;

          var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel; // we want to return focus to this button after closing the keyboard shortcuts panel

          openKeyboardShortcutsPanel(function () {
            _this2.showKeyboardShortcutsButton.focus();
          });
        }

        return onShowKeyboardShortcutsButtonClick;
      }()
    }, {
      key: "setShowKeyboardShortcutsButtonRef",
      value: function () {
        function setShowKeyboardShortcutsButtonRef(ref) {
          this.showKeyboardShortcutsButton = ref;
        }

        return setShowKeyboardShortcutsButtonRef;
      }()
    }, {
      key: "setHideKeyboardShortcutsButtonRef",
      value: function () {
        function setHideKeyboardShortcutsButtonRef(ref) {
          this.hideKeyboardShortcutsButton = ref;
        }

        return setHideKeyboardShortcutsButtonRef;
      }()
    }, {
      key: "handleFocus",
      value: function () {
        function handleFocus() {
          if (this.hideKeyboardShortcutsButton) {
            // automatically move focus into the dialog by moving
            // to the only interactive element, the hide button
            this.hideKeyboardShortcutsButton.focus();
          }
        }

        return handleFocus;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$props = this.props,
              block = _this$props.block,
              buttonLocation = _this$props.buttonLocation,
              showKeyboardShortcutsPanel = _this$props.showKeyboardShortcutsPanel,
              closeKeyboardShortcutsPanel = _this$props.closeKeyboardShortcutsPanel,
              styles = _this$props.styles,
              phrases = _this$props.phrases;
          var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;
          var bottomRight = buttonLocation === BOTTOM_RIGHT;
          var topRight = buttonLocation === TOP_RIGHT;
          var topLeft = buttonLocation === TOP_LEFT;
          return _react["default"].createElement("div", null, _react["default"].createElement("button", _extends({
            ref: this.setShowKeyboardShortcutsButtonRef
          }, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_show, bottomRight && styles.DayPickerKeyboardShortcuts_show__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_show__topRight, topLeft && styles.DayPickerKeyboardShortcuts_show__topLeft), {
            type: "button",
            "aria-label": toggleButtonText,
            onClick: this.onShowKeyboardShortcutsButtonClick,
            onMouseUp: function () {
              function onMouseUp(e) {
                e.currentTarget.blur();
              }

              return onMouseUp;
            }()
          }), _react["default"].createElement("span", (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_showSpan, bottomRight && styles.DayPickerKeyboardShortcuts_showSpan__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_showSpan__topRight, topLeft && styles.DayPickerKeyboardShortcuts_showSpan__topLeft), "?")), showKeyboardShortcutsPanel && _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_panel), {
            role: "dialog",
            "aria-labelledby": "DayPickerKeyboardShortcuts_title",
            "aria-describedby": "DayPickerKeyboardShortcuts_description"
          }), _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_title), {
            id: "DayPickerKeyboardShortcuts_title"
          }), phrases.keyboardShortcuts), _react["default"].createElement("button", _extends({
            ref: this.setHideKeyboardShortcutsButtonRef
          }, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_close), {
            type: "button",
            tabIndex: "0",
            "aria-label": phrases.hideKeyboardShortcutsPanel,
            onClick: closeKeyboardShortcutsPanel,
            onKeyDown: this.onKeyDown
          }), _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_closeSvg))), _react["default"].createElement("ul", _extends({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_list), {
            id: "DayPickerKeyboardShortcuts_description"
          }), this.keyboardShortcuts.map(function (_ref2) {
            var unicode = _ref2.unicode,
                label = _ref2.label,
                action = _ref2.action;
            return _react["default"].createElement(_KeyboardShortcutRow["default"], {
              key: label,
              unicode: unicode,
              label: label,
              action: action,
              block: block
            });
          }))));
        }

        return render;
      }()
    }]);

    return DayPickerKeyboardShortcuts;
  }(_react["default"].PureComponent || _react["default"].Component);

  DayPickerKeyboardShortcuts.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DayPickerKeyboardShortcuts.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref3) {
    var _ref3$reactDates = _ref3.reactDates,
        color = _ref3$reactDates.color,
        font = _ref3$reactDates.font,
        zIndex = _ref3$reactDates.zIndex;
    return {
      DayPickerKeyboardShortcuts_buttonReset: {
        background: 'none',
        border: 0,
        borderRadius: 0,
        color: 'inherit',
        font: 'inherit',
        lineHeight: 'normal',
        overflow: 'visible',
        padding: 0,
        cursor: 'pointer',
        fontSize: font.size,
        ':active': {
          outline: 'none'
        }
      },
      DayPickerKeyboardShortcuts_show: {
        width: 33,
        height: 26,
        position: 'absolute',
        zIndex: zIndex + 2,
        '::before': {
          content: '""',
          display: 'block',
          position: 'absolute'
        }
      },
      DayPickerKeyboardShortcuts_show__bottomRight: {
        bottom: 0,
        right: 0,
        '::before': {
          borderTop: '26px solid transparent',
          borderRight: "33px solid ".concat(color.core.primary),
          bottom: 0,
          right: 0
        },
        ':hover::before': {
          borderRight: "33px solid ".concat(color.core.primary_dark)
        }
      },
      DayPickerKeyboardShortcuts_show__topRight: {
        top: 0,
        right: 0,
        '::before': {
          borderBottom: '26px solid transparent',
          borderRight: "33px solid ".concat(color.core.primary),
          top: 0,
          right: 0
        },
        ':hover::before': {
          borderRight: "33px solid ".concat(color.core.primary_dark)
        }
      },
      DayPickerKeyboardShortcuts_show__topLeft: {
        top: 0,
        left: 0,
        '::before': {
          borderBottom: '26px solid transparent',
          borderLeft: "33px solid ".concat(color.core.primary),
          top: 0,
          left: 0
        },
        ':hover::before': {
          borderLeft: "33px solid ".concat(color.core.primary_dark)
        }
      },
      DayPickerKeyboardShortcuts_showSpan: {
        color: color.core.white,
        position: 'absolute'
      },
      DayPickerKeyboardShortcuts_showSpan__bottomRight: {
        bottom: 0,
        right: 5
      },
      DayPickerKeyboardShortcuts_showSpan__topRight: {
        top: 1,
        right: 5
      },
      DayPickerKeyboardShortcuts_showSpan__topLeft: {
        top: 1,
        left: 5
      },
      DayPickerKeyboardShortcuts_panel: {
        overflow: 'auto',
        background: color.background,
        border: "1px solid ".concat(color.core.border),
        borderRadius: 2,
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: zIndex + 2,
        padding: 22,
        margin: 33,
        textAlign: 'left' // TODO: investigate use of text-align throughout the library

      },
      DayPickerKeyboardShortcuts_title: {
        fontSize: 16,
        fontWeight: 'bold',
        margin: 0
      },
      DayPickerKeyboardShortcuts_list: {
        listStyle: 'none',
        padding: 0,
        fontSize: font.size
      },
      DayPickerKeyboardShortcuts_close: {
        position: 'absolute',
        right: 22,
        top: 22,
        zIndex: zIndex + 2,
        ':active': {
          outline: 'none'
        }
      },
      DayPickerKeyboardShortcuts_closeSvg: {
        height: 15,
        width: 15,
        fill: color.core.grayLighter,
        ':hover': {
          fill: color.core.grayLight
        },
        ':focus': {
          fill: color.core.grayLight
        }
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(DayPickerKeyboardShortcuts);

  exports["default"] = _default;
});
unwrapExports(DayPickerKeyboardShortcuts_1);
var DayPickerKeyboardShortcuts_2 = DayPickerKeyboardShortcuts_1.BOTTOM_RIGHT;
var DayPickerKeyboardShortcuts_3 = DayPickerKeyboardShortcuts_1.TOP_RIGHT;
var DayPickerKeyboardShortcuts_4 = DayPickerKeyboardShortcuts_1.TOP_LEFT;
var getNumberOfCalendarMonthWeeks_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getNumberOfCalendarMonthWeeks;

  var _moment = _interopRequireDefault(moment);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek) {
    var weekDayDiff = firstDayOfMonth.day() - firstDayOfWeek;
    return (weekDayDiff + 7) % 7;
  }

  function getNumberOfCalendarMonthWeeks(month) {
    var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment["default"].localeData().firstDayOfWeek();
    var firstDayOfMonth = month.clone().startOf('month');
    var numBlankDays = getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek);
    return Math.ceil((numBlankDays + month.daysInMonth()) / 7);
  }
});
unwrapExports(getNumberOfCalendarMonthWeeks_1);
var getActiveElement_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = getActiveElement;

  function getActiveElement() {
    return typeof document !== 'undefined' && document.activeElement;
  }
});
unwrapExports(getActiveElement_1);
var DayPicker_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.PureDayPicker = exports.defaultProps = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _moment = _interopRequireDefault(moment);

  var _throttle = _interopRequireDefault(throttle_1);

  var _isTouchDevice = _interopRequireDefault(build$2);

  var _reactOutsideClickHandler = _interopRequireDefault(reactOutsideClickHandler);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _noflip = _interopRequireDefault(noflip_1);

  var _CalendarMonthGrid = _interopRequireDefault(CalendarMonthGrid_1);

  var _DayPickerNavigation = _interopRequireDefault(DayPickerNavigation_1);

  var _DayPickerKeyboardShortcuts = _interopRequireWildcard(DayPickerKeyboardShortcuts_1);

  var _getNumberOfCalendarMonthWeeks = _interopRequireDefault(getNumberOfCalendarMonthWeeks_1);

  var _getCalendarMonthWidth = _interopRequireDefault(getCalendarMonthWidth_1);

  var _calculateDimension = _interopRequireDefault(calculateDimension_1);

  var _getActiveElement = _interopRequireDefault(getActiveElement_1);

  var _isDayVisible = _interopRequireDefault(isDayVisible_1);

  var _ModifiersShape = _interopRequireDefault(ModifiersShape);

  var _ScrollableOrientationShape = _interopRequireDefault(ScrollableOrientationShape);

  var _DayOfWeekShape = _interopRequireDefault(DayOfWeekShape);

  var _CalendarInfoPositionShape = _interopRequireDefault(CalendarInfoPositionShape);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var MONTH_PADDING = 23;
  var PREV_TRANSITION = 'prev';
  var NEXT_TRANSITION = 'next';
  var MONTH_SELECTION_TRANSITION = 'month_selection';
  var YEAR_SELECTION_TRANSITION = 'year_selection';
  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    // calendar presentation props
    enableOutsideDays: _propTypes["default"].bool,
    numberOfMonths: _propTypes["default"].number,
    orientation: _ScrollableOrientationShape["default"],
    withPortal: _propTypes["default"].bool,
    onOutsideClick: _propTypes["default"].func,
    hidden: _propTypes["default"].bool,
    initialVisibleMonth: _propTypes["default"].func,
    firstDayOfWeek: _DayOfWeekShape["default"],
    renderCalendarInfo: _propTypes["default"].func,
    calendarInfoPosition: _CalendarInfoPositionShape["default"],
    hideKeyboardShortcutsPanel: _propTypes["default"].bool,
    daySize: airbnbPropTypes.nonNegativeInteger,
    isRTL: _propTypes["default"].bool,
    verticalHeight: airbnbPropTypes.nonNegativeInteger,
    noBorder: _propTypes["default"].bool,
    transitionDuration: airbnbPropTypes.nonNegativeInteger,
    verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
    horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
    // navigation props
    disablePrev: _propTypes["default"].bool,
    disableNext: _propTypes["default"].bool,
    navPrev: _propTypes["default"].node,
    navNext: _propTypes["default"].node,
    noNavButtons: _propTypes["default"].bool,
    onPrevMonthClick: _propTypes["default"].func,
    onNextMonthClick: _propTypes["default"].func,
    onMonthChange: _propTypes["default"].func,
    onYearChange: _propTypes["default"].func,
    onMultiplyScrollableMonths: _propTypes["default"].func,
    // VERTICAL_SCROLLABLE daypickers only
    // month props
    renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    // day props
    modifiers: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_ModifiersShape["default"])),
    renderCalendarDay: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    onDayClick: _propTypes["default"].func,
    onDayMouseEnter: _propTypes["default"].func,
    onDayMouseLeave: _propTypes["default"].func,
    // accessibility props
    isFocused: _propTypes["default"].bool,
    getFirstFocusableDay: _propTypes["default"].func,
    onBlur: _propTypes["default"].func,
    showKeyboardShortcuts: _propTypes["default"].bool,
    onTab: _propTypes["default"].func,
    onShiftTab: _propTypes["default"].func,
    // internationalization
    monthFormat: _propTypes["default"].string,
    weekDayFormat: _propTypes["default"].string,
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
    dayAriaLabelFormat: _propTypes["default"].string
  })) : {};
  var defaultProps = {
    // calendar presentation props
    enableOutsideDays: false,
    numberOfMonths: 2,
    orientation: constants$4.HORIZONTAL_ORIENTATION,
    withPortal: false,
    onOutsideClick: function () {
      function onOutsideClick() {}

      return onOutsideClick;
    }(),
    hidden: false,
    initialVisibleMonth: function () {
      function initialVisibleMonth() {
        return (0, _moment["default"])();
      }

      return initialVisibleMonth;
    }(),
    firstDayOfWeek: null,
    renderCalendarInfo: null,
    calendarInfoPosition: constants$4.INFO_POSITION_BOTTOM,
    hideKeyboardShortcutsPanel: false,
    daySize: constants$4.DAY_SIZE,
    isRTL: false,
    verticalHeight: null,
    noBorder: false,
    transitionDuration: undefined,
    verticalBorderSpacing: undefined,
    horizontalMonthPadding: 13,
    // navigation props
    disablePrev: false,
    disableNext: false,
    navPrev: null,
    navNext: null,
    noNavButtons: false,
    onPrevMonthClick: function () {
      function onPrevMonthClick() {}

      return onPrevMonthClick;
    }(),
    onNextMonthClick: function () {
      function onNextMonthClick() {}

      return onNextMonthClick;
    }(),
    onMonthChange: function () {
      function onMonthChange() {}

      return onMonthChange;
    }(),
    onYearChange: function () {
      function onYearChange() {}

      return onYearChange;
    }(),
    onMultiplyScrollableMonths: function () {
      function onMultiplyScrollableMonths() {}

      return onMultiplyScrollableMonths;
    }(),
    // month props
    renderMonthText: null,
    renderMonthElement: null,
    // day props
    modifiers: {},
    renderCalendarDay: undefined,
    renderDayContents: null,
    onDayClick: function () {
      function onDayClick() {}

      return onDayClick;
    }(),
    onDayMouseEnter: function () {
      function onDayMouseEnter() {}

      return onDayMouseEnter;
    }(),
    onDayMouseLeave: function () {
      function onDayMouseLeave() {}

      return onDayMouseLeave;
    }(),
    // accessibility props
    isFocused: false,
    getFirstFocusableDay: null,
    onBlur: function () {
      function onBlur() {}

      return onBlur;
    }(),
    showKeyboardShortcuts: false,
    onTab: function () {
      function onTab() {}

      return onTab;
    }(),
    onShiftTab: function () {
      function onShiftTab() {}

      return onShiftTab;
    }(),
    // internationalization
    monthFormat: 'MMMM YYYY',
    weekDayFormat: 'dd',
    phrases: defaultPhrases.DayPickerPhrases,
    dayAriaLabelFormat: undefined
  };
  exports.defaultProps = defaultProps;

  var DayPicker =
  /*#__PURE__*/
  function (_ref) {
    _inherits(DayPicker, _ref);

    _createClass(DayPicker, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function DayPicker(props) {
      var _this;

      _classCallCheck(this, DayPicker);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DayPicker).call(this, props));
      var currentMonth = props.hidden ? (0, _moment["default"])() : props.initialVisibleMonth();
      var focusedDate = currentMonth.clone().startOf('month');

      if (props.getFirstFocusableDay) {
        focusedDate = props.getFirstFocusableDay(currentMonth);
      }

      var horizontalMonthPadding = props.horizontalMonthPadding;
      var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding) : 0;
      _this.hasSetInitialVisibleMonth = !props.hidden;
      _this.state = {
        currentMonth: currentMonth,
        monthTransition: null,
        translationValue: translationValue,
        scrollableMonthMultiple: 1,
        calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding),
        focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
        nextFocusedDate: null,
        showKeyboardShortcuts: props.showKeyboardShortcuts,
        onKeyboardShortcutsPanelClose: function () {
          function onKeyboardShortcutsPanelClose() {}

          return onKeyboardShortcutsPanelClose;
        }(),
        isTouchDevice: (0, _isTouchDevice["default"])(),
        withMouseInteractions: true,
        calendarInfoWidth: 0,
        monthTitleHeight: null,
        hasSetHeight: false
      };

      _this.setCalendarMonthWeeks(currentMonth);

      _this.calendarMonthGridHeight = 0;
      _this.setCalendarInfoWidthTimeout = null;
      _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 200, {
        trailing: false
      });
      _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onPrevMonthTransition = _this.onPrevMonthTransition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onNextMonthClick = _this.onNextMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onNextMonthTransition = _this.onNextMonthTransition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onYearChange = _this.onYearChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.multiplyScrollableMonths = _this.multiplyScrollableMonths.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setCalendarInfoRef = _this.setCalendarInfoRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(DayPicker, [{
      key: "componentDidMount",
      value: function () {
        function componentDidMount() {
          var currentMonth = this.state.currentMonth;

          if (this.calendarInfo) {
            this.setState({
              isTouchDevice: (0, _isTouchDevice["default"])(),
              calendarInfoWidth: (0, _calculateDimension["default"])(this.calendarInfo, 'width', true, true)
            });
          } else {
            this.setState({
              isTouchDevice: (0, _isTouchDevice["default"])()
            });
          }

          this.setCalendarMonthWeeks(currentMonth);
        }

        return componentDidMount;
      }()
    }, {
      key: "componentWillReceiveProps",
      value: function () {
        function componentWillReceiveProps(nextProps) {
          var hidden = nextProps.hidden,
              isFocused = nextProps.isFocused,
              showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
              onBlur = nextProps.onBlur,
              renderMonthText = nextProps.renderMonthText,
              horizontalMonthPadding = nextProps.horizontalMonthPadding;
          var currentMonth = this.state.currentMonth;

          if (!hidden) {
            if (!this.hasSetInitialVisibleMonth) {
              this.hasSetInitialVisibleMonth = true;
              this.setState({
                currentMonth: nextProps.initialVisibleMonth()
              });
            }
          }

          var _this$props = this.props,
              daySize = _this$props.daySize,
              prevIsFocused = _this$props.isFocused,
              prevRenderMonthText = _this$props.renderMonthText;

          if (nextProps.daySize !== daySize) {
            this.setState({
              calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(nextProps.daySize, horizontalMonthPadding)
            });
          }

          if (isFocused !== prevIsFocused) {
            if (isFocused) {
              var focusedDate = this.getFocusedDay(currentMonth);
              var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

              if (nextProps.showKeyboardShortcuts) {
                // the ? shortcut came from the input and we should return input there once it is close
                onKeyboardShortcutsPanelClose = onBlur;
              }

              this.setState({
                showKeyboardShortcuts: showKeyboardShortcuts,
                onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
                focusedDate: focusedDate,
                withMouseInteractions: false
              });
            } else {
              this.setState({
                focusedDate: null
              });
            }
          }

          if (renderMonthText !== prevRenderMonthText) {
            this.setState({
              monthTitleHeight: null
            });
          }
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: "componentWillUpdate",
      value: function () {
        function componentWillUpdate() {
          var _this2 = this;

          var transitionDuration = this.props.transitionDuration; // Calculating the dimensions trigger a DOM repaint which
          // breaks the CSS transition.
          // The setTimeout will wait until the transition ends.

          if (this.calendarInfo) {
            this.setCalendarInfoWidthTimeout = setTimeout(function () {
              var calendarInfoWidth = _this2.state.calendarInfoWidth;
              var calendarInfoPanelWidth = (0, _calculateDimension["default"])(_this2.calendarInfo, 'width', true, true);

              if (calendarInfoWidth !== calendarInfoPanelWidth) {
                _this2.setState({
                  calendarInfoWidth: calendarInfoPanelWidth
                });
              }
            }, transitionDuration);
          }
        }

        return componentWillUpdate;
      }()
    }, {
      key: "componentDidUpdate",
      value: function () {
        function componentDidUpdate(prevProps) {
          var _this$props2 = this.props,
              orientation = _this$props2.orientation,
              daySize = _this$props2.daySize,
              isFocused = _this$props2.isFocused,
              numberOfMonths = _this$props2.numberOfMonths;
          var _this$state = this.state,
              focusedDate = _this$state.focusedDate,
              monthTitleHeight = _this$state.monthTitleHeight;

          if (this.isHorizontal() && (orientation !== prevProps.orientation || daySize !== prevProps.daySize)) {
            var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
            var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarWeeks))) * (daySize - 1);
            var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;
            this.adjustDayPickerHeight(newMonthHeight);
          }

          if (!prevProps.isFocused && isFocused && !focusedDate) {
            this.container.focus();
          }
        }

        return componentDidUpdate;
      }()
    }, {
      key: "componentWillUnmount",
      value: function () {
        function componentWillUnmount() {
          clearTimeout(this.setCalendarInfoWidthTimeout);
        }

        return componentWillUnmount;
      }()
    }, {
      key: "onKeyDown",
      value: function () {
        function onKeyDown(e) {
          e.stopPropagation();

          if (!constants$4.MODIFIER_KEY_NAMES.has(e.key)) {
            this.throttledKeyDown(e);
          }
        }

        return onKeyDown;
      }()
    }, {
      key: "onFinalKeyDown",
      value: function () {
        function onFinalKeyDown(e) {
          this.setState({
            withMouseInteractions: false
          });
          var _this$props3 = this.props,
              onBlur = _this$props3.onBlur,
              onTab = _this$props3.onTab,
              onShiftTab = _this$props3.onShiftTab,
              isRTL = _this$props3.isRTL;
          var _this$state2 = this.state,
              focusedDate = _this$state2.focusedDate,
              showKeyboardShortcuts = _this$state2.showKeyboardShortcuts;
          if (!focusedDate) return;
          var newFocusedDate = focusedDate.clone();
          var didTransitionMonth = false; // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
          // return it to wherever it was before when the panel was opened

          var activeElement = (0, _getActiveElement["default"])();

          var onKeyboardShortcutsPanelClose = function () {
            function onKeyboardShortcutsPanelClose() {
              if (activeElement) activeElement.focus();
            }

            return onKeyboardShortcutsPanelClose;
          }();

          switch (e.key) {
            case 'ArrowUp':
              e.preventDefault();
              newFocusedDate.subtract(1, 'week');
              didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
              break;

            case 'ArrowLeft':
              e.preventDefault();

              if (isRTL) {
                newFocusedDate.add(1, 'day');
              } else {
                newFocusedDate.subtract(1, 'day');
              }

              didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
              break;

            case 'Home':
              e.preventDefault();
              newFocusedDate.startOf('week');
              didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
              break;

            case 'PageUp':
              e.preventDefault();
              newFocusedDate.subtract(1, 'month');
              didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
              break;

            case 'ArrowDown':
              e.preventDefault();
              newFocusedDate.add(1, 'week');
              didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
              break;

            case 'ArrowRight':
              e.preventDefault();

              if (isRTL) {
                newFocusedDate.subtract(1, 'day');
              } else {
                newFocusedDate.add(1, 'day');
              }

              didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
              break;

            case 'End':
              e.preventDefault();
              newFocusedDate.endOf('week');
              didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
              break;

            case 'PageDown':
              e.preventDefault();
              newFocusedDate.add(1, 'month');
              didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
              break;

            case '?':
              this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
              break;

            case 'Escape':
              if (showKeyboardShortcuts) {
                this.closeKeyboardShortcutsPanel();
              } else {
                onBlur(e);
              }

              break;

            case 'Tab':
              if (e.shiftKey) {
                onShiftTab();
              } else {
                onTab(e);
              }

              break;

            default:
              break;
          } // If there was a month transition, do not update the focused date until the transition has
          // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
          // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition


          if (!didTransitionMonth) {
            this.setState({
              focusedDate: newFocusedDate
            });
          }
        }

        return onFinalKeyDown;
      }()
    }, {
      key: "onPrevMonthClick",
      value: function () {
        function onPrevMonthClick(e) {
          if (e) e.preventDefault();
          this.onPrevMonthTransition();
        }

        return onPrevMonthClick;
      }()
    }, {
      key: "onPrevMonthTransition",
      value: function () {
        function onPrevMonthTransition(nextFocusedDate) {
          var _this$props4 = this.props,
              daySize = _this$props4.daySize,
              isRTL = _this$props4.isRTL,
              numberOfMonths = _this$props4.numberOfMonths;
          var _this$state3 = this.state,
              calendarMonthWidth = _this$state3.calendarMonthWidth,
              monthTitleHeight = _this$state3.monthTitleHeight;
          var translationValue;

          if (this.isVertical()) {
            var calendarMonthWeeksHeight = this.calendarMonthWeeks[0] * (daySize - 1);
            translationValue = monthTitleHeight + calendarMonthWeeksHeight + 1;
          } else if (this.isHorizontal()) {
            translationValue = calendarMonthWidth;

            if (isRTL) {
              translationValue = -2 * calendarMonthWidth;
            }

            var visibleCalendarWeeks = this.calendarMonthWeeks.slice(0, numberOfMonths);

            var _calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarWeeks))) * (daySize - 1);

            var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight + 1;
            this.adjustDayPickerHeight(newMonthHeight);
          }

          this.setState({
            monthTransition: PREV_TRANSITION,
            translationValue: translationValue,
            focusedDate: null,
            nextFocusedDate: nextFocusedDate
          });
        }

        return onPrevMonthTransition;
      }()
    }, {
      key: "onMonthChange",
      value: function () {
        function onMonthChange(currentMonth) {
          this.setCalendarMonthWeeks(currentMonth);
          this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
          // properly rerenders the CalendarMonthGrid

          this.setState({
            monthTransition: MONTH_SELECTION_TRANSITION,
            translationValue: 0.00001,
            focusedDate: null,
            nextFocusedDate: currentMonth,
            currentMonth: currentMonth
          });
        }

        return onMonthChange;
      }()
    }, {
      key: "onYearChange",
      value: function () {
        function onYearChange(currentMonth) {
          this.setCalendarMonthWeeks(currentMonth);
          this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
          // properly rerenders the CalendarMonthGrid

          this.setState({
            monthTransition: YEAR_SELECTION_TRANSITION,
            translationValue: 0.0001,
            focusedDate: null,
            nextFocusedDate: currentMonth,
            currentMonth: currentMonth
          });
        }

        return onYearChange;
      }()
    }, {
      key: "onNextMonthClick",
      value: function () {
        function onNextMonthClick(e) {
          if (e) e.preventDefault();
          this.onNextMonthTransition();
        }

        return onNextMonthClick;
      }()
    }, {
      key: "onNextMonthTransition",
      value: function () {
        function onNextMonthTransition(nextFocusedDate) {
          var _this$props5 = this.props,
              isRTL = _this$props5.isRTL,
              numberOfMonths = _this$props5.numberOfMonths,
              daySize = _this$props5.daySize;
          var _this$state4 = this.state,
              calendarMonthWidth = _this$state4.calendarMonthWidth,
              monthTitleHeight = _this$state4.monthTitleHeight;
          var translationValue;

          if (this.isVertical()) {
            var firstVisibleMonthWeeks = this.calendarMonthWeeks[1];
            var calendarMonthWeeksHeight = firstVisibleMonthWeeks * (daySize - 1);
            translationValue = -(monthTitleHeight + calendarMonthWeeksHeight + 1);
          }

          if (this.isHorizontal()) {
            translationValue = -calendarMonthWidth;

            if (isRTL) {
              translationValue = 0;
            }

            var visibleCalendarWeeks = this.calendarMonthWeeks.slice(2, numberOfMonths + 2);

            var _calendarMonthWeeksHeight2 = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarWeeks))) * (daySize - 1);

            var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight2 + 1;
            this.adjustDayPickerHeight(newMonthHeight);
          }

          this.setState({
            monthTransition: NEXT_TRANSITION,
            translationValue: translationValue,
            focusedDate: null,
            nextFocusedDate: nextFocusedDate
          });
        }

        return onNextMonthTransition;
      }()
    }, {
      key: "getFirstDayOfWeek",
      value: function () {
        function getFirstDayOfWeek() {
          var firstDayOfWeek = this.props.firstDayOfWeek;

          if (firstDayOfWeek == null) {
            return _moment["default"].localeData().firstDayOfWeek();
          }

          return firstDayOfWeek;
        }

        return getFirstDayOfWeek;
      }()
    }, {
      key: "getFirstVisibleIndex",
      value: function () {
        function getFirstVisibleIndex() {
          var orientation = this.props.orientation;
          var monthTransition = this.state.monthTransition;
          if (orientation === constants$4.VERTICAL_SCROLLABLE) return 0;
          var firstVisibleMonthIndex = 1;

          if (monthTransition === PREV_TRANSITION) {
            firstVisibleMonthIndex -= 1;
          } else if (monthTransition === NEXT_TRANSITION) {
            firstVisibleMonthIndex += 1;
          }

          return firstVisibleMonthIndex;
        }

        return getFirstVisibleIndex;
      }()
    }, {
      key: "getFocusedDay",
      value: function () {
        function getFocusedDay(newMonth) {
          var _this$props6 = this.props,
              getFirstFocusableDay = _this$props6.getFirstFocusableDay,
              numberOfMonths = _this$props6.numberOfMonths;
          var focusedDate;

          if (getFirstFocusableDay) {
            focusedDate = getFirstFocusableDay(newMonth);
          }

          if (newMonth && (!focusedDate || !(0, _isDayVisible["default"])(focusedDate, newMonth, numberOfMonths))) {
            focusedDate = newMonth.clone().startOf('month');
          }

          return focusedDate;
        }

        return getFocusedDay;
      }()
    }, {
      key: "setMonthTitleHeight",
      value: function () {
        function setMonthTitleHeight(monthTitleHeight) {
          var _this3 = this;

          this.setState({
            monthTitleHeight: monthTitleHeight
          }, function () {
            _this3.calculateAndSetDayPickerHeight();
          });
        }

        return setMonthTitleHeight;
      }()
    }, {
      key: "setCalendarMonthWeeks",
      value: function () {
        function setCalendarMonthWeeks(currentMonth) {
          var numberOfMonths = this.props.numberOfMonths;
          this.calendarMonthWeeks = [];
          var month = currentMonth.clone().subtract(1, 'months');
          var firstDayOfWeek = this.getFirstDayOfWeek();

          for (var i = 0; i < numberOfMonths + 2; i += 1) {
            var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(month, firstDayOfWeek);
            this.calendarMonthWeeks.push(numberOfWeeks);
            month = month.add(1, 'months');
          }
        }

        return setCalendarMonthWeeks;
      }()
    }, {
      key: "setContainerRef",
      value: function () {
        function setContainerRef(ref) {
          this.container = ref;
        }

        return setContainerRef;
      }()
    }, {
      key: "setCalendarInfoRef",
      value: function () {
        function setCalendarInfoRef(ref) {
          this.calendarInfo = ref;
        }

        return setCalendarInfoRef;
      }()
    }, {
      key: "setTransitionContainerRef",
      value: function () {
        function setTransitionContainerRef(ref) {
          this.transitionContainer = ref;
        }

        return setTransitionContainerRef;
      }()
    }, {
      key: "maybeTransitionNextMonth",
      value: function () {
        function maybeTransitionNextMonth(newFocusedDate) {
          var numberOfMonths = this.props.numberOfMonths;
          var _this$state5 = this.state,
              currentMonth = _this$state5.currentMonth,
              focusedDate = _this$state5.focusedDate;
          var newFocusedDateMonth = newFocusedDate.month();
          var focusedDateMonth = focusedDate.month();
          var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);

          if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
            this.onNextMonthTransition(newFocusedDate);
            return true;
          }

          return false;
        }

        return maybeTransitionNextMonth;
      }()
    }, {
      key: "maybeTransitionPrevMonth",
      value: function () {
        function maybeTransitionPrevMonth(newFocusedDate) {
          var numberOfMonths = this.props.numberOfMonths;
          var _this$state6 = this.state,
              currentMonth = _this$state6.currentMonth,
              focusedDate = _this$state6.focusedDate;
          var newFocusedDateMonth = newFocusedDate.month();
          var focusedDateMonth = focusedDate.month();
          var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);

          if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
            this.onPrevMonthTransition(newFocusedDate);
            return true;
          }

          return false;
        }

        return maybeTransitionPrevMonth;
      }()
    }, {
      key: "multiplyScrollableMonths",
      value: function () {
        function multiplyScrollableMonths(e) {
          var onMultiplyScrollableMonths = this.props.onMultiplyScrollableMonths;
          if (e) e.preventDefault();
          if (onMultiplyScrollableMonths) onMultiplyScrollableMonths(e);
          this.setState(function (_ref2) {
            var scrollableMonthMultiple = _ref2.scrollableMonthMultiple;
            return {
              scrollableMonthMultiple: scrollableMonthMultiple + 1
            };
          });
        }

        return multiplyScrollableMonths;
      }()
    }, {
      key: "isHorizontal",
      value: function () {
        function isHorizontal() {
          var orientation = this.props.orientation;
          return orientation === constants$4.HORIZONTAL_ORIENTATION;
        }

        return isHorizontal;
      }()
    }, {
      key: "isVertical",
      value: function () {
        function isVertical() {
          var orientation = this.props.orientation;
          return orientation === constants$4.VERTICAL_ORIENTATION || orientation === constants$4.VERTICAL_SCROLLABLE;
        }

        return isVertical;
      }()
    }, {
      key: "updateStateAfterMonthTransition",
      value: function () {
        function updateStateAfterMonthTransition() {
          var _this4 = this;

          var _this$props7 = this.props,
              onPrevMonthClick = _this$props7.onPrevMonthClick,
              onNextMonthClick = _this$props7.onNextMonthClick,
              numberOfMonths = _this$props7.numberOfMonths,
              onMonthChange = _this$props7.onMonthChange,
              onYearChange = _this$props7.onYearChange,
              isRTL = _this$props7.isRTL;
          var _this$state7 = this.state,
              currentMonth = _this$state7.currentMonth,
              monthTransition = _this$state7.monthTransition,
              focusedDate = _this$state7.focusedDate,
              nextFocusedDate = _this$state7.nextFocusedDate,
              withMouseInteractions = _this$state7.withMouseInteractions,
              calendarMonthWidth = _this$state7.calendarMonthWidth;
          if (!monthTransition) return;
          var newMonth = currentMonth.clone();
          var firstDayOfWeek = this.getFirstDayOfWeek();

          if (monthTransition === PREV_TRANSITION) {
            newMonth.subtract(1, 'month');
            if (onPrevMonthClick) onPrevMonthClick(newMonth);
            var newInvisibleMonth = newMonth.clone().subtract(1, 'month');
            var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(newInvisibleMonth, firstDayOfWeek);
            this.calendarMonthWeeks = [numberOfWeeks].concat(_toConsumableArray(this.calendarMonthWeeks.slice(0, -1)));
          } else if (monthTransition === NEXT_TRANSITION) {
            newMonth.add(1, 'month');
            if (onNextMonthClick) onNextMonthClick(newMonth);

            var _newInvisibleMonth = newMonth.clone().add(numberOfMonths, 'month');

            var _numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(_newInvisibleMonth, firstDayOfWeek);

            this.calendarMonthWeeks = _toConsumableArray(this.calendarMonthWeeks.slice(1)).concat([_numberOfWeeks]);
          } else if (monthTransition === MONTH_SELECTION_TRANSITION) {
            if (onMonthChange) onMonthChange(newMonth);
          } else if (monthTransition === YEAR_SELECTION_TRANSITION) {
            if (onYearChange) onYearChange(newMonth);
          }

          var newFocusedDate = null;

          if (nextFocusedDate) {
            newFocusedDate = nextFocusedDate;
          } else if (!focusedDate && !withMouseInteractions) {
            newFocusedDate = this.getFocusedDay(newMonth);
          }

          this.setState({
            currentMonth: newMonth,
            monthTransition: null,
            translationValue: isRTL && this.isHorizontal() ? -calendarMonthWidth : 0,
            nextFocusedDate: null,
            focusedDate: newFocusedDate
          }, function () {
            // we don't want to focus on the relevant calendar day after a month transition
            // if the user is navigating around using a mouse
            if (withMouseInteractions) {
              var activeElement = (0, _getActiveElement["default"])();

              if (activeElement && activeElement !== document.body && _this4.container.contains(activeElement) && activeElement.blur) {
                activeElement.blur();
              }
            }
          });
        }

        return updateStateAfterMonthTransition;
      }()
    }, {
      key: "adjustDayPickerHeight",
      value: function () {
        function adjustDayPickerHeight(newMonthHeight) {
          var _this5 = this;

          var monthHeight = newMonthHeight + MONTH_PADDING;

          if (monthHeight !== this.calendarMonthGridHeight) {
            this.transitionContainer.style.height = "".concat(monthHeight, "px");

            if (!this.calendarMonthGridHeight) {
              setTimeout(function () {
                _this5.setState({
                  hasSetHeight: true
                });
              }, 0);
            }

            this.calendarMonthGridHeight = monthHeight;
          }
        }

        return adjustDayPickerHeight;
      }()
    }, {
      key: "calculateAndSetDayPickerHeight",
      value: function () {
        function calculateAndSetDayPickerHeight() {
          var _this$props8 = this.props,
              daySize = _this$props8.daySize,
              numberOfMonths = _this$props8.numberOfMonths;
          var monthTitleHeight = this.state.monthTitleHeight;
          var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
          var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarWeeks))) * (daySize - 1);
          var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;

          if (this.isHorizontal()) {
            this.adjustDayPickerHeight(newMonthHeight);
          }
        }

        return calculateAndSetDayPickerHeight;
      }()
    }, {
      key: "openKeyboardShortcutsPanel",
      value: function () {
        function openKeyboardShortcutsPanel(onCloseCallBack) {
          this.setState({
            showKeyboardShortcuts: true,
            onKeyboardShortcutsPanelClose: onCloseCallBack
          });
        }

        return openKeyboardShortcutsPanel;
      }()
    }, {
      key: "closeKeyboardShortcutsPanel",
      value: function () {
        function closeKeyboardShortcutsPanel() {
          var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

          if (onKeyboardShortcutsPanelClose) {
            onKeyboardShortcutsPanelClose();
          }

          this.setState({
            onKeyboardShortcutsPanelClose: null,
            showKeyboardShortcuts: false
          });
        }

        return closeKeyboardShortcutsPanel;
      }()
    }, {
      key: "renderNavigation",
      value: function () {
        function renderNavigation() {
          var _this$props9 = this.props,
              disablePrev = _this$props9.disablePrev,
              disableNext = _this$props9.disableNext,
              navPrev = _this$props9.navPrev,
              navNext = _this$props9.navNext,
              noNavButtons = _this$props9.noNavButtons,
              orientation = _this$props9.orientation,
              phrases = _this$props9.phrases,
              isRTL = _this$props9.isRTL;

          if (noNavButtons) {
            return null;
          }

          var onNextMonthClick = orientation === constants$4.VERTICAL_SCROLLABLE ? this.multiplyScrollableMonths : this.onNextMonthClick;
          return _react["default"].createElement(_DayPickerNavigation["default"], {
            disablePrev: disablePrev,
            disableNext: disableNext,
            onPrevMonthClick: this.onPrevMonthClick,
            onNextMonthClick: onNextMonthClick,
            navPrev: navPrev,
            navNext: navNext,
            orientation: orientation,
            phrases: phrases,
            isRTL: isRTL
          });
        }

        return renderNavigation;
      }()
    }, {
      key: "renderWeekHeader",
      value: function () {
        function renderWeekHeader(index) {
          var _this$props10 = this.props,
              daySize = _this$props10.daySize,
              horizontalMonthPadding = _this$props10.horizontalMonthPadding,
              orientation = _this$props10.orientation,
              weekDayFormat = _this$props10.weekDayFormat,
              styles = _this$props10.styles;
          var calendarMonthWidth = this.state.calendarMonthWidth;
          var verticalScrollable = orientation === constants$4.VERTICAL_SCROLLABLE;
          var horizontalStyle = {
            left: index * calendarMonthWidth
          };
          var verticalStyle = {
            marginLeft: -calendarMonthWidth / 2
          };
          var weekHeaderStyle = {}; // no styles applied to the vertical-scrollable orientation

          if (this.isHorizontal()) {
            weekHeaderStyle = horizontalStyle;
          } else if (this.isVertical() && !verticalScrollable) {
            weekHeaderStyle = verticalStyle;
          }

          var firstDayOfWeek = this.getFirstDayOfWeek();
          var header = [];

          for (var i = 0; i < 7; i += 1) {
            header.push(_react["default"].createElement("li", _extends({
              key: i
            }, (0, withStyles_1.css)(styles.DayPicker_weekHeader_li, {
              width: daySize
            })), _react["default"].createElement("small", null, (0, _moment["default"])().day((i + firstDayOfWeek) % 7).format(weekDayFormat))));
          }

          return _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.DayPicker_weekHeader, this.isVertical() && styles.DayPicker_weekHeader__vertical, verticalScrollable && styles.DayPicker_weekHeader__verticalScrollable, weekHeaderStyle, {
            padding: "0 ".concat(horizontalMonthPadding, "px")
          }), {
            key: "week-".concat(index)
          }), _react["default"].createElement("ul", (0, withStyles_1.css)(styles.DayPicker_weekHeader_ul), header));
        }

        return renderWeekHeader;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this6 = this;

          var _this$state8 = this.state,
              calendarMonthWidth = _this$state8.calendarMonthWidth,
              currentMonth = _this$state8.currentMonth,
              monthTransition = _this$state8.monthTransition,
              translationValue = _this$state8.translationValue,
              scrollableMonthMultiple = _this$state8.scrollableMonthMultiple,
              focusedDate = _this$state8.focusedDate,
              showKeyboardShortcuts = _this$state8.showKeyboardShortcuts,
              isTouch = _this$state8.isTouchDevice,
              hasSetHeight = _this$state8.hasSetHeight,
              calendarInfoWidth = _this$state8.calendarInfoWidth,
              monthTitleHeight = _this$state8.monthTitleHeight;
          var _this$props11 = this.props,
              enableOutsideDays = _this$props11.enableOutsideDays,
              numberOfMonths = _this$props11.numberOfMonths,
              orientation = _this$props11.orientation,
              modifiers = _this$props11.modifiers,
              withPortal = _this$props11.withPortal,
              onDayClick = _this$props11.onDayClick,
              onDayMouseEnter = _this$props11.onDayMouseEnter,
              onDayMouseLeave = _this$props11.onDayMouseLeave,
              firstDayOfWeek = _this$props11.firstDayOfWeek,
              renderMonthText = _this$props11.renderMonthText,
              renderCalendarDay = _this$props11.renderCalendarDay,
              renderDayContents = _this$props11.renderDayContents,
              renderCalendarInfo = _this$props11.renderCalendarInfo,
              renderMonthElement = _this$props11.renderMonthElement,
              calendarInfoPosition = _this$props11.calendarInfoPosition,
              hideKeyboardShortcutsPanel = _this$props11.hideKeyboardShortcutsPanel,
              onOutsideClick = _this$props11.onOutsideClick,
              monthFormat = _this$props11.monthFormat,
              daySize = _this$props11.daySize,
              isFocused = _this$props11.isFocused,
              isRTL = _this$props11.isRTL,
              styles = _this$props11.styles,
              theme = _this$props11.theme,
              phrases = _this$props11.phrases,
              verticalHeight = _this$props11.verticalHeight,
              dayAriaLabelFormat = _this$props11.dayAriaLabelFormat,
              noBorder = _this$props11.noBorder,
              transitionDuration = _this$props11.transitionDuration,
              verticalBorderSpacing = _this$props11.verticalBorderSpacing,
              horizontalMonthPadding = _this$props11.horizontalMonthPadding;
          var dayPickerHorizontalPadding = theme.reactDates.spacing.dayPickerHorizontalPadding;
          var isHorizontal = this.isHorizontal();
          var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
          var weekHeaders = [];

          for (var i = 0; i < numOfWeekHeaders; i += 1) {
            weekHeaders.push(this.renderWeekHeader(i));
          }

          var verticalScrollable = orientation === constants$4.VERTICAL_SCROLLABLE;
          var height;

          if (isHorizontal) {
            height = this.calendarMonthGridHeight;
          } else if (this.isVertical() && !verticalScrollable && !withPortal) {
            // If the user doesn't set a desired height,
            // we default back to this kind of made-up value that generally looks good
            height = verticalHeight || 1.75 * calendarMonthWidth;
          }

          var isCalendarMonthGridAnimating = monthTransition !== null;
          var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
          var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;

          if (this.isVertical()) {
            keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
          }

          var shouldAnimateHeight = isHorizontal && hasSetHeight;
          var calendarInfoPositionTop = calendarInfoPosition === constants$4.INFO_POSITION_TOP;
          var calendarInfoPositionBottom = calendarInfoPosition === constants$4.INFO_POSITION_BOTTOM;
          var calendarInfoPositionBefore = calendarInfoPosition === constants$4.INFO_POSITION_BEFORE;
          var calendarInfoPositionAfter = calendarInfoPosition === constants$4.INFO_POSITION_AFTER;
          var calendarInfoIsInline = calendarInfoPositionBefore || calendarInfoPositionAfter;

          var calendarInfo = renderCalendarInfo && _react["default"].createElement("div", _extends({
            ref: this.setCalendarInfoRef
          }, (0, withStyles_1.css)(calendarInfoIsInline && styles.DayPicker_calendarInfo__horizontal)), renderCalendarInfo());

          var calendarInfoPanelWidth = renderCalendarInfo && calendarInfoIsInline ? calendarInfoWidth : 0;
          var firstVisibleMonthIndex = this.getFirstVisibleIndex();
          var wrapperHorizontalWidth = calendarMonthWidth * numberOfMonths + 2 * dayPickerHorizontalPadding; // Adding `1px` because of whitespace between 2 inline-block

          var fullHorizontalWidth = wrapperHorizontalWidth + calendarInfoPanelWidth + 1;
          var transitionContainerStyle = {
            width: isHorizontal && wrapperHorizontalWidth,
            height: height
          };
          var dayPickerWrapperStyle = {
            width: isHorizontal && wrapperHorizontalWidth
          };
          var dayPickerStyle = {
            width: isHorizontal && fullHorizontalWidth,
            // These values are to center the datepicker (approximately) on the page
            marginLeft: isHorizontal && withPortal ? -fullHorizontalWidth / 2 : null,
            marginTop: isHorizontal && withPortal ? -calendarMonthWidth / 2 : null
          };
          return _react["default"].createElement("div", _extends({
            role: "application",
            "aria-label": phrases.calendarLabel
          }, (0, withStyles_1.css)(styles.DayPicker, isHorizontal && styles.DayPicker__horizontal, verticalScrollable && styles.DayPicker__verticalScrollable, isHorizontal && withPortal && styles.DayPicker_portal__horizontal, this.isVertical() && withPortal && styles.DayPicker_portal__vertical, dayPickerStyle, !monthTitleHeight && styles.DayPicker__hidden, !noBorder && styles.DayPicker__withBorder)), _react["default"].createElement(_reactOutsideClickHandler["default"], {
            onOutsideClick: onOutsideClick
          }, (calendarInfoPositionTop || calendarInfoPositionBefore) && calendarInfo, _react["default"].createElement("div", (0, withStyles_1.css)(dayPickerWrapperStyle, calendarInfoIsInline && isHorizontal && styles.DayPicker_wrapper__horizontal), _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.DayPicker_weekHeaders, isHorizontal && styles.DayPicker_weekHeaders__horizontal), {
            "aria-hidden": "true",
            role: "presentation"
          }), weekHeaders), _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.DayPicker_focusRegion), {
            ref: this.setContainerRef,
            onClick: function () {
              function onClick(e) {
                e.stopPropagation();
              }

              return onClick;
            }(),
            onKeyDown: this.onKeyDown,
            onMouseUp: function () {
              function onMouseUp() {
                _this6.setState({
                  withMouseInteractions: true
                });
              }

              return onMouseUp;
            }(),
            role: "region",
            tabIndex: -1
          }), !verticalScrollable && this.renderNavigation(), _react["default"].createElement("div", _extends({}, (0, withStyles_1.css)(styles.DayPicker_transitionContainer, shouldAnimateHeight && styles.DayPicker_transitionContainer__horizontal, this.isVertical() && styles.DayPicker_transitionContainer__vertical, verticalScrollable && styles.DayPicker_transitionContainer__verticalScrollable, transitionContainerStyle), {
            ref: this.setTransitionContainerRef
          }), _react["default"].createElement(_CalendarMonthGrid["default"], {
            setMonthTitleHeight: !monthTitleHeight ? this.setMonthTitleHeight : undefined,
            translationValue: translationValue,
            enableOutsideDays: enableOutsideDays,
            firstVisibleMonthIndex: firstVisibleMonthIndex,
            initialMonth: currentMonth,
            isAnimating: isCalendarMonthGridAnimating,
            modifiers: modifiers,
            orientation: orientation,
            numberOfMonths: numberOfMonths * scrollableMonthMultiple,
            onDayClick: onDayClick,
            onDayMouseEnter: onDayMouseEnter,
            onDayMouseLeave: onDayMouseLeave,
            onMonthChange: this.onMonthChange,
            onYearChange: this.onYearChange,
            renderMonthText: renderMonthText,
            renderCalendarDay: renderCalendarDay,
            renderDayContents: renderDayContents,
            renderMonthElement: renderMonthElement,
            onMonthTransitionEnd: this.updateStateAfterMonthTransition,
            monthFormat: monthFormat,
            daySize: daySize,
            firstDayOfWeek: firstDayOfWeek,
            isFocused: shouldFocusDate,
            focusedDate: focusedDate,
            phrases: phrases,
            isRTL: isRTL,
            dayAriaLabelFormat: dayAriaLabelFormat,
            transitionDuration: transitionDuration,
            verticalBorderSpacing: verticalBorderSpacing,
            horizontalMonthPadding: horizontalMonthPadding
          }), verticalScrollable && this.renderNavigation()), !isTouch && !hideKeyboardShortcutsPanel && _react["default"].createElement(_DayPickerKeyboardShortcuts["default"], {
            block: this.isVertical() && !withPortal,
            buttonLocation: keyboardShortcutButtonLocation,
            showKeyboardShortcutsPanel: showKeyboardShortcuts,
            openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
            closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
            phrases: phrases
          }))), (calendarInfoPositionBottom || calendarInfoPositionAfter) && calendarInfo));
        }

        return render;
      }()
    }]);

    return DayPicker;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports.PureDayPicker = DayPicker;
  DayPicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DayPicker.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref3) {
    var _ref3$reactDates = _ref3.reactDates,
        color = _ref3$reactDates.color,
        font = _ref3$reactDates.font,
        noScrollBarOnVerticalScrollable = _ref3$reactDates.noScrollBarOnVerticalScrollable,
        spacing = _ref3$reactDates.spacing,
        zIndex = _ref3$reactDates.zIndex;
    return {
      DayPicker: {
        background: color.background,
        position: 'relative',
        textAlign: (0, _noflip["default"])('left')
      },
      DayPicker__horizontal: {
        background: color.background
      },
      DayPicker__verticalScrollable: {
        height: '100%'
      },
      DayPicker__hidden: {
        visibility: 'hidden'
      },
      DayPicker__withBorder: {
        boxShadow: (0, _noflip["default"])('0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)'),
        borderRadius: 3
      },
      DayPicker_portal__horizontal: {
        boxShadow: 'none',
        position: 'absolute',
        left: (0, _noflip["default"])('50%'),
        top: '50%'
      },
      DayPicker_portal__vertical: {
        position: 'initial'
      },
      DayPicker_focusRegion: {
        outline: 'none'
      },
      DayPicker_calendarInfo__horizontal: {
        display: 'inline-block',
        verticalAlign: 'top'
      },
      DayPicker_wrapper__horizontal: {
        display: 'inline-block',
        verticalAlign: 'top'
      },
      DayPicker_weekHeaders: {
        position: 'relative'
      },
      DayPicker_weekHeaders__horizontal: {
        marginLeft: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
      },
      DayPicker_weekHeader: {
        color: color.placeholderText,
        position: 'absolute',
        top: 62,
        zIndex: zIndex + 2,
        textAlign: (0, _noflip["default"])('left')
      },
      DayPicker_weekHeader__vertical: {
        left: (0, _noflip["default"])('50%')
      },
      DayPicker_weekHeader__verticalScrollable: {
        top: 0,
        display: 'table-row',
        borderBottom: "1px solid ".concat(color.core.border),
        background: color.background,
        marginLeft: (0, _noflip["default"])(0),
        left: (0, _noflip["default"])(0),
        width: '100%',
        textAlign: 'center'
      },
      DayPicker_weekHeader_ul: {
        listStyle: 'none',
        margin: '1px 0',
        paddingLeft: (0, _noflip["default"])(0),
        paddingRight: (0, _noflip["default"])(0),
        fontSize: font.size
      },
      DayPicker_weekHeader_li: {
        display: 'inline-block',
        textAlign: 'center'
      },
      DayPicker_transitionContainer: {
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 3
      },
      DayPicker_transitionContainer__horizontal: {
        transition: 'height 0.2s ease-in-out'
      },
      DayPicker_transitionContainer__vertical: {
        width: '100%'
      },
      DayPicker_transitionContainer__verticalScrollable: _objectSpread({
        paddingTop: 20,
        height: '100%',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: (0, _noflip["default"])(0),
        left: (0, _noflip["default"])(0),
        overflowY: 'scroll'
      }, noScrollBarOnVerticalScrollable && {
        '-webkitOverflowScrolling': 'touch',
        '::-webkit-scrollbar': {
          '-webkit-appearance': 'none',
          display: 'none'
        }
      })
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(DayPicker);

  exports["default"] = _default;
});
unwrapExports(DayPicker_1);
var DayPicker_2 = DayPicker_1.PureDayPicker;
var DayPicker_3 = DayPicker_1.defaultProps;
var DayPickerRangeController_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _moment = _interopRequireDefault(moment);

  var _object = _interopRequireDefault(object_values);

  var _isTouchDevice = _interopRequireDefault(build$2);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _isInclusivelyAfterDay = _interopRequireDefault(isInclusivelyAfterDay_1);

  var _isNextDay = _interopRequireDefault(isNextDay_1);

  var _isSameDay = _interopRequireDefault(isSameDay_1);

  var _isAfterDay = _interopRequireDefault(isAfterDay_1);

  var _isBeforeDay = _interopRequireDefault(isBeforeDay_1);

  var _getVisibleDays = _interopRequireDefault(getVisibleDays_1);

  var _isDayVisible = _interopRequireDefault(isDayVisible_1);

  var _getSelectedDateOffset = _interopRequireDefault(getSelectedDateOffset_1);

  var _toISODateString = _interopRequireDefault(toISODateString_1);

  var _toISOMonthString = _interopRequireDefault(toISOMonthString_1);

  var _DisabledShape = _interopRequireDefault(DisabledShape);

  var _FocusedInputShape = _interopRequireDefault(FocusedInputShape);

  var _ScrollableOrientationShape = _interopRequireDefault(ScrollableOrientationShape);

  var _DayOfWeekShape = _interopRequireDefault(DayOfWeekShape);

  var _CalendarInfoPositionShape = _interopRequireDefault(CalendarInfoPositionShape);

  var _DayPicker = _interopRequireDefault(DayPicker_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
    startDate: _reactMomentProptypes["default"].momentObj,
    endDate: _reactMomentProptypes["default"].momentObj,
    onDatesChange: _propTypes["default"].func,
    startDateOffset: _propTypes["default"].func,
    endDateOffset: _propTypes["default"].func,
    minDate: _reactMomentProptypes["default"].momentObj,
    maxDate: _reactMomentProptypes["default"].momentObj,
    focusedInput: _FocusedInputShape["default"],
    onFocusChange: _propTypes["default"].func,
    onClose: _propTypes["default"].func,
    keepOpenOnDateSelect: _propTypes["default"].bool,
    minimumNights: _propTypes["default"].number,
    disabled: _DisabledShape["default"],
    isOutsideRange: _propTypes["default"].func,
    isDayBlocked: _propTypes["default"].func,
    isDayHighlighted: _propTypes["default"].func,
    // DayPicker props
    renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    enableOutsideDays: _propTypes["default"].bool,
    numberOfMonths: _propTypes["default"].number,
    orientation: _ScrollableOrientationShape["default"],
    withPortal: _propTypes["default"].bool,
    initialVisibleMonth: _propTypes["default"].func,
    hideKeyboardShortcutsPanel: _propTypes["default"].bool,
    daySize: airbnbPropTypes.nonNegativeInteger,
    noBorder: _propTypes["default"].bool,
    verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
    horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
    navPrev: _propTypes["default"].node,
    navNext: _propTypes["default"].node,
    noNavButtons: _propTypes["default"].bool,
    onPrevMonthClick: _propTypes["default"].func,
    onNextMonthClick: _propTypes["default"].func,
    onOutsideClick: _propTypes["default"].func,
    renderCalendarDay: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    renderCalendarInfo: _propTypes["default"].func,
    calendarInfoPosition: _CalendarInfoPositionShape["default"],
    firstDayOfWeek: _DayOfWeekShape["default"],
    verticalHeight: airbnbPropTypes.nonNegativeInteger,
    transitionDuration: airbnbPropTypes.nonNegativeInteger,
    // accessibility
    onBlur: _propTypes["default"].func,
    isFocused: _propTypes["default"].bool,
    showKeyboardShortcuts: _propTypes["default"].bool,
    onTab: _propTypes["default"].func,
    onShiftTab: _propTypes["default"].func,
    // i18n
    monthFormat: _propTypes["default"].string,
    weekDayFormat: _propTypes["default"].string,
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
    dayAriaLabelFormat: _propTypes["default"].string,
    isRTL: _propTypes["default"].bool
  }) : {};
  var defaultProps = {
    startDate: undefined,
    // TODO: use null
    endDate: undefined,
    // TODO: use null
    minDate: null,
    maxDate: null,
    onDatesChange: function () {
      function onDatesChange() {}

      return onDatesChange;
    }(),
    startDateOffset: undefined,
    endDateOffset: undefined,
    focusedInput: null,
    onFocusChange: function () {
      function onFocusChange() {}

      return onFocusChange;
    }(),
    onClose: function () {
      function onClose() {}

      return onClose;
    }(),
    keepOpenOnDateSelect: false,
    minimumNights: 1,
    disabled: false,
    isOutsideRange: function () {
      function isOutsideRange() {}

      return isOutsideRange;
    }(),
    isDayBlocked: function () {
      function isDayBlocked() {}

      return isDayBlocked;
    }(),
    isDayHighlighted: function () {
      function isDayHighlighted() {}

      return isDayHighlighted;
    }(),
    // DayPicker props
    renderMonthText: null,
    enableOutsideDays: false,
    numberOfMonths: 1,
    orientation: constants$4.HORIZONTAL_ORIENTATION,
    withPortal: false,
    hideKeyboardShortcutsPanel: false,
    initialVisibleMonth: null,
    daySize: constants$4.DAY_SIZE,
    navPrev: null,
    navNext: null,
    noNavButtons: false,
    onPrevMonthClick: function () {
      function onPrevMonthClick() {}

      return onPrevMonthClick;
    }(),
    onNextMonthClick: function () {
      function onNextMonthClick() {}

      return onNextMonthClick;
    }(),
    onOutsideClick: function () {
      function onOutsideClick() {}

      return onOutsideClick;
    }(),
    renderCalendarDay: undefined,
    renderDayContents: null,
    renderCalendarInfo: null,
    renderMonthElement: null,
    calendarInfoPosition: constants$4.INFO_POSITION_BOTTOM,
    firstDayOfWeek: null,
    verticalHeight: null,
    noBorder: false,
    transitionDuration: undefined,
    verticalBorderSpacing: undefined,
    horizontalMonthPadding: 13,
    // accessibility
    onBlur: function () {
      function onBlur() {}

      return onBlur;
    }(),
    isFocused: false,
    showKeyboardShortcuts: false,
    onTab: function () {
      function onTab() {}

      return onTab;
    }(),
    onShiftTab: function () {
      function onShiftTab() {}

      return onShiftTab;
    }(),
    // i18n
    monthFormat: 'MMMM YYYY',
    weekDayFormat: 'dd',
    phrases: defaultPhrases.DayPickerPhrases,
    dayAriaLabelFormat: undefined,
    isRTL: false
  };

  var getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
    if (focusedInput === constants$4.START_DATE) {
      return phrases.chooseAvailableStartDate;
    }

    if (focusedInput === constants$4.END_DATE) {
      return phrases.chooseAvailableEndDate;
    }

    return phrases.chooseAvailableDate;
  };

  var DayPickerRangeController =
  /*#__PURE__*/
  function (_ref) {
    _inherits(DayPickerRangeController, _ref);

    _createClass(DayPickerRangeController, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function DayPickerRangeController(props) {
      var _this;

      _classCallCheck(this, DayPickerRangeController);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DayPickerRangeController).call(this, props));
      _this.isTouchDevice = (0, _isTouchDevice["default"])();
      _this.today = (0, _moment["default"])();
      _this.modifiers = {
        today: function () {
          function today(day) {
            return _this.isToday(day);
          }

          return today;
        }(),
        blocked: function () {
          function blocked(day) {
            return _this.isBlocked(day);
          }

          return blocked;
        }(),
        'blocked-calendar': function () {
          function blockedCalendar(day) {
            return props.isDayBlocked(day);
          }

          return blockedCalendar;
        }(),
        'blocked-out-of-range': function () {
          function blockedOutOfRange(day) {
            return props.isOutsideRange(day);
          }

          return blockedOutOfRange;
        }(),
        'highlighted-calendar': function () {
          function highlightedCalendar(day) {
            return props.isDayHighlighted(day);
          }

          return highlightedCalendar;
        }(),
        valid: function () {
          function valid(day) {
            return !_this.isBlocked(day);
          }

          return valid;
        }(),
        'selected-start': function () {
          function selectedStart(day) {
            return _this.isStartDate(day);
          }

          return selectedStart;
        }(),
        'selected-end': function () {
          function selectedEnd(day) {
            return _this.isEndDate(day);
          }

          return selectedEnd;
        }(),
        'blocked-minimum-nights': function () {
          function blockedMinimumNights(day) {
            return _this.doesNotMeetMinimumNights(day);
          }

          return blockedMinimumNights;
        }(),
        'selected-span': function () {
          function selectedSpan(day) {
            return _this.isInSelectedSpan(day);
          }

          return selectedSpan;
        }(),
        'last-in-range': function () {
          function lastInRange(day) {
            return _this.isLastInRange(day);
          }

          return lastInRange;
        }(),
        hovered: function () {
          function hovered(day) {
            return _this.isHovered(day);
          }

          return hovered;
        }(),
        'hovered-span': function () {
          function hoveredSpan(day) {
            return _this.isInHoveredSpan(day);
          }

          return hoveredSpan;
        }(),
        'hovered-offset': function () {
          function hoveredOffset(day) {
            return _this.isInHoveredSpan(day);
          }

          return hoveredOffset;
        }(),
        'after-hovered-start': function () {
          function afterHoveredStart(day) {
            return _this.isDayAfterHoveredStartDate(day);
          }

          return afterHoveredStart;
        }(),
        'first-day-of-week': function () {
          function firstDayOfWeek(day) {
            return _this.isFirstDayOfWeek(day);
          }

          return firstDayOfWeek;
        }(),
        'last-day-of-week': function () {
          function lastDayOfWeek(day) {
            return _this.isLastDayOfWeek(day);
          }

          return lastDayOfWeek;
        }()
      };

      var _this$getStateForNewM = _this.getStateForNewMonth(props),
          currentMonth = _this$getStateForNewM.currentMonth,
          visibleDays = _this$getStateForNewM.visibleDays; // initialize phrases
      // set the appropriate CalendarDay phrase based on focusedInput


      var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
      _this.state = {
        hoverDate: null,
        currentMonth: currentMonth,
        phrases: _objectSpread({}, props.phrases, {
          chooseAvailableDate: chooseAvailableDate
        }),
        visibleDays: visibleDays,
        disablePrev: _this.shouldDisableMonthNavigation(props.minDate, currentMonth),
        disableNext: _this.shouldDisableMonthNavigation(props.maxDate, currentMonth)
      };
      _this.onDayClick = _this.onDayClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onNextMonthClick = _this.onNextMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onYearChange = _this.onYearChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onMultiplyScrollableMonths = _this.onMultiplyScrollableMonths.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(DayPickerRangeController, [{
      key: "componentWillReceiveProps",
      value: function () {
        function componentWillReceiveProps(nextProps) {
          var _this2 = this;

          var startDate = nextProps.startDate,
              endDate = nextProps.endDate,
              focusedInput = nextProps.focusedInput,
              minimumNights = nextProps.minimumNights,
              isOutsideRange = nextProps.isOutsideRange,
              isDayBlocked = nextProps.isDayBlocked,
              isDayHighlighted = nextProps.isDayHighlighted,
              phrases = nextProps.phrases,
              initialVisibleMonth = nextProps.initialVisibleMonth,
              numberOfMonths = nextProps.numberOfMonths,
              enableOutsideDays = nextProps.enableOutsideDays;
          var _this$props = this.props,
              prevStartDate = _this$props.startDate,
              prevEndDate = _this$props.endDate,
              prevFocusedInput = _this$props.focusedInput,
              prevMinimumNights = _this$props.minimumNights,
              prevIsOutsideRange = _this$props.isOutsideRange,
              prevIsDayBlocked = _this$props.isDayBlocked,
              prevIsDayHighlighted = _this$props.isDayHighlighted,
              prevPhrases = _this$props.phrases,
              prevInitialVisibleMonth = _this$props.initialVisibleMonth,
              prevNumberOfMonths = _this$props.numberOfMonths,
              prevEnableOutsideDays = _this$props.enableOutsideDays;
          var visibleDays = this.state.visibleDays;
          var recomputeOutsideRange = false;
          var recomputeDayBlocked = false;
          var recomputeDayHighlighted = false;

          if (isOutsideRange !== prevIsOutsideRange) {
            this.modifiers['blocked-out-of-range'] = function (day) {
              return isOutsideRange(day);
            };

            recomputeOutsideRange = true;
          }

          if (isDayBlocked !== prevIsDayBlocked) {
            this.modifiers['blocked-calendar'] = function (day) {
              return isDayBlocked(day);
            };

            recomputeDayBlocked = true;
          }

          if (isDayHighlighted !== prevIsDayHighlighted) {
            this.modifiers['highlighted-calendar'] = function (day) {
              return isDayHighlighted(day);
            };

            recomputeDayHighlighted = true;
          }

          var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
          var didStartDateChange = startDate !== prevStartDate;
          var didEndDateChange = endDate !== prevEndDate;
          var didFocusChange = focusedInput !== prevFocusedInput;

          if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocusedInput && didFocusChange) {
            var newMonthState = this.getStateForNewMonth(nextProps);
            var currentMonth = newMonthState.currentMonth;
            visibleDays = newMonthState.visibleDays;
            this.setState({
              currentMonth: currentMonth,
              visibleDays: visibleDays
            });
          }

          var modifiers = {};

          if (didStartDateChange) {
            modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start');
            modifiers = this.addModifier(modifiers, startDate, 'selected-start');

            if (prevStartDate) {
              var startSpan = prevStartDate.clone().add(1, 'day');
              var endSpan = prevStartDate.clone().add(prevMinimumNights + 1, 'days');
              modifiers = this.deleteModifierFromRange(modifiers, startSpan, endSpan, 'after-hovered-start');
            }
          }

          if (didEndDateChange) {
            modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end');
            modifiers = this.addModifier(modifiers, endDate, 'selected-end');
          }

          if (didStartDateChange || didEndDateChange) {
            if (prevStartDate && prevEndDate) {
              modifiers = this.deleteModifierFromRange(modifiers, prevStartDate, prevEndDate.clone().add(1, 'day'), 'selected-span');
            }

            if (startDate && endDate) {
              modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
              modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
            }
          }

          if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
            var _startSpan = startDate.clone().add(1, 'day');

            var _endSpan = startDate.clone().add(minimumNights + 1, 'days');

            modifiers = this.addModifierToRange(modifiers, _startSpan, _endSpan, 'after-hovered-start');
          }

          if (prevMinimumNights > 0) {
            if (didFocusChange || didStartDateChange || minimumNights !== prevMinimumNights) {
              var _startSpan2 = prevStartDate || this.today;

              modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked-minimum-nights');
              modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked');
            }
          }

          if (didFocusChange || recomputePropModifiers) {
            (0, _object["default"])(visibleDays).forEach(function (days) {
              Object.keys(days).forEach(function (day) {
                var momentObj = (0, _moment["default"])(day);
                var isBlocked = false;

                if (didFocusChange || recomputeOutsideRange) {
                  if (isOutsideRange(momentObj)) {
                    modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
                    isBlocked = true;
                  } else {
                    modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
                  }
                }

                if (didFocusChange || recomputeDayBlocked) {
                  if (isDayBlocked(momentObj)) {
                    modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
                    isBlocked = true;
                  } else {
                    modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
                  }
                }

                if (isBlocked) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
                }

                if (didFocusChange || recomputeDayHighlighted) {
                  if (isDayHighlighted(momentObj)) {
                    modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
                  } else {
                    modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
                  }
                }
              });
            });
          }

          if (minimumNights > 0 && startDate && focusedInput === constants$4.END_DATE) {
            modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
            modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked');
          }

          var today = (0, _moment["default"])();

          if (!(0, _isSameDay["default"])(this.today, today)) {
            modifiers = this.deleteModifier(modifiers, this.today, 'today');
            modifiers = this.addModifier(modifiers, today, 'today');
            this.today = today;
          }

          if (Object.keys(modifiers).length > 0) {
            this.setState({
              visibleDays: _objectSpread({}, visibleDays, modifiers)
            });
          }

          if (didFocusChange || phrases !== prevPhrases) {
            // set the appropriate CalendarDay phrase based on focusedInput
            var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
            this.setState({
              phrases: _objectSpread({}, phrases, {
                chooseAvailableDate: chooseAvailableDate
              })
            });
          }
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: "onDayClick",
      value: function () {
        function onDayClick(day, e) {
          var _this$props2 = this.props,
              keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
              minimumNights = _this$props2.minimumNights,
              onBlur = _this$props2.onBlur,
              focusedInput = _this$props2.focusedInput,
              onFocusChange = _this$props2.onFocusChange,
              onClose = _this$props2.onClose,
              onDatesChange = _this$props2.onDatesChange,
              startDateOffset = _this$props2.startDateOffset,
              endDateOffset = _this$props2.endDateOffset,
              disabled = _this$props2.disabled;
          if (e) e.preventDefault();
          if (this.isBlocked(day)) return;
          var _this$props3 = this.props,
              startDate = _this$props3.startDate,
              endDate = _this$props3.endDate;

          if (startDateOffset || endDateOffset) {
            startDate = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
            endDate = (0, _getSelectedDateOffset["default"])(endDateOffset, day);

            if (!keepOpenOnDateSelect) {
              onFocusChange(null);
              onClose({
                startDate: startDate,
                endDate: endDate
              });
            }
          } else if (focusedInput === constants$4.START_DATE) {
            var lastAllowedStartDate = endDate && endDate.clone().subtract(minimumNights, 'days');
            var isStartDateAfterEndDate = (0, _isBeforeDay["default"])(lastAllowedStartDate, day) || (0, _isAfterDay["default"])(startDate, endDate);
            var isEndDateDisabled = disabled === constants$4.END_DATE;

            if (!isEndDateDisabled || !isStartDateAfterEndDate) {
              startDate = day;

              if (isStartDateAfterEndDate) {
                endDate = null;
              }
            }

            if (isEndDateDisabled && !isStartDateAfterEndDate) {
              onFocusChange(null);
              onClose({
                startDate: startDate,
                endDate: endDate
              });
            } else if (!isEndDateDisabled) {
              onFocusChange(constants$4.END_DATE);
            }
          } else if (focusedInput === constants$4.END_DATE) {
            var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');

            if (!startDate) {
              endDate = day;
              onFocusChange(constants$4.START_DATE);
            } else if ((0, _isInclusivelyAfterDay["default"])(day, firstAllowedEndDate)) {
              endDate = day;

              if (!keepOpenOnDateSelect) {
                onFocusChange(null);
                onClose({
                  startDate: startDate,
                  endDate: endDate
                });
              }
            } else if (disabled !== constants$4.START_DATE) {
              startDate = day;
              endDate = null;
            }
          }

          onDatesChange({
            startDate: startDate,
            endDate: endDate
          });
          onBlur();
        }

        return onDayClick;
      }()
    }, {
      key: "onDayMouseEnter",
      value: function () {
        function onDayMouseEnter(day) {
          /* eslint react/destructuring-assignment: 1 */
          if (this.isTouchDevice) return;
          var _this$props4 = this.props,
              startDate = _this$props4.startDate,
              endDate = _this$props4.endDate,
              focusedInput = _this$props4.focusedInput,
              minimumNights = _this$props4.minimumNights,
              startDateOffset = _this$props4.startDateOffset,
              endDateOffset = _this$props4.endDateOffset;
          var _this$state = this.state,
              hoverDate = _this$state.hoverDate,
              visibleDays = _this$state.visibleDays,
              dateOffset = _this$state.dateOffset;
          var nextDateOffset = null;

          if (focusedInput) {
            var hasOffset = startDateOffset || endDateOffset;
            var modifiers = {};

            if (hasOffset) {
              var start = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
              var end = (0, _getSelectedDateOffset["default"])(endDateOffset, day, function (rangeDay) {
                return rangeDay.add(1, 'day');
              });
              nextDateOffset = {
                start: start,
                end: end
              }; // eslint-disable-next-line react/destructuring-assignment

              if (dateOffset && dateOffset.start && dateOffset.end) {
                modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
              }

              modifiers = this.addModifierToRange(modifiers, start, end, 'hovered-offset');
            }

            if (!hasOffset) {
              modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
              modifiers = this.addModifier(modifiers, day, 'hovered');

              if (startDate && !endDate && focusedInput === constants$4.END_DATE) {
                if ((0, _isAfterDay["default"])(hoverDate, startDate)) {
                  var endSpan = hoverDate.clone().add(1, 'day');
                  modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
                }

                if (!this.isBlocked(day) && (0, _isAfterDay["default"])(day, startDate)) {
                  var _endSpan2 = day.clone().add(1, 'day');

                  modifiers = this.addModifierToRange(modifiers, startDate, _endSpan2, 'hovered-span');
                }
              }

              if (!startDate && endDate && focusedInput === constants$4.START_DATE) {
                if ((0, _isBeforeDay["default"])(hoverDate, endDate)) {
                  modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
                }

                if (!this.isBlocked(day) && (0, _isBeforeDay["default"])(day, endDate)) {
                  modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
                }
              }

              if (startDate) {
                var startSpan = startDate.clone().add(1, 'day');

                var _endSpan3 = startDate.clone().add(minimumNights + 1, 'days');

                modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan3, 'after-hovered-start');

                if ((0, _isSameDay["default"])(day, startDate)) {
                  var newStartSpan = startDate.clone().add(1, 'day');
                  var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
                  modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
                }
              }
            }

            this.setState({
              hoverDate: day,
              dateOffset: nextDateOffset,
              visibleDays: _objectSpread({}, visibleDays, modifiers)
            });
          }
        }

        return onDayMouseEnter;
      }()
    }, {
      key: "onDayMouseLeave",
      value: function () {
        function onDayMouseLeave(day) {
          var _this$props5 = this.props,
              startDate = _this$props5.startDate,
              endDate = _this$props5.endDate,
              minimumNights = _this$props5.minimumNights;
          var _this$state2 = this.state,
              hoverDate = _this$state2.hoverDate,
              visibleDays = _this$state2.visibleDays,
              dateOffset = _this$state2.dateOffset;
          if (this.isTouchDevice || !hoverDate) return;
          var modifiers = {};
          modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');

          if (dateOffset) {
            modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
          }

          if (startDate && !endDate && (0, _isAfterDay["default"])(hoverDate, startDate)) {
            var endSpan = hoverDate.clone().add(1, 'day');
            modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
          }

          if (!startDate && endDate && (0, _isAfterDay["default"])(endDate, hoverDate)) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
          }

          if (startDate && (0, _isSameDay["default"])(day, startDate)) {
            var startSpan = startDate.clone().add(1, 'day');

            var _endSpan4 = startDate.clone().add(minimumNights + 1, 'days');

            modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan4, 'after-hovered-start');
          }

          this.setState({
            hoverDate: null,
            visibleDays: _objectSpread({}, visibleDays, modifiers)
          });
        }

        return onDayMouseLeave;
      }()
    }, {
      key: "onPrevMonthClick",
      value: function () {
        function onPrevMonthClick() {
          var _this$props6 = this.props,
              enableOutsideDays = _this$props6.enableOutsideDays,
              maxDate = _this$props6.maxDate,
              minDate = _this$props6.minDate,
              numberOfMonths = _this$props6.numberOfMonths,
              onPrevMonthClick = _this$props6.onPrevMonthClick;
          var _this$state3 = this.state,
              currentMonth = _this$state3.currentMonth,
              visibleDays = _this$state3.visibleDays;
          var newVisibleDays = {};
          Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
            newVisibleDays[month] = visibleDays[month];
          });
          var prevMonth = currentMonth.clone().subtract(2, 'months');
          var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays, true);
          var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
          this.setState({
            currentMonth: newCurrentMonth,
            disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
            disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
            visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
          }, function () {
            onPrevMonthClick(newCurrentMonth.clone());
          });
        }

        return onPrevMonthClick;
      }()
    }, {
      key: "onNextMonthClick",
      value: function () {
        function onNextMonthClick() {
          var _this$props7 = this.props,
              enableOutsideDays = _this$props7.enableOutsideDays,
              maxDate = _this$props7.maxDate,
              minDate = _this$props7.minDate,
              numberOfMonths = _this$props7.numberOfMonths,
              onNextMonthClick = _this$props7.onNextMonthClick;
          var _this$state4 = this.state,
              currentMonth = _this$state4.currentMonth,
              visibleDays = _this$state4.visibleDays;
          var newVisibleDays = {};
          Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
            newVisibleDays[month] = visibleDays[month];
          });
          var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
          var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays, true);
          var newCurrentMonth = currentMonth.clone().add(1, 'month');
          this.setState({
            currentMonth: newCurrentMonth,
            disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
            disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
            visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
          }, function () {
            onNextMonthClick(newCurrentMonth.clone());
          });
        }

        return onNextMonthClick;
      }()
    }, {
      key: "onMonthChange",
      value: function () {
        function onMonthChange(newMonth) {
          var _this$props8 = this.props,
              numberOfMonths = _this$props8.numberOfMonths,
              enableOutsideDays = _this$props8.enableOutsideDays,
              orientation = _this$props8.orientation;
          var withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;
          var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
          this.setState({
            currentMonth: newMonth.clone(),
            visibleDays: this.getModifiers(newVisibleDays)
          });
        }

        return onMonthChange;
      }()
    }, {
      key: "onYearChange",
      value: function () {
        function onYearChange(newMonth) {
          var _this$props9 = this.props,
              numberOfMonths = _this$props9.numberOfMonths,
              enableOutsideDays = _this$props9.enableOutsideDays,
              orientation = _this$props9.orientation;
          var withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;
          var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
          this.setState({
            currentMonth: newMonth.clone(),
            visibleDays: this.getModifiers(newVisibleDays)
          });
        }

        return onYearChange;
      }()
    }, {
      key: "onMultiplyScrollableMonths",
      value: function () {
        function onMultiplyScrollableMonths() {
          var _this$props10 = this.props,
              numberOfMonths = _this$props10.numberOfMonths,
              enableOutsideDays = _this$props10.enableOutsideDays;
          var _this$state5 = this.state,
              currentMonth = _this$state5.currentMonth,
              visibleDays = _this$state5.visibleDays;
          var numberOfVisibleMonths = Object.keys(visibleDays).length;
          var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
          var newVisibleDays = (0, _getVisibleDays["default"])(nextMonth, numberOfMonths, enableOutsideDays, true);
          this.setState({
            visibleDays: _objectSpread({}, visibleDays, this.getModifiers(newVisibleDays))
          });
        }

        return onMultiplyScrollableMonths;
      }()
    }, {
      key: "getFirstFocusableDay",
      value: function () {
        function getFirstFocusableDay(newMonth) {
          var _this3 = this;

          var _this$props11 = this.props,
              startDate = _this$props11.startDate,
              endDate = _this$props11.endDate,
              focusedInput = _this$props11.focusedInput,
              minimumNights = _this$props11.minimumNights,
              numberOfMonths = _this$props11.numberOfMonths;
          var focusedDate = newMonth.clone().startOf('month');

          if (focusedInput === constants$4.START_DATE && startDate) {
            focusedDate = startDate.clone();
          } else if (focusedInput === constants$4.END_DATE && !endDate && startDate) {
            focusedDate = startDate.clone().add(minimumNights, 'days');
          } else if (focusedInput === constants$4.END_DATE && endDate) {
            focusedDate = endDate.clone();
          }

          if (this.isBlocked(focusedDate)) {
            var days = [];
            var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
            var currentDay = focusedDate.clone();

            while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
              currentDay = currentDay.clone().add(1, 'day');
              days.push(currentDay);
            }

            var viableDays = days.filter(function (day) {
              return !_this3.isBlocked(day);
            });

            if (viableDays.length > 0) {
              var _viableDays = _slicedToArray(viableDays, 1);

              focusedDate = _viableDays[0];
            }
          }

          return focusedDate;
        }

        return getFirstFocusableDay;
      }()
    }, {
      key: "getModifiers",
      value: function () {
        function getModifiers(visibleDays) {
          var _this4 = this;

          var modifiers = {};
          Object.keys(visibleDays).forEach(function (month) {
            modifiers[month] = {};
            visibleDays[month].forEach(function (day) {
              modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
            });
          });
          return modifiers;
        }

        return getModifiers;
      }()
    }, {
      key: "getModifiersForDay",
      value: function () {
        function getModifiersForDay(day) {
          var _this5 = this;

          return new Set(Object.keys(this.modifiers).filter(function (modifier) {
            return _this5.modifiers[modifier](day);
          }));
        }

        return getModifiersForDay;
      }()
    }, {
      key: "getStateForNewMonth",
      value: function () {
        function getStateForNewMonth(nextProps) {
          var _this6 = this;

          var initialVisibleMonth = nextProps.initialVisibleMonth,
              numberOfMonths = nextProps.numberOfMonths,
              enableOutsideDays = nextProps.enableOutsideDays,
              orientation = nextProps.orientation,
              startDate = nextProps.startDate;
          var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
            return startDate;
          } : function () {
            return _this6.today;
          });
          var currentMonth = initialVisibleMonthThunk();
          var withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;
          var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
          return {
            currentMonth: currentMonth,
            visibleDays: visibleDays
          };
        }

        return getStateForNewMonth;
      }()
    }, {
      key: "shouldDisableMonthNavigation",
      value: function () {
        function shouldDisableMonthNavigation(date, visibleMonth) {
          if (!date) return false;
          var _this$props12 = this.props,
              numberOfMonths = _this$props12.numberOfMonths,
              enableOutsideDays = _this$props12.enableOutsideDays;
          return (0, _isDayVisible["default"])(date, visibleMonth, numberOfMonths, enableOutsideDays);
        }

        return shouldDisableMonthNavigation;
      }()
    }, {
      key: "addModifier",
      value: function () {
        function addModifier(updatedDays, day, modifier) {
          var _this$props13 = this.props,
              numberOfVisibleMonths = _this$props13.numberOfMonths,
              enableOutsideDays = _this$props13.enableOutsideDays,
              orientation = _this$props13.orientation;
          var _this$state6 = this.state,
              firstVisibleMonth = _this$state6.currentMonth,
              visibleDays = _this$state6.visibleDays;
          var currentMonth = firstVisibleMonth;
          var numberOfMonths = numberOfVisibleMonths;

          if (orientation === constants$4.VERTICAL_SCROLLABLE) {
            numberOfMonths = Object.keys(visibleDays).length;
          } else {
            currentMonth = currentMonth.clone().subtract(1, 'month');
            numberOfMonths += 2;
          }

          if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
            return updatedDays;
          }

          var iso = (0, _toISODateString["default"])(day);

          var updatedDaysAfterAddition = _objectSpread({}, updatedDays);

          if (enableOutsideDays) {
            var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
              return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
            });
            updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
              var month = updatedDays[monthIso] || visibleDays[monthIso];
              var modifiers = new Set(month[iso]);
              modifiers.add(modifier);
              return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
            }, updatedDaysAfterAddition);
          } else {
            var monthIso = (0, _toISOMonthString["default"])(day);
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers.add(modifier);
            updatedDaysAfterAddition = _objectSpread({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
          }

          return updatedDaysAfterAddition;
        }

        return addModifier;
      }()
    }, {
      key: "addModifierToRange",
      value: function () {
        function addModifierToRange(updatedDays, start, end, modifier) {
          var days = updatedDays;
          var spanStart = start.clone();

          while ((0, _isBeforeDay["default"])(spanStart, end)) {
            days = this.addModifier(days, spanStart, modifier);
            spanStart = spanStart.clone().add(1, 'day');
          }

          return days;
        }

        return addModifierToRange;
      }()
    }, {
      key: "deleteModifier",
      value: function () {
        function deleteModifier(updatedDays, day, modifier) {
          var _this$props14 = this.props,
              numberOfVisibleMonths = _this$props14.numberOfMonths,
              enableOutsideDays = _this$props14.enableOutsideDays,
              orientation = _this$props14.orientation;
          var _this$state7 = this.state,
              firstVisibleMonth = _this$state7.currentMonth,
              visibleDays = _this$state7.visibleDays;
          var currentMonth = firstVisibleMonth;
          var numberOfMonths = numberOfVisibleMonths;

          if (orientation === constants$4.VERTICAL_SCROLLABLE) {
            numberOfMonths = Object.keys(visibleDays).length;
          } else {
            currentMonth = currentMonth.clone().subtract(1, 'month');
            numberOfMonths += 2;
          }

          if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
            return updatedDays;
          }

          var iso = (0, _toISODateString["default"])(day);

          var updatedDaysAfterDeletion = _objectSpread({}, updatedDays);

          if (enableOutsideDays) {
            var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
              return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
            });
            updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
              var month = updatedDays[monthIso] || visibleDays[monthIso];
              var modifiers = new Set(month[iso]);
              modifiers["delete"](modifier);
              return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
            }, updatedDaysAfterDeletion);
          } else {
            var monthIso = (0, _toISOMonthString["default"])(day);
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers["delete"](modifier);
            updatedDaysAfterDeletion = _objectSpread({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
          }

          return updatedDaysAfterDeletion;
        }

        return deleteModifier;
      }()
    }, {
      key: "deleteModifierFromRange",
      value: function () {
        function deleteModifierFromRange(updatedDays, start, end, modifier) {
          var days = updatedDays;
          var spanStart = start.clone();

          while ((0, _isBeforeDay["default"])(spanStart, end)) {
            days = this.deleteModifier(days, spanStart, modifier);
            spanStart = spanStart.clone().add(1, 'day');
          }

          return days;
        }

        return deleteModifierFromRange;
      }()
    }, {
      key: "doesNotMeetMinimumNights",
      value: function () {
        function doesNotMeetMinimumNights(day) {
          var _this$props15 = this.props,
              startDate = _this$props15.startDate,
              isOutsideRange = _this$props15.isOutsideRange,
              focusedInput = _this$props15.focusedInput,
              minimumNights = _this$props15.minimumNights;
          if (focusedInput !== constants$4.END_DATE) return false;

          if (startDate) {
            var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
            return dayDiff < minimumNights && dayDiff >= 0;
          }

          return isOutsideRange((0, _moment["default"])(day).subtract(minimumNights, 'days'));
        }

        return doesNotMeetMinimumNights;
      }()
    }, {
      key: "isDayAfterHoveredStartDate",
      value: function () {
        function isDayAfterHoveredStartDate(day) {
          var _this$props16 = this.props,
              startDate = _this$props16.startDate,
              endDate = _this$props16.endDate,
              minimumNights = _this$props16.minimumNights;

          var _ref2 = this.state || {},
              hoverDate = _ref2.hoverDate;

          return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay["default"])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay["default"])(hoverDate, startDate);
        }

        return isDayAfterHoveredStartDate;
      }()
    }, {
      key: "isEndDate",
      value: function () {
        function isEndDate(day) {
          var endDate = this.props.endDate;
          return (0, _isSameDay["default"])(day, endDate);
        }

        return isEndDate;
      }()
    }, {
      key: "isHovered",
      value: function () {
        function isHovered(day) {
          var _ref3 = this.state || {},
              hoverDate = _ref3.hoverDate;

          var focusedInput = this.props.focusedInput;
          return !!focusedInput && (0, _isSameDay["default"])(day, hoverDate);
        }

        return isHovered;
      }()
    }, {
      key: "isInHoveredSpan",
      value: function () {
        function isInHoveredSpan(day) {
          var _this$props17 = this.props,
              startDate = _this$props17.startDate,
              endDate = _this$props17.endDate;

          var _ref4 = this.state || {},
              hoverDate = _ref4.hoverDate;

          var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay["default"])(hoverDate, day));
          var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay["default"])(hoverDate, day));
          var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
          return (isForwardRange || isBackwardRange) && isValidDayHovered;
        }

        return isInHoveredSpan;
      }()
    }, {
      key: "isInSelectedSpan",
      value: function () {
        function isInSelectedSpan(day) {
          var _this$props18 = this.props,
              startDate = _this$props18.startDate,
              endDate = _this$props18.endDate;
          return day.isBetween(startDate, endDate);
        }

        return isInSelectedSpan;
      }()
    }, {
      key: "isLastInRange",
      value: function () {
        function isLastInRange(day) {
          var endDate = this.props.endDate;
          return this.isInSelectedSpan(day) && (0, _isNextDay["default"])(day, endDate);
        }

        return isLastInRange;
      }()
    }, {
      key: "isStartDate",
      value: function () {
        function isStartDate(day) {
          var startDate = this.props.startDate;
          return (0, _isSameDay["default"])(day, startDate);
        }

        return isStartDate;
      }()
    }, {
      key: "isBlocked",
      value: function () {
        function isBlocked(day) {
          var _this$props19 = this.props,
              isDayBlocked = _this$props19.isDayBlocked,
              isOutsideRange = _this$props19.isOutsideRange;
          return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
        }

        return isBlocked;
      }()
    }, {
      key: "isToday",
      value: function () {
        function isToday(day) {
          return (0, _isSameDay["default"])(day, this.today);
        }

        return isToday;
      }()
    }, {
      key: "isFirstDayOfWeek",
      value: function () {
        function isFirstDayOfWeek(day) {
          var firstDayOfWeek = this.props.firstDayOfWeek;
          return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
        }

        return isFirstDayOfWeek;
      }()
    }, {
      key: "isLastDayOfWeek",
      value: function () {
        function isLastDayOfWeek(day) {
          var firstDayOfWeek = this.props.firstDayOfWeek;
          return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
        }

        return isLastDayOfWeek;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$props20 = this.props,
              numberOfMonths = _this$props20.numberOfMonths,
              orientation = _this$props20.orientation,
              monthFormat = _this$props20.monthFormat,
              renderMonthText = _this$props20.renderMonthText,
              navPrev = _this$props20.navPrev,
              navNext = _this$props20.navNext,
              noNavButtons = _this$props20.noNavButtons,
              onOutsideClick = _this$props20.onOutsideClick,
              withPortal = _this$props20.withPortal,
              enableOutsideDays = _this$props20.enableOutsideDays,
              firstDayOfWeek = _this$props20.firstDayOfWeek,
              hideKeyboardShortcutsPanel = _this$props20.hideKeyboardShortcutsPanel,
              daySize = _this$props20.daySize,
              focusedInput = _this$props20.focusedInput,
              renderCalendarDay = _this$props20.renderCalendarDay,
              renderDayContents = _this$props20.renderDayContents,
              renderCalendarInfo = _this$props20.renderCalendarInfo,
              renderMonthElement = _this$props20.renderMonthElement,
              calendarInfoPosition = _this$props20.calendarInfoPosition,
              onBlur = _this$props20.onBlur,
              onShiftTab = _this$props20.onShiftTab,
              onTab = _this$props20.onTab,
              isFocused = _this$props20.isFocused,
              showKeyboardShortcuts = _this$props20.showKeyboardShortcuts,
              isRTL = _this$props20.isRTL,
              weekDayFormat = _this$props20.weekDayFormat,
              dayAriaLabelFormat = _this$props20.dayAriaLabelFormat,
              verticalHeight = _this$props20.verticalHeight,
              noBorder = _this$props20.noBorder,
              transitionDuration = _this$props20.transitionDuration,
              verticalBorderSpacing = _this$props20.verticalBorderSpacing,
              horizontalMonthPadding = _this$props20.horizontalMonthPadding;
          var _this$state8 = this.state,
              currentMonth = _this$state8.currentMonth,
              phrases = _this$state8.phrases,
              visibleDays = _this$state8.visibleDays,
              disablePrev = _this$state8.disablePrev,
              disableNext = _this$state8.disableNext;
          return _react["default"].createElement(_DayPicker["default"], {
            orientation: orientation,
            enableOutsideDays: enableOutsideDays,
            modifiers: visibleDays,
            numberOfMonths: numberOfMonths,
            onDayClick: this.onDayClick,
            onDayMouseEnter: this.onDayMouseEnter,
            onDayMouseLeave: this.onDayMouseLeave,
            onPrevMonthClick: this.onPrevMonthClick,
            onNextMonthClick: this.onNextMonthClick,
            onMonthChange: this.onMonthChange,
            onTab: onTab,
            onShiftTab: onShiftTab,
            onYearChange: this.onYearChange,
            onMultiplyScrollableMonths: this.onMultiplyScrollableMonths,
            monthFormat: monthFormat,
            renderMonthText: renderMonthText,
            withPortal: withPortal,
            hidden: !focusedInput,
            initialVisibleMonth: function () {
              function initialVisibleMonth() {
                return currentMonth;
              }

              return initialVisibleMonth;
            }(),
            daySize: daySize,
            onOutsideClick: onOutsideClick,
            disablePrev: disablePrev,
            disableNext: disableNext,
            navPrev: navPrev,
            navNext: navNext,
            noNavButtons: noNavButtons,
            renderCalendarDay: renderCalendarDay,
            renderDayContents: renderDayContents,
            renderCalendarInfo: renderCalendarInfo,
            renderMonthElement: renderMonthElement,
            calendarInfoPosition: calendarInfoPosition,
            firstDayOfWeek: firstDayOfWeek,
            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
            isFocused: isFocused,
            getFirstFocusableDay: this.getFirstFocusableDay,
            onBlur: onBlur,
            showKeyboardShortcuts: showKeyboardShortcuts,
            phrases: phrases,
            isRTL: isRTL,
            weekDayFormat: weekDayFormat,
            dayAriaLabelFormat: dayAriaLabelFormat,
            verticalHeight: verticalHeight,
            verticalBorderSpacing: verticalBorderSpacing,
            noBorder: noBorder,
            transitionDuration: transitionDuration,
            horizontalMonthPadding: horizontalMonthPadding
          });
        }

        return render;
      }()
    }]);

    return DayPickerRangeController;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports["default"] = DayPickerRangeController;
  DayPickerRangeController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DayPickerRangeController.defaultProps = defaultProps;
});
unwrapExports(DayPickerRangeController_1);
var DateRangePicker_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.PureDateRangePicker = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _moment = _interopRequireDefault(moment);

  var _isTouchDevice = _interopRequireDefault(build$2);

  var _reactOutsideClickHandler = _interopRequireDefault(reactOutsideClickHandler);

  var _DateRangePickerShape = _interopRequireDefault(DateRangePickerShape);

  var _getResponsiveContainerStyles = _interopRequireDefault(getResponsiveContainerStyles_1);

  var _getDetachedContainerStyles = _interopRequireDefault(getDetachedContainerStyles_1);

  var _getInputHeight = _interopRequireDefault(getInputHeight_1);

  var _isInclusivelyAfterDay = _interopRequireDefault(isInclusivelyAfterDay_1);

  var _disableScroll2 = _interopRequireDefault(disableScroll_1);

  var _noflip = _interopRequireDefault(noflip_1);

  var _DateRangePickerInputController = _interopRequireDefault(DateRangePickerInputController_1);

  var _DayPickerRangeController = _interopRequireDefault(DayPickerRangeController_1);

  var _CloseButton = _interopRequireDefault(CloseButton_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, _DateRangePickerShape["default"])) : {};
  var defaultProps = {
    // required props for a functional interactive DateRangePicker
    startDate: null,
    endDate: null,
    focusedInput: null,
    // input related props
    startDatePlaceholderText: 'Start Date',
    endDatePlaceholderText: 'End Date',
    disabled: false,
    required: false,
    readOnly: false,
    screenReaderInputMessage: '',
    showClearDates: false,
    showDefaultInputIcon: false,
    inputIconPosition: constants$4.ICON_BEFORE_POSITION,
    customInputIcon: null,
    customArrowIcon: null,
    customCloseIcon: null,
    noBorder: false,
    block: false,
    small: false,
    regular: false,
    keepFocusOnInput: false,
    // calendar presentation and interaction related props
    renderMonthText: null,
    orientation: constants$4.HORIZONTAL_ORIENTATION,
    anchorDirection: constants$4.ANCHOR_LEFT,
    openDirection: constants$4.OPEN_DOWN,
    horizontalMargin: 0,
    withPortal: false,
    withFullScreenPortal: false,
    appendToBody: false,
    disableScroll: false,
    initialVisibleMonth: null,
    numberOfMonths: 2,
    keepOpenOnDateSelect: false,
    reopenPickerOnClearDates: false,
    renderCalendarInfo: null,
    calendarInfoPosition: constants$4.INFO_POSITION_BOTTOM,
    hideKeyboardShortcutsPanel: false,
    daySize: constants$4.DAY_SIZE,
    isRTL: false,
    firstDayOfWeek: null,
    verticalHeight: null,
    transitionDuration: undefined,
    verticalSpacing: constants$4.DEFAULT_VERTICAL_SPACING,
    horizontalMonthPadding: undefined,
    // navigation related props
    navPrev: null,
    navNext: null,
    onPrevMonthClick: function () {
      function onPrevMonthClick() {}

      return onPrevMonthClick;
    }(),
    onNextMonthClick: function () {
      function onNextMonthClick() {}

      return onNextMonthClick;
    }(),
    onClose: function () {
      function onClose() {}

      return onClose;
    }(),
    // day presentation and interaction related props
    renderCalendarDay: undefined,
    renderDayContents: null,
    renderMonthElement: null,
    minimumNights: 1,
    enableOutsideDays: false,
    isDayBlocked: function () {
      function isDayBlocked() {
        return false;
      }

      return isDayBlocked;
    }(),
    isOutsideRange: function () {
      function isOutsideRange(day) {
        return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
      }

      return isOutsideRange;
    }(),
    isDayHighlighted: function () {
      function isDayHighlighted() {
        return false;
      }

      return isDayHighlighted;
    }(),
    // internationalization
    displayFormat: function () {
      function displayFormat() {
        return _moment["default"].localeData().longDateFormat('L');
      }

      return displayFormat;
    }(),
    monthFormat: 'MMMM YYYY',
    weekDayFormat: 'dd',
    phrases: defaultPhrases.DateRangePickerPhrases,
    dayAriaLabelFormat: undefined
  };

  var DateRangePicker =
  /*#__PURE__*/
  function (_ref) {
    _inherits(DateRangePicker, _ref);

    _createClass(DateRangePicker, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function DateRangePicker(props) {
      var _this;

      _classCallCheck(this, DateRangePicker);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePicker).call(this, props));
      _this.state = {
        dayPickerContainerStyles: {},
        isDateRangePickerInputFocused: false,
        isDayPickerFocused: false,
        showKeyboardShortcuts: false
      };
      _this.isTouchDevice = false;
      _this.onOutsideClick = _this.onOutsideClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayPickerFocusOut = _this.onDayPickerFocusOut.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.disableScroll = _this.disableScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(DateRangePicker, [{
      key: "componentDidMount",
      value: function () {
        function componentDidMount() {
          this.removeEventListener = (0, index_esm.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
            passive: true
          });
          this.responsivizePickerPosition();
          this.disableScroll();
          var focusedInput = this.props.focusedInput;

          if (focusedInput) {
            this.setState({
              isDateRangePickerInputFocused: true
            });
          }

          this.isTouchDevice = (0, _isTouchDevice["default"])();
        }

        return componentDidMount;
      }()
    }, {
      key: "componentDidUpdate",
      value: function () {
        function componentDidUpdate(prevProps) {
          var focusedInput = this.props.focusedInput;

          if (!prevProps.focusedInput && focusedInput && this.isOpened()) {
            // The date picker just changed from being closed to being open.
            this.responsivizePickerPosition();
            this.disableScroll();
          } else if (prevProps.focusedInput && !focusedInput && !this.isOpened()) {
            // The date picker just changed from being open to being closed.
            if (this.enableScroll) this.enableScroll();
          }
        }

        return componentDidUpdate;
      }()
    }, {
      key: "componentWillUnmount",
      value: function () {
        function componentWillUnmount() {
          this.removeDayPickerEventListeners();
          if (this.removeEventListener) this.removeEventListener();
          if (this.enableScroll) this.enableScroll();
        }

        return componentWillUnmount;
      }()
    }, {
      key: "onOutsideClick",
      value: function () {
        function onOutsideClick(event) {
          var _this$props = this.props,
              onFocusChange = _this$props.onFocusChange,
              onClose = _this$props.onClose,
              startDate = _this$props.startDate,
              endDate = _this$props.endDate,
              appendToBody = _this$props.appendToBody;
          if (!this.isOpened()) return;
          if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
          this.setState({
            isDateRangePickerInputFocused: false,
            isDayPickerFocused: false,
            showKeyboardShortcuts: false
          });
          onFocusChange(null);
          onClose({
            startDate: startDate,
            endDate: endDate
          });
        }

        return onOutsideClick;
      }()
    }, {
      key: "onDateRangePickerInputFocus",
      value: function () {
        function onDateRangePickerInputFocus(focusedInput) {
          var _this$props2 = this.props,
              onFocusChange = _this$props2.onFocusChange,
              readOnly = _this$props2.readOnly,
              withPortal = _this$props2.withPortal,
              withFullScreenPortal = _this$props2.withFullScreenPortal,
              keepFocusOnInput = _this$props2.keepFocusOnInput;

          if (focusedInput) {
            var withAnyPortal = withPortal || withFullScreenPortal;
            var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;

            if (moveFocusToDayPicker) {
              this.onDayPickerFocus();
            } else {
              this.onDayPickerBlur();
            }
          }

          onFocusChange(focusedInput);
        }

        return onDateRangePickerInputFocus;
      }()
    }, {
      key: "onDayPickerFocus",
      value: function () {
        function onDayPickerFocus() {
          var _this$props3 = this.props,
              focusedInput = _this$props3.focusedInput,
              onFocusChange = _this$props3.onFocusChange;
          if (!focusedInput) onFocusChange(constants$4.START_DATE);
          this.setState({
            isDateRangePickerInputFocused: false,
            isDayPickerFocused: true,
            showKeyboardShortcuts: false
          });
        }

        return onDayPickerFocus;
      }()
    }, {
      key: "onDayPickerFocusOut",
      value: function () {
        function onDayPickerFocusOut(event) {
          // In cases where **relatedTarget** is not null, it points to the right
          // element here. However, in cases where it is null (such as clicking on a
          // specific day), the appropriate value is **event.target**.
          //
          // We handle both situations here by using the ` || ` operator to fallback
          // to *event.target** when **relatedTarget** is not provided.
          if (this.dayPickerContainer.contains(event.relatedTarget || event.target)) return;
          this.onOutsideClick(event);
        }

        return onDayPickerFocusOut;
      }()
    }, {
      key: "onDayPickerBlur",
      value: function () {
        function onDayPickerBlur() {
          this.setState({
            isDateRangePickerInputFocused: true,
            isDayPickerFocused: false,
            showKeyboardShortcuts: false
          });
        }

        return onDayPickerBlur;
      }()
    }, {
      key: "setDayPickerContainerRef",
      value: function () {
        function setDayPickerContainerRef(ref) {
          if (ref === this.dayPickerContainer) return;
          if (this.dayPickerContainer) this.removeDayPickerEventListeners();
          this.dayPickerContainer = ref;
          if (!ref) return;
          this.addDayPickerEventListeners();
        }

        return setDayPickerContainerRef;
      }()
    }, {
      key: "setContainerRef",
      value: function () {
        function setContainerRef(ref) {
          this.container = ref;
        }

        return setContainerRef;
      }()
    }, {
      key: "addDayPickerEventListeners",
      value: function () {
        function addDayPickerEventListeners() {
          // NOTE: We are using a manual event listener here, because React doesn't
          // provide FocusOut, while blur and keydown don't provide the information
          // needed in order to know whether we have left focus or not.
          //
          // For reference, this issue is further described here:
          // - https://github.com/facebook/react/issues/6410
          this.removeDayPickerFocusOut = (0, index_esm.addEventListener)(this.dayPickerContainer, 'focusout', this.onDayPickerFocusOut);
        }

        return addDayPickerEventListeners;
      }()
    }, {
      key: "removeDayPickerEventListeners",
      value: function () {
        function removeDayPickerEventListeners() {
          if (this.removeDayPickerFocusOut) this.removeDayPickerFocusOut();
        }

        return removeDayPickerEventListeners;
      }()
    }, {
      key: "isOpened",
      value: function () {
        function isOpened() {
          var focusedInput = this.props.focusedInput;
          return focusedInput === constants$4.START_DATE || focusedInput === constants$4.END_DATE;
        }

        return isOpened;
      }()
    }, {
      key: "disableScroll",
      value: function () {
        function disableScroll() {
          var _this$props4 = this.props,
              appendToBody = _this$props4.appendToBody,
              propDisableScroll = _this$props4.disableScroll;
          if (!appendToBody && !propDisableScroll) return;
          if (!this.isOpened()) return; // Disable scroll for every ancestor of this DateRangePicker up to the
          // document level. This ensures the input and the picker never move. Other
          // sibling elements or the picker itself can scroll.

          this.enableScroll = (0, _disableScroll2["default"])(this.container);
        }

        return disableScroll;
      }()
    }, {
      key: "responsivizePickerPosition",
      value: function () {
        function responsivizePickerPosition() {
          // It's possible the portal props have been changed in response to window resizes
          // So let's ensure we reset this back to the base state each time
          this.setState({
            dayPickerContainerStyles: {}
          });

          if (!this.isOpened()) {
            return;
          }

          var _this$props5 = this.props,
              openDirection = _this$props5.openDirection,
              anchorDirection = _this$props5.anchorDirection,
              horizontalMargin = _this$props5.horizontalMargin,
              withPortal = _this$props5.withPortal,
              withFullScreenPortal = _this$props5.withFullScreenPortal,
              appendToBody = _this$props5.appendToBody;
          var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
          var isAnchoredLeft = anchorDirection === constants$4.ANCHOR_LEFT;

          if (!withPortal && !withFullScreenPortal) {
            var containerRect = this.dayPickerContainer.getBoundingClientRect();
            var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
            var containerEdge = isAnchoredLeft ? containerRect[constants$4.ANCHOR_RIGHT] : containerRect[constants$4.ANCHOR_LEFT];
            this.setState({
              dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
            });
          }
        }

        return responsivizePickerPosition;
      }()
    }, {
      key: "showKeyboardShortcutsPanel",
      value: function () {
        function showKeyboardShortcutsPanel() {
          this.setState({
            isDateRangePickerInputFocused: false,
            isDayPickerFocused: true,
            showKeyboardShortcuts: true
          });
        }

        return showKeyboardShortcutsPanel;
      }()
    }, {
      key: "maybeRenderDayPickerWithPortal",
      value: function () {
        function maybeRenderDayPickerWithPortal() {
          var _this$props6 = this.props,
              withPortal = _this$props6.withPortal,
              withFullScreenPortal = _this$props6.withFullScreenPortal,
              appendToBody = _this$props6.appendToBody;

          if (!this.isOpened()) {
            return null;
          }

          if (withPortal || withFullScreenPortal || appendToBody) {
            return _react["default"].createElement(es.Portal, null, this.renderDayPicker());
          }

          return this.renderDayPicker();
        }

        return maybeRenderDayPickerWithPortal;
      }()
    }, {
      key: "renderDayPicker",
      value: function () {
        function renderDayPicker() {
          var _this$props7 = this.props,
              anchorDirection = _this$props7.anchorDirection,
              openDirection = _this$props7.openDirection,
              isDayBlocked = _this$props7.isDayBlocked,
              isDayHighlighted = _this$props7.isDayHighlighted,
              isOutsideRange = _this$props7.isOutsideRange,
              numberOfMonths = _this$props7.numberOfMonths,
              orientation = _this$props7.orientation,
              monthFormat = _this$props7.monthFormat,
              renderMonthText = _this$props7.renderMonthText,
              navPrev = _this$props7.navPrev,
              navNext = _this$props7.navNext,
              onPrevMonthClick = _this$props7.onPrevMonthClick,
              onNextMonthClick = _this$props7.onNextMonthClick,
              onDatesChange = _this$props7.onDatesChange,
              onFocusChange = _this$props7.onFocusChange,
              withPortal = _this$props7.withPortal,
              withFullScreenPortal = _this$props7.withFullScreenPortal,
              daySize = _this$props7.daySize,
              enableOutsideDays = _this$props7.enableOutsideDays,
              focusedInput = _this$props7.focusedInput,
              startDate = _this$props7.startDate,
              endDate = _this$props7.endDate,
              minimumNights = _this$props7.minimumNights,
              keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
              renderCalendarDay = _this$props7.renderCalendarDay,
              renderDayContents = _this$props7.renderDayContents,
              renderCalendarInfo = _this$props7.renderCalendarInfo,
              renderMonthElement = _this$props7.renderMonthElement,
              calendarInfoPosition = _this$props7.calendarInfoPosition,
              firstDayOfWeek = _this$props7.firstDayOfWeek,
              initialVisibleMonth = _this$props7.initialVisibleMonth,
              hideKeyboardShortcutsPanel = _this$props7.hideKeyboardShortcutsPanel,
              customCloseIcon = _this$props7.customCloseIcon,
              onClose = _this$props7.onClose,
              phrases = _this$props7.phrases,
              dayAriaLabelFormat = _this$props7.dayAriaLabelFormat,
              isRTL = _this$props7.isRTL,
              weekDayFormat = _this$props7.weekDayFormat,
              styles = _this$props7.styles,
              verticalHeight = _this$props7.verticalHeight,
              transitionDuration = _this$props7.transitionDuration,
              verticalSpacing = _this$props7.verticalSpacing,
              horizontalMonthPadding = _this$props7.horizontalMonthPadding,
              small = _this$props7.small,
              disabled = _this$props7.disabled,
              reactDates = _this$props7.theme.reactDates;
          var _this$state = this.state,
              dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
              isDayPickerFocused = _this$state.isDayPickerFocused,
              showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
          var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;

          var initialVisibleMonthThunk = initialVisibleMonth || function () {
            return startDate || endDate || (0, _moment["default"])();
          };

          var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DateRangePicker_closeButton_svg));

          var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
          var withAnyPortal = withPortal || withFullScreenPortal;
          return _react["default"].createElement("div", _extends({
            // eslint-disable-line jsx-a11y/no-static-element-interactions
            ref: this.setDayPickerContainerRef
          }, (0, withStyles_1.css)(styles.DateRangePicker_picker, anchorDirection === constants$4.ANCHOR_LEFT && styles.DateRangePicker_picker__directionLeft, anchorDirection === constants$4.ANCHOR_RIGHT && styles.DateRangePicker_picker__directionRight, orientation === constants$4.HORIZONTAL_ORIENTATION && styles.DateRangePicker_picker__horizontal, orientation === constants$4.VERTICAL_ORIENTATION && styles.DateRangePicker_picker__vertical, !withAnyPortal && openDirection === constants$4.OPEN_DOWN && {
            top: inputHeight + verticalSpacing
          }, !withAnyPortal && openDirection === constants$4.OPEN_UP && {
            bottom: inputHeight + verticalSpacing
          }, withAnyPortal && styles.DateRangePicker_picker__portal, withFullScreenPortal && styles.DateRangePicker_picker__fullScreenPortal, isRTL && styles.DateRangePicker_picker__rtl, dayPickerContainerStyles), {
            onClick: onOutsideClick
          }), _react["default"].createElement(_DayPickerRangeController["default"], {
            orientation: orientation,
            enableOutsideDays: enableOutsideDays,
            numberOfMonths: numberOfMonths,
            onPrevMonthClick: onPrevMonthClick,
            onNextMonthClick: onNextMonthClick,
            onDatesChange: onDatesChange,
            onFocusChange: onFocusChange,
            onClose: onClose,
            focusedInput: focusedInput,
            startDate: startDate,
            endDate: endDate,
            monthFormat: monthFormat,
            renderMonthText: renderMonthText,
            withPortal: withAnyPortal,
            daySize: daySize,
            initialVisibleMonth: initialVisibleMonthThunk,
            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
            navPrev: navPrev,
            navNext: navNext,
            minimumNights: minimumNights,
            isOutsideRange: isOutsideRange,
            isDayHighlighted: isDayHighlighted,
            isDayBlocked: isDayBlocked,
            keepOpenOnDateSelect: keepOpenOnDateSelect,
            renderCalendarDay: renderCalendarDay,
            renderDayContents: renderDayContents,
            renderCalendarInfo: renderCalendarInfo,
            renderMonthElement: renderMonthElement,
            calendarInfoPosition: calendarInfoPosition,
            isFocused: isDayPickerFocused,
            showKeyboardShortcuts: showKeyboardShortcuts,
            onBlur: this.onDayPickerBlur,
            phrases: phrases,
            dayAriaLabelFormat: dayAriaLabelFormat,
            isRTL: isRTL,
            firstDayOfWeek: firstDayOfWeek,
            weekDayFormat: weekDayFormat,
            verticalHeight: verticalHeight,
            transitionDuration: transitionDuration,
            disabled: disabled,
            horizontalMonthPadding: horizontalMonthPadding
          }), withFullScreenPortal && _react["default"].createElement("button", _extends({}, (0, withStyles_1.css)(styles.DateRangePicker_closeButton), {
            type: "button",
            onClick: this.onOutsideClick,
            "aria-label": phrases.closeDatePicker
          }), closeIcon));
        }

        return renderDayPicker;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$props8 = this.props,
              startDate = _this$props8.startDate,
              startDateId = _this$props8.startDateId,
              startDatePlaceholderText = _this$props8.startDatePlaceholderText,
              endDate = _this$props8.endDate,
              endDateId = _this$props8.endDateId,
              endDatePlaceholderText = _this$props8.endDatePlaceholderText,
              focusedInput = _this$props8.focusedInput,
              screenReaderInputMessage = _this$props8.screenReaderInputMessage,
              showClearDates = _this$props8.showClearDates,
              showDefaultInputIcon = _this$props8.showDefaultInputIcon,
              inputIconPosition = _this$props8.inputIconPosition,
              customInputIcon = _this$props8.customInputIcon,
              customArrowIcon = _this$props8.customArrowIcon,
              customCloseIcon = _this$props8.customCloseIcon,
              disabled = _this$props8.disabled,
              required = _this$props8.required,
              readOnly = _this$props8.readOnly,
              openDirection = _this$props8.openDirection,
              phrases = _this$props8.phrases,
              isOutsideRange = _this$props8.isOutsideRange,
              minimumNights = _this$props8.minimumNights,
              withPortal = _this$props8.withPortal,
              withFullScreenPortal = _this$props8.withFullScreenPortal,
              displayFormat = _this$props8.displayFormat,
              reopenPickerOnClearDates = _this$props8.reopenPickerOnClearDates,
              keepOpenOnDateSelect = _this$props8.keepOpenOnDateSelect,
              onDatesChange = _this$props8.onDatesChange,
              onClose = _this$props8.onClose,
              isRTL = _this$props8.isRTL,
              noBorder = _this$props8.noBorder,
              block = _this$props8.block,
              verticalSpacing = _this$props8.verticalSpacing,
              small = _this$props8.small,
              regular = _this$props8.regular,
              styles = _this$props8.styles;
          var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;
          var enableOutsideClick = !withPortal && !withFullScreenPortal;
          var hideFang = verticalSpacing < constants$4.FANG_HEIGHT_PX;

          var input = _react["default"].createElement(_DateRangePickerInputController["default"], {
            startDate: startDate,
            startDateId: startDateId,
            startDatePlaceholderText: startDatePlaceholderText,
            isStartDateFocused: focusedInput === constants$4.START_DATE,
            endDate: endDate,
            endDateId: endDateId,
            endDatePlaceholderText: endDatePlaceholderText,
            isEndDateFocused: focusedInput === constants$4.END_DATE,
            displayFormat: displayFormat,
            showClearDates: showClearDates,
            showCaret: !withPortal && !withFullScreenPortal && !hideFang,
            showDefaultInputIcon: showDefaultInputIcon,
            inputIconPosition: inputIconPosition,
            customInputIcon: customInputIcon,
            customArrowIcon: customArrowIcon,
            customCloseIcon: customCloseIcon,
            disabled: disabled,
            required: required,
            readOnly: readOnly,
            openDirection: openDirection,
            reopenPickerOnClearDates: reopenPickerOnClearDates,
            keepOpenOnDateSelect: keepOpenOnDateSelect,
            isOutsideRange: isOutsideRange,
            minimumNights: minimumNights,
            withFullScreenPortal: withFullScreenPortal,
            onDatesChange: onDatesChange,
            onFocusChange: this.onDateRangePickerInputFocus,
            onKeyDownArrowDown: this.onDayPickerFocus,
            onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
            onClose: onClose,
            phrases: phrases,
            screenReaderMessage: screenReaderInputMessage,
            isFocused: isDateRangePickerInputFocused,
            isRTL: isRTL,
            noBorder: noBorder,
            block: block,
            small: small,
            regular: regular,
            verticalSpacing: verticalSpacing
          }, this.maybeRenderDayPickerWithPortal());

          return _react["default"].createElement("div", _extends({
            ref: this.setContainerRef
          }, (0, withStyles_1.css)(styles.DateRangePicker, block && styles.DateRangePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
            onOutsideClick: this.onOutsideClick
          }, input), enableOutsideClick || input);
        }

        return render;
      }()
    }]);

    return DateRangePicker;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports.PureDateRangePicker = DateRangePicker;
  DateRangePicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DateRangePicker.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var _ref2$reactDates = _ref2.reactDates,
        color = _ref2$reactDates.color,
        zIndex = _ref2$reactDates.zIndex;
    return {
      DateRangePicker: {
        position: 'relative',
        display: 'inline-block'
      },
      DateRangePicker__block: {
        display: 'block'
      },
      DateRangePicker_picker: {
        zIndex: zIndex + 1,
        backgroundColor: color.background,
        position: 'absolute'
      },
      DateRangePicker_picker__rtl: {
        direction: (0, _noflip["default"])('rtl')
      },
      DateRangePicker_picker__directionLeft: {
        left: (0, _noflip["default"])(0)
      },
      DateRangePicker_picker__directionRight: {
        right: (0, _noflip["default"])(0)
      },
      DateRangePicker_picker__portal: {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        position: 'fixed',
        top: 0,
        left: (0, _noflip["default"])(0),
        height: '100%',
        width: '100%'
      },
      DateRangePicker_picker__fullScreenPortal: {
        backgroundColor: color.background
      },
      DateRangePicker_closeButton: {
        background: 'none',
        border: 0,
        color: 'inherit',
        font: 'inherit',
        lineHeight: 'normal',
        overflow: 'visible',
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        right: (0, _noflip["default"])(0),
        padding: 15,
        zIndex: zIndex + 2,
        ':hover': {
          color: "darken(".concat(color.core.grayLighter, ", 10%)"),
          textDecoration: 'none'
        },
        ':focus': {
          color: "darken(".concat(color.core.grayLighter, ", 10%)"),
          textDecoration: 'none'
        }
      },
      DateRangePicker_closeButton_svg: {
        height: 15,
        width: 15,
        fill: color.core.grayLighter
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(DateRangePicker);

  exports["default"] = _default;
});
unwrapExports(DateRangePicker_1);
var DateRangePicker_2 = DateRangePicker_1.PureDateRangePicker;
var DayPickerSingleDateController_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _moment = _interopRequireDefault(moment);

  var _object = _interopRequireDefault(object_values);

  var _isTouchDevice = _interopRequireDefault(build$2);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _isSameDay = _interopRequireDefault(isSameDay_1);

  var _isAfterDay = _interopRequireDefault(isAfterDay_1);

  var _getVisibleDays = _interopRequireDefault(getVisibleDays_1);

  var _isDayVisible = _interopRequireDefault(isDayVisible_1);

  var _toISODateString = _interopRequireDefault(toISODateString_1);

  var _toISOMonthString = _interopRequireDefault(toISOMonthString_1);

  var _ScrollableOrientationShape = _interopRequireDefault(ScrollableOrientationShape);

  var _DayOfWeekShape = _interopRequireDefault(DayOfWeekShape);

  var _CalendarInfoPositionShape = _interopRequireDefault(CalendarInfoPositionShape);

  var _DayPicker = _interopRequireDefault(DayPicker_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
    date: _reactMomentProptypes["default"].momentObj,
    onDateChange: _propTypes["default"].func,
    focused: _propTypes["default"].bool,
    onFocusChange: _propTypes["default"].func,
    onClose: _propTypes["default"].func,
    keepOpenOnDateSelect: _propTypes["default"].bool,
    isOutsideRange: _propTypes["default"].func,
    isDayBlocked: _propTypes["default"].func,
    isDayHighlighted: _propTypes["default"].func,
    // DayPicker props
    renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    enableOutsideDays: _propTypes["default"].bool,
    numberOfMonths: _propTypes["default"].number,
    orientation: _ScrollableOrientationShape["default"],
    withPortal: _propTypes["default"].bool,
    initialVisibleMonth: _propTypes["default"].func,
    firstDayOfWeek: _DayOfWeekShape["default"],
    hideKeyboardShortcutsPanel: _propTypes["default"].bool,
    daySize: airbnbPropTypes.nonNegativeInteger,
    verticalHeight: airbnbPropTypes.nonNegativeInteger,
    noBorder: _propTypes["default"].bool,
    verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
    transitionDuration: airbnbPropTypes.nonNegativeInteger,
    horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
    navPrev: _propTypes["default"].node,
    navNext: _propTypes["default"].node,
    onPrevMonthClick: _propTypes["default"].func,
    onNextMonthClick: _propTypes["default"].func,
    onOutsideClick: _propTypes["default"].func,
    renderCalendarDay: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    renderCalendarInfo: _propTypes["default"].func,
    calendarInfoPosition: _CalendarInfoPositionShape["default"],
    // accessibility
    onBlur: _propTypes["default"].func,
    isFocused: _propTypes["default"].bool,
    showKeyboardShortcuts: _propTypes["default"].bool,
    onTab: _propTypes["default"].func,
    onShiftTab: _propTypes["default"].func,
    // i18n
    monthFormat: _propTypes["default"].string,
    weekDayFormat: _propTypes["default"].string,
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
    dayAriaLabelFormat: _propTypes["default"].string,
    isRTL: _propTypes["default"].bool
  }) : {};
  var defaultProps = {
    date: undefined,
    // TODO: use null
    onDateChange: function () {
      function onDateChange() {}

      return onDateChange;
    }(),
    focused: false,
    onFocusChange: function () {
      function onFocusChange() {}

      return onFocusChange;
    }(),
    onClose: function () {
      function onClose() {}

      return onClose;
    }(),
    keepOpenOnDateSelect: false,
    isOutsideRange: function () {
      function isOutsideRange() {}

      return isOutsideRange;
    }(),
    isDayBlocked: function () {
      function isDayBlocked() {}

      return isDayBlocked;
    }(),
    isDayHighlighted: function () {
      function isDayHighlighted() {}

      return isDayHighlighted;
    }(),
    // DayPicker props
    renderMonthText: null,
    enableOutsideDays: false,
    numberOfMonths: 1,
    orientation: constants$4.HORIZONTAL_ORIENTATION,
    withPortal: false,
    hideKeyboardShortcutsPanel: false,
    initialVisibleMonth: null,
    firstDayOfWeek: null,
    daySize: constants$4.DAY_SIZE,
    verticalHeight: null,
    noBorder: false,
    verticalBorderSpacing: undefined,
    transitionDuration: undefined,
    horizontalMonthPadding: 13,
    navPrev: null,
    navNext: null,
    onPrevMonthClick: function () {
      function onPrevMonthClick() {}

      return onPrevMonthClick;
    }(),
    onNextMonthClick: function () {
      function onNextMonthClick() {}

      return onNextMonthClick;
    }(),
    onOutsideClick: function () {
      function onOutsideClick() {}

      return onOutsideClick;
    }(),
    renderCalendarDay: undefined,
    renderDayContents: null,
    renderCalendarInfo: null,
    renderMonthElement: null,
    calendarInfoPosition: constants$4.INFO_POSITION_BOTTOM,
    // accessibility
    onBlur: function () {
      function onBlur() {}

      return onBlur;
    }(),
    isFocused: false,
    showKeyboardShortcuts: false,
    onTab: function () {
      function onTab() {}

      return onTab;
    }(),
    onShiftTab: function () {
      function onShiftTab() {}

      return onShiftTab;
    }(),
    // i18n
    monthFormat: 'MMMM YYYY',
    weekDayFormat: 'dd',
    phrases: defaultPhrases.DayPickerPhrases,
    dayAriaLabelFormat: undefined,
    isRTL: false
  };

  var DayPickerSingleDateController =
  /*#__PURE__*/
  function (_ref) {
    _inherits(DayPickerSingleDateController, _ref);

    _createClass(DayPickerSingleDateController, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function DayPickerSingleDateController(props) {
      var _this;

      _classCallCheck(this, DayPickerSingleDateController);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DayPickerSingleDateController).call(this, props));
      _this.isTouchDevice = false;
      _this.today = (0, _moment["default"])();
      _this.modifiers = {
        today: function () {
          function today(day) {
            return _this.isToday(day);
          }

          return today;
        }(),
        blocked: function () {
          function blocked(day) {
            return _this.isBlocked(day);
          }

          return blocked;
        }(),
        'blocked-calendar': function () {
          function blockedCalendar(day) {
            return props.isDayBlocked(day);
          }

          return blockedCalendar;
        }(),
        'blocked-out-of-range': function () {
          function blockedOutOfRange(day) {
            return props.isOutsideRange(day);
          }

          return blockedOutOfRange;
        }(),
        'highlighted-calendar': function () {
          function highlightedCalendar(day) {
            return props.isDayHighlighted(day);
          }

          return highlightedCalendar;
        }(),
        valid: function () {
          function valid(day) {
            return !_this.isBlocked(day);
          }

          return valid;
        }(),
        hovered: function () {
          function hovered(day) {
            return _this.isHovered(day);
          }

          return hovered;
        }(),
        selected: function () {
          function selected(day) {
            return _this.isSelected(day);
          }

          return selected;
        }(),
        'first-day-of-week': function () {
          function firstDayOfWeek(day) {
            return _this.isFirstDayOfWeek(day);
          }

          return firstDayOfWeek;
        }(),
        'last-day-of-week': function () {
          function lastDayOfWeek(day) {
            return _this.isLastDayOfWeek(day);
          }

          return lastDayOfWeek;
        }()
      };

      var _this$getStateForNewM = _this.getStateForNewMonth(props),
          currentMonth = _this$getStateForNewM.currentMonth,
          visibleDays = _this$getStateForNewM.visibleDays;

      _this.state = {
        hoverDate: null,
        currentMonth: currentMonth,
        visibleDays: visibleDays
      };
      _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayClick = _this.onDayClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onNextMonthClick = _this.onNextMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onYearChange = _this.onYearChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(DayPickerSingleDateController, [{
      key: "componentDidMount",
      value: function () {
        function componentDidMount() {
          this.isTouchDevice = (0, _isTouchDevice["default"])();
        }

        return componentDidMount;
      }()
    }, {
      key: "componentWillReceiveProps",
      value: function () {
        function componentWillReceiveProps(nextProps) {
          var _this2 = this;

          var date = nextProps.date,
              focused = nextProps.focused,
              isOutsideRange = nextProps.isOutsideRange,
              isDayBlocked = nextProps.isDayBlocked,
              isDayHighlighted = nextProps.isDayHighlighted,
              initialVisibleMonth = nextProps.initialVisibleMonth,
              numberOfMonths = nextProps.numberOfMonths,
              enableOutsideDays = nextProps.enableOutsideDays;
          var _this$props = this.props,
              prevIsOutsideRange = _this$props.isOutsideRange,
              prevIsDayBlocked = _this$props.isDayBlocked,
              prevIsDayHighlighted = _this$props.isDayHighlighted,
              prevNumberOfMonths = _this$props.numberOfMonths,
              prevEnableOutsideDays = _this$props.enableOutsideDays,
              prevInitialVisibleMonth = _this$props.initialVisibleMonth,
              prevFocused = _this$props.focused,
              prevDate = _this$props.date;
          var visibleDays = this.state.visibleDays;
          var recomputeOutsideRange = false;
          var recomputeDayBlocked = false;
          var recomputeDayHighlighted = false;

          if (isOutsideRange !== prevIsOutsideRange) {
            this.modifiers['blocked-out-of-range'] = function (day) {
              return isOutsideRange(day);
            };

            recomputeOutsideRange = true;
          }

          if (isDayBlocked !== prevIsDayBlocked) {
            this.modifiers['blocked-calendar'] = function (day) {
              return isDayBlocked(day);
            };

            recomputeDayBlocked = true;
          }

          if (isDayHighlighted !== prevIsDayHighlighted) {
            this.modifiers['highlighted-calendar'] = function (day) {
              return isDayHighlighted(day);
            };

            recomputeDayHighlighted = true;
          }

          var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;

          if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocused && focused) {
            var newMonthState = this.getStateForNewMonth(nextProps);
            var currentMonth = newMonthState.currentMonth;
            visibleDays = newMonthState.visibleDays;
            this.setState({
              currentMonth: currentMonth,
              visibleDays: visibleDays
            });
          }

          var didDateChange = date !== prevDate;
          var didFocusChange = focused !== prevFocused;
          var modifiers = {};

          if (didDateChange) {
            modifiers = this.deleteModifier(modifiers, prevDate, 'selected');
            modifiers = this.addModifier(modifiers, date, 'selected');
          }

          if (didFocusChange || recomputePropModifiers) {
            (0, _object["default"])(visibleDays).forEach(function (days) {
              Object.keys(days).forEach(function (day) {
                var momentObj = (0, _moment["default"])(day);

                if (_this2.isBlocked(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
                }

                if (didFocusChange || recomputeOutsideRange) {
                  if (isOutsideRange(momentObj)) {
                    modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
                  } else {
                    modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
                  }
                }

                if (didFocusChange || recomputeDayBlocked) {
                  if (isDayBlocked(momentObj)) {
                    modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
                  } else {
                    modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
                  }
                }

                if (didFocusChange || recomputeDayHighlighted) {
                  if (isDayHighlighted(momentObj)) {
                    modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
                  } else {
                    modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
                  }
                }
              });
            });
          }

          var today = (0, _moment["default"])();

          if (!(0, _isSameDay["default"])(this.today, today)) {
            modifiers = this.deleteModifier(modifiers, this.today, 'today');
            modifiers = this.addModifier(modifiers, today, 'today');
            this.today = today;
          }

          if (Object.keys(modifiers).length > 0) {
            this.setState({
              visibleDays: _objectSpread({}, visibleDays, modifiers)
            });
          }
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: "componentWillUpdate",
      value: function () {
        function componentWillUpdate() {
          this.today = (0, _moment["default"])();
        }

        return componentWillUpdate;
      }()
    }, {
      key: "onDayClick",
      value: function () {
        function onDayClick(day, e) {
          if (e) e.preventDefault();
          if (this.isBlocked(day)) return;
          var _this$props2 = this.props,
              onDateChange = _this$props2.onDateChange,
              keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
              onFocusChange = _this$props2.onFocusChange,
              onClose = _this$props2.onClose;
          onDateChange(day);

          if (!keepOpenOnDateSelect) {
            onFocusChange({
              focused: false
            });
            onClose({
              date: day
            });
          }
        }

        return onDayClick;
      }()
    }, {
      key: "onDayMouseEnter",
      value: function () {
        function onDayMouseEnter(day) {
          if (this.isTouchDevice) return;
          var _this$state = this.state,
              hoverDate = _this$state.hoverDate,
              visibleDays = _this$state.visibleDays;
          var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
          modifiers = this.addModifier(modifiers, day, 'hovered');
          this.setState({
            hoverDate: day,
            visibleDays: _objectSpread({}, visibleDays, modifiers)
          });
        }

        return onDayMouseEnter;
      }()
    }, {
      key: "onDayMouseLeave",
      value: function () {
        function onDayMouseLeave() {
          var _this$state2 = this.state,
              hoverDate = _this$state2.hoverDate,
              visibleDays = _this$state2.visibleDays;
          if (this.isTouchDevice || !hoverDate) return;
          var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
          this.setState({
            hoverDate: null,
            visibleDays: _objectSpread({}, visibleDays, modifiers)
          });
        }

        return onDayMouseLeave;
      }()
    }, {
      key: "onPrevMonthClick",
      value: function () {
        function onPrevMonthClick() {
          var _this$props3 = this.props,
              onPrevMonthClick = _this$props3.onPrevMonthClick,
              numberOfMonths = _this$props3.numberOfMonths,
              enableOutsideDays = _this$props3.enableOutsideDays;
          var _this$state3 = this.state,
              currentMonth = _this$state3.currentMonth,
              visibleDays = _this$state3.visibleDays;
          var newVisibleDays = {};
          Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
            newVisibleDays[month] = visibleDays[month];
          });
          var prevMonth = currentMonth.clone().subtract(1, 'month');
          var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays);
          this.setState({
            currentMonth: prevMonth,
            visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
          }, function () {
            onPrevMonthClick(prevMonth.clone());
          });
        }

        return onPrevMonthClick;
      }()
    }, {
      key: "onNextMonthClick",
      value: function () {
        function onNextMonthClick() {
          var _this$props4 = this.props,
              onNextMonthClick = _this$props4.onNextMonthClick,
              numberOfMonths = _this$props4.numberOfMonths,
              enableOutsideDays = _this$props4.enableOutsideDays;
          var _this$state4 = this.state,
              currentMonth = _this$state4.currentMonth,
              visibleDays = _this$state4.visibleDays;
          var newVisibleDays = {};
          Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
            newVisibleDays[month] = visibleDays[month];
          });
          var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
          var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays);
          var newCurrentMonth = currentMonth.clone().add(1, 'month');
          this.setState({
            currentMonth: newCurrentMonth,
            visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
          }, function () {
            onNextMonthClick(newCurrentMonth.clone());
          });
        }

        return onNextMonthClick;
      }()
    }, {
      key: "onMonthChange",
      value: function () {
        function onMonthChange(newMonth) {
          var _this$props5 = this.props,
              numberOfMonths = _this$props5.numberOfMonths,
              enableOutsideDays = _this$props5.enableOutsideDays,
              orientation = _this$props5.orientation;
          var withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;
          var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
          this.setState({
            currentMonth: newMonth.clone(),
            visibleDays: this.getModifiers(newVisibleDays)
          });
        }

        return onMonthChange;
      }()
    }, {
      key: "onYearChange",
      value: function () {
        function onYearChange(newMonth) {
          var _this$props6 = this.props,
              numberOfMonths = _this$props6.numberOfMonths,
              enableOutsideDays = _this$props6.enableOutsideDays,
              orientation = _this$props6.orientation;
          var withoutTransitionMonths = orientation === constants$4.VERTICAL_SCROLLABLE;
          var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
          this.setState({
            currentMonth: newMonth.clone(),
            visibleDays: this.getModifiers(newVisibleDays)
          });
        }

        return onYearChange;
      }()
    }, {
      key: "getFirstFocusableDay",
      value: function () {
        function getFirstFocusableDay(newMonth) {
          var _this3 = this;

          var _this$props7 = this.props,
              date = _this$props7.date,
              numberOfMonths = _this$props7.numberOfMonths;
          var focusedDate = newMonth.clone().startOf('month');

          if (date) {
            focusedDate = date.clone();
          }

          if (this.isBlocked(focusedDate)) {
            var days = [];
            var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
            var currentDay = focusedDate.clone();

            while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
              currentDay = currentDay.clone().add(1, 'day');
              days.push(currentDay);
            }

            var viableDays = days.filter(function (day) {
              return !_this3.isBlocked(day) && (0, _isAfterDay["default"])(day, focusedDate);
            });

            if (viableDays.length > 0) {
              var _viableDays = _slicedToArray(viableDays, 1);

              focusedDate = _viableDays[0];
            }
          }

          return focusedDate;
        }

        return getFirstFocusableDay;
      }()
    }, {
      key: "getModifiers",
      value: function () {
        function getModifiers(visibleDays) {
          var _this4 = this;

          var modifiers = {};
          Object.keys(visibleDays).forEach(function (month) {
            modifiers[month] = {};
            visibleDays[month].forEach(function (day) {
              modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
            });
          });
          return modifiers;
        }

        return getModifiers;
      }()
    }, {
      key: "getModifiersForDay",
      value: function () {
        function getModifiersForDay(day) {
          var _this5 = this;

          return new Set(Object.keys(this.modifiers).filter(function (modifier) {
            return _this5.modifiers[modifier](day);
          }));
        }

        return getModifiersForDay;
      }()
    }, {
      key: "getStateForNewMonth",
      value: function () {
        function getStateForNewMonth(nextProps) {
          var _this6 = this;

          var initialVisibleMonth = nextProps.initialVisibleMonth,
              date = nextProps.date,
              numberOfMonths = nextProps.numberOfMonths,
              enableOutsideDays = nextProps.enableOutsideDays;
          var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
            return date;
          } : function () {
            return _this6.today;
          });
          var currentMonth = initialVisibleMonthThunk();
          var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays));
          return {
            currentMonth: currentMonth,
            visibleDays: visibleDays
          };
        }

        return getStateForNewMonth;
      }()
    }, {
      key: "addModifier",
      value: function () {
        function addModifier(updatedDays, day, modifier) {
          var _this$props8 = this.props,
              numberOfVisibleMonths = _this$props8.numberOfMonths,
              enableOutsideDays = _this$props8.enableOutsideDays,
              orientation = _this$props8.orientation;
          var _this$state5 = this.state,
              firstVisibleMonth = _this$state5.currentMonth,
              visibleDays = _this$state5.visibleDays;
          var currentMonth = firstVisibleMonth;
          var numberOfMonths = numberOfVisibleMonths;

          if (orientation === constants$4.VERTICAL_SCROLLABLE) {
            numberOfMonths = Object.keys(visibleDays).length;
          } else {
            currentMonth = currentMonth.clone().subtract(1, 'month');
            numberOfMonths += 2;
          }

          if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
            return updatedDays;
          }

          var iso = (0, _toISODateString["default"])(day);

          var updatedDaysAfterAddition = _objectSpread({}, updatedDays);

          if (enableOutsideDays) {
            var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
              return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
            });
            updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
              var month = updatedDays[monthIso] || visibleDays[monthIso];
              var modifiers = new Set(month[iso]);
              modifiers.add(modifier);
              return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
            }, updatedDaysAfterAddition);
          } else {
            var monthIso = (0, _toISOMonthString["default"])(day);
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers.add(modifier);
            updatedDaysAfterAddition = _objectSpread({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
          }

          return updatedDaysAfterAddition;
        }

        return addModifier;
      }()
    }, {
      key: "deleteModifier",
      value: function () {
        function deleteModifier(updatedDays, day, modifier) {
          var _this$props9 = this.props,
              numberOfVisibleMonths = _this$props9.numberOfMonths,
              enableOutsideDays = _this$props9.enableOutsideDays,
              orientation = _this$props9.orientation;
          var _this$state6 = this.state,
              firstVisibleMonth = _this$state6.currentMonth,
              visibleDays = _this$state6.visibleDays;
          var currentMonth = firstVisibleMonth;
          var numberOfMonths = numberOfVisibleMonths;

          if (orientation === constants$4.VERTICAL_SCROLLABLE) {
            numberOfMonths = Object.keys(visibleDays).length;
          } else {
            currentMonth = currentMonth.clone().subtract(1, 'month');
            numberOfMonths += 2;
          }

          if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
            return updatedDays;
          }

          var iso = (0, _toISODateString["default"])(day);

          var updatedDaysAfterDeletion = _objectSpread({}, updatedDays);

          if (enableOutsideDays) {
            var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
              return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
            });
            updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
              var month = updatedDays[monthIso] || visibleDays[monthIso];
              var modifiers = new Set(month[iso]);
              modifiers["delete"](modifier);
              return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
            }, updatedDaysAfterDeletion);
          } else {
            var monthIso = (0, _toISOMonthString["default"])(day);
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers["delete"](modifier);
            updatedDaysAfterDeletion = _objectSpread({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
          }

          return updatedDaysAfterDeletion;
        }

        return deleteModifier;
      }()
    }, {
      key: "isBlocked",
      value: function () {
        function isBlocked(day) {
          var _this$props10 = this.props,
              isDayBlocked = _this$props10.isDayBlocked,
              isOutsideRange = _this$props10.isOutsideRange;
          return isDayBlocked(day) || isOutsideRange(day);
        }

        return isBlocked;
      }()
    }, {
      key: "isHovered",
      value: function () {
        function isHovered(day) {
          var _ref2 = this.state || {},
              hoverDate = _ref2.hoverDate;

          return (0, _isSameDay["default"])(day, hoverDate);
        }

        return isHovered;
      }()
    }, {
      key: "isSelected",
      value: function () {
        function isSelected(day) {
          var date = this.props.date;
          return (0, _isSameDay["default"])(day, date);
        }

        return isSelected;
      }()
    }, {
      key: "isToday",
      value: function () {
        function isToday(day) {
          return (0, _isSameDay["default"])(day, this.today);
        }

        return isToday;
      }()
    }, {
      key: "isFirstDayOfWeek",
      value: function () {
        function isFirstDayOfWeek(day) {
          var firstDayOfWeek = this.props.firstDayOfWeek;
          return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
        }

        return isFirstDayOfWeek;
      }()
    }, {
      key: "isLastDayOfWeek",
      value: function () {
        function isLastDayOfWeek(day) {
          var firstDayOfWeek = this.props.firstDayOfWeek;
          return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
        }

        return isLastDayOfWeek;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$props11 = this.props,
              numberOfMonths = _this$props11.numberOfMonths,
              orientation = _this$props11.orientation,
              monthFormat = _this$props11.monthFormat,
              renderMonthText = _this$props11.renderMonthText,
              navPrev = _this$props11.navPrev,
              navNext = _this$props11.navNext,
              onOutsideClick = _this$props11.onOutsideClick,
              onShiftTab = _this$props11.onShiftTab,
              onTab = _this$props11.onTab,
              withPortal = _this$props11.withPortal,
              focused = _this$props11.focused,
              enableOutsideDays = _this$props11.enableOutsideDays,
              hideKeyboardShortcutsPanel = _this$props11.hideKeyboardShortcutsPanel,
              daySize = _this$props11.daySize,
              firstDayOfWeek = _this$props11.firstDayOfWeek,
              renderCalendarDay = _this$props11.renderCalendarDay,
              renderDayContents = _this$props11.renderDayContents,
              renderCalendarInfo = _this$props11.renderCalendarInfo,
              renderMonthElement = _this$props11.renderMonthElement,
              calendarInfoPosition = _this$props11.calendarInfoPosition,
              isFocused = _this$props11.isFocused,
              isRTL = _this$props11.isRTL,
              phrases = _this$props11.phrases,
              dayAriaLabelFormat = _this$props11.dayAriaLabelFormat,
              onBlur = _this$props11.onBlur,
              showKeyboardShortcuts = _this$props11.showKeyboardShortcuts,
              weekDayFormat = _this$props11.weekDayFormat,
              verticalHeight = _this$props11.verticalHeight,
              noBorder = _this$props11.noBorder,
              transitionDuration = _this$props11.transitionDuration,
              verticalBorderSpacing = _this$props11.verticalBorderSpacing,
              horizontalMonthPadding = _this$props11.horizontalMonthPadding;
          var _this$state7 = this.state,
              currentMonth = _this$state7.currentMonth,
              visibleDays = _this$state7.visibleDays;
          return _react["default"].createElement(_DayPicker["default"], {
            orientation: orientation,
            enableOutsideDays: enableOutsideDays,
            modifiers: visibleDays,
            numberOfMonths: numberOfMonths,
            onDayClick: this.onDayClick,
            onDayMouseEnter: this.onDayMouseEnter,
            onDayMouseLeave: this.onDayMouseLeave,
            onPrevMonthClick: this.onPrevMonthClick,
            onNextMonthClick: this.onNextMonthClick,
            onMonthChange: this.onMonthChange,
            onYearChange: this.onYearChange,
            monthFormat: monthFormat,
            withPortal: withPortal,
            hidden: !focused,
            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
            initialVisibleMonth: function () {
              function initialVisibleMonth() {
                return currentMonth;
              }

              return initialVisibleMonth;
            }(),
            firstDayOfWeek: firstDayOfWeek,
            onOutsideClick: onOutsideClick,
            navPrev: navPrev,
            navNext: navNext,
            renderMonthText: renderMonthText,
            renderCalendarDay: renderCalendarDay,
            renderDayContents: renderDayContents,
            renderCalendarInfo: renderCalendarInfo,
            renderMonthElement: renderMonthElement,
            calendarInfoPosition: calendarInfoPosition,
            isFocused: isFocused,
            getFirstFocusableDay: this.getFirstFocusableDay,
            onBlur: onBlur,
            onTab: onTab,
            onShiftTab: onShiftTab,
            phrases: phrases,
            daySize: daySize,
            isRTL: isRTL,
            showKeyboardShortcuts: showKeyboardShortcuts,
            weekDayFormat: weekDayFormat,
            dayAriaLabelFormat: dayAriaLabelFormat,
            verticalHeight: verticalHeight,
            noBorder: noBorder,
            transitionDuration: transitionDuration,
            verticalBorderSpacing: verticalBorderSpacing,
            horizontalMonthPadding: horizontalMonthPadding
          });
        }

        return render;
      }()
    }]);

    return DayPickerSingleDateController;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports["default"] = DayPickerSingleDateController;
  DayPickerSingleDateController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  DayPickerSingleDateController.defaultProps = defaultProps;
});
unwrapExports(DayPickerSingleDateController_1);
var SingleDatePickerShape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _IconPositionShape = _interopRequireDefault(IconPositionShape);

  var _OrientationShape = _interopRequireDefault(OrientationShape);

  var _AnchorDirectionShape = _interopRequireDefault(AnchorDirectionShape);

  var _OpenDirectionShape = _interopRequireDefault(OpenDirectionShape);

  var _DayOfWeekShape = _interopRequireDefault(DayOfWeekShape);

  var _CalendarInfoPositionShape = _interopRequireDefault(CalendarInfoPositionShape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var _default = {
    // required props for a functional interactive SingleDatePicker
    date: _reactMomentProptypes["default"].momentObj,
    onDateChange: _propTypes["default"].func.isRequired,
    focused: _propTypes["default"].bool,
    onFocusChange: _propTypes["default"].func.isRequired,
    // input related props
    id: _propTypes["default"].string.isRequired,
    placeholder: _propTypes["default"].string,
    disabled: _propTypes["default"].bool,
    required: _propTypes["default"].bool,
    readOnly: _propTypes["default"].bool,
    screenReaderInputMessage: _propTypes["default"].string,
    showClearDate: _propTypes["default"].bool,
    customCloseIcon: _propTypes["default"].node,
    showDefaultInputIcon: _propTypes["default"].bool,
    inputIconPosition: _IconPositionShape["default"],
    customInputIcon: _propTypes["default"].node,
    noBorder: _propTypes["default"].bool,
    block: _propTypes["default"].bool,
    small: _propTypes["default"].bool,
    regular: _propTypes["default"].bool,
    verticalSpacing: airbnbPropTypes.nonNegativeInteger,
    keepFocusOnInput: _propTypes["default"].bool,
    // calendar presentation and interaction related props
    renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
    orientation: _OrientationShape["default"],
    anchorDirection: _AnchorDirectionShape["default"],
    openDirection: _OpenDirectionShape["default"],
    horizontalMargin: _propTypes["default"].number,
    withPortal: _propTypes["default"].bool,
    withFullScreenPortal: _propTypes["default"].bool,
    appendToBody: _propTypes["default"].bool,
    disableScroll: _propTypes["default"].bool,
    initialVisibleMonth: _propTypes["default"].func,
    firstDayOfWeek: _DayOfWeekShape["default"],
    numberOfMonths: _propTypes["default"].number,
    keepOpenOnDateSelect: _propTypes["default"].bool,
    reopenPickerOnClearDate: _propTypes["default"].bool,
    renderCalendarInfo: _propTypes["default"].func,
    calendarInfoPosition: _CalendarInfoPositionShape["default"],
    hideKeyboardShortcutsPanel: _propTypes["default"].bool,
    daySize: airbnbPropTypes.nonNegativeInteger,
    isRTL: _propTypes["default"].bool,
    verticalHeight: airbnbPropTypes.nonNegativeInteger,
    transitionDuration: airbnbPropTypes.nonNegativeInteger,
    horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
    // navigation related props
    navPrev: _propTypes["default"].node,
    navNext: _propTypes["default"].node,
    onPrevMonthClick: _propTypes["default"].func,
    onNextMonthClick: _propTypes["default"].func,
    onClose: _propTypes["default"].func,
    // day presentation and interaction related props
    renderCalendarDay: _propTypes["default"].func,
    renderDayContents: _propTypes["default"].func,
    enableOutsideDays: _propTypes["default"].bool,
    isDayBlocked: _propTypes["default"].func,
    isOutsideRange: _propTypes["default"].func,
    isDayHighlighted: _propTypes["default"].func,
    // internationalization props
    displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
    monthFormat: _propTypes["default"].string,
    weekDayFormat: _propTypes["default"].string,
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerPhrases)),
    dayAriaLabelFormat: _propTypes["default"].string
  };
  exports["default"] = _default;
});
unwrapExports(SingleDatePickerShape);
var SingleDatePickerInput_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _noflip = _interopRequireDefault(noflip_1);

  var _DateInput = _interopRequireDefault(DateInput_1);

  var _IconPositionShape = _interopRequireDefault(IconPositionShape);

  var _CloseButton = _interopRequireDefault(CloseButton_1);

  var _CalendarIcon = _interopRequireDefault(CalendarIcon_1);

  var _OpenDirectionShape = _interopRequireDefault(OpenDirectionShape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
    id: _propTypes["default"].string.isRequired,
    children: _propTypes["default"].node,
    placeholder: _propTypes["default"].string,
    // also used as label
    displayValue: _propTypes["default"].string,
    screenReaderMessage: _propTypes["default"].string,
    focused: _propTypes["default"].bool,
    isFocused: _propTypes["default"].bool,
    // describes actual DOM focus
    disabled: _propTypes["default"].bool,
    required: _propTypes["default"].bool,
    readOnly: _propTypes["default"].bool,
    openDirection: _OpenDirectionShape["default"],
    showCaret: _propTypes["default"].bool,
    showClearDate: _propTypes["default"].bool,
    customCloseIcon: _propTypes["default"].node,
    showDefaultInputIcon: _propTypes["default"].bool,
    inputIconPosition: _IconPositionShape["default"],
    customInputIcon: _propTypes["default"].node,
    isRTL: _propTypes["default"].bool,
    noBorder: _propTypes["default"].bool,
    block: _propTypes["default"].bool,
    small: _propTypes["default"].bool,
    regular: _propTypes["default"].bool,
    verticalSpacing: airbnbPropTypes.nonNegativeInteger,
    onChange: _propTypes["default"].func,
    onClearDate: _propTypes["default"].func,
    onFocus: _propTypes["default"].func,
    onKeyDownShiftTab: _propTypes["default"].func,
    onKeyDownTab: _propTypes["default"].func,
    onKeyDownArrowDown: _propTypes["default"].func,
    onKeyDownQuestionMark: _propTypes["default"].func,
    // i18n
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerInputPhrases))
  })) : {};
  var defaultProps = {
    children: null,
    placeholder: 'Select Date',
    displayValue: '',
    screenReaderMessage: '',
    focused: false,
    isFocused: false,
    disabled: false,
    required: false,
    readOnly: false,
    openDirection: constants$4.OPEN_DOWN,
    showCaret: false,
    showClearDate: false,
    showDefaultInputIcon: false,
    inputIconPosition: constants$4.ICON_BEFORE_POSITION,
    customCloseIcon: null,
    customInputIcon: null,
    isRTL: false,
    noBorder: false,
    block: false,
    small: false,
    regular: false,
    verticalSpacing: undefined,
    onChange: function () {
      function onChange() {}

      return onChange;
    }(),
    onClearDate: function () {
      function onClearDate() {}

      return onClearDate;
    }(),
    onFocus: function () {
      function onFocus() {}

      return onFocus;
    }(),
    onKeyDownShiftTab: function () {
      function onKeyDownShiftTab() {}

      return onKeyDownShiftTab;
    }(),
    onKeyDownTab: function () {
      function onKeyDownTab() {}

      return onKeyDownTab;
    }(),
    onKeyDownArrowDown: function () {
      function onKeyDownArrowDown() {}

      return onKeyDownArrowDown;
    }(),
    onKeyDownQuestionMark: function () {
      function onKeyDownQuestionMark() {}

      return onKeyDownQuestionMark;
    }(),
    // i18n
    phrases: defaultPhrases.SingleDatePickerInputPhrases
  };

  function SingleDatePickerInput(_ref) {
    var id = _ref.id,
        children = _ref.children,
        placeholder = _ref.placeholder,
        displayValue = _ref.displayValue,
        focused = _ref.focused,
        isFocused = _ref.isFocused,
        disabled = _ref.disabled,
        required = _ref.required,
        readOnly = _ref.readOnly,
        showCaret = _ref.showCaret,
        showClearDate = _ref.showClearDate,
        showDefaultInputIcon = _ref.showDefaultInputIcon,
        inputIconPosition = _ref.inputIconPosition,
        phrases = _ref.phrases,
        onClearDate = _ref.onClearDate,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        onKeyDownShiftTab = _ref.onKeyDownShiftTab,
        onKeyDownTab = _ref.onKeyDownTab,
        onKeyDownArrowDown = _ref.onKeyDownArrowDown,
        onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
        screenReaderMessage = _ref.screenReaderMessage,
        customCloseIcon = _ref.customCloseIcon,
        customInputIcon = _ref.customInputIcon,
        openDirection = _ref.openDirection,
        isRTL = _ref.isRTL,
        noBorder = _ref.noBorder,
        block = _ref.block,
        small = _ref.small,
        regular = _ref.regular,
        verticalSpacing = _ref.verticalSpacing,
        styles = _ref.styles;

    var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, withStyles_1.css)(styles.SingleDatePickerInput_calendarIcon_svg));

    var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.SingleDatePickerInput_clearDate_svg, small && styles.SingleDatePickerInput_clearDate_svg__small));

    var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;

    var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", _extends({}, (0, withStyles_1.css)(styles.SingleDatePickerInput_calendarIcon), {
      type: "button",
      disabled: disabled,
      "aria-label": phrases.focusStartDate,
      onClick: onFocus
    }), calendarIcon);

    return _react["default"].createElement("div", (0, withStyles_1.css)(styles.SingleDatePickerInput, disabled && styles.SingleDatePickerInput__disabled, isRTL && styles.SingleDatePickerInput__rtl, !noBorder && styles.SingleDatePickerInput__withBorder, block && styles.SingleDatePickerInput__block, showClearDate && styles.SingleDatePickerInput__showClearDate), inputIconPosition === constants$4.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
      id: id,
      placeholder: placeholder // also used as label
      ,
      displayValue: displayValue,
      screenReaderMessage: screenReaderText,
      focused: focused,
      isFocused: isFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      showCaret: showCaret,
      onChange: onChange,
      onFocus: onFocus,
      onKeyDownShiftTab: onKeyDownShiftTab,
      onKeyDownTab: onKeyDownTab,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      openDirection: openDirection,
      verticalSpacing: verticalSpacing,
      small: small,
      regular: regular,
      block: block
    }), children, showClearDate && _react["default"].createElement("button", _extends({}, (0, withStyles_1.css)(styles.SingleDatePickerInput_clearDate, small && styles.SingleDatePickerInput_clearDate__small, !customCloseIcon && styles.SingleDatePickerInput_clearDate__default, !displayValue && styles.SingleDatePickerInput_clearDate__hide), {
      type: "button",
      "aria-label": phrases.clearDate,
      disabled: disabled,
      onClick: onClearDate
    }), closeIcon), inputIconPosition === constants$4.ICON_AFTER_POSITION && inputIcon);
  }

  SingleDatePickerInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  SingleDatePickerInput.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref2) {
    var _ref2$reactDates = _ref2.reactDates,
        border = _ref2$reactDates.border,
        color = _ref2$reactDates.color;
    return {
      SingleDatePickerInput: {
        display: 'inline-block',
        backgroundColor: color.background
      },
      SingleDatePickerInput__withBorder: {
        borderColor: color.border,
        borderWidth: border.pickerInput.borderWidth,
        borderStyle: border.pickerInput.borderStyle,
        borderRadius: border.pickerInput.borderRadius
      },
      SingleDatePickerInput__rtl: {
        direction: (0, _noflip["default"])('rtl')
      },
      SingleDatePickerInput__disabled: {
        backgroundColor: color.disabled
      },
      SingleDatePickerInput__block: {
        display: 'block'
      },
      SingleDatePickerInput__showClearDate: {
        paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop

      },
      SingleDatePickerInput_clearDate: {
        background: 'none',
        border: 0,
        color: 'inherit',
        font: 'inherit',
        lineHeight: 'normal',
        overflow: 'visible',
        cursor: 'pointer',
        padding: 10,
        margin: '0 10px 0 5px',
        // TODO: should be noflip wrapped and handled by an isRTL prop
        position: 'absolute',
        right: 0,
        // TODO: should be noflip wrapped and handled by an isRTL prop
        top: '50%',
        transform: 'translateY(-50%)'
      },
      SingleDatePickerInput_clearDate__default: {
        ':focus': {
          background: color.core.border,
          borderRadius: '50%'
        },
        ':hover': {
          background: color.core.border,
          borderRadius: '50%'
        }
      },
      SingleDatePickerInput_clearDate__small: {
        padding: 6
      },
      SingleDatePickerInput_clearDate__hide: {
        visibility: 'hidden'
      },
      SingleDatePickerInput_clearDate_svg: {
        fill: color.core.grayLight,
        height: 12,
        width: 15,
        verticalAlign: 'middle'
      },
      SingleDatePickerInput_clearDate_svg__small: {
        height: 9
      },
      SingleDatePickerInput_calendarIcon: {
        background: 'none',
        border: 0,
        color: 'inherit',
        font: 'inherit',
        lineHeight: 'normal',
        overflow: 'visible',
        cursor: 'pointer',
        display: 'inline-block',
        verticalAlign: 'middle',
        padding: 10,
        margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop

      },
      SingleDatePickerInput_calendarIcon_svg: {
        fill: color.core.grayLight,
        height: 15,
        width: 14,
        verticalAlign: 'middle'
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(SingleDatePickerInput);

  exports["default"] = _default;
});
unwrapExports(SingleDatePickerInput_1);
var SingleDatePickerInputController_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _propTypes = _interopRequireDefault(propTypes$1);

  var _moment = _interopRequireDefault(moment);

  var _reactMomentProptypes = _interopRequireDefault(src$1);

  var _OpenDirectionShape = _interopRequireDefault(OpenDirectionShape);

  var _getPhrasePropTypes = _interopRequireDefault(getPhrasePropTypes_1);

  var _SingleDatePickerInput = _interopRequireDefault(SingleDatePickerInput_1);

  var _IconPositionShape = _interopRequireDefault(IconPositionShape);

  var _DisabledShape = _interopRequireDefault(DisabledShape);

  var _toMomentObject = _interopRequireDefault(toMomentObject_1);

  var _toLocalizedDateString = _interopRequireDefault(toLocalizedDateString_1);

  var _isInclusivelyAfterDay = _interopRequireDefault(isInclusivelyAfterDay_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
    children: _propTypes["default"].node,
    date: _reactMomentProptypes["default"].momentObj,
    onDateChange: _propTypes["default"].func.isRequired,
    focused: _propTypes["default"].bool,
    onFocusChange: _propTypes["default"].func.isRequired,
    id: _propTypes["default"].string.isRequired,
    placeholder: _propTypes["default"].string,
    // also used as label
    screenReaderMessage: _propTypes["default"].string,
    showClearDate: _propTypes["default"].bool,
    showCaret: _propTypes["default"].bool,
    showDefaultInputIcon: _propTypes["default"].bool,
    inputIconPosition: _IconPositionShape["default"],
    disabled: _DisabledShape["default"],
    required: _propTypes["default"].bool,
    readOnly: _propTypes["default"].bool,
    openDirection: _OpenDirectionShape["default"],
    noBorder: _propTypes["default"].bool,
    block: _propTypes["default"].bool,
    small: _propTypes["default"].bool,
    regular: _propTypes["default"].bool,
    verticalSpacing: airbnbPropTypes.nonNegativeInteger,
    keepOpenOnDateSelect: _propTypes["default"].bool,
    reopenPickerOnClearDate: _propTypes["default"].bool,
    isOutsideRange: _propTypes["default"].func,
    displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
    onClose: _propTypes["default"].func,
    onKeyDownArrowDown: _propTypes["default"].func,
    onKeyDownQuestionMark: _propTypes["default"].func,
    customInputIcon: _propTypes["default"].node,
    customCloseIcon: _propTypes["default"].node,
    // accessibility
    isFocused: _propTypes["default"].bool,
    // i18n
    phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerInputPhrases)),
    isRTL: _propTypes["default"].bool
  }) : {};
  var defaultProps = {
    children: null,
    date: null,
    focused: false,
    placeholder: '',
    screenReaderMessage: 'Date',
    showClearDate: false,
    showCaret: false,
    showDefaultInputIcon: false,
    inputIconPosition: constants$4.ICON_BEFORE_POSITION,
    disabled: false,
    required: false,
    readOnly: false,
    openDirection: constants$4.OPEN_DOWN,
    noBorder: false,
    block: false,
    small: false,
    regular: false,
    verticalSpacing: undefined,
    keepOpenOnDateSelect: false,
    reopenPickerOnClearDate: false,
    isOutsideRange: function () {
      function isOutsideRange(day) {
        return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
      }

      return isOutsideRange;
    }(),
    displayFormat: function () {
      function displayFormat() {
        return _moment["default"].localeData().longDateFormat('L');
      }

      return displayFormat;
    }(),
    onClose: function () {
      function onClose() {}

      return onClose;
    }(),
    onKeyDownArrowDown: function () {
      function onKeyDownArrowDown() {}

      return onKeyDownArrowDown;
    }(),
    onKeyDownQuestionMark: function () {
      function onKeyDownQuestionMark() {}

      return onKeyDownQuestionMark;
    }(),
    customInputIcon: null,
    customCloseIcon: null,
    // accessibility
    isFocused: false,
    // i18n
    phrases: defaultPhrases.SingleDatePickerInputPhrases,
    isRTL: false
  };

  var SingleDatePickerInputController =
  /*#__PURE__*/
  function (_ref) {
    _inherits(SingleDatePickerInputController, _ref);

    _createClass(SingleDatePickerInputController, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function SingleDatePickerInputController(props) {
      var _this;

      _classCallCheck(this, SingleDatePickerInputController);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleDatePickerInputController).call(this, props));
      _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onClearFocus = _this.onClearFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.clearDate = _this.clearDate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(SingleDatePickerInputController, [{
      key: "onChange",
      value: function () {
        function onChange(dateString) {
          var _this$props = this.props,
              isOutsideRange = _this$props.isOutsideRange,
              keepOpenOnDateSelect = _this$props.keepOpenOnDateSelect,
              onDateChange = _this$props.onDateChange,
              onFocusChange = _this$props.onFocusChange,
              onClose = _this$props.onClose;
          var newDate = (0, _toMomentObject["default"])(dateString, this.getDisplayFormat());
          var isValid = newDate && !isOutsideRange(newDate);

          if (isValid) {
            onDateChange(newDate);

            if (!keepOpenOnDateSelect) {
              onFocusChange({
                focused: false
              });
              onClose({
                date: newDate
              });
            }
          } else {
            onDateChange(null);
          }
        }

        return onChange;
      }()
    }, {
      key: "onFocus",
      value: function () {
        function onFocus() {
          var _this$props2 = this.props,
              onFocusChange = _this$props2.onFocusChange,
              disabled = _this$props2.disabled;

          if (!disabled) {
            onFocusChange({
              focused: true
            });
          }
        }

        return onFocus;
      }()
    }, {
      key: "onClearFocus",
      value: function () {
        function onClearFocus() {
          var _this$props3 = this.props,
              focused = _this$props3.focused,
              onFocusChange = _this$props3.onFocusChange,
              onClose = _this$props3.onClose,
              date = _this$props3.date;
          if (!focused) return;
          onFocusChange({
            focused: false
          });
          onClose({
            date: date
          });
        }

        return onClearFocus;
      }()
    }, {
      key: "getDisplayFormat",
      value: function () {
        function getDisplayFormat() {
          var displayFormat = this.props.displayFormat;
          return typeof displayFormat === 'string' ? displayFormat : displayFormat();
        }

        return getDisplayFormat;
      }()
    }, {
      key: "getDateString",
      value: function () {
        function getDateString(date) {
          var displayFormat = this.getDisplayFormat();

          if (date && displayFormat) {
            return date && date.format(displayFormat);
          }

          return (0, _toLocalizedDateString["default"])(date);
        }

        return getDateString;
      }()
    }, {
      key: "clearDate",
      value: function () {
        function clearDate() {
          var _this$props4 = this.props,
              onDateChange = _this$props4.onDateChange,
              reopenPickerOnClearDate = _this$props4.reopenPickerOnClearDate,
              onFocusChange = _this$props4.onFocusChange;
          onDateChange(null);

          if (reopenPickerOnClearDate) {
            onFocusChange({
              focused: true
            });
          }
        }

        return clearDate;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$props5 = this.props,
              children = _this$props5.children,
              id = _this$props5.id,
              placeholder = _this$props5.placeholder,
              disabled = _this$props5.disabled,
              focused = _this$props5.focused,
              isFocused = _this$props5.isFocused,
              required = _this$props5.required,
              readOnly = _this$props5.readOnly,
              openDirection = _this$props5.openDirection,
              showClearDate = _this$props5.showClearDate,
              showCaret = _this$props5.showCaret,
              showDefaultInputIcon = _this$props5.showDefaultInputIcon,
              inputIconPosition = _this$props5.inputIconPosition,
              customCloseIcon = _this$props5.customCloseIcon,
              customInputIcon = _this$props5.customInputIcon,
              date = _this$props5.date,
              phrases = _this$props5.phrases,
              onKeyDownArrowDown = _this$props5.onKeyDownArrowDown,
              onKeyDownQuestionMark = _this$props5.onKeyDownQuestionMark,
              screenReaderMessage = _this$props5.screenReaderMessage,
              isRTL = _this$props5.isRTL,
              noBorder = _this$props5.noBorder,
              block = _this$props5.block,
              small = _this$props5.small,
              regular = _this$props5.regular,
              verticalSpacing = _this$props5.verticalSpacing;
          var displayValue = this.getDateString(date);
          return _react["default"].createElement(_SingleDatePickerInput["default"], {
            id: id,
            placeholder: placeholder,
            focused: focused,
            isFocused: isFocused,
            disabled: disabled,
            required: required,
            readOnly: readOnly,
            openDirection: openDirection,
            showCaret: showCaret,
            onClearDate: this.clearDate,
            showClearDate: showClearDate,
            showDefaultInputIcon: showDefaultInputIcon,
            inputIconPosition: inputIconPosition,
            customCloseIcon: customCloseIcon,
            customInputIcon: customInputIcon,
            displayValue: displayValue,
            onChange: this.onChange,
            onFocus: this.onFocus,
            onKeyDownShiftTab: this.onClearFocus,
            onKeyDownArrowDown: onKeyDownArrowDown,
            onKeyDownQuestionMark: onKeyDownQuestionMark,
            screenReaderMessage: screenReaderMessage,
            phrases: phrases,
            isRTL: isRTL,
            noBorder: noBorder,
            block: block,
            small: small,
            regular: regular,
            verticalSpacing: verticalSpacing
          }, children);
        }

        return render;
      }()
    }]);

    return SingleDatePickerInputController;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports["default"] = SingleDatePickerInputController;
  SingleDatePickerInputController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  SingleDatePickerInputController.defaultProps = defaultProps;
});
unwrapExports(SingleDatePickerInputController_1);
var SingleDatePicker_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.PureSingleDatePicker = void 0;

  var _reactAddonsShallowCompare = _interopRequireDefault(reactAddonsShallowCompare);

  var _react = _interopRequireDefault(React__default);

  var _moment = _interopRequireDefault(moment);

  var _isTouchDevice = _interopRequireDefault(build$2);

  var _reactOutsideClickHandler = _interopRequireDefault(reactOutsideClickHandler);

  var _SingleDatePickerShape = _interopRequireDefault(SingleDatePickerShape);

  var _getResponsiveContainerStyles = _interopRequireDefault(getResponsiveContainerStyles_1);

  var _getDetachedContainerStyles = _interopRequireDefault(getDetachedContainerStyles_1);

  var _getInputHeight = _interopRequireDefault(getInputHeight_1);

  var _isInclusivelyAfterDay = _interopRequireDefault(isInclusivelyAfterDay_1);

  var _disableScroll2 = _interopRequireDefault(disableScroll_1);

  var _noflip = _interopRequireDefault(noflip_1);

  var _SingleDatePickerInputController = _interopRequireDefault(SingleDatePickerInputController_1);

  var _DayPickerSingleDateController = _interopRequireDefault(DayPickerSingleDateController_1);

  var _CloseButton = _interopRequireDefault(CloseButton_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () {
      function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }

      return _getPrototypeOf;
    }();
    return _getPrototypeOf(o);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function () {
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      }

      return _setPrototypeOf;
    }();

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, _SingleDatePickerShape["default"])) : {};
  var defaultProps = {
    // required props for a functional interactive SingleDatePicker
    date: null,
    focused: false,
    // input related props
    id: 'date',
    placeholder: 'Date',
    disabled: false,
    required: false,
    readOnly: false,
    screenReaderInputMessage: '',
    showClearDate: false,
    showDefaultInputIcon: false,
    inputIconPosition: constants$4.ICON_BEFORE_POSITION,
    customInputIcon: null,
    customCloseIcon: null,
    noBorder: false,
    block: false,
    small: false,
    regular: false,
    verticalSpacing: constants$4.DEFAULT_VERTICAL_SPACING,
    keepFocusOnInput: false,
    // calendar presentation and interaction related props
    orientation: constants$4.HORIZONTAL_ORIENTATION,
    anchorDirection: constants$4.ANCHOR_LEFT,
    openDirection: constants$4.OPEN_DOWN,
    horizontalMargin: 0,
    withPortal: false,
    withFullScreenPortal: false,
    appendToBody: false,
    disableScroll: false,
    initialVisibleMonth: null,
    firstDayOfWeek: null,
    numberOfMonths: 2,
    keepOpenOnDateSelect: false,
    reopenPickerOnClearDate: false,
    renderCalendarInfo: null,
    calendarInfoPosition: constants$4.INFO_POSITION_BOTTOM,
    hideKeyboardShortcutsPanel: false,
    daySize: constants$4.DAY_SIZE,
    isRTL: false,
    verticalHeight: null,
    transitionDuration: undefined,
    horizontalMonthPadding: 13,
    // navigation related props
    navPrev: null,
    navNext: null,
    onPrevMonthClick: function () {
      function onPrevMonthClick() {}

      return onPrevMonthClick;
    }(),
    onNextMonthClick: function () {
      function onNextMonthClick() {}

      return onNextMonthClick;
    }(),
    onClose: function () {
      function onClose() {}

      return onClose;
    }(),
    // month presentation and interaction related props
    renderMonthText: null,
    // day presentation and interaction related props
    renderCalendarDay: undefined,
    renderDayContents: null,
    renderMonthElement: null,
    enableOutsideDays: false,
    isDayBlocked: function () {
      function isDayBlocked() {
        return false;
      }

      return isDayBlocked;
    }(),
    isOutsideRange: function () {
      function isOutsideRange(day) {
        return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
      }

      return isOutsideRange;
    }(),
    isDayHighlighted: function () {
      function isDayHighlighted() {}

      return isDayHighlighted;
    }(),
    // internationalization props
    displayFormat: function () {
      function displayFormat() {
        return _moment["default"].localeData().longDateFormat('L');
      }

      return displayFormat;
    }(),
    monthFormat: 'MMMM YYYY',
    weekDayFormat: 'dd',
    phrases: defaultPhrases.SingleDatePickerPhrases,
    dayAriaLabelFormat: undefined
  };

  var SingleDatePicker =
  /*#__PURE__*/
  function (_ref) {
    _inherits(SingleDatePicker, _ref);

    _createClass(SingleDatePicker, [{
      key: !_react["default"].PureComponent && "shouldComponentUpdate",
      value: function () {
        function value(nextProps, nextState) {
          return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
        }

        return value;
      }()
    }]);

    function SingleDatePicker(props) {
      var _this;

      _classCallCheck(this, SingleDatePicker);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleDatePicker).call(this, props));
      _this.isTouchDevice = false;
      _this.state = {
        dayPickerContainerStyles: {},
        isDayPickerFocused: false,
        isInputFocused: false,
        showKeyboardShortcuts: false
      };
      _this.onFocusOut = _this.onFocusOut.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onOutsideClick = _this.onOutsideClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onInputFocus = _this.onInputFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.disableScroll = _this.disableScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }
    /* istanbul ignore next */


    _createClass(SingleDatePicker, [{
      key: "componentDidMount",
      value: function () {
        function componentDidMount() {
          this.removeResizeEventListener = (0, index_esm.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
            passive: true
          });
          this.responsivizePickerPosition();
          this.disableScroll();
          var focused = this.props.focused;

          if (focused) {
            this.setState({
              isInputFocused: true
            });
          }

          this.isTouchDevice = (0, _isTouchDevice["default"])();
        }

        return componentDidMount;
      }()
    }, {
      key: "componentDidUpdate",
      value: function () {
        function componentDidUpdate(prevProps) {
          var focused = this.props.focused;

          if (!prevProps.focused && focused) {
            this.responsivizePickerPosition();
            this.disableScroll();
          } else if (prevProps.focused && !focused) {
            if (this.enableScroll) this.enableScroll();
          }
        }

        return componentDidUpdate;
      }()
      /* istanbul ignore next */

    }, {
      key: "componentWillUnmount",
      value: function () {
        function componentWillUnmount() {
          if (this.removeResizeEventListener) this.removeResizeEventListener();
          if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
          if (this.enableScroll) this.enableScroll();
        }

        return componentWillUnmount;
      }()
    }, {
      key: "onOutsideClick",
      value: function () {
        function onOutsideClick(event) {
          var _this$props = this.props,
              focused = _this$props.focused,
              onFocusChange = _this$props.onFocusChange,
              onClose = _this$props.onClose,
              startDate = _this$props.startDate,
              endDate = _this$props.endDate,
              appendToBody = _this$props.appendToBody;
          if (!focused) return;
          if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
          this.setState({
            isInputFocused: false,
            isDayPickerFocused: false,
            showKeyboardShortcuts: false
          });
          onFocusChange({
            focused: false
          });
          onClose({
            startDate: startDate,
            endDate: endDate
          });
        }

        return onOutsideClick;
      }()
    }, {
      key: "onInputFocus",
      value: function () {
        function onInputFocus(_ref2) {
          var focused = _ref2.focused;
          var _this$props2 = this.props,
              onFocusChange = _this$props2.onFocusChange,
              readOnly = _this$props2.readOnly,
              withPortal = _this$props2.withPortal,
              withFullScreenPortal = _this$props2.withFullScreenPortal,
              keepFocusOnInput = _this$props2.keepFocusOnInput;

          if (focused) {
            var withAnyPortal = withPortal || withFullScreenPortal;
            var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;

            if (moveFocusToDayPicker) {
              this.onDayPickerFocus();
            } else {
              this.onDayPickerBlur();
            }
          }

          onFocusChange({
            focused: focused
          });
        }

        return onInputFocus;
      }()
    }, {
      key: "onDayPickerFocus",
      value: function () {
        function onDayPickerFocus() {
          this.setState({
            isInputFocused: false,
            isDayPickerFocused: true,
            showKeyboardShortcuts: false
          });
        }

        return onDayPickerFocus;
      }()
    }, {
      key: "onDayPickerBlur",
      value: function () {
        function onDayPickerBlur() {
          this.setState({
            isInputFocused: true,
            isDayPickerFocused: false,
            showKeyboardShortcuts: false
          });
        }

        return onDayPickerBlur;
      }()
    }, {
      key: "onFocusOut",
      value: function () {
        function onFocusOut(e) {
          var onFocusChange = this.props.onFocusChange;
          if (this.container.contains(e.relatedTarget || e.target)) return;
          onFocusChange({
            focused: false
          });
        }

        return onFocusOut;
      }()
    }, {
      key: "setDayPickerContainerRef",
      value: function () {
        function setDayPickerContainerRef(ref) {
          this.dayPickerContainer = ref;
        }

        return setDayPickerContainerRef;
      }()
    }, {
      key: "setContainerRef",
      value: function () {
        function setContainerRef(ref) {
          if (ref === this.container) return;
          this.removeEventListeners();
          this.container = ref;
          if (!ref) return;
          this.addEventListeners();
        }

        return setContainerRef;
      }()
    }, {
      key: "addEventListeners",
      value: function () {
        function addEventListeners() {
          // We manually set event because React has not implemented onFocusIn/onFocusOut.
          // Keep an eye on https://github.com/facebook/react/issues/6410 for updates
          // We use "blur w/ useCapture param" vs "onfocusout" for FF browser support
          this.removeFocusOutEventListener = (0, index_esm.addEventListener)(this.container, 'focusout', this.onFocusOut);
        }

        return addEventListeners;
      }()
    }, {
      key: "removeEventListeners",
      value: function () {
        function removeEventListeners() {
          if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
        }

        return removeEventListeners;
      }()
    }, {
      key: "disableScroll",
      value: function () {
        function disableScroll() {
          var _this$props3 = this.props,
              appendToBody = _this$props3.appendToBody,
              propDisableScroll = _this$props3.disableScroll,
              focused = _this$props3.focused;
          if (!appendToBody && !propDisableScroll) return;
          if (!focused) return; // Disable scroll for every ancestor of this <SingleDatePicker> up to the
          // document level. This ensures the input and the picker never move. Other
          // sibling elements or the picker itself can scroll.

          this.enableScroll = (0, _disableScroll2["default"])(this.container);
        }

        return disableScroll;
      }()
      /* istanbul ignore next */

    }, {
      key: "responsivizePickerPosition",
      value: function () {
        function responsivizePickerPosition() {
          // It's possible the portal props have been changed in response to window resizes
          // So let's ensure we reset this back to the base state each time
          this.setState({
            dayPickerContainerStyles: {}
          });
          var _this$props4 = this.props,
              openDirection = _this$props4.openDirection,
              anchorDirection = _this$props4.anchorDirection,
              horizontalMargin = _this$props4.horizontalMargin,
              withPortal = _this$props4.withPortal,
              withFullScreenPortal = _this$props4.withFullScreenPortal,
              appendToBody = _this$props4.appendToBody,
              focused = _this$props4.focused;
          var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

          if (!focused) {
            return;
          }

          var isAnchoredLeft = anchorDirection === constants$4.ANCHOR_LEFT;

          if (!withPortal && !withFullScreenPortal) {
            var containerRect = this.dayPickerContainer.getBoundingClientRect();
            var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
            var containerEdge = isAnchoredLeft ? containerRect[constants$4.ANCHOR_RIGHT] : containerRect[constants$4.ANCHOR_LEFT];
            this.setState({
              dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
            });
          }
        }

        return responsivizePickerPosition;
      }()
    }, {
      key: "showKeyboardShortcutsPanel",
      value: function () {
        function showKeyboardShortcutsPanel() {
          this.setState({
            isInputFocused: false,
            isDayPickerFocused: true,
            showKeyboardShortcuts: true
          });
        }

        return showKeyboardShortcutsPanel;
      }()
    }, {
      key: "maybeRenderDayPickerWithPortal",
      value: function () {
        function maybeRenderDayPickerWithPortal() {
          var _this$props5 = this.props,
              focused = _this$props5.focused,
              withPortal = _this$props5.withPortal,
              withFullScreenPortal = _this$props5.withFullScreenPortal,
              appendToBody = _this$props5.appendToBody;

          if (!focused) {
            return null;
          }

          if (withPortal || withFullScreenPortal || appendToBody) {
            return _react["default"].createElement(es.Portal, null, this.renderDayPicker());
          }

          return this.renderDayPicker();
        }

        return maybeRenderDayPickerWithPortal;
      }()
    }, {
      key: "renderDayPicker",
      value: function () {
        function renderDayPicker() {
          var _this$props6 = this.props,
              anchorDirection = _this$props6.anchorDirection,
              openDirection = _this$props6.openDirection,
              onDateChange = _this$props6.onDateChange,
              date = _this$props6.date,
              onFocusChange = _this$props6.onFocusChange,
              focused = _this$props6.focused,
              enableOutsideDays = _this$props6.enableOutsideDays,
              numberOfMonths = _this$props6.numberOfMonths,
              orientation = _this$props6.orientation,
              monthFormat = _this$props6.monthFormat,
              navPrev = _this$props6.navPrev,
              navNext = _this$props6.navNext,
              onPrevMonthClick = _this$props6.onPrevMonthClick,
              onNextMonthClick = _this$props6.onNextMonthClick,
              onClose = _this$props6.onClose,
              withPortal = _this$props6.withPortal,
              withFullScreenPortal = _this$props6.withFullScreenPortal,
              keepOpenOnDateSelect = _this$props6.keepOpenOnDateSelect,
              initialVisibleMonth = _this$props6.initialVisibleMonth,
              renderMonthText = _this$props6.renderMonthText,
              renderCalendarDay = _this$props6.renderCalendarDay,
              renderDayContents = _this$props6.renderDayContents,
              renderCalendarInfo = _this$props6.renderCalendarInfo,
              renderMonthElement = _this$props6.renderMonthElement,
              calendarInfoPosition = _this$props6.calendarInfoPosition,
              hideKeyboardShortcutsPanel = _this$props6.hideKeyboardShortcutsPanel,
              firstDayOfWeek = _this$props6.firstDayOfWeek,
              customCloseIcon = _this$props6.customCloseIcon,
              phrases = _this$props6.phrases,
              dayAriaLabelFormat = _this$props6.dayAriaLabelFormat,
              daySize = _this$props6.daySize,
              isRTL = _this$props6.isRTL,
              isOutsideRange = _this$props6.isOutsideRange,
              isDayBlocked = _this$props6.isDayBlocked,
              isDayHighlighted = _this$props6.isDayHighlighted,
              weekDayFormat = _this$props6.weekDayFormat,
              styles = _this$props6.styles,
              verticalHeight = _this$props6.verticalHeight,
              transitionDuration = _this$props6.transitionDuration,
              verticalSpacing = _this$props6.verticalSpacing,
              horizontalMonthPadding = _this$props6.horizontalMonthPadding,
              small = _this$props6.small,
              reactDates = _this$props6.theme.reactDates;
          var _this$state = this.state,
              dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
              isDayPickerFocused = _this$state.isDayPickerFocused,
              showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
          var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;

          var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], null);

          var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
          var withAnyPortal = withPortal || withFullScreenPortal;
          return _react["default"].createElement("div", _extends({
            // eslint-disable-line jsx-a11y/no-static-element-interactions
            ref: this.setDayPickerContainerRef
          }, (0, withStyles_1.css)(styles.SingleDatePicker_picker, anchorDirection === constants$4.ANCHOR_LEFT && styles.SingleDatePicker_picker__directionLeft, anchorDirection === constants$4.ANCHOR_RIGHT && styles.SingleDatePicker_picker__directionRight, openDirection === constants$4.OPEN_DOWN && styles.SingleDatePicker_picker__openDown, openDirection === constants$4.OPEN_UP && styles.SingleDatePicker_picker__openUp, !withAnyPortal && openDirection === constants$4.OPEN_DOWN && {
            top: inputHeight + verticalSpacing
          }, !withAnyPortal && openDirection === constants$4.OPEN_UP && {
            bottom: inputHeight + verticalSpacing
          }, orientation === constants$4.HORIZONTAL_ORIENTATION && styles.SingleDatePicker_picker__horizontal, orientation === constants$4.VERTICAL_ORIENTATION && styles.SingleDatePicker_picker__vertical, withAnyPortal && styles.SingleDatePicker_picker__portal, withFullScreenPortal && styles.SingleDatePicker_picker__fullScreenPortal, isRTL && styles.SingleDatePicker_picker__rtl, dayPickerContainerStyles), {
            onClick: onOutsideClick
          }), _react["default"].createElement(_DayPickerSingleDateController["default"], {
            date: date,
            onDateChange: onDateChange,
            onFocusChange: onFocusChange,
            orientation: orientation,
            enableOutsideDays: enableOutsideDays,
            numberOfMonths: numberOfMonths,
            monthFormat: monthFormat,
            withPortal: withAnyPortal,
            focused: focused,
            keepOpenOnDateSelect: keepOpenOnDateSelect,
            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
            initialVisibleMonth: initialVisibleMonth,
            navPrev: navPrev,
            navNext: navNext,
            onPrevMonthClick: onPrevMonthClick,
            onNextMonthClick: onNextMonthClick,
            onClose: onClose,
            renderMonthText: renderMonthText,
            renderCalendarDay: renderCalendarDay,
            renderDayContents: renderDayContents,
            renderCalendarInfo: renderCalendarInfo,
            renderMonthElement: renderMonthElement,
            calendarInfoPosition: calendarInfoPosition,
            isFocused: isDayPickerFocused,
            showKeyboardShortcuts: showKeyboardShortcuts,
            onBlur: this.onDayPickerBlur,
            phrases: phrases,
            dayAriaLabelFormat: dayAriaLabelFormat,
            daySize: daySize,
            isRTL: isRTL,
            isOutsideRange: isOutsideRange,
            isDayBlocked: isDayBlocked,
            isDayHighlighted: isDayHighlighted,
            firstDayOfWeek: firstDayOfWeek,
            weekDayFormat: weekDayFormat,
            verticalHeight: verticalHeight,
            transitionDuration: transitionDuration,
            horizontalMonthPadding: horizontalMonthPadding
          }), withFullScreenPortal && _react["default"].createElement("button", _extends({}, (0, withStyles_1.css)(styles.SingleDatePicker_closeButton), {
            "aria-label": phrases.closeDatePicker,
            type: "button",
            onClick: this.onOutsideClick
          }), _react["default"].createElement("div", (0, withStyles_1.css)(styles.SingleDatePicker_closeButton_svg), closeIcon)));
        }

        return renderDayPicker;
      }()
    }, {
      key: "render",
      value: function () {
        function render() {
          var _this$props7 = this.props,
              id = _this$props7.id,
              placeholder = _this$props7.placeholder,
              disabled = _this$props7.disabled,
              focused = _this$props7.focused,
              required = _this$props7.required,
              readOnly = _this$props7.readOnly,
              openDirection = _this$props7.openDirection,
              showClearDate = _this$props7.showClearDate,
              showDefaultInputIcon = _this$props7.showDefaultInputIcon,
              inputIconPosition = _this$props7.inputIconPosition,
              customCloseIcon = _this$props7.customCloseIcon,
              customInputIcon = _this$props7.customInputIcon,
              date = _this$props7.date,
              onDateChange = _this$props7.onDateChange,
              displayFormat = _this$props7.displayFormat,
              phrases = _this$props7.phrases,
              withPortal = _this$props7.withPortal,
              withFullScreenPortal = _this$props7.withFullScreenPortal,
              screenReaderInputMessage = _this$props7.screenReaderInputMessage,
              isRTL = _this$props7.isRTL,
              noBorder = _this$props7.noBorder,
              block = _this$props7.block,
              small = _this$props7.small,
              regular = _this$props7.regular,
              verticalSpacing = _this$props7.verticalSpacing,
              reopenPickerOnClearDate = _this$props7.reopenPickerOnClearDate,
              keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
              styles = _this$props7.styles,
              isOutsideRange = _this$props7.isOutsideRange;
          var isInputFocused = this.state.isInputFocused;
          var enableOutsideClick = !withPortal && !withFullScreenPortal;
          var hideFang = verticalSpacing < constants$4.FANG_HEIGHT_PX;

          var input = _react["default"].createElement(_SingleDatePickerInputController["default"], {
            id: id,
            placeholder: placeholder,
            focused: focused,
            isFocused: isInputFocused,
            disabled: disabled,
            required: required,
            readOnly: readOnly,
            openDirection: openDirection,
            showCaret: !withPortal && !withFullScreenPortal && !hideFang,
            showClearDate: showClearDate,
            showDefaultInputIcon: showDefaultInputIcon,
            inputIconPosition: inputIconPosition,
            isOutsideRange: isOutsideRange,
            customCloseIcon: customCloseIcon,
            customInputIcon: customInputIcon,
            date: date,
            onDateChange: onDateChange,
            displayFormat: displayFormat,
            onFocusChange: this.onInputFocus,
            onKeyDownArrowDown: this.onDayPickerFocus,
            onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
            screenReaderMessage: screenReaderInputMessage,
            phrases: phrases,
            isRTL: isRTL,
            noBorder: noBorder,
            block: block,
            small: small,
            regular: regular,
            verticalSpacing: verticalSpacing,
            reopenPickerOnClearDate: reopenPickerOnClearDate,
            keepOpenOnDateSelect: keepOpenOnDateSelect
          }, this.maybeRenderDayPickerWithPortal());

          return _react["default"].createElement("div", _extends({
            ref: this.setContainerRef
          }, (0, withStyles_1.css)(styles.SingleDatePicker, block && styles.SingleDatePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
            onOutsideClick: this.onOutsideClick
          }, input), enableOutsideClick || input);
        }

        return render;
      }()
    }]);

    return SingleDatePicker;
  }(_react["default"].PureComponent || _react["default"].Component);

  exports.PureSingleDatePicker = SingleDatePicker;
  SingleDatePicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
  SingleDatePicker.defaultProps = defaultProps;

  var _default = (0, withStyles_1.withStyles)(function (_ref3) {
    var _ref3$reactDates = _ref3.reactDates,
        color = _ref3$reactDates.color,
        zIndex = _ref3$reactDates.zIndex;
    return {
      SingleDatePicker: {
        position: 'relative',
        display: 'inline-block'
      },
      SingleDatePicker__block: {
        display: 'block'
      },
      SingleDatePicker_picker: {
        zIndex: zIndex + 1,
        backgroundColor: color.background,
        position: 'absolute'
      },
      SingleDatePicker_picker__rtl: {
        direction: (0, _noflip["default"])('rtl')
      },
      SingleDatePicker_picker__directionLeft: {
        left: (0, _noflip["default"])(0)
      },
      SingleDatePicker_picker__directionRight: {
        right: (0, _noflip["default"])(0)
      },
      SingleDatePicker_picker__portal: {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        position: 'fixed',
        top: 0,
        left: (0, _noflip["default"])(0),
        height: '100%',
        width: '100%'
      },
      SingleDatePicker_picker__fullScreenPortal: {
        backgroundColor: color.background
      },
      SingleDatePicker_closeButton: {
        background: 'none',
        border: 0,
        color: 'inherit',
        font: 'inherit',
        lineHeight: 'normal',
        overflow: 'visible',
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        right: (0, _noflip["default"])(0),
        padding: 15,
        zIndex: zIndex + 2,
        ':hover': {
          color: "darken(".concat(color.core.grayLighter, ", 10%)"),
          textDecoration: 'none'
        },
        ':focus': {
          color: "darken(".concat(color.core.grayLighter, ", 10%)"),
          textDecoration: 'none'
        }
      },
      SingleDatePicker_closeButton_svg: {
        height: 15,
        width: 15,
        fill: color.core.grayLighter
      }
    };
  }, {
    pureComponent: typeof _react["default"].PureComponent !== 'undefined'
  })(SingleDatePicker);

  exports["default"] = _default;
});
unwrapExports(SingleDatePicker_1);
var SingleDatePicker_2 = SingleDatePicker_1.PureSingleDatePicker;
var isInclusivelyBeforeDay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = isInclusivelyBeforeDay;

  var _moment = _interopRequireDefault(moment);

  var _isAfterDay = _interopRequireDefault(isAfterDay_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function isInclusivelyBeforeDay(a, b) {
    if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
    return !(0, _isAfterDay["default"])(a, b);
  }
});
unwrapExports(isInclusivelyBeforeDay_1);
var lib$4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "CalendarDay", {
    enumerable: true,
    get: function () {
      function get() {
        return _CalendarDay["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "CalendarMonth", {
    enumerable: true,
    get: function () {
      function get() {
        return _CalendarMonth["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "CalendarMonthGrid", {
    enumerable: true,
    get: function () {
      function get() {
        return _CalendarMonthGrid["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "DateRangePicker", {
    enumerable: true,
    get: function () {
      function get() {
        return _DateRangePicker["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "DateRangePickerInput", {
    enumerable: true,
    get: function () {
      function get() {
        return _DateRangePickerInput["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "DateRangePickerInputController", {
    enumerable: true,
    get: function () {
      function get() {
        return _DateRangePickerInputController["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "DateRangePickerShape", {
    enumerable: true,
    get: function () {
      function get() {
        return _DateRangePickerShape["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "DayPicker", {
    enumerable: true,
    get: function () {
      function get() {
        return _DayPicker["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "DayPickerRangeController", {
    enumerable: true,
    get: function () {
      function get() {
        return _DayPickerRangeController["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "DayPickerSingleDateController", {
    enumerable: true,
    get: function () {
      function get() {
        return _DayPickerSingleDateController["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "SingleDatePicker", {
    enumerable: true,
    get: function () {
      function get() {
        return _SingleDatePicker["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "SingleDatePickerInput", {
    enumerable: true,
    get: function () {
      function get() {
        return _SingleDatePickerInput["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "SingleDatePickerShape", {
    enumerable: true,
    get: function () {
      function get() {
        return _SingleDatePickerShape["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "isInclusivelyAfterDay", {
    enumerable: true,
    get: function () {
      function get() {
        return _isInclusivelyAfterDay["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "isInclusivelyBeforeDay", {
    enumerable: true,
    get: function () {
      function get() {
        return _isInclusivelyBeforeDay["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "isNextDay", {
    enumerable: true,
    get: function () {
      function get() {
        return _isNextDay["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "isSameDay", {
    enumerable: true,
    get: function () {
      function get() {
        return _isSameDay["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "toISODateString", {
    enumerable: true,
    get: function () {
      function get() {
        return _toISODateString["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "toLocalizedDateString", {
    enumerable: true,
    get: function () {
      function get() {
        return _toLocalizedDateString["default"];
      }

      return get;
    }()
  });
  Object.defineProperty(exports, "toMomentObject", {
    enumerable: true,
    get: function () {
      function get() {
        return _toMomentObject["default"];
      }

      return get;
    }()
  });

  var _CalendarDay = _interopRequireDefault(CalendarDay_1);

  var _CalendarMonth = _interopRequireDefault(CalendarMonth_1);

  var _CalendarMonthGrid = _interopRequireDefault(CalendarMonthGrid_1);

  var _DateRangePicker = _interopRequireDefault(DateRangePicker_1);

  var _DateRangePickerInput = _interopRequireDefault(DateRangePickerInput_1);

  var _DateRangePickerInputController = _interopRequireDefault(DateRangePickerInputController_1);

  var _DateRangePickerShape = _interopRequireDefault(DateRangePickerShape);

  var _DayPicker = _interopRequireDefault(DayPicker_1);

  var _DayPickerRangeController = _interopRequireDefault(DayPickerRangeController_1);

  var _DayPickerSingleDateController = _interopRequireDefault(DayPickerSingleDateController_1);

  var _SingleDatePicker = _interopRequireDefault(SingleDatePicker_1);

  var _SingleDatePickerInput = _interopRequireDefault(SingleDatePickerInput_1);

  var _SingleDatePickerShape = _interopRequireDefault(SingleDatePickerShape);

  var _isInclusivelyAfterDay = _interopRequireDefault(isInclusivelyAfterDay_1);

  var _isInclusivelyBeforeDay = _interopRequireDefault(isInclusivelyBeforeDay_1);

  var _isNextDay = _interopRequireDefault(isNextDay_1);

  var _isSameDay = _interopRequireDefault(isSameDay_1);

  var _toISODateString = _interopRequireDefault(toISODateString_1);

  var _toLocalizedDateString = _interopRequireDefault(toLocalizedDateString_1);

  var _toMomentObject = _interopRequireDefault(toMomentObject_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
});
unwrapExports(lib$4); // eslint-disable-next-line import/no-unresolved

var reactDates = lib$4;
var reactDates_1 = reactDates.DateRangePicker;
var reactDates_2 = reactDates.isInclusivelyBeforeDay;
var css$B = ".CalendarDay__selected_span {\n  background: var(--calendar-main-color);\n  color: var(--calendar-day-color);\n  border: 1px solid;\n  border-color: var(--calendar-day-border-color);\n}\n.CalendarDay__default:hover {\n  color: var(--calendar-main-color);\n}\n.CalendarDay__selected_span:active,\n.CalendarDay__selected_span:hover {\n  background: var(--calendar-day-active-hover-background-color);\n  border-color: var(--calendar-day-border-color);\n  color: var(--calendar-day-color);\n}\n.CalendarDay__selected {\n  background: var(--calendar-main-color);\n  color: var(--calendar-day-color);\n  border-color: var(--calendar-day-border-color);\n}\n.CalendarDay__selected:hover {\n  background: var(--calendar-main-color);\n  color: var(--calendar-day-color);\n  border-color: var(--calendar-day-border-color);\n}\n.CalendarDay__hovered_span:hover,\n.CalendarDay__hovered_span {\n  background: var(--calendar-main-color);\n  color: var(--calendar-day-color);\n  border-color: var(--calendar-day-color);\n}\n.DateInput {\n  width: 97px;\n}\n.DateInput_input {\n  background-color: var(--input-background-color);\n  border-color: var(--input-background-color);\n  color: var(--input-placeholder-color);\n  height: 38px;\n  font-size: 10pt;\n}\n.DateRangePickerInput {\n  background-color: var(--input-background-color);\n  border-color: var(--input-background-color);\n  color: var(--input-placeholder-color);\n  height: 40px;\n}\n.PresetDateRangePicker_panel: {\n  padding: 0 22px 11px 22px;\n}\n.PresetDateRangePicker_button {\n  position: relative;\n  height: 100%;\n  textAlign: center;\n  background: none;\n  border: 2px solid var(--calendar-main-color);\n  color: var(--calendar-main-color);\n  padding: 4px 12px;\n  marginRight: 8;\n  font: inherit;\n  fontWeight: 700;\n  lineHeight: normal;\n  overflow: visible;\n  boxSizing: border-box;\n  cursor: pointer;\n}\n.PresetDateRangePicker_button :active: {\n  outline: 0;\n}\n.PresetDateRangePicker_button__selected: {\n  color: var(--calendar-day-color);\n  background: var(--calendar-main-color);\n}\n";
styleInject(css$B);

var CustomDateRangePicker =
/*#__PURE__*/
function (_React$Component) {
  inherits(CustomDateRangePicker, _React$Component);

  function CustomDateRangePicker(props) {
    var _this;

    classCallCheck(this, CustomDateRangePicker);
    _this = possibleConstructorReturn(this, getPrototypeOf(CustomDateRangePicker).call(this, props));
    _this.state = {
      startDate: _this.props.startDate,
      endDate: _this.props.endDate
    };
    _this.renderDatePresets = _this.renderDatePresets.bind(assertThisInitialized(_this));
    _this.onDatesChange = _this.onDatesChange.bind(assertThisInitialized(_this));
    return _this;
  }

  createClass(CustomDateRangePicker, [{
    key: "onDatesChange",
    value: function onDatesChange(_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate,
          preset = _ref.preset;
      this.setState({
        startDate: startDate,
        endDate: endDate
      });

      if (this.props.onDatesChange) {
        this.props.onDatesChange({
          startDate: startDate,
          endDate: endDate,
          preset: preset
        });
      }
    }
  }, {
    key: "renderDatePresets",
    value: function renderDatePresets() {
      var _this2 = this;

      var presets = this.props.presets;
      var _this$state = this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      return React__default.createElement("div", {
        className: "PresetDateRangePicker_panel"
      }, presets.map(function (_ref2) {
        var text = _ref2.text,
            start = _ref2.start,
            end = _ref2.end;
        var isSelected = startDate === start && endDate === end;
        return React__default.createElement("button", {
          key: text,
          type: "button",
          className: "PresetDateRangePicker_button ".concat(isSelected ? 'PresetDateRangePicker_button__selected' : ''),
          onClick: function onClick() {
            return _this2.onDatesChange({
              startDate: start,
              endDate: end,
              preset: true
            });
          }
        }, text);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          autoFocusEndDate = _this$props.autoFocusEndDate,
          initialStartDate = _this$props.initialStartDate,
          initialEndDate = _this$props.initialEndDate,
          stateDateWrapper = _this$props.stateDateWrapper,
          onDatesChange = _this$props.onDatesChange,
          startDate = _this$props.startDate,
          endDate = _this$props.endDate,
          presets = _this$props.presets,
          dateRangePickerProps = objectWithoutProperties$1(_this$props, ["autoFocus", "autoFocusEndDate", "initialStartDate", "initialEndDate", "stateDateWrapper", "onDatesChange", "startDate", "endDate", "presets"]);
      return React__default.createElement("div", null, React__default.createElement(reactDates_1, _extends_1({}, dateRangePickerProps, {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        renderCalendarInfo: this.renderDatePresets,
        onDatesChange: this.onDatesChange
      })));
    }
  }]);
  return CustomDateRangePicker;
}(React__default.Component);

defineProperty(CustomDateRangePicker, "propTypes", {
  presets: propTypes.arrayOf(propTypes.shape({
    text: propTypes.string,
    start: propTypes.required,
    end: propTypes.required
  }))
});
var css$C = ".pagination-area {\n  color: var(--text-secondary-color);\n  font-size: 13px;\n  font-weight: normal !important;\n}\n.pagination-area label {\n  font-weight: normal;\n}\n.pagination-area select {\n  margin: 5px;\n  background-color: var(--primary-background-color);\n  color: #fff;\n}\n.row {\n  display: -webkit-box;\n  display: flex;\n}\n.row .rows-dropdown {\n  width: 25%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.row .pagination-buttons {\n  width: 75%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.row .form-group {\n  margin-bottom: 15px;\n}\n.rows-per-page label.wrapperLabel {\n  display: inline-table !important;\n  margin: 0 4px;\n}\n.rows-per-page label.wrapperLabel select {\n  margin: 0px 4px 0px 4px;\n  width: 42px;\n}\n.page-buttons {\n  margin: 0;\n  text-align: right;\n  font-weight: normal;\n}\n.page-buttons ul.pagination-control {\n  margin: 0;\n}\n.page-buttons ul.pagination-control li {\n  display: table-cell;\n  padding: 5px 2px;\n}\n.page-buttons ul.pagination-control li button {\n  padding: 4px 8px;\n  background-color: var(--primary-background-color);\n  border-color: var(--ui-gray);\n  color: var(--ui-gray-darkest);\n  color: #fff;\n  text-decoration: none;\n}\n.page-buttons ul.pagination-control li button:hover:enabled {\n  color: var(--active-color);\n}\n.page-buttons ul.pagination-control li .active button {\n  background-color: var(--ui-gray);\n  border-color: #ddd;\n  color: #fff;\n}\n";
styleInject(css$C);

var PaginationArea =
/*#__PURE__*/
function (_PureComponent) {
  inherits(PaginationArea, _PureComponent);

  function PaginationArea() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, PaginationArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(PaginationArea)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "nextPage", function () {
      _this.props.nextPageFunc(_this.props.currentPage);
    });
    defineProperty(assertThisInitialized(_this), "prevPage", function () {
      _this.props.prevPageFunc(_this.props.currentPage);
    });
    defineProperty(assertThisInitialized(_this), "onRowsPerPageChange", function (event) {
      _this.props.onRowsPerPageChange(parseInt(event.target.value));
    });
    return _this;
  }

  createClass(PaginationArea, [{
    key: "renderPaginationButtons",
    value: function renderPaginationButtons() {
      return React__default.createElement("div", {
        className: "col-xs-8 col-sm-9 col-md-9"
      }, React__default.createElement("div", {
        className: "form-inline form-group page-buttons noselect"
      }, React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: "pagination-control no-margins"
      }, React__default.createElement("li", {
        className: "page-item prev"
      }, React__default.createElement("button", {
        onClick: this.prevPage,
        disabled: this.props.currentPage === 0,
        className: "btn page-link"
      }, this.props.t('Previous'))), React__default.createElement("li", {
        className: "page-item next"
      }, React__default.createElement("button", {
        onClick: this.nextPage,
        disabled: this.props.recordCount === 0 || this.props.rowsPerPage > this.props.recordCount,
        className: "btn page-link"
      }, this.props.t('Next')))))));
    }
  }, {
    key: "renderRowsPerPageDropdown",
    value: function renderRowsPerPageDropdown() {
      return React__default.createElement("div", {
        className: "form-inline form-group rows-per-page"
      }, React__default.createElement("span", null, this.props.t('Show')), React__default.createElement("select", {
        onChange: this.onRowsPerPageChange,
        defaultValue: this.props.rowsPerPage
      }, this.props.pageOptions.map(function (pageNumber) {
        return React__default.createElement("option", {
          key: pageNumber,
          value: pageNumber
        }, pageNumber);
      })), React__default.createElement("span", null, this.props.t('RowsPerPage')));
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        name: "paginationArea"
      }, React__default.createElement("div", {
        className: "pagination-area"
      }, React__default.createElement("div", {
        className: "row"
      }, React__default.createElement("div", {
        className: "rows-dropdown"
      }, this.renderRowsPerPageDropdown()), React__default.createElement("div", {
        className: "pagination-buttons"
      }, React__default.createElement("div", {
        className: "form-inline form-group page-number pull-right"
      }, this.renderPaginationButtons())))));
    }
  }]);
  return PaginationArea;
}(PureComponent);

defineProperty(PaginationArea, "defaultProps", {
  pageOptions: [5, 10, 25, 50, 100],
  rowsPerPage: 25,
  currentPage: 0
});
defineProperty(PaginationArea, "propTypes", {
  pageOptions: propTypes.array.isRequired,
  rowsPerPage: propTypes.number.isRequired,
  currentPage: propTypes.number.isRequired,
  nextPageFunc: propTypes.func,
  prevPageFunc: propTypes.func,
  onRowsPerPageChange: propTypes.func,
  recordCount: propTypes.number.isRequired
});
var connectedComponent$5 = withTranslation$1('Common')(PaginationArea);

function StudyListLoadingText() {
  return React__default.createElement("div", {
    className: "loading-text"
  }, "Loading... ", React__default.createElement(Icon, {
    name: "circle-notch",
    animation: "pulse"
  }));
}

var css$D = ".studyListToolbar .addNewStudy {\n  margin: 0 10px;\n  color: var(--text-secondary-color);\n}\n.studyListToolbar .addNewStudy label {\n  font-weight: 400;\n  cursor: pointer;\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n}\n.studyListToolbar .addNewStudy input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n.studyListToolbar .addNewStudy:hover {\n  color: var(--hover-color);\n}\n.studyListToolbar .addNewStudy:active {\n  color: var(--active-color);\n}\n";
styleInject(css$D);

var StudylistToolbar =
/*#__PURE__*/
function (_PureComponent) {
  inherits(StudylistToolbar, _PureComponent);

  function StudylistToolbar() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, StudylistToolbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(StudylistToolbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "onImport", function (event) {
      if (_this.props.onImport) {
        _this.props.onImport(event);
      }
    });
    return _this;
  }

  createClass(StudylistToolbar, [{
    key: "getImportTool",
    value: function getImportTool() {
      if (this.props.onImport) {
        return React__default.createElement("div", {
          className: "addNewStudy btn-file"
        }, React__default.createElement("label", {
          htmlFor: "btnImport",
          style: {
            width: '18px'
          },
          onClick: this.onImport
        }, React__default.createElement(Icon, {
          name: "plus"
        })));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "studylistToolbar"
      }, this.getImportTool());
    }
  }]);
  return StudylistToolbar;
}(PureComponent);

defineProperty(StudylistToolbar, "propTypes", {
  onImport: propTypes.func
});
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */

var FUNC_ERROR_TEXT$2 = 'Expected a function';
/** Used as references for various `Number` constants. */

var NAN$1 = 0 / 0;
/** `Object#toString` result references. */

var symbolTag$1 = '[object Symbol]';
/** Used to match leading and trailing whitespace. */

var reTrim$1 = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary$1 = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal$1 = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt$1 = parseInt;
/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$3 = freeGlobal$1 || freeSelf$1 || Function('return this')();
/** Used for built-in method references. */

var objectProto$2 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$1 = objectProto$2.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now$1 = function now$1() {
  return root$3.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */


function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }

  wait = toNumber$1(wait) || 0;

  if (isObject$2(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now$1();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike$2(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol$3(value) {
  return typeof value == 'symbol' || isObjectLike$2(value) && objectToString$1.call(value) == symbolTag$1;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */


function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol$3(value)) {
    return NAN$1;
  }

  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}

var lodash_debounce = debounce$1;
var today = moment();
var lastWeek = moment().subtract(7, 'day');
var lastMonth = moment().subtract(1, 'month');

var StudyList =
/*#__PURE__*/
function (_Component) {
  inherits(StudyList, _Component);

  function StudyList(props) {
    var _this;

    classCallCheck(this, StudyList);
    _this = possibleConstructorReturn(this, getPrototypeOf(StudyList).call(this, props));
    var sortData = {
      field: undefined,
      order: undefined
    }; // init from props

    if (props.defaultSort) {
      sortData.field = props.defaultSort.field; // todo: -1, 0, 1?

      sortData.order = props.defaultSort.order; // asc, desc
    }

    _this.defaultStartDate = moment().subtract(_this.props.studyListDateFilterNumDays, 'days');
    _this.defaultEndDate = moment();
    _this.state = {
      loading: false,
      error: false,
      searchData: {
        sortData: sortData,
        currentPage: _this.props.currentPage,
        rowsPerPage: _this.props.rowsPerPage,
        studyDateFrom: _this.defaultStartDate,
        studyDateTo: _this.defaultEndDate
      },
      highlightedItem: ''
    };
    _this.getChangeHandler = _this.getChangeHandler.bind(assertThisInitialized(_this));
    _this.getBlurHandler = _this.getBlurHandler.bind(assertThisInitialized(_this));
    _this.onInputKeydown = _this.onInputKeydown.bind(assertThisInitialized(_this));
    _this.nextPage = _this.nextPage.bind(assertThisInitialized(_this));
    _this.prevPage = _this.prevPage.bind(assertThisInitialized(_this));
    _this.onRowsPerPageChange = _this.onRowsPerPageChange.bind(assertThisInitialized(_this));
    _this.delayedSearch = lodash_debounce(_this.search, 250);
    return _this;
  }

  createClass(StudyList, [{
    key: "getChangeHandler",
    value: function getChangeHandler(key) {
      var _this2 = this;

      return function (event) {
        _this2.delayedSearch.cancel();

        _this2.setSearchData(key, event.target.value, _this2.delayedSearch);
      };
    }
  }, {
    key: "getBlurHandler",
    value: function getBlurHandler(key) {
      var _this3 = this;

      return function (event) {
        _this3.delayedSearch.cancel();

        _this3.setSearchData(key, event.target.value, _this3.search);
      };
    }
  }, {
    key: "setSearchData",
    value: function setSearchData(key, value, callback) {
      var searchData = this.state.searchData;
      searchData[key] = value;
      this.setState({
        searchData: searchData
      }, callback);
    }
  }, {
    key: "setSearchDataBatch",
    value: function setSearchDataBatch(keyValues, callback) {
      var searchData = this.state.searchData;
      Object.keys(keyValues).forEach(function (key) {
        searchData[key] = keyValues[key];
      });
      this.setState({
        searchData: searchData
      }, callback);
    }
  }, {
    key: "onInputKeydown",
    value: function () {
      var _onInputKeydown = asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee(event) {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (event.key === 'Enter') {
                  event.preventDefault();
                  event.stopPropagation();
                  this.delayedSearch.cancel(); // reset the page because user is doing a new search

                  this.setSearchData('currentPage', 0, this.search);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onInputKeydown(_x) {
        return _onInputKeydown.apply(this, arguments);
      }

      return onInputKeydown;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.setState({
                  loading: true,
                  error: false
                });
                _context2.next = 4;
                return this.props.onSearch(this.state.searchData);

              case 4:
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                this.setState({
                  error: true
                });
                throw new Error(_context2.t0);

              case 10:
                _context2.prev = 10;
                this.setState({
                  loading: false
                });
                return _context2.finish(10);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6, 10, 13]]);
      }));

      function search() {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "renderNoMachingResults",
    value: function renderNoMachingResults() {
      if (!this.props.studies.length && !this.state.error) {
        return React__default.createElement("div", {
          className: "notFound"
        }, "No matching results");
      }
    }
  }, {
    key: "renderHasError",
    value: function renderHasError() {
      if (this.state.error) {
        return React__default.createElement("div", {
          className: "notFound"
        }, "There was an error fetching studies");
      }
    }
  }, {
    key: "renderIsLoading",
    value: function renderIsLoading() {
      if (this.state.loading) {
        return React__default.createElement("div", {
          className: "loading"
        }, React__default.createElement(StudyListLoadingText, null));
      }
    }
  }, {
    key: "nextPage",
    value: function nextPage(currentPage) {
      currentPage = currentPage + 1;
      this.delayedSearch.cancel();
      this.setSearchData('currentPage', currentPage, this.search);
    }
  }, {
    key: "prevPage",
    value: function prevPage(currentPage) {
      currentPage = currentPage - 1;
      this.delayedSearch.cancel();
      this.setSearchData('currentPage', currentPage, this.search);
    }
  }, {
    key: "onRowsPerPageChange",
    value: function onRowsPerPageChange(rowsPerPage) {
      this.delayedSearch.cancel();
      this.setSearchDataBatch({
        rowsPerPage: rowsPerPage,
        currentPage: 0
      }, this.search);
    }
  }, {
    key: "onSortClick",
    value: function onSortClick(field) {
      var _this4 = this;

      return function () {
        var order;
        var sort = _this4.state.searchData.sortData;
        var isSortedField = sort.field === field;

        if (isSortedField) {
          if (sort.order === 'asc') {
            order = 'desc';
          } else {
            order = undefined;
            field = undefined;
          }
        } else {
          order = 'asc';
        }

        _this4.delayedSearch.cancel();

        _this4.setSearchData('sortData', {
          field: field,
          order: order
        }, _this4.search);
      };
    }
  }, {
    key: "onHighlightItem",
    value: function onHighlightItem(studyItemUid) {
      this.setState({
        highlightedItem: studyItemUid
      });
    }
  }, {
    key: "renderTableRow",
    value: function renderTableRow(study) {
      var _this5 = this;

      return React__default.createElement("tr", {
        key: study.studyInstanceUid,
        className: this.state.highlightedItem === study.studyInstanceUid ? 'studylistStudy noselect active' : 'studylistStudy noselect',
        onMouseDown: function onMouseDown(event) {
          // middle/wheel click
          if (event.button === 1) {
            _this5.props.onSelectItem(study.studyInstanceUid);
          }
        },
        onClick: function onClick() {
          _this5.onHighlightItem(study.studyInstanceUid);

          _this5.props.onSelectItem(study.studyInstanceUid);
        }
      }, React__default.createElement("td", {
        className: study.patientName ? 'patientName' : 'emptyCell'
      }, study.patientName || "(".concat(this.props.t('Empty'), ")")), React__default.createElement("td", {
        className: "patientId"
      }, study.patientId), React__default.createElement("td", {
        className: "accessionNumber"
      }, study.accessionNumber), React__default.createElement("td", {
        className: "studyDate"
      }, study.studyDate), React__default.createElement("td", {
        className: "modalities"
      }, study.modalities), React__default.createElement("td", {
        className: "studyDescription"
      }, study.studyDescription));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var tableMeta = {
        patientName: {
          displayText: this.props.t('PatientName'),
          sort: 0
        },
        patientId: {
          displayText: this.props.t('MRN'),
          sort: 0
        },
        accessionNumber: {
          displayText: this.props.t('AccessionNumber'),
          sort: 0
        },
        studyDate: {
          displayText: this.props.t('StudyDate'),
          inputType: 'date-range',
          sort: 0
        },
        modalities: {
          displayText: this.props.t('Modality'),
          sort: 0
        },
        studyDescription: {
          displayText: this.props.t('StudyDescription'),
          sort: 0
        }
      }; // Apply sort

      var sortedFieldName = this.state.searchData.sortData.field;
      var sortedField = tableMeta[sortedFieldName];

      if (sortedField) {
        var sortOrder = this.state.searchData.sortData.order;
        sortedField.sort = sortOrder === 'asc' ? 1 : 2;
      } // Sort Icons


      var sortIcons = ['sort', 'sort-up', 'sort-down'];
      return React__default.createElement("div", {
        className: "StudyList"
      }, React__default.createElement("div", {
        className: "studyListToolbar clearfix"
      }, React__default.createElement("div", {
        className: "header pull-left"
      }, this.props.t('StudyList')), React__default.createElement("div", {
        className: "studyCount pull-right"
      }, this.props.studies.length), React__default.createElement("div", {
        className: "pull-right"
      }, this.props.studyListFunctionsEnabled ? React__default.createElement(StudylistToolbar, {
        onImport: this.props.onImport
      }) : null), this.props.children), React__default.createElement("div", {
        className: "theadBackground"
      }), React__default.createElement("div", {
        id: "studyListContainer"
      }, React__default.createElement("table", {
        id: "tblStudyList",
        className: "studylistResult table noselect"
      }, React__default.createElement("thead", null, React__default.createElement("tr", null, Object.keys(tableMeta).map(function (fieldName, i) {
        var field = tableMeta[fieldName];
        return React__default.createElement(React__default.Fragment, {
          key: i
        }, React__default.createElement("th", {
          className: fieldName
        }, React__default.createElement("div", {
          id: "_".concat(fieldName),
          className: "display-text",
          onClick: _this6.onSortClick(fieldName)
        }, React__default.createElement("span", null, field.displayText), React__default.createElement(Icon, {
          name: sortIcons[field.sort],
          style: {
            fontSize: '12px'
          }
        })), !field.inputType && React__default.createElement("input", {
          type: "text",
          className: "form-control studylist-search",
          id: fieldName,
          value: _this6.state[fieldName],
          onKeyDown: _this6.onInputKeydown,
          onChange: _this6.getChangeHandler(fieldName),
          onBlur: _this6.getBlurHandler(fieldName)
        }), field.inputType === 'date-range' && React__default.createElement("div", {
          style: {
            display: 'block'
          }
        }, React__default.createElement(CustomDateRangePicker, {
          presets: StudyList.studyDatePresets,
          showClearDates: true,
          startDateId: "studyListStartDate",
          endDateId: "studyListEndDate",
          startDate: _this6.defaultStartDate,
          endDate: _this6.defaultEndDate,
          hideKeyboardShortcutsPanel: true,
          anchorDirection: "left",
          isOutsideRange: function isOutsideRange(day) {
            return !reactDates_2(day, moment());
          },
          onDatesChange: function onDatesChange(_ref) {
            var startDate = _ref.startDate,
                endDate = _ref.endDate,
                _ref$preset = _ref.preset,
                preset = _ref$preset === void 0 ? false : _ref$preset;

            if (startDate && endDate && (_this6.state.focusedInput === 'endDate' || preset)) {
              _this6.setSearchDataBatch({
                studyDateFrom: startDate.toDate(),
                studyDateTo: endDate.toDate()
              }, _this6.search);

              _this6.setState({
                focusedInput: false
              });
            } else if (!startDate && !endDate) {
              _this6.setSearchDataBatch({
                studyDateFrom: null,
                studyDateTo: null
              }, _this6.search);
            }
          },
          focusedInput: _this6.state.focusedInput,
          onFocusChange: function onFocusChange(focusedInput) {
            _this6.setState({
              focusedInput: focusedInput
            });
          }
        }))));
      }))), React__default.createElement("tbody", {
        id: "studyListData"
      }, this.props.studies.map(function (study) {
        return _this6.renderTableRow(study);
      }))), this.renderIsLoading(), this.renderHasError(), this.renderNoMachingResults(), React__default.createElement(connectedComponent$5, {
        pageOptions: this.props.pageOptions,
        currentPage: this.state.searchData.currentPage,
        nextPageFunc: this.nextPage,
        prevPageFunc: this.prevPage,
        onRowsPerPageChange: this.onRowsPerPageChange,
        rowsPerPage: this.state.searchData.rowsPerPage,
        recordCount: this.props.studies.length
      })));
    }
  }]);
  return StudyList;
}(Component);

defineProperty(StudyList, "propTypes", {
  studies: propTypes.array.isRequired,
  onSelectItem: propTypes.func.isRequired,
  onSearch: propTypes.func.isRequired,
  currentPage: propTypes.number,
  rowsPerPage: propTypes.number,
  studyListDateFilterNumDays: propTypes.number,
  studyListFunctionsEnabled: propTypes.bool,
  defaultSort: propTypes.shape({
    field: propTypes.string.isRequired,
    order: propTypes.oneOf(['desc', 'asc']).isRequired
  }),
  onImport: propTypes.func,
  pageOptions: propTypes.array
});
defineProperty(StudyList, "defaultProps", {
  currentPage: 0,
  rowsPerPage: 25,
  studyListDateFilterNumDays: 7
});
defineProperty(StudyList, "studyDatePresets", [{
  text: 'Today',
  start: today,
  end: today
}, {
  text: 'Last 7 days',
  start: lastWeek,
  end: today
}, {
  text: 'Last 30 days',
  start: lastMonth,
  end: today
}]);
var connectedComponent$6 = withTranslation$1('StudyList')(StudyList);
var css$E = ".ToolbarSection {\n  float: left;\n  background-color: var(--primary-background-color);\n  border-radius: 8px;\n}\n";
styleInject(css$E);
var css$F = ".toolbarOverlay {\n  border: 2px solid var(--ui-border-color-dark);\n  padding: 5px;\n}\n.tooltip-toolbar-overlay {\n  margin-top: 40px;\n  background-color: var(--primary-background-color);\n  border: 1px solid var(--default-color);\n  border-radius: 8px;\n}\n.tooltip-toolbar-overlay .tooltip-arrow {\n  display: none;\n}\n.tooltip-toolbar-overlay .tooltip-inner {\n  max-width: unset;\n  background: none;\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-break: auto;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  font-size: 12px;\n  opacity: 0;\n}\n.tooltip.in {\n  opacity: 0.9;\n}\n.tooltip.top {\n  margin-top: -3px;\n  padding: 5px 0;\n}\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.right {\n  margin-left: 3px;\n  padding: 0 5px;\n}\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.tooltip.bottom {\n  margin-top: 3px;\n  padding: 5px 0;\n}\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.left {\n  margin-left: -3px;\n  padding: 0 5px;\n}\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000;\n}\n.tooltip.top-left .tooltip-arrow {\n  bottom: 0;\n  right: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-right .tooltip-arrow {\n  bottom: 0;\n  left: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.bottom-left .tooltip-arrow {\n  top: 0;\n  right: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-right .tooltip-arrow {\n  top: 0;\n  left: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.in {\n  opacity: 1;\n}\n";
styleInject(css$F);

var ExpandableToolMenu =
/*#__PURE__*/
function (_React$Component) {
  inherits(ExpandableToolMenu, _React$Component);

  function ExpandableToolMenu(props) {
    var _this;

    classCallCheck(this, ExpandableToolMenu);
    _this = possibleConstructorReturn(this, getPrototypeOf(ExpandableToolMenu).call(this, props));
    defineProperty(assertThisInitialized(_this), "toolbarMenuOverlay", function () {
      return React__default.createElement(Tooltip, {
        placement: "bottom",
        className: "tooltip-toolbar-overlay",
        id: "".concat(Math.random(), "_tooltip-toolbar-overlay}")
      }, _this.getButtons());
    });
    defineProperty(assertThisInitialized(_this), "getButtons", function () {
      return _this.props.buttons.map(function (button, index) {
        return React__default.createElement(ToolbarButton$1, _extends_1({
          key: index
        }, button, {
          isActive: button.id === _this.props.activeCommand
        }));
      });
    });
    defineProperty(assertThisInitialized(_this), "isActive", function () {
      var isActive = false;

      if (_this.props.activeCommand) {
        _this.props.buttons.forEach(function (button) {
          if (_this.props.activeCommand === button.id) {
            isActive = true;
          }
        });
      }

      return isActive;
    });
    defineProperty(assertThisInitialized(_this), "activeIcon", function () {
      var _this$props = _this.props,
          activeCommand = _this$props.activeCommand,
          buttons = _this$props.buttons,
          icon = _this$props.icon;

      if (activeCommand) {
        return (buttons.find(function (btn) {
          return activeCommand === btn.id;
        }) || {}).icon || icon;
      }

      return icon;
    });
    defineProperty(assertThisInitialized(_this), "onExpandableToolClick", function () {
      if (_this.props.onGroupMenuClick) {
        _this.props.onGroupMenuClick();
      }

      _this.props.overlayExpand(!_this.state.isExpanded, _this.props.label);

      _this.setState({
        isExpanded: !_this.state.isExpanded
      });
    });
    defineProperty(assertThisInitialized(_this), "onOverlayHide", function () {
      _this.setState({
        isExpanded: false
      });
    });
    _this.state = {
      isExpanded: false
    };
    return _this;
  }

  createClass(ExpandableToolMenu, [{
    key: "render",
    value: function render() {
      return React__default.createElement(OverlayTrigger, {
        key: "menu-button",
        trigger: "click",
        placement: "bottom",
        rootClose: true,
        handleHide: this.onOverlayHide,
        onClick: this.onExpandableToolClick,
        overlay: this.toolbarMenuOverlay()
      }, React__default.createElement(ToolbarButton$1, {
        key: "menu-button",
        type: "tool",
        label: this.props.label,
        icon: this.activeIcon(),
        className: 'toolbar-button expandableToolMenu',
        isActive: this.isActive(),
        isExpandable: true,
        isExpanded: this.state.isExpanded
      }));
    }
  }]);
  return ExpandableToolMenu;
}(React__default.Component);

defineProperty(ExpandableToolMenu, "propTypes", {
  /** Button label */
  label: propTypes.string.isRequired,

  /** Array of buttons to render when expanded */
  buttons: propTypes.arrayOf(propTypes.shape({
    id: propTypes.string,
    label: propTypes.string.isRequired,
    icon: propTypes.oneOfType([propTypes.string, propTypes.shape({
      name: propTypes.string.isRequired
    })])
  })).isRequired,
  icon: propTypes.oneOfType([propTypes.string, propTypes.shape({
    name: propTypes.string.isRequired
  })]),
  onGroupMenuClick: propTypes.func,
  activeCommand: propTypes.string,
  overlayExpand: propTypes.func
});
defineProperty(ExpandableToolMenu, "defaultProps", {
  buttons: [],
  icon: 'ellipse-circle',
  label: 'More'
});

var ToolbarSection =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ToolbarSection, _PureComponent);

  function ToolbarSection() {
    classCallCheck(this, ToolbarSection);
    return possibleConstructorReturn(this, getPrototypeOf(ToolbarSection).apply(this, arguments));
  }

  createClass(ToolbarSection, [{
    key: "render",
    value: function render() {
      var _this = this;

      var items = this.props.buttons.map(function (button, index) {
        if (button.buttons && Array.isArray(button.buttons)) {
          return React__default.createElement(ExpandableToolMenu, _extends_1({
            key: "expandable-".concat(index)
          }, button, {
            activeCommand: button.activeButton
          }));
        } else {
          return React__default.createElement(ToolbarButton$1, _extends_1({
            key: index
          }, button, {
            isActive: _this.props.activeButtons.includes(button.id)
          }));
        }
      });
      return React__default.createElement("div", {
        className: classnames('ToolbarSection', this.props.className)
      }, items);
    }
  }]);
  return ToolbarSection;
}(PureComponent);

defineProperty(ToolbarSection, "defaultProps", {
  className: ''
});
defineProperty(ToolbarSection, "propTypes", {
  buttons: propTypes.arrayOf(propTypes.shape({
    id: propTypes.string,
    label: propTypes.string.isRequired,
    icon: propTypes.oneOfType([propTypes.string, propTypes.shape({
      name: propTypes.string.isRequired
    })]),

    /** Optional: Expandable Tool Menu */
    buttons: propTypes.arrayOf(propTypes.shape({}))
  })).isRequired,

  /** Array of string button ids that should show as active */
  activeButtons: propTypes.arrayOf(propTypes.string).isRequired,

  /** Class for toolbar section container */
  className: propTypes.string
});
var css$G = ".select-ohif {\n  display: block;\n  font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',\n    sans-serif;\n  font-size: 0.8em;\n  font-weight: 600;\n  color: #444;\n  line-height: 1.3;\n  padding: 0.6em 1.4em 0.5em 0.8em;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  border: 1px solid #aaa;\n  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);\n  border-radius: 0.5em;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),\n    -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#e5e5e5));\n  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),\n    -webkit-linear-gradient(top, #ffffff 0%, #e5e5e5 100%);\n  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),\n    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.7em top 50%, 0 0;\n  background-size: 0.65em auto, 100%;\n}\n\n.select-ohif::-ms-expand {\n  display: none;\n}\n\n.select-ohif:hover {\n  border-color: #888;\n}\n\n.select-ohif:focus {\n  border-color: #aaa;\n  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);\n  box-shadow: 0 0 0 3px -moz-mac-focusring;\n  color: #222;\n  outline: none;\n}\n\n.select-ohif option {\n  font-weight: normal;\n}\n";
styleInject(css$G);

var Select =
/*#__PURE__*/
function (_Component) {
  inherits(Select, _Component);

  function Select(props) {
    var _this;

    classCallCheck(this, Select);
    _this = possibleConstructorReturn(this, getPrototypeOf(Select).call(this, props));
    defineProperty(assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        value: event.target.value
      });

      if (_this.props.onChange) _this.props.onChange();
    });
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  createClass(Select, [{
    key: "render",
    value: function render() {
      return React__default.createElement("select", {
        className: "select-ohif",
        value: this.state.selected,
        onChange: this.handleChange
      }, this.props.options.map(function (_ref) {
        var key = _ref.key,
            value = _ref.value;
        return React__default.createElement("option", {
          key: key,
          value: value
        }, key);
      }));
    }
  }]);
  return Select;
}(Component);

Select.propTypes = {
  options: propTypes.arrayOf(propTypes.shape({
    key: propTypes.string.isRequired,
    value: propTypes.string.isRequired
  })),
  value: propTypes.string,
  onChange: propTypes.func
};
var css$H = ".label-ohif {\n  font-size: 1em;\n  color: #ffffff;\n}\n\n.label-example {\n  background-color: var(--ui-gray-darker);\n}\n";
styleInject(css$H);

var Label =
/*#__PURE__*/
function (_React$Component) {
  inherits(Label, _React$Component);

  function Label(props) {
    var _this;

    classCallCheck(this, Label);
    _this = possibleConstructorReturn(this, getPrototypeOf(Label).call(this, props));
    _this.state = {
      value: _this.props.text
    };
    return _this;
  }

  createClass(Label, [{
    key: "render",
    value: function render() {
      return React__default.createElement("label", {
        className: "label-ohif",
        htmlFor: this.props.for
      }, this.props.text);
    }
  }]);
  return Label;
}(React__default.Component);

Label.propTypes = {
  text: propTypes.string.isRequired,
  for: propTypes.string
};
var css$I = ".range {\n  margin: 0;\n  width: 100%;\n  -webkit-appearance: none;\n}\n\n.range:focus {\n  outline: none;\n}\n\n.range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 2px;\n  cursor: pointer;\n  box-shadow: none;\n  background-color: var(--ui-border-color-dark);\n  border-radius: 0px;\n  border: 0px solid var(--ui-border-color-dark);\n}\n\n.range::-moz-range-track {\n  width: 100%;\n  height: 2px;\n  cursor: pointer;\n  box-shadow: none;\n  background-color: var(--ui-border-color-dark);\n  border-radius: 0px;\n  border: 0px solid var(--ui-border-color-dark);\n}\n\n.range::-webkit-slider-thumb {\n  box-shadow: none;\n  border: 0px solid var(--active-color);\n  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);\n  height: 21px;\n  width: 11px;\n  border-radius: 11px;\n  background: var(--active-color);\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -10px;\n}\n\n.range::-moz-range-thumb {\n  box-shadow: none;\n  border: 0px solid var(--active-color);\n  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);\n  height: 21px;\n  width: 11px;\n  border-radius: 11px;\n  background: var(--active-color);\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -10px;\n}\n\n.range::-moz-focus-outer {\n  border: 0;\n}\n\n.range-example {\n  background: black;\n  height: 2em;\n}\n";
styleInject(css$I);

var Range =
/*#__PURE__*/
function (_React$Component) {
  inherits(Range, _React$Component);

  function Range(props) {
    var _this;

    classCallCheck(this, Range);
    _this = possibleConstructorReturn(this, getPrototypeOf(Range).call(this, props));
    defineProperty(assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        value: event.target.value
      });

      if (_this.props.onChange) _this.props.onChange();
    });
    _this.state = {
      value: props.value
    };
    return _this;
  }

  createClass(Range, [{
    key: "render",
    value: function render() {
      return React__default.createElement("input", {
        type: "range",
        value: this.state.value,
        min: this.props.min,
        max: this.props.max,
        onChange: this.handleChange,
        id: this.props.id,
        className: "range"
      });
    }
  }]);
  return Range;
}(React__default.Component);

Range.propTypes = {
  value: propTypes.number,
  min: propTypes.number.isRequired,
  max: propTypes.number.isRequired,
  id: propTypes.string,
  onChange: propTypes.func
};
var css$J = ".textarea-ohif {\n  background-color: #b6b6b6;\n  border-color: #b6b6b6;\n  font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',\n    sans-serif;\n  font-size: 1em;\n}\n";
styleInject(css$J);

var TextArea =
/*#__PURE__*/
function (_React$Component) {
  inherits(TextArea, _React$Component);

  function TextArea(props) {
    var _this;

    classCallCheck(this, TextArea);
    _this = possibleConstructorReturn(this, getPrototypeOf(TextArea).call(this, props));
    defineProperty(assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        value: event.target.value
      });

      if (_this.props.onChange) _this.props.onChange();
    });
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  createClass(TextArea, [{
    key: "render",
    value: function render() {
      return React__default.createElement("textarea", {
        className: "textarea-ohif",
        value: this.state.value,
        rows: this.props.rows,
        cols: this.props.cols,
        onChange: this.handleChange,
        id: this.props.id
      });
    }
  }]);
  return TextArea;
}(React__default.Component);

TextArea.propTypes = {
  value: propTypes.string,
  rows: propTypes.number,
  cols: propTypes.number,
  id: propTypes.string,
  onChange: propTypes.func
};
var css$K = ".input-ohif {\n  background-color: #b6b6b6;\n  border-color: #b6b6b6;\n  font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',\n    sans-serif;\n  font-size: 1em;\n}\n";
styleInject(css$K);

var TextInput =
/*#__PURE__*/
function (_React$Component) {
  inherits(TextInput, _React$Component);

  function TextInput(props) {
    var _this;

    classCallCheck(this, TextInput);
    _this = possibleConstructorReturn(this, getPrototypeOf(TextInput).call(this, props));
    defineProperty(assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        value: event.target.value
      });

      if (_this.props.onChange) _this.props.onChange();
    });
    _this.state = {
      value: props.value
    };
    return _this;
  }

  createClass(TextInput, [{
    key: "render",
    value: function render() {
      return React__default.createElement("input", {
        className: "input-ohif",
        type: "text",
        value: this.state.value,
        onChange: this.handleChange,
        id: this.props.id
      });
    }
  }]);
  return TextInput;
}(React__default.Component);

TextInput.propTypes = {
  value: propTypes.string,
  id: propTypes.string,
  onChange: propTypes.func
};
var css$L = ".dd-menu {\n  float: left;\n  margin-right: 10px;\n  cursor: pointer;\n  position: relative;\n}\n\n.dd-title {\n  font-size: 13px;\n}\n\n.dd-menu-toggle {\n  display: inline-block;\n}\n\n.dd-caret-down {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-top: 0.5rem;\n  margin-left: 0.5rem;\n  border-top: 5px solid;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n}\n\n.dd-menu-list {\n  position: absolute;\n  top: 100%;\n  margin-top: 10px;\n  background: white;\n  z-index: 999;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  overflow: hidden;\n  transition: all 300ms ease;\n  -webkit-transition: all 300ms ease;\n  -moz-transition: all 300ms ease;\n  -ms-transition: all 300ms ease;\n  -o-transition: all 300ms ease;\n}\n\n.dd-menu-list.open {\n  display: inline-block;\n}\n\n.dd-menu-list.left {\n  left: 0;\n}\n\n.dd-menu-list.right {\n  right: 0;\n}\n\n.dd-menu-list.center {\n  left: 50%;\n  transform: translateX(-50%);\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n}\n\n.dd-item {\n  display: -webkit-box;\n  display: flex;\n  color: var(--text-color-active);\n  padding: 10px 15px;\n  border-bottom: 1px solid #ccc;\n}\n\n.dd-item:hover {\n  text-decoration: none;\n  background: #eee;\n}\n\n.dd-item:last-child {\n  border-bottom: none;\n}\n\n.dd-item-icon {\n  margin-right: 10px;\n  margin-top: 2px;\n}\n";
styleInject(css$L);

var DropdownMenu =
/*#__PURE__*/
function (_Component) {
  inherits(DropdownMenu, _Component);

  function DropdownMenu() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, DropdownMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(DropdownMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      open: false
    });
    defineProperty(assertThisInitialized(_this), "getListItems", function () {
      var _this$props = _this.props,
          list = _this$props.list,
          align = _this$props.align;
      return list.map(function (_ref, key) {
        var icon = _ref.icon,
            title = _ref.title,
            link = _ref.link,
            _onClick = _ref.onClick;

        if (link) {
          return React__default.createElement("a", {
            href: link || '#',
            key: key,
            className: "dd-item",
            onClick: function onClick() {
              return _this.handleOnClick(_onClick);
            }
          }, icon && React__default.createElement(Icon, _extends_1({}, icon, {
            className: "dd-item-icon"
          })), React__default.createElement("span", null, title));
        } else {
          return React__default.createElement("button", {
            key: key,
            className: "dd-item",
            onClick: function onClick() {
              return _this.handleOnClick(_onClick);
            }
          }, icon && React__default.createElement(Icon, _extends_1({}, icon, {
            className: "dd-item-icon"
          })), React__default.createElement("span", null, title));
        }
      });
    });
    defineProperty(assertThisInitialized(_this), "renderList", function () {
      var align = _this.props.align;

      if (!_this.state.open) {
        return null;
      }

      return React__default.createElement("div", {
        className: "dd-menu-list ".concat(align || 'left')
      }, _this.getListItems());
    });
    defineProperty(assertThisInitialized(_this), "handleOnClick", function (onClick) {
      _this.toggleList();

      if (onClick) {
        onClick();
      }
    });
    defineProperty(assertThisInitialized(_this), "handleMouseClick", function (e) {
      if (_this.node.contains(e.target)) {
        return;
      }

      _this.toggleList();
    });
    defineProperty(assertThisInitialized(_this), "renderTitleElement", function () {
      var _this$props2 = _this.props,
          titleElement = _this$props2.titleElement,
          title = _this$props2.title;

      if (titleElement) {
        return titleElement;
      }

      return React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
        className: "dd-title"
      }, title), React__default.createElement("span", {
        className: "dd-caret-down"
      }));
    });
    defineProperty(assertThisInitialized(_this), "toggleList", function () {
      var open = _this.state.open;
      var state = true;
      document.addEventListener('mousedown', _this.handleMouseClick, false);

      if (open) {
        document.removeEventListener('mousedown', _this.handleMouseClick, false);
        state = false;
      }

      _this.setState({
        open: state
      });
    });
    return _this;
  }

  createClass(DropdownMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement("div", {
        className: "dd-menu",
        ref: function ref(node) {
          return _this2.node = node;
        }
      }, React__default.createElement("div", {
        className: "dd-menu-toggle",
        onClick: this.toggleList
      }, this.renderTitleElement()), this.renderList());
    }
  }]);
  return DropdownMenu;
}(Component);

defineProperty(DropdownMenu, "propTypes", {
  titleElement: propTypes.node,
  title: propTypes.string,
  align: propTypes.oneOf(['left', 'center', 'right']),

  /** Items to render in the select's drop down */
  list: propTypes.arrayOf(propTypes.shape({
    title: propTypes.string.isRequired,
    icon: propTypes.object,
    onClick: propTypes.func,
    link: propTypes.string
  }))
});
var css$M = ".viewport-container {\n  float: left;\n  position: relative;\n  border: var(--viewport-border-thickness) solid var(--ui-border-color);\n}\n\n.viewport-container.active {\n  border: 2px solid var(--active-color);\n}\n\n.viewport-container.full {\n  position: absolute;\n  width: 100% !important;\n  height: 100% !important;\n  z-index: 9;\n}\n\n.EmptyViewport {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n          align-items: center;\n  height: 100%;\n  color: var(--text-secondary-color);\n}\n\n.LayoutPanel {\n  width: 100%;\n  height: 100%;\n}\n";
styleInject(css$M);
var css$N = ".LayoutPanelDropTarget {\n  width: 100%;\n  height: 100%;\n\n  opacity: 1;\n  -webkit-transition: 0.3s all ease;\n  transition: 0.3s all ease;\n}\n\n.LayoutPanelDropTarget.hovered {\n  opacity: 0.5;\n  cursor: copy;\n}\n";
styleInject(css$N); // if they have the same string type.

var Types$2 = {
  THUMBNAIL: 'thumbnail'
};
var divTarget$1 = {
  drop: function drop(props, monitor, component) {
    var item = monitor.getItem();

    if (props.onDrop) {
      props.onDrop({
        viewportIndex: props.viewportIndex,
        item: item
      });
    }

    return {
      id: "LayoutPanelDropTarget-".concat(props.viewportIndex),
      viewportIndex: props.viewportIndex,
      item: item
    };
  }
}; // TODO: Find out why we can't move this into the Example app instead.
// It looks like the context isn't properly shared.

var LayoutPanelDropTarget =
/*#__PURE__*/
function (_Component) {
  inherits(LayoutPanelDropTarget, _Component);

  function LayoutPanelDropTarget() {
    classCallCheck(this, LayoutPanelDropTarget);
    return possibleConstructorReturn(this, getPrototypeOf(LayoutPanelDropTarget).apply(this, arguments));
  }

  createClass(LayoutPanelDropTarget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          canDrop = _this$props.canDrop,
          isOver = _this$props.isOver,
          connectDropTarget = _this$props.connectDropTarget;
      var isActive = canDrop && isOver;
      var className = LayoutPanelDropTarget.className;

      if (isActive) {
        className += ' hovered';
      } else if (canDrop) {
        className += ' can-drop';
      }

      return connectDropTarget(React__default.createElement("div", {
        className: className
      }, this.props.children));
    }
  }]);
  return LayoutPanelDropTarget;
}(Component);

defineProperty(LayoutPanelDropTarget, "className", 'LayoutPanelDropTarget');
defineProperty(LayoutPanelDropTarget, "defaultProps", {
  isOver: false,
  canDrop: false
});
defineProperty(LayoutPanelDropTarget, "propTypes", {
  connectDropTarget: propTypes.func.isRequired,
  canDrop: propTypes.bool.isRequired,
  isOver: propTypes.bool.isRequired,
  viewportComponent: propTypes.object
});

var collect$2 = function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    canDrop: monitor.canDrop(),
    isOver: monitor.isOver()
  };
};

var LayoutPanelDropTarget$1 = DropTarget(Types$2.THUMBNAIL, divTarget$1, collect$2)(LayoutPanelDropTarget);

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(source, true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function defaultViewportPlugin(props) {
  return React__default.createElement("div", null, JSON.stringify(props));
}

function EmptyViewport() {
  return React__default.createElement("div", {
    className: "EmptyViewport"
  }, React__default.createElement("p", null, "Please drag a stack here to view images."));
}

var LayoutManager =
/*#__PURE__*/
function (_Component) {
  inherits(LayoutManager, _Component);

  function LayoutManager() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, LayoutManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(LayoutManager)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "onDrop", function (_ref) {
      var viewportIndex = _ref.viewportIndex,
          item = _ref.item;

      if (_this.props.setViewportData) {
        _this.props.setViewportData({
          viewportIndex: viewportIndex,
          item: item
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "getPluginComponent", function (plugin) {
      var pluginComponent = _this.props.availablePlugins[plugin || _this.props.defaultPlugin];

      if (!pluginComponent) {
        throw new Error("No Viewport Plugin available for plugin ".concat(plugin, ". Available plugins: ").concat(JSON.stringify(_this.props.availablePlugins)));
      }

      return pluginComponent;
    });
    return _this;
  }

  createClass(LayoutManager, [{
    key: "getChildComponent",
    value: function getChildComponent(plugin, data, viewportIndex, children) {
      if (data.displaySet) {
        var PluginComponent = this.getPluginComponent(plugin);
        return React__default.createElement(PluginComponent, {
          viewportData: data,
          viewportIndex: viewportIndex,
          children: Array.isArray(children) ? children : [children],
          userInfo: this.props.userInfo
        });
      }

      return React__default.createElement(EmptyViewport, null);
    }
  }, {
    key: "getContent",
    value: function getContent(childComponent, supportsDragAndDrop, viewportIndex) {
      if (supportsDragAndDrop) {
        return React__default.createElement(LayoutPanelDropTarget$1, {
          onDrop: this.onDrop,
          viewportIndex: viewportIndex,
          userInfo: this.props.userInfo
        }, childComponent);
      }

      return React__default.createElement("div", {
        className: "LayoutPanel"
      }, childComponent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.viewportData.length) {
        return '';
      }

      var _this$props = this.props,
          supportsDragAndDrop = _this$props.supportsDragAndDrop,
          studies = _this$props.studies,
          viewportData = _this$props.viewportData;
      var viewports = this.props.layout.viewports;
      var viewportElements = viewports.map(function (layout, viewportIndex) {
        var displaySet = viewportData[viewportIndex];
        var data = {
          displaySet: displaySet,
          studies: studies
        }; // Use whichever plugin is currently in use in the panel
        // unless nothing is specified. If nothing is specified
        // and the display set has a plugin specified, use that.
        //
        // TODO: Change this logic to:
        // - Plugins define how capable they are of displaying a SopClass
        // - When updating a panel, ensure that the currently enabled plugin
        // in the viewport is capable of rendering this display set. If not
        // then use the most capable available plugin

        var plugin = layout.plugin;

        if (!layout.plugin && displaySet && displaySet.plugin) {
          plugin = displaySet.plugin;
        }

        var childComponent = _this2.getChildComponent(plugin, data, viewportIndex, _this2.props.children);

        var content = _this2.getContent(childComponent, supportsDragAndDrop, viewportIndex);

        var className = 'viewport-container';

        if (_this2.props.activeViewportIndex === viewportIndex) {
          className += ' active';
        }

        if (_this2.props.fullscreenState && _this2.props.activeViewportIndex === viewportIndex) {
          className += ' full';
        }

        return React__default.createElement("div", {
          key: viewportIndex,
          className: className,
          style: _objectSpread$4({}, layout)
        }, content);
      });
      return React__default.createElement("div", {
        className: LayoutManager.className
      }, viewportElements);
    }
  }]);
  return LayoutManager;
}(Component);

defineProperty(LayoutManager, "className", 'LayoutManager');
defineProperty(LayoutManager, "defaultProps", {
  viewportData: [],
  layout: {
    viewports: [{
      top: 0,
      left: 0,
      height: '100%',
      width: '100%'
    }]
  },
  activeViewportIndex: 0,
  supportsDragAndDrop: true,
  availablePlugins: {
    defaultViewportPlugin: defaultViewportPlugin
  },
  defaultPlugin: 'defaultViewportPlugin'
});
defineProperty(LayoutManager, "propTypes", {
  viewportData: propTypes.array.isRequired,
  supportsDragAndDrop: propTypes.bool.isRequired,
  activeViewportIndex: propTypes.number.isRequired,
  fullscreenState: propTypes.bool.isRequired,
  layout: propTypes.object.isRequired,
  availablePlugins: propTypes.object.isRequired,
  setViewportData: propTypes.func,
  studies: propTypes.array,
  children: propTypes.node,
  userInfo: propTypes.object
});

var PlayClipButton =
/*#__PURE__*/
function (_Component) {
  inherits(PlayClipButton, _Component);

  function PlayClipButton() {
    classCallCheck(this, PlayClipButton);
    return possibleConstructorReturn(this, getPrototypeOf(PlayClipButton).apply(this, arguments));
  }

  createClass(PlayClipButton, [{
    key: "render",
    value: function render() {
      var iconName = this.props.isPlaying ? 'stop' : 'play';
      return React__default.createElement("div", {
        className: "btn-group"
      }, React__default.createElement("button", {
        id: "playClip",
        type: "button",
        className: "imageViewerCommand btn btn-sm btn-default",
        "data-container": "body",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: "Play/Stop Clip"
      }, React__default.createElement(Icon, {
        name: iconName
      })), React__default.createElement("button", {
        id: "toggleCineDialog",
        type: "button",
        className: "imageViewerCommand btn btn-sm btn-default",
        "data-container": "body",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: "Toggle CINE Dialog"
      }, React__default.createElement(Icon, {
        name: "youtube"
      })));
    }
  }]);
  return PlayClipButton;
}(Component);

defineProperty(PlayClipButton, "propTypes", {
  isPlaying: propTypes.bool.isRequired
});
defineProperty(PlayClipButton, "defaultProps", {
  isPlaying: false
});

function SimpleToolbarButton(props) {
  var className = classnames(props.className, 'btn btn-sm btn-default');
  return React__default.createElement("button", {
    id: props.id,
    type: "button",
    className: className,
    "data-container": "body",
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: props.title
  }, props.icon && React__default.createElement(Icon, {
    name: props.icon
  }));
}

SimpleToolbarButton.propTypes = {
  icon: propTypes.string,
  title: propTypes.string,
  className: propTypes.string,
  id: propTypes.string,
  onClick: propTypes.func
};

function getDefaultButtonData() {
  var buttonData = [{
    id: 'wwwc',
    title: 'WW/WC',
    className: 'imageViewerTool',
    icon: 'sun'
  }, {
    id: 'wwwcRegion',
    title: 'Window by Region',
    className: 'imageViewerTool',
    icon: 'stop'
  }, {
    id: 'magnify',
    title: 'Magnify',
    className: 'imageViewerTool',
    icon: 'circle'
  }, {
    id: 'annotate',
    title: 'Annotation',
    className: 'imageViewerTool',
    icon: 'arrows-alt-h'
  }, {
    id: 'invert',
    title: 'Invert',
    className: 'imageViewerCommand',
    icon: 'adjust'
  }, {
    id: 'zoom',
    title: 'Zoom',
    className: 'imageViewerTool',
    icon: 'search-plus'
  }, {
    id: 'pan',
    title: 'Pan',
    className: 'imageViewerTool',
    icon: 'arrows'
  }, {
    id: 'stackScroll',
    title: 'Stack Scroll',
    className: 'imageViewerTool',
    icon: 'bars'
  }, {
    id: 'length',
    title: 'Length Measurement',
    className: 'imageViewerTool',
    icon: 'arrows-alt-v'
  }, {
    id: 'angle',
    title: 'Angle Measurement',
    className: 'imageViewerTool',
    icon: 'fa fa-angle-left'
  }, {
    id: 'dragProbe',
    title: 'Pixel Probe',
    className: 'imageViewerTool',
    icon: 'fa fa-dot-circle-o'
  }, {
    id: 'ellipticalRoi',
    title: 'Elliptical ROI',
    className: 'imageViewerTool',
    icon: 'circle-o'
  }, {
    id: 'rectangleRoi',
    title: 'Rectangle ROI',
    className: 'imageViewerTool',
    icon: 'square-o'
  }, {
    id: 'resetViewport',
    title: 'Reset Viewport',
    className: 'imageViewerCommand',
    icon: 'reset'
  }, {
    id: 'clearTools',
    title: 'Clear tools',
    className: 'imageViewerCommand',
    icon: 'trash'
  }];
  return buttonData;
}

var Toolbar =
/*#__PURE__*/
function (_Component) {
  inherits(Toolbar, _Component);

  function Toolbar() {
    classCallCheck(this, Toolbar);
    return possibleConstructorReturn(this, getPrototypeOf(Toolbar).apply(this, arguments));
  }

  createClass(Toolbar, [{
    key: "render",
    value: function render() {
      var maybePlayClipButton;

      if (this.props.includePlayClipButton) {
        maybePlayClipButton = React__default.createElement(PlayClipButton, null);
      }

      var maybeLayoutButton;

      if (this.props.includeLayoutButton) {
        maybeLayoutButton = React__default.createElement(LayoutButton, null);
      }

      return React__default.createElement("div", {
        id: "toolbar"
      }, React__default.createElement("div", {
        className: "btn-group"
      }, this.props.buttons.map(function (button, i) {
        return React__default.createElement(SimpleToolbarButton, _extends_1({}, button, {
          key: i
        }));
      }), maybePlayClipButton, maybeLayoutButton));
    }
  }]);
  return Toolbar;
}(Component);

defineProperty(Toolbar, "propTypes", {
  buttons: propTypes.arrayOf(propTypes.shape({
    id: propTypes.string.isRequired,
    title: propTypes.string.isRequired,
    icon: propTypes.oneOfType([propTypes.string, propTypes.shape({
      name: propTypes.string.isRequired
    })])
  })).isRequired,
  includeLayoutButton: propTypes.bool.isRequired,
  includePlayClipButton: propTypes.bool.isRequired
});
defineProperty(Toolbar, "defaultProps", {
  buttons: getDefaultButtonData(),
  includeLayoutButton: true,
  includePlayClipButton: true
});
var Touch = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _a;

  function isTouchEvent(e) {
    return !!e.targetTouches;
  }

  function getEventClientTouchOffset(e) {
    if (e.targetTouches.length === 1) {
      return getEventClientOffset(e.targetTouches[0]);
    }
  }

  function getEventClientOffset(e) {
    if (isTouchEvent(e)) {
      return getEventClientTouchOffset(e);
    } else {
      return {
        x: e.clientX,
        y: e.clientY
      };
    }
  } // Used for MouseEvent.buttons (note the s on the end).


  var MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4
  }; // Used for e.button (note the lack of an s on the end).

  var MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2
  };
  /**
   * Only touch events and mouse events where the left button is pressed should initiate a drag.
   * @param {MouseEvent | TouchEvent} e The event
   */

  function eventShouldStartDrag(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === MouseButton.Left;
  }
  /**
   * Only touch events and mouse events where the left mouse button is no longer held should end a drag.
   * It's possible the user mouse downs with the left mouse button, then mouse down and ups with the right mouse button.
   * We don't want releasing the right mouse button to end the drag.
   * @param {MouseEvent | TouchEvent} e The event
   */


  function eventShouldEndDrag(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & MouseButtons.Left) === 0;
  } // Polyfill for document.elementsFromPoint


  var elementsFromPoint = (typeof document !== 'undefined' && document.elementsFromPoint || function (x, y) {
    if (document.msElementsFromPoint) {
      // msElementsFromPoint is much faster but returns a node-list, so convert it to an array
      var msElements = document.msElementsFromPoint(x, y);
      return msElements && Array.prototype.slice.call(msElements, 0);
    }

    var elements = [],
        previousPointerEvents = [],
        current,
        i,
        d; // get all elements via elementFromPoint, and remove them from hit-testing in order

    while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current !== null) {
      // push the element and its current style
      elements.push(current);
      previousPointerEvents.push({
        value: current.style.getPropertyValue('pointer-events'),
        priority: current.style.getPropertyPriority('pointer-events')
      }); // add "pointer-events: none", to get to the underlying element

      current.style.setProperty('pointer-events', 'none', 'important');
    } // restore the previous pointer-events values


    for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
      elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
    } // return our results


    return elements;
  }).bind(typeof document !== 'undefined' ? document : null);

  var supportsPassive = function () {
    // simular to jQuery's test
    var supported = false;

    try {
      addEventListener('test', null, Object.defineProperty({}, 'passive', {
        get: function get() {
          supported = true;
        }
      }));
    } catch (e) {}

    return supported;
  }();

  var ELEMENT_NODE = 1;

  function getNodeClientOffset(node) {
    var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

    if (!el) {
      return null;
    }

    var _a = el.getBoundingClientRect(),
        top = _a.top,
        left = _a.left;

    return {
      x: left,
      y: top
    };
  }

  var eventNames = (_a = {}, _a["mouse"
  /* mouse */
  ] = {
    start: 'mousedown',
    move: 'mousemove',
    end: 'mouseup',
    contextmenu: 'contextmenu'
  }, _a["touch"
  /* touch */
  ] = {
    start: 'touchstart',
    move: 'touchmove',
    end: 'touchend'
  }, _a["keyboard"
  /* keyboard */
  ] = {
    keydown: 'keydown'
  }, _a);

  var TouchBackend =
  /** @class */
  function () {
    function TouchBackend(manager, options) {
      var _this = this;

      if (options === void 0) {
        options = {};
      }

      this.getSourceClientOffset = function (sourceId) {
        return getNodeClientOffset(_this.sourceNodes[sourceId]);
      };

      this.handleTopMoveStartCapture = function (e) {
        if (!eventShouldStartDrag(e)) {
          return;
        }

        _this.moveStartSourceIds = [];
      };

      this.handleMoveStart = function (sourceId) {
        // Just because we received an event doesn't necessarily mean we need to collect drag sources.
        // We only collect start collecting drag sources on touch and left mouse events.
        if (Array.isArray(_this.moveStartSourceIds)) {
          _this.moveStartSourceIds.unshift(sourceId);
        }
      };

      this.handleTopMoveStart = function (e) {
        if (!eventShouldStartDrag(e)) {
          return;
        } // Don't prematurely preventDefault() here since it might:
        // 1. Mess up scrolling
        // 2. Mess up long tap (which brings up context menu)
        // 3. If there's an anchor link as a child, tap won't be triggered on link


        var clientOffset = getEventClientOffset(e);

        if (clientOffset) {
          _this._mouseClientOffset = clientOffset;
        }

        _this.waitingForDelay = false;
      };

      this.handleTopMoveStartDelay = function (e) {
        if (!eventShouldStartDrag(e)) {
          return;
        }

        var delay = e.type === eventNames.touch.start ? _this.delayTouchStart : _this.delayMouseStart;
        _this.timeout = setTimeout(_this.handleTopMoveStart.bind(_this, e), delay);
        _this.waitingForDelay = true;
      };

      this.handleTopMoveCapture = function () {
        _this.dragOverTargetIds = [];
      };

      this.handleMove = function (_, targetId) {
        _this.dragOverTargetIds.unshift(targetId);
      };

      this.handleTopMove = function (e) {
        clearTimeout(_this.timeout);

        if (_this.waitingForDelay) {
          return;
        }

        var _a = _this,
            moveStartSourceIds = _a.moveStartSourceIds,
            dragOverTargetIds = _a.dragOverTargetIds,
            enableHoverOutsideTarget = _a.enableHoverOutsideTarget;
        var clientOffset = getEventClientOffset(e);

        if (!clientOffset) {
          return;
        } // If the touch move started as a scroll, or is is between the scroll angles


        if (_this._isScrolling || !_this.monitor.isDragging() && inAngleRanges(_this._mouseClientOffset.x, _this._mouseClientOffset.y, clientOffset.x, clientOffset.y, _this.scrollAngleRanges)) {
          _this._isScrolling = true;
          return;
        } // If we're not dragging and we've moved a little, that counts as a drag start


        if (!_this.monitor.isDragging() && _this._mouseClientOffset.hasOwnProperty('x') && moveStartSourceIds && distance(_this._mouseClientOffset.x, _this._mouseClientOffset.y, clientOffset.x, clientOffset.y) > (_this.touchSlop ? _this.touchSlop : 0)) {
          _this.moveStartSourceIds = null;

          _this.actions.beginDrag(moveStartSourceIds, {
            clientOffset: _this._mouseClientOffset,
            getSourceClientOffset: _this.getSourceClientOffset,
            publishSource: false
          });
        }

        if (!_this.monitor.isDragging()) {
          return;
        }

        var sourceNode = _this.sourceNodes[_this.monitor.getSourceId()];

        _this.installSourceNodeRemovalObserver(sourceNode);

        _this.actions.publishDragSource();

        e.preventDefault(); // Get the node elements of the hovered DropTargets

        var dragOverTargetNodes = dragOverTargetIds.map(function (key) {
          return _this.targetNodes[key];
        }); // Get the a ordered list of nodes that are touched by

        var elementsAtPoint = _this.getDropTargetElementsAtPoint ? _this.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : elementsFromPoint(clientOffset.x, clientOffset.y); // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)

        var elementsAtPointExtended = [];

        for (var nodeId in elementsAtPoint) {
          if (!elementsAtPoint.hasOwnProperty(nodeId)) {
            continue;
          }

          var currentNode = elementsAtPoint[nodeId];
          elementsAtPointExtended.push(currentNode);

          while (currentNode) {
            currentNode = currentNode.parentElement;

            if (elementsAtPointExtended.indexOf(currentNode) === -1) {
              elementsAtPointExtended.push(currentNode);
            }
          }
        }

        var orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
        .filter(function (node) {
          return dragOverTargetNodes.indexOf(node) > -1;
        }) // Map back the nodes elements to targetIds
        .map(function (node) {
          for (var targetId in _this.targetNodes) {
            if (node === _this.targetNodes[targetId]) {
              return targetId;
            }
          }

          return null;
        }) // Filter off possible null rows
        .filter(function (node) {
          return !!node;
        }).filter(function (id, index, ids) {
          return ids.indexOf(id) === index;
        }); // Invoke hover for drop targets when source node is still over and pointer is outside

        if (enableHoverOutsideTarget) {
          for (var targetId in _this.targetNodes) {
            if (_this.targetNodes[targetId] && _this.targetNodes[targetId].contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
              orderedDragOverTargetIds.unshift(targetId);
              break;
            }
          }
        } // Reverse order because dnd-core reverse it before calling the DropTarget drop methods


        orderedDragOverTargetIds.reverse();

        _this.actions.hover(orderedDragOverTargetIds, {
          clientOffset: clientOffset
        });
      };

      this.handleTopMoveEndCapture = function (e) {
        _this._isScrolling = false;

        if (!eventShouldEndDrag(e)) {
          return;
        }

        if (!_this.monitor.isDragging() || _this.monitor.didDrop()) {
          _this.moveStartSourceIds = null;
          return;
        }

        e.preventDefault();
        _this._mouseClientOffset = {};

        _this.uninstallSourceNodeRemovalObserver();

        _this.actions.drop();

        _this.actions.endDrag();
      };

      this.handleCancelOnEscape = function (e) {
        if (e.key === 'Escape' && _this.monitor.isDragging()) {
          _this._mouseClientOffset = {};

          _this.uninstallSourceNodeRemovalObserver();

          _this.actions.endDrag();
        }
      };

      options.delayTouchStart = options.delayTouchStart || options.delay;
      options = __assign({
        enableTouchEvents: true,
        enableMouseEvents: false,
        enableKeyboardEvents: false,
        ignoreContextMenu: false,
        enableHoverOutsideTarget: false,
        delayTouchStart: 0,
        delayMouseStart: 0,
        touchSlop: 0,
        scrollAngleRanges: undefined
      }, options);
      this.actions = manager.getActions();
      this.monitor = manager.getMonitor();
      this.registry = manager.getRegistry();
      this.enableKeyboardEvents = options.enableKeyboardEvents;
      this.enableMouseEvents = options.enableMouseEvents;
      this.delayTouchStart = options.delayTouchStart;
      this.delayMouseStart = options.delayMouseStart;
      this.ignoreContextMenu = options.ignoreContextMenu;
      this.touchSlop = options.touchSlop;
      this.scrollAngleRanges = options.scrollAngleRanges;
      this.enableHoverOutsideTarget = options.enableHoverOutsideTarget;
      this.sourceNodes = {};
      this.sourceNodeOptions = {};
      this.sourcePreviewNodes = {};
      this.sourcePreviewNodeOptions = {};
      this.targetNodes = {};
      this.targetNodeOptions = {};
      this.listenerTypes = [];
      this._mouseClientOffset = {};
      this._isScrolling = false;

      if (options.enableMouseEvents) {
        this.listenerTypes.push("mouse"
        /* mouse */
        );
      }

      if (options.enableTouchEvents) {
        this.listenerTypes.push("touch"
        /* touch */
        );
      }

      if (options.enableKeyboardEvents) {
        this.listenerTypes.push("keyboard"
        /* keyboard */
        );
      }

      if (options.getDropTargetElementsAtPoint) {
        this.getDropTargetElementsAtPoint = options.getDropTargetElementsAtPoint;
      }
    }

    TouchBackend.prototype.setup = function () {
      if (typeof window === 'undefined') {
        return;
      }

      browser(!TouchBackend.isSetUp, 'Cannot have two Touch backends at the same time.');
      TouchBackend.isSetUp = true;
      this.addEventListener(window, 'start', this.getTopMoveStartHandler());
      this.addEventListener(window, 'start', this.handleTopMoveStartCapture, true);
      this.addEventListener(window, 'move', this.handleTopMove);
      this.addEventListener(window, 'move', this.handleTopMoveCapture, true);
      this.addEventListener(window, 'end', this.handleTopMoveEndCapture, true);

      if (this.enableMouseEvents && !this.ignoreContextMenu) {
        this.addEventListener(window, 'contextmenu', this.handleTopMoveEndCapture);
      }

      if (this.enableKeyboardEvents) {
        this.addEventListener(window, 'keydown', this.handleCancelOnEscape, true);
      }
    };

    TouchBackend.prototype.teardown = function () {
      if (typeof window === 'undefined') {
        return;
      }

      TouchBackend.isSetUp = false;
      this._mouseClientOffset = {};
      this.removeEventListener(window, 'start', this.handleTopMoveStartCapture, true);
      this.removeEventListener(window, 'start', this.handleTopMoveStart);
      this.removeEventListener(window, 'move', this.handleTopMoveCapture, true);
      this.removeEventListener(window, 'move', this.handleTopMove);
      this.removeEventListener(window, 'end', this.handleTopMoveEndCapture, true);

      if (this.enableMouseEvents && !this.ignoreContextMenu) {
        this.removeEventListener(window, 'contextmenu', this.handleTopMoveEndCapture);
      }

      if (this.enableKeyboardEvents) {
        this.removeEventListener(window, 'keydown', this.handleCancelOnEscape, true);
      }

      this.uninstallSourceNodeRemovalObserver();
    };

    TouchBackend.prototype.addEventListener = function (subject, event, handler, capture) {
      var options = supportsPassive ? {
        capture: capture,
        passive: false
      } : capture;
      this.listenerTypes.forEach(function (listenerType) {
        var evt = eventNames[listenerType][event];

        if (evt) {
          subject.addEventListener(evt, handler, options);
        }
      });
    };

    TouchBackend.prototype.removeEventListener = function (subject, event, handler, capture) {
      var options = supportsPassive ? {
        capture: capture,
        passive: false
      } : capture;
      this.listenerTypes.forEach(function (listenerType) {
        var evt = eventNames[listenerType][event];

        if (evt) {
          subject.removeEventListener(evt, handler, options);
        }
      });
    };

    TouchBackend.prototype.connectDragSource = function (sourceId, node) {
      var _this = this;

      var handleMoveStart = this.handleMoveStart.bind(this, sourceId);
      this.sourceNodes[sourceId] = node;
      this.addEventListener(node, 'start', handleMoveStart);
      return function () {
        delete _this.sourceNodes[sourceId];

        _this.removeEventListener(node, 'start', handleMoveStart);
      };
    };

    TouchBackend.prototype.connectDragPreview = function (sourceId, node, options) {
      var _this = this;

      this.sourcePreviewNodeOptions[sourceId] = options;
      this.sourcePreviewNodes[sourceId] = node;
      return function () {
        delete _this.sourcePreviewNodes[sourceId];
        delete _this.sourcePreviewNodeOptions[sourceId];
      };
    };

    TouchBackend.prototype.connectDropTarget = function (targetId, node) {
      var _this = this;

      var handleMove = function handleMove(e) {
        var coords;

        if (!_this.monitor.isDragging()) {
          return;
        }
        /**
         * Grab the coordinates for the current mouse/touch position
         */


        switch (e.type) {
          case eventNames.mouse.move:
            coords = {
              x: e.clientX,
              y: e.clientY
            };
            break;

          case eventNames.touch.move:
            coords = {
              x: e.touches[0].clientX,
              y: e.touches[0].clientY
            };
            break;
        }
        /**
         * Use the coordinates to grab the element the drag ended on.
         * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
         */


        var droppedOn = document.elementFromPoint(coords.x, coords.y);
        var childMatch = node.contains(droppedOn);

        if (droppedOn === node || childMatch) {
          return _this.handleMove(e, targetId);
        }
      };
      /**
       * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
       */


      this.addEventListener(document.body, 'move', handleMove);
      this.targetNodes[targetId] = node;
      return function () {
        delete _this.targetNodes[targetId];

        _this.removeEventListener(document.body, 'move', handleMove);
      };
    };

    TouchBackend.prototype.getTopMoveStartHandler = function () {
      if (!this.delayTouchStart && !this.delayMouseStart) {
        return this.handleTopMoveStart;
      }

      return this.handleTopMoveStartDelay;
    };

    TouchBackend.prototype.installSourceNodeRemovalObserver = function (node) {
      var _this = this;

      this.uninstallSourceNodeRemovalObserver();
      this.draggedSourceNode = node;
      this.draggedSourceNodeRemovalObserver = new MutationObserver(function () {
        if (!node.parentElement) {
          _this.resurrectSourceNode();

          _this.uninstallSourceNodeRemovalObserver();
        }
      });

      if (!node || !node.parentElement) {
        return;
      }

      this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
        childList: true
      });
    };

    TouchBackend.prototype.resurrectSourceNode = function () {
      this.draggedSourceNode.style.display = 'none';
      this.draggedSourceNode.removeAttribute('data-reactid');
      document.body.appendChild(this.draggedSourceNode);
    };

    TouchBackend.prototype.uninstallSourceNodeRemovalObserver = function () {
      if (this.draggedSourceNodeRemovalObserver) {
        this.draggedSourceNodeRemovalObserver.disconnect();
      }

      this.draggedSourceNodeRemovalObserver = null;
      this.draggedSourceNode = null;
    };

    return TouchBackend;
  }();

  exports.TouchBackend = TouchBackend;

  function isDragDropManager(optionsOrManager) {
    return !!optionsOrManager.getMonitor;
  }

  function createTouchBackend(optionsOrManager) {
    var touchBackendFactory = function touchBackendFactory(manager) {
      return new TouchBackend(manager, optionsOrManager);
    };

    if (isDragDropManager(optionsOrManager)) {
      return touchBackendFactory(optionsOrManager);
    } else {
      return touchBackendFactory;
    }
  }

  exports.default = createTouchBackend;

  function distance(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
  }

  function inAngleRanges(x1, y1, x2, y2, angleRanges) {
    if (!angleRanges) {
      return false;
    }

    var angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;

    for (var i = 0; i < angleRanges.length; ++i) {
      if ((angleRanges[i].start == null || angle >= angleRanges[i].start) && (angleRanges[i].end == null || angle <= angleRanges[i].end)) {
        return true;
      }
    }

    return false;
  }
});
var TouchBackend = unwrapExports(Touch);
var Touch_1 = Touch.TouchBackend; // https://github.com/react-dnd/react-dnd/issues/186#issuecomment-282789420
// TODO: Find a way for this context to be used in the parent application as well.
// http://react-dnd.github.io/react-dnd/docs/api/drag-drop-context

function viewerbaseDragDropContext(DecoratedClass) {
  return DragDropContext(TouchBackend({
    enableMouseEvents: true
  }), null, true)(DecoratedClass);
}

export { ICONS, connectedComponent$4 as CineDialog, DropdownMenu as Dropdown, ExpandableToolMenu, ExampleDropTarget, Icon, LayoutButton, LayoutChooser, LayoutManager, LayoutPanelDropTarget$1 as LayoutPanelDropTarget, connectedComponent$2 as MeasurementTable, connectedComponent$1 as MeasurementTableItem, connectedComponent as Overlay, OverlayTrigger, PlayClipButton, QuickSwitch, RoundedButtonGroup, ScrollableArea, SelectTree, SimpleDialog, StudyBrowser, CTStudyBrowser, connectedComponent$6 as StudyList, TableList, TableListItem, ThumbnailEntry, Toolbar, ToolbarButton$1 as ToolbarButton, ToolbarSection, Tooltip, AboutModal, UserPreferences, connectedComponent$3 as UserPreferencesModal, viewerbaseDragDropContext as ViewerbaseDragDropContext, FollowupVisitButton };